var _regeneratorRuntime = require("/home/runner/work/hx-connect-chat-ui/hx-connect-chat-ui/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/runner/work/hx-connect-chat-ui/hx-connect-chat-ui/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _possibleConstructorReturn = require("/home/runner/work/hx-connect-chat-ui/hx-connect-chat-ui/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/runner/work/hx-connect-chat-ui/hx-connect-chat-ui/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("/home/runner/work/hx-connect-chat-ui/hx-connect-chat-ui/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/home/runner/work/hx-connect-chat-ui/hx-connect-chat-ui/node_modules/@babel/runtime/helpers/inherits");

var _defineProperty = require("/home/runner/work/hx-connect-chat-ui/hx-connect-chat-ui/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/home/runner/work/hx-connect-chat-ui/hx-connect-chat-ui/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/hx-connect-chat-ui/hx-connect-chat-ui/node_modules/@babel/runtime/helpers/createClass");

// [AIV_SHORT]  Build version: 0.4.5 - Wednesday, March 11th, 2020, 8:39:06 PM  
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.TaskRouter = t() : e.TaskRouter = t();
}(window, function () {
  return function (e) {
    var t = {};

    function r(n) {
      if (t[n]) return t[n].exports;
      var i = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
    }

    return r.m = e, r.c = t, r.d = function (e, t, n) {
      r.o(e, t) || Object.defineProperty(e, t, {
        configurable: !1,
        enumerable: !0,
        get: n
      });
    }, r.r = function (e) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "", r(r.s = 112);
  }([function (e, t, r) {
    (function (e, n) {
      var i;
      /**
       * @license
       * Lodash <https://lodash.com/>
       * Copyright JS Foundation and other contributors <https://js.foundation/>
       * Released under MIT license <https://lodash.com/license>
       * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
       * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
       */

      (function () {
        var s,
            o = 200,
            a = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.",
            f = "Expected a function",
            c = "__lodash_hash_undefined__",
            u = 500,
            h = "__lodash_placeholder__",
            d = 1,
            l = 2,
            p = 4,
            b = 1,
            _ = 2,
            g = 1,
            v = 2,
            m = 4,
            y = 8,
            w = 16,
            k = 32,
            S = 64,
            E = 128,
            A = 256,
            x = 512,
            T = 30,
            R = "...",
            M = 800,
            I = 16,
            O = 1,
            C = 2,
            B = 1 / 0,
            P = 9007199254740991,
            N = 1.7976931348623157e308,
            L = NaN,
            j = 4294967295,
            U = j - 1,
            D = j >>> 1,
            q = [["ary", E], ["bind", g], ["bindKey", v], ["curry", y], ["curryRight", w], ["flip", x], ["partial", k], ["partialRight", S], ["rearg", A]],
            z = "[object Arguments]",
            F = "[object Array]",
            W = "[object AsyncFunction]",
            Z = "[object Boolean]",
            V = "[object Date]",
            H = "[object DOMException]",
            $ = "[object Error]",
            K = "[object Function]",
            G = "[object GeneratorFunction]",
            Y = "[object Map]",
            X = "[object Number]",
            J = "[object Null]",
            Q = "[object Object]",
            ee = "[object Proxy]",
            te = "[object RegExp]",
            re = "[object Set]",
            ne = "[object String]",
            ie = "[object Symbol]",
            se = "[object Undefined]",
            oe = "[object WeakMap]",
            ae = "[object WeakSet]",
            fe = "[object ArrayBuffer]",
            ce = "[object DataView]",
            ue = "[object Float32Array]",
            he = "[object Float64Array]",
            de = "[object Int8Array]",
            le = "[object Int16Array]",
            pe = "[object Int32Array]",
            be = "[object Uint8Array]",
            _e = "[object Uint8ClampedArray]",
            ge = "[object Uint16Array]",
            ve = "[object Uint32Array]",
            me = /\b__p \+= '';/g,
            ye = /\b(__p \+=) '' \+/g,
            we = /(__e\(.*?\)|\b__t\)) \+\n'';/g,
            ke = /&(?:amp|lt|gt|quot|#39);/g,
            Se = /[&<>"']/g,
            Ee = RegExp(ke.source),
            Ae = RegExp(Se.source),
            xe = /<%-([\s\S]+?)%>/g,
            Te = /<%([\s\S]+?)%>/g,
            Re = /<%=([\s\S]+?)%>/g,
            Me = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
            Ie = /^\w*$/,
            Oe = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
            Ce = /[\\^$.*+?()[\]{}|]/g,
            Be = RegExp(Ce.source),
            Pe = /^\s+|\s+$/g,
            Ne = /^\s+/,
            Le = /\s+$/,
            je = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
            Ue = /\{\n\/\* \[wrapped with (.+)\] \*/,
            De = /,? & /,
            qe = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,
            ze = /\\(\\)?/g,
            Fe = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,
            We = /\w*$/,
            Ze = /^[-+]0x[0-9a-f]+$/i,
            Ve = /^0b[01]+$/i,
            He = /^\[object .+?Constructor\]$/,
            $e = /^0o[0-7]+$/i,
            Ke = /^(?:0|[1-9]\d*)$/,
            Ge = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,
            Ye = /($^)/,
            Xe = /['\n\r\u2028\u2029\\]/g,
            Je = "\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff",
            Qe = "\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",
            et = "[\\ud800-\\udfff]",
            tt = "[" + Qe + "]",
            rt = "[" + Je + "]",
            nt = "\\d+",
            it = "[\\u2700-\\u27bf]",
            st = "[a-z\\xdf-\\xf6\\xf8-\\xff]",
            ot = "[^\\ud800-\\udfff" + Qe + nt + "\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde]",
            at = "\\ud83c[\\udffb-\\udfff]",
            ft = "[^\\ud800-\\udfff]",
            ct = "(?:\\ud83c[\\udde6-\\uddff]){2}",
            ut = "[\\ud800-\\udbff][\\udc00-\\udfff]",
            ht = "[A-Z\\xc0-\\xd6\\xd8-\\xde]",
            dt = "(?:" + st + "|" + ot + ")",
            lt = "(?:" + ht + "|" + ot + ")",
            pt = "(?:" + rt + "|" + at + ")" + "?",
            bt = "[\\ufe0e\\ufe0f]?" + pt + ("(?:\\u200d(?:" + [ft, ct, ut].join("|") + ")[\\ufe0e\\ufe0f]?" + pt + ")*"),
            _t = "(?:" + [it, ct, ut].join("|") + ")" + bt,
            gt = "(?:" + [ft + rt + "?", rt, ct, ut, et].join("|") + ")",
            vt = RegExp("['’]", "g"),
            mt = RegExp(rt, "g"),
            yt = RegExp(at + "(?=" + at + ")|" + gt + bt, "g"),
            wt = RegExp([ht + "?" + st + "+(?:['’](?:d|ll|m|re|s|t|ve))?(?=" + [tt, ht, "$"].join("|") + ")", lt + "+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=" + [tt, ht + dt, "$"].join("|") + ")", ht + "?" + dt + "+(?:['’](?:d|ll|m|re|s|t|ve))?", ht + "+(?:['’](?:D|LL|M|RE|S|T|VE))?", "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", nt, _t].join("|"), "g"),
            kt = RegExp("[\\u200d\\ud800-\\udfff" + Je + "\\ufe0e\\ufe0f]"),
            St = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,
            Et = ["Array", "Buffer", "DataView", "Date", "Error", "Float32Array", "Float64Array", "Function", "Int8Array", "Int16Array", "Int32Array", "Map", "Math", "Object", "Promise", "RegExp", "Set", "String", "Symbol", "TypeError", "Uint8Array", "Uint8ClampedArray", "Uint16Array", "Uint32Array", "WeakMap", "_", "clearTimeout", "isFinite", "parseInt", "setTimeout"],
            At = -1,
            xt = {};

        xt[ue] = xt[he] = xt[de] = xt[le] = xt[pe] = xt[be] = xt[_e] = xt[ge] = xt[ve] = !0, xt[z] = xt[F] = xt[fe] = xt[Z] = xt[ce] = xt[V] = xt[$] = xt[K] = xt[Y] = xt[X] = xt[Q] = xt[te] = xt[re] = xt[ne] = xt[oe] = !1;
        var Tt = {};
        Tt[z] = Tt[F] = Tt[fe] = Tt[ce] = Tt[Z] = Tt[V] = Tt[ue] = Tt[he] = Tt[de] = Tt[le] = Tt[pe] = Tt[Y] = Tt[X] = Tt[Q] = Tt[te] = Tt[re] = Tt[ne] = Tt[ie] = Tt[be] = Tt[_e] = Tt[ge] = Tt[ve] = !0, Tt[$] = Tt[K] = Tt[oe] = !1;

        var Rt = {
          "\\": "\\",
          "'": "'",
          "\n": "n",
          "\r": "r",
          "\u2028": "u2028",
          "\u2029": "u2029"
        },
            Mt = parseFloat,
            It = parseInt,
            Ot = "object" == typeof e && e && e.Object === Object && e,
            Ct = "object" == typeof self && self && self.Object === Object && self,
            Bt = Ot || Ct || Function("return this")(),
            Pt = "object" == typeof t && t && !t.nodeType && t,
            Nt = Pt && "object" == typeof n && n && !n.nodeType && n,
            Lt = Nt && Nt.exports === Pt,
            jt = Lt && Ot.process,
            Ut = function () {
          try {
            return jt && jt.binding && jt.binding("util");
          } catch (e) {}
        }(),
            Dt = Ut && Ut.isArrayBuffer,
            qt = Ut && Ut.isDate,
            zt = Ut && Ut.isMap,
            Ft = Ut && Ut.isRegExp,
            Wt = Ut && Ut.isSet,
            Zt = Ut && Ut.isTypedArray;

        function Vt(e, t, r) {
          switch (r.length) {
            case 0:
              return e.call(t);

            case 1:
              return e.call(t, r[0]);

            case 2:
              return e.call(t, r[0], r[1]);

            case 3:
              return e.call(t, r[0], r[1], r[2]);
          }

          return e.apply(t, r);
        }

        function Ht(e, t, r, n) {
          for (var i = -1, s = null == e ? 0 : e.length; ++i < s;) {
            var o = e[i];
            t(n, o, r(o), e);
          }

          return n;
        }

        function $t(e, t) {
          for (var r = -1, n = null == e ? 0 : e.length; ++r < n && !1 !== t(e[r], r, e);) {
            ;
          }

          return e;
        }

        function Kt(e, t) {
          for (var r = null == e ? 0 : e.length; r-- && !1 !== t(e[r], r, e);) {
            ;
          }

          return e;
        }

        function Gt(e, t) {
          for (var r = -1, n = null == e ? 0 : e.length; ++r < n;) {
            if (!t(e[r], r, e)) return !1;
          }

          return !0;
        }

        function Yt(e, t) {
          for (var r = -1, n = null == e ? 0 : e.length, i = 0, s = []; ++r < n;) {
            var o = e[r];
            t(o, r, e) && (s[i++] = o);
          }

          return s;
        }

        function Xt(e, t) {
          return !!(null == e ? 0 : e.length) && ar(e, t, 0) > -1;
        }

        function Jt(e, t, r) {
          for (var n = -1, i = null == e ? 0 : e.length; ++n < i;) {
            if (r(t, e[n])) return !0;
          }

          return !1;
        }

        function Qt(e, t) {
          for (var r = -1, n = null == e ? 0 : e.length, i = Array(n); ++r < n;) {
            i[r] = t(e[r], r, e);
          }

          return i;
        }

        function er(e, t) {
          for (var r = -1, n = t.length, i = e.length; ++r < n;) {
            e[i + r] = t[r];
          }

          return e;
        }

        function tr(e, t, r, n) {
          var i = -1,
              s = null == e ? 0 : e.length;

          for (n && s && (r = e[++i]); ++i < s;) {
            r = t(r, e[i], i, e);
          }

          return r;
        }

        function rr(e, t, r, n) {
          var i = null == e ? 0 : e.length;

          for (n && i && (r = e[--i]); i--;) {
            r = t(r, e[i], i, e);
          }

          return r;
        }

        function nr(e, t) {
          for (var r = -1, n = null == e ? 0 : e.length; ++r < n;) {
            if (t(e[r], r, e)) return !0;
          }

          return !1;
        }

        var ir = hr("length");

        function sr(e, t, r) {
          var n;
          return r(e, function (e, r, i) {
            if (t(e, r, i)) return n = r, !1;
          }), n;
        }

        function or(e, t, r, n) {
          for (var i = e.length, s = r + (n ? 1 : -1); n ? s-- : ++s < i;) {
            if (t(e[s], s, e)) return s;
          }

          return -1;
        }

        function ar(e, t, r) {
          return t == t ? function (e, t, r) {
            var n = r - 1,
                i = e.length;

            for (; ++n < i;) {
              if (e[n] === t) return n;
            }

            return -1;
          }(e, t, r) : or(e, cr, r);
        }

        function fr(e, t, r, n) {
          for (var i = r - 1, s = e.length; ++i < s;) {
            if (n(e[i], t)) return i;
          }

          return -1;
        }

        function cr(e) {
          return e != e;
        }

        function ur(e, t) {
          var r = null == e ? 0 : e.length;
          return r ? pr(e, t) / r : L;
        }

        function hr(e) {
          return function (t) {
            return null == t ? s : t[e];
          };
        }

        function dr(e) {
          return function (t) {
            return null == e ? s : e[t];
          };
        }

        function lr(e, t, r, n, i) {
          return i(e, function (e, i, s) {
            r = n ? (n = !1, e) : t(r, e, i, s);
          }), r;
        }

        function pr(e, t) {
          for (var r, n = -1, i = e.length; ++n < i;) {
            var o = t(e[n]);
            o !== s && (r = r === s ? o : r + o);
          }

          return r;
        }

        function br(e, t) {
          for (var r = -1, n = Array(e); ++r < e;) {
            n[r] = t(r);
          }

          return n;
        }

        function _r(e) {
          return function (t) {
            return e(t);
          };
        }

        function gr(e, t) {
          return Qt(t, function (t) {
            return e[t];
          });
        }

        function vr(e, t) {
          return e.has(t);
        }

        function mr(e, t) {
          for (var r = -1, n = e.length; ++r < n && ar(t, e[r], 0) > -1;) {
            ;
          }

          return r;
        }

        function yr(e, t) {
          for (var r = e.length; r-- && ar(t, e[r], 0) > -1;) {
            ;
          }

          return r;
        }

        var wr = dr({
          "À": "A",
          "Á": "A",
          "Â": "A",
          "Ã": "A",
          "Ä": "A",
          "Å": "A",
          "à": "a",
          "á": "a",
          "â": "a",
          "ã": "a",
          "ä": "a",
          "å": "a",
          "Ç": "C",
          "ç": "c",
          "Ð": "D",
          "ð": "d",
          "È": "E",
          "É": "E",
          "Ê": "E",
          "Ë": "E",
          "è": "e",
          "é": "e",
          "ê": "e",
          "ë": "e",
          "Ì": "I",
          "Í": "I",
          "Î": "I",
          "Ï": "I",
          "ì": "i",
          "í": "i",
          "î": "i",
          "ï": "i",
          "Ñ": "N",
          "ñ": "n",
          "Ò": "O",
          "Ó": "O",
          "Ô": "O",
          "Õ": "O",
          "Ö": "O",
          "Ø": "O",
          "ò": "o",
          "ó": "o",
          "ô": "o",
          "õ": "o",
          "ö": "o",
          "ø": "o",
          "Ù": "U",
          "Ú": "U",
          "Û": "U",
          "Ü": "U",
          "ù": "u",
          "ú": "u",
          "û": "u",
          "ü": "u",
          "Ý": "Y",
          "ý": "y",
          "ÿ": "y",
          "Æ": "Ae",
          "æ": "ae",
          "Þ": "Th",
          "þ": "th",
          "ß": "ss",
          "Ā": "A",
          "Ă": "A",
          "Ą": "A",
          "ā": "a",
          "ă": "a",
          "ą": "a",
          "Ć": "C",
          "Ĉ": "C",
          "Ċ": "C",
          "Č": "C",
          "ć": "c",
          "ĉ": "c",
          "ċ": "c",
          "č": "c",
          "Ď": "D",
          "Đ": "D",
          "ď": "d",
          "đ": "d",
          "Ē": "E",
          "Ĕ": "E",
          "Ė": "E",
          "Ę": "E",
          "Ě": "E",
          "ē": "e",
          "ĕ": "e",
          "ė": "e",
          "ę": "e",
          "ě": "e",
          "Ĝ": "G",
          "Ğ": "G",
          "Ġ": "G",
          "Ģ": "G",
          "ĝ": "g",
          "ğ": "g",
          "ġ": "g",
          "ģ": "g",
          "Ĥ": "H",
          "Ħ": "H",
          "ĥ": "h",
          "ħ": "h",
          "Ĩ": "I",
          "Ī": "I",
          "Ĭ": "I",
          "Į": "I",
          "İ": "I",
          "ĩ": "i",
          "ī": "i",
          "ĭ": "i",
          "į": "i",
          "ı": "i",
          "Ĵ": "J",
          "ĵ": "j",
          "Ķ": "K",
          "ķ": "k",
          "ĸ": "k",
          "Ĺ": "L",
          "Ļ": "L",
          "Ľ": "L",
          "Ŀ": "L",
          "Ł": "L",
          "ĺ": "l",
          "ļ": "l",
          "ľ": "l",
          "ŀ": "l",
          "ł": "l",
          "Ń": "N",
          "Ņ": "N",
          "Ň": "N",
          "Ŋ": "N",
          "ń": "n",
          "ņ": "n",
          "ň": "n",
          "ŋ": "n",
          "Ō": "O",
          "Ŏ": "O",
          "Ő": "O",
          "ō": "o",
          "ŏ": "o",
          "ő": "o",
          "Ŕ": "R",
          "Ŗ": "R",
          "Ř": "R",
          "ŕ": "r",
          "ŗ": "r",
          "ř": "r",
          "Ś": "S",
          "Ŝ": "S",
          "Ş": "S",
          "Š": "S",
          "ś": "s",
          "ŝ": "s",
          "ş": "s",
          "š": "s",
          "Ţ": "T",
          "Ť": "T",
          "Ŧ": "T",
          "ţ": "t",
          "ť": "t",
          "ŧ": "t",
          "Ũ": "U",
          "Ū": "U",
          "Ŭ": "U",
          "Ů": "U",
          "Ű": "U",
          "Ų": "U",
          "ũ": "u",
          "ū": "u",
          "ŭ": "u",
          "ů": "u",
          "ű": "u",
          "ų": "u",
          "Ŵ": "W",
          "ŵ": "w",
          "Ŷ": "Y",
          "ŷ": "y",
          "Ÿ": "Y",
          "Ź": "Z",
          "Ż": "Z",
          "Ž": "Z",
          "ź": "z",
          "ż": "z",
          "ž": "z",
          "Ĳ": "IJ",
          "ĳ": "ij",
          "Œ": "Oe",
          "œ": "oe",
          "ŉ": "'n",
          "ſ": "s"
        }),
            kr = dr({
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#39;"
        });

        function Sr(e) {
          return "\\" + Rt[e];
        }

        function Er(e) {
          return kt.test(e);
        }

        function Ar(e) {
          var t = -1,
              r = Array(e.size);
          return e.forEach(function (e, n) {
            r[++t] = [n, e];
          }), r;
        }

        function xr(e, t) {
          return function (r) {
            return e(t(r));
          };
        }

        function Tr(e, t) {
          for (var r = -1, n = e.length, i = 0, s = []; ++r < n;) {
            var o = e[r];
            o !== t && o !== h || (e[r] = h, s[i++] = r);
          }

          return s;
        }

        function Rr(e, t) {
          return "__proto__" == t ? s : e[t];
        }

        function Mr(e) {
          var t = -1,
              r = Array(e.size);
          return e.forEach(function (e) {
            r[++t] = e;
          }), r;
        }

        function Ir(e) {
          var t = -1,
              r = Array(e.size);
          return e.forEach(function (e) {
            r[++t] = [e, e];
          }), r;
        }

        function Or(e) {
          return Er(e) ? function (e) {
            var t = yt.lastIndex = 0;

            for (; yt.test(e);) {
              ++t;
            }

            return t;
          }(e) : ir(e);
        }

        function Cr(e) {
          return Er(e) ? function (e) {
            return e.match(yt) || [];
          }(e) : function (e) {
            return e.split("");
          }(e);
        }

        var Br = dr({
          "&amp;": "&",
          "&lt;": "<",
          "&gt;": ">",
          "&quot;": '"',
          "&#39;": "'"
        });

        var Pr = function e(t) {
          var r,
              n = (t = null == t ? Bt : Pr.defaults(Bt.Object(), t, Pr.pick(Bt, Et))).Array,
              i = t.Date,
              Je = t.Error,
              Qe = t.Function,
              et = t.Math,
              tt = t.Object,
              rt = t.RegExp,
              nt = t.String,
              it = t.TypeError,
              st = n.prototype,
              ot = Qe.prototype,
              at = tt.prototype,
              ft = t["__core-js_shared__"],
              ct = ot.toString,
              ut = at.hasOwnProperty,
              ht = 0,
              dt = (r = /[^.]+$/.exec(ft && ft.keys && ft.keys.IE_PROTO || "")) ? "Symbol(src)_1." + r : "",
              lt = at.toString,
              pt = ct.call(tt),
              bt = Bt._,
              _t = rt("^" + ct.call(ut).replace(Ce, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
              gt = Lt ? t.Buffer : s,
              yt = t.Symbol,
              kt = t.Uint8Array,
              Rt = gt ? gt.allocUnsafe : s,
              Ot = xr(tt.getPrototypeOf, tt),
              Ct = tt.create,
              Pt = at.propertyIsEnumerable,
              Nt = st.splice,
              jt = yt ? yt.isConcatSpreadable : s,
              Ut = yt ? yt.iterator : s,
              ir = yt ? yt.toStringTag : s,
              dr = function () {
            try {
              var e = Ds(tt, "defineProperty");
              return e({}, "", {}), e;
            } catch (e) {}
          }(),
              Nr = t.clearTimeout !== Bt.clearTimeout && t.clearTimeout,
              Lr = i && i.now !== Bt.Date.now && i.now,
              jr = t.setTimeout !== Bt.setTimeout && t.setTimeout,
              Ur = et.ceil,
              Dr = et.floor,
              qr = tt.getOwnPropertySymbols,
              zr = gt ? gt.isBuffer : s,
              Fr = t.isFinite,
              Wr = st.join,
              Zr = xr(tt.keys, tt),
              Vr = et.max,
              Hr = et.min,
              $r = i.now,
              Kr = t.parseInt,
              Gr = et.random,
              Yr = st.reverse,
              Xr = Ds(t, "DataView"),
              Jr = Ds(t, "Map"),
              Qr = Ds(t, "Promise"),
              en = Ds(t, "Set"),
              tn = Ds(t, "WeakMap"),
              rn = Ds(tt, "create"),
              nn = tn && new tn(),
              sn = {},
              on = uo(Xr),
              an = uo(Jr),
              fn = uo(Qr),
              cn = uo(en),
              un = uo(tn),
              hn = yt ? yt.prototype : s,
              dn = hn ? hn.valueOf : s,
              ln = hn ? hn.toString : s;

          function pn(e) {
            if (Ra(e) && !ga(e) && !(e instanceof vn)) {
              if (e instanceof gn) return e;
              if (ut.call(e, "__wrapped__")) return ho(e);
            }

            return new gn(e);
          }

          var bn = function () {
            function e() {}

            return function (t) {
              if (!Ta(t)) return {};
              if (Ct) return Ct(t);
              e.prototype = t;
              var r = new e();
              return e.prototype = s, r;
            };
          }();

          function _n() {}

          function gn(e, t) {
            this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!t, this.__index__ = 0, this.__values__ = s;
          }

          function vn(e) {
            this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = j, this.__views__ = [];
          }

          function mn(e) {
            var t = -1,
                r = null == e ? 0 : e.length;

            for (this.clear(); ++t < r;) {
              var n = e[t];
              this.set(n[0], n[1]);
            }
          }

          function yn(e) {
            var t = -1,
                r = null == e ? 0 : e.length;

            for (this.clear(); ++t < r;) {
              var n = e[t];
              this.set(n[0], n[1]);
            }
          }

          function wn(e) {
            var t = -1,
                r = null == e ? 0 : e.length;

            for (this.clear(); ++t < r;) {
              var n = e[t];
              this.set(n[0], n[1]);
            }
          }

          function kn(e) {
            var t = -1,
                r = null == e ? 0 : e.length;

            for (this.__data__ = new wn(); ++t < r;) {
              this.add(e[t]);
            }
          }

          function Sn(e) {
            var t = this.__data__ = new yn(e);
            this.size = t.size;
          }

          function En(e, t) {
            var r = ga(e),
                n = !r && _a(e),
                i = !r && !n && wa(e),
                s = !r && !n && !i && La(e),
                o = r || n || i || s,
                a = o ? br(e.length, nt) : [],
                f = a.length;

            for (var c in e) {
              !t && !ut.call(e, c) || o && ("length" == c || i && ("offset" == c || "parent" == c) || s && ("buffer" == c || "byteLength" == c || "byteOffset" == c) || Hs(c, f)) || a.push(c);
            }

            return a;
          }

          function An(e) {
            var t = e.length;
            return t ? e[ki(0, t - 1)] : s;
          }

          function xn(e, t) {
            return ao(ns(e), Nn(t, 0, e.length));
          }

          function Tn(e) {
            return ao(ns(e));
          }

          function Rn(e, t, r) {
            (r === s || la(e[t], r)) && (r !== s || t in e) || Bn(e, t, r);
          }

          function Mn(e, t, r) {
            var n = e[t];
            ut.call(e, t) && la(n, r) && (r !== s || t in e) || Bn(e, t, r);
          }

          function In(e, t) {
            for (var r = e.length; r--;) {
              if (la(e[r][0], t)) return r;
            }

            return -1;
          }

          function On(e, t, r, n) {
            return qn(e, function (e, i, s) {
              t(n, e, r(e), s);
            }), n;
          }

          function Cn(e, t) {
            return e && is(t, sf(t), e);
          }

          function Bn(e, t, r) {
            "__proto__" == t && dr ? dr(e, t, {
              configurable: !0,
              enumerable: !0,
              value: r,
              writable: !0
            }) : e[t] = r;
          }

          function Pn(e, t) {
            for (var r = -1, i = t.length, o = n(i), a = null == e; ++r < i;) {
              o[r] = a ? s : Qa(e, t[r]);
            }

            return o;
          }

          function Nn(e, t, r) {
            return e == e && (r !== s && (e = e <= r ? e : r), t !== s && (e = e >= t ? e : t)), e;
          }

          function Ln(e, t, r, n, i, o) {
            var a,
                f = t & d,
                c = t & l,
                u = t & p;
            if (r && (a = i ? r(e, n, i, o) : r(e)), a !== s) return a;
            if (!Ta(e)) return e;
            var h = ga(e);

            if (h) {
              if (a = function (e) {
                var t = e.length,
                    r = new e.constructor(t);
                return t && "string" == typeof e[0] && ut.call(e, "index") && (r.index = e.index, r.input = e.input), r;
              }(e), !f) return ns(e, a);
            } else {
              var b = Fs(e),
                  _ = b == K || b == G;

              if (wa(e)) return Xi(e, f);

              if (b == Q || b == z || _ && !i) {
                if (a = c || _ ? {} : Zs(e), !f) return c ? function (e, t) {
                  return is(e, zs(e), t);
                }(e, function (e, t) {
                  return e && is(t, of(t), e);
                }(a, e)) : function (e, t) {
                  return is(e, qs(e), t);
                }(e, Cn(a, e));
              } else {
                if (!Tt[b]) return i ? e : {};

                a = function (e, t, r) {
                  var n,
                      i,
                      s,
                      o = e.constructor;

                  switch (t) {
                    case fe:
                      return Ji(e);

                    case Z:
                    case V:
                      return new o(+e);

                    case ce:
                      return function (e, t) {
                        var r = t ? Ji(e.buffer) : e.buffer;
                        return new e.constructor(r, e.byteOffset, e.byteLength);
                      }(e, r);

                    case ue:
                    case he:
                    case de:
                    case le:
                    case pe:
                    case be:
                    case _e:
                    case ge:
                    case ve:
                      return Qi(e, r);

                    case Y:
                      return new o();

                    case X:
                    case ne:
                      return new o(e);

                    case te:
                      return (s = new (i = e).constructor(i.source, We.exec(i))).lastIndex = i.lastIndex, s;

                    case re:
                      return new o();

                    case ie:
                      return n = e, dn ? tt(dn.call(n)) : {};
                  }
                }(e, b, f);
              }
            }

            o || (o = new Sn());
            var g = o.get(e);
            if (g) return g;
            if (o.set(e, a), Ba(e)) return e.forEach(function (n) {
              a.add(Ln(n, t, r, n, e, o));
            }), a;
            if (Ma(e)) return e.forEach(function (n, i) {
              a.set(i, Ln(n, t, r, i, e, o));
            }), a;
            var v = h ? s : (u ? c ? Cs : Os : c ? of : sf)(e);
            return $t(v || e, function (n, i) {
              v && (n = e[i = n]), Mn(a, i, Ln(n, t, r, i, e, o));
            }), a;
          }

          function jn(e, t, r) {
            var n = r.length;
            if (null == e) return !n;

            for (e = tt(e); n--;) {
              var i = r[n],
                  o = t[i],
                  a = e[i];
              if (a === s && !(i in e) || !o(a)) return !1;
            }

            return !0;
          }

          function Un(e, t, r) {
            if ("function" != typeof e) throw new it(f);
            return no(function () {
              e.apply(s, r);
            }, t);
          }

          function Dn(e, t, r, n) {
            var i = -1,
                s = Xt,
                a = !0,
                f = e.length,
                c = [],
                u = t.length;
            if (!f) return c;
            r && (t = Qt(t, _r(r))), n ? (s = Jt, a = !1) : t.length >= o && (s = vr, a = !1, t = new kn(t));

            e: for (; ++i < f;) {
              var h = e[i],
                  d = null == r ? h : r(h);

              if (h = n || 0 !== h ? h : 0, a && d == d) {
                for (var l = u; l--;) {
                  if (t[l] === d) continue e;
                }

                c.push(h);
              } else s(t, d, n) || c.push(h);
            }

            return c;
          }

          pn.templateSettings = {
            escape: xe,
            evaluate: Te,
            interpolate: Re,
            variable: "",
            imports: {
              _: pn
            }
          }, pn.prototype = _n.prototype, pn.prototype.constructor = pn, gn.prototype = bn(_n.prototype), gn.prototype.constructor = gn, vn.prototype = bn(_n.prototype), vn.prototype.constructor = vn, mn.prototype.clear = function () {
            this.__data__ = rn ? rn(null) : {}, this.size = 0;
          }, mn.prototype.delete = function (e) {
            var t = this.has(e) && delete this.__data__[e];
            return this.size -= t ? 1 : 0, t;
          }, mn.prototype.get = function (e) {
            var t = this.__data__;

            if (rn) {
              var r = t[e];
              return r === c ? s : r;
            }

            return ut.call(t, e) ? t[e] : s;
          }, mn.prototype.has = function (e) {
            var t = this.__data__;
            return rn ? t[e] !== s : ut.call(t, e);
          }, mn.prototype.set = function (e, t) {
            var r = this.__data__;
            return this.size += this.has(e) ? 0 : 1, r[e] = rn && t === s ? c : t, this;
          }, yn.prototype.clear = function () {
            this.__data__ = [], this.size = 0;
          }, yn.prototype.delete = function (e) {
            var t = this.__data__,
                r = In(t, e);
            return !(r < 0 || (r == t.length - 1 ? t.pop() : Nt.call(t, r, 1), --this.size, 0));
          }, yn.prototype.get = function (e) {
            var t = this.__data__,
                r = In(t, e);
            return r < 0 ? s : t[r][1];
          }, yn.prototype.has = function (e) {
            return In(this.__data__, e) > -1;
          }, yn.prototype.set = function (e, t) {
            var r = this.__data__,
                n = In(r, e);
            return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
          }, wn.prototype.clear = function () {
            this.size = 0, this.__data__ = {
              hash: new mn(),
              map: new (Jr || yn)(),
              string: new mn()
            };
          }, wn.prototype.delete = function (e) {
            var t = js(this, e).delete(e);
            return this.size -= t ? 1 : 0, t;
          }, wn.prototype.get = function (e) {
            return js(this, e).get(e);
          }, wn.prototype.has = function (e) {
            return js(this, e).has(e);
          }, wn.prototype.set = function (e, t) {
            var r = js(this, e),
                n = r.size;
            return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
          }, kn.prototype.add = kn.prototype.push = function (e) {
            return this.__data__.set(e, c), this;
          }, kn.prototype.has = function (e) {
            return this.__data__.has(e);
          }, Sn.prototype.clear = function () {
            this.__data__ = new yn(), this.size = 0;
          }, Sn.prototype.delete = function (e) {
            var t = this.__data__,
                r = t.delete(e);
            return this.size = t.size, r;
          }, Sn.prototype.get = function (e) {
            return this.__data__.get(e);
          }, Sn.prototype.has = function (e) {
            return this.__data__.has(e);
          }, Sn.prototype.set = function (e, t) {
            var r = this.__data__;

            if (r instanceof yn) {
              var n = r.__data__;
              if (!Jr || n.length < o - 1) return n.push([e, t]), this.size = ++r.size, this;
              r = this.__data__ = new wn(n);
            }

            return r.set(e, t), this.size = r.size, this;
          };
          var qn = as(Kn),
              zn = as(Gn, !0);

          function Fn(e, t) {
            var r = !0;
            return qn(e, function (e, n, i) {
              return r = !!t(e, n, i);
            }), r;
          }

          function Wn(e, t, r) {
            for (var n = -1, i = e.length; ++n < i;) {
              var o = e[n],
                  a = t(o);
              if (null != a && (f === s ? a == a && !Na(a) : r(a, f))) var f = a,
                  c = o;
            }

            return c;
          }

          function Zn(e, t) {
            var r = [];
            return qn(e, function (e, n, i) {
              t(e, n, i) && r.push(e);
            }), r;
          }

          function Vn(e, t, r, n, i) {
            var s = -1,
                o = e.length;

            for (r || (r = Vs), i || (i = []); ++s < o;) {
              var a = e[s];
              t > 0 && r(a) ? t > 1 ? Vn(a, t - 1, r, n, i) : er(i, a) : n || (i[i.length] = a);
            }

            return i;
          }

          var Hn = fs(),
              $n = fs(!0);

          function Kn(e, t) {
            return e && Hn(e, t, sf);
          }

          function Gn(e, t) {
            return e && $n(e, t, sf);
          }

          function Yn(e, t) {
            return Yt(t, function (t) {
              return Ea(e[t]);
            });
          }

          function Xn(e, t) {
            for (var r = 0, n = (t = $i(t, e)).length; null != e && r < n;) {
              e = e[co(t[r++])];
            }

            return r && r == n ? e : s;
          }

          function Jn(e, t, r) {
            var n = t(e);
            return ga(e) ? n : er(n, r(e));
          }

          function Qn(e) {
            return null == e ? e === s ? se : J : ir && ir in tt(e) ? function (e) {
              var t = ut.call(e, ir),
                  r = e[ir];

              try {
                e[ir] = s;
                var n = !0;
              } catch (e) {}

              var i = lt.call(e);
              return n && (t ? e[ir] = r : delete e[ir]), i;
            }(e) : function (e) {
              return lt.call(e);
            }(e);
          }

          function ei(e, t) {
            return e > t;
          }

          function ti(e, t) {
            return null != e && ut.call(e, t);
          }

          function ri(e, t) {
            return null != e && t in tt(e);
          }

          function ni(e, t, r) {
            for (var i = r ? Jt : Xt, o = e[0].length, a = e.length, f = a, c = n(a), u = 1 / 0, h = []; f--;) {
              var d = e[f];
              f && t && (d = Qt(d, _r(t))), u = Hr(d.length, u), c[f] = !r && (t || o >= 120 && d.length >= 120) ? new kn(f && d) : s;
            }

            d = e[0];
            var l = -1,
                p = c[0];

            e: for (; ++l < o && h.length < u;) {
              var b = d[l],
                  _ = t ? t(b) : b;

              if (b = r || 0 !== b ? b : 0, !(p ? vr(p, _) : i(h, _, r))) {
                for (f = a; --f;) {
                  var g = c[f];
                  if (!(g ? vr(g, _) : i(e[f], _, r))) continue e;
                }

                p && p.push(_), h.push(b);
              }
            }

            return h;
          }

          function ii(e, t, r) {
            var n = null == (e = to(e, t = $i(t, e))) ? e : e[co(So(t))];
            return null == n ? s : Vt(n, e, r);
          }

          function si(e) {
            return Ra(e) && Qn(e) == z;
          }

          function oi(e, t, r, n, i) {
            return e === t || (null == e || null == t || !Ra(e) && !Ra(t) ? e != e && t != t : function (e, t, r, n, i, o) {
              var a = ga(e),
                  f = ga(t),
                  c = a ? F : Fs(e),
                  u = f ? F : Fs(t),
                  h = (c = c == z ? Q : c) == Q,
                  d = (u = u == z ? Q : u) == Q,
                  l = c == u;

              if (l && wa(e)) {
                if (!wa(t)) return !1;
                a = !0, h = !1;
              }

              if (l && !h) return o || (o = new Sn()), a || La(e) ? Ms(e, t, r, n, i, o) : function (e, t, r, n, i, s, o) {
                switch (r) {
                  case ce:
                    if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
                    e = e.buffer, t = t.buffer;

                  case fe:
                    return !(e.byteLength != t.byteLength || !s(new kt(e), new kt(t)));

                  case Z:
                  case V:
                  case X:
                    return la(+e, +t);

                  case $:
                    return e.name == t.name && e.message == t.message;

                  case te:
                  case ne:
                    return e == t + "";

                  case Y:
                    var a = Ar;

                  case re:
                    var f = n & b;
                    if (a || (a = Mr), e.size != t.size && !f) return !1;
                    var c = o.get(e);
                    if (c) return c == t;
                    n |= _, o.set(e, t);
                    var u = Ms(a(e), a(t), n, i, s, o);
                    return o.delete(e), u;

                  case ie:
                    if (dn) return dn.call(e) == dn.call(t);
                }

                return !1;
              }(e, t, c, r, n, i, o);

              if (!(r & b)) {
                var p = h && ut.call(e, "__wrapped__"),
                    g = d && ut.call(t, "__wrapped__");

                if (p || g) {
                  var v = p ? e.value() : e,
                      m = g ? t.value() : t;
                  return o || (o = new Sn()), i(v, m, r, n, o);
                }
              }

              return !!l && (o || (o = new Sn()), function (e, t, r, n, i, o) {
                var a = r & b,
                    f = Os(e),
                    c = f.length,
                    u = Os(t).length;
                if (c != u && !a) return !1;

                for (var h = c; h--;) {
                  var d = f[h];
                  if (!(a ? d in t : ut.call(t, d))) return !1;
                }

                var l = o.get(e);
                if (l && o.get(t)) return l == t;
                var p = !0;
                o.set(e, t), o.set(t, e);

                for (var _ = a; ++h < c;) {
                  d = f[h];
                  var g = e[d],
                      v = t[d];
                  if (n) var m = a ? n(v, g, d, t, e, o) : n(g, v, d, e, t, o);

                  if (!(m === s ? g === v || i(g, v, r, n, o) : m)) {
                    p = !1;
                    break;
                  }

                  _ || (_ = "constructor" == d);
                }

                if (p && !_) {
                  var y = e.constructor,
                      w = t.constructor;
                  y != w && "constructor" in e && "constructor" in t && !("function" == typeof y && y instanceof y && "function" == typeof w && w instanceof w) && (p = !1);
                }

                return o.delete(e), o.delete(t), p;
              }(e, t, r, n, i, o));
            }(e, t, r, n, oi, i));
          }

          function ai(e, t, r, n) {
            var i = r.length,
                o = i,
                a = !n;
            if (null == e) return !o;

            for (e = tt(e); i--;) {
              var f = r[i];
              if (a && f[2] ? f[1] !== e[f[0]] : !(f[0] in e)) return !1;
            }

            for (; ++i < o;) {
              var c = (f = r[i])[0],
                  u = e[c],
                  h = f[1];

              if (a && f[2]) {
                if (u === s && !(c in e)) return !1;
              } else {
                var d = new Sn();
                if (n) var l = n(u, h, c, e, t, d);
                if (!(l === s ? oi(h, u, b | _, n, d) : l)) return !1;
              }
            }

            return !0;
          }

          function fi(e) {
            return !(!Ta(e) || dt && dt in e) && (Ea(e) ? _t : He).test(uo(e));
          }

          function ci(e) {
            return "function" == typeof e ? e : null == e ? Of : "object" == typeof e ? ga(e) ? bi(e[0], e[1]) : pi(e) : qf(e);
          }

          function ui(e) {
            if (!Xs(e)) return Zr(e);
            var t = [];

            for (var r in tt(e)) {
              ut.call(e, r) && "constructor" != r && t.push(r);
            }

            return t;
          }

          function hi(e) {
            if (!Ta(e)) return function (e) {
              var t = [];
              if (null != e) for (var r in tt(e)) {
                t.push(r);
              }
              return t;
            }(e);
            var t = Xs(e),
                r = [];

            for (var n in e) {
              ("constructor" != n || !t && ut.call(e, n)) && r.push(n);
            }

            return r;
          }

          function di(e, t) {
            return e < t;
          }

          function li(e, t) {
            var r = -1,
                i = ma(e) ? n(e.length) : [];
            return qn(e, function (e, n, s) {
              i[++r] = t(e, n, s);
            }), i;
          }

          function pi(e) {
            var t = Us(e);
            return 1 == t.length && t[0][2] ? Qs(t[0][0], t[0][1]) : function (r) {
              return r === e || ai(r, e, t);
            };
          }

          function bi(e, t) {
            return Ks(e) && Js(t) ? Qs(co(e), t) : function (r) {
              var n = Qa(r, e);
              return n === s && n === t ? ef(r, e) : oi(t, n, b | _);
            };
          }

          function _i(e, t, r, n, i) {
            e !== t && Hn(t, function (o, a) {
              if (Ta(o)) i || (i = new Sn()), function (e, t, r, n, i, o, a) {
                var f = Rr(e, r),
                    c = Rr(t, r),
                    u = a.get(c);
                if (u) Rn(e, r, u);else {
                  var h = o ? o(f, c, r + "", e, t, a) : s,
                      d = h === s;

                  if (d) {
                    var l = ga(c),
                        p = !l && wa(c),
                        b = !l && !p && La(c);
                    h = c, l || p || b ? ga(f) ? h = f : ya(f) ? h = ns(f) : p ? (d = !1, h = Xi(c, !0)) : b ? (d = !1, h = Qi(c, !0)) : h = [] : Oa(c) || _a(c) ? (h = f, _a(f) ? h = Za(f) : (!Ta(f) || n && Ea(f)) && (h = Zs(c))) : d = !1;
                  }

                  d && (a.set(c, h), i(h, c, n, o, a), a.delete(c)), Rn(e, r, h);
                }
              }(e, t, a, r, _i, n, i);else {
                var f = n ? n(Rr(e, a), o, a + "", e, t, i) : s;
                f === s && (f = o), Rn(e, a, f);
              }
            }, of);
          }

          function gi(e, t) {
            var r = e.length;
            if (r) return Hs(t += t < 0 ? r : 0, r) ? e[t] : s;
          }

          function vi(e, t, r) {
            var n = -1;
            return t = Qt(t.length ? t : [Of], _r(Ls())), function (e, t) {
              var r = e.length;

              for (e.sort(t); r--;) {
                e[r] = e[r].value;
              }

              return e;
            }(li(e, function (e, r, i) {
              return {
                criteria: Qt(t, function (t) {
                  return t(e);
                }),
                index: ++n,
                value: e
              };
            }), function (e, t) {
              return function (e, t, r) {
                for (var n = -1, i = e.criteria, s = t.criteria, o = i.length, a = r.length; ++n < o;) {
                  var f = es(i[n], s[n]);

                  if (f) {
                    if (n >= a) return f;
                    var c = r[n];
                    return f * ("desc" == c ? -1 : 1);
                  }
                }

                return e.index - t.index;
              }(e, t, r);
            });
          }

          function mi(e, t, r) {
            for (var n = -1, i = t.length, s = {}; ++n < i;) {
              var o = t[n],
                  a = Xn(e, o);
              r(a, o) && Ti(s, $i(o, e), a);
            }

            return s;
          }

          function yi(e, t, r, n) {
            var i = n ? fr : ar,
                s = -1,
                o = t.length,
                a = e;

            for (e === t && (t = ns(t)), r && (a = Qt(e, _r(r))); ++s < o;) {
              for (var f = 0, c = t[s], u = r ? r(c) : c; (f = i(a, u, f, n)) > -1;) {
                a !== e && Nt.call(a, f, 1), Nt.call(e, f, 1);
              }
            }

            return e;
          }

          function wi(e, t) {
            for (var r = e ? t.length : 0, n = r - 1; r--;) {
              var i = t[r];

              if (r == n || i !== s) {
                var s = i;
                Hs(i) ? Nt.call(e, i, 1) : Di(e, i);
              }
            }

            return e;
          }

          function ki(e, t) {
            return e + Dr(Gr() * (t - e + 1));
          }

          function Si(e, t) {
            var r = "";
            if (!e || t < 1 || t > P) return r;

            do {
              t % 2 && (r += e), (t = Dr(t / 2)) && (e += e);
            } while (t);

            return r;
          }

          function Ei(e, t) {
            return io(eo(e, t, Of), e + "");
          }

          function Ai(e) {
            return An(pf(e));
          }

          function xi(e, t) {
            var r = pf(e);
            return ao(r, Nn(t, 0, r.length));
          }

          function Ti(e, t, r, n) {
            if (!Ta(e)) return e;

            for (var i = -1, o = (t = $i(t, e)).length, a = o - 1, f = e; null != f && ++i < o;) {
              var c = co(t[i]),
                  u = r;

              if (i != a) {
                var h = f[c];
                (u = n ? n(h, c, f) : s) === s && (u = Ta(h) ? h : Hs(t[i + 1]) ? [] : {});
              }

              Mn(f, c, u), f = f[c];
            }

            return e;
          }

          var Ri = nn ? function (e, t) {
            return nn.set(e, t), e;
          } : Of,
              Mi = dr ? function (e, t) {
            return dr(e, "toString", {
              configurable: !0,
              enumerable: !1,
              value: Rf(t),
              writable: !0
            });
          } : Of;

          function Ii(e) {
            return ao(pf(e));
          }

          function Oi(e, t, r) {
            var i = -1,
                s = e.length;
            t < 0 && (t = -t > s ? 0 : s + t), (r = r > s ? s : r) < 0 && (r += s), s = t > r ? 0 : r - t >>> 0, t >>>= 0;

            for (var o = n(s); ++i < s;) {
              o[i] = e[i + t];
            }

            return o;
          }

          function Ci(e, t) {
            var r;
            return qn(e, function (e, n, i) {
              return !(r = t(e, n, i));
            }), !!r;
          }

          function Bi(e, t, r) {
            var n = 0,
                i = null == e ? n : e.length;

            if ("number" == typeof t && t == t && i <= D) {
              for (; n < i;) {
                var s = n + i >>> 1,
                    o = e[s];
                null !== o && !Na(o) && (r ? o <= t : o < t) ? n = s + 1 : i = s;
              }

              return i;
            }

            return Pi(e, t, Of, r);
          }

          function Pi(e, t, r, n) {
            t = r(t);

            for (var i = 0, o = null == e ? 0 : e.length, a = t != t, f = null === t, c = Na(t), u = t === s; i < o;) {
              var h = Dr((i + o) / 2),
                  d = r(e[h]),
                  l = d !== s,
                  p = null === d,
                  b = d == d,
                  _ = Na(d);

              if (a) var g = n || b;else g = u ? b && (n || l) : f ? b && l && (n || !p) : c ? b && l && !p && (n || !_) : !p && !_ && (n ? d <= t : d < t);
              g ? i = h + 1 : o = h;
            }

            return Hr(o, U);
          }

          function Ni(e, t) {
            for (var r = -1, n = e.length, i = 0, s = []; ++r < n;) {
              var o = e[r],
                  a = t ? t(o) : o;

              if (!r || !la(a, f)) {
                var f = a;
                s[i++] = 0 === o ? 0 : o;
              }
            }

            return s;
          }

          function Li(e) {
            return "number" == typeof e ? e : Na(e) ? L : +e;
          }

          function ji(e) {
            if ("string" == typeof e) return e;
            if (ga(e)) return Qt(e, ji) + "";
            if (Na(e)) return ln ? ln.call(e) : "";
            var t = e + "";
            return "0" == t && 1 / e == -B ? "-0" : t;
          }

          function Ui(e, t, r) {
            var n = -1,
                i = Xt,
                s = e.length,
                a = !0,
                f = [],
                c = f;
            if (r) a = !1, i = Jt;else if (s >= o) {
              var u = t ? null : Ss(e);
              if (u) return Mr(u);
              a = !1, i = vr, c = new kn();
            } else c = t ? [] : f;

            e: for (; ++n < s;) {
              var h = e[n],
                  d = t ? t(h) : h;

              if (h = r || 0 !== h ? h : 0, a && d == d) {
                for (var l = c.length; l--;) {
                  if (c[l] === d) continue e;
                }

                t && c.push(d), f.push(h);
              } else i(c, d, r) || (c !== f && c.push(d), f.push(h));
            }

            return f;
          }

          function Di(e, t) {
            return null == (e = to(e, t = $i(t, e))) || delete e[co(So(t))];
          }

          function qi(e, t, r, n) {
            return Ti(e, t, r(Xn(e, t)), n);
          }

          function zi(e, t, r, n) {
            for (var i = e.length, s = n ? i : -1; (n ? s-- : ++s < i) && t(e[s], s, e);) {
              ;
            }

            return r ? Oi(e, n ? 0 : s, n ? s + 1 : i) : Oi(e, n ? s + 1 : 0, n ? i : s);
          }

          function Fi(e, t) {
            var r = e;
            return r instanceof vn && (r = r.value()), tr(t, function (e, t) {
              return t.func.apply(t.thisArg, er([e], t.args));
            }, r);
          }

          function Wi(e, t, r) {
            var i = e.length;
            if (i < 2) return i ? Ui(e[0]) : [];

            for (var s = -1, o = n(i); ++s < i;) {
              for (var a = e[s], f = -1; ++f < i;) {
                f != s && (o[s] = Dn(o[s] || a, e[f], t, r));
              }
            }

            return Ui(Vn(o, 1), t, r);
          }

          function Zi(e, t, r) {
            for (var n = -1, i = e.length, o = t.length, a = {}; ++n < i;) {
              var f = n < o ? t[n] : s;
              r(a, e[n], f);
            }

            return a;
          }

          function Vi(e) {
            return ya(e) ? e : [];
          }

          function Hi(e) {
            return "function" == typeof e ? e : Of;
          }

          function $i(e, t) {
            return ga(e) ? e : Ks(e, t) ? [e] : fo(Va(e));
          }

          var Ki = Ei;

          function Gi(e, t, r) {
            var n = e.length;
            return r = r === s ? n : r, !t && r >= n ? e : Oi(e, t, r);
          }

          var Yi = Nr || function (e) {
            return Bt.clearTimeout(e);
          };

          function Xi(e, t) {
            if (t) return e.slice();
            var r = e.length,
                n = Rt ? Rt(r) : new e.constructor(r);
            return e.copy(n), n;
          }

          function Ji(e) {
            var t = new e.constructor(e.byteLength);
            return new kt(t).set(new kt(e)), t;
          }

          function Qi(e, t) {
            var r = t ? Ji(e.buffer) : e.buffer;
            return new e.constructor(r, e.byteOffset, e.length);
          }

          function es(e, t) {
            if (e !== t) {
              var r = e !== s,
                  n = null === e,
                  i = e == e,
                  o = Na(e),
                  a = t !== s,
                  f = null === t,
                  c = t == t,
                  u = Na(t);
              if (!f && !u && !o && e > t || o && a && c && !f && !u || n && a && c || !r && c || !i) return 1;
              if (!n && !o && !u && e < t || u && r && i && !n && !o || f && r && i || !a && i || !c) return -1;
            }

            return 0;
          }

          function ts(e, t, r, i) {
            for (var s = -1, o = e.length, a = r.length, f = -1, c = t.length, u = Vr(o - a, 0), h = n(c + u), d = !i; ++f < c;) {
              h[f] = t[f];
            }

            for (; ++s < a;) {
              (d || s < o) && (h[r[s]] = e[s]);
            }

            for (; u--;) {
              h[f++] = e[s++];
            }

            return h;
          }

          function rs(e, t, r, i) {
            for (var s = -1, o = e.length, a = -1, f = r.length, c = -1, u = t.length, h = Vr(o - f, 0), d = n(h + u), l = !i; ++s < h;) {
              d[s] = e[s];
            }

            for (var p = s; ++c < u;) {
              d[p + c] = t[c];
            }

            for (; ++a < f;) {
              (l || s < o) && (d[p + r[a]] = e[s++]);
            }

            return d;
          }

          function ns(e, t) {
            var r = -1,
                i = e.length;

            for (t || (t = n(i)); ++r < i;) {
              t[r] = e[r];
            }

            return t;
          }

          function is(e, t, r, n) {
            var i = !r;
            r || (r = {});

            for (var o = -1, a = t.length; ++o < a;) {
              var f = t[o],
                  c = n ? n(r[f], e[f], f, r, e) : s;
              c === s && (c = e[f]), i ? Bn(r, f, c) : Mn(r, f, c);
            }

            return r;
          }

          function ss(e, t) {
            return function (r, n) {
              var i = ga(r) ? Ht : On,
                  s = t ? t() : {};
              return i(r, e, Ls(n, 2), s);
            };
          }

          function os(e) {
            return Ei(function (t, r) {
              var n = -1,
                  i = r.length,
                  o = i > 1 ? r[i - 1] : s,
                  a = i > 2 ? r[2] : s;

              for (o = e.length > 3 && "function" == typeof o ? (i--, o) : s, a && $s(r[0], r[1], a) && (o = i < 3 ? s : o, i = 1), t = tt(t); ++n < i;) {
                var f = r[n];
                f && e(t, f, n, o);
              }

              return t;
            });
          }

          function as(e, t) {
            return function (r, n) {
              if (null == r) return r;
              if (!ma(r)) return e(r, n);

              for (var i = r.length, s = t ? i : -1, o = tt(r); (t ? s-- : ++s < i) && !1 !== n(o[s], s, o);) {
                ;
              }

              return r;
            };
          }

          function fs(e) {
            return function (t, r, n) {
              for (var i = -1, s = tt(t), o = n(t), a = o.length; a--;) {
                var f = o[e ? a : ++i];
                if (!1 === r(s[f], f, s)) break;
              }

              return t;
            };
          }

          function cs(e) {
            return function (t) {
              var r = Er(t = Va(t)) ? Cr(t) : s,
                  n = r ? r[0] : t.charAt(0),
                  i = r ? Gi(r, 1).join("") : t.slice(1);
              return n[e]() + i;
            };
          }

          function us(e) {
            return function (t) {
              return tr(Af(gf(t).replace(vt, "")), e, "");
            };
          }

          function hs(e) {
            return function () {
              var t = arguments;

              switch (t.length) {
                case 0:
                  return new e();

                case 1:
                  return new e(t[0]);

                case 2:
                  return new e(t[0], t[1]);

                case 3:
                  return new e(t[0], t[1], t[2]);

                case 4:
                  return new e(t[0], t[1], t[2], t[3]);

                case 5:
                  return new e(t[0], t[1], t[2], t[3], t[4]);

                case 6:
                  return new e(t[0], t[1], t[2], t[3], t[4], t[5]);

                case 7:
                  return new e(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
              }

              var r = bn(e.prototype),
                  n = e.apply(r, t);
              return Ta(n) ? n : r;
            };
          }

          function ds(e) {
            return function (t, r, n) {
              var i = tt(t);

              if (!ma(t)) {
                var o = Ls(r, 3);
                t = sf(t), r = function r(e) {
                  return o(i[e], e, i);
                };
              }

              var a = e(t, r, n);
              return a > -1 ? i[o ? t[a] : a] : s;
            };
          }

          function ls(e) {
            return Is(function (t) {
              var r = t.length,
                  n = r,
                  i = gn.prototype.thru;

              for (e && t.reverse(); n--;) {
                var o = t[n];
                if ("function" != typeof o) throw new it(f);
                if (i && !a && "wrapper" == Ps(o)) var a = new gn([], !0);
              }

              for (n = a ? n : r; ++n < r;) {
                var c = Ps(o = t[n]),
                    u = "wrapper" == c ? Bs(o) : s;
                a = u && Gs(u[0]) && u[1] == (E | y | k | A) && !u[4].length && 1 == u[9] ? a[Ps(u[0])].apply(a, u[3]) : 1 == o.length && Gs(o) ? a[c]() : a.thru(o);
              }

              return function () {
                var e = arguments,
                    n = e[0];
                if (a && 1 == e.length && ga(n)) return a.plant(n).value();

                for (var i = 0, s = r ? t[i].apply(this, e) : n; ++i < r;) {
                  s = t[i].call(this, s);
                }

                return s;
              };
            });
          }

          function ps(e, t, r, i, o, a, f, c, u, h) {
            var d = t & E,
                l = t & g,
                p = t & v,
                b = t & (y | w),
                _ = t & x,
                m = p ? s : hs(e);

            return function g() {
              for (var v = arguments.length, y = n(v), w = v; w--;) {
                y[w] = arguments[w];
              }

              if (b) var k = Ns(g),
                  S = function (e, t) {
                for (var r = e.length, n = 0; r--;) {
                  e[r] === t && ++n;
                }

                return n;
              }(y, k);

              if (i && (y = ts(y, i, o, b)), a && (y = rs(y, a, f, b)), v -= S, b && v < h) {
                var E = Tr(y, k);
                return ws(e, t, ps, g.placeholder, r, y, E, c, u, h - v);
              }

              var A = l ? r : this,
                  x = p ? A[e] : e;
              return v = y.length, c ? y = function (e, t) {
                for (var r = e.length, n = Hr(t.length, r), i = ns(e); n--;) {
                  var o = t[n];
                  e[n] = Hs(o, r) ? i[o] : s;
                }

                return e;
              }(y, c) : _ && v > 1 && y.reverse(), d && u < v && (y.length = u), this && this !== Bt && this instanceof g && (x = m || hs(x)), x.apply(A, y);
            };
          }

          function bs(e, t) {
            return function (r, n) {
              return function (e, t, r, n) {
                return Kn(e, function (e, i, s) {
                  t(n, r(e), i, s);
                }), n;
              }(r, e, t(n), {});
            };
          }

          function _s(e, t) {
            return function (r, n) {
              var i;
              if (r === s && n === s) return t;

              if (r !== s && (i = r), n !== s) {
                if (i === s) return n;
                "string" == typeof r || "string" == typeof n ? (r = ji(r), n = ji(n)) : (r = Li(r), n = Li(n)), i = e(r, n);
              }

              return i;
            };
          }

          function gs(e) {
            return Is(function (t) {
              return t = Qt(t, _r(Ls())), Ei(function (r) {
                var n = this;
                return e(t, function (e) {
                  return Vt(e, n, r);
                });
              });
            });
          }

          function vs(e, t) {
            var r = (t = t === s ? " " : ji(t)).length;
            if (r < 2) return r ? Si(t, e) : t;
            var n = Si(t, Ur(e / Or(t)));
            return Er(t) ? Gi(Cr(n), 0, e).join("") : n.slice(0, e);
          }

          function ms(e) {
            return function (t, r, i) {
              return i && "number" != typeof i && $s(t, r, i) && (r = i = s), t = qa(t), r === s ? (r = t, t = 0) : r = qa(r), function (e, t, r, i) {
                for (var s = -1, o = Vr(Ur((t - e) / (r || 1)), 0), a = n(o); o--;) {
                  a[i ? o : ++s] = e, e += r;
                }

                return a;
              }(t, r, i = i === s ? t < r ? 1 : -1 : qa(i), e);
            };
          }

          function ys(e) {
            return function (t, r) {
              return "string" == typeof t && "string" == typeof r || (t = Wa(t), r = Wa(r)), e(t, r);
            };
          }

          function ws(e, t, r, n, i, o, a, f, c, u) {
            var h = t & y;
            t |= h ? k : S, (t &= ~(h ? S : k)) & m || (t &= ~(g | v));
            var d = [e, t, i, h ? o : s, h ? a : s, h ? s : o, h ? s : a, f, c, u],
                l = r.apply(s, d);
            return Gs(e) && ro(l, d), l.placeholder = n, so(l, e, t);
          }

          function ks(e) {
            var t = et[e];
            return function (e, r) {
              if (e = Wa(e), r = null == r ? 0 : Hr(za(r), 292)) {
                var n = (Va(e) + "e").split("e");
                return +((n = (Va(t(n[0] + "e" + (+n[1] + r))) + "e").split("e"))[0] + "e" + (+n[1] - r));
              }

              return t(e);
            };
          }

          var Ss = en && 1 / Mr(new en([, -0]))[1] == B ? function (e) {
            return new en(e);
          } : Lf;

          function Es(e) {
            return function (t) {
              var r = Fs(t);
              return r == Y ? Ar(t) : r == re ? Ir(t) : function (e, t) {
                return Qt(t, function (t) {
                  return [t, e[t]];
                });
              }(t, e(t));
            };
          }

          function As(e, t, r, i, o, a, c, u) {
            var d = t & v;
            if (!d && "function" != typeof e) throw new it(f);
            var l = i ? i.length : 0;

            if (l || (t &= ~(k | S), i = o = s), c = c === s ? c : Vr(za(c), 0), u = u === s ? u : za(u), l -= o ? o.length : 0, t & S) {
              var p = i,
                  b = o;
              i = o = s;
            }

            var _ = d ? s : Bs(e),
                x = [e, t, r, i, o, p, b, a, c, u];

            if (_ && function (e, t) {
              var r = e[1],
                  n = t[1],
                  i = r | n,
                  s = i < (g | v | E),
                  o = n == E && r == y || n == E && r == A && e[7].length <= t[8] || n == (E | A) && t[7].length <= t[8] && r == y;
              if (!s && !o) return e;
              n & g && (e[2] = t[2], i |= r & g ? 0 : m);
              var a = t[3];

              if (a) {
                var f = e[3];
                e[3] = f ? ts(f, a, t[4]) : a, e[4] = f ? Tr(e[3], h) : t[4];
              }

              (a = t[5]) && (f = e[5], e[5] = f ? rs(f, a, t[6]) : a, e[6] = f ? Tr(e[5], h) : t[6]), (a = t[7]) && (e[7] = a), n & E && (e[8] = null == e[8] ? t[8] : Hr(e[8], t[8])), null == e[9] && (e[9] = t[9]), e[0] = t[0], e[1] = i;
            }(x, _), e = x[0], t = x[1], r = x[2], i = x[3], o = x[4], !(u = x[9] = x[9] === s ? d ? 0 : e.length : Vr(x[9] - l, 0)) && t & (y | w) && (t &= ~(y | w)), t && t != g) T = t == y || t == w ? function (e, t, r) {
              var i = hs(e);
              return function o() {
                for (var a = arguments.length, f = n(a), c = a, u = Ns(o); c--;) {
                  f[c] = arguments[c];
                }

                var h = a < 3 && f[0] !== u && f[a - 1] !== u ? [] : Tr(f, u);
                return (a -= h.length) < r ? ws(e, t, ps, o.placeholder, s, f, h, s, s, r - a) : Vt(this && this !== Bt && this instanceof o ? i : e, this, f);
              };
            }(e, t, u) : t != k && t != (g | k) || o.length ? ps.apply(s, x) : function (e, t, r, i) {
              var s = t & g,
                  o = hs(e);
              return function t() {
                for (var a = -1, f = arguments.length, c = -1, u = i.length, h = n(u + f), d = this && this !== Bt && this instanceof t ? o : e; ++c < u;) {
                  h[c] = i[c];
                }

                for (; f--;) {
                  h[c++] = arguments[++a];
                }

                return Vt(d, s ? r : this, h);
              };
            }(e, t, r, i);else var T = function (e, t, r) {
              var n = t & g,
                  i = hs(e);
              return function t() {
                return (this && this !== Bt && this instanceof t ? i : e).apply(n ? r : this, arguments);
              };
            }(e, t, r);
            return so((_ ? Ri : ro)(T, x), e, t);
          }

          function xs(e, t, r, n) {
            return e === s || la(e, at[r]) && !ut.call(n, r) ? t : e;
          }

          function Ts(e, t, r, n, i, o) {
            return Ta(e) && Ta(t) && (o.set(t, e), _i(e, t, s, Ts, o), o.delete(t)), e;
          }

          function Rs(e) {
            return Oa(e) ? s : e;
          }

          function Ms(e, t, r, n, i, o) {
            var a = r & b,
                f = e.length,
                c = t.length;
            if (f != c && !(a && c > f)) return !1;
            var u = o.get(e);
            if (u && o.get(t)) return u == t;
            var h = -1,
                d = !0,
                l = r & _ ? new kn() : s;

            for (o.set(e, t), o.set(t, e); ++h < f;) {
              var p = e[h],
                  g = t[h];
              if (n) var v = a ? n(g, p, h, t, e, o) : n(p, g, h, e, t, o);

              if (v !== s) {
                if (v) continue;
                d = !1;
                break;
              }

              if (l) {
                if (!nr(t, function (e, t) {
                  if (!vr(l, t) && (p === e || i(p, e, r, n, o))) return l.push(t);
                })) {
                  d = !1;
                  break;
                }
              } else if (p !== g && !i(p, g, r, n, o)) {
                d = !1;
                break;
              }
            }

            return o.delete(e), o.delete(t), d;
          }

          function Is(e) {
            return io(eo(e, s, vo), e + "");
          }

          function Os(e) {
            return Jn(e, sf, qs);
          }

          function Cs(e) {
            return Jn(e, of, zs);
          }

          var Bs = nn ? function (e) {
            return nn.get(e);
          } : Lf;

          function Ps(e) {
            for (var t = e.name + "", r = sn[t], n = ut.call(sn, t) ? r.length : 0; n--;) {
              var i = r[n],
                  s = i.func;
              if (null == s || s == e) return i.name;
            }

            return t;
          }

          function Ns(e) {
            return (ut.call(pn, "placeholder") ? pn : e).placeholder;
          }

          function Ls() {
            var e = pn.iteratee || Cf;
            return e = e === Cf ? ci : e, arguments.length ? e(arguments[0], arguments[1]) : e;
          }

          function js(e, t) {
            var r,
                n,
                i = e.__data__;
            return ("string" == (n = typeof (r = t)) || "number" == n || "symbol" == n || "boolean" == n ? "__proto__" !== r : null === r) ? i["string" == typeof t ? "string" : "hash"] : i.map;
          }

          function Us(e) {
            for (var t = sf(e), r = t.length; r--;) {
              var n = t[r],
                  i = e[n];
              t[r] = [n, i, Js(i)];
            }

            return t;
          }

          function Ds(e, t) {
            var r = function (e, t) {
              return null == e ? s : e[t];
            }(e, t);

            return fi(r) ? r : s;
          }

          var qs = qr ? function (e) {
            return null == e ? [] : (e = tt(e), Yt(qr(e), function (t) {
              return Pt.call(e, t);
            }));
          } : Wf,
              zs = qr ? function (e) {
            for (var t = []; e;) {
              er(t, qs(e)), e = Ot(e);
            }

            return t;
          } : Wf,
              Fs = Qn;

          function Ws(e, t, r) {
            for (var n = -1, i = (t = $i(t, e)).length, s = !1; ++n < i;) {
              var o = co(t[n]);
              if (!(s = null != e && r(e, o))) break;
              e = e[o];
            }

            return s || ++n != i ? s : !!(i = null == e ? 0 : e.length) && xa(i) && Hs(o, i) && (ga(e) || _a(e));
          }

          function Zs(e) {
            return "function" != typeof e.constructor || Xs(e) ? {} : bn(Ot(e));
          }

          function Vs(e) {
            return ga(e) || _a(e) || !!(jt && e && e[jt]);
          }

          function Hs(e, t) {
            var r = typeof e;
            return !!(t = null == t ? P : t) && ("number" == r || "symbol" != r && Ke.test(e)) && e > -1 && e % 1 == 0 && e < t;
          }

          function $s(e, t, r) {
            if (!Ta(r)) return !1;
            var n = typeof t;
            return !!("number" == n ? ma(r) && Hs(t, r.length) : "string" == n && t in r) && la(r[t], e);
          }

          function Ks(e, t) {
            if (ga(e)) return !1;
            var r = typeof e;
            return !("number" != r && "symbol" != r && "boolean" != r && null != e && !Na(e)) || Ie.test(e) || !Me.test(e) || null != t && e in tt(t);
          }

          function Gs(e) {
            var t = Ps(e),
                r = pn[t];
            if ("function" != typeof r || !(t in vn.prototype)) return !1;
            if (e === r) return !0;
            var n = Bs(r);
            return !!n && e === n[0];
          }

          (Xr && Fs(new Xr(new ArrayBuffer(1))) != ce || Jr && Fs(new Jr()) != Y || Qr && "[object Promise]" != Fs(Qr.resolve()) || en && Fs(new en()) != re || tn && Fs(new tn()) != oe) && (Fs = function Fs(e) {
            var t = Qn(e),
                r = t == Q ? e.constructor : s,
                n = r ? uo(r) : "";
            if (n) switch (n) {
              case on:
                return ce;

              case an:
                return Y;

              case fn:
                return "[object Promise]";

              case cn:
                return re;

              case un:
                return oe;
            }
            return t;
          });
          var Ys = ft ? Ea : Zf;

          function Xs(e) {
            var t = e && e.constructor;
            return e === ("function" == typeof t && t.prototype || at);
          }

          function Js(e) {
            return e == e && !Ta(e);
          }

          function Qs(e, t) {
            return function (r) {
              return null != r && r[e] === t && (t !== s || e in tt(r));
            };
          }

          function eo(e, t, r) {
            return t = Vr(t === s ? e.length - 1 : t, 0), function () {
              for (var i = arguments, s = -1, o = Vr(i.length - t, 0), a = n(o); ++s < o;) {
                a[s] = i[t + s];
              }

              s = -1;

              for (var f = n(t + 1); ++s < t;) {
                f[s] = i[s];
              }

              return f[t] = r(a), Vt(e, this, f);
            };
          }

          function to(e, t) {
            return t.length < 2 ? e : Xn(e, Oi(t, 0, -1));
          }

          var ro = oo(Ri),
              no = jr || function (e, t) {
            return Bt.setTimeout(e, t);
          },
              io = oo(Mi);

          function so(e, t, r) {
            var n = t + "";
            return io(e, function (e, t) {
              var r = t.length;
              if (!r) return e;
              var n = r - 1;
              return t[n] = (r > 1 ? "& " : "") + t[n], t = t.join(r > 2 ? ", " : " "), e.replace(je, "{\n/* [wrapped with " + t + "] */\n");
            }(n, function (e, t) {
              return $t(q, function (r) {
                var n = "_." + r[0];
                t & r[1] && !Xt(e, n) && e.push(n);
              }), e.sort();
            }(function (e) {
              var t = e.match(Ue);
              return t ? t[1].split(De) : [];
            }(n), r)));
          }

          function oo(e) {
            var t = 0,
                r = 0;
            return function () {
              var n = $r(),
                  i = I - (n - r);

              if (r = n, i > 0) {
                if (++t >= M) return arguments[0];
              } else t = 0;

              return e.apply(s, arguments);
            };
          }

          function ao(e, t) {
            var r = -1,
                n = e.length,
                i = n - 1;

            for (t = t === s ? n : t; ++r < t;) {
              var o = ki(r, i),
                  a = e[o];
              e[o] = e[r], e[r] = a;
            }

            return e.length = t, e;
          }

          var fo = function (e) {
            var t = aa(e, function (e) {
              return r.size === u && r.clear(), e;
            }),
                r = t.cache;
            return t;
          }(function (e) {
            var t = [];
            return 46 === e.charCodeAt(0) && t.push(""), e.replace(Oe, function (e, r, n, i) {
              t.push(n ? i.replace(ze, "$1") : r || e);
            }), t;
          });

          function co(e) {
            if ("string" == typeof e || Na(e)) return e;
            var t = e + "";
            return "0" == t && 1 / e == -B ? "-0" : t;
          }

          function uo(e) {
            if (null != e) {
              try {
                return ct.call(e);
              } catch (e) {}

              try {
                return e + "";
              } catch (e) {}
            }

            return "";
          }

          function ho(e) {
            if (e instanceof vn) return e.clone();
            var t = new gn(e.__wrapped__, e.__chain__);
            return t.__actions__ = ns(e.__actions__), t.__index__ = e.__index__, t.__values__ = e.__values__, t;
          }

          var lo = Ei(function (e, t) {
            return ya(e) ? Dn(e, Vn(t, 1, ya, !0)) : [];
          }),
              po = Ei(function (e, t) {
            var r = So(t);
            return ya(r) && (r = s), ya(e) ? Dn(e, Vn(t, 1, ya, !0), Ls(r, 2)) : [];
          }),
              bo = Ei(function (e, t) {
            var r = So(t);
            return ya(r) && (r = s), ya(e) ? Dn(e, Vn(t, 1, ya, !0), s, r) : [];
          });

          function _o(e, t, r) {
            var n = null == e ? 0 : e.length;
            if (!n) return -1;
            var i = null == r ? 0 : za(r);
            return i < 0 && (i = Vr(n + i, 0)), or(e, Ls(t, 3), i);
          }

          function go(e, t, r) {
            var n = null == e ? 0 : e.length;
            if (!n) return -1;
            var i = n - 1;
            return r !== s && (i = za(r), i = r < 0 ? Vr(n + i, 0) : Hr(i, n - 1)), or(e, Ls(t, 3), i, !0);
          }

          function vo(e) {
            return null != e && e.length ? Vn(e, 1) : [];
          }

          function mo(e) {
            return e && e.length ? e[0] : s;
          }

          var yo = Ei(function (e) {
            var t = Qt(e, Vi);
            return t.length && t[0] === e[0] ? ni(t) : [];
          }),
              wo = Ei(function (e) {
            var t = So(e),
                r = Qt(e, Vi);
            return t === So(r) ? t = s : r.pop(), r.length && r[0] === e[0] ? ni(r, Ls(t, 2)) : [];
          }),
              ko = Ei(function (e) {
            var t = So(e),
                r = Qt(e, Vi);
            return (t = "function" == typeof t ? t : s) && r.pop(), r.length && r[0] === e[0] ? ni(r, s, t) : [];
          });

          function So(e) {
            var t = null == e ? 0 : e.length;
            return t ? e[t - 1] : s;
          }

          var Eo = Ei(Ao);

          function Ao(e, t) {
            return e && e.length && t && t.length ? yi(e, t) : e;
          }

          var xo = Is(function (e, t) {
            var r = null == e ? 0 : e.length,
                n = Pn(e, t);
            return wi(e, Qt(t, function (e) {
              return Hs(e, r) ? +e : e;
            }).sort(es)), n;
          });

          function To(e) {
            return null == e ? e : Yr.call(e);
          }

          var Ro = Ei(function (e) {
            return Ui(Vn(e, 1, ya, !0));
          }),
              Mo = Ei(function (e) {
            var t = So(e);
            return ya(t) && (t = s), Ui(Vn(e, 1, ya, !0), Ls(t, 2));
          }),
              Io = Ei(function (e) {
            var t = So(e);
            return t = "function" == typeof t ? t : s, Ui(Vn(e, 1, ya, !0), s, t);
          });

          function Oo(e) {
            if (!e || !e.length) return [];
            var t = 0;
            return e = Yt(e, function (e) {
              if (ya(e)) return t = Vr(e.length, t), !0;
            }), br(t, function (t) {
              return Qt(e, hr(t));
            });
          }

          function Co(e, t) {
            if (!e || !e.length) return [];
            var r = Oo(e);
            return null == t ? r : Qt(r, function (e) {
              return Vt(t, s, e);
            });
          }

          var Bo = Ei(function (e, t) {
            return ya(e) ? Dn(e, t) : [];
          }),
              Po = Ei(function (e) {
            return Wi(Yt(e, ya));
          }),
              No = Ei(function (e) {
            var t = So(e);
            return ya(t) && (t = s), Wi(Yt(e, ya), Ls(t, 2));
          }),
              Lo = Ei(function (e) {
            var t = So(e);
            return t = "function" == typeof t ? t : s, Wi(Yt(e, ya), s, t);
          }),
              jo = Ei(Oo);
          var Uo = Ei(function (e) {
            var t = e.length,
                r = t > 1 ? e[t - 1] : s;
            return Co(e, r = "function" == typeof r ? (e.pop(), r) : s);
          });

          function Do(e) {
            var t = pn(e);
            return t.__chain__ = !0, t;
          }

          function qo(e, t) {
            return t(e);
          }

          var zo = Is(function (e) {
            var t = e.length,
                r = t ? e[0] : 0,
                n = this.__wrapped__,
                i = function i(t) {
              return Pn(t, e);
            };

            return !(t > 1 || this.__actions__.length) && n instanceof vn && Hs(r) ? ((n = n.slice(r, +r + (t ? 1 : 0))).__actions__.push({
              func: qo,
              args: [i],
              thisArg: s
            }), new gn(n, this.__chain__).thru(function (e) {
              return t && !e.length && e.push(s), e;
            })) : this.thru(i);
          });
          var Fo = ss(function (e, t, r) {
            ut.call(e, r) ? ++e[r] : Bn(e, r, 1);
          });
          var Wo = ds(_o),
              Zo = ds(go);

          function Vo(e, t) {
            return (ga(e) ? $t : qn)(e, Ls(t, 3));
          }

          function Ho(e, t) {
            return (ga(e) ? Kt : zn)(e, Ls(t, 3));
          }

          var $o = ss(function (e, t, r) {
            ut.call(e, r) ? e[r].push(t) : Bn(e, r, [t]);
          });
          var Ko = Ei(function (e, t, r) {
            var i = -1,
                s = "function" == typeof t,
                o = ma(e) ? n(e.length) : [];
            return qn(e, function (e) {
              o[++i] = s ? Vt(t, e, r) : ii(e, t, r);
            }), o;
          }),
              Go = ss(function (e, t, r) {
            Bn(e, r, t);
          });

          function Yo(e, t) {
            return (ga(e) ? Qt : li)(e, Ls(t, 3));
          }

          var Xo = ss(function (e, t, r) {
            e[r ? 0 : 1].push(t);
          }, function () {
            return [[], []];
          });

          var Jo = Ei(function (e, t) {
            if (null == e) return [];
            var r = t.length;
            return r > 1 && $s(e, t[0], t[1]) ? t = [] : r > 2 && $s(t[0], t[1], t[2]) && (t = [t[0]]), vi(e, Vn(t, 1), []);
          }),
              Qo = Lr || function () {
            return Bt.Date.now();
          };

          function ea(e, t, r) {
            return t = r ? s : t, t = e && null == t ? e.length : t, As(e, E, s, s, s, s, t);
          }

          function ta(e, t) {
            var r;
            if ("function" != typeof t) throw new it(f);
            return e = za(e), function () {
              return --e > 0 && (r = t.apply(this, arguments)), e <= 1 && (t = s), r;
            };
          }

          var ra = Ei(function (e, t, r) {
            var n = g;

            if (r.length) {
              var i = Tr(r, Ns(ra));
              n |= k;
            }

            return As(e, n, t, r, i);
          }),
              na = Ei(function (e, t, r) {
            var n = g | v;

            if (r.length) {
              var i = Tr(r, Ns(na));
              n |= k;
            }

            return As(t, n, e, r, i);
          });

          function ia(e, t, r) {
            var n,
                i,
                o,
                a,
                c,
                u,
                h = 0,
                d = !1,
                l = !1,
                p = !0;
            if ("function" != typeof e) throw new it(f);

            function b(t) {
              var r = n,
                  o = i;
              return n = i = s, h = t, a = e.apply(o, r);
            }

            function _(e) {
              var r = e - u;
              return u === s || r >= t || r < 0 || l && e - h >= o;
            }

            function g() {
              var e = Qo();
              if (_(e)) return v(e);
              c = no(g, function (e) {
                var r = t - (e - u);
                return l ? Hr(r, o - (e - h)) : r;
              }(e));
            }

            function v(e) {
              return c = s, p && n ? b(e) : (n = i = s, a);
            }

            function m() {
              var e = Qo(),
                  r = _(e);

              if (n = arguments, i = this, u = e, r) {
                if (c === s) return function (e) {
                  return h = e, c = no(g, t), d ? b(e) : a;
                }(u);
                if (l) return c = no(g, t), b(u);
              }

              return c === s && (c = no(g, t)), a;
            }

            return t = Wa(t) || 0, Ta(r) && (d = !!r.leading, o = (l = "maxWait" in r) ? Vr(Wa(r.maxWait) || 0, t) : o, p = "trailing" in r ? !!r.trailing : p), m.cancel = function () {
              c !== s && Yi(c), h = 0, n = u = i = c = s;
            }, m.flush = function () {
              return c === s ? a : v(Qo());
            }, m;
          }

          var sa = Ei(function (e, t) {
            return Un(e, 1, t);
          }),
              oa = Ei(function (e, t, r) {
            return Un(e, Wa(t) || 0, r);
          });

          function aa(e, t) {
            if ("function" != typeof e || null != t && "function" != typeof t) throw new it(f);

            var r = function r() {
              var n = arguments,
                  i = t ? t.apply(this, n) : n[0],
                  s = r.cache;
              if (s.has(i)) return s.get(i);
              var o = e.apply(this, n);
              return r.cache = s.set(i, o) || s, o;
            };

            return r.cache = new (aa.Cache || wn)(), r;
          }

          function fa(e) {
            if ("function" != typeof e) throw new it(f);
            return function () {
              var t = arguments;

              switch (t.length) {
                case 0:
                  return !e.call(this);

                case 1:
                  return !e.call(this, t[0]);

                case 2:
                  return !e.call(this, t[0], t[1]);

                case 3:
                  return !e.call(this, t[0], t[1], t[2]);
              }

              return !e.apply(this, t);
            };
          }

          aa.Cache = wn;
          var ca = Ki(function (e, t) {
            var r = (t = 1 == t.length && ga(t[0]) ? Qt(t[0], _r(Ls())) : Qt(Vn(t, 1), _r(Ls()))).length;
            return Ei(function (n) {
              for (var i = -1, s = Hr(n.length, r); ++i < s;) {
                n[i] = t[i].call(this, n[i]);
              }

              return Vt(e, this, n);
            });
          }),
              ua = Ei(function (e, t) {
            var r = Tr(t, Ns(ua));
            return As(e, k, s, t, r);
          }),
              ha = Ei(function (e, t) {
            var r = Tr(t, Ns(ha));
            return As(e, S, s, t, r);
          }),
              da = Is(function (e, t) {
            return As(e, A, s, s, s, t);
          });

          function la(e, t) {
            return e === t || e != e && t != t;
          }

          var pa = ys(ei),
              ba = ys(function (e, t) {
            return e >= t;
          }),
              _a = si(function () {
            return arguments;
          }()) ? si : function (e) {
            return Ra(e) && ut.call(e, "callee") && !Pt.call(e, "callee");
          },
              ga = n.isArray,
              va = Dt ? _r(Dt) : function (e) {
            return Ra(e) && Qn(e) == fe;
          };

          function ma(e) {
            return null != e && xa(e.length) && !Ea(e);
          }

          function ya(e) {
            return Ra(e) && ma(e);
          }

          var wa = zr || Zf,
              ka = qt ? _r(qt) : function (e) {
            return Ra(e) && Qn(e) == V;
          };

          function Sa(e) {
            if (!Ra(e)) return !1;
            var t = Qn(e);
            return t == $ || t == H || "string" == typeof e.message && "string" == typeof e.name && !Oa(e);
          }

          function Ea(e) {
            if (!Ta(e)) return !1;
            var t = Qn(e);
            return t == K || t == G || t == W || t == ee;
          }

          function Aa(e) {
            return "number" == typeof e && e == za(e);
          }

          function xa(e) {
            return "number" == typeof e && e > -1 && e % 1 == 0 && e <= P;
          }

          function Ta(e) {
            var t = typeof e;
            return null != e && ("object" == t || "function" == t);
          }

          function Ra(e) {
            return null != e && "object" == typeof e;
          }

          var Ma = zt ? _r(zt) : function (e) {
            return Ra(e) && Fs(e) == Y;
          };

          function Ia(e) {
            return "number" == typeof e || Ra(e) && Qn(e) == X;
          }

          function Oa(e) {
            if (!Ra(e) || Qn(e) != Q) return !1;
            var t = Ot(e);
            if (null === t) return !0;
            var r = ut.call(t, "constructor") && t.constructor;
            return "function" == typeof r && r instanceof r && ct.call(r) == pt;
          }

          var Ca = Ft ? _r(Ft) : function (e) {
            return Ra(e) && Qn(e) == te;
          };
          var Ba = Wt ? _r(Wt) : function (e) {
            return Ra(e) && Fs(e) == re;
          };

          function Pa(e) {
            return "string" == typeof e || !ga(e) && Ra(e) && Qn(e) == ne;
          }

          function Na(e) {
            return "symbol" == typeof e || Ra(e) && Qn(e) == ie;
          }

          var La = Zt ? _r(Zt) : function (e) {
            return Ra(e) && xa(e.length) && !!xt[Qn(e)];
          };
          var ja = ys(di),
              Ua = ys(function (e, t) {
            return e <= t;
          });

          function Da(e) {
            if (!e) return [];
            if (ma(e)) return Pa(e) ? Cr(e) : ns(e);
            if (Ut && e[Ut]) return function (e) {
              for (var t, r = []; !(t = e.next()).done;) {
                r.push(t.value);
              }

              return r;
            }(e[Ut]());
            var t = Fs(e);
            return (t == Y ? Ar : t == re ? Mr : pf)(e);
          }

          function qa(e) {
            return e ? (e = Wa(e)) === B || e === -B ? (e < 0 ? -1 : 1) * N : e == e ? e : 0 : 0 === e ? e : 0;
          }

          function za(e) {
            var t = qa(e),
                r = t % 1;
            return t == t ? r ? t - r : t : 0;
          }

          function Fa(e) {
            return e ? Nn(za(e), 0, j) : 0;
          }

          function Wa(e) {
            if ("number" == typeof e) return e;
            if (Na(e)) return L;

            if (Ta(e)) {
              var t = "function" == typeof e.valueOf ? e.valueOf() : e;
              e = Ta(t) ? t + "" : t;
            }

            if ("string" != typeof e) return 0 === e ? e : +e;
            e = e.replace(Pe, "");
            var r = Ve.test(e);
            return r || $e.test(e) ? It(e.slice(2), r ? 2 : 8) : Ze.test(e) ? L : +e;
          }

          function Za(e) {
            return is(e, of(e));
          }

          function Va(e) {
            return null == e ? "" : ji(e);
          }

          var Ha = os(function (e, t) {
            if (Xs(t) || ma(t)) is(t, sf(t), e);else for (var r in t) {
              ut.call(t, r) && Mn(e, r, t[r]);
            }
          }),
              $a = os(function (e, t) {
            is(t, of(t), e);
          }),
              Ka = os(function (e, t, r, n) {
            is(t, of(t), e, n);
          }),
              Ga = os(function (e, t, r, n) {
            is(t, sf(t), e, n);
          }),
              Ya = Is(Pn);
          var Xa = Ei(function (e, t) {
            e = tt(e);
            var r = -1,
                n = t.length,
                i = n > 2 ? t[2] : s;

            for (i && $s(t[0], t[1], i) && (n = 1); ++r < n;) {
              for (var o = t[r], a = of(o), f = -1, c = a.length; ++f < c;) {
                var u = a[f],
                    h = e[u];
                (h === s || la(h, at[u]) && !ut.call(e, u)) && (e[u] = o[u]);
              }
            }

            return e;
          }),
              Ja = Ei(function (e) {
            return e.push(s, Ts), Vt(ff, s, e);
          });

          function Qa(e, t, r) {
            var n = null == e ? s : Xn(e, t);
            return n === s ? r : n;
          }

          function ef(e, t) {
            return null != e && Ws(e, t, ri);
          }

          var tf = bs(function (e, t, r) {
            null != t && "function" != typeof t.toString && (t = lt.call(t)), e[t] = r;
          }, Rf(Of)),
              rf = bs(function (e, t, r) {
            null != t && "function" != typeof t.toString && (t = lt.call(t)), ut.call(e, t) ? e[t].push(r) : e[t] = [r];
          }, Ls),
              nf = Ei(ii);

          function sf(e) {
            return ma(e) ? En(e) : ui(e);
          }

          function of(e) {
            return ma(e) ? En(e, !0) : hi(e);
          }

          var af = os(function (e, t, r) {
            _i(e, t, r);
          }),
              ff = os(function (e, t, r, n) {
            _i(e, t, r, n);
          }),
              cf = Is(function (e, t) {
            var r = {};
            if (null == e) return r;
            var n = !1;
            t = Qt(t, function (t) {
              return t = $i(t, e), n || (n = t.length > 1), t;
            }), is(e, Cs(e), r), n && (r = Ln(r, d | l | p, Rs));

            for (var i = t.length; i--;) {
              Di(r, t[i]);
            }

            return r;
          });
          var uf = Is(function (e, t) {
            return null == e ? {} : function (e, t) {
              return mi(e, t, function (t, r) {
                return ef(e, r);
              });
            }(e, t);
          });

          function hf(e, t) {
            if (null == e) return {};
            var r = Qt(Cs(e), function (e) {
              return [e];
            });
            return t = Ls(t), mi(e, r, function (e, r) {
              return t(e, r[0]);
            });
          }

          var df = Es(sf),
              lf = Es(of);

          function pf(e) {
            return null == e ? [] : gr(e, sf(e));
          }

          var bf = us(function (e, t, r) {
            return t = t.toLowerCase(), e + (r ? _f(t) : t);
          });

          function _f(e) {
            return Ef(Va(e).toLowerCase());
          }

          function gf(e) {
            return (e = Va(e)) && e.replace(Ge, wr).replace(mt, "");
          }

          var vf = us(function (e, t, r) {
            return e + (r ? "-" : "") + t.toLowerCase();
          }),
              mf = us(function (e, t, r) {
            return e + (r ? " " : "") + t.toLowerCase();
          }),
              yf = cs("toLowerCase");
          var wf = us(function (e, t, r) {
            return e + (r ? "_" : "") + t.toLowerCase();
          });
          var kf = us(function (e, t, r) {
            return e + (r ? " " : "") + Ef(t);
          });
          var Sf = us(function (e, t, r) {
            return e + (r ? " " : "") + t.toUpperCase();
          }),
              Ef = cs("toUpperCase");

          function Af(e, t, r) {
            return e = Va(e), (t = r ? s : t) === s ? function (e) {
              return St.test(e);
            }(e) ? function (e) {
              return e.match(wt) || [];
            }(e) : function (e) {
              return e.match(qe) || [];
            }(e) : e.match(t) || [];
          }

          var xf = Ei(function (e, t) {
            try {
              return Vt(e, s, t);
            } catch (e) {
              return Sa(e) ? e : new Je(e);
            }
          }),
              Tf = Is(function (e, t) {
            return $t(t, function (t) {
              t = co(t), Bn(e, t, ra(e[t], e));
            }), e;
          });

          function Rf(e) {
            return function () {
              return e;
            };
          }

          var Mf = ls(),
              If = ls(!0);

          function Of(e) {
            return e;
          }

          function Cf(e) {
            return ci("function" == typeof e ? e : Ln(e, d));
          }

          var Bf = Ei(function (e, t) {
            return function (r) {
              return ii(r, e, t);
            };
          }),
              Pf = Ei(function (e, t) {
            return function (r) {
              return ii(e, r, t);
            };
          });

          function Nf(e, t, r) {
            var n = sf(t),
                i = Yn(t, n);
            null != r || Ta(t) && (i.length || !n.length) || (r = t, t = e, e = this, i = Yn(t, sf(t)));
            var s = !(Ta(r) && "chain" in r && !r.chain),
                o = Ea(e);
            return $t(i, function (r) {
              var n = t[r];
              e[r] = n, o && (e.prototype[r] = function () {
                var t = this.__chain__;

                if (s || t) {
                  var r = e(this.__wrapped__);
                  return (r.__actions__ = ns(this.__actions__)).push({
                    func: n,
                    args: arguments,
                    thisArg: e
                  }), r.__chain__ = t, r;
                }

                return n.apply(e, er([this.value()], arguments));
              });
            }), e;
          }

          function Lf() {}

          var jf = gs(Qt),
              Uf = gs(Gt),
              Df = gs(nr);

          function qf(e) {
            return Ks(e) ? hr(co(e)) : function (e) {
              return function (t) {
                return Xn(t, e);
              };
            }(e);
          }

          var zf = ms(),
              Ff = ms(!0);

          function Wf() {
            return [];
          }

          function Zf() {
            return !1;
          }

          var Vf = _s(function (e, t) {
            return e + t;
          }, 0),
              Hf = ks("ceil"),
              $f = _s(function (e, t) {
            return e / t;
          }, 1),
              Kf = ks("floor");

          var Gf,
              Yf = _s(function (e, t) {
            return e * t;
          }, 1),
              Xf = ks("round"),
              Jf = _s(function (e, t) {
            return e - t;
          }, 0);

          return pn.after = function (e, t) {
            if ("function" != typeof t) throw new it(f);
            return e = za(e), function () {
              if (--e < 1) return t.apply(this, arguments);
            };
          }, pn.ary = ea, pn.assign = Ha, pn.assignIn = $a, pn.assignInWith = Ka, pn.assignWith = Ga, pn.at = Ya, pn.before = ta, pn.bind = ra, pn.bindAll = Tf, pn.bindKey = na, pn.castArray = function () {
            if (!arguments.length) return [];
            var e = arguments[0];
            return ga(e) ? e : [e];
          }, pn.chain = Do, pn.chunk = function (e, t, r) {
            t = (r ? $s(e, t, r) : t === s) ? 1 : Vr(za(t), 0);
            var i = null == e ? 0 : e.length;
            if (!i || t < 1) return [];

            for (var o = 0, a = 0, f = n(Ur(i / t)); o < i;) {
              f[a++] = Oi(e, o, o += t);
            }

            return f;
          }, pn.compact = function (e) {
            for (var t = -1, r = null == e ? 0 : e.length, n = 0, i = []; ++t < r;) {
              var s = e[t];
              s && (i[n++] = s);
            }

            return i;
          }, pn.concat = function () {
            var e = arguments.length;
            if (!e) return [];

            for (var t = n(e - 1), r = arguments[0], i = e; i--;) {
              t[i - 1] = arguments[i];
            }

            return er(ga(r) ? ns(r) : [r], Vn(t, 1));
          }, pn.cond = function (e) {
            var t = null == e ? 0 : e.length,
                r = Ls();
            return e = t ? Qt(e, function (e) {
              if ("function" != typeof e[1]) throw new it(f);
              return [r(e[0]), e[1]];
            }) : [], Ei(function (r) {
              for (var n = -1; ++n < t;) {
                var i = e[n];
                if (Vt(i[0], this, r)) return Vt(i[1], this, r);
              }
            });
          }, pn.conforms = function (e) {
            return function (e) {
              var t = sf(e);
              return function (r) {
                return jn(r, e, t);
              };
            }(Ln(e, d));
          }, pn.constant = Rf, pn.countBy = Fo, pn.create = function (e, t) {
            var r = bn(e);
            return null == t ? r : Cn(r, t);
          }, pn.curry = function e(t, r, n) {
            var i = As(t, y, s, s, s, s, s, r = n ? s : r);
            return i.placeholder = e.placeholder, i;
          }, pn.curryRight = function e(t, r, n) {
            var i = As(t, w, s, s, s, s, s, r = n ? s : r);
            return i.placeholder = e.placeholder, i;
          }, pn.debounce = ia, pn.defaults = Xa, pn.defaultsDeep = Ja, pn.defer = sa, pn.delay = oa, pn.difference = lo, pn.differenceBy = po, pn.differenceWith = bo, pn.drop = function (e, t, r) {
            var n = null == e ? 0 : e.length;
            return n ? Oi(e, (t = r || t === s ? 1 : za(t)) < 0 ? 0 : t, n) : [];
          }, pn.dropRight = function (e, t, r) {
            var n = null == e ? 0 : e.length;
            return n ? Oi(e, 0, (t = n - (t = r || t === s ? 1 : za(t))) < 0 ? 0 : t) : [];
          }, pn.dropRightWhile = function (e, t) {
            return e && e.length ? zi(e, Ls(t, 3), !0, !0) : [];
          }, pn.dropWhile = function (e, t) {
            return e && e.length ? zi(e, Ls(t, 3), !0) : [];
          }, pn.fill = function (e, t, r, n) {
            var i = null == e ? 0 : e.length;
            return i ? (r && "number" != typeof r && $s(e, t, r) && (r = 0, n = i), function (e, t, r, n) {
              var i = e.length;

              for ((r = za(r)) < 0 && (r = -r > i ? 0 : i + r), (n = n === s || n > i ? i : za(n)) < 0 && (n += i), n = r > n ? 0 : Fa(n); r < n;) {
                e[r++] = t;
              }

              return e;
            }(e, t, r, n)) : [];
          }, pn.filter = function (e, t) {
            return (ga(e) ? Yt : Zn)(e, Ls(t, 3));
          }, pn.flatMap = function (e, t) {
            return Vn(Yo(e, t), 1);
          }, pn.flatMapDeep = function (e, t) {
            return Vn(Yo(e, t), B);
          }, pn.flatMapDepth = function (e, t, r) {
            return r = r === s ? 1 : za(r), Vn(Yo(e, t), r);
          }, pn.flatten = vo, pn.flattenDeep = function (e) {
            return null != e && e.length ? Vn(e, B) : [];
          }, pn.flattenDepth = function (e, t) {
            return null != e && e.length ? Vn(e, t = t === s ? 1 : za(t)) : [];
          }, pn.flip = function (e) {
            return As(e, x);
          }, pn.flow = Mf, pn.flowRight = If, pn.fromPairs = function (e) {
            for (var t = -1, r = null == e ? 0 : e.length, n = {}; ++t < r;) {
              var i = e[t];
              n[i[0]] = i[1];
            }

            return n;
          }, pn.functions = function (e) {
            return null == e ? [] : Yn(e, sf(e));
          }, pn.functionsIn = function (e) {
            return null == e ? [] : Yn(e, of(e));
          }, pn.groupBy = $o, pn.initial = function (e) {
            return null != e && e.length ? Oi(e, 0, -1) : [];
          }, pn.intersection = yo, pn.intersectionBy = wo, pn.intersectionWith = ko, pn.invert = tf, pn.invertBy = rf, pn.invokeMap = Ko, pn.iteratee = Cf, pn.keyBy = Go, pn.keys = sf, pn.keysIn = of, pn.map = Yo, pn.mapKeys = function (e, t) {
            var r = {};
            return t = Ls(t, 3), Kn(e, function (e, n, i) {
              Bn(r, t(e, n, i), e);
            }), r;
          }, pn.mapValues = function (e, t) {
            var r = {};
            return t = Ls(t, 3), Kn(e, function (e, n, i) {
              Bn(r, n, t(e, n, i));
            }), r;
          }, pn.matches = function (e) {
            return pi(Ln(e, d));
          }, pn.matchesProperty = function (e, t) {
            return bi(e, Ln(t, d));
          }, pn.memoize = aa, pn.merge = af, pn.mergeWith = ff, pn.method = Bf, pn.methodOf = Pf, pn.mixin = Nf, pn.negate = fa, pn.nthArg = function (e) {
            return e = za(e), Ei(function (t) {
              return gi(t, e);
            });
          }, pn.omit = cf, pn.omitBy = function (e, t) {
            return hf(e, fa(Ls(t)));
          }, pn.once = function (e) {
            return ta(2, e);
          }, pn.orderBy = function (e, t, r, n) {
            return null == e ? [] : (ga(t) || (t = null == t ? [] : [t]), ga(r = n ? s : r) || (r = null == r ? [] : [r]), vi(e, t, r));
          }, pn.over = jf, pn.overArgs = ca, pn.overEvery = Uf, pn.overSome = Df, pn.partial = ua, pn.partialRight = ha, pn.partition = Xo, pn.pick = uf, pn.pickBy = hf, pn.property = qf, pn.propertyOf = function (e) {
            return function (t) {
              return null == e ? s : Xn(e, t);
            };
          }, pn.pull = Eo, pn.pullAll = Ao, pn.pullAllBy = function (e, t, r) {
            return e && e.length && t && t.length ? yi(e, t, Ls(r, 2)) : e;
          }, pn.pullAllWith = function (e, t, r) {
            return e && e.length && t && t.length ? yi(e, t, s, r) : e;
          }, pn.pullAt = xo, pn.range = zf, pn.rangeRight = Ff, pn.rearg = da, pn.reject = function (e, t) {
            return (ga(e) ? Yt : Zn)(e, fa(Ls(t, 3)));
          }, pn.remove = function (e, t) {
            var r = [];
            if (!e || !e.length) return r;
            var n = -1,
                i = [],
                s = e.length;

            for (t = Ls(t, 3); ++n < s;) {
              var o = e[n];
              t(o, n, e) && (r.push(o), i.push(n));
            }

            return wi(e, i), r;
          }, pn.rest = function (e, t) {
            if ("function" != typeof e) throw new it(f);
            return Ei(e, t = t === s ? t : za(t));
          }, pn.reverse = To, pn.sampleSize = function (e, t, r) {
            return t = (r ? $s(e, t, r) : t === s) ? 1 : za(t), (ga(e) ? xn : xi)(e, t);
          }, pn.set = function (e, t, r) {
            return null == e ? e : Ti(e, t, r);
          }, pn.setWith = function (e, t, r, n) {
            return n = "function" == typeof n ? n : s, null == e ? e : Ti(e, t, r, n);
          }, pn.shuffle = function (e) {
            return (ga(e) ? Tn : Ii)(e);
          }, pn.slice = function (e, t, r) {
            var n = null == e ? 0 : e.length;
            return n ? (r && "number" != typeof r && $s(e, t, r) ? (t = 0, r = n) : (t = null == t ? 0 : za(t), r = r === s ? n : za(r)), Oi(e, t, r)) : [];
          }, pn.sortBy = Jo, pn.sortedUniq = function (e) {
            return e && e.length ? Ni(e) : [];
          }, pn.sortedUniqBy = function (e, t) {
            return e && e.length ? Ni(e, Ls(t, 2)) : [];
          }, pn.split = function (e, t, r) {
            return r && "number" != typeof r && $s(e, t, r) && (t = r = s), (r = r === s ? j : r >>> 0) ? (e = Va(e)) && ("string" == typeof t || null != t && !Ca(t)) && !(t = ji(t)) && Er(e) ? Gi(Cr(e), 0, r) : e.split(t, r) : [];
          }, pn.spread = function (e, t) {
            if ("function" != typeof e) throw new it(f);
            return t = null == t ? 0 : Vr(za(t), 0), Ei(function (r) {
              var n = r[t],
                  i = Gi(r, 0, t);
              return n && er(i, n), Vt(e, this, i);
            });
          }, pn.tail = function (e) {
            var t = null == e ? 0 : e.length;
            return t ? Oi(e, 1, t) : [];
          }, pn.take = function (e, t, r) {
            return e && e.length ? Oi(e, 0, (t = r || t === s ? 1 : za(t)) < 0 ? 0 : t) : [];
          }, pn.takeRight = function (e, t, r) {
            var n = null == e ? 0 : e.length;
            return n ? Oi(e, (t = n - (t = r || t === s ? 1 : za(t))) < 0 ? 0 : t, n) : [];
          }, pn.takeRightWhile = function (e, t) {
            return e && e.length ? zi(e, Ls(t, 3), !1, !0) : [];
          }, pn.takeWhile = function (e, t) {
            return e && e.length ? zi(e, Ls(t, 3)) : [];
          }, pn.tap = function (e, t) {
            return t(e), e;
          }, pn.throttle = function (e, t, r) {
            var n = !0,
                i = !0;
            if ("function" != typeof e) throw new it(f);
            return Ta(r) && (n = "leading" in r ? !!r.leading : n, i = "trailing" in r ? !!r.trailing : i), ia(e, t, {
              leading: n,
              maxWait: t,
              trailing: i
            });
          }, pn.thru = qo, pn.toArray = Da, pn.toPairs = df, pn.toPairsIn = lf, pn.toPath = function (e) {
            return ga(e) ? Qt(e, co) : Na(e) ? [e] : ns(fo(Va(e)));
          }, pn.toPlainObject = Za, pn.transform = function (e, t, r) {
            var n = ga(e),
                i = n || wa(e) || La(e);

            if (t = Ls(t, 4), null == r) {
              var s = e && e.constructor;
              r = i ? n ? new s() : [] : Ta(e) && Ea(s) ? bn(Ot(e)) : {};
            }

            return (i ? $t : Kn)(e, function (e, n, i) {
              return t(r, e, n, i);
            }), r;
          }, pn.unary = function (e) {
            return ea(e, 1);
          }, pn.union = Ro, pn.unionBy = Mo, pn.unionWith = Io, pn.uniq = function (e) {
            return e && e.length ? Ui(e) : [];
          }, pn.uniqBy = function (e, t) {
            return e && e.length ? Ui(e, Ls(t, 2)) : [];
          }, pn.uniqWith = function (e, t) {
            return t = "function" == typeof t ? t : s, e && e.length ? Ui(e, s, t) : [];
          }, pn.unset = function (e, t) {
            return null == e || Di(e, t);
          }, pn.unzip = Oo, pn.unzipWith = Co, pn.update = function (e, t, r) {
            return null == e ? e : qi(e, t, Hi(r));
          }, pn.updateWith = function (e, t, r, n) {
            return n = "function" == typeof n ? n : s, null == e ? e : qi(e, t, Hi(r), n);
          }, pn.values = pf, pn.valuesIn = function (e) {
            return null == e ? [] : gr(e, of(e));
          }, pn.without = Bo, pn.words = Af, pn.wrap = function (e, t) {
            return ua(Hi(t), e);
          }, pn.xor = Po, pn.xorBy = No, pn.xorWith = Lo, pn.zip = jo, pn.zipObject = function (e, t) {
            return Zi(e || [], t || [], Mn);
          }, pn.zipObjectDeep = function (e, t) {
            return Zi(e || [], t || [], Ti);
          }, pn.zipWith = Uo, pn.entries = df, pn.entriesIn = lf, pn.extend = $a, pn.extendWith = Ka, Nf(pn, pn), pn.add = Vf, pn.attempt = xf, pn.camelCase = bf, pn.capitalize = _f, pn.ceil = Hf, pn.clamp = function (e, t, r) {
            return r === s && (r = t, t = s), r !== s && (r = (r = Wa(r)) == r ? r : 0), t !== s && (t = (t = Wa(t)) == t ? t : 0), Nn(Wa(e), t, r);
          }, pn.clone = function (e) {
            return Ln(e, p);
          }, pn.cloneDeep = function (e) {
            return Ln(e, d | p);
          }, pn.cloneDeepWith = function (e, t) {
            return Ln(e, d | p, t = "function" == typeof t ? t : s);
          }, pn.cloneWith = function (e, t) {
            return Ln(e, p, t = "function" == typeof t ? t : s);
          }, pn.conformsTo = function (e, t) {
            return null == t || jn(e, t, sf(t));
          }, pn.deburr = gf, pn.defaultTo = function (e, t) {
            return null == e || e != e ? t : e;
          }, pn.divide = $f, pn.endsWith = function (e, t, r) {
            e = Va(e), t = ji(t);
            var n = e.length,
                i = r = r === s ? n : Nn(za(r), 0, n);
            return (r -= t.length) >= 0 && e.slice(r, i) == t;
          }, pn.eq = la, pn.escape = function (e) {
            return (e = Va(e)) && Ae.test(e) ? e.replace(Se, kr) : e;
          }, pn.escapeRegExp = function (e) {
            return (e = Va(e)) && Be.test(e) ? e.replace(Ce, "\\$&") : e;
          }, pn.every = function (e, t, r) {
            var n = ga(e) ? Gt : Fn;
            return r && $s(e, t, r) && (t = s), n(e, Ls(t, 3));
          }, pn.find = Wo, pn.findIndex = _o, pn.findKey = function (e, t) {
            return sr(e, Ls(t, 3), Kn);
          }, pn.findLast = Zo, pn.findLastIndex = go, pn.findLastKey = function (e, t) {
            return sr(e, Ls(t, 3), Gn);
          }, pn.floor = Kf, pn.forEach = Vo, pn.forEachRight = Ho, pn.forIn = function (e, t) {
            return null == e ? e : Hn(e, Ls(t, 3), of);
          }, pn.forInRight = function (e, t) {
            return null == e ? e : $n(e, Ls(t, 3), of);
          }, pn.forOwn = function (e, t) {
            return e && Kn(e, Ls(t, 3));
          }, pn.forOwnRight = function (e, t) {
            return e && Gn(e, Ls(t, 3));
          }, pn.get = Qa, pn.gt = pa, pn.gte = ba, pn.has = function (e, t) {
            return null != e && Ws(e, t, ti);
          }, pn.hasIn = ef, pn.head = mo, pn.identity = Of, pn.includes = function (e, t, r, n) {
            e = ma(e) ? e : pf(e), r = r && !n ? za(r) : 0;
            var i = e.length;
            return r < 0 && (r = Vr(i + r, 0)), Pa(e) ? r <= i && e.indexOf(t, r) > -1 : !!i && ar(e, t, r) > -1;
          }, pn.indexOf = function (e, t, r) {
            var n = null == e ? 0 : e.length;
            if (!n) return -1;
            var i = null == r ? 0 : za(r);
            return i < 0 && (i = Vr(n + i, 0)), ar(e, t, i);
          }, pn.inRange = function (e, t, r) {
            return t = qa(t), r === s ? (r = t, t = 0) : r = qa(r), function (e, t, r) {
              return e >= Hr(t, r) && e < Vr(t, r);
            }(e = Wa(e), t, r);
          }, pn.invoke = nf, pn.isArguments = _a, pn.isArray = ga, pn.isArrayBuffer = va, pn.isArrayLike = ma, pn.isArrayLikeObject = ya, pn.isBoolean = function (e) {
            return !0 === e || !1 === e || Ra(e) && Qn(e) == Z;
          }, pn.isBuffer = wa, pn.isDate = ka, pn.isElement = function (e) {
            return Ra(e) && 1 === e.nodeType && !Oa(e);
          }, pn.isEmpty = function (e) {
            if (null == e) return !0;
            if (ma(e) && (ga(e) || "string" == typeof e || "function" == typeof e.splice || wa(e) || La(e) || _a(e))) return !e.length;
            var t = Fs(e);
            if (t == Y || t == re) return !e.size;
            if (Xs(e)) return !ui(e).length;

            for (var r in e) {
              if (ut.call(e, r)) return !1;
            }

            return !0;
          }, pn.isEqual = function (e, t) {
            return oi(e, t);
          }, pn.isEqualWith = function (e, t, r) {
            var n = (r = "function" == typeof r ? r : s) ? r(e, t) : s;
            return n === s ? oi(e, t, s, r) : !!n;
          }, pn.isError = Sa, pn.isFinite = function (e) {
            return "number" == typeof e && Fr(e);
          }, pn.isFunction = Ea, pn.isInteger = Aa, pn.isLength = xa, pn.isMap = Ma, pn.isMatch = function (e, t) {
            return e === t || ai(e, t, Us(t));
          }, pn.isMatchWith = function (e, t, r) {
            return r = "function" == typeof r ? r : s, ai(e, t, Us(t), r);
          }, pn.isNaN = function (e) {
            return Ia(e) && e != +e;
          }, pn.isNative = function (e) {
            if (Ys(e)) throw new Je(a);
            return fi(e);
          }, pn.isNil = function (e) {
            return null == e;
          }, pn.isNull = function (e) {
            return null === e;
          }, pn.isNumber = Ia, pn.isObject = Ta, pn.isObjectLike = Ra, pn.isPlainObject = Oa, pn.isRegExp = Ca, pn.isSafeInteger = function (e) {
            return Aa(e) && e >= -P && e <= P;
          }, pn.isSet = Ba, pn.isString = Pa, pn.isSymbol = Na, pn.isTypedArray = La, pn.isUndefined = function (e) {
            return e === s;
          }, pn.isWeakMap = function (e) {
            return Ra(e) && Fs(e) == oe;
          }, pn.isWeakSet = function (e) {
            return Ra(e) && Qn(e) == ae;
          }, pn.join = function (e, t) {
            return null == e ? "" : Wr.call(e, t);
          }, pn.kebabCase = vf, pn.last = So, pn.lastIndexOf = function (e, t, r) {
            var n = null == e ? 0 : e.length;
            if (!n) return -1;
            var i = n;
            return r !== s && (i = (i = za(r)) < 0 ? Vr(n + i, 0) : Hr(i, n - 1)), t == t ? function (e, t, r) {
              for (var n = r + 1; n--;) {
                if (e[n] === t) return n;
              }

              return n;
            }(e, t, i) : or(e, cr, i, !0);
          }, pn.lowerCase = mf, pn.lowerFirst = yf, pn.lt = ja, pn.lte = Ua, pn.max = function (e) {
            return e && e.length ? Wn(e, Of, ei) : s;
          }, pn.maxBy = function (e, t) {
            return e && e.length ? Wn(e, Ls(t, 2), ei) : s;
          }, pn.mean = function (e) {
            return ur(e, Of);
          }, pn.meanBy = function (e, t) {
            return ur(e, Ls(t, 2));
          }, pn.min = function (e) {
            return e && e.length ? Wn(e, Of, di) : s;
          }, pn.minBy = function (e, t) {
            return e && e.length ? Wn(e, Ls(t, 2), di) : s;
          }, pn.stubArray = Wf, pn.stubFalse = Zf, pn.stubObject = function () {
            return {};
          }, pn.stubString = function () {
            return "";
          }, pn.stubTrue = function () {
            return !0;
          }, pn.multiply = Yf, pn.nth = function (e, t) {
            return e && e.length ? gi(e, za(t)) : s;
          }, pn.noConflict = function () {
            return Bt._ === this && (Bt._ = bt), this;
          }, pn.noop = Lf, pn.now = Qo, pn.pad = function (e, t, r) {
            e = Va(e);
            var n = (t = za(t)) ? Or(e) : 0;
            if (!t || n >= t) return e;
            var i = (t - n) / 2;
            return vs(Dr(i), r) + e + vs(Ur(i), r);
          }, pn.padEnd = function (e, t, r) {
            e = Va(e);
            var n = (t = za(t)) ? Or(e) : 0;
            return t && n < t ? e + vs(t - n, r) : e;
          }, pn.padStart = function (e, t, r) {
            e = Va(e);
            var n = (t = za(t)) ? Or(e) : 0;
            return t && n < t ? vs(t - n, r) + e : e;
          }, pn.parseInt = function (e, t, r) {
            return r || null == t ? t = 0 : t && (t = +t), Kr(Va(e).replace(Ne, ""), t || 0);
          }, pn.random = function (e, t, r) {
            if (r && "boolean" != typeof r && $s(e, t, r) && (t = r = s), r === s && ("boolean" == typeof t ? (r = t, t = s) : "boolean" == typeof e && (r = e, e = s)), e === s && t === s ? (e = 0, t = 1) : (e = qa(e), t === s ? (t = e, e = 0) : t = qa(t)), e > t) {
              var n = e;
              e = t, t = n;
            }

            if (r || e % 1 || t % 1) {
              var i = Gr();
              return Hr(e + i * (t - e + Mt("1e-" + ((i + "").length - 1))), t);
            }

            return ki(e, t);
          }, pn.reduce = function (e, t, r) {
            var n = ga(e) ? tr : lr,
                i = arguments.length < 3;
            return n(e, Ls(t, 4), r, i, qn);
          }, pn.reduceRight = function (e, t, r) {
            var n = ga(e) ? rr : lr,
                i = arguments.length < 3;
            return n(e, Ls(t, 4), r, i, zn);
          }, pn.repeat = function (e, t, r) {
            return t = (r ? $s(e, t, r) : t === s) ? 1 : za(t), Si(Va(e), t);
          }, pn.replace = function () {
            var e = arguments,
                t = Va(e[0]);
            return e.length < 3 ? t : t.replace(e[1], e[2]);
          }, pn.result = function (e, t, r) {
            var n = -1,
                i = (t = $i(t, e)).length;

            for (i || (i = 1, e = s); ++n < i;) {
              var o = null == e ? s : e[co(t[n])];
              o === s && (n = i, o = r), e = Ea(o) ? o.call(e) : o;
            }

            return e;
          }, pn.round = Xf, pn.runInContext = e, pn.sample = function (e) {
            return (ga(e) ? An : Ai)(e);
          }, pn.size = function (e) {
            if (null == e) return 0;
            if (ma(e)) return Pa(e) ? Or(e) : e.length;
            var t = Fs(e);
            return t == Y || t == re ? e.size : ui(e).length;
          }, pn.snakeCase = wf, pn.some = function (e, t, r) {
            var n = ga(e) ? nr : Ci;
            return r && $s(e, t, r) && (t = s), n(e, Ls(t, 3));
          }, pn.sortedIndex = function (e, t) {
            return Bi(e, t);
          }, pn.sortedIndexBy = function (e, t, r) {
            return Pi(e, t, Ls(r, 2));
          }, pn.sortedIndexOf = function (e, t) {
            var r = null == e ? 0 : e.length;

            if (r) {
              var n = Bi(e, t);
              if (n < r && la(e[n], t)) return n;
            }

            return -1;
          }, pn.sortedLastIndex = function (e, t) {
            return Bi(e, t, !0);
          }, pn.sortedLastIndexBy = function (e, t, r) {
            return Pi(e, t, Ls(r, 2), !0);
          }, pn.sortedLastIndexOf = function (e, t) {
            if (null != e && e.length) {
              var r = Bi(e, t, !0) - 1;
              if (la(e[r], t)) return r;
            }

            return -1;
          }, pn.startCase = kf, pn.startsWith = function (e, t, r) {
            return e = Va(e), r = null == r ? 0 : Nn(za(r), 0, e.length), t = ji(t), e.slice(r, r + t.length) == t;
          }, pn.subtract = Jf, pn.sum = function (e) {
            return e && e.length ? pr(e, Of) : 0;
          }, pn.sumBy = function (e, t) {
            return e && e.length ? pr(e, Ls(t, 2)) : 0;
          }, pn.template = function (e, t, r) {
            var n = pn.templateSettings;
            r && $s(e, t, r) && (t = s), e = Va(e), t = Ka({}, t, n, xs);
            var i,
                o,
                a = Ka({}, t.imports, n.imports, xs),
                f = sf(a),
                c = gr(a, f),
                u = 0,
                h = t.interpolate || Ye,
                d = "__p += '",
                l = rt((t.escape || Ye).source + "|" + h.source + "|" + (h === Re ? Fe : Ye).source + "|" + (t.evaluate || Ye).source + "|$", "g"),
                p = "//# sourceURL=" + ("sourceURL" in t ? t.sourceURL : "lodash.templateSources[" + ++At + "]") + "\n";
            e.replace(l, function (t, r, n, s, a, f) {
              return n || (n = s), d += e.slice(u, f).replace(Xe, Sr), r && (i = !0, d += "' +\n__e(" + r + ") +\n'"), a && (o = !0, d += "';\n" + a + ";\n__p += '"), n && (d += "' +\n((__t = (" + n + ")) == null ? '' : __t) +\n'"), u = f + t.length, t;
            }), d += "';\n";
            var b = t.variable;
            b || (d = "with (obj) {\n" + d + "\n}\n"), d = (o ? d.replace(me, "") : d).replace(ye, "$1").replace(we, "$1;"), d = "function(" + (b || "obj") + ") {\n" + (b ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (i ? ", __e = _.escape" : "") + (o ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + d + "return __p\n}";

            var _ = xf(function () {
              return Qe(f, p + "return " + d).apply(s, c);
            });

            if (_.source = d, Sa(_)) throw _;
            return _;
          }, pn.times = function (e, t) {
            if ((e = za(e)) < 1 || e > P) return [];
            var r = j,
                n = Hr(e, j);
            t = Ls(t), e -= j;

            for (var i = br(n, t); ++r < e;) {
              t(r);
            }

            return i;
          }, pn.toFinite = qa, pn.toInteger = za, pn.toLength = Fa, pn.toLower = function (e) {
            return Va(e).toLowerCase();
          }, pn.toNumber = Wa, pn.toSafeInteger = function (e) {
            return e ? Nn(za(e), -P, P) : 0 === e ? e : 0;
          }, pn.toString = Va, pn.toUpper = function (e) {
            return Va(e).toUpperCase();
          }, pn.trim = function (e, t, r) {
            if ((e = Va(e)) && (r || t === s)) return e.replace(Pe, "");
            if (!e || !(t = ji(t))) return e;
            var n = Cr(e),
                i = Cr(t);
            return Gi(n, mr(n, i), yr(n, i) + 1).join("");
          }, pn.trimEnd = function (e, t, r) {
            if ((e = Va(e)) && (r || t === s)) return e.replace(Le, "");
            if (!e || !(t = ji(t))) return e;
            var n = Cr(e);
            return Gi(n, 0, yr(n, Cr(t)) + 1).join("");
          }, pn.trimStart = function (e, t, r) {
            if ((e = Va(e)) && (r || t === s)) return e.replace(Ne, "");
            if (!e || !(t = ji(t))) return e;
            var n = Cr(e);
            return Gi(n, mr(n, Cr(t))).join("");
          }, pn.truncate = function (e, t) {
            var r = T,
                n = R;

            if (Ta(t)) {
              var i = "separator" in t ? t.separator : i;
              r = "length" in t ? za(t.length) : r, n = "omission" in t ? ji(t.omission) : n;
            }

            var o = (e = Va(e)).length;

            if (Er(e)) {
              var a = Cr(e);
              o = a.length;
            }

            if (r >= o) return e;
            var f = r - Or(n);
            if (f < 1) return n;
            var c = a ? Gi(a, 0, f).join("") : e.slice(0, f);
            if (i === s) return c + n;

            if (a && (f += c.length - f), Ca(i)) {
              if (e.slice(f).search(i)) {
                var u,
                    h = c;

                for (i.global || (i = rt(i.source, Va(We.exec(i)) + "g")), i.lastIndex = 0; u = i.exec(h);) {
                  var d = u.index;
                }

                c = c.slice(0, d === s ? f : d);
              }
            } else if (e.indexOf(ji(i), f) != f) {
              var l = c.lastIndexOf(i);
              l > -1 && (c = c.slice(0, l));
            }

            return c + n;
          }, pn.unescape = function (e) {
            return (e = Va(e)) && Ee.test(e) ? e.replace(ke, Br) : e;
          }, pn.uniqueId = function (e) {
            var t = ++ht;
            return Va(e) + t;
          }, pn.upperCase = Sf, pn.upperFirst = Ef, pn.each = Vo, pn.eachRight = Ho, pn.first = mo, Nf(pn, (Gf = {}, Kn(pn, function (e, t) {
            ut.call(pn.prototype, t) || (Gf[t] = e);
          }), Gf), {
            chain: !1
          }), pn.VERSION = "4.17.5", $t(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function (e) {
            pn[e].placeholder = pn;
          }), $t(["drop", "take"], function (e, t) {
            vn.prototype[e] = function (r) {
              r = r === s ? 1 : Vr(za(r), 0);
              var n = this.__filtered__ && !t ? new vn(this) : this.clone();
              return n.__filtered__ ? n.__takeCount__ = Hr(r, n.__takeCount__) : n.__views__.push({
                size: Hr(r, j),
                type: e + (n.__dir__ < 0 ? "Right" : "")
              }), n;
            }, vn.prototype[e + "Right"] = function (t) {
              return this.reverse()[e](t).reverse();
            };
          }), $t(["filter", "map", "takeWhile"], function (e, t) {
            var r = t + 1,
                n = r == O || 3 == r;

            vn.prototype[e] = function (e) {
              var t = this.clone();
              return t.__iteratees__.push({
                iteratee: Ls(e, 3),
                type: r
              }), t.__filtered__ = t.__filtered__ || n, t;
            };
          }), $t(["head", "last"], function (e, t) {
            var r = "take" + (t ? "Right" : "");

            vn.prototype[e] = function () {
              return this[r](1).value()[0];
            };
          }), $t(["initial", "tail"], function (e, t) {
            var r = "drop" + (t ? "" : "Right");

            vn.prototype[e] = function () {
              return this.__filtered__ ? new vn(this) : this[r](1);
            };
          }), vn.prototype.compact = function () {
            return this.filter(Of);
          }, vn.prototype.find = function (e) {
            return this.filter(e).head();
          }, vn.prototype.findLast = function (e) {
            return this.reverse().find(e);
          }, vn.prototype.invokeMap = Ei(function (e, t) {
            return "function" == typeof e ? new vn(this) : this.map(function (r) {
              return ii(r, e, t);
            });
          }), vn.prototype.reject = function (e) {
            return this.filter(fa(Ls(e)));
          }, vn.prototype.slice = function (e, t) {
            e = za(e);
            var r = this;
            return r.__filtered__ && (e > 0 || t < 0) ? new vn(r) : (e < 0 ? r = r.takeRight(-e) : e && (r = r.drop(e)), t !== s && (r = (t = za(t)) < 0 ? r.dropRight(-t) : r.take(t - e)), r);
          }, vn.prototype.takeRightWhile = function (e) {
            return this.reverse().takeWhile(e).reverse();
          }, vn.prototype.toArray = function () {
            return this.take(j);
          }, Kn(vn.prototype, function (e, t) {
            var r = /^(?:filter|find|map|reject)|While$/.test(t),
                n = /^(?:head|last)$/.test(t),
                i = pn[n ? "take" + ("last" == t ? "Right" : "") : t],
                o = n || /^find/.test(t);
            i && (pn.prototype[t] = function () {
              var t = this.__wrapped__,
                  a = n ? [1] : arguments,
                  f = t instanceof vn,
                  c = a[0],
                  u = f || ga(t),
                  h = function h(e) {
                var t = i.apply(pn, er([e], a));
                return n && d ? t[0] : t;
              };

              u && r && "function" == typeof c && 1 != c.length && (f = u = !1);
              var d = this.__chain__,
                  l = !!this.__actions__.length,
                  p = o && !d,
                  b = f && !l;

              if (!o && u) {
                t = b ? t : new vn(this);

                var _ = e.apply(t, a);

                return _.__actions__.push({
                  func: qo,
                  args: [h],
                  thisArg: s
                }), new gn(_, d);
              }

              return p && b ? e.apply(this, a) : (_ = this.thru(h), p ? n ? _.value()[0] : _.value() : _);
            });
          }), $t(["pop", "push", "shift", "sort", "splice", "unshift"], function (e) {
            var t = st[e],
                r = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru",
                n = /^(?:pop|shift)$/.test(e);

            pn.prototype[e] = function () {
              var e = arguments;

              if (n && !this.__chain__) {
                var i = this.value();
                return t.apply(ga(i) ? i : [], e);
              }

              return this[r](function (r) {
                return t.apply(ga(r) ? r : [], e);
              });
            };
          }), Kn(vn.prototype, function (e, t) {
            var r = pn[t];

            if (r) {
              var n = r.name + "";
              (sn[n] || (sn[n] = [])).push({
                name: t,
                func: r
              });
            }
          }), sn[ps(s, v).name] = [{
            name: "wrapper",
            func: s
          }], vn.prototype.clone = function () {
            var e = new vn(this.__wrapped__);
            return e.__actions__ = ns(this.__actions__), e.__dir__ = this.__dir__, e.__filtered__ = this.__filtered__, e.__iteratees__ = ns(this.__iteratees__), e.__takeCount__ = this.__takeCount__, e.__views__ = ns(this.__views__), e;
          }, vn.prototype.reverse = function () {
            if (this.__filtered__) {
              var e = new vn(this);
              e.__dir__ = -1, e.__filtered__ = !0;
            } else (e = this.clone()).__dir__ *= -1;

            return e;
          }, vn.prototype.value = function () {
            var e = this.__wrapped__.value(),
                t = this.__dir__,
                r = ga(e),
                n = t < 0,
                i = r ? e.length : 0,
                s = function (e, t, r) {
              for (var n = -1, i = r.length; ++n < i;) {
                var s = r[n],
                    o = s.size;

                switch (s.type) {
                  case "drop":
                    e += o;
                    break;

                  case "dropRight":
                    t -= o;
                    break;

                  case "take":
                    t = Hr(t, e + o);
                    break;

                  case "takeRight":
                    e = Vr(e, t - o);
                }
              }

              return {
                start: e,
                end: t
              };
            }(0, i, this.__views__),
                o = s.start,
                a = s.end,
                f = a - o,
                c = n ? a : o - 1,
                u = this.__iteratees__,
                h = u.length,
                d = 0,
                l = Hr(f, this.__takeCount__);

            if (!r || !n && i == f && l == f) return Fi(e, this.__actions__);
            var p = [];

            e: for (; f-- && d < l;) {
              for (var b = -1, _ = e[c += t]; ++b < h;) {
                var g = u[b],
                    v = g.iteratee,
                    m = g.type,
                    y = v(_);
                if (m == C) _ = y;else if (!y) {
                  if (m == O) continue e;
                  break e;
                }
              }

              p[d++] = _;
            }

            return p;
          }, pn.prototype.at = zo, pn.prototype.chain = function () {
            return Do(this);
          }, pn.prototype.commit = function () {
            return new gn(this.value(), this.__chain__);
          }, pn.prototype.next = function () {
            this.__values__ === s && (this.__values__ = Da(this.value()));
            var e = this.__index__ >= this.__values__.length;
            return {
              done: e,
              value: e ? s : this.__values__[this.__index__++]
            };
          }, pn.prototype.plant = function (e) {
            for (var t, r = this; r instanceof _n;) {
              var n = ho(r);
              n.__index__ = 0, n.__values__ = s, t ? i.__wrapped__ = n : t = n;
              var i = n;
              r = r.__wrapped__;
            }

            return i.__wrapped__ = e, t;
          }, pn.prototype.reverse = function () {
            var e = this.__wrapped__;

            if (e instanceof vn) {
              var t = e;
              return this.__actions__.length && (t = new vn(this)), (t = t.reverse()).__actions__.push({
                func: qo,
                args: [To],
                thisArg: s
              }), new gn(t, this.__chain__);
            }

            return this.thru(To);
          }, pn.prototype.toJSON = pn.prototype.valueOf = pn.prototype.value = function () {
            return Fi(this.__wrapped__, this.__actions__);
          }, pn.prototype.first = pn.prototype.head, Ut && (pn.prototype[Ut] = function () {
            return this;
          }), pn;
        }();

        Bt._ = Pr, (i = function () {
          return Pr;
        }.call(t, r, t, n)) === s || (n.exports = i);
      }).call(this);
    }).call(this, r(9), r(59)(e));
  }, function (e, t, r) {
    "use strict";

    r.r(t), r.d(t, "RESERVATION_STATUS_ACCEPTED", function () {
      return n;
    }), r.d(t, "RESERVATION_STATUS_COMPLETED", function () {
      return i;
    }), r.d(t, "RESERVATION_STATUS_REJECTED", function () {
      return s;
    }), r.d(t, "RESERVATION_STATUS_WRAPPING", function () {
      return o;
    }), r.d(t, "RESERVATION_INSTRUCTION_CALL", function () {
      return a;
    }), r.d(t, "RESERVATION_INSTRUCTION_DEQUEUE", function () {
      return f;
    }), r.d(t, "RESERVATION_INSTRUCTION_REDIRECT", function () {
      return c;
    }), r.d(t, "RESERVATION_INSTRUCTION_CONFERENCE", function () {
      return u;
    }), r.d(t, "TRANSFER_STATUS", function () {
      return h;
    }), r.d(t, "RESERVATION_REJECT_OPTIONS", function () {
      return d;
    }), r.d(t, "WORKER_UPDATE_OPTIONS", function () {
      return l;
    }), r.d(t, "RESERVATION_CALL_OPTIONS", function () {
      return p;
    }), r.d(t, "RESERVATION_DEQUEUE_OPTIONS", function () {
      return b;
    }), r.d(t, "RESERVATION_REDIRECT_OPTIONS", function () {
      return _;
    }), r.d(t, "CREATE_TASK_OPTIONS", function () {
      return g;
    }), r.d(t, "TASK_STATUS_COMPLETED", function () {
      return v;
    }), r.d(t, "TASK_STATUS_WRAPPING", function () {
      return m;
    }), r.d(t, "reservationEventTypes", function () {
      return y;
    }), r.d(t, "taskEventTypes", function () {
      return w;
    }), r.d(t, "transferFields", function () {
      return k;
    }), r.d(t, "TRANSFER_INITIATED", function () {
      return S;
    }), r.d(t, "taskTransferEventTypes", function () {
      return E;
    }), r.d(t, "API_V1", function () {
      return A;
    }), r.d(t, "API_V2", function () {
      return x;
    }), r.d(t, "DEFAULT_PAGE_SIZE", function () {
      return T;
    }), r.d(t, "DEFAULT_HTTP_TIMEOUT", function () {
      return R;
    }), r.d(t, "EB_URL_PARAMS", function () {
      return M;
    }), r.d(t, "twilioErrors", function () {
      return O;
    });
    var n = "accepted",
        i = "completed",
        s = "rejected",
        o = "wrapping",
        a = "call",
        f = "dequeue",
        c = "redirect",
        u = "conference",
        h = Object.freeze({
      canceled: "canceled",
      complete: "complete",
      failed: "failed",
      initiated: "initiated"
    }),
        d = {
      activitySid: "WorkerActivitySid"
    };
    Object.freeze(d);
    var l = {
      rejectPendingReservations: "RejectPendingReservations"
    };
    Object.freeze(l);
    var p = {
      accept: "CallAccept",
      record: "CallRecord",
      statusCallbackUrl: "CallStatusCallbackUrl",
      timeout: "CallTimeout",
      to: "CallTo"
    };
    Object.freeze(p);
    var b = {
      to: "DequeueTo",
      from: "DequeueFrom",
      postWorkActivitySid: "DequeuePostWorkActivitySid",
      record: "DequeueRecord",
      timeout: "DequeueTimeout",
      statusCallbackUrl: "DequeueStatusCallbackUrl",
      statusCallbackEvents: "DequeueStatusCallbackEvents"
    };
    Object.freeze(b);
    var _ = {
      accept: "RedirectAccept"
    };
    Object.freeze(_);
    var g = {
      taskChannelUniqueName: "TaskChannelUniqueName",
      taskChannelSid: "TaskChannelSid",
      attributes: "Attributes"
    },
        v = "completed",
        m = "wrapping",
        y = {
      accepted: 0,
      rejected: 1,
      timeout: 2,
      canceled: 3,
      rescinded: 4,
      completed: 5,
      wrapup: 6
    };
    Object.freeze(y);
    var w = {
      updated: 0,
      canceled: 1,
      completed: 2,
      wrapup: 3
    };
    Object.freeze(w);
    var k = Object.freeze({
      taskTransfer: "task_transfer",
      activeOutgoingTaskTransfer: "active_outgoing_task_transfer"
    }),
        S = "transfer-initiated",
        E = {
      "transfer-attempt-failed": "attemptFailed",
      "transfer-completed": "completed",
      "transfer-failed": "failed",
      "transfer-initiated": "transferInitiated",
      "transfer-canceled": "canceled"
    };
    Object.freeze(E);
    var A = "v1",
        x = "v2",
        T = 1e3,
        R = 5e3,
        M = {
      TOKEN: "token",
      CLOSE_EXISTING_SESSIONS: "closeExistingSessions",
      CLIENT_VERSION: "clientVersion"
    },
        I = r(250),
        O = [{
      name: "INVALID_ARGUMENT",
      message: "One or more arguments passed were invalid."
    }, {
      name: "INVALID_TOKEN",
      message: "The token is invalid or malformed."
    }, {
      name: "TOKEN_EXPIRED",
      message: "Worker's active token has expired."
    }, {
      name: "GATEWAY_CONNECTION_FAILED",
      message: "Could not connect to Twilio's servers."
    }, {
      name: "GATEWAY_DISCONNECTED",
      message: "Connection to Twilio's servers was lost."
    }, {
      name: "INVALID_GATEWAY_MESSAGE",
      message: "The JSON message received was malformed."
    }, {
      name: "TASKROUTER_ERROR",
      message: "TaskRouter failed to complete the request."
    }].reduce(function (e, t) {
      return e[t.name] = new I(t), e;
    }, {});
  }, function (e, t) {
    "function" == typeof Object.create ? e.exports = function (e, t) {
      e.super_ = t, e.prototype = Object.create(t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      });
    } : e.exports = function (e, t) {
      e.super_ = t;

      var r = function r() {};

      r.prototype = t.prototype, e.prototype = new r(), e.prototype.constructor = e;
    };
  }, function (e, t, r) {
    "use strict";

    (function (e) {
      /*!
       * The buffer module from node.js, for the browser.
       *
       * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
       * @license  MIT
       */
      var n = r(245),
          i = r(244),
          s = r(107);

      function o() {
        return f.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
      }

      function a(e, t) {
        if (o() < t) throw new RangeError("Invalid typed array length");
        return f.TYPED_ARRAY_SUPPORT ? (e = new Uint8Array(t)).__proto__ = f.prototype : (null === e && (e = new f(t)), e.length = t), e;
      }

      function f(e, t, r) {
        if (!(f.TYPED_ARRAY_SUPPORT || this instanceof f)) return new f(e, t, r);

        if ("number" == typeof e) {
          if ("string" == typeof t) throw new Error("If encoding is specified then the first argument must be a string");
          return h(this, e);
        }

        return c(this, e, t, r);
      }

      function c(e, t, r, n) {
        if ("number" == typeof t) throw new TypeError('"value" argument must not be a number');
        return "undefined" != typeof ArrayBuffer && t instanceof ArrayBuffer ? function (e, t, r, n) {
          if (t.byteLength, r < 0 || t.byteLength < r) throw new RangeError("'offset' is out of bounds");
          if (t.byteLength < r + (n || 0)) throw new RangeError("'length' is out of bounds");
          t = void 0 === r && void 0 === n ? new Uint8Array(t) : void 0 === n ? new Uint8Array(t, r) : new Uint8Array(t, r, n);
          f.TYPED_ARRAY_SUPPORT ? (e = t).__proto__ = f.prototype : e = d(e, t);
          return e;
        }(e, t, r, n) : "string" == typeof t ? function (e, t, r) {
          "string" == typeof r && "" !== r || (r = "utf8");
          if (!f.isEncoding(r)) throw new TypeError('"encoding" must be a valid string encoding');
          var n = 0 | p(t, r),
              i = (e = a(e, n)).write(t, r);
          i !== n && (e = e.slice(0, i));
          return e;
        }(e, t, r) : function (e, t) {
          if (f.isBuffer(t)) {
            var r = 0 | l(t.length);
            return 0 === (e = a(e, r)).length ? e : (t.copy(e, 0, 0, r), e);
          }

          if (t) {
            if ("undefined" != typeof ArrayBuffer && t.buffer instanceof ArrayBuffer || "length" in t) return "number" != typeof t.length || (n = t.length) != n ? a(e, 0) : d(e, t);
            if ("Buffer" === t.type && s(t.data)) return d(e, t.data);
          }

          var n;
          throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
        }(e, t);
      }

      function u(e) {
        if ("number" != typeof e) throw new TypeError('"size" argument must be a number');
        if (e < 0) throw new RangeError('"size" argument must not be negative');
      }

      function h(e, t) {
        if (u(t), e = a(e, t < 0 ? 0 : 0 | l(t)), !f.TYPED_ARRAY_SUPPORT) for (var r = 0; r < t; ++r) {
          e[r] = 0;
        }
        return e;
      }

      function d(e, t) {
        var r = t.length < 0 ? 0 : 0 | l(t.length);
        e = a(e, r);

        for (var n = 0; n < r; n += 1) {
          e[n] = 255 & t[n];
        }

        return e;
      }

      function l(e) {
        if (e >= o()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + o().toString(16) + " bytes");
        return 0 | e;
      }

      function p(e, t) {
        if (f.isBuffer(e)) return e.length;
        if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(e) || e instanceof ArrayBuffer)) return e.byteLength;
        "string" != typeof e && (e = "" + e);
        var r = e.length;
        if (0 === r) return 0;

        for (var n = !1;;) {
          switch (t) {
            case "ascii":
            case "latin1":
            case "binary":
              return r;

            case "utf8":
            case "utf-8":
            case void 0:
              return q(e).length;

            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return 2 * r;

            case "hex":
              return r >>> 1;

            case "base64":
              return z(e).length;

            default:
              if (n) return q(e).length;
              t = ("" + t).toLowerCase(), n = !0;
          }
        }
      }

      function b(e, t, r) {
        var n = e[t];
        e[t] = e[r], e[r] = n;
      }

      function _(e, t, r, n, i) {
        if (0 === e.length) return -1;

        if ("string" == typeof r ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), r = +r, isNaN(r) && (r = i ? 0 : e.length - 1), r < 0 && (r = e.length + r), r >= e.length) {
          if (i) return -1;
          r = e.length - 1;
        } else if (r < 0) {
          if (!i) return -1;
          r = 0;
        }

        if ("string" == typeof t && (t = f.from(t, n)), f.isBuffer(t)) return 0 === t.length ? -1 : g(e, t, r, n, i);
        if ("number" == typeof t) return t &= 255, f.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? i ? Uint8Array.prototype.indexOf.call(e, t, r) : Uint8Array.prototype.lastIndexOf.call(e, t, r) : g(e, [t], r, n, i);
        throw new TypeError("val must be string, number or Buffer");
      }

      function g(e, t, r, n, i) {
        var s,
            o = 1,
            a = e.length,
            f = t.length;

        if (void 0 !== n && ("ucs2" === (n = String(n).toLowerCase()) || "ucs-2" === n || "utf16le" === n || "utf-16le" === n)) {
          if (e.length < 2 || t.length < 2) return -1;
          o = 2, a /= 2, f /= 2, r /= 2;
        }

        function c(e, t) {
          return 1 === o ? e[t] : e.readUInt16BE(t * o);
        }

        if (i) {
          var u = -1;

          for (s = r; s < a; s++) {
            if (c(e, s) === c(t, -1 === u ? 0 : s - u)) {
              if (-1 === u && (u = s), s - u + 1 === f) return u * o;
            } else -1 !== u && (s -= s - u), u = -1;
          }
        } else for (r + f > a && (r = a - f), s = r; s >= 0; s--) {
          for (var h = !0, d = 0; d < f; d++) {
            if (c(e, s + d) !== c(t, d)) {
              h = !1;
              break;
            }
          }

          if (h) return s;
        }

        return -1;
      }

      function v(e, t, r, n) {
        r = Number(r) || 0;
        var i = e.length - r;
        n ? (n = Number(n)) > i && (n = i) : n = i;
        var s = t.length;
        if (s % 2 != 0) throw new TypeError("Invalid hex string");
        n > s / 2 && (n = s / 2);

        for (var o = 0; o < n; ++o) {
          var a = parseInt(t.substr(2 * o, 2), 16);
          if (isNaN(a)) return o;
          e[r + o] = a;
        }

        return o;
      }

      function m(e, t, r, n) {
        return F(q(t, e.length - r), e, r, n);
      }

      function y(e, t, r, n) {
        return F(function (e) {
          for (var t = [], r = 0; r < e.length; ++r) {
            t.push(255 & e.charCodeAt(r));
          }

          return t;
        }(t), e, r, n);
      }

      function w(e, t, r, n) {
        return y(e, t, r, n);
      }

      function k(e, t, r, n) {
        return F(z(t), e, r, n);
      }

      function S(e, t, r, n) {
        return F(function (e, t) {
          for (var r, n, i, s = [], o = 0; o < e.length && !((t -= 2) < 0); ++o) {
            r = e.charCodeAt(o), n = r >> 8, i = r % 256, s.push(i), s.push(n);
          }

          return s;
        }(t, e.length - r), e, r, n);
      }

      function E(e, t, r) {
        return 0 === t && r === e.length ? n.fromByteArray(e) : n.fromByteArray(e.slice(t, r));
      }

      function A(e, t, r) {
        r = Math.min(e.length, r);

        for (var n = [], i = t; i < r;) {
          var s,
              o,
              a,
              f,
              c = e[i],
              u = null,
              h = c > 239 ? 4 : c > 223 ? 3 : c > 191 ? 2 : 1;
          if (i + h <= r) switch (h) {
            case 1:
              c < 128 && (u = c);
              break;

            case 2:
              128 == (192 & (s = e[i + 1])) && (f = (31 & c) << 6 | 63 & s) > 127 && (u = f);
              break;

            case 3:
              s = e[i + 1], o = e[i + 2], 128 == (192 & s) && 128 == (192 & o) && (f = (15 & c) << 12 | (63 & s) << 6 | 63 & o) > 2047 && (f < 55296 || f > 57343) && (u = f);
              break;

            case 4:
              s = e[i + 1], o = e[i + 2], a = e[i + 3], 128 == (192 & s) && 128 == (192 & o) && 128 == (192 & a) && (f = (15 & c) << 18 | (63 & s) << 12 | (63 & o) << 6 | 63 & a) > 65535 && f < 1114112 && (u = f);
          }
          null === u ? (u = 65533, h = 1) : u > 65535 && (u -= 65536, n.push(u >>> 10 & 1023 | 55296), u = 56320 | 1023 & u), n.push(u), i += h;
        }

        return function (e) {
          var t = e.length;
          if (t <= x) return String.fromCharCode.apply(String, e);
          var r = "",
              n = 0;

          for (; n < t;) {
            r += String.fromCharCode.apply(String, e.slice(n, n += x));
          }

          return r;
        }(n);
      }

      t.Buffer = f, t.SlowBuffer = function (e) {
        +e != e && (e = 0);
        return f.alloc(+e);
      }, t.INSPECT_MAX_BYTES = 50, f.TYPED_ARRAY_SUPPORT = void 0 !== e.TYPED_ARRAY_SUPPORT ? e.TYPED_ARRAY_SUPPORT : function () {
        try {
          var e = new Uint8Array(1);
          return e.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function foo() {
              return 42;
            }
          }, 42 === e.foo() && "function" == typeof e.subarray && 0 === e.subarray(1, 1).byteLength;
        } catch (e) {
          return !1;
        }
      }(), t.kMaxLength = o(), f.poolSize = 8192, f._augment = function (e) {
        return e.__proto__ = f.prototype, e;
      }, f.from = function (e, t, r) {
        return c(null, e, t, r);
      }, f.TYPED_ARRAY_SUPPORT && (f.prototype.__proto__ = Uint8Array.prototype, f.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && f[Symbol.species] === f && Object.defineProperty(f, Symbol.species, {
        value: null,
        configurable: !0
      })), f.alloc = function (e, t, r) {
        return function (e, t, r, n) {
          return u(t), t <= 0 ? a(e, t) : void 0 !== r ? "string" == typeof n ? a(e, t).fill(r, n) : a(e, t).fill(r) : a(e, t);
        }(null, e, t, r);
      }, f.allocUnsafe = function (e) {
        return h(null, e);
      }, f.allocUnsafeSlow = function (e) {
        return h(null, e);
      }, f.isBuffer = function (e) {
        return !(null == e || !e._isBuffer);
      }, f.compare = function (e, t) {
        if (!f.isBuffer(e) || !f.isBuffer(t)) throw new TypeError("Arguments must be Buffers");
        if (e === t) return 0;

        for (var r = e.length, n = t.length, i = 0, s = Math.min(r, n); i < s; ++i) {
          if (e[i] !== t[i]) {
            r = e[i], n = t[i];
            break;
          }
        }

        return r < n ? -1 : n < r ? 1 : 0;
      }, f.isEncoding = function (e) {
        switch (String(e).toLowerCase()) {
          case "hex":
          case "utf8":
          case "utf-8":
          case "ascii":
          case "latin1":
          case "binary":
          case "base64":
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return !0;

          default:
            return !1;
        }
      }, f.concat = function (e, t) {
        if (!s(e)) throw new TypeError('"list" argument must be an Array of Buffers');
        if (0 === e.length) return f.alloc(0);
        var r;
        if (void 0 === t) for (t = 0, r = 0; r < e.length; ++r) {
          t += e[r].length;
        }
        var n = f.allocUnsafe(t),
            i = 0;

        for (r = 0; r < e.length; ++r) {
          var o = e[r];
          if (!f.isBuffer(o)) throw new TypeError('"list" argument must be an Array of Buffers');
          o.copy(n, i), i += o.length;
        }

        return n;
      }, f.byteLength = p, f.prototype._isBuffer = !0, f.prototype.swap16 = function () {
        var e = this.length;
        if (e % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");

        for (var t = 0; t < e; t += 2) {
          b(this, t, t + 1);
        }

        return this;
      }, f.prototype.swap32 = function () {
        var e = this.length;
        if (e % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");

        for (var t = 0; t < e; t += 4) {
          b(this, t, t + 3), b(this, t + 1, t + 2);
        }

        return this;
      }, f.prototype.swap64 = function () {
        var e = this.length;
        if (e % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");

        for (var t = 0; t < e; t += 8) {
          b(this, t, t + 7), b(this, t + 1, t + 6), b(this, t + 2, t + 5), b(this, t + 3, t + 4);
        }

        return this;
      }, f.prototype.toString = function () {
        var e = 0 | this.length;
        return 0 === e ? "" : 0 === arguments.length ? A(this, 0, e) : function (e, t, r) {
          var n = !1;
          if ((void 0 === t || t < 0) && (t = 0), t > this.length) return "";
          if ((void 0 === r || r > this.length) && (r = this.length), r <= 0) return "";
          if ((r >>>= 0) <= (t >>>= 0)) return "";

          for (e || (e = "utf8");;) {
            switch (e) {
              case "hex":
                return M(this, t, r);

              case "utf8":
              case "utf-8":
                return A(this, t, r);

              case "ascii":
                return T(this, t, r);

              case "latin1":
              case "binary":
                return R(this, t, r);

              case "base64":
                return E(this, t, r);

              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return I(this, t, r);

              default:
                if (n) throw new TypeError("Unknown encoding: " + e);
                e = (e + "").toLowerCase(), n = !0;
            }
          }
        }.apply(this, arguments);
      }, f.prototype.equals = function (e) {
        if (!f.isBuffer(e)) throw new TypeError("Argument must be a Buffer");
        return this === e || 0 === f.compare(this, e);
      }, f.prototype.inspect = function () {
        var e = "",
            r = t.INSPECT_MAX_BYTES;
        return this.length > 0 && (e = this.toString("hex", 0, r).match(/.{2}/g).join(" "), this.length > r && (e += " ... ")), "<Buffer " + e + ">";
      }, f.prototype.compare = function (e, t, r, n, i) {
        if (!f.isBuffer(e)) throw new TypeError("Argument must be a Buffer");
        if (void 0 === t && (t = 0), void 0 === r && (r = e ? e.length : 0), void 0 === n && (n = 0), void 0 === i && (i = this.length), t < 0 || r > e.length || n < 0 || i > this.length) throw new RangeError("out of range index");
        if (n >= i && t >= r) return 0;
        if (n >= i) return -1;
        if (t >= r) return 1;
        if (t >>>= 0, r >>>= 0, n >>>= 0, i >>>= 0, this === e) return 0;

        for (var s = i - n, o = r - t, a = Math.min(s, o), c = this.slice(n, i), u = e.slice(t, r), h = 0; h < a; ++h) {
          if (c[h] !== u[h]) {
            s = c[h], o = u[h];
            break;
          }
        }

        return s < o ? -1 : o < s ? 1 : 0;
      }, f.prototype.includes = function (e, t, r) {
        return -1 !== this.indexOf(e, t, r);
      }, f.prototype.indexOf = function (e, t, r) {
        return _(this, e, t, r, !0);
      }, f.prototype.lastIndexOf = function (e, t, r) {
        return _(this, e, t, r, !1);
      }, f.prototype.write = function (e, t, r, n) {
        if (void 0 === t) n = "utf8", r = this.length, t = 0;else if (void 0 === r && "string" == typeof t) n = t, r = this.length, t = 0;else {
          if (!isFinite(t)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
          t |= 0, isFinite(r) ? (r |= 0, void 0 === n && (n = "utf8")) : (n = r, r = void 0);
        }
        var i = this.length - t;
        if ((void 0 === r || r > i) && (r = i), e.length > 0 && (r < 0 || t < 0) || t > this.length) throw new RangeError("Attempt to write outside buffer bounds");
        n || (n = "utf8");

        for (var s = !1;;) {
          switch (n) {
            case "hex":
              return v(this, e, t, r);

            case "utf8":
            case "utf-8":
              return m(this, e, t, r);

            case "ascii":
              return y(this, e, t, r);

            case "latin1":
            case "binary":
              return w(this, e, t, r);

            case "base64":
              return k(this, e, t, r);

            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return S(this, e, t, r);

            default:
              if (s) throw new TypeError("Unknown encoding: " + n);
              n = ("" + n).toLowerCase(), s = !0;
          }
        }
      }, f.prototype.toJSON = function () {
        return {
          type: "Buffer",
          data: Array.prototype.slice.call(this._arr || this, 0)
        };
      };
      var x = 4096;

      function T(e, t, r) {
        var n = "";
        r = Math.min(e.length, r);

        for (var i = t; i < r; ++i) {
          n += String.fromCharCode(127 & e[i]);
        }

        return n;
      }

      function R(e, t, r) {
        var n = "";
        r = Math.min(e.length, r);

        for (var i = t; i < r; ++i) {
          n += String.fromCharCode(e[i]);
        }

        return n;
      }

      function M(e, t, r) {
        var n = e.length;
        (!t || t < 0) && (t = 0), (!r || r < 0 || r > n) && (r = n);

        for (var i = "", s = t; s < r; ++s) {
          i += D(e[s]);
        }

        return i;
      }

      function I(e, t, r) {
        for (var n = e.slice(t, r), i = "", s = 0; s < n.length; s += 2) {
          i += String.fromCharCode(n[s] + 256 * n[s + 1]);
        }

        return i;
      }

      function O(e, t, r) {
        if (e % 1 != 0 || e < 0) throw new RangeError("offset is not uint");
        if (e + t > r) throw new RangeError("Trying to access beyond buffer length");
      }

      function C(e, t, r, n, i, s) {
        if (!f.isBuffer(e)) throw new TypeError('"buffer" argument must be a Buffer instance');
        if (t > i || t < s) throw new RangeError('"value" argument is out of bounds');
        if (r + n > e.length) throw new RangeError("Index out of range");
      }

      function B(e, t, r, n) {
        t < 0 && (t = 65535 + t + 1);

        for (var i = 0, s = Math.min(e.length - r, 2); i < s; ++i) {
          e[r + i] = (t & 255 << 8 * (n ? i : 1 - i)) >>> 8 * (n ? i : 1 - i);
        }
      }

      function P(e, t, r, n) {
        t < 0 && (t = 4294967295 + t + 1);

        for (var i = 0, s = Math.min(e.length - r, 4); i < s; ++i) {
          e[r + i] = t >>> 8 * (n ? i : 3 - i) & 255;
        }
      }

      function N(e, t, r, n, i, s) {
        if (r + n > e.length) throw new RangeError("Index out of range");
        if (r < 0) throw new RangeError("Index out of range");
      }

      function L(e, t, r, n, s) {
        return s || N(e, 0, r, 4), i.write(e, t, r, n, 23, 4), r + 4;
      }

      function j(e, t, r, n, s) {
        return s || N(e, 0, r, 8), i.write(e, t, r, n, 52, 8), r + 8;
      }

      f.prototype.slice = function (e, t) {
        var r,
            n = this.length;
        if (e = ~~e, t = void 0 === t ? n : ~~t, e < 0 ? (e += n) < 0 && (e = 0) : e > n && (e = n), t < 0 ? (t += n) < 0 && (t = 0) : t > n && (t = n), t < e && (t = e), f.TYPED_ARRAY_SUPPORT) (r = this.subarray(e, t)).__proto__ = f.prototype;else {
          var i = t - e;
          r = new f(i, void 0);

          for (var s = 0; s < i; ++s) {
            r[s] = this[s + e];
          }
        }
        return r;
      }, f.prototype.readUIntLE = function (e, t, r) {
        e |= 0, t |= 0, r || O(e, t, this.length);

        for (var n = this[e], i = 1, s = 0; ++s < t && (i *= 256);) {
          n += this[e + s] * i;
        }

        return n;
      }, f.prototype.readUIntBE = function (e, t, r) {
        e |= 0, t |= 0, r || O(e, t, this.length);

        for (var n = this[e + --t], i = 1; t > 0 && (i *= 256);) {
          n += this[e + --t] * i;
        }

        return n;
      }, f.prototype.readUInt8 = function (e, t) {
        return t || O(e, 1, this.length), this[e];
      }, f.prototype.readUInt16LE = function (e, t) {
        return t || O(e, 2, this.length), this[e] | this[e + 1] << 8;
      }, f.prototype.readUInt16BE = function (e, t) {
        return t || O(e, 2, this.length), this[e] << 8 | this[e + 1];
      }, f.prototype.readUInt32LE = function (e, t) {
        return t || O(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + 16777216 * this[e + 3];
      }, f.prototype.readUInt32BE = function (e, t) {
        return t || O(e, 4, this.length), 16777216 * this[e] + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
      }, f.prototype.readIntLE = function (e, t, r) {
        e |= 0, t |= 0, r || O(e, t, this.length);

        for (var n = this[e], i = 1, s = 0; ++s < t && (i *= 256);) {
          n += this[e + s] * i;
        }

        return n >= (i *= 128) && (n -= Math.pow(2, 8 * t)), n;
      }, f.prototype.readIntBE = function (e, t, r) {
        e |= 0, t |= 0, r || O(e, t, this.length);

        for (var n = t, i = 1, s = this[e + --n]; n > 0 && (i *= 256);) {
          s += this[e + --n] * i;
        }

        return s >= (i *= 128) && (s -= Math.pow(2, 8 * t)), s;
      }, f.prototype.readInt8 = function (e, t) {
        return t || O(e, 1, this.length), 128 & this[e] ? -1 * (255 - this[e] + 1) : this[e];
      }, f.prototype.readInt16LE = function (e, t) {
        t || O(e, 2, this.length);
        var r = this[e] | this[e + 1] << 8;
        return 32768 & r ? 4294901760 | r : r;
      }, f.prototype.readInt16BE = function (e, t) {
        t || O(e, 2, this.length);
        var r = this[e + 1] | this[e] << 8;
        return 32768 & r ? 4294901760 | r : r;
      }, f.prototype.readInt32LE = function (e, t) {
        return t || O(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
      }, f.prototype.readInt32BE = function (e, t) {
        return t || O(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
      }, f.prototype.readFloatLE = function (e, t) {
        return t || O(e, 4, this.length), i.read(this, e, !0, 23, 4);
      }, f.prototype.readFloatBE = function (e, t) {
        return t || O(e, 4, this.length), i.read(this, e, !1, 23, 4);
      }, f.prototype.readDoubleLE = function (e, t) {
        return t || O(e, 8, this.length), i.read(this, e, !0, 52, 8);
      }, f.prototype.readDoubleBE = function (e, t) {
        return t || O(e, 8, this.length), i.read(this, e, !1, 52, 8);
      }, f.prototype.writeUIntLE = function (e, t, r, n) {
        (e = +e, t |= 0, r |= 0, n) || C(this, e, t, r, Math.pow(2, 8 * r) - 1, 0);
        var i = 1,
            s = 0;

        for (this[t] = 255 & e; ++s < r && (i *= 256);) {
          this[t + s] = e / i & 255;
        }

        return t + r;
      }, f.prototype.writeUIntBE = function (e, t, r, n) {
        (e = +e, t |= 0, r |= 0, n) || C(this, e, t, r, Math.pow(2, 8 * r) - 1, 0);
        var i = r - 1,
            s = 1;

        for (this[t + i] = 255 & e; --i >= 0 && (s *= 256);) {
          this[t + i] = e / s & 255;
        }

        return t + r;
      }, f.prototype.writeUInt8 = function (e, t, r) {
        return e = +e, t |= 0, r || C(this, e, t, 1, 255, 0), f.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), this[t] = 255 & e, t + 1;
      }, f.prototype.writeUInt16LE = function (e, t, r) {
        return e = +e, t |= 0, r || C(this, e, t, 2, 65535, 0), f.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8) : B(this, e, t, !0), t + 2;
      }, f.prototype.writeUInt16BE = function (e, t, r) {
        return e = +e, t |= 0, r || C(this, e, t, 2, 65535, 0), f.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = 255 & e) : B(this, e, t, !1), t + 2;
      }, f.prototype.writeUInt32LE = function (e, t, r) {
        return e = +e, t |= 0, r || C(this, e, t, 4, 4294967295, 0), f.TYPED_ARRAY_SUPPORT ? (this[t + 3] = e >>> 24, this[t + 2] = e >>> 16, this[t + 1] = e >>> 8, this[t] = 255 & e) : P(this, e, t, !0), t + 4;
      }, f.prototype.writeUInt32BE = function (e, t, r) {
        return e = +e, t |= 0, r || C(this, e, t, 4, 4294967295, 0), f.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e) : P(this, e, t, !1), t + 4;
      }, f.prototype.writeIntLE = function (e, t, r, n) {
        if (e = +e, t |= 0, !n) {
          var i = Math.pow(2, 8 * r - 1);
          C(this, e, t, r, i - 1, -i);
        }

        var s = 0,
            o = 1,
            a = 0;

        for (this[t] = 255 & e; ++s < r && (o *= 256);) {
          e < 0 && 0 === a && 0 !== this[t + s - 1] && (a = 1), this[t + s] = (e / o >> 0) - a & 255;
        }

        return t + r;
      }, f.prototype.writeIntBE = function (e, t, r, n) {
        if (e = +e, t |= 0, !n) {
          var i = Math.pow(2, 8 * r - 1);
          C(this, e, t, r, i - 1, -i);
        }

        var s = r - 1,
            o = 1,
            a = 0;

        for (this[t + s] = 255 & e; --s >= 0 && (o *= 256);) {
          e < 0 && 0 === a && 0 !== this[t + s + 1] && (a = 1), this[t + s] = (e / o >> 0) - a & 255;
        }

        return t + r;
      }, f.prototype.writeInt8 = function (e, t, r) {
        return e = +e, t |= 0, r || C(this, e, t, 1, 127, -128), f.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), e < 0 && (e = 255 + e + 1), this[t] = 255 & e, t + 1;
      }, f.prototype.writeInt16LE = function (e, t, r) {
        return e = +e, t |= 0, r || C(this, e, t, 2, 32767, -32768), f.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8) : B(this, e, t, !0), t + 2;
      }, f.prototype.writeInt16BE = function (e, t, r) {
        return e = +e, t |= 0, r || C(this, e, t, 2, 32767, -32768), f.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = 255 & e) : B(this, e, t, !1), t + 2;
      }, f.prototype.writeInt32LE = function (e, t, r) {
        return e = +e, t |= 0, r || C(this, e, t, 4, 2147483647, -2147483648), f.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8, this[t + 2] = e >>> 16, this[t + 3] = e >>> 24) : P(this, e, t, !0), t + 4;
      }, f.prototype.writeInt32BE = function (e, t, r) {
        return e = +e, t |= 0, r || C(this, e, t, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), f.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e) : P(this, e, t, !1), t + 4;
      }, f.prototype.writeFloatLE = function (e, t, r) {
        return L(this, e, t, !0, r);
      }, f.prototype.writeFloatBE = function (e, t, r) {
        return L(this, e, t, !1, r);
      }, f.prototype.writeDoubleLE = function (e, t, r) {
        return j(this, e, t, !0, r);
      }, f.prototype.writeDoubleBE = function (e, t, r) {
        return j(this, e, t, !1, r);
      }, f.prototype.copy = function (e, t, r, n) {
        if (r || (r = 0), n || 0 === n || (n = this.length), t >= e.length && (t = e.length), t || (t = 0), n > 0 && n < r && (n = r), n === r) return 0;
        if (0 === e.length || 0 === this.length) return 0;
        if (t < 0) throw new RangeError("targetStart out of bounds");
        if (r < 0 || r >= this.length) throw new RangeError("sourceStart out of bounds");
        if (n < 0) throw new RangeError("sourceEnd out of bounds");
        n > this.length && (n = this.length), e.length - t < n - r && (n = e.length - t + r);
        var i,
            s = n - r;
        if (this === e && r < t && t < n) for (i = s - 1; i >= 0; --i) {
          e[i + t] = this[i + r];
        } else if (s < 1e3 || !f.TYPED_ARRAY_SUPPORT) for (i = 0; i < s; ++i) {
          e[i + t] = this[i + r];
        } else Uint8Array.prototype.set.call(e, this.subarray(r, r + s), t);
        return s;
      }, f.prototype.fill = function (e, t, r, n) {
        if ("string" == typeof e) {
          if ("string" == typeof t ? (n = t, t = 0, r = this.length) : "string" == typeof r && (n = r, r = this.length), 1 === e.length) {
            var i = e.charCodeAt(0);
            i < 256 && (e = i);
          }

          if (void 0 !== n && "string" != typeof n) throw new TypeError("encoding must be a string");
          if ("string" == typeof n && !f.isEncoding(n)) throw new TypeError("Unknown encoding: " + n);
        } else "number" == typeof e && (e &= 255);

        if (t < 0 || this.length < t || this.length < r) throw new RangeError("Out of range index");
        if (r <= t) return this;
        var s;
        if (t >>>= 0, r = void 0 === r ? this.length : r >>> 0, e || (e = 0), "number" == typeof e) for (s = t; s < r; ++s) {
          this[s] = e;
        } else {
          var o = f.isBuffer(e) ? e : q(new f(e, n).toString()),
              a = o.length;

          for (s = 0; s < r - t; ++s) {
            this[s + t] = o[s % a];
          }
        }
        return this;
      };
      var U = /[^+\/0-9A-Za-z-_]/g;

      function D(e) {
        return e < 16 ? "0" + e.toString(16) : e.toString(16);
      }

      function q(e, t) {
        var r;
        t = t || 1 / 0;

        for (var n = e.length, i = null, s = [], o = 0; o < n; ++o) {
          if ((r = e.charCodeAt(o)) > 55295 && r < 57344) {
            if (!i) {
              if (r > 56319) {
                (t -= 3) > -1 && s.push(239, 191, 189);
                continue;
              }

              if (o + 1 === n) {
                (t -= 3) > -1 && s.push(239, 191, 189);
                continue;
              }

              i = r;
              continue;
            }

            if (r < 56320) {
              (t -= 3) > -1 && s.push(239, 191, 189), i = r;
              continue;
            }

            r = 65536 + (i - 55296 << 10 | r - 56320);
          } else i && (t -= 3) > -1 && s.push(239, 191, 189);

          if (i = null, r < 128) {
            if ((t -= 1) < 0) break;
            s.push(r);
          } else if (r < 2048) {
            if ((t -= 2) < 0) break;
            s.push(r >> 6 | 192, 63 & r | 128);
          } else if (r < 65536) {
            if ((t -= 3) < 0) break;
            s.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128);
          } else {
            if (!(r < 1114112)) throw new Error("Invalid code point");
            if ((t -= 4) < 0) break;
            s.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128);
          }
        }

        return s;
      }

      function z(e) {
        return n.toByteArray(function (e) {
          if ((e = function (e) {
            return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
          }(e).replace(U, "")).length < 2) return "";

          for (; e.length % 4 != 0;) {
            e += "=";
          }

          return e;
        }(e));
      }

      function F(e, t, r, n) {
        for (var i = 0; i < n && !(i + r >= t.length || i >= e.length); ++i) {
          t[i + r] = e[i];
        }

        return i;
      }
    }).call(this, r(9));
  }, function (e, t, r) {
    "use strict";

    r.d(t, "f", function () {
      return o;
    }), r.d(t, "e", function () {
      return a;
    }), r.d(t, "n", function () {
      return f;
    }), r.d(t, "o", function () {
      return c;
    }), r.d(t, "j", function () {
      return u;
    }), r.d(t, "i", function () {
      return h;
    }), r.d(t, "h", function () {
      return d;
    }), r.d(t, "l", function () {
      return l;
    }), r.d(t, "k", function () {
      return p;
    }), r.d(t, "g", function () {
      return b;
    }), r.d(t, "m", function () {
      return _;
    }), r.d(t, "a", function () {
      return g;
    }), r.d(t, "b", function () {
      return v;
    }), r.d(t, "p", function () {
      return m;
    }), r.d(t, "c", function () {
      return y;
    }), r.d(t, "d", function () {
      return w;
    }), r.d(t, "q", function () {
      return k;
    });
    var n = r(10),
        i = r.n(n);
    var s = r(1).twilioErrors,
        o = "reservationList",
        a = "reservationInstance",
        f = "workerInstance",
        c = "workerList",
        u = "taskReservationInstance",
        h = "taskList",
        d = "taskInstance",
        l = "taskTransferList",
        p = "taskTransferInstance",
        b = "taskQueueList",
        _ = "workerChannels",
        g = "activitiesList",
        v = "customerParticipantInstance",
        m = "workerParticipantInstance",
        y = "holdWorkerParticipantInstance",
        w = "kickWorkerParticipant";

    var k =
    /*#__PURE__*/
    function () {
      function k(e, t) {
        var _this$routes;

        _classCallCheck(this, k);

        if (!e || !t) throw s.INVALID_ARGUMENT.clone("Error instantiating Routes class. <string>workspaceSid and <string>workerSid are required parameters.");
        this.workspaceSid = e, this.workerSid = t, this.routes = (_this$routes = {}, _defineProperty(_this$routes, g, {
          path: i.a.join("Workspaces", this.workspaceSid, "Activities")
        }), _defineProperty(_this$routes, f, {
          path: i.a.join("Workspaces", this.workspaceSid, "Workers", this.workerSid)
        }), _defineProperty(_this$routes, c, {
          path: i.a.join("Workspaces", this.workspaceSid, "Workers")
        }), _defineProperty(_this$routes, a, {
          path: i.a.join("Workspaces", this.workspaceSid, "Workers", this.workerSid, "Reservations", "%s")
        }), _defineProperty(_this$routes, o, {
          path: i.a.join("Workspaces", this.workspaceSid, "Workers", this.workerSid, "Reservations")
        }), _defineProperty(_this$routes, h, {
          path: i.a.join("Workspaces", this.workspaceSid, "Tasks")
        }), _defineProperty(_this$routes, d, {
          path: i.a.join("Workspaces", this.workspaceSid, "Tasks", "%s")
        }), _defineProperty(_this$routes, l, {
          path: i.a.join("Workspaces", this.workspaceSid, "Workers", this.workerSid, "Transfers")
        }), _defineProperty(_this$routes, p, {
          path: i.a.join("Workspaces", this.workspaceSid, "Workers", this.workerSid, "Transfers", "%s")
        }), _defineProperty(_this$routes, u, {
          path: i.a.join("Workspaces", this.workspaceSid, "Tasks", "%s", "Reservations", "%s")
        }), _defineProperty(_this$routes, b, {
          path: i.a.join("Workspaces", this.workspaceSid, "TaskQueues")
        }), _defineProperty(_this$routes, _, {
          path: i.a.join("Workspaces", this.workspaceSid, "Workers", this.workerSid, "WorkerChannels")
        }), _defineProperty(_this$routes, v, {
          path: i.a.join("Workspaces", this.workspaceSid, "Workers", this.workerSid, "CustomerParticipant")
        }), _defineProperty(_this$routes, m, {
          path: i.a.join("Workspaces", this.workspaceSid, "Workers", this.workerSid, "WorkerParticipant")
        }), _defineProperty(_this$routes, y, {
          path: i.a.join("Workspaces", this.workspaceSid, "Workers", this.workerSid, "HoldWorkerParticipant")
        }), _defineProperty(_this$routes, w, {
          path: i.a.join("Workspaces", this.workspaceSid, "Workers", this.workerSid, "KickWorkerParticipant")
        }), _this$routes);
      }

      _createClass(k, [{
        key: "getRoute",
        value: function getRoute(e) {
          if (!this.routes[e]) throw s.INVALID_ARGUMENT.clone("Invalid route fetched <string>route \"".concat(e, "\" does not exist."));

          for (var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            t[_key - 1] = arguments[_key];
          }

          if (t.length) {
            var _r2 = Object.assign({}, this.routes[e]);

            if (t.length !== (_r2.path.match(/%s/g) || []).length) throw s.INVALID_ARGUMENT.clone("Invalid number of positional arguments supplied for route ".concat(e));
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var _e2 = _step.value;
                _r2.path = _r2.path.replace(/%s/, _e2);
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            return _r2;
          }

          return this.routes[e];
        }
      }]);

      return k;
    }();
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      try {
        return new Date(e);
      } catch (e) {
        return null;
      }
    }

    function i(e, t) {
      for (var _r3 in e) {
        if (_r3 in t && !t[_r3](e[_r3])) throw new TypeError("Option key: ".concat(_r3, " does not meet the required type."));
      }

      return !0;
    }

    r.r(t), r.d(t, "parseTime", function () {
      return n;
    }), r.d(t, "validateOptions", function () {
      return i;
    });
  }, function (e, t, r) {
    var n = r(3),
        i = n.Buffer;

    function s(e, t) {
      for (var r in e) {
        t[r] = e[r];
      }
    }

    function o(e, t, r) {
      return i(e, t, r);
    }

    i.from && i.alloc && i.allocUnsafe && i.allocUnsafeSlow ? e.exports = n : (s(n, t), t.Buffer = o), s(i, o), o.from = function (e, t, r) {
      if ("number" == typeof e) throw new TypeError("Argument must not be a number");
      return i(e, t, r);
    }, o.alloc = function (e, t, r) {
      if ("number" != typeof e) throw new TypeError("Argument must be a number");
      var n = i(e);
      return void 0 !== t ? "string" == typeof r ? n.fill(t, r) : n.fill(t) : n.fill(0), n;
    }, o.allocUnsafe = function (e) {
      if ("number" != typeof e) throw new TypeError("Argument must be a number");
      return i(e);
    }, o.allocUnsafeSlow = function (e) {
      if ("number" != typeof e) throw new TypeError("Argument must be a number");
      return n.SlowBuffer(e);
    };
  }, function (e, t) {
    function r() {
      this._events = this._events || {}, this._maxListeners = this._maxListeners || void 0;
    }

    function n(e) {
      return "function" == typeof e;
    }

    function i(e) {
      return "object" == typeof e && null !== e;
    }

    function s(e) {
      return void 0 === e;
    }

    e.exports = r, r.EventEmitter = r, r.prototype._events = void 0, r.prototype._maxListeners = void 0, r.defaultMaxListeners = 10, r.prototype.setMaxListeners = function (e) {
      if ("number" != typeof e || e < 0 || isNaN(e)) throw TypeError("n must be a positive number");
      return this._maxListeners = e, this;
    }, r.prototype.emit = function (e) {
      var t, r, o, a, f, c;

      if (this._events || (this._events = {}), "error" === e && (!this._events.error || i(this._events.error) && !this._events.error.length)) {
        if ((t = arguments[1]) instanceof Error) throw t;
        var u = new Error('Uncaught, unspecified "error" event. (' + t + ")");
        throw u.context = t, u;
      }

      if (s(r = this._events[e])) return !1;
      if (n(r)) switch (arguments.length) {
        case 1:
          r.call(this);
          break;

        case 2:
          r.call(this, arguments[1]);
          break;

        case 3:
          r.call(this, arguments[1], arguments[2]);
          break;

        default:
          a = Array.prototype.slice.call(arguments, 1), r.apply(this, a);
      } else if (i(r)) for (a = Array.prototype.slice.call(arguments, 1), o = (c = r.slice()).length, f = 0; f < o; f++) {
        c[f].apply(this, a);
      }
      return !0;
    }, r.prototype.addListener = function (e, t) {
      var o;
      if (!n(t)) throw TypeError("listener must be a function");
      return this._events || (this._events = {}), this._events.newListener && this.emit("newListener", e, n(t.listener) ? t.listener : t), this._events[e] ? i(this._events[e]) ? this._events[e].push(t) : this._events[e] = [this._events[e], t] : this._events[e] = t, i(this._events[e]) && !this._events[e].warned && (o = s(this._maxListeners) ? r.defaultMaxListeners : this._maxListeners) && o > 0 && this._events[e].length > o && (this._events[e].warned = !0, console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.", this._events[e].length), "function" == typeof console.trace && console.trace()), this;
    }, r.prototype.on = r.prototype.addListener, r.prototype.once = function (e, t) {
      if (!n(t)) throw TypeError("listener must be a function");
      var r = !1;

      function i() {
        this.removeListener(e, i), r || (r = !0, t.apply(this, arguments));
      }

      return i.listener = t, this.on(e, i), this;
    }, r.prototype.removeListener = function (e, t) {
      var r, s, o, a;
      if (!n(t)) throw TypeError("listener must be a function");
      if (!this._events || !this._events[e]) return this;
      if (o = (r = this._events[e]).length, s = -1, r === t || n(r.listener) && r.listener === t) delete this._events[e], this._events.removeListener && this.emit("removeListener", e, t);else if (i(r)) {
        for (a = o; a-- > 0;) {
          if (r[a] === t || r[a].listener && r[a].listener === t) {
            s = a;
            break;
          }
        }

        if (s < 0) return this;
        1 === r.length ? (r.length = 0, delete this._events[e]) : r.splice(s, 1), this._events.removeListener && this.emit("removeListener", e, t);
      }
      return this;
    }, r.prototype.removeAllListeners = function (e) {
      var t, r;
      if (!this._events) return this;
      if (!this._events.removeListener) return 0 === arguments.length ? this._events = {} : this._events[e] && delete this._events[e], this;

      if (0 === arguments.length) {
        for (t in this._events) {
          "removeListener" !== t && this.removeAllListeners(t);
        }

        return this.removeAllListeners("removeListener"), this._events = {}, this;
      }

      if (n(r = this._events[e])) this.removeListener(e, r);else if (r) for (; r.length;) {
        this.removeListener(e, r[r.length - 1]);
      }
      return delete this._events[e], this;
    }, r.prototype.listeners = function (e) {
      return this._events && this._events[e] ? n(this._events[e]) ? [this._events[e]] : this._events[e].slice() : [];
    }, r.prototype.listenerCount = function (e) {
      if (this._events) {
        var t = this._events[e];
        if (n(t)) return 1;
        if (t) return t.length;
      }

      return 0;
    }, r.listenerCount = function (e, t) {
      return e.listenerCount(t);
    };
  }, function (e, t, r) {
    (function (e) {
      !function (e, t) {
        "use strict";

        function n(e, t) {
          if (!e) throw new Error(t || "Assertion failed");
        }

        function i(e, t) {
          e.super_ = t;

          var r = function r() {};

          r.prototype = t.prototype, e.prototype = new r(), e.prototype.constructor = e;
        }

        function s(e, t, r) {
          if (s.isBN(e)) return e;
          this.negative = 0, this.words = null, this.length = 0, this.red = null, null !== e && ("le" !== t && "be" !== t || (r = t, t = 10), this._init(e || 0, t || 10, r || "be"));
        }

        var o;
        "object" == typeof e ? e.exports = s : t.BN = s, s.BN = s, s.wordSize = 26;

        try {
          o = r(203).Buffer;
        } catch (e) {}

        function a(e, t, r) {
          for (var n = 0, i = Math.min(e.length, r), s = t; s < i; s++) {
            var o = e.charCodeAt(s) - 48;
            n <<= 4, n |= o >= 49 && o <= 54 ? o - 49 + 10 : o >= 17 && o <= 22 ? o - 17 + 10 : 15 & o;
          }

          return n;
        }

        function f(e, t, r, n) {
          for (var i = 0, s = Math.min(e.length, r), o = t; o < s; o++) {
            var a = e.charCodeAt(o) - 48;
            i *= n, i += a >= 49 ? a - 49 + 10 : a >= 17 ? a - 17 + 10 : a;
          }

          return i;
        }

        s.isBN = function (e) {
          return e instanceof s || null !== e && "object" == typeof e && e.constructor.wordSize === s.wordSize && Array.isArray(e.words);
        }, s.max = function (e, t) {
          return e.cmp(t) > 0 ? e : t;
        }, s.min = function (e, t) {
          return e.cmp(t) < 0 ? e : t;
        }, s.prototype._init = function (e, t, r) {
          if ("number" == typeof e) return this._initNumber(e, t, r);
          if ("object" == typeof e) return this._initArray(e, t, r);
          "hex" === t && (t = 16), n(t === (0 | t) && t >= 2 && t <= 36);
          var i = 0;
          "-" === (e = e.toString().replace(/\s+/g, ""))[0] && i++, 16 === t ? this._parseHex(e, i) : this._parseBase(e, t, i), "-" === e[0] && (this.negative = 1), this.strip(), "le" === r && this._initArray(this.toArray(), t, r);
        }, s.prototype._initNumber = function (e, t, r) {
          e < 0 && (this.negative = 1, e = -e), e < 67108864 ? (this.words = [67108863 & e], this.length = 1) : e < 4503599627370496 ? (this.words = [67108863 & e, e / 67108864 & 67108863], this.length = 2) : (n(e < 9007199254740992), this.words = [67108863 & e, e / 67108864 & 67108863, 1], this.length = 3), "le" === r && this._initArray(this.toArray(), t, r);
        }, s.prototype._initArray = function (e, t, r) {
          if (n("number" == typeof e.length), e.length <= 0) return this.words = [0], this.length = 1, this;
          this.length = Math.ceil(e.length / 3), this.words = new Array(this.length);

          for (var i = 0; i < this.length; i++) {
            this.words[i] = 0;
          }

          var s,
              o,
              a = 0;
          if ("be" === r) for (i = e.length - 1, s = 0; i >= 0; i -= 3) {
            o = e[i] | e[i - 1] << 8 | e[i - 2] << 16, this.words[s] |= o << a & 67108863, this.words[s + 1] = o >>> 26 - a & 67108863, (a += 24) >= 26 && (a -= 26, s++);
          } else if ("le" === r) for (i = 0, s = 0; i < e.length; i += 3) {
            o = e[i] | e[i + 1] << 8 | e[i + 2] << 16, this.words[s] |= o << a & 67108863, this.words[s + 1] = o >>> 26 - a & 67108863, (a += 24) >= 26 && (a -= 26, s++);
          }
          return this.strip();
        }, s.prototype._parseHex = function (e, t) {
          this.length = Math.ceil((e.length - t) / 6), this.words = new Array(this.length);

          for (var r = 0; r < this.length; r++) {
            this.words[r] = 0;
          }

          var n,
              i,
              s = 0;

          for (r = e.length - 6, n = 0; r >= t; r -= 6) {
            i = a(e, r, r + 6), this.words[n] |= i << s & 67108863, this.words[n + 1] |= i >>> 26 - s & 4194303, (s += 24) >= 26 && (s -= 26, n++);
          }

          r + 6 !== t && (i = a(e, t, r + 6), this.words[n] |= i << s & 67108863, this.words[n + 1] |= i >>> 26 - s & 4194303), this.strip();
        }, s.prototype._parseBase = function (e, t, r) {
          this.words = [0], this.length = 1;

          for (var n = 0, i = 1; i <= 67108863; i *= t) {
            n++;
          }

          n--, i = i / t | 0;

          for (var s = e.length - r, o = s % n, a = Math.min(s, s - o) + r, c = 0, u = r; u < a; u += n) {
            c = f(e, u, u + n, t), this.imuln(i), this.words[0] + c < 67108864 ? this.words[0] += c : this._iaddn(c);
          }

          if (0 !== o) {
            var h = 1;

            for (c = f(e, u, e.length, t), u = 0; u < o; u++) {
              h *= t;
            }

            this.imuln(h), this.words[0] + c < 67108864 ? this.words[0] += c : this._iaddn(c);
          }
        }, s.prototype.copy = function (e) {
          e.words = new Array(this.length);

          for (var t = 0; t < this.length; t++) {
            e.words[t] = this.words[t];
          }

          e.length = this.length, e.negative = this.negative, e.red = this.red;
        }, s.prototype.clone = function () {
          var e = new s(null);
          return this.copy(e), e;
        }, s.prototype._expand = function (e) {
          for (; this.length < e;) {
            this.words[this.length++] = 0;
          }

          return this;
        }, s.prototype.strip = function () {
          for (; this.length > 1 && 0 === this.words[this.length - 1];) {
            this.length--;
          }

          return this._normSign();
        }, s.prototype._normSign = function () {
          return 1 === this.length && 0 === this.words[0] && (this.negative = 0), this;
        }, s.prototype.inspect = function () {
          return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
        };
        var c = ["", "0", "00", "000", "0000", "00000", "000000", "0000000", "00000000", "000000000", "0000000000", "00000000000", "000000000000", "0000000000000", "00000000000000", "000000000000000", "0000000000000000", "00000000000000000", "000000000000000000", "0000000000000000000", "00000000000000000000", "000000000000000000000", "0000000000000000000000", "00000000000000000000000", "000000000000000000000000", "0000000000000000000000000"],
            u = [0, 0, 25, 16, 12, 11, 10, 9, 8, 8, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
            h = [0, 0, 33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216, 43046721, 1e7, 19487171, 35831808, 62748517, 7529536, 11390625, 16777216, 24137569, 34012224, 47045881, 64e6, 4084101, 5153632, 6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149, 243e5, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176];

        function d(e, t, r) {
          r.negative = t.negative ^ e.negative;
          var n = e.length + t.length | 0;
          r.length = n, n = n - 1 | 0;
          var i = 0 | e.words[0],
              s = 0 | t.words[0],
              o = i * s,
              a = 67108863 & o,
              f = o / 67108864 | 0;
          r.words[0] = a;

          for (var c = 1; c < n; c++) {
            for (var u = f >>> 26, h = 67108863 & f, d = Math.min(c, t.length - 1), l = Math.max(0, c - e.length + 1); l <= d; l++) {
              var p = c - l | 0;
              u += (o = (i = 0 | e.words[p]) * (s = 0 | t.words[l]) + h) / 67108864 | 0, h = 67108863 & o;
            }

            r.words[c] = 0 | h, f = 0 | u;
          }

          return 0 !== f ? r.words[c] = 0 | f : r.length--, r.strip();
        }

        s.prototype.toString = function (e, t) {
          var r;

          if (e = e || 10, t = 0 | t || 1, 16 === e || "hex" === e) {
            r = "";

            for (var i = 0, s = 0, o = 0; o < this.length; o++) {
              var a = this.words[o],
                  f = (16777215 & (a << i | s)).toString(16);
              r = 0 !== (s = a >>> 24 - i & 16777215) || o !== this.length - 1 ? c[6 - f.length] + f + r : f + r, (i += 2) >= 26 && (i -= 26, o--);
            }

            for (0 !== s && (r = s.toString(16) + r); r.length % t != 0;) {
              r = "0" + r;
            }

            return 0 !== this.negative && (r = "-" + r), r;
          }

          if (e === (0 | e) && e >= 2 && e <= 36) {
            var d = u[e],
                l = h[e];
            r = "";
            var p = this.clone();

            for (p.negative = 0; !p.isZero();) {
              var b = p.modn(l).toString(e);
              r = (p = p.idivn(l)).isZero() ? b + r : c[d - b.length] + b + r;
            }

            for (this.isZero() && (r = "0" + r); r.length % t != 0;) {
              r = "0" + r;
            }

            return 0 !== this.negative && (r = "-" + r), r;
          }

          n(!1, "Base should be between 2 and 36");
        }, s.prototype.toNumber = function () {
          var e = this.words[0];
          return 2 === this.length ? e += 67108864 * this.words[1] : 3 === this.length && 1 === this.words[2] ? e += 4503599627370496 + 67108864 * this.words[1] : this.length > 2 && n(!1, "Number can only safely store up to 53 bits"), 0 !== this.negative ? -e : e;
        }, s.prototype.toJSON = function () {
          return this.toString(16);
        }, s.prototype.toBuffer = function (e, t) {
          return n(void 0 !== o), this.toArrayLike(o, e, t);
        }, s.prototype.toArray = function (e, t) {
          return this.toArrayLike(Array, e, t);
        }, s.prototype.toArrayLike = function (e, t, r) {
          var i = this.byteLength(),
              s = r || Math.max(1, i);
          n(i <= s, "byte array longer than desired length"), n(s > 0, "Requested array length <= 0"), this.strip();
          var o,
              a,
              f = "le" === t,
              c = new e(s),
              u = this.clone();

          if (f) {
            for (a = 0; !u.isZero(); a++) {
              o = u.andln(255), u.iushrn(8), c[a] = o;
            }

            for (; a < s; a++) {
              c[a] = 0;
            }
          } else {
            for (a = 0; a < s - i; a++) {
              c[a] = 0;
            }

            for (a = 0; !u.isZero(); a++) {
              o = u.andln(255), u.iushrn(8), c[s - a - 1] = o;
            }
          }

          return c;
        }, Math.clz32 ? s.prototype._countBits = function (e) {
          return 32 - Math.clz32(e);
        } : s.prototype._countBits = function (e) {
          var t = e,
              r = 0;
          return t >= 4096 && (r += 13, t >>>= 13), t >= 64 && (r += 7, t >>>= 7), t >= 8 && (r += 4, t >>>= 4), t >= 2 && (r += 2, t >>>= 2), r + t;
        }, s.prototype._zeroBits = function (e) {
          if (0 === e) return 26;
          var t = e,
              r = 0;
          return 0 == (8191 & t) && (r += 13, t >>>= 13), 0 == (127 & t) && (r += 7, t >>>= 7), 0 == (15 & t) && (r += 4, t >>>= 4), 0 == (3 & t) && (r += 2, t >>>= 2), 0 == (1 & t) && r++, r;
        }, s.prototype.bitLength = function () {
          var e = this.words[this.length - 1],
              t = this._countBits(e);

          return 26 * (this.length - 1) + t;
        }, s.prototype.zeroBits = function () {
          if (this.isZero()) return 0;

          for (var e = 0, t = 0; t < this.length; t++) {
            var r = this._zeroBits(this.words[t]);

            if (e += r, 26 !== r) break;
          }

          return e;
        }, s.prototype.byteLength = function () {
          return Math.ceil(this.bitLength() / 8);
        }, s.prototype.toTwos = function (e) {
          return 0 !== this.negative ? this.abs().inotn(e).iaddn(1) : this.clone();
        }, s.prototype.fromTwos = function (e) {
          return this.testn(e - 1) ? this.notn(e).iaddn(1).ineg() : this.clone();
        }, s.prototype.isNeg = function () {
          return 0 !== this.negative;
        }, s.prototype.neg = function () {
          return this.clone().ineg();
        }, s.prototype.ineg = function () {
          return this.isZero() || (this.negative ^= 1), this;
        }, s.prototype.iuor = function (e) {
          for (; this.length < e.length;) {
            this.words[this.length++] = 0;
          }

          for (var t = 0; t < e.length; t++) {
            this.words[t] = this.words[t] | e.words[t];
          }

          return this.strip();
        }, s.prototype.ior = function (e) {
          return n(0 == (this.negative | e.negative)), this.iuor(e);
        }, s.prototype.or = function (e) {
          return this.length > e.length ? this.clone().ior(e) : e.clone().ior(this);
        }, s.prototype.uor = function (e) {
          return this.length > e.length ? this.clone().iuor(e) : e.clone().iuor(this);
        }, s.prototype.iuand = function (e) {
          var t;
          t = this.length > e.length ? e : this;

          for (var r = 0; r < t.length; r++) {
            this.words[r] = this.words[r] & e.words[r];
          }

          return this.length = t.length, this.strip();
        }, s.prototype.iand = function (e) {
          return n(0 == (this.negative | e.negative)), this.iuand(e);
        }, s.prototype.and = function (e) {
          return this.length > e.length ? this.clone().iand(e) : e.clone().iand(this);
        }, s.prototype.uand = function (e) {
          return this.length > e.length ? this.clone().iuand(e) : e.clone().iuand(this);
        }, s.prototype.iuxor = function (e) {
          var t, r;
          this.length > e.length ? (t = this, r = e) : (t = e, r = this);

          for (var n = 0; n < r.length; n++) {
            this.words[n] = t.words[n] ^ r.words[n];
          }

          if (this !== t) for (; n < t.length; n++) {
            this.words[n] = t.words[n];
          }
          return this.length = t.length, this.strip();
        }, s.prototype.ixor = function (e) {
          return n(0 == (this.negative | e.negative)), this.iuxor(e);
        }, s.prototype.xor = function (e) {
          return this.length > e.length ? this.clone().ixor(e) : e.clone().ixor(this);
        }, s.prototype.uxor = function (e) {
          return this.length > e.length ? this.clone().iuxor(e) : e.clone().iuxor(this);
        }, s.prototype.inotn = function (e) {
          n("number" == typeof e && e >= 0);
          var t = 0 | Math.ceil(e / 26),
              r = e % 26;
          this._expand(t), r > 0 && t--;

          for (var i = 0; i < t; i++) {
            this.words[i] = 67108863 & ~this.words[i];
          }

          return r > 0 && (this.words[i] = ~this.words[i] & 67108863 >> 26 - r), this.strip();
        }, s.prototype.notn = function (e) {
          return this.clone().inotn(e);
        }, s.prototype.setn = function (e, t) {
          n("number" == typeof e && e >= 0);
          var r = e / 26 | 0,
              i = e % 26;
          return this._expand(r + 1), this.words[r] = t ? this.words[r] | 1 << i : this.words[r] & ~(1 << i), this.strip();
        }, s.prototype.iadd = function (e) {
          var t, r, n;
          if (0 !== this.negative && 0 === e.negative) return this.negative = 0, t = this.isub(e), this.negative ^= 1, this._normSign();
          if (0 === this.negative && 0 !== e.negative) return e.negative = 0, t = this.isub(e), e.negative = 1, t._normSign();
          this.length > e.length ? (r = this, n = e) : (r = e, n = this);

          for (var i = 0, s = 0; s < n.length; s++) {
            t = (0 | r.words[s]) + (0 | n.words[s]) + i, this.words[s] = 67108863 & t, i = t >>> 26;
          }

          for (; 0 !== i && s < r.length; s++) {
            t = (0 | r.words[s]) + i, this.words[s] = 67108863 & t, i = t >>> 26;
          }

          if (this.length = r.length, 0 !== i) this.words[this.length] = i, this.length++;else if (r !== this) for (; s < r.length; s++) {
            this.words[s] = r.words[s];
          }
          return this;
        }, s.prototype.add = function (e) {
          var t;
          return 0 !== e.negative && 0 === this.negative ? (e.negative = 0, t = this.sub(e), e.negative ^= 1, t) : 0 === e.negative && 0 !== this.negative ? (this.negative = 0, t = e.sub(this), this.negative = 1, t) : this.length > e.length ? this.clone().iadd(e) : e.clone().iadd(this);
        }, s.prototype.isub = function (e) {
          if (0 !== e.negative) {
            e.negative = 0;
            var t = this.iadd(e);
            return e.negative = 1, t._normSign();
          }

          if (0 !== this.negative) return this.negative = 0, this.iadd(e), this.negative = 1, this._normSign();
          var r,
              n,
              i = this.cmp(e);
          if (0 === i) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
          i > 0 ? (r = this, n = e) : (r = e, n = this);

          for (var s = 0, o = 0; o < n.length; o++) {
            s = (t = (0 | r.words[o]) - (0 | n.words[o]) + s) >> 26, this.words[o] = 67108863 & t;
          }

          for (; 0 !== s && o < r.length; o++) {
            s = (t = (0 | r.words[o]) + s) >> 26, this.words[o] = 67108863 & t;
          }

          if (0 === s && o < r.length && r !== this) for (; o < r.length; o++) {
            this.words[o] = r.words[o];
          }
          return this.length = Math.max(this.length, o), r !== this && (this.negative = 1), this.strip();
        }, s.prototype.sub = function (e) {
          return this.clone().isub(e);
        };

        var l = function l(e, t, r) {
          var n,
              i,
              s,
              o = e.words,
              a = t.words,
              f = r.words,
              c = 0,
              u = 0 | o[0],
              h = 8191 & u,
              d = u >>> 13,
              l = 0 | o[1],
              p = 8191 & l,
              b = l >>> 13,
              _ = 0 | o[2],
              g = 8191 & _,
              v = _ >>> 13,
              m = 0 | o[3],
              y = 8191 & m,
              w = m >>> 13,
              k = 0 | o[4],
              S = 8191 & k,
              E = k >>> 13,
              A = 0 | o[5],
              x = 8191 & A,
              T = A >>> 13,
              R = 0 | o[6],
              M = 8191 & R,
              I = R >>> 13,
              O = 0 | o[7],
              C = 8191 & O,
              B = O >>> 13,
              P = 0 | o[8],
              N = 8191 & P,
              L = P >>> 13,
              j = 0 | o[9],
              U = 8191 & j,
              D = j >>> 13,
              q = 0 | a[0],
              z = 8191 & q,
              F = q >>> 13,
              W = 0 | a[1],
              Z = 8191 & W,
              V = W >>> 13,
              H = 0 | a[2],
              $ = 8191 & H,
              K = H >>> 13,
              G = 0 | a[3],
              Y = 8191 & G,
              X = G >>> 13,
              J = 0 | a[4],
              Q = 8191 & J,
              ee = J >>> 13,
              te = 0 | a[5],
              re = 8191 & te,
              ne = te >>> 13,
              ie = 0 | a[6],
              se = 8191 & ie,
              oe = ie >>> 13,
              ae = 0 | a[7],
              fe = 8191 & ae,
              ce = ae >>> 13,
              ue = 0 | a[8],
              he = 8191 & ue,
              de = ue >>> 13,
              le = 0 | a[9],
              pe = 8191 & le,
              be = le >>> 13;

          r.negative = e.negative ^ t.negative, r.length = 19;

          var _e = (c + (n = Math.imul(h, z)) | 0) + ((8191 & (i = (i = Math.imul(h, F)) + Math.imul(d, z) | 0)) << 13) | 0;

          c = ((s = Math.imul(d, F)) + (i >>> 13) | 0) + (_e >>> 26) | 0, _e &= 67108863, n = Math.imul(p, z), i = (i = Math.imul(p, F)) + Math.imul(b, z) | 0, s = Math.imul(b, F);
          var ge = (c + (n = n + Math.imul(h, Z) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, V) | 0) + Math.imul(d, Z) | 0)) << 13) | 0;
          c = ((s = s + Math.imul(d, V) | 0) + (i >>> 13) | 0) + (ge >>> 26) | 0, ge &= 67108863, n = Math.imul(g, z), i = (i = Math.imul(g, F)) + Math.imul(v, z) | 0, s = Math.imul(v, F), n = n + Math.imul(p, Z) | 0, i = (i = i + Math.imul(p, V) | 0) + Math.imul(b, Z) | 0, s = s + Math.imul(b, V) | 0;
          var ve = (c + (n = n + Math.imul(h, $) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, K) | 0) + Math.imul(d, $) | 0)) << 13) | 0;
          c = ((s = s + Math.imul(d, K) | 0) + (i >>> 13) | 0) + (ve >>> 26) | 0, ve &= 67108863, n = Math.imul(y, z), i = (i = Math.imul(y, F)) + Math.imul(w, z) | 0, s = Math.imul(w, F), n = n + Math.imul(g, Z) | 0, i = (i = i + Math.imul(g, V) | 0) + Math.imul(v, Z) | 0, s = s + Math.imul(v, V) | 0, n = n + Math.imul(p, $) | 0, i = (i = i + Math.imul(p, K) | 0) + Math.imul(b, $) | 0, s = s + Math.imul(b, K) | 0;
          var me = (c + (n = n + Math.imul(h, Y) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, X) | 0) + Math.imul(d, Y) | 0)) << 13) | 0;
          c = ((s = s + Math.imul(d, X) | 0) + (i >>> 13) | 0) + (me >>> 26) | 0, me &= 67108863, n = Math.imul(S, z), i = (i = Math.imul(S, F)) + Math.imul(E, z) | 0, s = Math.imul(E, F), n = n + Math.imul(y, Z) | 0, i = (i = i + Math.imul(y, V) | 0) + Math.imul(w, Z) | 0, s = s + Math.imul(w, V) | 0, n = n + Math.imul(g, $) | 0, i = (i = i + Math.imul(g, K) | 0) + Math.imul(v, $) | 0, s = s + Math.imul(v, K) | 0, n = n + Math.imul(p, Y) | 0, i = (i = i + Math.imul(p, X) | 0) + Math.imul(b, Y) | 0, s = s + Math.imul(b, X) | 0;
          var ye = (c + (n = n + Math.imul(h, Q) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, ee) | 0) + Math.imul(d, Q) | 0)) << 13) | 0;
          c = ((s = s + Math.imul(d, ee) | 0) + (i >>> 13) | 0) + (ye >>> 26) | 0, ye &= 67108863, n = Math.imul(x, z), i = (i = Math.imul(x, F)) + Math.imul(T, z) | 0, s = Math.imul(T, F), n = n + Math.imul(S, Z) | 0, i = (i = i + Math.imul(S, V) | 0) + Math.imul(E, Z) | 0, s = s + Math.imul(E, V) | 0, n = n + Math.imul(y, $) | 0, i = (i = i + Math.imul(y, K) | 0) + Math.imul(w, $) | 0, s = s + Math.imul(w, K) | 0, n = n + Math.imul(g, Y) | 0, i = (i = i + Math.imul(g, X) | 0) + Math.imul(v, Y) | 0, s = s + Math.imul(v, X) | 0, n = n + Math.imul(p, Q) | 0, i = (i = i + Math.imul(p, ee) | 0) + Math.imul(b, Q) | 0, s = s + Math.imul(b, ee) | 0;
          var we = (c + (n = n + Math.imul(h, re) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, ne) | 0) + Math.imul(d, re) | 0)) << 13) | 0;
          c = ((s = s + Math.imul(d, ne) | 0) + (i >>> 13) | 0) + (we >>> 26) | 0, we &= 67108863, n = Math.imul(M, z), i = (i = Math.imul(M, F)) + Math.imul(I, z) | 0, s = Math.imul(I, F), n = n + Math.imul(x, Z) | 0, i = (i = i + Math.imul(x, V) | 0) + Math.imul(T, Z) | 0, s = s + Math.imul(T, V) | 0, n = n + Math.imul(S, $) | 0, i = (i = i + Math.imul(S, K) | 0) + Math.imul(E, $) | 0, s = s + Math.imul(E, K) | 0, n = n + Math.imul(y, Y) | 0, i = (i = i + Math.imul(y, X) | 0) + Math.imul(w, Y) | 0, s = s + Math.imul(w, X) | 0, n = n + Math.imul(g, Q) | 0, i = (i = i + Math.imul(g, ee) | 0) + Math.imul(v, Q) | 0, s = s + Math.imul(v, ee) | 0, n = n + Math.imul(p, re) | 0, i = (i = i + Math.imul(p, ne) | 0) + Math.imul(b, re) | 0, s = s + Math.imul(b, ne) | 0;
          var ke = (c + (n = n + Math.imul(h, se) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, oe) | 0) + Math.imul(d, se) | 0)) << 13) | 0;
          c = ((s = s + Math.imul(d, oe) | 0) + (i >>> 13) | 0) + (ke >>> 26) | 0, ke &= 67108863, n = Math.imul(C, z), i = (i = Math.imul(C, F)) + Math.imul(B, z) | 0, s = Math.imul(B, F), n = n + Math.imul(M, Z) | 0, i = (i = i + Math.imul(M, V) | 0) + Math.imul(I, Z) | 0, s = s + Math.imul(I, V) | 0, n = n + Math.imul(x, $) | 0, i = (i = i + Math.imul(x, K) | 0) + Math.imul(T, $) | 0, s = s + Math.imul(T, K) | 0, n = n + Math.imul(S, Y) | 0, i = (i = i + Math.imul(S, X) | 0) + Math.imul(E, Y) | 0, s = s + Math.imul(E, X) | 0, n = n + Math.imul(y, Q) | 0, i = (i = i + Math.imul(y, ee) | 0) + Math.imul(w, Q) | 0, s = s + Math.imul(w, ee) | 0, n = n + Math.imul(g, re) | 0, i = (i = i + Math.imul(g, ne) | 0) + Math.imul(v, re) | 0, s = s + Math.imul(v, ne) | 0, n = n + Math.imul(p, se) | 0, i = (i = i + Math.imul(p, oe) | 0) + Math.imul(b, se) | 0, s = s + Math.imul(b, oe) | 0;
          var Se = (c + (n = n + Math.imul(h, fe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, ce) | 0) + Math.imul(d, fe) | 0)) << 13) | 0;
          c = ((s = s + Math.imul(d, ce) | 0) + (i >>> 13) | 0) + (Se >>> 26) | 0, Se &= 67108863, n = Math.imul(N, z), i = (i = Math.imul(N, F)) + Math.imul(L, z) | 0, s = Math.imul(L, F), n = n + Math.imul(C, Z) | 0, i = (i = i + Math.imul(C, V) | 0) + Math.imul(B, Z) | 0, s = s + Math.imul(B, V) | 0, n = n + Math.imul(M, $) | 0, i = (i = i + Math.imul(M, K) | 0) + Math.imul(I, $) | 0, s = s + Math.imul(I, K) | 0, n = n + Math.imul(x, Y) | 0, i = (i = i + Math.imul(x, X) | 0) + Math.imul(T, Y) | 0, s = s + Math.imul(T, X) | 0, n = n + Math.imul(S, Q) | 0, i = (i = i + Math.imul(S, ee) | 0) + Math.imul(E, Q) | 0, s = s + Math.imul(E, ee) | 0, n = n + Math.imul(y, re) | 0, i = (i = i + Math.imul(y, ne) | 0) + Math.imul(w, re) | 0, s = s + Math.imul(w, ne) | 0, n = n + Math.imul(g, se) | 0, i = (i = i + Math.imul(g, oe) | 0) + Math.imul(v, se) | 0, s = s + Math.imul(v, oe) | 0, n = n + Math.imul(p, fe) | 0, i = (i = i + Math.imul(p, ce) | 0) + Math.imul(b, fe) | 0, s = s + Math.imul(b, ce) | 0;
          var Ee = (c + (n = n + Math.imul(h, he) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, de) | 0) + Math.imul(d, he) | 0)) << 13) | 0;
          c = ((s = s + Math.imul(d, de) | 0) + (i >>> 13) | 0) + (Ee >>> 26) | 0, Ee &= 67108863, n = Math.imul(U, z), i = (i = Math.imul(U, F)) + Math.imul(D, z) | 0, s = Math.imul(D, F), n = n + Math.imul(N, Z) | 0, i = (i = i + Math.imul(N, V) | 0) + Math.imul(L, Z) | 0, s = s + Math.imul(L, V) | 0, n = n + Math.imul(C, $) | 0, i = (i = i + Math.imul(C, K) | 0) + Math.imul(B, $) | 0, s = s + Math.imul(B, K) | 0, n = n + Math.imul(M, Y) | 0, i = (i = i + Math.imul(M, X) | 0) + Math.imul(I, Y) | 0, s = s + Math.imul(I, X) | 0, n = n + Math.imul(x, Q) | 0, i = (i = i + Math.imul(x, ee) | 0) + Math.imul(T, Q) | 0, s = s + Math.imul(T, ee) | 0, n = n + Math.imul(S, re) | 0, i = (i = i + Math.imul(S, ne) | 0) + Math.imul(E, re) | 0, s = s + Math.imul(E, ne) | 0, n = n + Math.imul(y, se) | 0, i = (i = i + Math.imul(y, oe) | 0) + Math.imul(w, se) | 0, s = s + Math.imul(w, oe) | 0, n = n + Math.imul(g, fe) | 0, i = (i = i + Math.imul(g, ce) | 0) + Math.imul(v, fe) | 0, s = s + Math.imul(v, ce) | 0, n = n + Math.imul(p, he) | 0, i = (i = i + Math.imul(p, de) | 0) + Math.imul(b, he) | 0, s = s + Math.imul(b, de) | 0;
          var Ae = (c + (n = n + Math.imul(h, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, be) | 0) + Math.imul(d, pe) | 0)) << 13) | 0;
          c = ((s = s + Math.imul(d, be) | 0) + (i >>> 13) | 0) + (Ae >>> 26) | 0, Ae &= 67108863, n = Math.imul(U, Z), i = (i = Math.imul(U, V)) + Math.imul(D, Z) | 0, s = Math.imul(D, V), n = n + Math.imul(N, $) | 0, i = (i = i + Math.imul(N, K) | 0) + Math.imul(L, $) | 0, s = s + Math.imul(L, K) | 0, n = n + Math.imul(C, Y) | 0, i = (i = i + Math.imul(C, X) | 0) + Math.imul(B, Y) | 0, s = s + Math.imul(B, X) | 0, n = n + Math.imul(M, Q) | 0, i = (i = i + Math.imul(M, ee) | 0) + Math.imul(I, Q) | 0, s = s + Math.imul(I, ee) | 0, n = n + Math.imul(x, re) | 0, i = (i = i + Math.imul(x, ne) | 0) + Math.imul(T, re) | 0, s = s + Math.imul(T, ne) | 0, n = n + Math.imul(S, se) | 0, i = (i = i + Math.imul(S, oe) | 0) + Math.imul(E, se) | 0, s = s + Math.imul(E, oe) | 0, n = n + Math.imul(y, fe) | 0, i = (i = i + Math.imul(y, ce) | 0) + Math.imul(w, fe) | 0, s = s + Math.imul(w, ce) | 0, n = n + Math.imul(g, he) | 0, i = (i = i + Math.imul(g, de) | 0) + Math.imul(v, he) | 0, s = s + Math.imul(v, de) | 0;
          var xe = (c + (n = n + Math.imul(p, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(p, be) | 0) + Math.imul(b, pe) | 0)) << 13) | 0;
          c = ((s = s + Math.imul(b, be) | 0) + (i >>> 13) | 0) + (xe >>> 26) | 0, xe &= 67108863, n = Math.imul(U, $), i = (i = Math.imul(U, K)) + Math.imul(D, $) | 0, s = Math.imul(D, K), n = n + Math.imul(N, Y) | 0, i = (i = i + Math.imul(N, X) | 0) + Math.imul(L, Y) | 0, s = s + Math.imul(L, X) | 0, n = n + Math.imul(C, Q) | 0, i = (i = i + Math.imul(C, ee) | 0) + Math.imul(B, Q) | 0, s = s + Math.imul(B, ee) | 0, n = n + Math.imul(M, re) | 0, i = (i = i + Math.imul(M, ne) | 0) + Math.imul(I, re) | 0, s = s + Math.imul(I, ne) | 0, n = n + Math.imul(x, se) | 0, i = (i = i + Math.imul(x, oe) | 0) + Math.imul(T, se) | 0, s = s + Math.imul(T, oe) | 0, n = n + Math.imul(S, fe) | 0, i = (i = i + Math.imul(S, ce) | 0) + Math.imul(E, fe) | 0, s = s + Math.imul(E, ce) | 0, n = n + Math.imul(y, he) | 0, i = (i = i + Math.imul(y, de) | 0) + Math.imul(w, he) | 0, s = s + Math.imul(w, de) | 0;
          var Te = (c + (n = n + Math.imul(g, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(g, be) | 0) + Math.imul(v, pe) | 0)) << 13) | 0;
          c = ((s = s + Math.imul(v, be) | 0) + (i >>> 13) | 0) + (Te >>> 26) | 0, Te &= 67108863, n = Math.imul(U, Y), i = (i = Math.imul(U, X)) + Math.imul(D, Y) | 0, s = Math.imul(D, X), n = n + Math.imul(N, Q) | 0, i = (i = i + Math.imul(N, ee) | 0) + Math.imul(L, Q) | 0, s = s + Math.imul(L, ee) | 0, n = n + Math.imul(C, re) | 0, i = (i = i + Math.imul(C, ne) | 0) + Math.imul(B, re) | 0, s = s + Math.imul(B, ne) | 0, n = n + Math.imul(M, se) | 0, i = (i = i + Math.imul(M, oe) | 0) + Math.imul(I, se) | 0, s = s + Math.imul(I, oe) | 0, n = n + Math.imul(x, fe) | 0, i = (i = i + Math.imul(x, ce) | 0) + Math.imul(T, fe) | 0, s = s + Math.imul(T, ce) | 0, n = n + Math.imul(S, he) | 0, i = (i = i + Math.imul(S, de) | 0) + Math.imul(E, he) | 0, s = s + Math.imul(E, de) | 0;
          var Re = (c + (n = n + Math.imul(y, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(y, be) | 0) + Math.imul(w, pe) | 0)) << 13) | 0;
          c = ((s = s + Math.imul(w, be) | 0) + (i >>> 13) | 0) + (Re >>> 26) | 0, Re &= 67108863, n = Math.imul(U, Q), i = (i = Math.imul(U, ee)) + Math.imul(D, Q) | 0, s = Math.imul(D, ee), n = n + Math.imul(N, re) | 0, i = (i = i + Math.imul(N, ne) | 0) + Math.imul(L, re) | 0, s = s + Math.imul(L, ne) | 0, n = n + Math.imul(C, se) | 0, i = (i = i + Math.imul(C, oe) | 0) + Math.imul(B, se) | 0, s = s + Math.imul(B, oe) | 0, n = n + Math.imul(M, fe) | 0, i = (i = i + Math.imul(M, ce) | 0) + Math.imul(I, fe) | 0, s = s + Math.imul(I, ce) | 0, n = n + Math.imul(x, he) | 0, i = (i = i + Math.imul(x, de) | 0) + Math.imul(T, he) | 0, s = s + Math.imul(T, de) | 0;
          var Me = (c + (n = n + Math.imul(S, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(S, be) | 0) + Math.imul(E, pe) | 0)) << 13) | 0;
          c = ((s = s + Math.imul(E, be) | 0) + (i >>> 13) | 0) + (Me >>> 26) | 0, Me &= 67108863, n = Math.imul(U, re), i = (i = Math.imul(U, ne)) + Math.imul(D, re) | 0, s = Math.imul(D, ne), n = n + Math.imul(N, se) | 0, i = (i = i + Math.imul(N, oe) | 0) + Math.imul(L, se) | 0, s = s + Math.imul(L, oe) | 0, n = n + Math.imul(C, fe) | 0, i = (i = i + Math.imul(C, ce) | 0) + Math.imul(B, fe) | 0, s = s + Math.imul(B, ce) | 0, n = n + Math.imul(M, he) | 0, i = (i = i + Math.imul(M, de) | 0) + Math.imul(I, he) | 0, s = s + Math.imul(I, de) | 0;
          var Ie = (c + (n = n + Math.imul(x, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(x, be) | 0) + Math.imul(T, pe) | 0)) << 13) | 0;
          c = ((s = s + Math.imul(T, be) | 0) + (i >>> 13) | 0) + (Ie >>> 26) | 0, Ie &= 67108863, n = Math.imul(U, se), i = (i = Math.imul(U, oe)) + Math.imul(D, se) | 0, s = Math.imul(D, oe), n = n + Math.imul(N, fe) | 0, i = (i = i + Math.imul(N, ce) | 0) + Math.imul(L, fe) | 0, s = s + Math.imul(L, ce) | 0, n = n + Math.imul(C, he) | 0, i = (i = i + Math.imul(C, de) | 0) + Math.imul(B, he) | 0, s = s + Math.imul(B, de) | 0;
          var Oe = (c + (n = n + Math.imul(M, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(M, be) | 0) + Math.imul(I, pe) | 0)) << 13) | 0;
          c = ((s = s + Math.imul(I, be) | 0) + (i >>> 13) | 0) + (Oe >>> 26) | 0, Oe &= 67108863, n = Math.imul(U, fe), i = (i = Math.imul(U, ce)) + Math.imul(D, fe) | 0, s = Math.imul(D, ce), n = n + Math.imul(N, he) | 0, i = (i = i + Math.imul(N, de) | 0) + Math.imul(L, he) | 0, s = s + Math.imul(L, de) | 0;
          var Ce = (c + (n = n + Math.imul(C, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(C, be) | 0) + Math.imul(B, pe) | 0)) << 13) | 0;
          c = ((s = s + Math.imul(B, be) | 0) + (i >>> 13) | 0) + (Ce >>> 26) | 0, Ce &= 67108863, n = Math.imul(U, he), i = (i = Math.imul(U, de)) + Math.imul(D, he) | 0, s = Math.imul(D, de);
          var Be = (c + (n = n + Math.imul(N, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(N, be) | 0) + Math.imul(L, pe) | 0)) << 13) | 0;
          c = ((s = s + Math.imul(L, be) | 0) + (i >>> 13) | 0) + (Be >>> 26) | 0, Be &= 67108863;
          var Pe = (c + (n = Math.imul(U, pe)) | 0) + ((8191 & (i = (i = Math.imul(U, be)) + Math.imul(D, pe) | 0)) << 13) | 0;
          return c = ((s = Math.imul(D, be)) + (i >>> 13) | 0) + (Pe >>> 26) | 0, Pe &= 67108863, f[0] = _e, f[1] = ge, f[2] = ve, f[3] = me, f[4] = ye, f[5] = we, f[6] = ke, f[7] = Se, f[8] = Ee, f[9] = Ae, f[10] = xe, f[11] = Te, f[12] = Re, f[13] = Me, f[14] = Ie, f[15] = Oe, f[16] = Ce, f[17] = Be, f[18] = Pe, 0 !== c && (f[19] = c, r.length++), r;
        };

        function p(e, t, r) {
          return new b().mulp(e, t, r);
        }

        function b(e, t) {
          this.x = e, this.y = t;
        }

        Math.imul || (l = d), s.prototype.mulTo = function (e, t) {
          var r = this.length + e.length;
          return 10 === this.length && 10 === e.length ? l(this, e, t) : r < 63 ? d(this, e, t) : r < 1024 ? function (e, t, r) {
            r.negative = t.negative ^ e.negative, r.length = e.length + t.length;

            for (var n = 0, i = 0, s = 0; s < r.length - 1; s++) {
              var o = i;
              i = 0;

              for (var a = 67108863 & n, f = Math.min(s, t.length - 1), c = Math.max(0, s - e.length + 1); c <= f; c++) {
                var u = s - c,
                    h = (0 | e.words[u]) * (0 | t.words[c]),
                    d = 67108863 & h;
                a = 67108863 & (d = d + a | 0), i += (o = (o = o + (h / 67108864 | 0) | 0) + (d >>> 26) | 0) >>> 26, o &= 67108863;
              }

              r.words[s] = a, n = o, o = i;
            }

            return 0 !== n ? r.words[s] = n : r.length--, r.strip();
          }(this, e, t) : p(this, e, t);
        }, b.prototype.makeRBT = function (e) {
          for (var t = new Array(e), r = s.prototype._countBits(e) - 1, n = 0; n < e; n++) {
            t[n] = this.revBin(n, r, e);
          }

          return t;
        }, b.prototype.revBin = function (e, t, r) {
          if (0 === e || e === r - 1) return e;

          for (var n = 0, i = 0; i < t; i++) {
            n |= (1 & e) << t - i - 1, e >>= 1;
          }

          return n;
        }, b.prototype.permute = function (e, t, r, n, i, s) {
          for (var o = 0; o < s; o++) {
            n[o] = t[e[o]], i[o] = r[e[o]];
          }
        }, b.prototype.transform = function (e, t, r, n, i, s) {
          this.permute(s, e, t, r, n, i);

          for (var o = 1; o < i; o <<= 1) {
            for (var a = o << 1, f = Math.cos(2 * Math.PI / a), c = Math.sin(2 * Math.PI / a), u = 0; u < i; u += a) {
              for (var h = f, d = c, l = 0; l < o; l++) {
                var p = r[u + l],
                    b = n[u + l],
                    _ = r[u + l + o],
                    g = n[u + l + o],
                    v = h * _ - d * g;
                g = h * g + d * _, _ = v, r[u + l] = p + _, n[u + l] = b + g, r[u + l + o] = p - _, n[u + l + o] = b - g, l !== a && (v = f * h - c * d, d = f * d + c * h, h = v);
              }
            }
          }
        }, b.prototype.guessLen13b = function (e, t) {
          var r = 1 | Math.max(t, e),
              n = 1 & r,
              i = 0;

          for (r = r / 2 | 0; r; r >>>= 1) {
            i++;
          }

          return 1 << i + 1 + n;
        }, b.prototype.conjugate = function (e, t, r) {
          if (!(r <= 1)) for (var n = 0; n < r / 2; n++) {
            var i = e[n];
            e[n] = e[r - n - 1], e[r - n - 1] = i, i = t[n], t[n] = -t[r - n - 1], t[r - n - 1] = -i;
          }
        }, b.prototype.normalize13b = function (e, t) {
          for (var r = 0, n = 0; n < t / 2; n++) {
            var i = 8192 * Math.round(e[2 * n + 1] / t) + Math.round(e[2 * n] / t) + r;
            e[n] = 67108863 & i, r = i < 67108864 ? 0 : i / 67108864 | 0;
          }

          return e;
        }, b.prototype.convert13b = function (e, t, r, i) {
          for (var s = 0, o = 0; o < t; o++) {
            s += 0 | e[o], r[2 * o] = 8191 & s, s >>>= 13, r[2 * o + 1] = 8191 & s, s >>>= 13;
          }

          for (o = 2 * t; o < i; ++o) {
            r[o] = 0;
          }

          n(0 === s), n(0 == (-8192 & s));
        }, b.prototype.stub = function (e) {
          for (var t = new Array(e), r = 0; r < e; r++) {
            t[r] = 0;
          }

          return t;
        }, b.prototype.mulp = function (e, t, r) {
          var n = 2 * this.guessLen13b(e.length, t.length),
              i = this.makeRBT(n),
              s = this.stub(n),
              o = new Array(n),
              a = new Array(n),
              f = new Array(n),
              c = new Array(n),
              u = new Array(n),
              h = new Array(n),
              d = r.words;
          d.length = n, this.convert13b(e.words, e.length, o, n), this.convert13b(t.words, t.length, c, n), this.transform(o, s, a, f, n, i), this.transform(c, s, u, h, n, i);

          for (var l = 0; l < n; l++) {
            var p = a[l] * u[l] - f[l] * h[l];
            f[l] = a[l] * h[l] + f[l] * u[l], a[l] = p;
          }

          return this.conjugate(a, f, n), this.transform(a, f, d, s, n, i), this.conjugate(d, s, n), this.normalize13b(d, n), r.negative = e.negative ^ t.negative, r.length = e.length + t.length, r.strip();
        }, s.prototype.mul = function (e) {
          var t = new s(null);
          return t.words = new Array(this.length + e.length), this.mulTo(e, t);
        }, s.prototype.mulf = function (e) {
          var t = new s(null);
          return t.words = new Array(this.length + e.length), p(this, e, t);
        }, s.prototype.imul = function (e) {
          return this.clone().mulTo(e, this);
        }, s.prototype.imuln = function (e) {
          n("number" == typeof e), n(e < 67108864);

          for (var t = 0, r = 0; r < this.length; r++) {
            var i = (0 | this.words[r]) * e,
                s = (67108863 & i) + (67108863 & t);
            t >>= 26, t += i / 67108864 | 0, t += s >>> 26, this.words[r] = 67108863 & s;
          }

          return 0 !== t && (this.words[r] = t, this.length++), this;
        }, s.prototype.muln = function (e) {
          return this.clone().imuln(e);
        }, s.prototype.sqr = function () {
          return this.mul(this);
        }, s.prototype.isqr = function () {
          return this.imul(this.clone());
        }, s.prototype.pow = function (e) {
          var t = function (e) {
            for (var t = new Array(e.bitLength()), r = 0; r < t.length; r++) {
              var n = r / 26 | 0,
                  i = r % 26;
              t[r] = (e.words[n] & 1 << i) >>> i;
            }

            return t;
          }(e);

          if (0 === t.length) return new s(1);

          for (var r = this, n = 0; n < t.length && 0 === t[n]; n++, r = r.sqr()) {
            ;
          }

          if (++n < t.length) for (var i = r.sqr(); n < t.length; n++, i = i.sqr()) {
            0 !== t[n] && (r = r.mul(i));
          }
          return r;
        }, s.prototype.iushln = function (e) {
          n("number" == typeof e && e >= 0);
          var t,
              r = e % 26,
              i = (e - r) / 26,
              s = 67108863 >>> 26 - r << 26 - r;

          if (0 !== r) {
            var o = 0;

            for (t = 0; t < this.length; t++) {
              var a = this.words[t] & s,
                  f = (0 | this.words[t]) - a << r;
              this.words[t] = f | o, o = a >>> 26 - r;
            }

            o && (this.words[t] = o, this.length++);
          }

          if (0 !== i) {
            for (t = this.length - 1; t >= 0; t--) {
              this.words[t + i] = this.words[t];
            }

            for (t = 0; t < i; t++) {
              this.words[t] = 0;
            }

            this.length += i;
          }

          return this.strip();
        }, s.prototype.ishln = function (e) {
          return n(0 === this.negative), this.iushln(e);
        }, s.prototype.iushrn = function (e, t, r) {
          var i;
          n("number" == typeof e && e >= 0), i = t ? (t - t % 26) / 26 : 0;
          var s = e % 26,
              o = Math.min((e - s) / 26, this.length),
              a = 67108863 ^ 67108863 >>> s << s,
              f = r;

          if (i -= o, i = Math.max(0, i), f) {
            for (var c = 0; c < o; c++) {
              f.words[c] = this.words[c];
            }

            f.length = o;
          }

          if (0 === o) ;else if (this.length > o) for (this.length -= o, c = 0; c < this.length; c++) {
            this.words[c] = this.words[c + o];
          } else this.words[0] = 0, this.length = 1;
          var u = 0;

          for (c = this.length - 1; c >= 0 && (0 !== u || c >= i); c--) {
            var h = 0 | this.words[c];
            this.words[c] = u << 26 - s | h >>> s, u = h & a;
          }

          return f && 0 !== u && (f.words[f.length++] = u), 0 === this.length && (this.words[0] = 0, this.length = 1), this.strip();
        }, s.prototype.ishrn = function (e, t, r) {
          return n(0 === this.negative), this.iushrn(e, t, r);
        }, s.prototype.shln = function (e) {
          return this.clone().ishln(e);
        }, s.prototype.ushln = function (e) {
          return this.clone().iushln(e);
        }, s.prototype.shrn = function (e) {
          return this.clone().ishrn(e);
        }, s.prototype.ushrn = function (e) {
          return this.clone().iushrn(e);
        }, s.prototype.testn = function (e) {
          n("number" == typeof e && e >= 0);
          var t = e % 26,
              r = (e - t) / 26,
              i = 1 << t;
          return !(this.length <= r) && !!(this.words[r] & i);
        }, s.prototype.imaskn = function (e) {
          n("number" == typeof e && e >= 0);
          var t = e % 26,
              r = (e - t) / 26;
          if (n(0 === this.negative, "imaskn works only with positive numbers"), this.length <= r) return this;

          if (0 !== t && r++, this.length = Math.min(r, this.length), 0 !== t) {
            var i = 67108863 ^ 67108863 >>> t << t;
            this.words[this.length - 1] &= i;
          }

          return this.strip();
        }, s.prototype.maskn = function (e) {
          return this.clone().imaskn(e);
        }, s.prototype.iaddn = function (e) {
          return n("number" == typeof e), n(e < 67108864), e < 0 ? this.isubn(-e) : 0 !== this.negative ? 1 === this.length && (0 | this.words[0]) < e ? (this.words[0] = e - (0 | this.words[0]), this.negative = 0, this) : (this.negative = 0, this.isubn(e), this.negative = 1, this) : this._iaddn(e);
        }, s.prototype._iaddn = function (e) {
          this.words[0] += e;

          for (var t = 0; t < this.length && this.words[t] >= 67108864; t++) {
            this.words[t] -= 67108864, t === this.length - 1 ? this.words[t + 1] = 1 : this.words[t + 1]++;
          }

          return this.length = Math.max(this.length, t + 1), this;
        }, s.prototype.isubn = function (e) {
          if (n("number" == typeof e), n(e < 67108864), e < 0) return this.iaddn(-e);
          if (0 !== this.negative) return this.negative = 0, this.iaddn(e), this.negative = 1, this;
          if (this.words[0] -= e, 1 === this.length && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;else for (var t = 0; t < this.length && this.words[t] < 0; t++) {
            this.words[t] += 67108864, this.words[t + 1] -= 1;
          }
          return this.strip();
        }, s.prototype.addn = function (e) {
          return this.clone().iaddn(e);
        }, s.prototype.subn = function (e) {
          return this.clone().isubn(e);
        }, s.prototype.iabs = function () {
          return this.negative = 0, this;
        }, s.prototype.abs = function () {
          return this.clone().iabs();
        }, s.prototype._ishlnsubmul = function (e, t, r) {
          var i,
              s,
              o = e.length + r;

          this._expand(o);

          var a = 0;

          for (i = 0; i < e.length; i++) {
            s = (0 | this.words[i + r]) + a;
            var f = (0 | e.words[i]) * t;
            a = ((s -= 67108863 & f) >> 26) - (f / 67108864 | 0), this.words[i + r] = 67108863 & s;
          }

          for (; i < this.length - r; i++) {
            a = (s = (0 | this.words[i + r]) + a) >> 26, this.words[i + r] = 67108863 & s;
          }

          if (0 === a) return this.strip();

          for (n(-1 === a), a = 0, i = 0; i < this.length; i++) {
            a = (s = -(0 | this.words[i]) + a) >> 26, this.words[i] = 67108863 & s;
          }

          return this.negative = 1, this.strip();
        }, s.prototype._wordDiv = function (e, t) {
          var r = (this.length, e.length),
              n = this.clone(),
              i = e,
              o = 0 | i.words[i.length - 1];
          0 !== (r = 26 - this._countBits(o)) && (i = i.ushln(r), n.iushln(r), o = 0 | i.words[i.length - 1]);
          var a,
              f = n.length - i.length;

          if ("mod" !== t) {
            (a = new s(null)).length = f + 1, a.words = new Array(a.length);

            for (var c = 0; c < a.length; c++) {
              a.words[c] = 0;
            }
          }

          var u = n.clone()._ishlnsubmul(i, 1, f);

          0 === u.negative && (n = u, a && (a.words[f] = 1));

          for (var h = f - 1; h >= 0; h--) {
            var d = 67108864 * (0 | n.words[i.length + h]) + (0 | n.words[i.length + h - 1]);

            for (d = Math.min(d / o | 0, 67108863), n._ishlnsubmul(i, d, h); 0 !== n.negative;) {
              d--, n.negative = 0, n._ishlnsubmul(i, 1, h), n.isZero() || (n.negative ^= 1);
            }

            a && (a.words[h] = d);
          }

          return a && a.strip(), n.strip(), "div" !== t && 0 !== r && n.iushrn(r), {
            div: a || null,
            mod: n
          };
        }, s.prototype.divmod = function (e, t, r) {
          return n(!e.isZero()), this.isZero() ? {
            div: new s(0),
            mod: new s(0)
          } : 0 !== this.negative && 0 === e.negative ? (a = this.neg().divmod(e, t), "mod" !== t && (i = a.div.neg()), "div" !== t && (o = a.mod.neg(), r && 0 !== o.negative && o.iadd(e)), {
            div: i,
            mod: o
          }) : 0 === this.negative && 0 !== e.negative ? (a = this.divmod(e.neg(), t), "mod" !== t && (i = a.div.neg()), {
            div: i,
            mod: a.mod
          }) : 0 != (this.negative & e.negative) ? (a = this.neg().divmod(e.neg(), t), "div" !== t && (o = a.mod.neg(), r && 0 !== o.negative && o.isub(e)), {
            div: a.div,
            mod: o
          }) : e.length > this.length || this.cmp(e) < 0 ? {
            div: new s(0),
            mod: this
          } : 1 === e.length ? "div" === t ? {
            div: this.divn(e.words[0]),
            mod: null
          } : "mod" === t ? {
            div: null,
            mod: new s(this.modn(e.words[0]))
          } : {
            div: this.divn(e.words[0]),
            mod: new s(this.modn(e.words[0]))
          } : this._wordDiv(e, t);
          var i, o, a;
        }, s.prototype.div = function (e) {
          return this.divmod(e, "div", !1).div;
        }, s.prototype.mod = function (e) {
          return this.divmod(e, "mod", !1).mod;
        }, s.prototype.umod = function (e) {
          return this.divmod(e, "mod", !0).mod;
        }, s.prototype.divRound = function (e) {
          var t = this.divmod(e);
          if (t.mod.isZero()) return t.div;
          var r = 0 !== t.div.negative ? t.mod.isub(e) : t.mod,
              n = e.ushrn(1),
              i = e.andln(1),
              s = r.cmp(n);
          return s < 0 || 1 === i && 0 === s ? t.div : 0 !== t.div.negative ? t.div.isubn(1) : t.div.iaddn(1);
        }, s.prototype.modn = function (e) {
          n(e <= 67108863);

          for (var t = (1 << 26) % e, r = 0, i = this.length - 1; i >= 0; i--) {
            r = (t * r + (0 | this.words[i])) % e;
          }

          return r;
        }, s.prototype.idivn = function (e) {
          n(e <= 67108863);

          for (var t = 0, r = this.length - 1; r >= 0; r--) {
            var i = (0 | this.words[r]) + 67108864 * t;
            this.words[r] = i / e | 0, t = i % e;
          }

          return this.strip();
        }, s.prototype.divn = function (e) {
          return this.clone().idivn(e);
        }, s.prototype.egcd = function (e) {
          n(0 === e.negative), n(!e.isZero());
          var t = this,
              r = e.clone();
          t = 0 !== t.negative ? t.umod(e) : t.clone();

          for (var i = new s(1), o = new s(0), a = new s(0), f = new s(1), c = 0; t.isEven() && r.isEven();) {
            t.iushrn(1), r.iushrn(1), ++c;
          }

          for (var u = r.clone(), h = t.clone(); !t.isZero();) {
            for (var d = 0, l = 1; 0 == (t.words[0] & l) && d < 26; ++d, l <<= 1) {
              ;
            }

            if (d > 0) for (t.iushrn(d); d-- > 0;) {
              (i.isOdd() || o.isOdd()) && (i.iadd(u), o.isub(h)), i.iushrn(1), o.iushrn(1);
            }

            for (var p = 0, b = 1; 0 == (r.words[0] & b) && p < 26; ++p, b <<= 1) {
              ;
            }

            if (p > 0) for (r.iushrn(p); p-- > 0;) {
              (a.isOdd() || f.isOdd()) && (a.iadd(u), f.isub(h)), a.iushrn(1), f.iushrn(1);
            }
            t.cmp(r) >= 0 ? (t.isub(r), i.isub(a), o.isub(f)) : (r.isub(t), a.isub(i), f.isub(o));
          }

          return {
            a: a,
            b: f,
            gcd: r.iushln(c)
          };
        }, s.prototype._invmp = function (e) {
          n(0 === e.negative), n(!e.isZero());
          var t = this,
              r = e.clone();
          t = 0 !== t.negative ? t.umod(e) : t.clone();

          for (var i, o = new s(1), a = new s(0), f = r.clone(); t.cmpn(1) > 0 && r.cmpn(1) > 0;) {
            for (var c = 0, u = 1; 0 == (t.words[0] & u) && c < 26; ++c, u <<= 1) {
              ;
            }

            if (c > 0) for (t.iushrn(c); c-- > 0;) {
              o.isOdd() && o.iadd(f), o.iushrn(1);
            }

            for (var h = 0, d = 1; 0 == (r.words[0] & d) && h < 26; ++h, d <<= 1) {
              ;
            }

            if (h > 0) for (r.iushrn(h); h-- > 0;) {
              a.isOdd() && a.iadd(f), a.iushrn(1);
            }
            t.cmp(r) >= 0 ? (t.isub(r), o.isub(a)) : (r.isub(t), a.isub(o));
          }

          return (i = 0 === t.cmpn(1) ? o : a).cmpn(0) < 0 && i.iadd(e), i;
        }, s.prototype.gcd = function (e) {
          if (this.isZero()) return e.abs();
          if (e.isZero()) return this.abs();
          var t = this.clone(),
              r = e.clone();
          t.negative = 0, r.negative = 0;

          for (var n = 0; t.isEven() && r.isEven(); n++) {
            t.iushrn(1), r.iushrn(1);
          }

          for (;;) {
            for (; t.isEven();) {
              t.iushrn(1);
            }

            for (; r.isEven();) {
              r.iushrn(1);
            }

            var i = t.cmp(r);

            if (i < 0) {
              var s = t;
              t = r, r = s;
            } else if (0 === i || 0 === r.cmpn(1)) break;

            t.isub(r);
          }

          return r.iushln(n);
        }, s.prototype.invm = function (e) {
          return this.egcd(e).a.umod(e);
        }, s.prototype.isEven = function () {
          return 0 == (1 & this.words[0]);
        }, s.prototype.isOdd = function () {
          return 1 == (1 & this.words[0]);
        }, s.prototype.andln = function (e) {
          return this.words[0] & e;
        }, s.prototype.bincn = function (e) {
          n("number" == typeof e);
          var t = e % 26,
              r = (e - t) / 26,
              i = 1 << t;
          if (this.length <= r) return this._expand(r + 1), this.words[r] |= i, this;

          for (var s = i, o = r; 0 !== s && o < this.length; o++) {
            var a = 0 | this.words[o];
            s = (a += s) >>> 26, a &= 67108863, this.words[o] = a;
          }

          return 0 !== s && (this.words[o] = s, this.length++), this;
        }, s.prototype.isZero = function () {
          return 1 === this.length && 0 === this.words[0];
        }, s.prototype.cmpn = function (e) {
          var t,
              r = e < 0;
          if (0 !== this.negative && !r) return -1;
          if (0 === this.negative && r) return 1;
          if (this.strip(), this.length > 1) t = 1;else {
            r && (e = -e), n(e <= 67108863, "Number is too big");
            var i = 0 | this.words[0];
            t = i === e ? 0 : i < e ? -1 : 1;
          }
          return 0 !== this.negative ? 0 | -t : t;
        }, s.prototype.cmp = function (e) {
          if (0 !== this.negative && 0 === e.negative) return -1;
          if (0 === this.negative && 0 !== e.negative) return 1;
          var t = this.ucmp(e);
          return 0 !== this.negative ? 0 | -t : t;
        }, s.prototype.ucmp = function (e) {
          if (this.length > e.length) return 1;
          if (this.length < e.length) return -1;

          for (var t = 0, r = this.length - 1; r >= 0; r--) {
            var n = 0 | this.words[r],
                i = 0 | e.words[r];

            if (n !== i) {
              n < i ? t = -1 : n > i && (t = 1);
              break;
            }
          }

          return t;
        }, s.prototype.gtn = function (e) {
          return 1 === this.cmpn(e);
        }, s.prototype.gt = function (e) {
          return 1 === this.cmp(e);
        }, s.prototype.gten = function (e) {
          return this.cmpn(e) >= 0;
        }, s.prototype.gte = function (e) {
          return this.cmp(e) >= 0;
        }, s.prototype.ltn = function (e) {
          return -1 === this.cmpn(e);
        }, s.prototype.lt = function (e) {
          return -1 === this.cmp(e);
        }, s.prototype.lten = function (e) {
          return this.cmpn(e) <= 0;
        }, s.prototype.lte = function (e) {
          return this.cmp(e) <= 0;
        }, s.prototype.eqn = function (e) {
          return 0 === this.cmpn(e);
        }, s.prototype.eq = function (e) {
          return 0 === this.cmp(e);
        }, s.red = function (e) {
          return new k(e);
        }, s.prototype.toRed = function (e) {
          return n(!this.red, "Already a number in reduction context"), n(0 === this.negative, "red works only with positives"), e.convertTo(this)._forceRed(e);
        }, s.prototype.fromRed = function () {
          return n(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
        }, s.prototype._forceRed = function (e) {
          return this.red = e, this;
        }, s.prototype.forceRed = function (e) {
          return n(!this.red, "Already a number in reduction context"), this._forceRed(e);
        }, s.prototype.redAdd = function (e) {
          return n(this.red, "redAdd works only with red numbers"), this.red.add(this, e);
        }, s.prototype.redIAdd = function (e) {
          return n(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, e);
        }, s.prototype.redSub = function (e) {
          return n(this.red, "redSub works only with red numbers"), this.red.sub(this, e);
        }, s.prototype.redISub = function (e) {
          return n(this.red, "redISub works only with red numbers"), this.red.isub(this, e);
        }, s.prototype.redShl = function (e) {
          return n(this.red, "redShl works only with red numbers"), this.red.shl(this, e);
        }, s.prototype.redMul = function (e) {
          return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.mul(this, e);
        }, s.prototype.redIMul = function (e) {
          return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.imul(this, e);
        }, s.prototype.redSqr = function () {
          return n(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
        }, s.prototype.redISqr = function () {
          return n(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
        }, s.prototype.redSqrt = function () {
          return n(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
        }, s.prototype.redInvm = function () {
          return n(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
        }, s.prototype.redNeg = function () {
          return n(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
        }, s.prototype.redPow = function (e) {
          return n(this.red && !e.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, e);
        };
        var _ = {
          k256: null,
          p224: null,
          p192: null,
          p25519: null
        };

        function g(e, t) {
          this.name = e, this.p = new s(t, 16), this.n = this.p.bitLength(), this.k = new s(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
        }

        function v() {
          g.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
        }

        function m() {
          g.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
        }

        function y() {
          g.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
        }

        function w() {
          g.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
        }

        function k(e) {
          if ("string" == typeof e) {
            var t = s._prime(e);

            this.m = t.p, this.prime = t;
          } else n(e.gtn(1), "modulus must be greater than 1"), this.m = e, this.prime = null;
        }

        function S(e) {
          k.call(this, e), this.shift = this.m.bitLength(), this.shift % 26 != 0 && (this.shift += 26 - this.shift % 26), this.r = new s(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
        }

        g.prototype._tmp = function () {
          var e = new s(null);
          return e.words = new Array(Math.ceil(this.n / 13)), e;
        }, g.prototype.ireduce = function (e) {
          var t,
              r = e;

          do {
            this.split(r, this.tmp), t = (r = (r = this.imulK(r)).iadd(this.tmp)).bitLength();
          } while (t > this.n);

          var n = t < this.n ? -1 : r.ucmp(this.p);
          return 0 === n ? (r.words[0] = 0, r.length = 1) : n > 0 ? r.isub(this.p) : r.strip(), r;
        }, g.prototype.split = function (e, t) {
          e.iushrn(this.n, 0, t);
        }, g.prototype.imulK = function (e) {
          return e.imul(this.k);
        }, i(v, g), v.prototype.split = function (e, t) {
          for (var r = Math.min(e.length, 9), n = 0; n < r; n++) {
            t.words[n] = e.words[n];
          }

          if (t.length = r, e.length <= 9) return e.words[0] = 0, void (e.length = 1);
          var i = e.words[9];

          for (t.words[t.length++] = 4194303 & i, n = 10; n < e.length; n++) {
            var s = 0 | e.words[n];
            e.words[n - 10] = (4194303 & s) << 4 | i >>> 22, i = s;
          }

          i >>>= 22, e.words[n - 10] = i, 0 === i && e.length > 10 ? e.length -= 10 : e.length -= 9;
        }, v.prototype.imulK = function (e) {
          e.words[e.length] = 0, e.words[e.length + 1] = 0, e.length += 2;

          for (var t = 0, r = 0; r < e.length; r++) {
            var n = 0 | e.words[r];
            t += 977 * n, e.words[r] = 67108863 & t, t = 64 * n + (t / 67108864 | 0);
          }

          return 0 === e.words[e.length - 1] && (e.length--, 0 === e.words[e.length - 1] && e.length--), e;
        }, i(m, g), i(y, g), i(w, g), w.prototype.imulK = function (e) {
          for (var t = 0, r = 0; r < e.length; r++) {
            var n = 19 * (0 | e.words[r]) + t,
                i = 67108863 & n;
            n >>>= 26, e.words[r] = i, t = n;
          }

          return 0 !== t && (e.words[e.length++] = t), e;
        }, s._prime = function (e) {
          if (_[e]) return _[e];
          var t;
          if ("k256" === e) t = new v();else if ("p224" === e) t = new m();else if ("p192" === e) t = new y();else {
            if ("p25519" !== e) throw new Error("Unknown prime " + e);
            t = new w();
          }
          return _[e] = t, t;
        }, k.prototype._verify1 = function (e) {
          n(0 === e.negative, "red works only with positives"), n(e.red, "red works only with red numbers");
        }, k.prototype._verify2 = function (e, t) {
          n(0 == (e.negative | t.negative), "red works only with positives"), n(e.red && e.red === t.red, "red works only with red numbers");
        }, k.prototype.imod = function (e) {
          return this.prime ? this.prime.ireduce(e)._forceRed(this) : e.umod(this.m)._forceRed(this);
        }, k.prototype.neg = function (e) {
          return e.isZero() ? e.clone() : this.m.sub(e)._forceRed(this);
        }, k.prototype.add = function (e, t) {
          this._verify2(e, t);

          var r = e.add(t);
          return r.cmp(this.m) >= 0 && r.isub(this.m), r._forceRed(this);
        }, k.prototype.iadd = function (e, t) {
          this._verify2(e, t);

          var r = e.iadd(t);
          return r.cmp(this.m) >= 0 && r.isub(this.m), r;
        }, k.prototype.sub = function (e, t) {
          this._verify2(e, t);

          var r = e.sub(t);
          return r.cmpn(0) < 0 && r.iadd(this.m), r._forceRed(this);
        }, k.prototype.isub = function (e, t) {
          this._verify2(e, t);

          var r = e.isub(t);
          return r.cmpn(0) < 0 && r.iadd(this.m), r;
        }, k.prototype.shl = function (e, t) {
          return this._verify1(e), this.imod(e.ushln(t));
        }, k.prototype.imul = function (e, t) {
          return this._verify2(e, t), this.imod(e.imul(t));
        }, k.prototype.mul = function (e, t) {
          return this._verify2(e, t), this.imod(e.mul(t));
        }, k.prototype.isqr = function (e) {
          return this.imul(e, e.clone());
        }, k.prototype.sqr = function (e) {
          return this.mul(e, e);
        }, k.prototype.sqrt = function (e) {
          if (e.isZero()) return e.clone();
          var t = this.m.andln(3);

          if (n(t % 2 == 1), 3 === t) {
            var r = this.m.add(new s(1)).iushrn(2);
            return this.pow(e, r);
          }

          for (var i = this.m.subn(1), o = 0; !i.isZero() && 0 === i.andln(1);) {
            o++, i.iushrn(1);
          }

          n(!i.isZero());
          var a = new s(1).toRed(this),
              f = a.redNeg(),
              c = this.m.subn(1).iushrn(1),
              u = this.m.bitLength();

          for (u = new s(2 * u * u).toRed(this); 0 !== this.pow(u, c).cmp(f);) {
            u.redIAdd(f);
          }

          for (var h = this.pow(u, i), d = this.pow(e, i.addn(1).iushrn(1)), l = this.pow(e, i), p = o; 0 !== l.cmp(a);) {
            for (var b = l, _ = 0; 0 !== b.cmp(a); _++) {
              b = b.redSqr();
            }

            n(_ < p);
            var g = this.pow(h, new s(1).iushln(p - _ - 1));
            d = d.redMul(g), h = g.redSqr(), l = l.redMul(h), p = _;
          }

          return d;
        }, k.prototype.invm = function (e) {
          var t = e._invmp(this.m);

          return 0 !== t.negative ? (t.negative = 0, this.imod(t).redNeg()) : this.imod(t);
        }, k.prototype.pow = function (e, t) {
          if (t.isZero()) return new s(1).toRed(this);
          if (0 === t.cmpn(1)) return e.clone();
          var r = new Array(16);
          r[0] = new s(1).toRed(this), r[1] = e;

          for (var n = 2; n < r.length; n++) {
            r[n] = this.mul(r[n - 1], e);
          }

          var i = r[0],
              o = 0,
              a = 0,
              f = t.bitLength() % 26;

          for (0 === f && (f = 26), n = t.length - 1; n >= 0; n--) {
            for (var c = t.words[n], u = f - 1; u >= 0; u--) {
              var h = c >> u & 1;
              i !== r[0] && (i = this.sqr(i)), 0 !== h || 0 !== o ? (o <<= 1, o |= h, (4 === ++a || 0 === n && 0 === u) && (i = this.mul(i, r[o]), a = 0, o = 0)) : a = 0;
            }

            f = 26;
          }

          return i;
        }, k.prototype.convertTo = function (e) {
          var t = e.umod(this.m);
          return t === e ? t.clone() : t;
        }, k.prototype.convertFrom = function (e) {
          var t = e.clone();
          return t.red = null, t;
        }, s.mont = function (e) {
          return new S(e);
        }, i(S, k), S.prototype.convertTo = function (e) {
          return this.imod(e.ushln(this.shift));
        }, S.prototype.convertFrom = function (e) {
          var t = this.imod(e.mul(this.rinv));
          return t.red = null, t;
        }, S.prototype.imul = function (e, t) {
          if (e.isZero() || t.isZero()) return e.words[0] = 0, e.length = 1, e;
          var r = e.imul(t),
              n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
              i = r.isub(n).iushrn(this.shift),
              s = i;
          return i.cmp(this.m) >= 0 ? s = i.isub(this.m) : i.cmpn(0) < 0 && (s = i.iadd(this.m)), s._forceRed(this);
        }, S.prototype.mul = function (e, t) {
          if (e.isZero() || t.isZero()) return new s(0)._forceRed(this);
          var r = e.mul(t),
              n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
              i = r.isub(n).iushrn(this.shift),
              o = i;
          return i.cmp(this.m) >= 0 ? o = i.isub(this.m) : i.cmpn(0) < 0 && (o = i.iadd(this.m)), o._forceRed(this);
        }, S.prototype.invm = function (e) {
          return this.imod(e._invmp(this.m).mul(this.r2))._forceRed(this);
        };
      }(void 0 === e || e, this);
    }).call(this, r(59)(e));
  }, function (e, t) {
    var r;

    r = function () {
      return this;
    }();

    try {
      r = r || Function("return this")() || (0, eval)("this");
    } catch (e) {
      "object" == typeof window && (r = window);
    }

    e.exports = r;
  }, function (e, t) {
    function r(e, t) {
      for (var r = 0, n = e.length - 1; n >= 0; n--) {
        var i = e[n];
        "." === i ? e.splice(n, 1) : ".." === i ? (e.splice(n, 1), r++) : r && (e.splice(n, 1), r--);
      }

      if (t) for (; r--; r) {
        e.unshift("..");
      }
      return e;
    }

    var n = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/,
        i = function i(e) {
      return n.exec(e).slice(1);
    };

    function s(e, t) {
      if (e.filter) return e.filter(t);

      for (var r = [], n = 0; n < e.length; n++) {
        t(e[n], n, e) && r.push(e[n]);
      }

      return r;
    }

    t.resolve = function () {
      for (var e = "", t = !1, n = arguments.length - 1; n >= -1 && !t; n--) {
        var i = n >= 0 ? arguments[n] : process.cwd();
        if ("string" != typeof i) throw new TypeError("Arguments to path.resolve must be strings");
        i && (e = i + "/" + e, t = "/" === i.charAt(0));
      }

      return e = r(s(e.split("/"), function (e) {
        return !!e;
      }), !t).join("/"), (t ? "/" : "") + e || ".";
    }, t.normalize = function (e) {
      var n = t.isAbsolute(e),
          i = "/" === o(e, -1);
      return (e = r(s(e.split("/"), function (e) {
        return !!e;
      }), !n).join("/")) || n || (e = "."), e && i && (e += "/"), (n ? "/" : "") + e;
    }, t.isAbsolute = function (e) {
      return "/" === e.charAt(0);
    }, t.join = function () {
      var e = Array.prototype.slice.call(arguments, 0);
      return t.normalize(s(e, function (e, t) {
        if ("string" != typeof e) throw new TypeError("Arguments to path.join must be strings");
        return e;
      }).join("/"));
    }, t.relative = function (e, r) {
      function n(e) {
        for (var t = 0; t < e.length && "" === e[t]; t++) {
          ;
        }

        for (var r = e.length - 1; r >= 0 && "" === e[r]; r--) {
          ;
        }

        return t > r ? [] : e.slice(t, r - t + 1);
      }

      e = t.resolve(e).substr(1), r = t.resolve(r).substr(1);

      for (var i = n(e.split("/")), s = n(r.split("/")), o = Math.min(i.length, s.length), a = o, f = 0; f < o; f++) {
        if (i[f] !== s[f]) {
          a = f;
          break;
        }
      }

      var c = [];

      for (f = a; f < i.length; f++) {
        c.push("..");
      }

      return (c = c.concat(s.slice(a))).join("/");
    }, t.sep = "/", t.delimiter = ":", t.dirname = function (e) {
      var t = i(e),
          r = t[0],
          n = t[1];
      return r || n ? (n && (n = n.substr(0, n.length - 1)), r + n) : ".";
    }, t.basename = function (e, t) {
      var r = i(e)[2];
      return t && r.substr(-1 * t.length) === t && (r = r.substr(0, r.length - t.length)), r;
    }, t.extname = function (e) {
      return i(e)[3];
    };
    var o = "b" === "ab".substr(-1) ? function (e, t, r) {
      return e.substr(t, r);
    } : function (e, t, r) {
      return t < 0 && (t = e.length + t), e.substr(t, r);
    };
  }, function (e, t, r) {
    "use strict";

    var n = t;
    n.version = r(197).version, n.utils = r(196), n.rand = r(87), n.curve = r(37), n.curves = r(191), n.ec = r(183), n.eddsa = r(179);
  }, function (e, t, r) {
    "use strict";

    var n = r(64),
        i = r(129),
        s = Object.prototype.toString;

    function o(e) {
      return "[object Array]" === s.call(e);
    }

    function a(e) {
      return null !== e && "object" == typeof e;
    }

    function f(e) {
      return "[object Function]" === s.call(e);
    }

    function c(e, t) {
      if (null !== e && void 0 !== e) if ("object" != typeof e && (e = [e]), o(e)) for (var r = 0, n = e.length; r < n; r++) {
        t.call(null, e[r], r, e);
      } else for (var i in e) {
        Object.prototype.hasOwnProperty.call(e, i) && t.call(null, e[i], i, e);
      }
    }

    e.exports = {
      isArray: o,
      isArrayBuffer: function isArrayBuffer(e) {
        return "[object ArrayBuffer]" === s.call(e);
      },
      isBuffer: i,
      isFormData: function isFormData(e) {
        return "undefined" != typeof FormData && e instanceof FormData;
      },
      isArrayBufferView: function isArrayBufferView(e) {
        return "undefined" != typeof ArrayBuffer && ArrayBuffer.isView ? ArrayBuffer.isView(e) : e && e.buffer && e.buffer instanceof ArrayBuffer;
      },
      isString: function isString(e) {
        return "string" == typeof e;
      },
      isNumber: function isNumber(e) {
        return "number" == typeof e;
      },
      isObject: a,
      isUndefined: function isUndefined(e) {
        return void 0 === e;
      },
      isDate: function isDate(e) {
        return "[object Date]" === s.call(e);
      },
      isFile: function isFile(e) {
        return "[object File]" === s.call(e);
      },
      isBlob: function isBlob(e) {
        return "[object Blob]" === s.call(e);
      },
      isFunction: f,
      isStream: function isStream(e) {
        return a(e) && f(e.pipe);
      },
      isURLSearchParams: function isURLSearchParams(e) {
        return "undefined" != typeof URLSearchParams && e instanceof URLSearchParams;
      },
      isStandardBrowserEnv: function isStandardBrowserEnv() {
        return ("undefined" == typeof navigator || "ReactNative" !== navigator.product) && "undefined" != typeof window && "undefined" != typeof document;
      },
      forEach: c,
      merge: function e() {
        var t = {};

        function r(r, n) {
          "object" == typeof t[n] && "object" == typeof r ? t[n] = e(t[n], r) : t[n] = r;
        }

        for (var n = 0, i = arguments.length; n < i; n++) {
          c(arguments[n], r);
        }

        return t;
      },
      extend: function extend(e, t, r) {
        return c(t, function (t, i) {
          e[i] = r && "function" == typeof t ? n(t, r) : t;
        }), e;
      },
      trim: function trim(e) {
        return e.replace(/^\s*/, "").replace(/\s*$/, "");
      }
    };
  }, function (e, t) {
    function r(e, t) {
      if (!e) throw new Error(t || "Assertion failed");
    }

    e.exports = r, r.equal = function (e, t, r) {
      if (e != t) throw new Error(r || "Assertion failed: " + e + " != " + t);
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(13),
        i = r(2);

    function s(e) {
      return (e >>> 24 | e >>> 8 & 65280 | e << 8 & 16711680 | (255 & e) << 24) >>> 0;
    }

    function o(e) {
      return 1 === e.length ? "0" + e : e;
    }

    function a(e) {
      return 7 === e.length ? "0" + e : 6 === e.length ? "00" + e : 5 === e.length ? "000" + e : 4 === e.length ? "0000" + e : 3 === e.length ? "00000" + e : 2 === e.length ? "000000" + e : 1 === e.length ? "0000000" + e : e;
    }

    t.inherits = i, t.toArray = function (e, t) {
      if (Array.isArray(e)) return e.slice();
      if (!e) return [];
      var r = [];
      if ("string" == typeof e) {
        if (t) {
          if ("hex" === t) for ((e = e.replace(/[^a-z0-9]+/gi, "")).length % 2 != 0 && (e = "0" + e), n = 0; n < e.length; n += 2) {
            r.push(parseInt(e[n] + e[n + 1], 16));
          }
        } else for (var n = 0; n < e.length; n++) {
          var i = e.charCodeAt(n),
              s = i >> 8,
              o = 255 & i;
          s ? r.push(s, o) : r.push(o);
        }
      } else for (n = 0; n < e.length; n++) {
        r[n] = 0 | e[n];
      }
      return r;
    }, t.toHex = function (e) {
      for (var t = "", r = 0; r < e.length; r++) {
        t += o(e[r].toString(16));
      }

      return t;
    }, t.htonl = s, t.toHex32 = function (e, t) {
      for (var r = "", n = 0; n < e.length; n++) {
        var i = e[n];
        "little" === t && (i = s(i)), r += a(i.toString(16));
      }

      return r;
    }, t.zero2 = o, t.zero8 = a, t.join32 = function (e, t, r, i) {
      var s = r - t;
      n(s % 4 == 0);

      for (var o = new Array(s / 4), a = 0, f = t; a < o.length; a++, f += 4) {
        var c;
        c = "big" === i ? e[f] << 24 | e[f + 1] << 16 | e[f + 2] << 8 | e[f + 3] : e[f + 3] << 24 | e[f + 2] << 16 | e[f + 1] << 8 | e[f], o[a] = c >>> 0;
      }

      return o;
    }, t.split32 = function (e, t) {
      for (var r = new Array(4 * e.length), n = 0, i = 0; n < e.length; n++, i += 4) {
        var s = e[n];
        "big" === t ? (r[i] = s >>> 24, r[i + 1] = s >>> 16 & 255, r[i + 2] = s >>> 8 & 255, r[i + 3] = 255 & s) : (r[i + 3] = s >>> 24, r[i + 2] = s >>> 16 & 255, r[i + 1] = s >>> 8 & 255, r[i] = 255 & s);
      }

      return r;
    }, t.rotr32 = function (e, t) {
      return e >>> t | e << 32 - t;
    }, t.rotl32 = function (e, t) {
      return e << t | e >>> 32 - t;
    }, t.sum32 = function (e, t) {
      return e + t >>> 0;
    }, t.sum32_3 = function (e, t, r) {
      return e + t + r >>> 0;
    }, t.sum32_4 = function (e, t, r, n) {
      return e + t + r + n >>> 0;
    }, t.sum32_5 = function (e, t, r, n, i) {
      return e + t + r + n + i >>> 0;
    }, t.sum64 = function (e, t, r, n) {
      var i = e[t],
          s = n + e[t + 1] >>> 0,
          o = (s < n ? 1 : 0) + r + i;
      e[t] = o >>> 0, e[t + 1] = s;
    }, t.sum64_hi = function (e, t, r, n) {
      return (t + n >>> 0 < t ? 1 : 0) + e + r >>> 0;
    }, t.sum64_lo = function (e, t, r, n) {
      return t + n >>> 0;
    }, t.sum64_4_hi = function (e, t, r, n, i, s, o, a) {
      var f = 0,
          c = t;
      return f += (c = c + n >>> 0) < t ? 1 : 0, f += (c = c + s >>> 0) < s ? 1 : 0, e + r + i + o + (f += (c = c + a >>> 0) < a ? 1 : 0) >>> 0;
    }, t.sum64_4_lo = function (e, t, r, n, i, s, o, a) {
      return t + n + s + a >>> 0;
    }, t.sum64_5_hi = function (e, t, r, n, i, s, o, a, f, c) {
      var u = 0,
          h = t;
      return u += (h = h + n >>> 0) < t ? 1 : 0, u += (h = h + s >>> 0) < s ? 1 : 0, u += (h = h + a >>> 0) < a ? 1 : 0, e + r + i + o + f + (u += (h = h + c >>> 0) < c ? 1 : 0) >>> 0;
    }, t.sum64_5_lo = function (e, t, r, n, i, s, o, a, f, c) {
      return t + n + s + a + c >>> 0;
    }, t.rotr64_hi = function (e, t, r) {
      return (t << 32 - r | e >>> r) >>> 0;
    }, t.rotr64_lo = function (e, t, r) {
      return (e << 32 - r | t >>> r) >>> 0;
    }, t.shr64_hi = function (e, t, r) {
      return e >>> r;
    }, t.shr64_lo = function (e, t, r) {
      return (e << 32 - r | t >>> r) >>> 0;
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(0),
        i = r.n(n),
        s = r(23),
        o = r(111),
        a = r(7),
        f = r(32),
        c = r(41),
        u = r(4),
        h = r(19),
        d = r(1),
        l = r(5);

    var p = function p(e) {
      _classCallCheck(this, p);

      if (!i.a.isObject(e)) throw new TypeError("Failed to instantiate ActivityDescriptor. <Descriptor>descriptor is required.");
      if (!_.every(function (t) {
        return t in e;
      })) throw new TypeError("Failed to instantiate ActivityDescriptor. <Descriptor>descriptor does not contain all properties of an Activity.");
      this.accountSid = e.account_sid, this.available = e.available, this.dateCreated = Object(l.parseTime)(1e3 * e.date_created), this.dateUpdated = Object(l.parseTime)(1e3 * e.date_updated), this.name = e.friendly_name, this.sid = e.sid, this.workspaceSid = e.workspace_sid;
    };

    var b = r(5).validateOptions;
    var _ = ["account_sid", "available", "date_created", "date_updated", "friendly_name", "sid", "workspace_sid"];

    var g =
    /*#__PURE__*/
    function () {
      function g(e, t) {
        _classCallCheck(this, g);

        if (!i.a.isObject(e)) throw new TypeError("Failed to create an Activity. <Worker>worker is a required parameter.");
        if (!(t instanceof p)) throw new TypeError("Failed to create an Activity. <ActivityDescriptor>descriptor is a required parameter.");
        Object.assign(this, t), this._worker = e, this._isCurrent = !1;
      }

      _createClass(g, [{
        key: "setAsCurrent",
        value: function setAsCurrent() {
          var _this = this;

          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          if (!b(e, {
            rejectPendingReservations: function rejectPendingReservations(e) {
              return i.a.isBoolean(e);
            }
          })) throw new TypeError("Failed to set activity=".concat(this.sid, ". The options passed in did not match the required types."));
          if (e.rejectPendingReservations && this.available) throw new Error("Unable to reject pending reservations when updating to an Available activity state.");
          return this._worker._updateWorkerActivity(this.sid, e).then(function () {
            return _this;
          });
        }
      }, {
        key: "isCurrent",
        get: function get() {
          return this._isCurrent;
        }
      }]);

      return g;
    }(),
        v = r(18);

    var m =
    /*#__PURE__*/
    function () {
      function m(e, t) {
        var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        _classCallCheck(this, m);

        if (!i.a.isObject(e)) throw new TypeError("Failed to initialize ActivitiesEntity. <Worker>worker is a required parameter.");
        this._activities = new Map(), this._log = e.getLogger("ActivitiesEntity-".concat(e.sid)), this._request = t, this._worker = e, this._pageSize = r.pageSize || d.DEFAULT_PAGE_SIZE, i.a.inRange(this._pageSize, 1, d.DEFAULT_PAGE_SIZE + 1) || (this._log.warn("PageSize range for ActivitiesEntity must be between 1 and %d. Setting pageSize to default size=%d", d.DEFAULT_PAGE_SIZE, d.DEFAULT_PAGE_SIZE), this._pageSize = 1e3);
      }

      _createClass(m, [{
        key: "fetchActivities",
        value: function fetchActivities() {
          var e = this._getPage();

          return this._getAllActivities(e);
        }
      }, {
        key: "_getAllActivities",
        value: function _getAllActivities(e) {
          var _this2 = this;

          return e.then(function (e) {
            return e.items.forEach(function (e) {
              _this2._insertActivity(e);
            }), e.hasNextPage ? _this2._getAllActivities(e.nextPage()) : Promise.resolve();
          });
        }
      }, {
        key: "_getPage",
        value: function _getPage(e) {
          var _this3 = this;

          e = e || {};

          var t = this._worker.getRoutes().getRoute(u.a).path,
              r = {
            PageSize: this._pageSize
          };

          return e.AfterSid && (r.AfterSid = e.AfterSid), this._request.get(t, d.API_V1, r).then(function (e) {
            return new v.default(e.contents.map(function (e) {
              return new p(e);
            }), function (e) {
              return _this3._getPage({
                AfterSid: e
              });
            }, e.after_sid);
          });
        }
      }, {
        key: "_insertActivity",
        value: function _insertActivity(e) {
          var t = e.sid;

          this._log.trace("_insertActivity(sid=".concat(t, ", data=").concat(JSON.stringify(e)));

          try {
            var _r4 = new g(this._worker, e);

            this._activities.set(t, _r4);
          } catch (e) {
            this._log.error("Unable to create an Activity for sid=".concat(t, ". Skipping insert into Activities map. Error: ").concat(e));
          }
        }
      }, {
        key: "activities",
        get: function get() {
          return this._activities;
        }
      }]);

      return m;
    }();

    var y = function y(e) {
      _classCallCheck(this, y);

      if (!i.a.isObject(e)) throw new TypeError("Failed to instantiate WorkerChannelDescriptor. <Descriptor>descriptor is required.");
      if (!k.every(function (t) {
        return t in e;
      })) throw new TypeError("Failed to create a WorkerChannelDescriptor. <Descriptor>descriptor does not contain all properties of a Channel.");
      this.accountSid = e.account_sid, this.assignedTasks = e.assigned_tasks, this.available = !!e.available, this.availableCapacityPercentage = e.available_capacity_percentage, this.capacity = e.configured_capacity, this.dateCreated = Object(l.parseTime)(1e3 * e.date_created), this.dateUpdated = Object(l.parseTime)(1e3 * e.date_updated), this.lastReservedTime = Object(l.parseTime)(e.last_reserved_time), this.sid = e.sid, this.taskChannelSid = e.task_channel_sid, this.taskChannelUniqueName = e.task_channel_unique_name, this.workerSid = e.worker_sid, this.workspaceSid = e.workspace_sid;
    };

    var w = ["capacity", "available", "assignedTasks", "availableCapacityPercentage", "dateUpdated", "lastReservedTime"];
    var k = ["account_sid", "assigned_tasks", "available", "available_capacity_percentage", "configured_capacity", "date_created", "date_updated", "last_reserved_time", "sid", "task_channel_sid", "task_channel_unique_name", "worker_sid", "workspace_sid"];

    var S =
    /*#__PURE__*/
    function (_a$EventEmitter) {
      _inherits(S, _a$EventEmitter);

      function S(e, t, r) {
        var _this4;

        _classCallCheck(this, S);

        if (_this4 = _possibleConstructorReturn(this, _getPrototypeOf(S).call(this)), !(e instanceof V)) throw new TypeError("Failed to instantiate Worker. <Worker>worker is a required parameter.");
        if (!(r instanceof y)) throw new TypeError("Failed to instantiate Channel. <WorkerChannelDescriptor>descriptor is a required parameter.");
        _this4._request = t, _this4._log = e.getLogger("Channel-".concat(r.sid)), Object.assign(_assertThisInitialized(_this4), r);
        return _possibleConstructorReturn(_this4);
      }

      _createClass(S, [{
        key: "_emitEvent",
        value: function _emitEvent(e, t) {
          if (!i.a.isString(e)) throw new TypeError("Error calling _emitEvent(). <string>eventType is a required parameter.");
          if (!i.a.isObject(t)) throw new TypeError("Error calling method _emitEvent(). <object>rawEventData is a required parameter.");
          this._update(t), this.emit(e, this);
        }
      }, {
        key: "_update",
        value: function _update(e) {
          var _this5 = this;

          try {
            var _t2 = new y(e);

            w.forEach(function (e) {
              _this5[e] = _t2[e];
            });
          } catch (t) {
            this._log.warn("Failed to update Channel sid=%s. Update aborted. Error: %s.", e.sid, t);
          }

          return this;
        }
      }]);

      return S;
    }(a.EventEmitter);

    var E =
    /*#__PURE__*/
    function () {
      function E(e, t) {
        var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        _classCallCheck(this, E);

        if (!(e instanceof V)) throw new TypeError("Failed to initialize ChannelsEntity. <Worker>worker is a required parameter.");
        this._channels = new Map(), this._log = e.getLogger("ChannelsEntity"), this._request = t, this._pageSize = r.pageSize || d.DEFAULT_PAGE_SIZE, this._worker = e, i.a.inRange(this._pageSize, 1, d.DEFAULT_PAGE_SIZE + 1) || (this._log.warn("PageSize range for ChannelsEntity must be between 1 and %d. Setting pageSize to default size=%d", d.DEFAULT_PAGE_SIZE, d.DEFAULT_PAGE_SIZE), this._pageSize = 1e3);
      }

      _createClass(E, [{
        key: "fetchChannels",
        value: function fetchChannels() {
          var e = this._getPage();

          return this._getAllChannels(e);
        }
      }, {
        key: "_getAllChannels",
        value: function _getAllChannels(e) {
          var _this6 = this;

          return e.then(function (e) {
            return e.items.forEach(function (e) {
              _this6._insertChannel(e);
            }), e.hasNextPage ? _this6._getAllChannels(e.nextPage()) : Promise.resolve();
          });
        }
      }, {
        key: "_getPage",
        value: function _getPage(e) {
          var _this7 = this;

          e = e || {};

          var t = this._worker.getRoutes().getRoute(u.m).path,
              r = {
            PageSize: this._pageSize
          };

          return e.AfterSid && (r.AfterSid = e.AfterSid), this._request.get(t, d.API_V1, r).then(function (e) {
            return new v.default(e.contents.map(function (e) {
              return new y(e);
            }), function (e) {
              return _this7._getPage({
                AfterSid: e
              });
            }, e.after_sid);
          });
        }
      }, {
        key: "_insertChannel",
        value: function _insertChannel(e) {
          var t = e.sid;

          this._log.trace("_insertChannel(sid=".concat(t, ", data=").concat(JSON.stringify(e)));

          try {
            var _r5 = new S(this._worker, this._request, e);

            this._channels.set(t, _r5);
          } catch (e) {
            this._log.error("Unable to create a Channel for sid=".concat(t, ". Skipping insert into Channels map. Error: ").concat(e));
          }
        }
      }, {
        key: "channels",
        get: function get() {
          return this._channels;
        }
      }]);

      return E;
    }();

    var A = function A(e) {
      _classCallCheck(this, A);

      if (!i.a.isObject(e)) throw new TypeError("Failed to instantiate TransferDescriptor. <Descriptor>descriptor is required.");
      if (!T.every(function (t) {
        return t in e;
      })) throw new TypeError("Failed to instantiate TransferDescriptor. <Descriptor>descriptor does not contain all properties of a Transfer.");
      this.dateCreated = Object(l.parseTime)(1e3 * e.date_created), this.dateUpdated = Object(l.parseTime)(1e3 * e.date_updated), this.mode = e.transfer_mode, this.queueSid = e.initiating_queue_sid, this.reservationSid = e.initiating_reservation_sid, this.to = e.transfer_to, this.transferFailedReason = e.transfer_failed_reason, this.type = e.transfer_type, this.sid = e.sid, this.status = e.transfer_status, this.workerSid = e.initiating_worker_sid, this.workflowSid = e.initiating_workflow_sid;
    };

    var x = ["dateUpdated", "status", "transferFailedReason"];
    var T = ["date_created", "date_updated", "initiating_reservation_sid", "initiating_worker_sid", "initiating_queue_sid", "initiating_workflow_sid", "sid", "transfer_mode", "transfer_to", "transfer_type", "transfer_status"];

    var R =
    /*#__PURE__*/
    function (_a$EventEmitter2) {
      _inherits(R, _a$EventEmitter2);

      function R(e, t) {
        var _this8;

        _classCallCheck(this, R);

        if (_this8 = _possibleConstructorReturn(this, _getPrototypeOf(R).call(this)), !(t instanceof A)) throw new TypeError("Failed to instantiate Transfer. <TransferDescriptor>descriptor is a required parameter.");
        _this8._log = e.getLogger("Transfer-".concat(t.sid)), Object.assign(_assertThisInitialized(_this8), t);
        return _possibleConstructorReturn(_this8);
      }

      _createClass(R, [{
        key: "_update",
        value: function _update(e) {
          var _this9 = this;

          try {
            var _t3 = new A(e);

            x.forEach(function (e) {
              _this9[e] = _t3[e];
            });
          } catch (t) {
            throw this._log.error("Failed to update Transfer sid=".concat(e.sid, ". Update aborted."), t), new Error("Failed to update Transfer sid=".concat(e.sid, ". Update aborted. Error: ").concat(t, "."));
          }

          return this;
        }
      }]);

      return R;
    }(a.EventEmitter);

    var M =
    /*#__PURE__*/
    function (_R) {
      _inherits(M, _R);

      function M(e, t) {
        _classCallCheck(this, M);

        return _possibleConstructorReturn(this, _getPrototypeOf(M).call(this, e, t));
      }

      return M;
    }(R);

    var I =
    /*#__PURE__*/
    function (_R2) {
      _inherits(I, _R2);

      function I(e, t, r, n) {
        var _this10;

        _classCallCheck(this, I);

        if (_this10 = _possibleConstructorReturn(this, _getPrototypeOf(I).call(this, e, n)), "string" != typeof r) throw new TypeError("Failed to instantiate OutgoingTransfer. <string>taskSid is a required parameter.");
        _this10._worker = e, _this10._request = t, _this10.taskSid = r;
        return _possibleConstructorReturn(_this10);
      }

      _createClass(I, [{
        key: "_emitEvent",
        value: function _emitEvent(e, t) {
          if (this._log.trace("_emitEvent(".concat(e, ", ").concat(JSON.stringify(t), ")")), !i.a.isString(e)) throw new TypeError("Error calling _emitEvent(). <string>eventType is a required parameter.");
          if (!i.a.isObject(t)) throw new TypeError("Error calling method _emitEvent(). <object>payload is a required parameter.");
          this.emit(e, this);
        }
      }, {
        key: "cancel",
        value: function () {
          var _cancel = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee() {
            var e, t, r;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    e = this._worker.getRoutes().getRoute(u.k, this.sid).path;
                    t = {
                      TaskSid: this.taskSid,
                      TransferStatus: d.TRANSFER_STATUS.canceled
                    };
                    _context.next = 4;
                    return this._request.post(e, t, d.API_V2);

                  case 4:
                    r = _context.sent;
                    return _context.abrupt("return", this._update(r));

                  case 6:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, this);
          }));

          function cancel() {
            return _cancel.apply(this, arguments);
          }

          return cancel;
        }()
      }]);

      return I;
    }(R);

    var O =
    /*#__PURE__*/
    function (_a$EventEmitter3) {
      _inherits(O, _a$EventEmitter3);

      function O(e, t, r) {
        var _this11;

        _classCallCheck(this, O);

        if (_this11 = _possibleConstructorReturn(this, _getPrototypeOf(O).call(this)), !(r instanceof N)) throw new TypeError("Failed to instantiate Transfers. <TaskDescriptor>taskDescriptor is a required parameter.");
        _this11._log = e.getLogger("Transfers-".concat(r.sid)), _this11._worker = e, _this11._request = t, _this11.incoming = r.incomingTransferDescriptor ? new M(e, r.incomingTransferDescriptor) : null, _this11.outgoing = r.outgoingTransferDescriptor ? new I(e, t, r.sid, r.outgoingTransferDescriptor) : null;
        return _possibleConstructorReturn(_this11);
      }

      _createClass(O, [{
        key: "_emitEvent",
        value: function _emitEvent(e, t) {
          if (this._log.trace("_emitEvent(".concat(e, ", ").concat(JSON.stringify(t), ")")), !i.a.isString(e)) throw new TypeError("Error calling _emitEvent(). <string>eventType is a required parameter.");
          if (!i.a.isObject(t)) throw new TypeError("Error calling method _emitEvent(). <object>payload is a required parameter.");
          var r = d.taskTransferEventTypes[e];
          this.outgoing ? this.outgoing.sid === t.sid ? Object.keys(i.a.pick(d.taskTransferEventTypes, ["transfer-attempt-failed", "transfer-completed", "transfer-failed", "transfer-canceled"])).indexOf(e) > -1 && (this._updateOutgoing(t), this.outgoing._emitEvent(r, t)) : this._log.warn("The transfer %s specified by Event: transfer.%s does not match the current active outgoing transfer for Worker %s. Skipping event.", t.sid, r, this._worker.sid) : this._log.warn("An active outgoing transfer does currently exist in Worker %s transfers map for Event: transfer.%s. Skipping event.", this._worker.sid, r);
        }
      }, {
        key: "_updateOutgoing",
        value: function _updateOutgoing(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          !this.outgoing || t ? this.outgoing = new I(this._worker, this._request, e.task_sid, new A(e)) : this.outgoing._update(e);
        }
      }, {
        key: "_update",
        value: function _update(e) {
          if (e.incoming) if (this.incoming) this.incoming._update(e.incoming);else {
            var _t4 = new A(e.incoming);

            this.incoming = new M(this._worker, this._request, e.incoming.task_sid, _t4);
          }
          if (e.outgoing) if (this.outgoing) this.outgoing._update(e.outgoing);else {
            var _t5 = new A(e.outgoing);

            this.outgoing = new I(this._worker, this._request, e.outgoing.task_sid, _t5);
          }
        }
      }]);

      return O;
    }(a.EventEmitter);

    var C = ["attributes", "status", "workflowSid", "workflowName", "queueSid", "queueName", "priority", "reason", "routingTarget", "timeout", "taskChannelSid", "taskChannelUniqueName", "age", "addOns", "dateUpdated", "transfers"];
    var B = ["addons", "age", "attributes", "date_created", "date_updated", "priority", "queue_name", "queue_sid", "reason", "routing_target", "sid", "assignment_status", "task_channel_unique_name", "task_channel_sid", "timeout", "workflow_name", "workflow_sid"];

    var P =
    /*#__PURE__*/
    function (_a$EventEmitter4) {
      _inherits(P, _a$EventEmitter4);

      function P(e, t, r, n) {
        var _this12;

        _classCallCheck(this, P);

        if (_this12 = _possibleConstructorReturn(this, _getPrototypeOf(P).call(this)), !(e instanceof V)) throw new TypeError("Failed to instantiate Task. <Worker>worker is a required parameter.");
        if (!n) throw new TypeError("Failed to instantiate Task. <TaskDescriptor>descriptor is a required parameter.");
        if (!(n instanceof N)) throw new TypeError("descriptor should be of type <TaskDescriptor>");
        if ("string" != typeof r) throw new TypeError("Failed to instantiate Task. <string>reservationSid is a required parameter.");
        _this12._worker = e, _this12._log = e.getLogger("Task-".concat(n.sid)), _this12._request = t, _this12.transfers = new O(e, t, n), Object.assign(_assertThisInitialized(_this12), n), _this12.reservationSid = r;
        return _possibleConstructorReturn(_this12);
      }

      _createClass(P, [{
        key: "complete",
        value: function complete(e) {
          var _this13 = this;

          if (!i.a.isString(e)) throw new TypeError("Error calling method complete(). <string>reason is a required parameter.");

          var t = this._worker.getRoutes().getRoute(u.h, this.sid).path,
              r = {
            AssignmentStatus: d.TASK_STATUS_COMPLETED,
            Reason: e
          };

          return this._request.post(t, r, d.API_V1).then(function (e) {
            return _this13._update(e);
          });
        }
      }, {
        key: "transfer",
        value: function () {
          var _transfer = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee2(e) {
            var t,
                r,
                n,
                s,
                _args2 = arguments;
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    t = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};

                    if (i.a.isString(e)) {
                      _context2.next = 3;
                      break;
                    }

                    throw new TypeError("Error calling method transfer(). <string>to is a required parameter.");

                  case 3:
                    r = this._worker.getRoutes().getRoute(u.l).path, n = {
                      ReservationSid: this.reservationSid,
                      TaskSid: this.sid,
                      To: e
                    };
                    t.attributes && (n.Attributes = t.attributes), t.mode && (n.Mode = t.mode), t.priority && (n.Priority = t.priority);
                    _context2.next = 7;
                    return this._request.post(r, n, d.API_V2);

                  case 7:
                    s = _context2.sent;
                    return _context2.abrupt("return", (this._log.info("Completed transfer to Worker/TaskQueue=".concat(e)), this.transfers._updateOutgoing(s, !0), this));

                  case 9:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2, this);
          }));

          function transfer(_x) {
            return _transfer.apply(this, arguments);
          }

          return transfer;
        }()
      }, {
        key: "wrapUp",
        value: function wrapUp() {
          var _this14 = this;

          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          var t = this._worker.getRoutes().getRoute(u.h, this.sid).path,
              r = {
            AssignmentStatus: d.TASK_STATUS_WRAPPING
          };

          if (e.reason) {
            if (!i.a.isString(e.reason)) throw new Error("Failed to call wrapUp() on Task sid=".concat(this.sid, ". A <string>reason is required."));
            r.Reason = e.reason;
          }

          return this._request.post(t, r, d.API_V1).then(function (e) {
            return _this14._update(e);
          });
        }
      }, {
        key: "setAttributes",
        value: function setAttributes(e) {
          var _this15 = this;

          if (!i.a.isObject(e)) throw new TypeError("Unable to set attributes on Task. <object>attributes is a required parameter.");

          var t = this._worker.getRoutes().getRoute(u.h, this.sid).path,
              r = {
            Attributes: e
          };

          return this._request.post(t, r, d.API_V1).then(function (e) {
            return _this15._update(e);
          });
        }
      }, {
        key: "updateParticipant",
        value: function updateParticipant(e) {
          var _this16 = this;

          var t = {
            hold: function hold(e) {
              return i.a.isBoolean(e);
            }
          };
          if (!Object(l.validateOptions)(e, t)) throw new TypeError("Failed to update Worker Participant tied to Task sid=".concat(this.sid, ". The options passed in did not match the required types."));

          var r = this._worker.getRoutes().getRoute(u.b).path,
              n = {
            TaskSid: this.sid
          };

          for (var _t6 in e) {
            n[i.a.upperFirst(_t6)] = e[_t6];
          }

          return this._request.post(r, n, d.API_V2).then(function (e) {
            return _this16._update(e);
          });
        }
      }, {
        key: "kick",
        value: function kick(e) {
          var _this17 = this;

          if (!i.a.isString(e)) throw new TypeError("Error calling method kick(). <string>workerSid is a required parameter.");

          var t = this._worker.getRoutes().getRoute(u.d).path,
              r = {
            TaskSid: this.sid,
            TargetWorkerSid: e
          };

          return this._request.post(t, r, d.API_V2).then(function (e) {
            return _this17._update(e);
          });
        }
      }, {
        key: "hold",
        value: function hold(e, t) {
          var _this18 = this;

          if (!i.a.isString(e)) throw new TypeError("Error calling method hold(). <string>targetWorkerSid is a required parameter.");
          if (!i.a.isBoolean(t)) throw new TypeError("Error calling method hold(). <boolean>onHold is a required parameter that is either true or false.");

          var r = this._worker.getRoutes().getRoute(u.c).path,
              n = {
            TaskSid: this.sid,
            TargetWorkerSid: e,
            Hold: t
          };

          return this._request.post(r, n, d.API_V2).then(function (e) {
            return _this18._update(e);
          });
        }
      }, {
        key: "_emitEvent",
        value: function _emitEvent(e, t) {
          if (this._log.trace("_emitEvent(".concat(e, ", ").concat(JSON.stringify(t), ")")), !i.a.isString(e)) throw new TypeError("Error calling _emitEvent(). <string>eventType is a required parameter.");
          if (!i.a.isObject(t)) throw new TypeError("Error calling method _emitEvent(). <object>payload is a required parameter.");
          this.emit(e, this);
        }
      }, {
        key: "_emitEventForOutgoingTransfer",
        value: function _emitEventForOutgoingTransfer(e, t) {
          if (this._log.trace("_emitEventForOutgoingTransfer(".concat(e, ", ").concat(JSON.stringify(t), ")")), !i.a.isString(e)) throw new TypeError("Error calling _emitEventForOutgoingTransfer(). <string>eventType is a required parameter.");
          if (!i.a.isObject(t)) throw new TypeError("Error calling method _emitEventForOutgoingTransfer(). <object>payload is a required parameter.");
          this.transfers.outgoing && this.transfers.outgoing.sid === t.sid ? Object.keys(i.a.pick(d.taskTransferEventTypes, [d.TRANSFER_INITIATED])).indexOf(e) > -1 ? (this.transfers._updateOutgoing(t), this.emit(d.taskTransferEventTypes[d.TRANSFER_INITIATED], this.transfers.outgoing)) : this.transfers._emitEvent(e, t) : this._log.debug("The transfers.outgoing object is either not present or does not match the transfer sid in the event. ".concat(JSON.stringify(t)));
        }
      }, {
        key: "_update",
        value: function _update(e) {
          var _this19 = this;

          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

          try {
            var _r6 = new N(e, this._config);

            C.forEach(function (e) {
              "transfers" === e ? (t.incoming || t.outgoing) && _this19.transfers._update(t) : _this19[e] = _r6[e];
            });
          } catch (t) {
            throw this._log.error("Failed to update Task sid=".concat(e.sid, ". Update aborted."), t), new Error("Failed to update Task sid=".concat(e.sid, ". Update aborted. Error: ").concat(t, "."));
          }

          return this;
        }
      }]);

      return P;
    }(a.EventEmitter);

    var N = function N(e) {
      _classCallCheck(this, N);

      if (!i.a.isObject(e)) throw new TypeError("Failed to instantiate TaskDescriptor. <Descriptor>descriptor is required.");
      if (!B.every(function (t) {
        return t in e;
      })) throw new TypeError("Failed to instantiate TaskDescriptor. <Descriptor>descriptor does not contain all properties of a Task.");
      this.addOns = JSON.parse(e.addons), this.age = e.age, this.attributes = JSON.parse(e.attributes), this.dateCreated = Object(l.parseTime)(1e3 * e.date_created), this.dateUpdated = Object(l.parseTime)(1e3 * e.date_updated), this.priority = e.priority, this.queueName = e.queue_name, this.queueSid = e.queue_sid, this.reason = e.reason, this.routingTarget = e.routing_target, this.sid = e.sid, this.status = e.assignment_status, this.taskChannelUniqueName = e.task_channel_unique_name, this.taskChannelSid = e.task_channel_sid, this.timeout = e.timeout, this.workflowName = e.workflow_name, this.workflowSid = e.workflow_sid, this.incomingTransferDescriptor = null, this.outgoingTransferDescriptor = null;
    };

    var L = function L(e, t) {
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

      _classCallCheck(this, L);

      if (!i.a.isObject(e)) throw new TypeError("Failed to instantiate ReservationDescriptor. <Descriptor>descriptor is required.");
      if (!i.a.isObject(t)) throw new TypeError("Failed to instantiate ReservationDescriptor. <Worker>worker is required.");
      var n = i.a.filter(q, function (e) {
        return -1 === r.indexOf(e);
      });

      if (!i.a.every(n, function (t) {
        return t in e;
      })) {
        var _t7 = i.a.difference(n, Object.keys(e)).join(", ");

        throw new TypeError("Failed to instantiate ReservationDescriptor. <Descriptor>descriptor does not contain all properties of a Reservation. Missing: ".concat(_t7));
      }

      this.accountSid = e.account_sid, this.dateCreated = Object(l.parseTime)(1e3 * e.date_created), this.dateUpdated = Object(l.parseTime)(1e3 * e.date_updated), this.sid = e.sid, this.status = e.reservation_status, this.timeout = e.reservation_timeout, this.workerSid = e.worker_sid, this.workspaceSid = e.workspace_sid, this.taskDescriptor = null, e.canceled_reason_code && (this.canceledReasonCode = e.canceled_reason_code);
      var s = t.getLogger("ReservationDescriptor-".concat(this.sid));
      if (-1 === r.indexOf("task")) try {
        this.taskDescriptor = new N(e.task);
      } catch (e) {
        throw s.error("Failed to create a ReservationDescriptor. The 'task' property is malformed."), e;
      }
      if (-1 === r.indexOf(d.transferFields.taskTransfer) && "object" == typeof e.task_transfer) try {
        this.taskDescriptor.incomingTransferDescriptor = new A(e.task_transfer), this.transferDescriptor = new A(e.task_transfer);
      } catch (e) {
        throw s.error("Failed to create a ReservationDescriptor. The 'task_transfer' property is malformed."), e;
      }
      if (-1 === r.indexOf(d.transferFields.activeOutgoingTaskTransfer) && "object" == typeof e.active_outgoing_task_transfer) try {
        this.taskDescriptor.outgoingTransferDescriptor = new A(e.active_outgoing_task_transfer);
      } catch (e) {
        throw s.error("Failed to create a ReservationDescriptor. The 'active_outgoing_task_transfer' property is malformed."), e;
      }
    };

    var j = r(5).validateOptions,
        U = ["dateUpdated", "canceledReasonCode", "status", "timeout", "task", "task_transfer"],
        D = ["reservation_timeout", "task", "canceled_reason_code"];
    var q = ["account_sid", "date_created", "date_updated", "reservation_status", "sid", "task", "reservation_timeout", "worker_sid", "workspace_sid"];

    var z =
    /*#__PURE__*/
    function (_a$EventEmitter5) {
      _inherits(z, _a$EventEmitter5);

      function z(e, t, r) {
        var _this20;

        _classCallCheck(this, z);

        if (_this20 = _possibleConstructorReturn(this, _getPrototypeOf(z).call(this)), !(e instanceof V)) throw new TypeError("Failed to instantiate Reservation. <Worker>worker is a required parameter.");
        if (!(r instanceof L)) throw new TypeError("Failed to instantiate Reservation. <ReservationDescriptor>descriptor is a required parameter.");
        _this20._worker = e, _this20._log = e.getLogger("Reservation-".concat(r.sid)), _this20._request = t, _this20.task = _this20._createTask(r), r.transferDescriptor && (_this20.transfer = _this20._createTransfer(r)), Object.assign(_assertThisInitialized(_this20), r), delete _this20.taskDescriptor, delete _this20.transferDescriptor;
        return _possibleConstructorReturn(_this20);
      }

      _createClass(z, [{
        key: "accept",
        value: function accept() {
          var _this21 = this;

          var e = this._worker.getRoutes().getRoute(u.e, this.sid).path,
              t = {
            ReservationStatus: d.RESERVATION_STATUS_ACCEPTED
          };

          return this._request.post(e, t, d.API_V1).then(function (e) {
            return _this21._update(e, D);
          });
        }
      }, {
        key: "complete",
        value: function complete() {
          var _this22 = this;

          var e = this._worker.getRoutes().getRoute(u.e, this.sid).path,
              t = {
            ReservationStatus: d.RESERVATION_STATUS_COMPLETED
          };

          return this._request.post(e, t, d.API_V1).then(function (e) {
            return _this22._update(e, D);
          });
        }
      }, {
        key: "reject",
        value: function reject() {
          var _this23 = this;

          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          var t = this._worker.getRoutes().getRoute(u.e, this.sid).path,
              r = {
            ReservationStatus: d.RESERVATION_STATUS_REJECTED
          };

          if (!j(e, {
            activitySid: function activitySid(e) {
              return i.a.isString(e);
            }
          })) throw new TypeError("Failed to issue Instruction:reject on Reservation sid=".concat(this.sid, ". The options passed in did not match the required types."));

          for (var _t8 in e) {
            r[d.RESERVATION_REJECT_OPTIONS[_t8]] = e[_t8];
          }

          return this._request.post(t, r, d.API_V1).then(function (e) {
            return _this23._update(e, D);
          });
        }
      }, {
        key: "wrap",
        value: function wrap() {
          var _this24 = this;

          var e = this._worker.getRoutes().getRoute(u.e, this.sid).path,
              t = {
            ReservationStatus: d.RESERVATION_STATUS_WRAPPING
          };

          return this._request.post(e, t, d.API_V1).then(function (e) {
            return _this24._update(e, D);
          });
        }
      }, {
        key: "call",
        value: function call(e, t) {
          var _this25 = this;

          var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          if (!i.a.isString(e)) throw new TypeError("Error calling method call(). <string>from is a required parameter.");
          if (!i.a.isString(t)) throw new TypeError("Error calling method call(). <string>url is a required parameter.");

          var n = this._worker.getRoutes().getRoute(u.e, this.sid).path,
              s = {
            Instruction: d.RESERVATION_INSTRUCTION_CALL,
            CallFrom: e,
            CallUrl: t
          };

          if (!j(r, {
            accept: function accept(e) {
              return i.a.isBoolean(e);
            },
            record: function record(e) {
              return i.a.isString(e);
            },
            statusCallbackUrl: function statusCallbackUrl(e) {
              return i.a.isString(e);
            },
            timeout: function timeout(e) {
              return i.a.isInteger(e);
            },
            to: function to(e) {
              return i.a.isString(e);
            }
          })) throw new TypeError("Failed to issue Instruction:call on Reservation sid=".concat(this.sid, ". The options passed in did not match the required types."));

          for (var _e3 in r) {
            s[d.RESERVATION_CALL_OPTIONS[_e3]] = r[_e3];
          }

          return this._request.post(n, s, d.API_V1).then(function (e) {
            return _this25._update(e, D);
          });
        }
      }, {
        key: "dequeue",
        value: function dequeue() {
          var _this26 = this;

          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          var t = this._worker.getRoutes().getRoute(u.e, this.sid).path,
              r = {
            Instruction: d.RESERVATION_INSTRUCTION_DEQUEUE
          };

          if (!j(e, {
            from: function from(e) {
              return i.a.isString(e);
            },
            to: function to(e) {
              return i.a.isString(e);
            },
            postWorkActivitySid: function postWorkActivitySid(e) {
              return i.a.isString(e);
            },
            record: function record(e) {
              return i.a.isString(e);
            },
            timeout: function timeout(e) {
              return i.a.isInteger(e);
            },
            statusCallbackUrl: function statusCallbackUrl(e) {
              return i.a.isString(e);
            },
            statusCallbackEvents: function statusCallbackEvents(e) {
              return i.a.isString(e);
            }
          })) throw new TypeError("Failed to issue Instruction:dequeue on Reservation sid=".concat(this.sid, ". The options passed in did not match the required types."));

          for (var _t9 in e) {
            r[d.RESERVATION_DEQUEUE_OPTIONS[_t9]] = e[_t9];
          }

          return this._request.post(t, r, d.API_V1).then(function (e) {
            return _this26._update(e, D);
          });
        }
      }, {
        key: "redirect",
        value: function redirect(e, t) {
          var _this27 = this;

          var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          if (!i.a.isString(e)) throw new TypeError("Error calling method redirect(). <string>callSid is a required parameter.");
          if (!i.a.isString(t)) throw new TypeError("Error calling method redirect(). <string>url is a required parameter.");

          var n = this._worker.getRoutes().getRoute(u.e, this.sid).path,
              s = {
            accept: function accept(e) {
              return i.a.isBoolean(e);
            }
          },
              o = {
            Instruction: d.RESERVATION_INSTRUCTION_REDIRECT,
            RedirectCallSid: e,
            RedirectUrl: t
          };

          if (!j(r, s)) throw new TypeError("Failed to issue Instruction:redirect on Reservation sid=".concat(this.sid, ". The options passed in did not match the required types."));

          for (var _e4 in r) {
            o[d.RESERVATION_REDIRECT_OPTIONS[_e4]] = r[_e4];
          }

          return this._request.post(n, o, d.API_V1).then(function (e) {
            return _this27._update(e, D);
          });
        }
      }, {
        key: "conference",
        value: function conference() {
          var _this28 = this;

          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          if (!j(e, {
            to: function to(e) {
              return i.a.isString(e);
            },
            from: function from(e) {
              return i.a.isString(e);
            },
            timeout: function timeout(e) {
              return i.a.isInteger(e);
            },
            statusCallback: function statusCallback(e) {
              return i.a.isString(e);
            },
            statusCallbackMethod: function statusCallbackMethod(e) {
              return i.a.isString(e);
            },
            statusCallbackEvent: function statusCallbackEvent(e) {
              return i.a.isString(e);
            },
            record: function record(e) {
              return i.a.isString(e);
            },
            muted: function muted(e) {
              return i.a.isBoolean(e);
            },
            beep: function beep(e) {
              return i.a.isBoolean(e) || i.a.isString(e);
            },
            startConferenceOnEnter: function startConferenceOnEnter(e) {
              return i.a.isBoolean(e);
            },
            endConferenceOnExit: function endConferenceOnExit(e) {
              return i.a.isBoolean(e);
            },
            endConferenceOnCustomerExit: function endConferenceOnCustomerExit(e) {
              return i.a.isBoolean(e);
            },
            waitUrl: function waitUrl(e) {
              return i.a.isString(e);
            },
            waitMethod: function waitMethod(e) {
              return i.a.isString(e);
            },
            earlyMedia: function earlyMedia(e) {
              return i.a.isBoolean(e);
            },
            maxParticipants: function maxParticipants(e) {
              return i.a.isInteger(e);
            },
            conferenceStatusCallback: function conferenceStatusCallback(e) {
              return i.a.isString(e);
            },
            conferenceStatusCallbackMethod: function conferenceStatusCallbackMethod(e) {
              return i.a.isString(e);
            },
            conferenceStatusCallbackEvent: function conferenceStatusCallbackEvent(e) {
              return i.a.isString(e);
            },
            conferenceRecord: function conferenceRecord(e) {
              return i.a.isBoolean(e) || i.a.isString(e);
            },
            conferenceTrim: function conferenceTrim(e) {
              return i.a.isString(e);
            },
            recordingChannels: function recordingChannels(e) {
              return i.a.isString(e);
            },
            recordingStatusCallback: function recordingStatusCallback(e) {
              return i.a.isString(e);
            },
            recordingStatusCallbackMethod: function recordingStatusCallbackMethod(e) {
              return i.a.isString(e);
            },
            conferenceRecordingStatusCallback: function conferenceRecordingStatusCallback(e) {
              return i.a.isString(e);
            },
            conferenceRecordingStatusCallbackMethod: function conferenceRecordingStatusCallbackMethod(e) {
              return i.a.isString(e);
            },
            region: function region(e) {
              return i.a.isString(e);
            },
            sipAuthUsername: function sipAuthUsername(e) {
              return i.a.isString(e);
            },
            sipAuthPassword: function sipAuthPassword(e) {
              return i.a.isString(e);
            }
          })) throw new TypeError("Failed to issue Instruction:conference on Reservation sid=".concat(this.sid, ". The options passed in did not match the required types."));

          var t = this._worker.getRoutes().getRoute(u.e, this.sid).path,
              r = {
            Instruction: d.RESERVATION_INSTRUCTION_CONFERENCE
          };

          for (var _t10 in e) {
            r[i.a.upperFirst(_t10)] = e[_t10];
          }

          return this._request.post(t, r, d.API_V1).then(function () {
            return _this28;
          });
        }
      }, {
        key: "updateParticipant",
        value: function updateParticipant(e) {
          var _this29 = this;

          if (!j(e, {
            endConferenceOnExit: function endConferenceOnExit(e) {
              return i.a.isBoolean(e);
            },
            mute: function mute(e) {
              return i.a.isBoolean(e);
            },
            beepOnExit: function beepOnExit(e) {
              return i.a.isBoolean(e);
            }
          })) throw new TypeError("Failed to update Worker Participant tied to Reservation sid=".concat(this.sid, ". The options passed in did not match the required types."));

          var t = this._worker.getRoutes().getRoute(u.p).path,
              r = {
            ReservationSid: this.sid
          };

          for (var _t11 in e) {
            r[i.a.upperFirst(_t11)] = e[_t11];
          }

          return this._request.post(t, r, d.API_V2).then(function () {
            return _this29;
          });
        }
      }, {
        key: "_createTask",
        value: function _createTask(e) {
          if (!(e instanceof L)) return this._log.error("Error calling method _createTask() for Reservation                              sid=".concat(this.sid, ". <ReservationDescriptor>reservationDescriptor                              is a required parameter.")), {};
          var t = e.taskDescriptor;

          try {
            return new P(this._worker, this._request, e.sid, t);
          } catch (e) {
            return this._log.error("Failed to create a Task for Reservation sid=".concat(this.sid, ". Error: ").concat(e)), {};
          }
        }
      }, {
        key: "_createTransfer",
        value: function _createTransfer(e) {
          if (!(e instanceof L)) return this._log.error("Error calling method _createTransfer() for Reservation                              sid=".concat(this.sid, ". <ReservationDescriptor>reservationDescriptor                              is a required parameter.")), {};
          var t = e.transferDescriptor;

          try {
            return new M(this._worker, t);
          } catch (e) {
            return this._log.error("Failed to create a Transfer for Reservation sid=".concat(this.sid, ". Error: ").concat(e)), {};
          }
        }
      }, {
        key: "_update",
        value: function _update(e) {
          var _this30 = this;

          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

          try {
            var _r7 = new L(e, this._worker, t);

            U.forEach(function (n) {
              if ("task" === n) {
                if (-1 === t.indexOf("task")) {
                  var _t12 = e.task_transfer,
                      _r8 = e.active_outgoing_task_transfer;

                  _this30.task._update(e.task, {
                    incoming: _t12,
                    outgoing: _r8
                  });
                }
              } else "canceledReasonCode" === n ? -1 === t.indexOf("canceled_reason_code") && e.canceled_reason_code && (_this30[n] = _r7[n]) : "task_transfer" === n && e.task_transfer ? _this30.transfer._update(e.task_transfer) : _this30[n] = _r7[n];
            });
          } catch (t) {
            throw this._log.error("Failed to update Reservation sid=".concat(e.sid, ". Update aborted. Error: ").concat(t, ".")), t;
          }

          return this;
        }
      }, {
        key: "_emitEvent",
        value: function _emitEvent(e, t) {
          if (!i.a.isString(e)) throw new TypeError("Error calling _emitEvent(). <string>eventType is a required parameter.");
          if (!i.a.isObject(t)) throw new TypeError("Error calling method _emitEvent(). <object>rawEventData is a required parameter.");
          this._update(t), this.emit(e, this);
        }
      }]);

      return z;
    }(a.EventEmitter);

    var F =
    /*#__PURE__*/
    function (_a$EventEmitter6) {
      _inherits(F, _a$EventEmitter6);

      function F(e, t) {
        var _this31;

        var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        _classCallCheck(this, F);

        if (_this31 = _possibleConstructorReturn(this, _getPrototypeOf(F).call(this)), !(e instanceof V)) throw new TypeError("Failed to initialize ReservationsEntity. <Worker>worker is a required parameter.");
        _this31._worker = e, _this31._log = e.getLogger("ReservationsEntity"), _this31._request = t, _this31._reservations = new Map(), _this31._reservationSidsByTask = new Map(), _this31._pageSize = r.pageSize || d.DEFAULT_PAGE_SIZE, i.a.inRange(_this31._pageSize, 1, d.DEFAULT_PAGE_SIZE + 1) || (_this31._log.warn("PageSize range for ReservationsEntity must be between 1 and %d. Setting pageSize to default size=%d", d.DEFAULT_PAGE_SIZE, d.DEFAULT_PAGE_SIZE), _this31._pageSize = 1e3);
        return _possibleConstructorReturn(_this31);
      }

      _createClass(F, [{
        key: "fetchReservations",
        value: function fetchReservations() {
          var e = this._getPage();

          return this._reservations.clear(), this._getAllReservations(e);
        }
      }, {
        key: "_getAllReservations",
        value: function _getAllReservations(e) {
          var _this32 = this;

          return e.then(function (e) {
            e.items.forEach(function (e) {
              _this32._insertReservation(e);
            }), e.hasNextPage && _this32._getAllReservations(e.nextPage());
          });
        }
      }, {
        key: "_getPage",
        value: function _getPage(e) {
          var _this33 = this;

          e = e || {};

          var t = this._worker.getRoutes().getRoute(u.f).path,
              r = {
            Active: "true",
            PageSize: this._pageSize
          };

          return e.AfterSid && (r.AfterSid = e.AfterSid), this._request.get(t, d.API_V2, r).then(function (e) {
            return new v.default(e.contents.map(function (e) {
              return new L(e, _this33._worker);
            }), function (e) {
              return _this33._getPage({
                AfterSid: e
              });
            }, e.after_sid);
          });
        }
      }, {
        key: "_insertReservation",
        value: function _insertReservation(e) {
          var t = e.sid;
          this._log.trace("_insertReservation(sid=%s, data=%s)", t, JSON.stringify(e)), this._reservations.has(t) && this._log.debug("Reservation %s already exists for Worker %s. Attempting to overwrite it.", t, this._worker.sid);

          try {
            var _r9 = new z(this._worker, this._request, e);

            return this._reservations.set(t, [_r9, !1]), this._reservationSidsByTask.has(_r9.task.sid) ? this._reservationSidsByTask.get(_r9.task.sid).add(_r9.sid) : this._reservationSidsByTask.set(_r9.task.sid, new Set([_r9.sid])), this._log.debug("Successfully created and inserted %s for %s to Task-Reservation lookup. Contents: %s", _r9.sid, _r9.task.sid, this._reservationSidsByTask.get(_r9.task.sid)), _r9;
          } catch (e) {
            throw this._log.error("Unable to create a Reservation for sid=%s. Skipping insert into Reservations map. Error: %s", t, e), e;
          }
        }
      }, {
        key: "insert",
        value: function insert(e) {
          this._log.trace("_insertReservation(sid=%s, data=%s)", e.sid, JSON.stringify(e));

          var t = new L(e, this._worker);
          return this._insertReservation(t);
        }
      }, {
        key: "getTasks",
        value: function getTasks(e) {
          var _this34 = this;

          if (!this._reservationSidsByTask.has(e)) return null;
          var t = [];
          return this._reservationSidsByTask.get(e).forEach(function (e) {
            var r = _this34._reservations.get(e);

            r && r[0].task && t.push(r[0].task);
          }), t;
        }
      }, {
        key: "_deleteByReservationSid",
        value: function _deleteByReservationSid(e) {
          this._log.trace("_deleteByReservationSid(sid=%s)", e);

          var t = this.reservations.get(e);
          t ? (this._log.info("Found Reservation sid=%s for Worker %s. Removing reservation and task.", e, this._worker.sid), this._cleanUpReservationAndTask(t)) : this._log.info("Reservation with sid=%s not found. Unable to remove Reservation.", e);
        }
      }, {
        key: "_cleanUpReservationAndTask",
        value: function _cleanUpReservationAndTask(e) {
          var _this35 = this;

          this._log.debug("Soft deleting Reservation sid=%s for Worker %s", e.sid, this._worker.sid), this._reservations.set(e.sid, [e, !0]), setTimeout(function () {
            _this35._log.debug("Hard deleting of Reservation sid=%s for Worker %s", e.sid, _this35._worker.sid), _this35._reservations.delete(e.sid) || _this35._log.warn("Failed to hard delete Reservation sid=%s for Worker %s", e.sid, _this35._worker.sid);
          }, 5e3);
        }
      }, {
        key: "reservations",
        get: function get() {
          return new Map(Array.from(this._reservations).filter(function (e) {
            return !e[1][1];
          }).map(function (e) {
            return [e[0], e[1][0]];
          }));
        }
      }]);

      return F;
    }(a.EventEmitter);

    r.d(t, "a", function () {
      return Z;
    });
    var W = ["dateUpdated", "dateStatusChanged", "attributes", "name", "available"];
    var Z = ["account_sid", "activity_name", "activity_sid", "attributes", "available", "date_created", "date_status_changed", "date_updated", "friendly_name", "sid", "workspace_sid"];

    var V = t.b =
    /*#__PURE__*/
    function (_a$EventEmitter7) {
      _inherits(_class, _a$EventEmitter7);

      function _class(e) {
        var _this36;

        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
          Request: c.a,
          EventBridgeSignaling: o.a
        };

        _classCallCheck(this, _class);

        if (_this36 = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this)), !i.a.isString(e)) throw new TypeError("Failed to instantiate Worker. <string>token is a required parameter.");
        var n = {
          connectActivitySid: function connectActivitySid(e) {
            return i.a.isString(e);
          },
          closeExistingSessions: function closeExistingSessions(e) {
            return i.a.isBoolean(e);
          },
          logLevel: function logLevel(e) {
            return i.a.isString(e);
          },
          ebServer: function ebServer(e) {
            return i.a.isString(e);
          },
          wsServer: function wsServer(e) {
            return i.a.isString(e);
          },
          region: function region(e) {
            return i.a.isString(e);
          }
        };
        Object(l.validateOptions)(t, n), _this36._connectActivitySid = t.connectActivitySid, _this36._closeExistingSessions = t.closeExistingSessions, _this36._logLevel = t.logLevel || "error", _this36._config = new s.a(e, t), _this36._log = new f.a("Worker-".concat(_this36._config.getLogIdentifier()), _this36._logLevel), _this36._request = new r.Request(_this36._config), _this36._dataServices = {
          activitiesEntity: new m(_assertThisInitialized(_this36), _this36._request),
          channelsEntity: new E(_assertThisInitialized(_this36), _this36._request),
          reservationsEntity: new F(_assertThisInitialized(_this36), _this36._request)
        }, _this36._signaling = new r.EventBridgeSignaling(_assertThisInitialized(_this36), {
          closeExistingSessions: t.closeExistingSessions
        }), _this36._subscribeToSignalingEvents();
        return _possibleConstructorReturn(_this36);
      }

      _createClass(_class, [{
        key: "createTask",
        value: function createTask(e, t, r, n) {
          var s = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
          if (!i.a.isString(e)) throw new TypeError("Error calling method createTask(). <string>to is a required parameter.");
          if (!i.a.isString(t)) throw new TypeError("Error calling method createTask(). <string>from is a required parameter.");
          if (!i.a.isString(r)) throw new TypeError("Error calling method createTask(). <string>workflowSid is a required parameter.");
          if (!i.a.isString(n)) throw new TypeError("Error calling method createTask(). <string>taskQueueSid is a required parameter.");
          var o = {
            attributes: function attributes(e) {
              return i.a.isObject(e);
            },
            taskChannelUniqueName: function taskChannelUniqueName(e) {
              return i.a.isString(e);
            },
            taskChannelSid: function taskChannelSid(e) {
              return i.a.isString(e);
            }
          };
          if (!Object(l.validateOptions)(s, o)) throw new TypeError("Failed to create a Task for Worker ".concat(this.sid, ". The options passed in did not match the required types."));
          var a = this.getRoutes().getRoute(u.i).path,
              f = {
            WorkflowSid: r,
            TaskQueueSid: n,
            RoutingTarget: this.sid
          };

          for (var _e5 in s) {
            "attributes" === _e5 || (f[d.CREATE_TASK_OPTIONS[_e5]] = s[_e5]);
          }

          var c = {
            outbound_to: e,
            from: t
          };
          return f.Attributes = Object.assign({}, s.attributes, c), this._request.post(a, f, d.API_V1).then(function (e) {
            return e.sid;
          });
        }
      }, {
        key: "getLogger",
        value: function getLogger(e) {
          return new f.a("".concat(e, "-").concat(this.sid), this._config._logLevel);
        }
      }, {
        key: "setAttributes",
        value: function setAttributes(e) {
          var _this37 = this;

          if (!i.a.isObject(e)) throw new TypeError("Unable to set attributes on Worker. <object>attributes is a required parameter.");
          var t = this.getRoutes().getRoute(u.n).path,
              r = {
            Attributes: e
          };
          return this._request.post(t, r, d.API_V1).then(function (e) {
            return _this37._update(e);
          });
        }
      }, {
        key: "updateToken",
        value: function updateToken(e) {
          if (!i.a.isString(e)) throw new TypeError("To update the Twilio token, a new Twilio token must be passed in. <string>newToken is a required parameter.");
          this._log.info("Proceeding to update the Worker's current active token with a new token."), this._log.debug("New token: " + e);

          try {
            this._config.updateToken(e), this._signaling.updateToken(e), this.emit("tokenUpdated");
          } catch (e) {
            this.emit("error", e);
          }
        }
      }, {
        key: "_subscribeToSignalingEvents",
        value: function _subscribeToSignalingEvents() {
          var _this38 = this;

          this._log.info("Subscribing to Signaling events .... "), this._signaling.on("connected", function () {
            _this38._log.info("Received Event: 'connected' from Signaling layer. Pending initialization.", _this38.sid);
          }), this._signaling.on("disconnected", function () {
            _this38._log.info("Received Event: 'disconnected' from Signaling layer for Worker %s.", _this38.sid), _this38.emit("disconnected");
          }), this._signaling.on("init", function (e) {
            _this38._log.info("Received Event: 'init' from Signaling layer. Proceeding to initialize Worker %s.", e.channel_id), _this38.sid = e.channel_id, _this38.accountSid = e.account_sid, _this38.workspaceSid = e.workspace_sid, _this38._signaling.setLifetime(e.token_lifetime), _this38._initialize();
          }), this._signaling.on("error", function (e) {
            _this38._log.info("Received Event: 'error' from Signaling layer for Worker %s.", _this38.sid), _this38.emit("error", e);
          }), this._signaling.on("tokenExpired", function () {
            _this38._log.info("Received Event: 'tokenExpired' for for Worker %s. Please update the token. Websocket will not reconnect automatically until token is updated.", _this38.sid), _this38.emit("tokenExpired");
          });
        }
      }, {
        key: "_subscribeToTaskRouterEvents",
        value: function _subscribeToTaskRouterEvents() {
          var _this39 = this;

          this._log.info("Subscribing to TaskRouter events ... "), this._signaling.on("worker.activity.update", function (e) {
            if (_this39._log.info("Worker %s received Event: worker.activity.update. Proceeding to update ...", _this39.sid), !e.activity_sid) throw _this39._log.error("Event: worker.activity.update did not contain an activity_sid. Unable to update Worker %s.", _this39.sid), new Error("Failed to update Worker ".concat(_this39.sid, " activity."));
            {
              var _t13 = _this39.activities.get(e.activity_sid);

              if (!_t13) throw _this39._log.error("The Activity sid=%s specified in Event: worker.activity.update does not exist in the Worker's map of Activities. Unable to update Worker %s activity.", e.activity_sid, _this39.sid), new Error("Failed to update Worker ".concat(_this39.sid, " activity."));
              _this39.activity._isCurrent = !1, _this39.activity = _t13, _t13._isCurrent = !0, _this39.emit("activityUpdated", _this39._update(e));
            }
          }), this._signaling.on("worker.attributes.update", function (e) {
            _this39._log.info("Worker ".concat(_this39.sid, " received Event: worker.attributes.update. Proceeding to update ...")), _this39.emit("attributesUpdated", _this39._update(e));
          }), this._signaling.on("worker.capacity.update", function (e) {
            if (_this39._log.info("Worker ".concat(_this39.sid, " received Event: worker.capacity.update.")), !e.sid) throw _this39._log.error("Event: worker.capacity.update did not contain a Channel sid. Unable to update Channel for Worker %s.", _this39.sid), new Error("Failed to update Worker ".concat(_this39.sid, " channel."));
            {
              var _t14 = _this39.channels.get(e.sid);

              if (!_t14) throw _this39._log.error("The Channel sid=%s specified in Event: worker.capacity.update does not  exist in the Worker's map of Channels. Unable to update Worker %s channel.", e.sid, _this39.sid), new Error("Failed to update Worker ".concat(_this39.sid, " channel."));

              _t14._emitEvent("capacityUpdated", e);
            }
          }), this._signaling.on("worker.channel.availability.update", function (e) {
            if (_this39._log.info("Worker %s received Event: worker.channel.availability.update.", _this39.sid), !e.sid) throw _this39._log.error("Event: worker.capacity.update did not contain a Channel sid. Unable to update Channel for Worker %s.", _this39.sid), new Error("Failed to update Worker ".concat(_this39.sid, " channel."));
            {
              var _t15 = _this39.channels.get(e.sid);

              if (!_t15) throw _this39._log.error("The Channel sid=%s specified in Event: worker.channel.availability.update does not  exist in the Worker's map of Channels. Unable to update Worker %s channel.", e.sid, _this39.sid), new Error("Failed to update Worker ".concat(_this39.sid, " channel."));

              _t15._emitEvent("availabilityUpdated", e);
            }
          }), this._signaling.on("reservation.created", function (e) {
            if (_this39._log.info("Worker %s received Event: reservation.created.", _this39.sid), !e.sid) throw _this39._log.error("Event: reservationCreated did not contain a Reservation sid. Unable to create a Reservation for Worker %s.", _this39.sid), new Error("Failed to create Reservation for Worker ".concat(_this39.sid, "."));

            try {
              _this39._log.info("Attempting to create and insert Reservation into Worker %s reservations map.", _this39.sid);

              var _t16 = _this39._dataServices.reservationsEntity.insert(e);

              _this39.emit("reservationCreated", _t16);
            } catch (e) {
              throw _this39._log.info("Failed to create and insert Reservation into Worker %s reservations map.", _this39.sid), new Error("Failed to create a Reservation for Worker ".concat(_this39.sid, " on Event: reservationCreated. Error: ").concat(e));
            }
          }), this._signaling.on("reservation.failed", function (e) {
            _this39._log.info("Worker %s received Event: reservation.failed.", _this39.sid), _this39.emit("reservationFailed", e);
          }), Object.keys(i.a.pick(d.reservationEventTypes, ["accepted", "wrapup"])).forEach(function (e) {
            _this39._signaling.on("reservation.".concat(e), function (t) {
              if (_this39._log.info("Worker %s received Event: reservation.".concat(e, "."), _this39.sid), !t.sid) throw _this39._log.error("Event: reservation.".concat(e, " did not contain a Reservation sid. Unable to update Reservation for Worker ").concat(_this39.sid)), new Error("Failed to update Reservation for Worker ".concat(_this39.sid, "."));
              {
                var _r10 = _this39.reservations.get(t.sid);

                if (!_r10) throw _this39._log.error("The Resevation sid=".concat(t.sid, " specified in Event: reservation.").concat(e, " does not                                         exist in the Worker's map of Reservations. Unable to update Worker ").concat(_this39.sid, " reservation.")), new Error("Failed to update Worker ".concat(_this39.sid, " reservation."));

                _r10._emitEvent(e, t);
              }
            });
          }), Object.keys(i.a.pick(d.reservationEventTypes, ["completed", "rejected", "timeout", "canceled", "rescinded"])).forEach(function (e) {
            _this39._signaling.on("reservation.".concat(e), function (t) {
              if (_this39._log.info("Worker %s received Event: reservation.%s.", _this39.sid, e), !t.sid) throw _this39._log.error("Event: reservation.%s did not contain a Reservation sid. Unable to update Reservation for Worker %s.", e, _this39.sid), new Error("Failed to update Reservation for Worker ".concat(_this39.sid, "."));
              {
                var _r11 = _this39.reservations.get(t.sid);

                _r11 ? (_this39._dataServices.reservationsEntity._deleteByReservationSid(t.sid), _r11._emitEvent(e, t)) : _this39._log.warn("The reservation specified by Event: reservation.%s does not exist in Worker %s Reservations map. Skipping event.", e, _this39.sid);
              }
            });
          }), Object.keys(d.taskEventTypes).forEach(function (e) {
            _this39._signaling.on("task.".concat(e), function (t) {
              if (_this39._log.info("Worker %s received Event: task.%s.", _this39.sid, e), !t.sid) throw _this39._log.error("Event: task.%s did not contain a Task sid. Unable to emit event for Worker %s.", e, _this39.sid), new Error("Failed to emit event for Worker ".concat(_this39.sid, "."));
              {
                var _r12 = _this39._dataServices.reservationsEntity.getTasks(t.sid);

                _r12 && _r12.length > 0 ? _r12.forEach(function (r) {
                  r._update(t), r._emitEvent(e, t);
                }) : _this39._log.warn("The task specified by Event: task.%s does not exist in Worker %s Reservations map. Skipping event.", e, _this39.sid);
              }
            });
          }), Object.keys(d.taskTransferEventTypes).forEach(function (e) {
            _this39._signaling.on("task.".concat(e), function (t) {
              if (_this39._log.info("Worker %s received Event: task.%s.", _this39.sid, e), !t.initiating_reservation_sid || !t.task_sid) throw _this39._log.error("Event: task.%s did not contain a Reservation sid or Task sid. Unable to emit event for Worker %s.", e, _this39.sid), new Error("Failed to emit event for Worker ".concat(_this39.sid, "."));
              {
                var _r13 = _this39.reservations.get(t.initiating_reservation_sid);

                _r13 ? _r13.task.sid === t.task_sid ? _r13.task._emitEventForOutgoingTransfer(e, t) : _this39._log.warn("The task %s related to Event: task.%s does not match the expected owning Reservation %s for Worker %s. Skipping event.", t.task_sid, e, _r13.sid, _this39.sid) : _this39._log.warn("The reservation %s related to Event: task.%s does not exist in Worker %s Reservations map. Skipping event.", t.initiating_reservation_sid, e, _this39.sid);
              }
            });
          });
        }
      }, {
        key: "_initialize",
        value: function _initialize() {
          var _this40 = this;

          this._routes = new u.q(this.workspaceSid, this.sid), this._log.info("Initializing Worker %s...", this.sid);
          var e = this.getRoutes().getRoute(u.n).path;
          var t;

          this._request.get(e, d.API_V1).then(function (e) {
            var r = new h.a(e, _this40._config);
            return t = r.activitySid, delete r.activityName, delete r.activitySid, delete r.available, Object.assign(_this40, r), Promise.all([_this40._dataServices.activitiesEntity.fetchActivities(), _this40._dataServices.channelsEntity.fetchChannels(), _this40._dataServices.reservationsEntity.fetchReservations()]);
          }).then(function () {
            _this40._log.info("Worker %s activities, channels and pending reservations initialized", _this40.sid), _this40._setCurrentActivity(t), _this40._connectActivitySid ? _this40._setWorkerConnectActivity().then(function () {
              _this40._log.info("Successfully updated Worker on connect to Activity=%s", _this40._connectActivitySid), _this40._log.info("Worker %s successfully initialized", _this40.sid);
            }) : _this40._log.info("Worker %s successfully initialized", _this40.sid), _this40._subscribeToTaskRouterEvents(), _this40.emit("ready", _this40);
          }).catch(function (e) {
            _this40._log.error("Failed to initialize Worker %s. Error: %s", _this40.sid, e), _this40.emit("error", "Failed to initialize Worker ".concat(_this40.sid));
          });
        }
      }, {
        key: "_setCurrentActivity",
        value: function _setCurrentActivity(e) {
          var t = this.activities.get(e);
          if (!t) throw new Error("Unable to set the current Activity sid=".concat(e, " on the Worker."));
          t._isCurrent = !0, this.activity = t, this.activity._isCurrent = !0;
        }
      }, {
        key: "_setWorkerConnectActivity",
        value: function _setWorkerConnectActivity() {
          var _this41 = this;

          if (!i.a.isString(this._connectActivitySid)) throw new TypeError("Failed to set the Worker's activity to the provided optional connectActivitySid. <string>connectActivitySid must be a string.");
          return this._updateWorkerActivity(this._connectActivitySid).then(function () {
            return _this41._log.info("Successfully set the Worker's activity to the provided connectActivitySid=%s on connection.", _this41._connectActivitySid), _this41._connectRetry = 0, _this41;
          }).catch(function (e) {
            if (_this41._connectRetry >= 3) throw _this41._log.error("Unable to set Worker %s activity to the provided %s on successful connection. %s", _this41.sid, _this41._connectActivitySid, e), e;
            return _this41._connectRetry = _this41._connectRetry > 0 ? _this41._connectRetry + 1 : 1, new Promise(function (e) {
              return setTimeout(e, 500);
            }).then(_this41._setWorkerConnectActivity.bind(_this41));
          });
        }
      }, {
        key: "_updateWorkerActivity",
        value: function _updateWorkerActivity(e) {
          var _this42 = this;

          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          if (!i.a.isString(e)) throw new TypeError("Error updating Worker Activity: <string>activitySid is a required parameter");
          var r = this.getRoutes().getRoute(u.n).path,
              n = {
            ActivitySid: e
          };

          for (var _e6 in t) {
            n[d.WORKER_UPDATE_OPTIONS[_e6]] = t[_e6];
          }

          return this._request.post(r, n, d.API_V1).then(function (t) {
            try {
              _this42._update(t), _this42.activity._isCurrent = !1;

              var _r14 = _this42.activities.get(t.activity_sid);

              _this42.activity = _r14, _this42.activity._isCurrent = !0;
            } catch (t) {
              throw _this42._log.error("Failed to update the Worker's activity to sid=%s. Error: %s", e, t), t;
            }

            return _this42;
          });
        }
      }, {
        key: "_update",
        value: function _update(e) {
          var _this43 = this;

          this._log.trace("Attempting to update Worker %s with latest Worker data=%s", this.sid, JSON.stringify(e));

          try {
            var _t17 = new h.a(e, this._config);

            W.forEach(function (e) {
              _this43[e] = _t17[e];
            });
          } catch (t) {
            this._log.error("Failed to update Worker sid=%s. Update aborted. Error: %s.", e.sid, t);
          }

          return this;
        }
      }, {
        key: "disconnect",
        value: function disconnect() {
          this._signaling.disconnect();
        }
      }, {
        key: "getRoutes",
        value: function getRoutes() {
          return this._routes;
        }
      }, {
        key: "channels",
        get: function get() {
          return this._dataServices.channelsEntity.channels;
        }
      }, {
        key: "activities",
        get: function get() {
          return this._dataServices.activitiesEntity.activities;
        }
      }, {
        key: "reservations",
        get: function get() {
          return this._dataServices.reservationsEntity.reservations;
        }
      }]);

      return _class;
    }(a.EventEmitter);
  }, function (e, t, r) {
    var n = r(6).Buffer,
        i = r(21).Transform,
        s = r(53).StringDecoder;

    function o(e) {
      i.call(this), this.hashMode = "string" == typeof e, this.hashMode ? this[e] = this._finalOrDigest : this.final = this._finalOrDigest, this._final && (this.__final = this._final, this._final = null), this._decoder = null, this._encoding = null;
    }

    r(2)(o, i), o.prototype.update = function (e, t, r) {
      "string" == typeof e && (e = n.from(e, t));

      var i = this._update(e);

      return this.hashMode ? this : (r && (i = this._toString(i, r)), i);
    }, o.prototype.setAutoPadding = function () {}, o.prototype.getAuthTag = function () {
      throw new Error("trying to get auth tag in unsupported state");
    }, o.prototype.setAuthTag = function () {
      throw new Error("trying to set auth tag in unsupported state");
    }, o.prototype.setAAD = function () {
      throw new Error("trying to set aad in unsupported state");
    }, o.prototype._transform = function (e, t, r) {
      var n;

      try {
        this.hashMode ? this._update(e) : this.push(this._update(e));
      } catch (e) {
        n = e;
      } finally {
        r(n);
      }
    }, o.prototype._flush = function (e) {
      var t;

      try {
        this.push(this.__final());
      } catch (e) {
        t = e;
      }

      e(t);
    }, o.prototype._finalOrDigest = function (e) {
      var t = this.__final() || n.alloc(0);
      return e && (t = this._toString(t, e, !0)), t;
    }, o.prototype._toString = function (e, t, r) {
      if (this._decoder || (this._decoder = new s(t), this._encoding = t), this._encoding !== t) throw new Error("can't switch encodings");

      var n = this._decoder.write(e);

      return r && (n += this._decoder.end()), n;
    }, e.exports = o;
  }, function (e, t, r) {
    "use strict";

    var n = r(40),
        i = Object.keys || function (e) {
      var t = [];

      for (var r in e) {
        t.push(r);
      }

      return t;
    };

    e.exports = h;
    var s = r(29);
    s.inherits = r(2);
    var o = r(106),
        a = r(54);
    s.inherits(h, o);

    for (var f = i(a.prototype), c = 0; c < f.length; c++) {
      var u = f[c];
      h.prototype[u] || (h.prototype[u] = a.prototype[u]);
    }

    function h(e) {
      if (!(this instanceof h)) return new h(e);
      o.call(this, e), a.call(this, e), e && !1 === e.readable && (this.readable = !1), e && !1 === e.writable && (this.writable = !1), this.allowHalfOpen = !0, e && !1 === e.allowHalfOpen && (this.allowHalfOpen = !1), this.once("end", d);
    }

    function d() {
      this.allowHalfOpen || this._writableState.ended || n.nextTick(l, this);
    }

    function l(e) {
      e.end();
    }

    Object.defineProperty(h.prototype, "writableHighWaterMark", {
      enumerable: !1,
      get: function get() {
        return this._writableState.highWaterMark;
      }
    }), Object.defineProperty(h.prototype, "destroyed", {
      get: function get() {
        return void 0 !== this._readableState && void 0 !== this._writableState && this._readableState.destroyed && this._writableState.destroyed;
      },
      set: function set(e) {
        void 0 !== this._readableState && void 0 !== this._writableState && (this._readableState.destroyed = e, this._writableState.destroyed = e);
      }
    }), h.prototype._destroy = function (e, t) {
      this.push(null), this.end(), n.nextTick(t, e);
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t), r.d(t, "default", function () {
      return i;
    });
    var n = r(1).twilioErrors;

    var i =
    /*#__PURE__*/
    function () {
      function i(e, t, r) {
        _classCallCheck(this, i);

        if (!e) throw n.INVALID_ARGUMENT.clone("Error instantiating Paginator. <Array>items is a required parameter.");
        if (!t) throw n.INVALID_ARGUMENT.clone("Error instantiating Paginator. <Function>source is a required parameter.");
        this._nextToken = r, this._source = t, this.hasNextPage = !!this._nextToken, this.items = e;
      }

      _createClass(i, [{
        key: "nextPage",
        value: function nextPage() {
          return this.hasNextPage ? this._source(this._nextToken) : Promise.reject(n.TASKROUTER_ERROR.clone("Error getting the next page. No next page exists."));
        }
      }]);

      return i;
    }();
  }, function (e, t, r) {
    "use strict";

    r.d(t, "a", function () {
      return a;
    });
    var n = r(0),
        i = r.n(n),
        s = r(5),
        o = r(15);

    var a = function a(e, t) {
      _classCallCheck(this, a);

      if (!i.a.isObject(e)) throw new TypeError("Failed to create a WorkerDescriptor. <Descriptor>descriptor is a required parameter.");
      if (!i.a.isObject(t)) throw new TypeError("Failed to create a WorkerDescriptor. <Configuration>config is a required parameter.");
      if (!o.a.every(function (t) {
        return t in e;
      })) throw new TypeError("Failed to create a WorkerDescriptor. The provided <Descriptor>descriptor does not contain all properties of a Worker.");
      this.accountSid = e.account_sid, this.activityName = e.activity_name, this.activitySid = e.activity_sid, this.attributes = JSON.parse(e.attributes), this.available = e.available, this.dateCreated = Object(s.parseTime)(1e3 * e.date_created), this.dateStatusChanged = Object(s.parseTime)(1e3 * e.date_status_changed), this.dateUpdated = Object(s.parseTime)(1e3 * e.date_updated), this.name = e.friendly_name, this.sid = e.sid, this.workspaceSid = e.workspace_sid;
    };
  }, function (e, t, r) {
    var n = r(6).Buffer;

    function i(e, t) {
      this._block = n.alloc(e), this._finalSize = t, this._blockSize = e, this._len = 0;
    }

    i.prototype.update = function (e, t) {
      "string" == typeof e && (t = t || "utf8", e = n.from(e, t));

      for (var r = this._block, i = this._blockSize, s = e.length, o = this._len, a = 0; a < s;) {
        for (var f = o % i, c = Math.min(s - a, i - f), u = 0; u < c; u++) {
          r[f + u] = e[a + u];
        }

        a += c, (o += c) % i == 0 && this._update(r);
      }

      return this._len += s, this;
    }, i.prototype.digest = function (e) {
      var t = this._len % this._blockSize;
      this._block[t] = 128, this._block.fill(0, t + 1), t >= this._finalSize && (this._update(this._block), this._block.fill(0));
      var r = 8 * this._len;
      if (r <= 4294967295) this._block.writeUInt32BE(r, this._blockSize - 4);else {
        var n = (4294967295 & r) >>> 0,
            i = (r - n) / 4294967296;
        this._block.writeUInt32BE(i, this._blockSize - 8), this._block.writeUInt32BE(n, this._blockSize - 4);
      }

      this._update(this._block);

      var s = this._hash();

      return e ? s.toString(e) : s;
    }, i.prototype._update = function () {
      throw new Error("_update must be implemented by subclass");
    }, e.exports = i;
  }, function (e, t, r) {
    e.exports = i;
    var n = r(7).EventEmitter;

    function i() {
      n.call(this);
    }

    r(2)(i, n), i.Readable = r(30), i.Writable = r(234), i.Duplex = r(233), i.Transform = r(232), i.PassThrough = r(231), i.Stream = i, i.prototype.pipe = function (e, t) {
      var r = this;

      function i(t) {
        e.writable && !1 === e.write(t) && r.pause && r.pause();
      }

      function s() {
        r.readable && r.resume && r.resume();
      }

      r.on("data", i), e.on("drain", s), e._isStdio || t && !1 === t.end || (r.on("end", a), r.on("close", f));
      var o = !1;

      function a() {
        o || (o = !0, e.end());
      }

      function f() {
        o || (o = !0, "function" == typeof e.destroy && e.destroy());
      }

      function c(e) {
        if (u(), 0 === n.listenerCount(this, "error")) throw e;
      }

      function u() {
        r.removeListener("data", i), e.removeListener("drain", s), r.removeListener("end", a), r.removeListener("close", f), r.removeListener("error", c), e.removeListener("error", c), r.removeListener("end", u), r.removeListener("close", u), e.removeListener("close", u);
      }

      return r.on("error", c), e.on("error", c), r.on("end", u), r.on("close", u), e.on("close", u), e.emit("pipe", r), e;
    };
  }, function (e, t, r) {
    "use strict";

    (function (t) {
      var n = r(6).Buffer,
          i = t.crypto || t.msCrypto;
      i && i.getRandomValues ? e.exports = function (e, r) {
        if (e > 65536) throw new Error("requested too many random bytes");
        var s = new t.Uint8Array(e);
        e > 0 && i.getRandomValues(s);
        var o = n.from(s.buffer);
        if ("function" == typeof r) return process.nextTick(function () {
          r(null, o);
        });
        return o;
      } : e.exports = function () {
        throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11");
      };
    }).call(this, r(9));
  }, function (e, t, r) {
    "use strict";

    r.d(t, "a", function () {
      return o;
    });
    var n = r(32),
        i = r(0),
        s = r.n(i);

    var o =
    /*#__PURE__*/
    function () {
      function o(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, o);

        if (!s.a.isString(e)) throw new TypeError("Failed to initialize Configuration. <string>token is a required parameter.");

        if (this.logIdentifier = t.logIdentifier || +new Date(), this._logLevel = t.logLevel || "error", this._log = new n.a("Configuration-".concat(this.logIdentifier), this._logLevel), this.token = e, this.EB_SERVER = t.ebServer || "https://event-bridge.twilio.com/v1/wschannels", this.WS_SERVER = t.wsServer || "wss://event-bridge.twilio.com/v1/wschannels", t.region) {
          var _e7 = t.region + ".us1.",
              _r15 = this.EB_SERVER.indexOf("twilio.com"),
              _n2 = this.WS_SERVER.indexOf("twilio.com");

          this.EB_SERVER = this.EB_SERVER.slice(0, _r15) + _e7 + this.EB_SERVER.slice(_r15), this.WS_SERVER = this.WS_SERVER.slice(0, _n2) + _e7 + this.WS_SERVER.slice(_n2);
        }
      }

      _createClass(o, [{
        key: "updateToken",
        value: function updateToken(e) {
          if (!s.a.isString(e)) throw new TypeError("To update the Twilio token, a new Twilio token must be passed in. <string>newToken is a required parameter.");
          this.token = e;
        }
      }, {
        key: "getLogIdentifier",
        value: function getLogIdentifier() {
          return this.logIdentifier;
        }
      }]);

      return o;
    }();
  }, function (e, t, r) {
    "use strict";

    (function (t) {
      e.exports = {
        BINARY_TYPES: ["nodebuffer", "arraybuffer", "fragments"],
        GUID: "258EAFA5-E914-47DA-95CA-C5AB0DC85B11",
        kStatusCode: Symbol("status-code"),
        kWebSocket: Symbol("websocket"),
        EMPTY_BUFFER: t.alloc(0),
        NOOP: function NOOP() {}
      };
    }).call(this, r(3).Buffer);
  }, function (e, t, r) {
    var n = t;
    n.Reporter = r(172).Reporter, n.DecoderBuffer = r(82).DecoderBuffer, n.EncoderBuffer = r(82).EncoderBuffer, n.Node = r(171);
  }, function (e, t, r) {
    var n = t;
    n.bignum = r(8), n.define = r(175).define, n.base = r(25), n.constants = r(81), n.decoders = r(169), n.encoders = r(167);
  }, function (e, t, r) {
    "use strict";

    var n = r(14),
        i = r(13);

    function s() {
      this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
    }

    t.BlockHash = s, s.prototype.update = function (e, t) {
      if (e = n.toArray(e, t), this.pending ? this.pending = this.pending.concat(e) : this.pending = e, this.pendingTotal += e.length, this.pending.length >= this._delta8) {
        var r = (e = this.pending).length % this._delta8;
        this.pending = e.slice(e.length - r, e.length), 0 === this.pending.length && (this.pending = null), e = n.join32(e, 0, e.length - r, this.endian);

        for (var i = 0; i < e.length; i += this._delta32) {
          this._update(e, i, i + this._delta32);
        }
      }

      return this;
    }, s.prototype.digest = function (e) {
      return this.update(this._pad()), i(null === this.pending), this._digest(e);
    }, s.prototype._pad = function () {
      var e = this.pendingTotal,
          t = this._delta8,
          r = t - (e + this.padLength) % t,
          n = new Array(r + this.padLength);
      n[0] = 128;

      for (var i = 1; i < r; i++) {
        n[i] = 0;
      }

      if (e <<= 3, "big" === this.endian) {
        for (var s = 8; s < this.padLength; s++) {
          n[i++] = 0;
        }

        n[i++] = 0, n[i++] = 0, n[i++] = 0, n[i++] = 0, n[i++] = e >>> 24 & 255, n[i++] = e >>> 16 & 255, n[i++] = e >>> 8 & 255, n[i++] = 255 & e;
      } else for (n[i++] = 255 & e, n[i++] = e >>> 8 & 255, n[i++] = e >>> 16 & 255, n[i++] = e >>> 24 & 255, n[i++] = 0, n[i++] = 0, n[i++] = 0, n[i++] = 0, s = 8; s < this.padLength; s++) {
        n[i++] = 0;
      }

      return n;
    };
  }, function (e, t, r) {
    (function (t) {
      e.exports = function (e, r) {
        for (var n = Math.min(e.length, r.length), i = new t(n), s = 0; s < n; ++s) {
          i[s] = e[s] ^ r[s];
        }

        return i;
      };
    }).call(this, r(3).Buffer);
  }, function (e, t, r) {
    (function (e) {
      function r(e) {
        return Object.prototype.toString.call(e);
      }

      t.isArray = function (e) {
        return Array.isArray ? Array.isArray(e) : "[object Array]" === r(e);
      }, t.isBoolean = function (e) {
        return "boolean" == typeof e;
      }, t.isNull = function (e) {
        return null === e;
      }, t.isNullOrUndefined = function (e) {
        return null == e;
      }, t.isNumber = function (e) {
        return "number" == typeof e;
      }, t.isString = function (e) {
        return "string" == typeof e;
      }, t.isSymbol = function (e) {
        return "symbol" == typeof e;
      }, t.isUndefined = function (e) {
        return void 0 === e;
      }, t.isRegExp = function (e) {
        return "[object RegExp]" === r(e);
      }, t.isObject = function (e) {
        return "object" == typeof e && null !== e;
      }, t.isDate = function (e) {
        return "[object Date]" === r(e);
      }, t.isError = function (e) {
        return "[object Error]" === r(e) || e instanceof Error;
      }, t.isFunction = function (e) {
        return "function" == typeof e;
      }, t.isPrimitive = function (e) {
        return null === e || "boolean" == typeof e || "number" == typeof e || "string" == typeof e || "symbol" == typeof e || void 0 === e;
      }, t.isBuffer = e.isBuffer;
    }).call(this, r(3).Buffer);
  }, function (e, t, r) {
    (t = e.exports = r(106)).Stream = t, t.Readable = t, t.Writable = r(54), t.Duplex = r(17), t.Transform = r(103), t.PassThrough = r(235);
  }, function (e, t, r) {
    "use strict";

    (function (t) {
      var n = r(2),
          i = r(56),
          s = r(55),
          o = r(52),
          a = r(16);

      function f(e) {
        a.call(this, "digest"), this._hash = e, this.buffers = [];
      }

      function c(e) {
        a.call(this, "digest"), this._hash = e;
      }

      n(f, a), f.prototype._update = function (e) {
        this.buffers.push(e);
      }, f.prototype._final = function () {
        var e = t.concat(this.buffers),
            r = this._hash(e);

        return this.buffers = null, r;
      }, n(c, a), c.prototype._update = function (e) {
        this._hash.update(e);
      }, c.prototype._final = function () {
        return this._hash.digest();
      }, e.exports = function (e) {
        return "md5" === (e = e.toLowerCase()) ? new f(i) : new c("rmd160" === e || "ripemd160" === e ? new s() : o(e));
      };
    }).call(this, r(3).Buffer);
  }, function (e, t, r) {
    "use strict";

    r.d(t, "a", function () {
      return o;
    });
    var n = r(1).twilioErrors,
        i = r(247),
        s = ["trace", "debug", "info", "warn", "error", "silent"];

    var o =
    /*#__PURE__*/
    function () {
      function o(e, t) {
        _classCallCheck(this, o);

        if (!e) throw n.INVALID_ARGUMENT.clone("Error instantiating Logger. <string>moduleName is a required parameter.");
        this._log = i.getLogger(e), s.forEach(function (e) {
          var _this44 = this;

          this[e] = function () {
            var _this44$_log;

            return (_this44$_log = _this44._log)[e].apply(_this44$_log, arguments);
          };
        }.bind(this)), t && this.setLevel(t);
      }

      _createClass(o, [{
        key: "setLevel",
        value: function setLevel(e) {
          if (-1 === s.indexOf(e)) throw n.INVALID_ARGUMENT.clone("Error setting Logger level. <string>level must be one of ['trace', 'debug', 'info', 'warn', 'error', 'silent']");
          this._log.setLevel(e, !1), this._log.setDefaultLevel(e);
        }
      }, {
        key: "getLevel",
        value: function getLevel() {
          return s[this._log.getLevel()];
        }
      }]);

      return o;
    }();
  }, function (e, t, r) {
    "use strict";

    var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;

    function i(e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }

    t.assign = function (e) {
      for (var t = Array.prototype.slice.call(arguments, 1); t.length;) {
        var r = t.shift();

        if (r) {
          if ("object" != typeof r) throw new TypeError(r + "must be non-object");

          for (var n in r) {
            i(r, n) && (e[n] = r[n]);
          }
        }
      }

      return e;
    }, t.shrinkBuf = function (e, t) {
      return e.length === t ? e : e.subarray ? e.subarray(0, t) : (e.length = t, e);
    };
    var s = {
      arraySet: function arraySet(e, t, r, n, i) {
        if (t.subarray && e.subarray) e.set(t.subarray(r, r + n), i);else for (var s = 0; s < n; s++) {
          e[i + s] = t[r + s];
        }
      },
      flattenChunks: function flattenChunks(e) {
        var t, r, n, i, s, o;

        for (n = 0, t = 0, r = e.length; t < r; t++) {
          n += e[t].length;
        }

        for (o = new Uint8Array(n), i = 0, t = 0, r = e.length; t < r; t++) {
          s = e[t], o.set(s, i), i += s.length;
        }

        return o;
      }
    },
        o = {
      arraySet: function arraySet(e, t, r, n, i) {
        for (var s = 0; s < n; s++) {
          e[i + s] = t[r + s];
        }
      },
      flattenChunks: function flattenChunks(e) {
        return [].concat.apply([], e);
      }
    };
    t.setTyped = function (e) {
      e ? (t.Buf8 = Uint8Array, t.Buf16 = Uint16Array, t.Buf32 = Int32Array, t.assign(t, s)) : (t.Buf8 = Array, t.Buf16 = Array, t.Buf32 = Array, t.assign(t, o));
    }, t.setTyped(n);
  }, function (e, t, r) {
    "use strict";

    (function (t) {
      var n = r(146),
          i = r(145),
          s = r(44),
          o = r(24),
          a = t.from([0, 0, 255, 255]),
          f = t.from([0]),
          c = Symbol("permessage-deflate"),
          u = Symbol("write-in-progress"),
          h = Symbol("pending-close"),
          d = Symbol("total-length"),
          l = Symbol("callback"),
          p = Symbol("buffers"),
          b = Symbol("error");

      var _;

      function g(e) {
        this[p].push(e), this[d] += e.length;
      }

      function v(e) {
        this[d] += e.length, this[c]._maxPayload < 1 || this[d] <= this[c]._maxPayload ? this[p].push(e) : (this[b] = new RangeError("Max payload size exceeded"), this[b][o.kStatusCode] = 1009, this.removeListener("data", v), this.reset());
      }

      function m(e) {
        this[c]._inflate = null, e[o.kStatusCode] = 1007, this[l](e);
      }

      e.exports =
      /*#__PURE__*/
      function () {
        function _class2(e, t, r) {
          _classCallCheck(this, _class2);

          if (this._maxPayload = 0 | r, this._options = e || {}, this._threshold = void 0 !== this._options.threshold ? this._options.threshold : 1024, this._isServer = !!t, this._deflate = null, this._inflate = null, this.params = null, !_) {
            var _e8 = void 0 !== this._options.concurrencyLimit ? this._options.concurrencyLimit : 10;

            _ = new n({
              concurrency: _e8
            });
          }
        }

        _createClass(_class2, [{
          key: "offer",
          value: function offer() {
            var e = {};
            return this._options.serverNoContextTakeover && (e.server_no_context_takeover = !0), this._options.clientNoContextTakeover && (e.client_no_context_takeover = !0), this._options.serverMaxWindowBits && (e.server_max_window_bits = this._options.serverMaxWindowBits), this._options.clientMaxWindowBits ? e.client_max_window_bits = this._options.clientMaxWindowBits : null == this._options.clientMaxWindowBits && (e.client_max_window_bits = !0), e;
          }
        }, {
          key: "accept",
          value: function accept(e) {
            return e = this.normalizeParams(e), this.params = this._isServer ? this.acceptAsServer(e) : this.acceptAsClient(e), this.params;
          }
        }, {
          key: "cleanup",
          value: function cleanup() {
            this._inflate && (this._inflate[u] ? this._inflate[h] = !0 : (this._inflate.close(), this._inflate = null)), this._deflate && (this._deflate[u] ? this._deflate[h] = !0 : (this._deflate.close(), this._deflate = null));
          }
        }, {
          key: "acceptAsServer",
          value: function acceptAsServer(e) {
            var t = this._options,
                r = e.find(function (e) {
              return !(!1 === t.serverNoContextTakeover && e.server_no_context_takeover || e.server_max_window_bits && (!1 === t.serverMaxWindowBits || "number" == typeof t.serverMaxWindowBits && t.serverMaxWindowBits > e.server_max_window_bits) || "number" == typeof t.clientMaxWindowBits && !e.client_max_window_bits);
            });
            if (!r) throw new Error("None of the extension offers can be accepted");
            return t.serverNoContextTakeover && (r.server_no_context_takeover = !0), t.clientNoContextTakeover && (r.client_no_context_takeover = !0), "number" == typeof t.serverMaxWindowBits && (r.server_max_window_bits = t.serverMaxWindowBits), "number" == typeof t.clientMaxWindowBits ? r.client_max_window_bits = t.clientMaxWindowBits : !0 !== r.client_max_window_bits && !1 !== t.clientMaxWindowBits || delete r.client_max_window_bits, r;
          }
        }, {
          key: "acceptAsClient",
          value: function acceptAsClient(e) {
            var t = e[0];
            if (!1 === this._options.clientNoContextTakeover && t.client_no_context_takeover) throw new Error('Unexpected parameter "client_no_context_takeover"');

            if (t.client_max_window_bits) {
              if (!1 === this._options.clientMaxWindowBits || "number" == typeof this._options.clientMaxWindowBits && t.client_max_window_bits > this._options.clientMaxWindowBits) throw new Error('Unexpected or invalid parameter "client_max_window_bits"');
            } else "number" == typeof this._options.clientMaxWindowBits && (t.client_max_window_bits = this._options.clientMaxWindowBits);

            return t;
          }
        }, {
          key: "normalizeParams",
          value: function normalizeParams(e) {
            var _this45 = this;

            return e.forEach(function (e) {
              Object.keys(e).forEach(function (t) {
                var r = e[t];
                if (r.length > 1) throw new Error("Parameter \"".concat(t, "\" must have only a single value"));

                if (r = r[0], "client_max_window_bits" === t) {
                  if (!0 !== r) {
                    var _e9 = +r;

                    if (!Number.isInteger(_e9) || _e9 < 8 || _e9 > 15) throw new TypeError("Invalid value for parameter \"".concat(t, "\": ").concat(r));
                    r = _e9;
                  } else if (!_this45._isServer) throw new TypeError("Invalid value for parameter \"".concat(t, "\": ").concat(r));
                } else if ("server_max_window_bits" === t) {
                  var _e10 = +r;

                  if (!Number.isInteger(_e10) || _e10 < 8 || _e10 > 15) throw new TypeError("Invalid value for parameter \"".concat(t, "\": ").concat(r));
                  r = _e10;
                } else {
                  if ("client_no_context_takeover" !== t && "server_no_context_takeover" !== t) throw new Error("Unknown parameter \"".concat(t, "\""));
                  if (!0 !== r) throw new TypeError("Invalid value for parameter \"".concat(t, "\": ").concat(r));
                }

                e[t] = r;
              });
            }), e;
          }
        }, {
          key: "decompress",
          value: function decompress(e, t, r) {
            var _this46 = this;

            _.push(function (n) {
              _this46._decompress(e, t, function (e, t) {
                n(), r(e, t);
              });
            });
          }
        }, {
          key: "compress",
          value: function compress(e, t, r) {
            var _this47 = this;

            _.push(function (n) {
              _this47._compress(e, t, function (e, t) {
                n(), r(e, t);
              });
            });
          }
        }, {
          key: "_decompress",
          value: function _decompress(e, t, r) {
            var _this48 = this;

            var n = this._isServer ? "client" : "server";

            if (!this._inflate) {
              var _e11 = "".concat(n, "_max_window_bits"),
                  _t18 = "number" != typeof this.params[_e11] ? i.Z_DEFAULT_WINDOWBITS : this.params[_e11];

              this._inflate = i.createInflateRaw(Object.assign({}, this._options.zlibInflateOptions, {
                windowBits: _t18
              })), this._inflate[c] = this, this._inflate[d] = 0, this._inflate[p] = [], this._inflate.on("error", m), this._inflate.on("data", v);
            }

            this._inflate[l] = r, this._inflate[u] = !0, this._inflate.write(e), t && this._inflate.write(a), this._inflate.flush(function () {
              var e = _this48._inflate[b];
              if (e) return _this48._inflate.close(), _this48._inflate = null, void r(e);
              var i = s.concat(_this48._inflate[p], _this48._inflate[d]);
              t && _this48.params["".concat(n, "_no_context_takeover")] || _this48._inflate[h] ? (_this48._inflate.close(), _this48._inflate = null) : (_this48._inflate[u] = !1, _this48._inflate[d] = 0, _this48._inflate[p] = []), r(null, i);
            });
          }
        }, {
          key: "_compress",
          value: function _compress(e, t, r) {
            var _this49 = this;

            if (!e || 0 === e.length) return void process.nextTick(r, null, f);
            var n = this._isServer ? "server" : "client";

            if (!this._deflate) {
              var _e12 = "".concat(n, "_max_window_bits"),
                  _t19 = "number" != typeof this.params[_e12] ? i.Z_DEFAULT_WINDOWBITS : this.params[_e12];

              this._deflate = i.createDeflateRaw(Object.assign({
                memLevel: this._options.memLevel,
                level: this._options.level
              }, this._options.zlibDeflateOptions, {
                windowBits: _t19
              })), this._deflate[d] = 0, this._deflate[p] = [], this._deflate.on("data", g);
            }

            this._deflate[u] = !0, this._deflate.write(e), this._deflate.flush(i.Z_SYNC_FLUSH, function () {
              var e = s.concat(_this49._deflate[p], _this49._deflate[d]);
              t && (e = e.slice(0, e.length - 4)), t && _this49.params["".concat(n, "_no_context_takeover")] || _this49._deflate[h] ? (_this49._deflate.close(), _this49._deflate = null) : (_this49._deflate[u] = !1, _this49._deflate[d] = 0, _this49._deflate[p] = []), r(null, e);
            });
          }
        }], [{
          key: "extensionName",
          get: function get() {
            return "permessage-deflate";
          }
        }]);

        return _class2;
      }();
    }).call(this, r(3).Buffer);
  }, function (e, t, r) {
    "use strict";

    var n = r(151),
        i = r(150);

    function s() {
      this.protocol = null, this.slashes = null, this.auth = null, this.host = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.query = null, this.pathname = null, this.path = null, this.href = null;
    }

    t.parse = m, t.resolve = function (e, t) {
      return m(e, !1, !0).resolve(t);
    }, t.resolveObject = function (e, t) {
      return e ? m(e, !1, !0).resolveObject(t) : t;
    }, t.format = function (e) {
      i.isString(e) && (e = m(e));
      return e instanceof s ? e.format() : s.prototype.format.call(e);
    }, t.Url = s;
    var o = /^([a-z0-9.+-]+:)/i,
        a = /:[0-9]*$/,
        f = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,
        c = ["{", "}", "|", "\\", "^", "`"].concat(["<", ">", '"', "`", " ", "\r", "\n", "\t"]),
        u = ["'"].concat(c),
        h = ["%", "/", "?", ";", "#"].concat(u),
        d = ["/", "?", "#"],
        l = /^[+a-z0-9A-Z_-]{0,63}$/,
        p = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
        b = {
      javascript: !0,
      "javascript:": !0
    },
        _ = {
      javascript: !0,
      "javascript:": !0
    },
        g = {
      http: !0,
      https: !0,
      ftp: !0,
      gopher: !0,
      file: !0,
      "http:": !0,
      "https:": !0,
      "ftp:": !0,
      "gopher:": !0,
      "file:": !0
    },
        v = r(149);

    function m(e, t, r) {
      if (e && i.isObject(e) && e instanceof s) return e;
      var n = new s();
      return n.parse(e, t, r), n;
    }

    s.prototype.parse = function (e, t, r) {
      if (!i.isString(e)) throw new TypeError("Parameter 'url' must be a string, not " + typeof e);
      var s = e.indexOf("?"),
          a = -1 !== s && s < e.indexOf("#") ? "?" : "#",
          c = e.split(a);
      c[0] = c[0].replace(/\\/g, "/");
      var m = e = c.join(a);

      if (m = m.trim(), !r && 1 === e.split("#").length) {
        var y = f.exec(m);
        if (y) return this.path = m, this.href = m, this.pathname = y[1], y[2] ? (this.search = y[2], this.query = t ? v.parse(this.search.substr(1)) : this.search.substr(1)) : t && (this.search = "", this.query = {}), this;
      }

      var w = o.exec(m);

      if (w) {
        var k = (w = w[0]).toLowerCase();
        this.protocol = k, m = m.substr(w.length);
      }

      if (r || w || m.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        var S = "//" === m.substr(0, 2);
        !S || w && _[w] || (m = m.substr(2), this.slashes = !0);
      }

      if (!_[w] && (S || w && !g[w])) {
        for (var E, A, x = -1, T = 0; T < d.length; T++) {
          -1 !== (R = m.indexOf(d[T])) && (-1 === x || R < x) && (x = R);
        }

        -1 !== (A = -1 === x ? m.lastIndexOf("@") : m.lastIndexOf("@", x)) && (E = m.slice(0, A), m = m.slice(A + 1), this.auth = decodeURIComponent(E)), x = -1;

        for (T = 0; T < h.length; T++) {
          var R;
          -1 !== (R = m.indexOf(h[T])) && (-1 === x || R < x) && (x = R);
        }

        -1 === x && (x = m.length), this.host = m.slice(0, x), m = m.slice(x), this.parseHost(), this.hostname = this.hostname || "";
        var M = "[" === this.hostname[0] && "]" === this.hostname[this.hostname.length - 1];
        if (!M) for (var I = this.hostname.split(/\./), O = (T = 0, I.length); T < O; T++) {
          var C = I[T];

          if (C && !C.match(l)) {
            for (var B = "", P = 0, N = C.length; P < N; P++) {
              C.charCodeAt(P) > 127 ? B += "x" : B += C[P];
            }

            if (!B.match(l)) {
              var L = I.slice(0, T),
                  j = I.slice(T + 1),
                  U = C.match(p);
              U && (L.push(U[1]), j.unshift(U[2])), j.length && (m = "/" + j.join(".") + m), this.hostname = L.join(".");
              break;
            }
          }
        }
        this.hostname.length > 255 ? this.hostname = "" : this.hostname = this.hostname.toLowerCase(), M || (this.hostname = n.toASCII(this.hostname));
        var D = this.port ? ":" + this.port : "",
            q = this.hostname || "";
        this.host = q + D, this.href += this.host, M && (this.hostname = this.hostname.substr(1, this.hostname.length - 2), "/" !== m[0] && (m = "/" + m));
      }

      if (!b[k]) for (T = 0, O = u.length; T < O; T++) {
        var z = u[T];

        if (-1 !== m.indexOf(z)) {
          var F = encodeURIComponent(z);
          F === z && (F = escape(z)), m = m.split(z).join(F);
        }
      }
      var W = m.indexOf("#");
      -1 !== W && (this.hash = m.substr(W), m = m.slice(0, W));
      var Z = m.indexOf("?");

      if (-1 !== Z ? (this.search = m.substr(Z), this.query = m.substr(Z + 1), t && (this.query = v.parse(this.query)), m = m.slice(0, Z)) : t && (this.search = "", this.query = {}), m && (this.pathname = m), g[k] && this.hostname && !this.pathname && (this.pathname = "/"), this.pathname || this.search) {
        D = this.pathname || "";
        var V = this.search || "";
        this.path = D + V;
      }

      return this.href = this.format(), this;
    }, s.prototype.format = function () {
      var e = this.auth || "";
      e && (e = (e = encodeURIComponent(e)).replace(/%3A/i, ":"), e += "@");
      var t = this.protocol || "",
          r = this.pathname || "",
          n = this.hash || "",
          s = !1,
          o = "";
      this.host ? s = e + this.host : this.hostname && (s = e + (-1 === this.hostname.indexOf(":") ? this.hostname : "[" + this.hostname + "]"), this.port && (s += ":" + this.port)), this.query && i.isObject(this.query) && Object.keys(this.query).length && (o = v.stringify(this.query));
      var a = this.search || o && "?" + o || "";
      return t && ":" !== t.substr(-1) && (t += ":"), this.slashes || (!t || g[t]) && !1 !== s ? (s = "//" + (s || ""), r && "/" !== r.charAt(0) && (r = "/" + r)) : s || (s = ""), n && "#" !== n.charAt(0) && (n = "#" + n), a && "?" !== a.charAt(0) && (a = "?" + a), t + s + (r = r.replace(/[?#]/g, function (e) {
        return encodeURIComponent(e);
      })) + (a = a.replace("#", "%23")) + n;
    }, s.prototype.resolve = function (e) {
      return this.resolveObject(m(e, !1, !0)).format();
    }, s.prototype.resolveObject = function (e) {
      if (i.isString(e)) {
        var t = new s();
        t.parse(e, !1, !0), e = t;
      }

      for (var r = new s(), n = Object.keys(this), o = 0; o < n.length; o++) {
        var a = n[o];
        r[a] = this[a];
      }

      if (r.hash = e.hash, "" === e.href) return r.href = r.format(), r;

      if (e.slashes && !e.protocol) {
        for (var f = Object.keys(e), c = 0; c < f.length; c++) {
          var u = f[c];
          "protocol" !== u && (r[u] = e[u]);
        }

        return g[r.protocol] && r.hostname && !r.pathname && (r.path = r.pathname = "/"), r.href = r.format(), r;
      }

      if (e.protocol && e.protocol !== r.protocol) {
        if (!g[e.protocol]) {
          for (var h = Object.keys(e), d = 0; d < h.length; d++) {
            var l = h[d];
            r[l] = e[l];
          }

          return r.href = r.format(), r;
        }

        if (r.protocol = e.protocol, e.host || _[e.protocol]) r.pathname = e.pathname;else {
          for (var p = (e.pathname || "").split("/"); p.length && !(e.host = p.shift());) {
            ;
          }

          e.host || (e.host = ""), e.hostname || (e.hostname = ""), "" !== p[0] && p.unshift(""), p.length < 2 && p.unshift(""), r.pathname = p.join("/");
        }

        if (r.search = e.search, r.query = e.query, r.host = e.host || "", r.auth = e.auth, r.hostname = e.hostname || e.host, r.port = e.port, r.pathname || r.search) {
          var b = r.pathname || "",
              v = r.search || "";
          r.path = b + v;
        }

        return r.slashes = r.slashes || e.slashes, r.href = r.format(), r;
      }

      var m = r.pathname && "/" === r.pathname.charAt(0),
          y = e.host || e.pathname && "/" === e.pathname.charAt(0),
          w = y || m || r.host && e.pathname,
          k = w,
          S = r.pathname && r.pathname.split("/") || [],
          E = (p = e.pathname && e.pathname.split("/") || [], r.protocol && !g[r.protocol]);
      if (E && (r.hostname = "", r.port = null, r.host && ("" === S[0] ? S[0] = r.host : S.unshift(r.host)), r.host = "", e.protocol && (e.hostname = null, e.port = null, e.host && ("" === p[0] ? p[0] = e.host : p.unshift(e.host)), e.host = null), w = w && ("" === p[0] || "" === S[0])), y) r.host = e.host || "" === e.host ? e.host : r.host, r.hostname = e.hostname || "" === e.hostname ? e.hostname : r.hostname, r.search = e.search, r.query = e.query, S = p;else if (p.length) S || (S = []), S.pop(), S = S.concat(p), r.search = e.search, r.query = e.query;else if (!i.isNullOrUndefined(e.search)) {
        if (E) r.hostname = r.host = S.shift(), (M = !!(r.host && r.host.indexOf("@") > 0) && r.host.split("@")) && (r.auth = M.shift(), r.host = r.hostname = M.shift());
        return r.search = e.search, r.query = e.query, i.isNull(r.pathname) && i.isNull(r.search) || (r.path = (r.pathname ? r.pathname : "") + (r.search ? r.search : "")), r.href = r.format(), r;
      }
      if (!S.length) return r.pathname = null, r.search ? r.path = "/" + r.search : r.path = null, r.href = r.format(), r;

      for (var A = S.slice(-1)[0], x = (r.host || e.host || S.length > 1) && ("." === A || ".." === A) || "" === A, T = 0, R = S.length; R >= 0; R--) {
        "." === (A = S[R]) ? S.splice(R, 1) : ".." === A ? (S.splice(R, 1), T++) : T && (S.splice(R, 1), T--);
      }

      if (!w && !k) for (; T--; T) {
        S.unshift("..");
      }
      !w || "" === S[0] || S[0] && "/" === S[0].charAt(0) || S.unshift(""), x && "/" !== S.join("/").substr(-1) && S.push("");
      var M,
          I = "" === S[0] || S[0] && "/" === S[0].charAt(0);
      E && (r.hostname = r.host = I ? "" : S.length ? S.shift() : "", (M = !!(r.host && r.host.indexOf("@") > 0) && r.host.split("@")) && (r.auth = M.shift(), r.host = r.hostname = M.shift()));
      return (w = w || r.host && S.length) && !I && S.unshift(""), S.length ? r.pathname = S.join("/") : (r.pathname = null, r.path = null), i.isNull(r.pathname) && i.isNull(r.search) || (r.path = (r.pathname ? r.pathname : "") + (r.search ? r.search : "")), r.auth = e.auth || r.auth, r.slashes = r.slashes || e.slashes, r.href = r.format(), r;
    }, s.prototype.parseHost = function () {
      var e = this.host,
          t = a.exec(e);
      t && (":" !== (t = t[0]) && (this.port = t.substr(1)), e = e.substr(0, e.length - t.length)), e && (this.hostname = e);
    };
  }, function (e, t, r) {
    (function (t) {
      var n = r(176),
          i = r(164),
          s = r(163),
          o = r(51),
          a = r(98);

      function f(e) {
        var r;
        "object" != typeof e || t.isBuffer(e) || (r = e.passphrase, e = e.key), "string" == typeof e && (e = new t(e));
        var f,
            c,
            u = s(e, r),
            h = u.tag,
            d = u.data;

        switch (h) {
          case "CERTIFICATE":
            c = n.certificate.decode(d, "der").tbsCertificate.subjectPublicKeyInfo;

          case "PUBLIC KEY":
            switch (c || (c = n.PublicKey.decode(d, "der")), f = c.algorithm.algorithm.join(".")) {
              case "1.2.840.113549.1.1.1":
                return n.RSAPublicKey.decode(c.subjectPublicKey.data, "der");

              case "1.2.840.10045.2.1":
                return c.subjectPrivateKey = c.subjectPublicKey, {
                  type: "ec",
                  data: c
                };

              case "1.2.840.10040.4.1":
                return c.algorithm.params.pub_key = n.DSAparam.decode(c.subjectPublicKey.data, "der"), {
                  type: "dsa",
                  data: c.algorithm.params
                };

              default:
                throw new Error("unknown key id " + f);
            }

            throw new Error("unknown key type " + h);

          case "ENCRYPTED PRIVATE KEY":
            d = function (e, r) {
              var n = e.algorithm.decrypt.kde.kdeparams.salt,
                  s = parseInt(e.algorithm.decrypt.kde.kdeparams.iters.toString(), 10),
                  f = i[e.algorithm.decrypt.cipher.algo.join(".")],
                  c = e.algorithm.decrypt.cipher.iv,
                  u = e.subjectPrivateKey,
                  h = parseInt(f.split("-")[1], 10) / 8,
                  d = a.pbkdf2Sync(r, n, s, h),
                  l = o.createDecipheriv(f, d, c),
                  p = [];
              return p.push(l.update(u)), p.push(l.final()), t.concat(p);
            }(d = n.EncryptedPrivateKey.decode(d, "der"), r);

          case "PRIVATE KEY":
            switch (f = (c = n.PrivateKey.decode(d, "der")).algorithm.algorithm.join(".")) {
              case "1.2.840.113549.1.1.1":
                return n.RSAPrivateKey.decode(c.subjectPrivateKey, "der");

              case "1.2.840.10045.2.1":
                return {
                  curve: c.algorithm.curve,
                  privateKey: n.ECPrivateKey.decode(c.subjectPrivateKey, "der").privateKey
                };

              case "1.2.840.10040.4.1":
                return c.algorithm.params.priv_key = n.DSAparam.decode(c.subjectPrivateKey, "der"), {
                  type: "dsa",
                  params: c.algorithm.params
                };

              default:
                throw new Error("unknown key id " + f);
            }

            throw new Error("unknown key type " + h);

          case "RSA PUBLIC KEY":
            return n.RSAPublicKey.decode(d, "der");

          case "RSA PRIVATE KEY":
            return n.RSAPrivateKey.decode(d, "der");

          case "DSA PRIVATE KEY":
            return {
              type: "dsa",
              params: n.DSAPrivateKey.decode(d, "der")
            };

          case "EC PRIVATE KEY":
            return {
              curve: (d = n.ECPrivateKey.decode(d, "der")).parameters.value,
              privateKey: d.privateKey
            };

          default:
            throw new Error("unknown key type " + h);
        }
      }

      e.exports = f, f.signature = n.signature;
    }).call(this, r(3).Buffer);
  }, function (e, t, r) {
    "use strict";

    var n = t;
    n.base = r(195), n.short = r(194), n.mont = r(193), n.edwards = r(192);
  }, function (e, t, r) {
    var n = r(6).Buffer;

    function i(e) {
      n.isBuffer(e) || (e = n.from(e));

      for (var t = e.length / 4 | 0, r = new Array(t), i = 0; i < t; i++) {
        r[i] = e.readUInt32BE(4 * i);
      }

      return r;
    }

    function s(e) {
      for (; 0 < e.length; e++) {
        e[0] = 0;
      }
    }

    function o(e, t, r, n, i) {
      for (var s, o, a, f, c = r[0], u = r[1], h = r[2], d = r[3], l = e[0] ^ t[0], p = e[1] ^ t[1], b = e[2] ^ t[2], _ = e[3] ^ t[3], g = 4, v = 1; v < i; v++) {
        s = c[l >>> 24] ^ u[p >>> 16 & 255] ^ h[b >>> 8 & 255] ^ d[255 & _] ^ t[g++], o = c[p >>> 24] ^ u[b >>> 16 & 255] ^ h[_ >>> 8 & 255] ^ d[255 & l] ^ t[g++], a = c[b >>> 24] ^ u[_ >>> 16 & 255] ^ h[l >>> 8 & 255] ^ d[255 & p] ^ t[g++], f = c[_ >>> 24] ^ u[l >>> 16 & 255] ^ h[p >>> 8 & 255] ^ d[255 & b] ^ t[g++], l = s, p = o, b = a, _ = f;
      }

      return s = (n[l >>> 24] << 24 | n[p >>> 16 & 255] << 16 | n[b >>> 8 & 255] << 8 | n[255 & _]) ^ t[g++], o = (n[p >>> 24] << 24 | n[b >>> 16 & 255] << 16 | n[_ >>> 8 & 255] << 8 | n[255 & l]) ^ t[g++], a = (n[b >>> 24] << 24 | n[_ >>> 16 & 255] << 16 | n[l >>> 8 & 255] << 8 | n[255 & p]) ^ t[g++], f = (n[_ >>> 24] << 24 | n[l >>> 16 & 255] << 16 | n[p >>> 8 & 255] << 8 | n[255 & b]) ^ t[g++], [s >>>= 0, o >>>= 0, a >>>= 0, f >>>= 0];
    }

    var a = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54],
        f = function () {
      for (var e = new Array(256), t = 0; t < 256; t++) {
        e[t] = t < 128 ? t << 1 : t << 1 ^ 283;
      }

      for (var r = [], n = [], i = [[], [], [], []], s = [[], [], [], []], o = 0, a = 0, f = 0; f < 256; ++f) {
        var c = a ^ a << 1 ^ a << 2 ^ a << 3 ^ a << 4;
        c = c >>> 8 ^ 255 & c ^ 99, r[o] = c, n[c] = o;
        var u = e[o],
            h = e[u],
            d = e[h],
            l = 257 * e[c] ^ 16843008 * c;
        i[0][o] = l << 24 | l >>> 8, i[1][o] = l << 16 | l >>> 16, i[2][o] = l << 8 | l >>> 24, i[3][o] = l, l = 16843009 * d ^ 65537 * h ^ 257 * u ^ 16843008 * o, s[0][c] = l << 24 | l >>> 8, s[1][c] = l << 16 | l >>> 16, s[2][c] = l << 8 | l >>> 24, s[3][c] = l, 0 === o ? o = a = 1 : (o = u ^ e[e[e[d ^ u]]], a ^= e[e[a]]);
      }

      return {
        SBOX: r,
        INV_SBOX: n,
        SUB_MIX: i,
        INV_SUB_MIX: s
      };
    }();

    function c(e) {
      this._key = i(e), this._reset();
    }

    c.blockSize = 16, c.keySize = 32, c.prototype.blockSize = c.blockSize, c.prototype.keySize = c.keySize, c.prototype._reset = function () {
      for (var e = this._key, t = e.length, r = t + 6, n = 4 * (r + 1), i = [], s = 0; s < t; s++) {
        i[s] = e[s];
      }

      for (s = t; s < n; s++) {
        var o = i[s - 1];
        s % t == 0 ? (o = o << 8 | o >>> 24, o = f.SBOX[o >>> 24] << 24 | f.SBOX[o >>> 16 & 255] << 16 | f.SBOX[o >>> 8 & 255] << 8 | f.SBOX[255 & o], o ^= a[s / t | 0] << 24) : t > 6 && s % t == 4 && (o = f.SBOX[o >>> 24] << 24 | f.SBOX[o >>> 16 & 255] << 16 | f.SBOX[o >>> 8 & 255] << 8 | f.SBOX[255 & o]), i[s] = i[s - t] ^ o;
      }

      for (var c = [], u = 0; u < n; u++) {
        var h = n - u,
            d = i[h - (u % 4 ? 0 : 4)];
        c[u] = u < 4 || h <= 4 ? d : f.INV_SUB_MIX[0][f.SBOX[d >>> 24]] ^ f.INV_SUB_MIX[1][f.SBOX[d >>> 16 & 255]] ^ f.INV_SUB_MIX[2][f.SBOX[d >>> 8 & 255]] ^ f.INV_SUB_MIX[3][f.SBOX[255 & d]];
      }

      this._nRounds = r, this._keySchedule = i, this._invKeySchedule = c;
    }, c.prototype.encryptBlockRaw = function (e) {
      return o(e = i(e), this._keySchedule, f.SUB_MIX, f.SBOX, this._nRounds);
    }, c.prototype.encryptBlock = function (e) {
      var t = this.encryptBlockRaw(e),
          r = n.allocUnsafe(16);
      return r.writeUInt32BE(t[0], 0), r.writeUInt32BE(t[1], 4), r.writeUInt32BE(t[2], 8), r.writeUInt32BE(t[3], 12), r;
    }, c.prototype.decryptBlock = function (e) {
      var t = (e = i(e))[1];
      e[1] = e[3], e[3] = t;
      var r = o(e, this._invKeySchedule, f.INV_SUB_MIX, f.INV_SBOX, this._nRounds),
          s = n.allocUnsafe(16);
      return s.writeUInt32BE(r[0], 0), s.writeUInt32BE(r[3], 4), s.writeUInt32BE(r[2], 8), s.writeUInt32BE(r[1], 12), s;
    }, c.prototype.scrub = function () {
      s(this._keySchedule), s(this._invKeySchedule), s(this._key);
    }, e.exports.AES = c;
  }, function (e, t, r) {
    var n = r(6).Buffer,
        i = r(222);

    e.exports = function (e, t, r, s) {
      if (n.isBuffer(e) || (e = n.from(e, "binary")), t && (n.isBuffer(t) || (t = n.from(t, "binary")), 8 !== t.length)) throw new RangeError("salt should be Buffer with 8 byte length");

      for (var o = r / 8, a = n.alloc(o), f = n.alloc(s || 0), c = n.alloc(0); o > 0 || s > 0;) {
        var u = new i();
        u.update(c), u.update(e), t && u.update(t), c = u.digest();
        var h = 0;

        if (o > 0) {
          var d = a.length - o;
          h = Math.min(o, c.length), c.copy(a, d, 0, h), o -= h;
        }

        if (h < c.length && s > 0) {
          var l = f.length - s,
              p = Math.min(s, c.length - h);
          c.copy(f, l, h, h + p), s -= p;
        }
      }

      return c.fill(0), {
        key: a,
        iv: f
      };
    };
  }, function (e, t, r) {
    "use strict";

    !process.version || 0 === process.version.indexOf("v0.") || 0 === process.version.indexOf("v1.") && 0 !== process.version.indexOf("v1.8.") ? e.exports = {
      nextTick: function nextTick(e, t, r, n) {
        if ("function" != typeof e) throw new TypeError('"callback" argument must be a function');
        var i,
            s,
            o = arguments.length;

        switch (o) {
          case 0:
          case 1:
            return process.nextTick(e);

          case 2:
            return process.nextTick(function () {
              e.call(null, t);
            });

          case 3:
            return process.nextTick(function () {
              e.call(null, t, r);
            });

          case 4:
            return process.nextTick(function () {
              e.call(null, t, r, n);
            });

          default:
            for (i = new Array(o - 1), s = 0; s < i.length;) {
              i[s++] = arguments[s];
            }

            return process.nextTick(function () {
              e.apply(null, i);
            });
        }
      }
    } : e.exports = process;
  }, function (e, t, r) {
    "use strict";

    r.d(t, "a", function () {
      return h;
    });
    var n = r(0),
        i = r.n(n),
        s = r(109),
        o = r(23),
        a = r(1),
        f = r(42);
    var c = {
      GET: "GET",
      POST: "POST"
    };
    Object.freeze(c);
    var u = f.a;

    var h =
    /*#__PURE__*/
    function () {
      function h(e) {
        _classCallCheck(this, h);

        if (!(e instanceof o.a)) throw new TypeError("Failed to initialize Request. <Configuration>config is a required parameter.");
        this._config = e, this._postClient = s.create({
          method: c.POST,
          timeout: a.DEFAULT_HTTP_TIMEOUT,
          headers: {
            clientVersion: u
          }
        });
      }

      _createClass(h, [{
        key: "post",
        value: function post(e, t, r) {
          if (!e) throw new Error("Failed to make POST request. <string>url is a required parameter.");
          if (!i.a.isObject(t)) throw new Error("Failed to make POST request. <object>paramsJSON is a required parameter.");
          if (!r) throw new Error("Failed to make POST request. <string>apiVersion is a required parameter.");
          var n = this.buildRequest(c.POST, e, t);
          return this._postClient.post(this._config.EB_SERVER, n, {
            headers: {
              apiVersion: r
            }
          }).then(function (e) {
            return Promise.resolve(e.data.payload);
          });
        }
      }, {
        key: "get",
        value: function get(e, t, r) {
          if (!e) throw new Error("Failed to make GET request. <string>url is a required parameter.");
          if (!t) throw new Error("Failed to make GET request. <string>apiVersion is a required parameter.");
          if (r = r || {}, !i.a.isObject(r)) throw new Error("Failed to make GET request. <object>paramsJSON is a required parameter.");
          var n = this.buildRequest(c.GET, e, r);
          return this._postClient.post(this._config.EB_SERVER, n, {
            headers: {
              apiVersion: t
            }
          }).then(function (e) {
            return Promise.resolve(e.data.payload);
          });
        }
      }, {
        key: "buildRequest",
        value: function buildRequest(e, t, r) {
          return JSON.stringify({
            url: t,
            method: e,
            params: r,
            token: this._config.token
          });
        }
      }]);

      return h;
    }();
  }, function (e) {
    e.exports = {
      a: "0.4.5"
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(12),
        i = r(127),
        s = {
      "Content-Type": "application/x-www-form-urlencoded"
    };

    function o(e, t) {
      !n.isUndefined(e) && n.isUndefined(e["Content-Type"]) && (e["Content-Type"] = t);
    }

    var a,
        f = {
      adapter: ("undefined" != typeof XMLHttpRequest ? a = r(63) : "undefined" != typeof process && (a = r(63)), a),
      transformRequest: [function (e, t) {
        return i(t, "Content-Type"), n.isFormData(e) || n.isArrayBuffer(e) || n.isBuffer(e) || n.isStream(e) || n.isFile(e) || n.isBlob(e) ? e : n.isArrayBufferView(e) ? e.buffer : n.isURLSearchParams(e) ? (o(t, "application/x-www-form-urlencoded;charset=utf-8"), e.toString()) : n.isObject(e) ? (o(t, "application/json;charset=utf-8"), JSON.stringify(e)) : e;
      }],
      transformResponse: [function (e) {
        if ("string" == typeof e) try {
          e = JSON.parse(e);
        } catch (e) {}
        return e;
      }],
      timeout: 0,
      xsrfCookieName: "XSRF-TOKEN",
      xsrfHeaderName: "X-XSRF-TOKEN",
      maxContentLength: -1,
      validateStatus: function validateStatus(e) {
        return e >= 200 && e < 300;
      }
    };
    f.headers = {
      common: {
        Accept: "application/json, text/plain, */*"
      }
    }, n.forEach(["delete", "get", "head"], function (e) {
      f.headers[e] = {};
    }), n.forEach(["post", "put", "patch"], function (e) {
      f.headers[e] = n.merge(s);
    }), e.exports = f;
  }, function (e, t, r) {
    "use strict";

    (function (t) {
      function n(e, r) {
        var n = t.allocUnsafe(r);

        for (var i = 0, s = 0; s < e.length; s++) {
          var _t20 = e[s];
          _t20.copy(n, i), i += _t20.length;
        }

        return n;
      }

      function i(e, t, r, n, i) {
        for (var s = 0; s < i; s++) {
          r[n + s] = e[s] ^ t[3 & s];
        }
      }

      function s(e, t) {
        var r = e.length;

        for (var n = 0; n < r; n++) {
          e[n] ^= t[3 & n];
        }
      }

      try {
        var _t21 = r(!function () {
          var e = new Error('Cannot find module "bufferutil"');
          throw e.code = "MODULE_NOT_FOUND", e;
        }()),
            o = _t21.BufferUtil || _t21;

        e.exports = {
          mask: function mask(e, t, r, n, s) {
            s < 48 ? i(e, t, r, n, s) : o.mask(e, t, r, n, s);
          },
          unmask: function unmask(e, t) {
            e.length < 32 ? s(e, t) : o.unmask(e, t);
          },
          concat: n
        };
      } catch (t) {
        e.exports = {
          concat: n,
          mask: i,
          unmask: s
        };
      }
    }).call(this, r(3).Buffer);
  }, function (e, t) {}, function (e, t, r) {
    (function (e) {
      var n = r(155),
          i = r(73),
          s = r(153),
          o = r(152),
          a = r(35),
          f = t;
      f.request = function (t, r) {
        t = "string" == typeof t ? a.parse(t) : s(t);
        var i = -1 === e.location.protocol.search(/^https?:$/) ? "http:" : "",
            o = t.protocol || i,
            f = t.hostname || t.host,
            c = t.port,
            u = t.path || "/";
        f && -1 !== f.indexOf(":") && (f = "[" + f + "]"), t.url = (f ? o + "//" + f : "") + (c ? ":" + c : "") + u, t.method = (t.method || "GET").toUpperCase(), t.headers = t.headers || {};
        var h = new n(t);
        return r && h.on("response", r), h;
      }, f.get = function (e, t) {
        var r = f.request(e, t);
        return r.end(), r;
      }, f.ClientRequest = n, f.IncomingMessage = i.IncomingMessage, f.Agent = function () {}, f.Agent.defaultMaxSockets = 4, f.globalAgent = new f.Agent(), f.STATUS_CODES = o, f.METHODS = ["CHECKOUT", "CONNECT", "COPY", "DELETE", "GET", "HEAD", "LOCK", "M-SEARCH", "MERGE", "MKACTIVITY", "MKCOL", "MOVE", "NOTIFY", "OPTIONS", "PATCH", "POST", "PROPFIND", "PROPPATCH", "PURGE", "PUT", "REPORT", "SEARCH", "SUBSCRIBE", "TRACE", "UNLOCK", "UNSUBSCRIBE"];
    }).call(this, r(9));
  }, function (e, t, r) {
    var n = t;
    n.utils = r(14), n.common = r(27), n.sha = r(190), n.ripemd = r(186), n.hmac = r(185), n.sha1 = n.sha.sha1, n.sha256 = n.sha.sha256, n.sha224 = n.sha.sha224, n.sha384 = n.sha.sha384, n.sha512 = n.sha.sha512, n.ripemd160 = n.ripemd.ripemd160;
  }, function (e, t, r) {
    (function (t) {
      var n = r(8),
          i = r(22);

      function s(e, r) {
        var i = function (e) {
          var t = o(e);
          return {
            blinder: t.toRed(n.mont(e.modulus)).redPow(new n(e.publicExponent)).fromRed(),
            unblinder: t.invm(e.modulus)
          };
        }(r),
            s = r.modulus.byteLength(),
            a = (n.mont(r.modulus), new n(e).mul(i.blinder).umod(r.modulus)),
            f = a.toRed(n.mont(r.prime1)),
            c = a.toRed(n.mont(r.prime2)),
            u = r.coefficient,
            h = r.prime1,
            d = r.prime2,
            l = f.redPow(r.exponent1),
            p = c.redPow(r.exponent2);

        l = l.fromRed(), p = p.fromRed();
        var b = l.isub(p).imul(u).umod(h);
        return b.imul(d), p.iadd(b), new t(p.imul(i.unblinder).umod(r.modulus).toArray(!1, s));
      }

      function o(e) {
        for (var t = e.modulus.byteLength(), r = new n(i(t)); r.cmp(e.modulus) >= 0 || !r.umod(e.prime1) || !r.umod(e.prime2);) {
          r = new n(i(t));
        }

        return r;
      }

      e.exports = s, s.getr = o;
    }).call(this, r(3).Buffer);
  }, function (e, t, r) {
    "use strict";

    t.utils = r(210), t.Cipher = r(209), t.DES = r(208), t.CBC = r(207), t.EDE = r(206);
  }, function (e, t, r) {
    var n = {
      ECB: r(219),
      CBC: r(218),
      CFB: r(217),
      CFB8: r(216),
      CFB1: r(215),
      OFB: r(214),
      CTR: r(94),
      GCM: r(94)
    },
        i = r(92);

    for (var s in i) {
      i[s].module = n[i[s].mode];
    }

    e.exports = i;
  }, function (e, t, r) {
    var n = r(220),
        i = r(212),
        s = r(92);
    t.createCipher = t.Cipher = n.createCipher, t.createCipheriv = t.Cipheriv = n.createCipheriv, t.createDecipher = t.Decipher = i.createDecipher, t.createDecipheriv = t.Decipheriv = i.createDecipheriv, t.listCiphers = t.getCiphers = function () {
      return Object.keys(s);
    };
  }, function (e, t, r) {
    (t = e.exports = function (e) {
      e = e.toLowerCase();
      var r = t[e];
      if (!r) throw new Error(e + " is not supported (we accept pull requests)");
      return new r();
    }).sha = r(230), t.sha1 = r(229), t.sha224 = r(228), t.sha256 = r(102), t.sha384 = r(227), t.sha512 = r(101);
  }, function (e, t, r) {
    "use strict";

    var n = r(6).Buffer,
        i = n.isEncoding || function (e) {
      switch ((e = "" + e) && e.toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
          return !0;

        default:
          return !1;
      }
    };

    function s(e) {
      var t;

      switch (this.encoding = function (e) {
        var t = function (e) {
          if (!e) return "utf8";

          for (var t;;) {
            switch (e) {
              case "utf8":
              case "utf-8":
                return "utf8";

              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return "utf16le";

              case "latin1":
              case "binary":
                return "latin1";

              case "base64":
              case "ascii":
              case "hex":
                return e;

              default:
                if (t) return;
                e = ("" + e).toLowerCase(), t = !0;
            }
          }
        }(e);

        if ("string" != typeof t && (n.isEncoding === i || !i(e))) throw new Error("Unknown encoding: " + e);
        return t || e;
      }(e), this.encoding) {
        case "utf16le":
          this.text = f, this.end = c, t = 4;
          break;

        case "utf8":
          this.fillLast = a, t = 4;
          break;

        case "base64":
          this.text = u, this.end = h, t = 3;
          break;

        default:
          return this.write = d, void (this.end = l);
      }

      this.lastNeed = 0, this.lastTotal = 0, this.lastChar = n.allocUnsafe(t);
    }

    function o(e) {
      return e <= 127 ? 0 : e >> 5 == 6 ? 2 : e >> 4 == 14 ? 3 : e >> 3 == 30 ? 4 : e >> 6 == 2 ? -1 : -2;
    }

    function a(e) {
      var t = this.lastTotal - this.lastNeed,
          r = function (e, t, r) {
        if (128 != (192 & t[0])) return e.lastNeed = 0, "�";

        if (e.lastNeed > 1 && t.length > 1) {
          if (128 != (192 & t[1])) return e.lastNeed = 1, "�";
          if (e.lastNeed > 2 && t.length > 2 && 128 != (192 & t[2])) return e.lastNeed = 2, "�";
        }
      }(this, e);

      return void 0 !== r ? r : this.lastNeed <= e.length ? (e.copy(this.lastChar, t, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal)) : (e.copy(this.lastChar, t, 0, e.length), void (this.lastNeed -= e.length));
    }

    function f(e, t) {
      if ((e.length - t) % 2 == 0) {
        var r = e.toString("utf16le", t);

        if (r) {
          var n = r.charCodeAt(r.length - 1);
          if (n >= 55296 && n <= 56319) return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = e[e.length - 2], this.lastChar[1] = e[e.length - 1], r.slice(0, -1);
        }

        return r;
      }

      return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = e[e.length - 1], e.toString("utf16le", t, e.length - 1);
    }

    function c(e) {
      var t = e && e.length ? this.write(e) : "";

      if (this.lastNeed) {
        var r = this.lastTotal - this.lastNeed;
        return t + this.lastChar.toString("utf16le", 0, r);
      }

      return t;
    }

    function u(e, t) {
      var r = (e.length - t) % 3;
      return 0 === r ? e.toString("base64", t) : (this.lastNeed = 3 - r, this.lastTotal = 3, 1 === r ? this.lastChar[0] = e[e.length - 1] : (this.lastChar[0] = e[e.length - 2], this.lastChar[1] = e[e.length - 1]), e.toString("base64", t, e.length - r));
    }

    function h(e) {
      var t = e && e.length ? this.write(e) : "";
      return this.lastNeed ? t + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : t;
    }

    function d(e) {
      return e.toString(this.encoding);
    }

    function l(e) {
      return e && e.length ? this.write(e) : "";
    }

    t.StringDecoder = s, s.prototype.write = function (e) {
      if (0 === e.length) return "";
      var t, r;

      if (this.lastNeed) {
        if (void 0 === (t = this.fillLast(e))) return "";
        r = this.lastNeed, this.lastNeed = 0;
      } else r = 0;

      return r < e.length ? t ? t + this.text(e, r) : this.text(e, r) : t || "";
    }, s.prototype.end = function (e) {
      var t = e && e.length ? this.write(e) : "";
      return this.lastNeed ? t + "�" : t;
    }, s.prototype.text = function (e, t) {
      var r = function (e, t, r) {
        var n = t.length - 1;
        if (n < r) return 0;
        var i = o(t[n]);
        if (i >= 0) return i > 0 && (e.lastNeed = i - 1), i;
        if (--n < r || -2 === i) return 0;
        if ((i = o(t[n])) >= 0) return i > 0 && (e.lastNeed = i - 2), i;
        if (--n < r || -2 === i) return 0;
        if ((i = o(t[n])) >= 0) return i > 0 && (2 === i ? i = 0 : e.lastNeed = i - 3), i;
        return 0;
      }(this, e, t);

      if (!this.lastNeed) return e.toString("utf8", t);
      this.lastTotal = r;
      var n = e.length - (r - this.lastNeed);
      return e.copy(this.lastChar, 0, n), e.toString("utf8", t, n);
    }, s.prototype.fillLast = function (e) {
      if (this.lastNeed <= e.length) return e.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
      e.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, e.length), this.lastNeed -= e.length;
    };
  }, function (e, t, r) {
    "use strict";

    (function (t, n) {
      var i = r(40);

      function s(e) {
        var t = this;
        this.next = null, this.entry = null, this.finish = function () {
          !function (e, t, r) {
            var n = e.entry;
            e.entry = null;

            for (; n;) {
              var i = n.callback;
              t.pendingcb--, i(r), n = n.next;
            }

            t.corkedRequestsFree ? t.corkedRequestsFree.next = e : t.corkedRequestsFree = e;
          }(t, e);
        };
      }

      e.exports = g;
      var o,
          a = !process.browser && ["v0.10", "v0.9."].indexOf(process.version.slice(0, 5)) > -1 ? t : i.nextTick;
      g.WritableState = _;
      var f = r(29);
      f.inherits = r(2);

      var c = {
        deprecate: r(236)
      },
          u = r(105),
          h = r(6).Buffer,
          d = n.Uint8Array || function () {};

      var l,
          p = r(104);

      function b() {}

      function _(e, t) {
        o = o || r(17), e = e || {};
        var n = t instanceof o;
        this.objectMode = !!e.objectMode, n && (this.objectMode = this.objectMode || !!e.writableObjectMode);
        var f = e.highWaterMark,
            c = e.writableHighWaterMark,
            u = this.objectMode ? 16 : 16384;
        this.highWaterMark = f || 0 === f ? f : n && (c || 0 === c) ? c : u, this.highWaterMark = Math.floor(this.highWaterMark), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
        var h = !1 === e.decodeStrings;
        this.decodeStrings = !h, this.defaultEncoding = e.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function (e) {
          !function (e, t) {
            var r = e._writableState,
                n = r.sync,
                s = r.writecb;
            if (function (e) {
              e.writing = !1, e.writecb = null, e.length -= e.writelen, e.writelen = 0;
            }(r), t) !function (e, t, r, n, s) {
              --t.pendingcb, r ? (i.nextTick(s, n), i.nextTick(S, e, t), e._writableState.errorEmitted = !0, e.emit("error", n)) : (s(n), e._writableState.errorEmitted = !0, e.emit("error", n), S(e, t));
            }(e, r, n, t, s);else {
              var o = w(r);
              o || r.corked || r.bufferProcessing || !r.bufferedRequest || y(e, r), n ? a(m, e, r, o, s) : m(e, r, o, s);
            }
          }(t, e);
        }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new s(this);
      }

      function g(e) {
        if (o = o || r(17), !(l.call(g, this) || this instanceof o)) return new g(e);
        this._writableState = new _(e, this), this.writable = !0, e && ("function" == typeof e.write && (this._write = e.write), "function" == typeof e.writev && (this._writev = e.writev), "function" == typeof e.destroy && (this._destroy = e.destroy), "function" == typeof e.final && (this._final = e.final)), u.call(this);
      }

      function v(e, t, r, n, i, s, o) {
        t.writelen = n, t.writecb = o, t.writing = !0, t.sync = !0, r ? e._writev(i, t.onwrite) : e._write(i, s, t.onwrite), t.sync = !1;
      }

      function m(e, t, r, n) {
        r || function (e, t) {
          0 === t.length && t.needDrain && (t.needDrain = !1, e.emit("drain"));
        }(e, t), t.pendingcb--, n(), S(e, t);
      }

      function y(e, t) {
        t.bufferProcessing = !0;
        var r = t.bufferedRequest;

        if (e._writev && r && r.next) {
          var n = t.bufferedRequestCount,
              i = new Array(n),
              o = t.corkedRequestsFree;
          o.entry = r;

          for (var a = 0, f = !0; r;) {
            i[a] = r, r.isBuf || (f = !1), r = r.next, a += 1;
          }

          i.allBuffers = f, v(e, t, !0, t.length, i, "", o.finish), t.pendingcb++, t.lastBufferedRequest = null, o.next ? (t.corkedRequestsFree = o.next, o.next = null) : t.corkedRequestsFree = new s(t), t.bufferedRequestCount = 0;
        } else {
          for (; r;) {
            var c = r.chunk,
                u = r.encoding,
                h = r.callback;
            if (v(e, t, !1, t.objectMode ? 1 : c.length, c, u, h), r = r.next, t.bufferedRequestCount--, t.writing) break;
          }

          null === r && (t.lastBufferedRequest = null);
        }

        t.bufferedRequest = r, t.bufferProcessing = !1;
      }

      function w(e) {
        return e.ending && 0 === e.length && null === e.bufferedRequest && !e.finished && !e.writing;
      }

      function k(e, t) {
        e._final(function (r) {
          t.pendingcb--, r && e.emit("error", r), t.prefinished = !0, e.emit("prefinish"), S(e, t);
        });
      }

      function S(e, t) {
        var r = w(t);
        return r && (!function (e, t) {
          t.prefinished || t.finalCalled || ("function" == typeof e._final ? (t.pendingcb++, t.finalCalled = !0, i.nextTick(k, e, t)) : (t.prefinished = !0, e.emit("prefinish")));
        }(e, t), 0 === t.pendingcb && (t.finished = !0, e.emit("finish"))), r;
      }

      f.inherits(g, u), _.prototype.getBuffer = function () {
        for (var e = this.bufferedRequest, t = []; e;) {
          t.push(e), e = e.next;
        }

        return t;
      }, function () {
        try {
          Object.defineProperty(_.prototype, "buffer", {
            get: c.deprecate(function () {
              return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
          });
        } catch (e) {}
      }(), "function" == typeof Symbol && Symbol.hasInstance && "function" == typeof Function.prototype[Symbol.hasInstance] ? (l = Function.prototype[Symbol.hasInstance], Object.defineProperty(g, Symbol.hasInstance, {
        value: function value(e) {
          return !!l.call(this, e) || this === g && e && e._writableState instanceof _;
        }
      })) : l = function l(e) {
        return e instanceof this;
      }, g.prototype.pipe = function () {
        this.emit("error", new Error("Cannot pipe, not readable"));
      }, g.prototype.write = function (e, t, r) {
        var n,
            s = this._writableState,
            o = !1,
            a = !s.objectMode && (n = e, h.isBuffer(n) || n instanceof d);
        return a && !h.isBuffer(e) && (e = function (e) {
          return h.from(e);
        }(e)), "function" == typeof t && (r = t, t = null), a ? t = "buffer" : t || (t = s.defaultEncoding), "function" != typeof r && (r = b), s.ended ? function (e, t) {
          var r = new Error("write after end");
          e.emit("error", r), i.nextTick(t, r);
        }(this, r) : (a || function (e, t, r, n) {
          var s = !0,
              o = !1;
          return null === r ? o = new TypeError("May not write null values to stream") : "string" == typeof r || void 0 === r || t.objectMode || (o = new TypeError("Invalid non-string/buffer chunk")), o && (e.emit("error", o), i.nextTick(n, o), s = !1), s;
        }(this, s, e, r)) && (s.pendingcb++, o = function (e, t, r, n, i, s) {
          if (!r) {
            var o = function (e, t, r) {
              e.objectMode || !1 === e.decodeStrings || "string" != typeof t || (t = h.from(t, r));
              return t;
            }(t, n, i);

            n !== o && (r = !0, i = "buffer", n = o);
          }

          var a = t.objectMode ? 1 : n.length;
          t.length += a;
          var f = t.length < t.highWaterMark;
          f || (t.needDrain = !0);

          if (t.writing || t.corked) {
            var c = t.lastBufferedRequest;
            t.lastBufferedRequest = {
              chunk: n,
              encoding: i,
              isBuf: r,
              callback: s,
              next: null
            }, c ? c.next = t.lastBufferedRequest : t.bufferedRequest = t.lastBufferedRequest, t.bufferedRequestCount += 1;
          } else v(e, t, !1, a, n, i, s);

          return f;
        }(this, s, a, e, t, r)), o;
      }, g.prototype.cork = function () {
        this._writableState.corked++;
      }, g.prototype.uncork = function () {
        var e = this._writableState;
        e.corked && (e.corked--, e.writing || e.corked || e.finished || e.bufferProcessing || !e.bufferedRequest || y(this, e));
      }, g.prototype.setDefaultEncoding = function (e) {
        if ("string" == typeof e && (e = e.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((e + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + e);
        return this._writableState.defaultEncoding = e, this;
      }, Object.defineProperty(g.prototype, "writableHighWaterMark", {
        enumerable: !1,
        get: function get() {
          return this._writableState.highWaterMark;
        }
      }), g.prototype._write = function (e, t, r) {
        r(new Error("_write() is not implemented"));
      }, g.prototype._writev = null, g.prototype.end = function (e, t, r) {
        var n = this._writableState;
        "function" == typeof e ? (r = e, e = null, t = null) : "function" == typeof t && (r = t, t = null), null !== e && void 0 !== e && this.write(e, t), n.corked && (n.corked = 1, this.uncork()), n.ending || n.finished || function (e, t, r) {
          t.ending = !0, S(e, t), r && (t.finished ? i.nextTick(r) : e.once("finish", r));
          t.ended = !0, e.writable = !1;
        }(this, n, r);
      }, Object.defineProperty(g.prototype, "destroyed", {
        get: function get() {
          return void 0 !== this._writableState && this._writableState.destroyed;
        },
        set: function set(e) {
          this._writableState && (this._writableState.destroyed = e);
        }
      }), g.prototype.destroy = p.destroy, g.prototype._undestroy = p.undestroy, g.prototype._destroy = function (e, t) {
        this.end(), t(e);
      };
    }).call(this, r(238).setImmediate, r(9));
  }, function (e, t, r) {
    "use strict";

    (function (t) {
      var n = r(2),
          i = r(242);

      function s() {
        i.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520;
      }

      function o(e, t) {
        return e << t | e >>> 32 - t;
      }

      function a(e, t, r, n, i, s, a, f) {
        return o(e + (t ^ r ^ n) + s + a | 0, f) + i | 0;
      }

      function f(e, t, r, n, i, s, a, f) {
        return o(e + (t & r | ~t & n) + s + a | 0, f) + i | 0;
      }

      function c(e, t, r, n, i, s, a, f) {
        return o(e + ((t | ~r) ^ n) + s + a | 0, f) + i | 0;
      }

      function u(e, t, r, n, i, s, a, f) {
        return o(e + (t & n | r & ~n) + s + a | 0, f) + i | 0;
      }

      function h(e, t, r, n, i, s, a, f) {
        return o(e + (t ^ (r | ~n)) + s + a | 0, f) + i | 0;
      }

      n(s, i), s.prototype._update = function () {
        for (var e = new Array(16), t = 0; t < 16; ++t) {
          e[t] = this._block.readInt32LE(4 * t);
        }

        var r = this._a,
            n = this._b,
            i = this._c,
            s = this._d,
            d = this._e;
        d = a(d, r = a(r, n, i, s, d, e[0], 0, 11), n, i = o(i, 10), s, e[1], 0, 14), n = a(n = o(n, 10), i = a(i, s = a(s, d, r, n, i, e[2], 0, 15), d, r = o(r, 10), n, e[3], 0, 12), s, d = o(d, 10), r, e[4], 0, 5), s = a(s = o(s, 10), d = a(d, r = a(r, n, i, s, d, e[5], 0, 8), n, i = o(i, 10), s, e[6], 0, 7), r, n = o(n, 10), i, e[7], 0, 9), r = a(r = o(r, 10), n = a(n, i = a(i, s, d, r, n, e[8], 0, 11), s, d = o(d, 10), r, e[9], 0, 13), i, s = o(s, 10), d, e[10], 0, 14), i = a(i = o(i, 10), s = a(s, d = a(d, r, n, i, s, e[11], 0, 15), r, n = o(n, 10), i, e[12], 0, 6), d, r = o(r, 10), n, e[13], 0, 7), d = f(d = o(d, 10), r = a(r, n = a(n, i, s, d, r, e[14], 0, 9), i, s = o(s, 10), d, e[15], 0, 8), n, i = o(i, 10), s, e[7], 1518500249, 7), n = f(n = o(n, 10), i = f(i, s = f(s, d, r, n, i, e[4], 1518500249, 6), d, r = o(r, 10), n, e[13], 1518500249, 8), s, d = o(d, 10), r, e[1], 1518500249, 13), s = f(s = o(s, 10), d = f(d, r = f(r, n, i, s, d, e[10], 1518500249, 11), n, i = o(i, 10), s, e[6], 1518500249, 9), r, n = o(n, 10), i, e[15], 1518500249, 7), r = f(r = o(r, 10), n = f(n, i = f(i, s, d, r, n, e[3], 1518500249, 15), s, d = o(d, 10), r, e[12], 1518500249, 7), i, s = o(s, 10), d, e[0], 1518500249, 12), i = f(i = o(i, 10), s = f(s, d = f(d, r, n, i, s, e[9], 1518500249, 15), r, n = o(n, 10), i, e[5], 1518500249, 9), d, r = o(r, 10), n, e[2], 1518500249, 11), d = f(d = o(d, 10), r = f(r, n = f(n, i, s, d, r, e[14], 1518500249, 7), i, s = o(s, 10), d, e[11], 1518500249, 13), n, i = o(i, 10), s, e[8], 1518500249, 12), n = c(n = o(n, 10), i = c(i, s = c(s, d, r, n, i, e[3], 1859775393, 11), d, r = o(r, 10), n, e[10], 1859775393, 13), s, d = o(d, 10), r, e[14], 1859775393, 6), s = c(s = o(s, 10), d = c(d, r = c(r, n, i, s, d, e[4], 1859775393, 7), n, i = o(i, 10), s, e[9], 1859775393, 14), r, n = o(n, 10), i, e[15], 1859775393, 9), r = c(r = o(r, 10), n = c(n, i = c(i, s, d, r, n, e[8], 1859775393, 13), s, d = o(d, 10), r, e[1], 1859775393, 15), i, s = o(s, 10), d, e[2], 1859775393, 14), i = c(i = o(i, 10), s = c(s, d = c(d, r, n, i, s, e[7], 1859775393, 8), r, n = o(n, 10), i, e[0], 1859775393, 13), d, r = o(r, 10), n, e[6], 1859775393, 6), d = c(d = o(d, 10), r = c(r, n = c(n, i, s, d, r, e[13], 1859775393, 5), i, s = o(s, 10), d, e[11], 1859775393, 12), n, i = o(i, 10), s, e[5], 1859775393, 7), n = u(n = o(n, 10), i = u(i, s = c(s, d, r, n, i, e[12], 1859775393, 5), d, r = o(r, 10), n, e[1], 2400959708, 11), s, d = o(d, 10), r, e[9], 2400959708, 12), s = u(s = o(s, 10), d = u(d, r = u(r, n, i, s, d, e[11], 2400959708, 14), n, i = o(i, 10), s, e[10], 2400959708, 15), r, n = o(n, 10), i, e[0], 2400959708, 14), r = u(r = o(r, 10), n = u(n, i = u(i, s, d, r, n, e[8], 2400959708, 15), s, d = o(d, 10), r, e[12], 2400959708, 9), i, s = o(s, 10), d, e[4], 2400959708, 8), i = u(i = o(i, 10), s = u(s, d = u(d, r, n, i, s, e[13], 2400959708, 9), r, n = o(n, 10), i, e[3], 2400959708, 14), d, r = o(r, 10), n, e[7], 2400959708, 5), d = u(d = o(d, 10), r = u(r, n = u(n, i, s, d, r, e[15], 2400959708, 6), i, s = o(s, 10), d, e[14], 2400959708, 8), n, i = o(i, 10), s, e[5], 2400959708, 6), n = h(n = o(n, 10), i = u(i, s = u(s, d, r, n, i, e[6], 2400959708, 5), d, r = o(r, 10), n, e[2], 2400959708, 12), s, d = o(d, 10), r, e[4], 2840853838, 9), s = h(s = o(s, 10), d = h(d, r = h(r, n, i, s, d, e[0], 2840853838, 15), n, i = o(i, 10), s, e[5], 2840853838, 5), r, n = o(n, 10), i, e[9], 2840853838, 11), r = h(r = o(r, 10), n = h(n, i = h(i, s, d, r, n, e[7], 2840853838, 6), s, d = o(d, 10), r, e[12], 2840853838, 8), i, s = o(s, 10), d, e[2], 2840853838, 13), i = h(i = o(i, 10), s = h(s, d = h(d, r, n, i, s, e[10], 2840853838, 12), r, n = o(n, 10), i, e[14], 2840853838, 5), d, r = o(r, 10), n, e[1], 2840853838, 12), d = h(d = o(d, 10), r = h(r, n = h(n, i, s, d, r, e[3], 2840853838, 13), i, s = o(s, 10), d, e[8], 2840853838, 14), n, i = o(i, 10), s, e[11], 2840853838, 11), n = h(n = o(n, 10), i = h(i, s = h(s, d, r, n, i, e[6], 2840853838, 8), d, r = o(r, 10), n, e[15], 2840853838, 5), s, d = o(d, 10), r, e[13], 2840853838, 6), s = o(s, 10);
        var l = this._a,
            p = this._b,
            b = this._c,
            _ = this._d,
            g = this._e;
        g = h(g, l = h(l, p, b, _, g, e[5], 1352829926, 8), p, b = o(b, 10), _, e[14], 1352829926, 9), p = h(p = o(p, 10), b = h(b, _ = h(_, g, l, p, b, e[7], 1352829926, 9), g, l = o(l, 10), p, e[0], 1352829926, 11), _, g = o(g, 10), l, e[9], 1352829926, 13), _ = h(_ = o(_, 10), g = h(g, l = h(l, p, b, _, g, e[2], 1352829926, 15), p, b = o(b, 10), _, e[11], 1352829926, 15), l, p = o(p, 10), b, e[4], 1352829926, 5), l = h(l = o(l, 10), p = h(p, b = h(b, _, g, l, p, e[13], 1352829926, 7), _, g = o(g, 10), l, e[6], 1352829926, 7), b, _ = o(_, 10), g, e[15], 1352829926, 8), b = h(b = o(b, 10), _ = h(_, g = h(g, l, p, b, _, e[8], 1352829926, 11), l, p = o(p, 10), b, e[1], 1352829926, 14), g, l = o(l, 10), p, e[10], 1352829926, 14), g = u(g = o(g, 10), l = h(l, p = h(p, b, _, g, l, e[3], 1352829926, 12), b, _ = o(_, 10), g, e[12], 1352829926, 6), p, b = o(b, 10), _, e[6], 1548603684, 9), p = u(p = o(p, 10), b = u(b, _ = u(_, g, l, p, b, e[11], 1548603684, 13), g, l = o(l, 10), p, e[3], 1548603684, 15), _, g = o(g, 10), l, e[7], 1548603684, 7), _ = u(_ = o(_, 10), g = u(g, l = u(l, p, b, _, g, e[0], 1548603684, 12), p, b = o(b, 10), _, e[13], 1548603684, 8), l, p = o(p, 10), b, e[5], 1548603684, 9), l = u(l = o(l, 10), p = u(p, b = u(b, _, g, l, p, e[10], 1548603684, 11), _, g = o(g, 10), l, e[14], 1548603684, 7), b, _ = o(_, 10), g, e[15], 1548603684, 7), b = u(b = o(b, 10), _ = u(_, g = u(g, l, p, b, _, e[8], 1548603684, 12), l, p = o(p, 10), b, e[12], 1548603684, 7), g, l = o(l, 10), p, e[4], 1548603684, 6), g = u(g = o(g, 10), l = u(l, p = u(p, b, _, g, l, e[9], 1548603684, 15), b, _ = o(_, 10), g, e[1], 1548603684, 13), p, b = o(b, 10), _, e[2], 1548603684, 11), p = c(p = o(p, 10), b = c(b, _ = c(_, g, l, p, b, e[15], 1836072691, 9), g, l = o(l, 10), p, e[5], 1836072691, 7), _, g = o(g, 10), l, e[1], 1836072691, 15), _ = c(_ = o(_, 10), g = c(g, l = c(l, p, b, _, g, e[3], 1836072691, 11), p, b = o(b, 10), _, e[7], 1836072691, 8), l, p = o(p, 10), b, e[14], 1836072691, 6), l = c(l = o(l, 10), p = c(p, b = c(b, _, g, l, p, e[6], 1836072691, 6), _, g = o(g, 10), l, e[9], 1836072691, 14), b, _ = o(_, 10), g, e[11], 1836072691, 12), b = c(b = o(b, 10), _ = c(_, g = c(g, l, p, b, _, e[8], 1836072691, 13), l, p = o(p, 10), b, e[12], 1836072691, 5), g, l = o(l, 10), p, e[2], 1836072691, 14), g = c(g = o(g, 10), l = c(l, p = c(p, b, _, g, l, e[10], 1836072691, 13), b, _ = o(_, 10), g, e[0], 1836072691, 13), p, b = o(b, 10), _, e[4], 1836072691, 7), p = f(p = o(p, 10), b = f(b, _ = c(_, g, l, p, b, e[13], 1836072691, 5), g, l = o(l, 10), p, e[8], 2053994217, 15), _, g = o(g, 10), l, e[6], 2053994217, 5), _ = f(_ = o(_, 10), g = f(g, l = f(l, p, b, _, g, e[4], 2053994217, 8), p, b = o(b, 10), _, e[1], 2053994217, 11), l, p = o(p, 10), b, e[3], 2053994217, 14), l = f(l = o(l, 10), p = f(p, b = f(b, _, g, l, p, e[11], 2053994217, 14), _, g = o(g, 10), l, e[15], 2053994217, 6), b, _ = o(_, 10), g, e[0], 2053994217, 14), b = f(b = o(b, 10), _ = f(_, g = f(g, l, p, b, _, e[5], 2053994217, 6), l, p = o(p, 10), b, e[12], 2053994217, 9), g, l = o(l, 10), p, e[2], 2053994217, 12), g = f(g = o(g, 10), l = f(l, p = f(p, b, _, g, l, e[13], 2053994217, 9), b, _ = o(_, 10), g, e[9], 2053994217, 12), p, b = o(b, 10), _, e[7], 2053994217, 5), p = a(p = o(p, 10), b = f(b, _ = f(_, g, l, p, b, e[10], 2053994217, 15), g, l = o(l, 10), p, e[14], 2053994217, 8), _, g = o(g, 10), l, e[12], 0, 8), _ = a(_ = o(_, 10), g = a(g, l = a(l, p, b, _, g, e[15], 0, 5), p, b = o(b, 10), _, e[10], 0, 12), l, p = o(p, 10), b, e[4], 0, 9), l = a(l = o(l, 10), p = a(p, b = a(b, _, g, l, p, e[1], 0, 12), _, g = o(g, 10), l, e[5], 0, 5), b, _ = o(_, 10), g, e[8], 0, 14), b = a(b = o(b, 10), _ = a(_, g = a(g, l, p, b, _, e[7], 0, 6), l, p = o(p, 10), b, e[6], 0, 8), g, l = o(l, 10), p, e[2], 0, 13), g = a(g = o(g, 10), l = a(l, p = a(p, b, _, g, l, e[13], 0, 6), b, _ = o(_, 10), g, e[14], 0, 5), p, b = o(b, 10), _, e[0], 0, 15), p = a(p = o(p, 10), b = a(b, _ = a(_, g, l, p, b, e[3], 0, 13), g, l = o(l, 10), p, e[9], 0, 11), _, g = o(g, 10), l, e[11], 0, 11), _ = o(_, 10);
        var v = this._b + i + _ | 0;
        this._b = this._c + s + g | 0, this._c = this._d + d + l | 0, this._d = this._e + r + p | 0, this._e = this._a + n + b | 0, this._a = v;
      }, s.prototype._digest = function () {
        this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
        var e = new t(20);
        return e.writeInt32LE(this._a, 0), e.writeInt32LE(this._b, 4), e.writeInt32LE(this._c, 8), e.writeInt32LE(this._d, 12), e.writeInt32LE(this._e, 16), e;
      }, e.exports = s;
    }).call(this, r(3).Buffer);
  }, function (e, t, r) {
    "use strict";

    var n = r(243);

    function i(e, t) {
      e[t >> 5] |= 128 << t % 32, e[14 + (t + 64 >>> 9 << 4)] = t;

      for (var r = 1732584193, n = -271733879, i = -1732584194, s = 271733878, h = 0; h < e.length; h += 16) {
        var d = r,
            l = n,
            p = i,
            b = s;
        n = c(n = c(n = c(n = c(n = f(n = f(n = f(n = f(n = a(n = a(n = a(n = a(n = o(n = o(n = o(n = o(n, i = o(i, s = o(s, r = o(r, n, i, s, e[h + 0], 7, -680876936), n, i, e[h + 1], 12, -389564586), r, n, e[h + 2], 17, 606105819), s, r, e[h + 3], 22, -1044525330), i = o(i, s = o(s, r = o(r, n, i, s, e[h + 4], 7, -176418897), n, i, e[h + 5], 12, 1200080426), r, n, e[h + 6], 17, -1473231341), s, r, e[h + 7], 22, -45705983), i = o(i, s = o(s, r = o(r, n, i, s, e[h + 8], 7, 1770035416), n, i, e[h + 9], 12, -1958414417), r, n, e[h + 10], 17, -42063), s, r, e[h + 11], 22, -1990404162), i = o(i, s = o(s, r = o(r, n, i, s, e[h + 12], 7, 1804603682), n, i, e[h + 13], 12, -40341101), r, n, e[h + 14], 17, -1502002290), s, r, e[h + 15], 22, 1236535329), i = a(i, s = a(s, r = a(r, n, i, s, e[h + 1], 5, -165796510), n, i, e[h + 6], 9, -1069501632), r, n, e[h + 11], 14, 643717713), s, r, e[h + 0], 20, -373897302), i = a(i, s = a(s, r = a(r, n, i, s, e[h + 5], 5, -701558691), n, i, e[h + 10], 9, 38016083), r, n, e[h + 15], 14, -660478335), s, r, e[h + 4], 20, -405537848), i = a(i, s = a(s, r = a(r, n, i, s, e[h + 9], 5, 568446438), n, i, e[h + 14], 9, -1019803690), r, n, e[h + 3], 14, -187363961), s, r, e[h + 8], 20, 1163531501), i = a(i, s = a(s, r = a(r, n, i, s, e[h + 13], 5, -1444681467), n, i, e[h + 2], 9, -51403784), r, n, e[h + 7], 14, 1735328473), s, r, e[h + 12], 20, -1926607734), i = f(i, s = f(s, r = f(r, n, i, s, e[h + 5], 4, -378558), n, i, e[h + 8], 11, -2022574463), r, n, e[h + 11], 16, 1839030562), s, r, e[h + 14], 23, -35309556), i = f(i, s = f(s, r = f(r, n, i, s, e[h + 1], 4, -1530992060), n, i, e[h + 4], 11, 1272893353), r, n, e[h + 7], 16, -155497632), s, r, e[h + 10], 23, -1094730640), i = f(i, s = f(s, r = f(r, n, i, s, e[h + 13], 4, 681279174), n, i, e[h + 0], 11, -358537222), r, n, e[h + 3], 16, -722521979), s, r, e[h + 6], 23, 76029189), i = f(i, s = f(s, r = f(r, n, i, s, e[h + 9], 4, -640364487), n, i, e[h + 12], 11, -421815835), r, n, e[h + 15], 16, 530742520), s, r, e[h + 2], 23, -995338651), i = c(i, s = c(s, r = c(r, n, i, s, e[h + 0], 6, -198630844), n, i, e[h + 7], 10, 1126891415), r, n, e[h + 14], 15, -1416354905), s, r, e[h + 5], 21, -57434055), i = c(i, s = c(s, r = c(r, n, i, s, e[h + 12], 6, 1700485571), n, i, e[h + 3], 10, -1894986606), r, n, e[h + 10], 15, -1051523), s, r, e[h + 1], 21, -2054922799), i = c(i, s = c(s, r = c(r, n, i, s, e[h + 8], 6, 1873313359), n, i, e[h + 15], 10, -30611744), r, n, e[h + 6], 15, -1560198380), s, r, e[h + 13], 21, 1309151649), i = c(i, s = c(s, r = c(r, n, i, s, e[h + 4], 6, -145523070), n, i, e[h + 11], 10, -1120210379), r, n, e[h + 2], 15, 718787259), s, r, e[h + 9], 21, -343485551), r = u(r, d), n = u(n, l), i = u(i, p), s = u(s, b);
      }

      return [r, n, i, s];
    }

    function s(e, t, r, n, i, s) {
      return u((o = u(u(t, e), u(n, s))) << (a = i) | o >>> 32 - a, r);
      var o, a;
    }

    function o(e, t, r, n, i, o, a) {
      return s(t & r | ~t & n, e, t, i, o, a);
    }

    function a(e, t, r, n, i, o, a) {
      return s(t & n | r & ~n, e, t, i, o, a);
    }

    function f(e, t, r, n, i, o, a) {
      return s(t ^ r ^ n, e, t, i, o, a);
    }

    function c(e, t, r, n, i, o, a) {
      return s(r ^ (t | ~n), e, t, i, o, a);
    }

    function u(e, t) {
      var r = (65535 & e) + (65535 & t);
      return (e >> 16) + (t >> 16) + (r >> 16) << 16 | 65535 & r;
    }

    e.exports = function (e) {
      return n(e, i);
    };
  }, function (e, t, r) {
    "use strict";

    t.randomBytes = t.rng = t.pseudoRandomBytes = t.prng = r(22), t.createHash = t.Hash = r(31), t.createHmac = t.Hmac = r(100);
    var n = r(225),
        i = Object.keys(n),
        s = ["sha1", "sha224", "sha256", "sha384", "sha512", "md5", "rmd160"].concat(i);

    t.getHashes = function () {
      return s;
    };

    var o = r(98);
    t.pbkdf2 = o.pbkdf2, t.pbkdf2Sync = o.pbkdf2Sync;
    var a = r(223);
    t.Cipher = a.Cipher, t.createCipher = a.createCipher, t.Cipheriv = a.Cipheriv, t.createCipheriv = a.createCipheriv, t.Decipher = a.Decipher, t.createDecipher = a.createDecipher, t.Decipheriv = a.Decipheriv, t.createDecipheriv = a.createDecipheriv, t.getCiphers = a.getCiphers, t.listCiphers = a.listCiphers;
    var f = r(204);
    t.DiffieHellmanGroup = f.DiffieHellmanGroup, t.createDiffieHellmanGroup = f.createDiffieHellmanGroup, t.getDiffieHellman = f.getDiffieHellman, t.createDiffieHellman = f.createDiffieHellman, t.DiffieHellman = f.DiffieHellman;
    var c = r(199);
    t.createSign = c.createSign, t.Sign = c.Sign, t.createVerify = c.createVerify, t.Verify = c.Verify, t.createECDH = r(161);
    var u = r(160);
    t.publicEncrypt = u.publicEncrypt, t.privateEncrypt = u.privateEncrypt, t.publicDecrypt = u.publicDecrypt, t.privateDecrypt = u.privateDecrypt;
    var h = r(157);
    t.randomFill = h.randomFill, t.randomFillSync = h.randomFillSync, t.createCredentials = function () {
      throw new Error(["sorry, createCredentials is not implemented yet", "we accept pull requests", "https://github.com/crypto-browserify/crypto-browserify"].join("\n"));
    }, t.constants = {
      DH_CHECK_P_NOT_SAFE_PRIME: 2,
      DH_CHECK_P_NOT_PRIME: 1,
      DH_UNABLE_TO_CHECK_GENERATOR: 4,
      DH_NOT_SUITABLE_GENERATOR: 8,
      NPN_ENABLED: 1,
      ALPN_ENABLED: 1,
      RSA_PKCS1_PADDING: 1,
      RSA_SSLV23_PADDING: 2,
      RSA_NO_PADDING: 3,
      RSA_PKCS1_OAEP_PADDING: 4,
      RSA_X931_PADDING: 5,
      RSA_PKCS1_PSS_PADDING: 6,
      POINT_CONVERSION_COMPRESSED: 2,
      POINT_CONVERSION_UNCOMPRESSED: 4,
      POINT_CONVERSION_HYBRID: 6
    };
  }, function (e, t, r) {
    (function (e) {
      var n = /%[sdj%]/g;
      t.format = function (e) {
        if (!_(e)) {
          for (var t = [], r = 0; r < arguments.length; r++) {
            t.push(o(arguments[r]));
          }

          return t.join(" ");
        }

        r = 1;

        for (var i = arguments, s = i.length, a = String(e).replace(n, function (e) {
          if ("%%" === e) return "%";
          if (r >= s) return e;

          switch (e) {
            case "%s":
              return String(i[r++]);

            case "%d":
              return Number(i[r++]);

            case "%j":
              try {
                return JSON.stringify(i[r++]);
              } catch (e) {
                return "[Circular]";
              }

            default:
              return e;
          }
        }), f = i[r]; r < s; f = i[++r]) {
          p(f) || !m(f) ? a += " " + f : a += " " + o(f);
        }

        return a;
      }, t.deprecate = function (r, n) {
        if (g(e.process)) return function () {
          return t.deprecate(r, n).apply(this, arguments);
        };
        if (!0 === process.noDeprecation) return r;
        var i = !1;
        return function () {
          if (!i) {
            if (process.throwDeprecation) throw new Error(n);
            process.traceDeprecation ? console.trace(n) : console.error(n), i = !0;
          }

          return r.apply(this, arguments);
        };
      };
      var i,
          s = {};

      function o(e, r) {
        var n = {
          seen: [],
          stylize: f
        };
        return arguments.length >= 3 && (n.depth = arguments[2]), arguments.length >= 4 && (n.colors = arguments[3]), l(r) ? n.showHidden = r : r && t._extend(n, r), g(n.showHidden) && (n.showHidden = !1), g(n.depth) && (n.depth = 2), g(n.colors) && (n.colors = !1), g(n.customInspect) && (n.customInspect = !0), n.colors && (n.stylize = a), c(n, e, n.depth);
      }

      function a(e, t) {
        var r = o.styles[t];
        return r ? "[" + o.colors[r][0] + "m" + e + "[" + o.colors[r][1] + "m" : e;
      }

      function f(e, t) {
        return e;
      }

      function c(e, r, n) {
        if (e.customInspect && r && k(r.inspect) && r.inspect !== t.inspect && (!r.constructor || r.constructor.prototype !== r)) {
          var i = r.inspect(n, e);
          return _(i) || (i = c(e, i, n)), i;
        }

        var s = function (e, t) {
          if (g(t)) return e.stylize("undefined", "undefined");

          if (_(t)) {
            var r = "'" + JSON.stringify(t).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
            return e.stylize(r, "string");
          }

          if (b(t)) return e.stylize("" + t, "number");
          if (l(t)) return e.stylize("" + t, "boolean");
          if (p(t)) return e.stylize("null", "null");
        }(e, r);

        if (s) return s;

        var o = Object.keys(r),
            a = function (e) {
          var t = {};
          return e.forEach(function (e, r) {
            t[e] = !0;
          }), t;
        }(o);

        if (e.showHidden && (o = Object.getOwnPropertyNames(r)), w(r) && (o.indexOf("message") >= 0 || o.indexOf("description") >= 0)) return u(r);

        if (0 === o.length) {
          if (k(r)) {
            var f = r.name ? ": " + r.name : "";
            return e.stylize("[Function" + f + "]", "special");
          }

          if (v(r)) return e.stylize(RegExp.prototype.toString.call(r), "regexp");
          if (y(r)) return e.stylize(Date.prototype.toString.call(r), "date");
          if (w(r)) return u(r);
        }

        var m,
            S = "",
            E = !1,
            A = ["{", "}"];
        (d(r) && (E = !0, A = ["[", "]"]), k(r)) && (S = " [Function" + (r.name ? ": " + r.name : "") + "]");
        return v(r) && (S = " " + RegExp.prototype.toString.call(r)), y(r) && (S = " " + Date.prototype.toUTCString.call(r)), w(r) && (S = " " + u(r)), 0 !== o.length || E && 0 != r.length ? n < 0 ? v(r) ? e.stylize(RegExp.prototype.toString.call(r), "regexp") : e.stylize("[Object]", "special") : (e.seen.push(r), m = E ? function (e, t, r, n, i) {
          for (var s = [], o = 0, a = t.length; o < a; ++o) {
            x(t, String(o)) ? s.push(h(e, t, r, n, String(o), !0)) : s.push("");
          }

          return i.forEach(function (i) {
            i.match(/^\d+$/) || s.push(h(e, t, r, n, i, !0));
          }), s;
        }(e, r, n, a, o) : o.map(function (t) {
          return h(e, r, n, a, t, E);
        }), e.seen.pop(), function (e, t, r) {
          if (e.reduce(function (e, t) {
            return 0, t.indexOf("\n") >= 0 && 0, e + t.replace(/\u001b\[\d\d?m/g, "").length + 1;
          }, 0) > 60) return r[0] + ("" === t ? "" : t + "\n ") + " " + e.join(",\n  ") + " " + r[1];
          return r[0] + t + " " + e.join(", ") + " " + r[1];
        }(m, S, A)) : A[0] + S + A[1];
      }

      function u(e) {
        return "[" + Error.prototype.toString.call(e) + "]";
      }

      function h(e, t, r, n, i, s) {
        var o, a, f;

        if ((f = Object.getOwnPropertyDescriptor(t, i) || {
          value: t[i]
        }).get ? a = f.set ? e.stylize("[Getter/Setter]", "special") : e.stylize("[Getter]", "special") : f.set && (a = e.stylize("[Setter]", "special")), x(n, i) || (o = "[" + i + "]"), a || (e.seen.indexOf(f.value) < 0 ? (a = p(r) ? c(e, f.value, null) : c(e, f.value, r - 1)).indexOf("\n") > -1 && (a = s ? a.split("\n").map(function (e) {
          return "  " + e;
        }).join("\n").substr(2) : "\n" + a.split("\n").map(function (e) {
          return "   " + e;
        }).join("\n")) : a = e.stylize("[Circular]", "special")), g(o)) {
          if (s && i.match(/^\d+$/)) return a;
          (o = JSON.stringify("" + i)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (o = o.substr(1, o.length - 2), o = e.stylize(o, "name")) : (o = o.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), o = e.stylize(o, "string"));
        }

        return o + ": " + a;
      }

      function d(e) {
        return Array.isArray(e);
      }

      function l(e) {
        return "boolean" == typeof e;
      }

      function p(e) {
        return null === e;
      }

      function b(e) {
        return "number" == typeof e;
      }

      function _(e) {
        return "string" == typeof e;
      }

      function g(e) {
        return void 0 === e;
      }

      function v(e) {
        return m(e) && "[object RegExp]" === S(e);
      }

      function m(e) {
        return "object" == typeof e && null !== e;
      }

      function y(e) {
        return m(e) && "[object Date]" === S(e);
      }

      function w(e) {
        return m(e) && ("[object Error]" === S(e) || e instanceof Error);
      }

      function k(e) {
        return "function" == typeof e;
      }

      function S(e) {
        return Object.prototype.toString.call(e);
      }

      function E(e) {
        return e < 10 ? "0" + e.toString(10) : e.toString(10);
      }

      t.debuglog = function (e) {
        if (g(i) && (i = process.env.NODE_DEBUG || ""), e = e.toUpperCase(), !s[e]) if (new RegExp("\\b" + e + "\\b", "i").test(i)) {
          var r = process.pid;

          s[e] = function () {
            var n = t.format.apply(t, arguments);
            console.error("%s %d: %s", e, r, n);
          };
        } else s[e] = function () {};
        return s[e];
      }, t.inspect = o, o.colors = {
        bold: [1, 22],
        italic: [3, 23],
        underline: [4, 24],
        inverse: [7, 27],
        white: [37, 39],
        grey: [90, 39],
        black: [30, 39],
        blue: [34, 39],
        cyan: [36, 39],
        green: [32, 39],
        magenta: [35, 39],
        red: [31, 39],
        yellow: [33, 39]
      }, o.styles = {
        special: "cyan",
        number: "yellow",
        boolean: "yellow",
        undefined: "grey",
        null: "bold",
        string: "green",
        date: "magenta",
        regexp: "red"
      }, t.isArray = d, t.isBoolean = l, t.isNull = p, t.isNullOrUndefined = function (e) {
        return null == e;
      }, t.isNumber = b, t.isString = _, t.isSymbol = function (e) {
        return "symbol" == typeof e;
      }, t.isUndefined = g, t.isRegExp = v, t.isObject = m, t.isDate = y, t.isError = w, t.isFunction = k, t.isPrimitive = function (e) {
        return null === e || "boolean" == typeof e || "number" == typeof e || "string" == typeof e || "symbol" == typeof e || void 0 === e;
      }, t.isBuffer = r(249);
      var A = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

      function x(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }

      t.log = function () {
        var e, r;
        console.log("%s - %s", (e = new Date(), r = [E(e.getHours()), E(e.getMinutes()), E(e.getSeconds())].join(":"), [e.getDate(), A[e.getMonth()], r].join(" ")), t.format.apply(t, arguments));
      }, t.inherits = r(248), t._extend = function (e, t) {
        if (!t || !m(t)) return e;

        for (var r = Object.keys(t), n = r.length; n--;) {
          e[r[n]] = t[r[n]];
        }

        return e;
      };
    }).call(this, r(9));
  }, function (e, t) {
    e.exports = function (e) {
      return e.webpackPolyfill || (e.deprecate = function () {}, e.paths = [], e.children || (e.children = []), Object.defineProperty(e, "loaded", {
        enumerable: !0,
        get: function get() {
          return e.l;
        }
      }), Object.defineProperty(e, "id", {
        enumerable: !0,
        get: function get() {
          return e.i;
        }
      }), e.webpackPolyfill = 1), e;
    };
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      this.message = e;
    }

    n.prototype.toString = function () {
      return "Cancel" + (this.message ? ": " + this.message : "");
    }, n.prototype.__CANCEL__ = !0, e.exports = n;
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e) {
      return !(!e || !e.__CANCEL__);
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(125);

    e.exports = function (e, t, r, i, s) {
      var o = new Error(e);
      return n(o, t, r, i, s);
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(12),
        i = r(126),
        s = r(124),
        o = r(123),
        a = r(122),
        f = r(62),
        c = "undefined" != typeof window && window.btoa && window.btoa.bind(window) || r(121);

    e.exports = function (e) {
      return new Promise(function (t, u) {
        var h = e.data,
            d = e.headers;
        n.isFormData(h) && delete d["Content-Type"];
        var l = new XMLHttpRequest(),
            p = "onreadystatechange",
            b = !1;

        if ("undefined" == typeof window || !window.XDomainRequest || "withCredentials" in l || a(e.url) || (l = new window.XDomainRequest(), p = "onload", b = !0, l.onprogress = function () {}, l.ontimeout = function () {}), e.auth) {
          var _ = e.auth.username || "",
              g = e.auth.password || "";

          d.Authorization = "Basic " + c(_ + ":" + g);
        }

        if (l.open(e.method.toUpperCase(), s(e.url, e.params, e.paramsSerializer), !0), l.timeout = e.timeout, l[p] = function () {
          if (l && (4 === l.readyState || b) && (0 !== l.status || l.responseURL && 0 === l.responseURL.indexOf("file:"))) {
            var r = "getAllResponseHeaders" in l ? o(l.getAllResponseHeaders()) : null,
                n = {
              data: e.responseType && "text" !== e.responseType ? l.response : l.responseText,
              status: 1223 === l.status ? 204 : l.status,
              statusText: 1223 === l.status ? "No Content" : l.statusText,
              headers: r,
              config: e,
              request: l
            };
            i(t, u, n), l = null;
          }
        }, l.onerror = function () {
          u(f("Network Error", e, null, l)), l = null;
        }, l.ontimeout = function () {
          u(f("timeout of " + e.timeout + "ms exceeded", e, "ECONNABORTED", l)), l = null;
        }, n.isStandardBrowserEnv()) {
          var v = r(120),
              m = (e.withCredentials || a(e.url)) && e.xsrfCookieName ? v.read(e.xsrfCookieName) : void 0;
          m && (d[e.xsrfHeaderName] = m);
        }

        if ("setRequestHeader" in l && n.forEach(d, function (e, t) {
          void 0 === h && "content-type" === t.toLowerCase() ? delete d[t] : l.setRequestHeader(t, e);
        }), e.withCredentials && (l.withCredentials = !0), e.responseType) try {
          l.responseType = e.responseType;
        } catch (t) {
          if ("json" !== e.responseType) throw t;
        }
        "function" == typeof e.onDownloadProgress && l.addEventListener("progress", e.onDownloadProgress), "function" == typeof e.onUploadProgress && l.upload && l.upload.addEventListener("progress", e.onUploadProgress), e.cancelToken && e.cancelToken.promise.then(function (e) {
          l && (l.abort(), u(e), l = null);
        }), void 0 === h && (h = null), l.send(h);
      });
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e, t) {
      return function () {
        for (var r = new Array(arguments.length), n = 0; n < r.length; n++) {
          r[n] = arguments[n];
        }

        return e.apply(t, r);
      };
    };
  }, function (e, t, r) {
    "use strict";

    (function (t) {
      var n = r(57),
          i = r(34),
          s = r(44),
          o = r(67),
          a = r(24);

      var f =
      /*#__PURE__*/
      function () {
        function f(e, t) {
          _classCallCheck(this, f);

          this._extensions = t || {}, this._socket = e, this._firstFragment = !0, this._compress = !1, this._bufferedBytes = 0, this._deflating = !1, this._queue = [];
        }

        _createClass(f, [{
          key: "close",
          value: function close(e, r, n, i) {
            var s;
            if (void 0 === e) s = a.EMPTY_BUFFER;else {
              if ("number" != typeof e || !o.isValidStatusCode(e)) throw new TypeError("First argument must be a valid error code number");
              void 0 === r || "" === r ? (s = t.allocUnsafe(2)).writeUInt16BE(e, 0) : ((s = t.allocUnsafe(2 + t.byteLength(r))).writeUInt16BE(e, 0), s.write(r, 2));
            }
            this._deflating ? this.enqueue([this.doClose, s, n, i]) : this.doClose(s, n, i);
          }
        }, {
          key: "doClose",
          value: function doClose(e, t, r) {
            this.sendFrame(f.frame(e, {
              fin: !0,
              rsv1: !1,
              opcode: 8,
              mask: t,
              readOnly: !1
            }), r);
          }
        }, {
          key: "ping",
          value: function ping(e, r, n) {
            var i = !0;
            t.isBuffer(e) || (e instanceof ArrayBuffer ? e = t.from(e) : ArrayBuffer.isView(e) ? e = c(e) : (e = t.from(e), i = !1)), this._deflating ? this.enqueue([this.doPing, e, r, i, n]) : this.doPing(e, r, i, n);
          }
        }, {
          key: "doPing",
          value: function doPing(e, t, r, n) {
            this.sendFrame(f.frame(e, {
              fin: !0,
              rsv1: !1,
              opcode: 9,
              mask: t,
              readOnly: r
            }), n);
          }
        }, {
          key: "pong",
          value: function pong(e, r, n) {
            var i = !0;
            t.isBuffer(e) || (e instanceof ArrayBuffer ? e = t.from(e) : ArrayBuffer.isView(e) ? e = c(e) : (e = t.from(e), i = !1)), this._deflating ? this.enqueue([this.doPong, e, r, i, n]) : this.doPong(e, r, i, n);
          }
        }, {
          key: "doPong",
          value: function doPong(e, t, r, n) {
            this.sendFrame(f.frame(e, {
              fin: !0,
              rsv1: !1,
              opcode: 10,
              mask: t,
              readOnly: r
            }), n);
          }
        }, {
          key: "send",
          value: function send(e, r, n) {
            var s = r.binary ? 2 : 1,
                o = r.compress,
                a = !0;
            t.isBuffer(e) || (e instanceof ArrayBuffer ? e = t.from(e) : ArrayBuffer.isView(e) ? e = c(e) : (e = t.from(e), a = !1));
            var u = this._extensions[i.extensionName];

            if (this._firstFragment ? (this._firstFragment = !1, o && u && (o = e.length >= u._threshold), this._compress = o) : (o = !1, s = 0), r.fin && (this._firstFragment = !0), u) {
              var _t22 = {
                fin: r.fin,
                rsv1: o,
                opcode: s,
                mask: r.mask,
                readOnly: a
              };
              this._deflating ? this.enqueue([this.dispatch, e, this._compress, _t22, n]) : this.dispatch(e, this._compress, _t22, n);
            } else this.sendFrame(f.frame(e, {
              fin: r.fin,
              rsv1: !1,
              opcode: s,
              mask: r.mask,
              readOnly: a
            }), n);
          }
        }, {
          key: "dispatch",
          value: function dispatch(e, t, r, n) {
            var _this50 = this;

            if (!t) return void this.sendFrame(f.frame(e, r), n);
            var s = this._extensions[i.extensionName];
            this._deflating = !0, s.compress(e, r.fin, function (e, t) {
              r.readOnly = !1, _this50.sendFrame(f.frame(t, r), n), _this50._deflating = !1, _this50.dequeue();
            });
          }
        }, {
          key: "dequeue",
          value: function dequeue() {
            for (; !this._deflating && this._queue.length;) {
              var _e13 = this._queue.shift();

              this._bufferedBytes -= _e13[1].length, _e13[0].apply(this, _e13.slice(1));
            }
          }
        }, {
          key: "enqueue",
          value: function enqueue(e) {
            this._bufferedBytes += e[1].length, this._queue.push(e);
          }
        }, {
          key: "sendFrame",
          value: function sendFrame(e, t) {
            2 === e.length ? (this._socket.write(e[0]), this._socket.write(e[1], t)) : this._socket.write(e[0], t);
          }
        }], [{
          key: "frame",
          value: function frame(e, r) {
            var i = e.length < 1024 || r.mask && r.readOnly;
            var o = r.mask ? 6 : 2,
                a = e.length;
            e.length >= 65536 ? (o += 8, a = 127) : e.length > 125 && (o += 2, a = 126);
            var f = t.allocUnsafe(i ? e.length + o : o);
            if (f[0] = r.fin ? 128 | r.opcode : r.opcode, r.rsv1 && (f[0] |= 64), 126 === a ? f.writeUInt16BE(e.length, 2) : 127 === a && (f.writeUInt32BE(0, 2), f.writeUInt32BE(e.length, 6)), !r.mask) return f[1] = a, i ? (e.copy(f, o), [f]) : [f, e];
            var c = n.randomBytes(4);
            return f[1] = 128 | a, f[o - 4] = c[0], f[o - 3] = c[1], f[o - 2] = c[2], f[o - 1] = c[3], i ? (s.mask(e, c, f, o, e.length), [f]) : (s.mask(e, c, e, 0, e.length), [f, e]);
          }
        }]);

        return f;
      }();

      function c(e) {
        var r = t.from(e.buffer);
        return e.byteLength !== e.buffer.byteLength ? r.slice(e.byteOffset, e.byteOffset + e.byteLength) : r;
      }

      e.exports = f;
    }).call(this, r(3).Buffer);
  }, function (e, t) {
    function r(e) {
      var t = new Error('Cannot find module "' + e + '".');
      throw t.code = "MODULE_NOT_FOUND", t;
    }

    r.keys = function () {
      return [];
    }, r.resolve = r, e.exports = r, r.id = 66;
  }, function (e, t, r) {
    "use strict";

    try {
      var _e14 = r(134);

      t.isValidUTF8 = "object" == typeof _e14 ? _e14.Validation.isValidUTF8 : _e14;
    } catch (e) {
      t.isValidUTF8 = function () {
        return !0;
      };
    }

    t.isValidStatusCode = function (e) {
      return e >= 1e3 && e <= 1013 && 1004 !== e && 1005 !== e && 1006 !== e || e >= 3e3 && e <= 4999;
    };
  }, function (e, t, r) {
    "use strict";

    (function (t) {
      var n = r(21),
          i = r(34),
          s = r(44),
          o = r(67),
          a = r(24),
          f = 0,
          c = 1,
          u = 2,
          h = 3,
          d = 4,
          l = 5;

      function p(e, t, r, n) {
        var i = new e(r ? "Invalid WebSocket frame: ".concat(t) : t);
        return Error.captureStackTrace(i, p), i[a.kStatusCode] = n, i;
      }

      function b(e, t) {
        return 1 === e.length ? e[0] : e.length > 1 ? s.concat(e, t) : a.EMPTY_BUFFER;
      }

      e.exports =
      /*#__PURE__*/
      function (_n$Writable) {
        _inherits(_class3, _n$Writable);

        function _class3(e, t, r) {
          var _this51;

          _classCallCheck(this, _class3);

          _this51 = _possibleConstructorReturn(this, _getPrototypeOf(_class3).call(this)), _this51._binaryType = e || a.BINARY_TYPES[0], _this51[a.kWebSocket] = void 0, _this51._extensions = t || {}, _this51._maxPayload = 0 | r, _this51._bufferedBytes = 0, _this51._buffers = [], _this51._compressed = !1, _this51._payloadLength = 0, _this51._mask = void 0, _this51._fragmented = 0, _this51._masked = !1, _this51._fin = !1, _this51._opcode = 0, _this51._totalPayloadLength = 0, _this51._messageLength = 0, _this51._fragments = [], _this51._state = f, _this51._loop = !1;
          return _this51;
        }

        _createClass(_class3, [{
          key: "_write",
          value: function _write(e, t, r) {
            if (8 === this._opcode) return r();
            this._bufferedBytes += e.length, this._buffers.push(e), this.startLoop(r);
          }
        }, {
          key: "consume",
          value: function consume(e) {
            if (this._bufferedBytes -= e, e === this._buffers[0].length) return this._buffers.shift();

            if (e < this._buffers[0].length) {
              var _t23 = this._buffers[0];
              return this._buffers[0] = _t23.slice(e), _t23.slice(0, e);
            }

            var r = t.allocUnsafe(e);

            do {
              var _t24 = this._buffers[0];
              e >= _t24.length ? this._buffers.shift().copy(r, r.length - e) : (_t24.copy(r, r.length - e, 0, e), this._buffers[0] = _t24.slice(e)), e -= _t24.length;
            } while (e > 0);

            return r;
          }
        }, {
          key: "startLoop",
          value: function startLoop(e) {
            var t;
            this._loop = !0;

            do {
              switch (this._state) {
                case f:
                  t = this.getInfo();
                  break;

                case c:
                  t = this.getPayloadLength16();
                  break;

                case u:
                  t = this.getPayloadLength64();
                  break;

                case h:
                  this.getMask();
                  break;

                case d:
                  t = this.getData(e);
                  break;

                default:
                  return void (this._loop = !1);
              }
            } while (this._loop);

            e(t);
          }
        }, {
          key: "getInfo",
          value: function getInfo() {
            if (this._bufferedBytes < 2) return void (this._loop = !1);
            var e = this.consume(2);
            if (0 != (48 & e[0])) return this._loop = !1, p(RangeError, "RSV2 and RSV3 must be clear", !0, 1002);
            var t = 64 == (64 & e[0]);
            if (t && !this._extensions[i.extensionName]) return this._loop = !1, p(RangeError, "RSV1 must be clear", !0, 1002);

            if (this._fin = 128 == (128 & e[0]), this._opcode = 15 & e[0], this._payloadLength = 127 & e[1], 0 === this._opcode) {
              if (t) return this._loop = !1, p(RangeError, "RSV1 must be clear", !0, 1002);
              if (!this._fragmented) return this._loop = !1, p(RangeError, "invalid opcode 0", !0, 1002);
              this._opcode = this._fragmented;
            } else if (1 === this._opcode || 2 === this._opcode) {
              if (this._fragmented) return this._loop = !1, p(RangeError, "invalid opcode ".concat(this._opcode), !0, 1002);
              this._compressed = t;
            } else {
              if (!(this._opcode > 7 && this._opcode < 11)) return this._loop = !1, p(RangeError, "invalid opcode ".concat(this._opcode), !0, 1002);
              if (!this._fin) return this._loop = !1, p(RangeError, "FIN must be set", !0, 1002);
              if (t) return this._loop = !1, p(RangeError, "RSV1 must be clear", !0, 1002);
              if (this._payloadLength > 125) return this._loop = !1, p(RangeError, "invalid payload length ".concat(this._payloadLength), !0, 1002);
            }

            if (this._fin || this._fragmented || (this._fragmented = this._opcode), this._masked = 128 == (128 & e[1]), 126 === this._payloadLength) this._state = c;else {
              if (127 !== this._payloadLength) return this.haveLength();
              this._state = u;
            }
          }
        }, {
          key: "getPayloadLength16",
          value: function getPayloadLength16() {
            if (!(this._bufferedBytes < 2)) return this._payloadLength = this.consume(2).readUInt16BE(0), this.haveLength();
            this._loop = !1;
          }
        }, {
          key: "getPayloadLength64",
          value: function getPayloadLength64() {
            if (this._bufferedBytes < 8) return void (this._loop = !1);
            var e = this.consume(8),
                t = e.readUInt32BE(0);
            return t > Math.pow(2, 21) - 1 ? (this._loop = !1, p(RangeError, "Unsupported WebSocket frame: payload length > 2^53 - 1", !1, 1009)) : (this._payloadLength = t * Math.pow(2, 32) + e.readUInt32BE(4), this.haveLength());
          }
        }, {
          key: "haveLength",
          value: function haveLength() {
            if (this._payloadLength && this._opcode < 8 && (this._totalPayloadLength += this._payloadLength, this._totalPayloadLength > this._maxPayload && this._maxPayload > 0)) return this._loop = !1, p(RangeError, "Max payload size exceeded", !1, 1009);
            this._masked ? this._state = h : this._state = d;
          }
        }, {
          key: "getMask",
          value: function getMask() {
            this._bufferedBytes < 4 ? this._loop = !1 : (this._mask = this.consume(4), this._state = d);
          }
        }, {
          key: "getData",
          value: function getData(e) {
            var t = a.EMPTY_BUFFER;

            if (this._payloadLength) {
              if (this._bufferedBytes < this._payloadLength) return void (this._loop = !1);
              t = this.consume(this._payloadLength), this._masked && s.unmask(t, this._mask);
            }

            return this._opcode > 7 ? this.controlMessage(t) : this._compressed ? (this._state = l, void this.decompress(t, e)) : (t.length && (this._messageLength = this._totalPayloadLength, this._fragments.push(t)), this.dataMessage());
          }
        }, {
          key: "decompress",
          value: function decompress(e, t) {
            var _this52 = this;

            this._extensions[i.extensionName].decompress(e, this._fin, function (e, r) {
              if (e) return t(e);

              if (r.length) {
                if (_this52._messageLength += r.length, _this52._messageLength > _this52._maxPayload && _this52._maxPayload > 0) return t(p(RangeError, "Max payload size exceeded", !1, 1009));

                _this52._fragments.push(r);
              }

              var n = _this52.dataMessage();

              if (n) return t(n);

              _this52.startLoop(t);
            });
          }
        }, {
          key: "dataMessage",
          value: function dataMessage() {
            if (this._fin) {
              var _r16 = this._messageLength,
                  _n3 = this._fragments;

              if (this._totalPayloadLength = 0, this._messageLength = 0, this._fragmented = 0, this._fragments = [], 2 === this._opcode) {
                var e;
                e = "nodebuffer" === this._binaryType ? b(_n3, _r16) : "arraybuffer" === this._binaryType ? 0 === (t = b(_n3, _r16)).byteOffset && t.byteLength === t.buffer.byteLength ? t.buffer : t.buffer.slice(t.byteOffset, t.byteOffset + t.byteLength) : _n3, this.emit("message", e);
              } else {
                var _e15 = b(_n3, _r16);

                if (!o.isValidUTF8(_e15)) return this._loop = !1, p(Error, "invalid UTF-8 sequence", !0, 1007);
                this.emit("message", _e15.toString());
              }
            }

            var t;
            this._state = f;
          }
        }, {
          key: "controlMessage",
          value: function controlMessage(e) {
            if (8 !== this._opcode) 9 === this._opcode ? this.emit("ping", e) : this.emit("pong", e), this._state = f;else if (this._loop = !1, 0 === e.length) this.emit("conclude", 1005, ""), this.end();else {
              if (1 === e.length) return p(RangeError, "invalid payload length 1", !0, 1002);
              {
                var _t25 = e.readUInt16BE(0);

                if (!o.isValidStatusCode(_t25)) return p(RangeError, "invalid status code ".concat(_t25), !0, 1002);

                var _r17 = e.slice(2);

                if (!o.isValidUTF8(_r17)) return p(Error, "invalid UTF-8 sequence", !0, 1007);
                this.emit("conclude", _t25, _r17.toString()), this.end();
              }
            }
          }
        }]);

        return _class3;
      }(n.Writable);
    }).call(this, r(3).Buffer);
  }, function (e, t, r) {
    "use strict";

    var n = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 1, 1, 1, 1, 1, 0, 0, 1, 1, 0, 1, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 0, 1, 0];

    function i(e, t, r) {
      Object.prototype.hasOwnProperty.call(e, t) ? e[t].push(r) : e[t] = [r];
    }

    e.exports = {
      format: function format(e) {
        return Object.keys(e).map(function (t) {
          var r = e[t];
          return Array.isArray(r) || (r = [r]), r.map(function (e) {
            return [t].concat(Object.keys(e).map(function (t) {
              var r = e[t];
              return Array.isArray(r) || (r = [r]), r.map(function (e) {
                return !0 === e ? t : "".concat(t, "=").concat(e);
              }).join("; ");
            })).join("; ");
          }).join(", ");
        }).join(", ");
      },
      parse: function parse(e) {
        var t = {};
        if (void 0 === e || "" === e) return t;

        for (var r, s, o = {}, a = !1, f = !1, c = !1, u = -1, h = -1, d = 0; d < e.length; d++) {
          var _p = e.charCodeAt(d);

          if (void 0 === r) {
            if (-1 === h && 1 === n[_p]) -1 === u && (u = d);else if (32 === _p || 9 === _p) -1 === h && -1 !== u && (h = d);else {
              if (59 !== _p && 44 !== _p) throw new SyntaxError("Unexpected character at index ".concat(d));
              {
                if (-1 === u) throw new SyntaxError("Unexpected character at index ".concat(d));
                -1 === h && (h = d);

                var _n4 = e.slice(u, h);

                44 === _p ? (i(t, _n4, o), o = {}) : r = _n4, u = h = -1;
              }
            }
          } else if (void 0 === s) {
            if (-1 === h && 1 === n[_p]) -1 === u && (u = d);else if (32 === _p || 9 === _p) -1 === h && -1 !== u && (h = d);else if (59 === _p || 44 === _p) {
              if (-1 === u) throw new SyntaxError("Unexpected character at index ".concat(d));
              -1 === h && (h = d), i(o, e.slice(u, h), !0), 44 === _p && (i(t, r, o), o = {}, r = void 0), u = h = -1;
            } else {
              if (61 !== _p || -1 === u || -1 !== h) throw new SyntaxError("Unexpected character at index ".concat(d));
              s = e.slice(u, d), u = h = -1;
            }
          } else if (f) {
            if (1 !== n[_p]) throw new SyntaxError("Unexpected character at index ".concat(d));
            -1 === u ? u = d : a || (a = !0), f = !1;
          } else if (c) {
            if (1 === n[_p]) -1 === u && (u = d);else if (34 === _p && -1 !== u) c = !1, h = d;else {
              if (92 !== _p) throw new SyntaxError("Unexpected character at index ".concat(d));
              f = !0;
            }
          } else if (34 === _p && 61 === e.charCodeAt(d - 1)) c = !0;else if (-1 === h && 1 === n[_p]) -1 === u && (u = d);else if (-1 === u || 32 !== _p && 9 !== _p) {
            if (59 !== _p && 44 !== _p) throw new SyntaxError("Unexpected character at index ".concat(d));
            if (-1 === u) throw new SyntaxError("Unexpected character at index ".concat(d));
            -1 === h && (h = d);
            var l = e.slice(u, h);
            a && (l = l.replace(/\\/g, ""), a = !1), i(o, s, l), 44 === _p && (i(t, r, o), o = {}, r = void 0), s = void 0, u = h = -1;
          } else -1 === h && (h = d);
        }

        if (-1 === u || c) throw new SyntaxError("Unexpected end of input");
        -1 === h && (h = d);
        var p = e.slice(u, h);
        return void 0 === r ? i(t, p, {}) : (void 0 === s ? i(o, p, !0) : i(o, s, a ? p.replace(/\\/g, "") : p), i(t, r, o)), t;
      }
    };
  }, function (e, t, r) {
    "use strict";

    var n = function () {
      for (var e, t = [], r = 0; r < 256; r++) {
        e = r;

        for (var n = 0; n < 8; n++) {
          e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
        }

        t[r] = e;
      }

      return t;
    }();

    e.exports = function (e, t, r, i) {
      var s = n,
          o = i + r;
      e ^= -1;

      for (var a = i; a < o; a++) {
        e = e >>> 8 ^ s[255 & (e ^ t[a])];
      }

      return -1 ^ e;
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e, t, r, n) {
      for (var i = 65535 & e | 0, s = e >>> 16 & 65535 | 0, o = 0; 0 !== r;) {
        r -= o = r > 2e3 ? 2e3 : r;

        do {
          s = s + (i = i + t[n++] | 0) | 0;
        } while (--o);

        i %= 65521, s %= 65521;
      }

      return i | s << 16 | 0;
    };
  }, function (e, t, r) {
    "use strict";

    (function (t) {
      /*!
       * The buffer module from node.js, for the browser.
       *
       * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
       * @license  MIT
       */
      function n(e, t) {
        if (e === t) return 0;

        for (var r = e.length, n = t.length, i = 0, s = Math.min(r, n); i < s; ++i) {
          if (e[i] !== t[i]) {
            r = e[i], n = t[i];
            break;
          }
        }

        return r < n ? -1 : n < r ? 1 : 0;
      }

      function i(e) {
        return t.Buffer && "function" == typeof t.Buffer.isBuffer ? t.Buffer.isBuffer(e) : !(null == e || !e._isBuffer);
      }

      var s = r(58),
          o = Object.prototype.hasOwnProperty,
          a = Array.prototype.slice,
          f = "foo" === function () {}.name;

      function c(e) {
        return Object.prototype.toString.call(e);
      }

      function u(e) {
        return !i(e) && "function" == typeof t.ArrayBuffer && ("function" == typeof ArrayBuffer.isView ? ArrayBuffer.isView(e) : !!e && (e instanceof DataView || !!(e.buffer && e.buffer instanceof ArrayBuffer)));
      }

      var h = e.exports = g,
          d = /\s*function\s+([^\(\s]*)\s*/;

      function l(e) {
        if (s.isFunction(e)) {
          if (f) return e.name;
          var t = e.toString().match(d);
          return t && t[1];
        }
      }

      function p(e, t) {
        return "string" == typeof e ? e.length < t ? e : e.slice(0, t) : e;
      }

      function b(e) {
        if (f || !s.isFunction(e)) return s.inspect(e);
        var t = l(e);
        return "[Function" + (t ? ": " + t : "") + "]";
      }

      function _(e, t, r, n, i) {
        throw new h.AssertionError({
          message: r,
          actual: e,
          expected: t,
          operator: n,
          stackStartFunction: i
        });
      }

      function g(e, t) {
        e || _(e, !0, t, "==", h.ok);
      }

      function v(e, t, r, o) {
        if (e === t) return !0;
        if (i(e) && i(t)) return 0 === n(e, t);
        if (s.isDate(e) && s.isDate(t)) return e.getTime() === t.getTime();
        if (s.isRegExp(e) && s.isRegExp(t)) return e.source === t.source && e.global === t.global && e.multiline === t.multiline && e.lastIndex === t.lastIndex && e.ignoreCase === t.ignoreCase;

        if (null !== e && "object" == typeof e || null !== t && "object" == typeof t) {
          if (u(e) && u(t) && c(e) === c(t) && !(e instanceof Float32Array || e instanceof Float64Array)) return 0 === n(new Uint8Array(e.buffer), new Uint8Array(t.buffer));
          if (i(e) !== i(t)) return !1;
          var f = (o = o || {
            actual: [],
            expected: []
          }).actual.indexOf(e);
          return -1 !== f && f === o.expected.indexOf(t) || (o.actual.push(e), o.expected.push(t), function (e, t, r, n) {
            if (null === e || void 0 === e || null === t || void 0 === t) return !1;
            if (s.isPrimitive(e) || s.isPrimitive(t)) return e === t;
            if (r && Object.getPrototypeOf(e) !== Object.getPrototypeOf(t)) return !1;
            var i = m(e),
                o = m(t);
            if (i && !o || !i && o) return !1;
            if (i) return e = a.call(e), t = a.call(t), v(e, t, r);
            var f,
                c,
                u = k(e),
                h = k(t);
            if (u.length !== h.length) return !1;

            for (u.sort(), h.sort(), c = u.length - 1; c >= 0; c--) {
              if (u[c] !== h[c]) return !1;
            }

            for (c = u.length - 1; c >= 0; c--) {
              if (f = u[c], !v(e[f], t[f], r, n)) return !1;
            }

            return !0;
          }(e, t, r, o));
        }

        return r ? e === t : e == t;
      }

      function m(e) {
        return "[object Arguments]" == Object.prototype.toString.call(e);
      }

      function y(e, t) {
        if (!e || !t) return !1;
        if ("[object RegExp]" == Object.prototype.toString.call(t)) return t.test(e);

        try {
          if (e instanceof t) return !0;
        } catch (e) {}

        return !Error.isPrototypeOf(t) && !0 === t.call({}, e);
      }

      function w(e, t, r, n) {
        var i;
        if ("function" != typeof t) throw new TypeError('"block" argument must be a function');
        "string" == typeof r && (n = r, r = null), i = function (e) {
          var t;

          try {
            e();
          } catch (e) {
            t = e;
          }

          return t;
        }(t), n = (r && r.name ? " (" + r.name + ")." : ".") + (n ? " " + n : "."), e && !i && _(i, r, "Missing expected exception" + n);
        var o = "string" == typeof n,
            a = !e && s.isError(i),
            f = !e && i && !r;
        if ((a && o && y(i, r) || f) && _(i, r, "Got unwanted exception" + n), e && i && r && !y(i, r) || !e && i) throw i;
      }

      h.AssertionError = function (e) {
        var t;
        this.name = "AssertionError", this.actual = e.actual, this.expected = e.expected, this.operator = e.operator, e.message ? (this.message = e.message, this.generatedMessage = !1) : (this.message = p(b((t = this).actual), 128) + " " + t.operator + " " + p(b(t.expected), 128), this.generatedMessage = !0);
        var r = e.stackStartFunction || _;
        if (Error.captureStackTrace) Error.captureStackTrace(this, r);else {
          var n = new Error();

          if (n.stack) {
            var i = n.stack,
                s = l(r),
                o = i.indexOf("\n" + s);

            if (o >= 0) {
              var a = i.indexOf("\n", o + 1);
              i = i.substring(a + 1);
            }

            this.stack = i;
          }
        }
      }, s.inherits(h.AssertionError, Error), h.fail = _, h.ok = g, h.equal = function (e, t, r) {
        e != t && _(e, t, r, "==", h.equal);
      }, h.notEqual = function (e, t, r) {
        e == t && _(e, t, r, "!=", h.notEqual);
      }, h.deepEqual = function (e, t, r) {
        v(e, t, !1) || _(e, t, r, "deepEqual", h.deepEqual);
      }, h.deepStrictEqual = function (e, t, r) {
        v(e, t, !0) || _(e, t, r, "deepStrictEqual", h.deepStrictEqual);
      }, h.notDeepEqual = function (e, t, r) {
        v(e, t, !1) && _(e, t, r, "notDeepEqual", h.notDeepEqual);
      }, h.notDeepStrictEqual = function e(t, r, n) {
        v(t, r, !0) && _(t, r, n, "notDeepStrictEqual", e);
      }, h.strictEqual = function (e, t, r) {
        e !== t && _(e, t, r, "===", h.strictEqual);
      }, h.notStrictEqual = function (e, t, r) {
        e === t && _(e, t, r, "!==", h.notStrictEqual);
      }, h.throws = function (e, t, r) {
        w(!0, e, t, r);
      }, h.doesNotThrow = function (e, t, r) {
        w(!1, e, t, r);
      }, h.ifError = function (e) {
        if (e) throw e;
      };

      var k = Object.keys || function (e) {
        var t = [];

        for (var r in e) {
          o.call(e, r) && t.push(r);
        }

        return t;
      };
    }).call(this, r(9));
  }, function (e, t, r) {
    (function (e, n) {
      var i = r(74),
          s = r(2),
          o = r(30),
          a = t.readyStates = {
        UNSENT: 0,
        OPENED: 1,
        HEADERS_RECEIVED: 2,
        LOADING: 3,
        DONE: 4
      },
          f = t.IncomingMessage = function (t, r, n) {
        var s = this;

        if (o.Readable.call(s), s._mode = n, s.headers = {}, s.rawHeaders = [], s.trailers = {}, s.rawTrailers = [], s.on("end", function () {
          process.nextTick(function () {
            s.emit("close");
          });
        }), "fetch" === n) {
          if (s._fetchResponse = r, s.url = r.url, s.statusCode = r.status, s.statusMessage = r.statusText, r.headers.forEach(function (e, t) {
            s.headers[t.toLowerCase()] = e, s.rawHeaders.push(t, e);
          }), i.writableStream) {
            var a = new WritableStream({
              write: function write(t) {
                return new Promise(function (r, n) {
                  s._destroyed || (s.push(new e(t)) ? r() : s._resumeFetch = r);
                });
              },
              close: function close() {
                s._destroyed || s.push(null);
              },
              abort: function abort(e) {
                s._destroyed || s.emit("error", e);
              }
            });

            try {
              return void r.body.pipeTo(a);
            } catch (e) {}
          }

          var f = r.body.getReader();
          !function t() {
            f.read().then(function (r) {
              s._destroyed || (r.done ? s.push(null) : (s.push(new e(r.value)), t()));
            }).catch(function (e) {
              s._destroyed || s.emit("error", e);
            });
          }();
        } else {
          if (s._xhr = t, s._pos = 0, s.url = t.responseURL, s.statusCode = t.status, s.statusMessage = t.statusText, t.getAllResponseHeaders().split(/\r?\n/).forEach(function (e) {
            var t = e.match(/^([^:]+):\s*(.*)/);

            if (t) {
              var r = t[1].toLowerCase();
              "set-cookie" === r ? (void 0 === s.headers[r] && (s.headers[r] = []), s.headers[r].push(t[2])) : void 0 !== s.headers[r] ? s.headers[r] += ", " + t[2] : s.headers[r] = t[2], s.rawHeaders.push(t[1], t[2]);
            }
          }), s._charset = "x-user-defined", !i.overrideMimeType) {
            var c = s.rawHeaders["mime-type"];

            if (c) {
              var u = c.match(/;\s*charset=([^;])(;|$)/);
              u && (s._charset = u[1].toLowerCase());
            }

            s._charset || (s._charset = "utf-8");
          }
        }
      };

      s(f, o.Readable), f.prototype._read = function () {
        var e = this._resumeFetch;
        e && (this._resumeFetch = null, e());
      }, f.prototype._onXHRProgress = function () {
        var t = this,
            r = t._xhr,
            i = null;

        switch (t._mode) {
          case "text:vbarray":
            if (r.readyState !== a.DONE) break;

            try {
              i = new n.VBArray(r.responseBody).toArray();
            } catch (e) {}

            if (null !== i) {
              t.push(new e(i));
              break;
            }

          case "text":
            try {
              i = r.responseText;
            } catch (e) {
              t._mode = "text:vbarray";
              break;
            }

            if (i.length > t._pos) {
              var s = i.substr(t._pos);

              if ("x-user-defined" === t._charset) {
                for (var o = new e(s.length), f = 0; f < s.length; f++) {
                  o[f] = 255 & s.charCodeAt(f);
                }

                t.push(o);
              } else t.push(s, t._charset);

              t._pos = i.length;
            }

            break;

          case "arraybuffer":
            if (r.readyState !== a.DONE || !r.response) break;
            i = r.response, t.push(new e(new Uint8Array(i)));
            break;

          case "moz-chunked-arraybuffer":
            if (i = r.response, r.readyState !== a.LOADING || !i) break;
            t.push(new e(new Uint8Array(i)));
            break;

          case "ms-stream":
            if (i = r.response, r.readyState !== a.LOADING) break;
            var c = new n.MSStreamReader();
            c.onprogress = function () {
              c.result.byteLength > t._pos && (t.push(new e(new Uint8Array(c.result.slice(t._pos)))), t._pos = c.result.byteLength);
            }, c.onload = function () {
              t.push(null);
            }, c.readAsArrayBuffer(i);
        }

        t._xhr.readyState === a.DONE && "ms-stream" !== t._mode && t.push(null);
      };
    }).call(this, r(3).Buffer, r(9));
  }, function (e, t, r) {
    (function (e) {
      t.fetch = a(e.fetch) && a(e.ReadableStream), t.writableStream = a(e.WritableStream), t.abortController = a(e.AbortController), t.blobConstructor = !1;

      try {
        new Blob([new ArrayBuffer(1)]), t.blobConstructor = !0;
      } catch (e) {}

      var r;

      function n() {
        if (void 0 !== r) return r;

        if (e.XMLHttpRequest) {
          r = new e.XMLHttpRequest();

          try {
            r.open("GET", e.XDomainRequest ? "/" : "https://example.com");
          } catch (e) {
            r = null;
          }
        } else r = null;

        return r;
      }

      function i(e) {
        var t = n();
        if (!t) return !1;

        try {
          return t.responseType = e, t.responseType === e;
        } catch (e) {}

        return !1;
      }

      var s = void 0 !== e.ArrayBuffer,
          o = s && a(e.ArrayBuffer.prototype.slice);

      function a(e) {
        return "function" == typeof e;
      }

      t.arraybuffer = t.fetch || s && i("arraybuffer"), t.msstream = !t.fetch && o && i("ms-stream"), t.mozchunkedarraybuffer = !t.fetch && s && i("moz-chunked-arraybuffer"), t.overrideMimeType = t.fetch || !!n() && a(n().overrideMimeType), t.vbArray = a(e.VBArray), r = null;
    }).call(this, r(9));
  }, function (e, t, r) {
    (function (t) {
      var n = r(8);

      e.exports = function (e, r) {
        return new t(e.toRed(n.mont(r.modulus)).redPow(new n(r.publicExponent)).fromRed().toArray());
      };
    }).call(this, r(3).Buffer);
  }, function (e, t) {
    e.exports = function (e, t) {
      for (var r = e.length, n = -1; ++n < r;) {
        e[n] ^= t[n];
      }

      return e;
    };
  }, function (e, t, r) {
    (function (t) {
      var n = r(31);

      function i(e) {
        var r = new t(4);
        return r.writeUInt32BE(e, 0), r;
      }

      e.exports = function (e, r) {
        for (var s, o = new t(""), a = 0; o.length < r;) {
          s = i(a++), o = t.concat([o, n("sha1").update(e).update(s).digest()]);
        }

        return o.slice(0, r);
      };
    }).call(this, r(3).Buffer);
  }, function (e) {
    e.exports = {
      "1.3.132.0.10": "secp256k1",
      "1.3.132.0.33": "p224",
      "1.2.840.10045.3.1.1": "p192",
      "1.2.840.10045.3.1.7": "p256",
      "1.3.132.0.34": "p384",
      "1.3.132.0.35": "p521"
    };
  }, function (e, t, r) {
    var n = r(2),
        i = r(3).Buffer,
        s = r(26),
        o = s.base,
        a = s.constants.der;

    function f(e) {
      this.enc = "der", this.name = e.name, this.entity = e, this.tree = new c(), this.tree._init(e.body);
    }

    function c(e) {
      o.Node.call(this, "der", e);
    }

    function u(e) {
      return e < 10 ? "0" + e : e;
    }

    e.exports = f, f.prototype.encode = function (e, t) {
      return this.tree._encode(e, t).join();
    }, n(c, o.Node), c.prototype._encodeComposite = function (e, t, r, n) {
      var s,
          o = function (e, t, r, n) {
        var i;
        "seqof" === e ? e = "seq" : "setof" === e && (e = "set");
        if (a.tagByName.hasOwnProperty(e)) i = a.tagByName[e];else {
          if ("number" != typeof e || (0 | e) !== e) return n.error("Unknown tag: " + e);
          i = e;
        }
        if (i >= 31) return n.error("Multi-octet tag encoding unsupported");
        t || (i |= 32);
        return i |= a.tagClassByName[r || "universal"] << 6;
      }(e, t, r, this.reporter);

      if (n.length < 128) return (s = new i(2))[0] = o, s[1] = n.length, this._createEncoderBuffer([s, n]);

      for (var f = 1, c = n.length; c >= 256; c >>= 8) {
        f++;
      }

      (s = new i(2 + f))[0] = o, s[1] = 128 | f;
      c = 1 + f;

      for (var u = n.length; u > 0; c--, u >>= 8) {
        s[c] = 255 & u;
      }

      return this._createEncoderBuffer([s, n]);
    }, c.prototype._encodeStr = function (e, t) {
      if ("bitstr" === t) return this._createEncoderBuffer([0 | e.unused, e.data]);

      if ("bmpstr" === t) {
        for (var r = new i(2 * e.length), n = 0; n < e.length; n++) {
          r.writeUInt16BE(e.charCodeAt(n), 2 * n);
        }

        return this._createEncoderBuffer(r);
      }

      return "numstr" === t ? this._isNumstr(e) ? this._createEncoderBuffer(e) : this.reporter.error("Encoding of string type: numstr supports only digits and space") : "printstr" === t ? this._isPrintstr(e) ? this._createEncoderBuffer(e) : this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark") : /str$/.test(t) ? this._createEncoderBuffer(e) : "objDesc" === t ? this._createEncoderBuffer(e) : this.reporter.error("Encoding of string type: " + t + " unsupported");
    }, c.prototype._encodeObjid = function (e, t, r) {
      if ("string" == typeof e) {
        if (!t) return this.reporter.error("string objid given, but no values map found");
        if (!t.hasOwnProperty(e)) return this.reporter.error("objid not found in values map");
        e = t[e].split(/[\s\.]+/g);

        for (var n = 0; n < e.length; n++) {
          e[n] |= 0;
        }
      } else if (Array.isArray(e)) {
        e = e.slice();

        for (n = 0; n < e.length; n++) {
          e[n] |= 0;
        }
      }

      if (!Array.isArray(e)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(e));

      if (!r) {
        if (e[1] >= 40) return this.reporter.error("Second objid identifier OOB");
        e.splice(0, 2, 40 * e[0] + e[1]);
      }

      var s = 0;

      for (n = 0; n < e.length; n++) {
        var o = e[n];

        for (s++; o >= 128; o >>= 7) {
          s++;
        }
      }

      var a = new i(s),
          f = a.length - 1;

      for (n = e.length - 1; n >= 0; n--) {
        o = e[n];

        for (a[f--] = 127 & o; (o >>= 7) > 0;) {
          a[f--] = 128 | 127 & o;
        }
      }

      return this._createEncoderBuffer(a);
    }, c.prototype._encodeTime = function (e, t) {
      var r,
          n = new Date(e);
      return "gentime" === t ? r = [u(n.getFullYear()), u(n.getUTCMonth() + 1), u(n.getUTCDate()), u(n.getUTCHours()), u(n.getUTCMinutes()), u(n.getUTCSeconds()), "Z"].join("") : "utctime" === t ? r = [u(n.getFullYear() % 100), u(n.getUTCMonth() + 1), u(n.getUTCDate()), u(n.getUTCHours()), u(n.getUTCMinutes()), u(n.getUTCSeconds()), "Z"].join("") : this.reporter.error("Encoding " + t + " time is not supported yet"), this._encodeStr(r, "octstr");
    }, c.prototype._encodeNull = function () {
      return this._createEncoderBuffer("");
    }, c.prototype._encodeInt = function (e, t) {
      if ("string" == typeof e) {
        if (!t) return this.reporter.error("String int or enum given, but no values map");
        if (!t.hasOwnProperty(e)) return this.reporter.error("Values map doesn't contain: " + JSON.stringify(e));
        e = t[e];
      }

      if ("number" != typeof e && !i.isBuffer(e)) {
        var r = e.toArray();
        !e.sign && 128 & r[0] && r.unshift(0), e = new i(r);
      }

      if (i.isBuffer(e)) {
        var n = e.length;
        0 === e.length && n++;
        var s = new i(n);
        return e.copy(s), 0 === e.length && (s[0] = 0), this._createEncoderBuffer(s);
      }

      if (e < 128) return this._createEncoderBuffer(e);
      if (e < 256) return this._createEncoderBuffer([0, e]);
      n = 1;

      for (var o = e; o >= 256; o >>= 8) {
        n++;
      }

      for (o = (s = new Array(n)).length - 1; o >= 0; o--) {
        s[o] = 255 & e, e >>= 8;
      }

      return 128 & s[0] && s.unshift(0), this._createEncoderBuffer(new i(s));
    }, c.prototype._encodeBool = function (e) {
      return this._createEncoderBuffer(e ? 255 : 0);
    }, c.prototype._use = function (e, t) {
      return "function" == typeof e && (e = e(t)), e._getEncoder("der").tree;
    }, c.prototype._skipDefault = function (e, t, r) {
      var n,
          i = this._baseState;
      if (null === i.default) return !1;
      var s = e.join();
      if (void 0 === i.defaultBuffer && (i.defaultBuffer = this._encodeValue(i.default, t, r).join()), s.length !== i.defaultBuffer.length) return !1;

      for (n = 0; n < s.length; n++) {
        if (s[n] !== i.defaultBuffer[n]) return !1;
      }

      return !0;
    };
  }, function (e, t, r) {
    var n = r(2),
        i = r(26),
        s = i.base,
        o = i.bignum,
        a = i.constants.der;

    function f(e) {
      this.enc = "der", this.name = e.name, this.entity = e, this.tree = new c(), this.tree._init(e.body);
    }

    function c(e) {
      s.Node.call(this, "der", e);
    }

    function u(e, t) {
      var r = e.readUInt8(t);
      if (e.isError(r)) return r;
      var n = a.tagClass[r >> 6],
          i = 0 == (32 & r);

      if (31 == (31 & r)) {
        var s = r;

        for (r = 0; 128 == (128 & s);) {
          if (s = e.readUInt8(t), e.isError(s)) return s;
          r <<= 7, r |= 127 & s;
        }
      } else r &= 31;

      return {
        cls: n,
        primitive: i,
        tag: r,
        tagStr: a.tag[r]
      };
    }

    function h(e, t, r) {
      var n = e.readUInt8(r);
      if (e.isError(n)) return n;
      if (!t && 128 === n) return null;
      if (0 == (128 & n)) return n;
      var i = 127 & n;
      if (i > 4) return e.error("length octect is too long");
      n = 0;

      for (var s = 0; s < i; s++) {
        n <<= 8;
        var o = e.readUInt8(r);
        if (e.isError(o)) return o;
        n |= o;
      }

      return n;
    }

    e.exports = f, f.prototype.decode = function (e, t) {
      return e instanceof s.DecoderBuffer || (e = new s.DecoderBuffer(e, t)), this.tree._decode(e, t);
    }, n(c, s.Node), c.prototype._peekTag = function (e, t, r) {
      if (e.isEmpty()) return !1;
      var n = e.save(),
          i = u(e, 'Failed to peek tag: "' + t + '"');
      return e.isError(i) ? i : (e.restore(n), i.tag === t || i.tagStr === t || i.tagStr + "of" === t || r);
    }, c.prototype._decodeTag = function (e, t, r) {
      var n = u(e, 'Failed to decode tag of "' + t + '"');
      if (e.isError(n)) return n;
      var i = h(e, n.primitive, 'Failed to get length of "' + t + '"');
      if (e.isError(i)) return i;
      if (!r && n.tag !== t && n.tagStr !== t && n.tagStr + "of" !== t) return e.error('Failed to match tag: "' + t + '"');
      if (n.primitive || null !== i) return e.skip(i, 'Failed to match body of: "' + t + '"');

      var s = e.save(),
          o = this._skipUntilEnd(e, 'Failed to skip indefinite length body: "' + this.tag + '"');

      return e.isError(o) ? o : (i = e.offset - s.offset, e.restore(s), e.skip(i, 'Failed to match body of: "' + t + '"'));
    }, c.prototype._skipUntilEnd = function (e, t) {
      for (;;) {
        var r = u(e, t);
        if (e.isError(r)) return r;
        var n,
            i = h(e, r.primitive, t);
        if (e.isError(i)) return i;
        if (n = r.primitive || null !== i ? e.skip(i) : this._skipUntilEnd(e, t), e.isError(n)) return n;
        if ("end" === r.tagStr) break;
      }
    }, c.prototype._decodeList = function (e, t, r, n) {
      for (var i = []; !e.isEmpty();) {
        var s = this._peekTag(e, "end");

        if (e.isError(s)) return s;
        var o = r.decode(e, "der", n);
        if (e.isError(o) && s) break;
        i.push(o);
      }

      return i;
    }, c.prototype._decodeStr = function (e, t) {
      if ("bitstr" === t) {
        var r = e.readUInt8();
        return e.isError(r) ? r : {
          unused: r,
          data: e.raw()
        };
      }

      if ("bmpstr" === t) {
        var n = e.raw();
        if (n.length % 2 == 1) return e.error("Decoding of string type: bmpstr length mismatch");

        for (var i = "", s = 0; s < n.length / 2; s++) {
          i += String.fromCharCode(n.readUInt16BE(2 * s));
        }

        return i;
      }

      if ("numstr" === t) {
        var o = e.raw().toString("ascii");
        return this._isNumstr(o) ? o : e.error("Decoding of string type: numstr unsupported characters");
      }

      if ("octstr" === t) return e.raw();
      if ("objDesc" === t) return e.raw();

      if ("printstr" === t) {
        var a = e.raw().toString("ascii");
        return this._isPrintstr(a) ? a : e.error("Decoding of string type: printstr unsupported characters");
      }

      return /str$/.test(t) ? e.raw().toString() : e.error("Decoding of string type: " + t + " unsupported");
    }, c.prototype._decodeObjid = function (e, t, r) {
      for (var n, i = [], s = 0; !e.isEmpty();) {
        var o = e.readUInt8();
        s <<= 7, s |= 127 & o, 0 == (128 & o) && (i.push(s), s = 0);
      }

      128 & o && i.push(s);
      var a = i[0] / 40 | 0,
          f = i[0] % 40;

      if (n = r ? i : [a, f].concat(i.slice(1)), t) {
        var c = t[n.join(" ")];
        void 0 === c && (c = t[n.join(".")]), void 0 !== c && (n = c);
      }

      return n;
    }, c.prototype._decodeTime = function (e, t) {
      var r = e.raw().toString();
      if ("gentime" === t) var n = 0 | r.slice(0, 4),
          i = 0 | r.slice(4, 6),
          s = 0 | r.slice(6, 8),
          o = 0 | r.slice(8, 10),
          a = 0 | r.slice(10, 12),
          f = 0 | r.slice(12, 14);else {
        if ("utctime" !== t) return e.error("Decoding " + t + " time is not supported yet");
        n = 0 | r.slice(0, 2), i = 0 | r.slice(2, 4), s = 0 | r.slice(4, 6), o = 0 | r.slice(6, 8), a = 0 | r.slice(8, 10), f = 0 | r.slice(10, 12);
        n = n < 70 ? 2e3 + n : 1900 + n;
      }
      return Date.UTC(n, i - 1, s, o, a, f, 0);
    }, c.prototype._decodeNull = function (e) {
      return null;
    }, c.prototype._decodeBool = function (e) {
      var t = e.readUInt8();
      return e.isError(t) ? t : 0 !== t;
    }, c.prototype._decodeInt = function (e, t) {
      var r = e.raw(),
          n = new o(r);
      return t && (n = t[n.toString(10)] || n), n;
    }, c.prototype._use = function (e, t) {
      return "function" == typeof e && (e = e(t)), e._getDecoder("der").tree;
    };
  }, function (e, t, r) {
    var n = t;
    n._reverse = function (e) {
      var t = {};
      return Object.keys(e).forEach(function (r) {
        (0 | r) == r && (r |= 0);
        var n = e[r];
        t[n] = r;
      }), t;
    }, n.der = r(170);
  }, function (e, t, r) {
    var n = r(2),
        i = r(25).Reporter,
        s = r(3).Buffer;

    function o(e, t) {
      i.call(this, t), s.isBuffer(e) ? (this.base = e, this.offset = 0, this.length = e.length) : this.error("Input not Buffer");
    }

    function a(e, t) {
      if (Array.isArray(e)) this.length = 0, this.value = e.map(function (e) {
        return e instanceof a || (e = new a(e, t)), this.length += e.length, e;
      }, this);else if ("number" == typeof e) {
        if (!(0 <= e && e <= 255)) return t.error("non-byte EncoderBuffer value");
        this.value = e, this.length = 1;
      } else if ("string" == typeof e) this.value = e, this.length = s.byteLength(e);else {
        if (!s.isBuffer(e)) return t.error("Unsupported type: " + typeof e);
        this.value = e, this.length = e.length;
      }
    }

    n(o, i), t.DecoderBuffer = o, o.prototype.save = function () {
      return {
        offset: this.offset,
        reporter: i.prototype.save.call(this)
      };
    }, o.prototype.restore = function (e) {
      var t = new o(this.base);
      return t.offset = e.offset, t.length = this.offset, this.offset = e.offset, i.prototype.restore.call(this, e.reporter), t;
    }, o.prototype.isEmpty = function () {
      return this.offset === this.length;
    }, o.prototype.readUInt8 = function (e) {
      return this.offset + 1 <= this.length ? this.base.readUInt8(this.offset++, !0) : this.error(e || "DecoderBuffer overrun");
    }, o.prototype.skip = function (e, t) {
      if (!(this.offset + e <= this.length)) return this.error(t || "DecoderBuffer overrun");
      var r = new o(this.base);
      return r._reporterState = this._reporterState, r.offset = this.offset, r.length = this.offset + e, this.offset += e, r;
    }, o.prototype.raw = function (e) {
      return this.base.slice(e ? e.offset : this.offset, this.length);
    }, t.EncoderBuffer = a, a.prototype.join = function (e, t) {
      return e || (e = new s(this.length)), t || (t = 0), 0 === this.length ? e : (Array.isArray(this.value) ? this.value.forEach(function (r) {
        r.join(e, t), t += r.length;
      }) : ("number" == typeof this.value ? e[t] = this.value : "string" == typeof this.value ? e.write(this.value, t) : s.isBuffer(this.value) && this.value.copy(e, t), t += this.length), e);
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(14),
        i = r(27),
        s = r(13),
        o = n.rotr64_hi,
        a = n.rotr64_lo,
        f = n.shr64_hi,
        c = n.shr64_lo,
        u = n.sum64,
        h = n.sum64_hi,
        d = n.sum64_lo,
        l = n.sum64_4_hi,
        p = n.sum64_4_lo,
        b = n.sum64_5_hi,
        _ = n.sum64_5_lo,
        g = i.BlockHash,
        v = [1116352408, 3609767458, 1899447441, 602891725, 3049323471, 3964484399, 3921009573, 2173295548, 961987163, 4081628472, 1508970993, 3053834265, 2453635748, 2937671579, 2870763221, 3664609560, 3624381080, 2734883394, 310598401, 1164996542, 607225278, 1323610764, 1426881987, 3590304994, 1925078388, 4068182383, 2162078206, 991336113, 2614888103, 633803317, 3248222580, 3479774868, 3835390401, 2666613458, 4022224774, 944711139, 264347078, 2341262773, 604807628, 2007800933, 770255983, 1495990901, 1249150122, 1856431235, 1555081692, 3175218132, 1996064986, 2198950837, 2554220882, 3999719339, 2821834349, 766784016, 2952996808, 2566594879, 3210313671, 3203337956, 3336571891, 1034457026, 3584528711, 2466948901, 113926993, 3758326383, 338241895, 168717936, 666307205, 1188179964, 773529912, 1546045734, 1294757372, 1522805485, 1396182291, 2643833823, 1695183700, 2343527390, 1986661051, 1014477480, 2177026350, 1206759142, 2456956037, 344077627, 2730485921, 1290863460, 2820302411, 3158454273, 3259730800, 3505952657, 3345764771, 106217008, 3516065817, 3606008344, 3600352804, 1432725776, 4094571909, 1467031594, 275423344, 851169720, 430227734, 3100823752, 506948616, 1363258195, 659060556, 3750685593, 883997877, 3785050280, 958139571, 3318307427, 1322822218, 3812723403, 1537002063, 2003034995, 1747873779, 3602036899, 1955562222, 1575990012, 2024104815, 1125592928, 2227730452, 2716904306, 2361852424, 442776044, 2428436474, 593698344, 2756734187, 3733110249, 3204031479, 2999351573, 3329325298, 3815920427, 3391569614, 3928383900, 3515267271, 566280711, 3940187606, 3454069534, 4118630271, 4000239992, 116418474, 1914138554, 174292421, 2731055270, 289380356, 3203993006, 460393269, 320620315, 685471733, 587496836, 852142971, 1086792851, 1017036298, 365543100, 1126000580, 2618297676, 1288033470, 3409855158, 1501505948, 4234509866, 1607167915, 987167468, 1816402316, 1246189591];

    function m() {
      if (!(this instanceof m)) return new m();
      g.call(this), this.h = [1779033703, 4089235720, 3144134277, 2227873595, 1013904242, 4271175723, 2773480762, 1595750129, 1359893119, 2917565137, 2600822924, 725511199, 528734635, 4215389547, 1541459225, 327033209], this.k = v, this.W = new Array(160);
    }

    function y(e, t, r, n, i) {
      var s = e & r ^ ~e & i;
      return s < 0 && (s += 4294967296), s;
    }

    function w(e, t, r, n, i, s) {
      var o = t & n ^ ~t & s;
      return o < 0 && (o += 4294967296), o;
    }

    function k(e, t, r, n, i) {
      var s = e & r ^ e & i ^ r & i;
      return s < 0 && (s += 4294967296), s;
    }

    function S(e, t, r, n, i, s) {
      var o = t & n ^ t & s ^ n & s;
      return o < 0 && (o += 4294967296), o;
    }

    function E(e, t) {
      var r = o(e, t, 28) ^ o(t, e, 2) ^ o(t, e, 7);
      return r < 0 && (r += 4294967296), r;
    }

    function A(e, t) {
      var r = a(e, t, 28) ^ a(t, e, 2) ^ a(t, e, 7);
      return r < 0 && (r += 4294967296), r;
    }

    function x(e, t) {
      var r = o(e, t, 14) ^ o(e, t, 18) ^ o(t, e, 9);
      return r < 0 && (r += 4294967296), r;
    }

    function T(e, t) {
      var r = a(e, t, 14) ^ a(e, t, 18) ^ a(t, e, 9);
      return r < 0 && (r += 4294967296), r;
    }

    function R(e, t) {
      var r = o(e, t, 1) ^ o(e, t, 8) ^ f(e, t, 7);
      return r < 0 && (r += 4294967296), r;
    }

    function M(e, t) {
      var r = a(e, t, 1) ^ a(e, t, 8) ^ c(e, t, 7);
      return r < 0 && (r += 4294967296), r;
    }

    function I(e, t) {
      var r = o(e, t, 19) ^ o(t, e, 29) ^ f(e, t, 6);
      return r < 0 && (r += 4294967296), r;
    }

    function O(e, t) {
      var r = a(e, t, 19) ^ a(t, e, 29) ^ c(e, t, 6);
      return r < 0 && (r += 4294967296), r;
    }

    n.inherits(m, g), e.exports = m, m.blockSize = 1024, m.outSize = 512, m.hmacStrength = 192, m.padLength = 128, m.prototype._prepareBlock = function (e, t) {
      for (var r = this.W, n = 0; n < 32; n++) {
        r[n] = e[t + n];
      }

      for (; n < r.length; n += 2) {
        var i = I(r[n - 4], r[n - 3]),
            s = O(r[n - 4], r[n - 3]),
            o = r[n - 14],
            a = r[n - 13],
            f = R(r[n - 30], r[n - 29]),
            c = M(r[n - 30], r[n - 29]),
            u = r[n - 32],
            h = r[n - 31];
        r[n] = l(i, s, o, a, f, c, u, h), r[n + 1] = p(i, s, o, a, f, c, u, h);
      }
    }, m.prototype._update = function (e, t) {
      this._prepareBlock(e, t);

      var r = this.W,
          n = this.h[0],
          i = this.h[1],
          o = this.h[2],
          a = this.h[3],
          f = this.h[4],
          c = this.h[5],
          l = this.h[6],
          p = this.h[7],
          g = this.h[8],
          v = this.h[9],
          m = this.h[10],
          R = this.h[11],
          M = this.h[12],
          I = this.h[13],
          O = this.h[14],
          C = this.h[15];
      s(this.k.length === r.length);

      for (var B = 0; B < r.length; B += 2) {
        var P = O,
            N = C,
            L = x(g, v),
            j = T(g, v),
            U = y(g, v, m, R, M),
            D = w(g, v, m, R, M, I),
            q = this.k[B],
            z = this.k[B + 1],
            F = r[B],
            W = r[B + 1],
            Z = b(P, N, L, j, U, D, q, z, F, W),
            V = _(P, N, L, j, U, D, q, z, F, W);

        P = E(n, i), N = A(n, i), L = k(n, i, o, a, f), j = S(n, i, o, a, f, c);
        var H = h(P, N, L, j),
            $ = d(P, N, L, j);
        O = M, C = I, M = m, I = R, m = g, R = v, g = h(l, p, Z, V), v = d(p, p, Z, V), l = f, p = c, f = o, c = a, o = n, a = i, n = h(Z, V, H, $), i = d(Z, V, H, $);
      }

      u(this.h, 0, n, i), u(this.h, 2, o, a), u(this.h, 4, f, c), u(this.h, 6, l, p), u(this.h, 8, g, v), u(this.h, 10, m, R), u(this.h, 12, M, I), u(this.h, 14, O, C);
    }, m.prototype._digest = function (e) {
      return "hex" === e ? n.toHex32(this.h, "big") : n.split32(this.h, "big");
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(14),
        i = r(27),
        s = r(85),
        o = r(13),
        a = n.sum32,
        f = n.sum32_4,
        c = n.sum32_5,
        u = s.ch32,
        h = s.maj32,
        d = s.s0_256,
        l = s.s1_256,
        p = s.g0_256,
        b = s.g1_256,
        _ = i.BlockHash,
        g = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298];

    function v() {
      if (!(this instanceof v)) return new v();
      _.call(this), this.h = [1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225], this.k = g, this.W = new Array(64);
    }

    n.inherits(v, _), e.exports = v, v.blockSize = 512, v.outSize = 256, v.hmacStrength = 192, v.padLength = 64, v.prototype._update = function (e, t) {
      for (var r = this.W, n = 0; n < 16; n++) {
        r[n] = e[t + n];
      }

      for (; n < r.length; n++) {
        r[n] = f(b(r[n - 2]), r[n - 7], p(r[n - 15]), r[n - 16]);
      }

      var i = this.h[0],
          s = this.h[1],
          _ = this.h[2],
          g = this.h[3],
          v = this.h[4],
          m = this.h[5],
          y = this.h[6],
          w = this.h[7];

      for (o(this.k.length === r.length), n = 0; n < r.length; n++) {
        var k = c(w, l(v), u(v, m, y), this.k[n], r[n]),
            S = a(d(i), h(i, s, _));
        w = y, y = m, m = v, v = a(g, k), g = _, _ = s, s = i, i = a(k, S);
      }

      this.h[0] = a(this.h[0], i), this.h[1] = a(this.h[1], s), this.h[2] = a(this.h[2], _), this.h[3] = a(this.h[3], g), this.h[4] = a(this.h[4], v), this.h[5] = a(this.h[5], m), this.h[6] = a(this.h[6], y), this.h[7] = a(this.h[7], w);
    }, v.prototype._digest = function (e) {
      return "hex" === e ? n.toHex32(this.h, "big") : n.split32(this.h, "big");
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(14).rotr32;

    function i(e, t, r) {
      return e & t ^ ~e & r;
    }

    function s(e, t, r) {
      return e & t ^ e & r ^ t & r;
    }

    function o(e, t, r) {
      return e ^ t ^ r;
    }

    t.ft_1 = function (e, t, r, n) {
      return 0 === e ? i(t, r, n) : 1 === e || 3 === e ? o(t, r, n) : 2 === e ? s(t, r, n) : void 0;
    }, t.ch32 = i, t.maj32 = s, t.p32 = o, t.s0_256 = function (e) {
      return n(e, 2) ^ n(e, 13) ^ n(e, 22);
    }, t.s1_256 = function (e) {
      return n(e, 6) ^ n(e, 11) ^ n(e, 25);
    }, t.g0_256 = function (e) {
      return n(e, 7) ^ n(e, 18) ^ e >>> 3;
    }, t.g1_256 = function (e) {
      return n(e, 17) ^ n(e, 19) ^ e >>> 10;
    };
  }, function (e, t, r) {
    "use strict";

    var n = t;

    function i(e) {
      return 1 === e.length ? "0" + e : e;
    }

    function s(e) {
      for (var t = "", r = 0; r < e.length; r++) {
        t += i(e[r].toString(16));
      }

      return t;
    }

    n.toArray = function (e, t) {
      if (Array.isArray(e)) return e.slice();
      if (!e) return [];
      var r = [];

      if ("string" != typeof e) {
        for (var n = 0; n < e.length; n++) {
          r[n] = 0 | e[n];
        }

        return r;
      }

      if ("hex" === t) for ((e = e.replace(/[^a-z0-9]+/gi, "")).length % 2 != 0 && (e = "0" + e), n = 0; n < e.length; n += 2) {
        r.push(parseInt(e[n] + e[n + 1], 16));
      } else for (n = 0; n < e.length; n++) {
        var i = e.charCodeAt(n),
            s = i >> 8,
            o = 255 & i;
        s ? r.push(s, o) : r.push(o);
      }
      return r;
    }, n.zero2 = i, n.toHex = s, n.encode = function (e, t) {
      return "hex" === t ? s(e) : e;
    };
  }, function (e, t, r) {
    var n;

    function i(e) {
      this.rand = e;
    }

    if (e.exports = function (e) {
      return n || (n = new i(null)), n.generate(e);
    }, e.exports.Rand = i, i.prototype.generate = function (e) {
      return this._rand(e);
    }, i.prototype._rand = function (e) {
      if (this.rand.getBytes) return this.rand.getBytes(e);

      for (var t = new Uint8Array(e), r = 0; r < t.length; r++) {
        t[r] = this.rand.getByte();
      }

      return t;
    }, "object" == typeof self) self.crypto && self.crypto.getRandomValues ? i.prototype._rand = function (e) {
      var t = new Uint8Array(e);
      return self.crypto.getRandomValues(t), t;
    } : self.msCrypto && self.msCrypto.getRandomValues ? i.prototype._rand = function (e) {
      var t = new Uint8Array(e);
      return self.msCrypto.getRandomValues(t), t;
    } : "object" == typeof window && (i.prototype._rand = function () {
      throw new Error("Not implemented yet");
    });else try {
      var s = r(202);
      if ("function" != typeof s.randomBytes) throw new Error("Not supported");

      i.prototype._rand = function (e) {
        return s.randomBytes(e);
      };
    } catch (e) {}
  }, function (e, t, r) {
    var n = r(8),
        i = r(87);

    function s(e) {
      this.rand = e || new i.Rand();
    }

    e.exports = s, s.create = function (e) {
      return new s(e);
    }, s.prototype._randbelow = function (e) {
      var t = e.bitLength(),
          r = Math.ceil(t / 8);

      do {
        var i = new n(this.rand.generate(r));
      } while (i.cmp(e) >= 0);

      return i;
    }, s.prototype._randrange = function (e, t) {
      var r = t.sub(e);
      return e.add(this._randbelow(r));
    }, s.prototype.test = function (e, t, r) {
      var i = e.bitLength(),
          s = n.mont(e),
          o = new n(1).toRed(s);
      t || (t = Math.max(1, i / 48 | 0));

      for (var a = e.subn(1), f = 0; !a.testn(f); f++) {
        ;
      }

      for (var c = e.shrn(f), u = a.toRed(s); t > 0; t--) {
        var h = this._randrange(new n(2), a);

        r && r(h);
        var d = h.toRed(s).redPow(c);

        if (0 !== d.cmp(o) && 0 !== d.cmp(u)) {
          for (var l = 1; l < f; l++) {
            if (0 === (d = d.redSqr()).cmp(o)) return !1;
            if (0 === d.cmp(u)) break;
          }

          if (l === f) return !1;
        }
      }

      return !0;
    }, s.prototype.getDivisor = function (e, t) {
      var r = e.bitLength(),
          i = n.mont(e),
          s = new n(1).toRed(i);
      t || (t = Math.max(1, r / 48 | 0));

      for (var o = e.subn(1), a = 0; !o.testn(a); a++) {
        ;
      }

      for (var f = e.shrn(a), c = o.toRed(i); t > 0; t--) {
        var u = this._randrange(new n(2), o),
            h = e.gcd(u);

        if (0 !== h.cmpn(1)) return h;
        var d = u.toRed(i).redPow(f);

        if (0 !== d.cmp(s) && 0 !== d.cmp(c)) {
          for (var l = 1; l < a; l++) {
            if (0 === (d = d.redSqr()).cmp(s)) return d.fromRed().subn(1).gcd(e);
            if (0 === d.cmp(c)) break;
          }

          if (l === a) return (d = d.redSqr()).fromRed().subn(1).gcd(e);
        }
      }

      return !1;
    };
  }, function (e, t, r) {
    var n = r(22);
    e.exports = v, v.simpleSieve = _, v.fermatTest = g;
    var i = r(8),
        s = new i(24),
        o = new (r(88))(),
        a = new i(1),
        f = new i(2),
        c = new i(5),
        u = (new i(16), new i(8), new i(10)),
        h = new i(3),
        d = (new i(7), new i(11)),
        l = new i(4),
        p = (new i(12), null);

    function b() {
      if (null !== p) return p;
      var e = [];
      e[0] = 2;

      for (var t = 1, r = 3; r < 1048576; r += 2) {
        for (var n = Math.ceil(Math.sqrt(r)), i = 0; i < t && e[i] <= n && r % e[i] != 0; i++) {
          ;
        }

        t !== i && e[i] <= n || (e[t++] = r);
      }

      return p = e, e;
    }

    function _(e) {
      for (var t = b(), r = 0; r < t.length; r++) {
        if (0 === e.modn(t[r])) return 0 === e.cmpn(t[r]);
      }

      return !0;
    }

    function g(e) {
      var t = i.mont(e);
      return 0 === f.toRed(t).redPow(e.subn(1)).fromRed().cmpn(1);
    }

    function v(e, t) {
      if (e < 16) return new i(2 === t || 5 === t ? [140, 123] : [140, 39]);
      var r, p;

      for (t = new i(t);;) {
        for (r = new i(n(Math.ceil(e / 8))); r.bitLength() > e;) {
          r.ishrn(1);
        }

        if (r.isEven() && r.iadd(a), r.testn(1) || r.iadd(f), t.cmp(f)) {
          if (!t.cmp(c)) for (; r.mod(u).cmp(h);) {
            r.iadd(l);
          }
        } else for (; r.mod(s).cmp(d);) {
          r.iadd(l);
        }

        if (_(p = r.shrn(1)) && _(r) && g(p) && g(r) && o.test(p) && o.test(r)) return r;
      }
    }
  }, function (e, t, r) {
    var n = r(38),
        i = r(6).Buffer,
        s = r(16);

    function o(e, t, r, o) {
      s.call(this), this._cipher = new n.AES(t), this._prev = i.from(r), this._cache = i.allocUnsafe(0), this._secCache = i.allocUnsafe(0), this._decrypt = o, this._mode = e;
    }

    r(2)(o, s), o.prototype._update = function (e) {
      return this._mode.encrypt(this, e, this._decrypt);
    }, o.prototype._final = function () {
      this._cipher.scrub();
    }, e.exports = o;
  }, function (e, t, r) {
    var n = r(38),
        i = r(6).Buffer,
        s = r(16),
        o = r(2),
        a = r(213),
        f = r(28),
        c = r(93);

    function u(e, t, r, o) {
      s.call(this);
      var f = i.alloc(4, 0);
      this._cipher = new n.AES(t);

      var u = this._cipher.encryptBlock(f);

      this._ghash = new a(u), r = function (e, t, r) {
        if (12 === t.length) return e._finID = i.concat([t, i.from([0, 0, 0, 1])]), i.concat([t, i.from([0, 0, 0, 2])]);
        var n = new a(r),
            s = t.length,
            o = s % 16;
        n.update(t), o && (o = 16 - o, n.update(i.alloc(o, 0))), n.update(i.alloc(8, 0));
        var f = 8 * s,
            u = i.alloc(8);
        u.writeUIntBE(f, 0, 8), n.update(u), e._finID = n.state;
        var h = i.from(e._finID);
        return c(h), h;
      }(this, r, u), this._prev = i.from(r), this._cache = i.allocUnsafe(0), this._secCache = i.allocUnsafe(0), this._decrypt = o, this._alen = 0, this._len = 0, this._mode = e, this._authTag = null, this._called = !1;
    }

    o(u, s), u.prototype._update = function (e) {
      if (!this._called && this._alen) {
        var t = 16 - this._alen % 16;
        t < 16 && (t = i.alloc(t, 0), this._ghash.update(t));
      }

      this._called = !0;

      var r = this._mode.encrypt(this, e);

      return this._decrypt ? this._ghash.update(e) : this._ghash.update(r), this._len += e.length, r;
    }, u.prototype._final = function () {
      if (this._decrypt && !this._authTag) throw new Error("Unsupported state or unable to authenticate data");
      var e = f(this._ghash.final(8 * this._alen, 8 * this._len), this._cipher.encryptBlock(this._finID));
      if (this._decrypt && function (e, t) {
        var r = 0;
        e.length !== t.length && r++;

        for (var n = Math.min(e.length, t.length), i = 0; i < n; ++i) {
          r += e[i] ^ t[i];
        }

        return r;
      }(e, this._authTag)) throw new Error("Unsupported state or unable to authenticate data");
      this._authTag = e, this._cipher.scrub();
    }, u.prototype.getAuthTag = function () {
      if (this._decrypt || !i.isBuffer(this._authTag)) throw new Error("Attempting to get auth tag in unsupported state");
      return this._authTag;
    }, u.prototype.setAuthTag = function (e) {
      if (!this._decrypt) throw new Error("Attempting to set auth tag in unsupported state");
      this._authTag = e;
    }, u.prototype.setAAD = function (e) {
      if (this._called) throw new Error("Attempting to set AAD in unsupported state");
      this._ghash.update(e), this._alen += e.length;
    }, e.exports = u;
  }, function (e) {
    e.exports = {
      "aes-128-ecb": {
        cipher: "AES",
        key: 128,
        iv: 0,
        mode: "ECB",
        type: "block"
      },
      "aes-192-ecb": {
        cipher: "AES",
        key: 192,
        iv: 0,
        mode: "ECB",
        type: "block"
      },
      "aes-256-ecb": {
        cipher: "AES",
        key: 256,
        iv: 0,
        mode: "ECB",
        type: "block"
      },
      "aes-128-cbc": {
        cipher: "AES",
        key: 128,
        iv: 16,
        mode: "CBC",
        type: "block"
      },
      "aes-192-cbc": {
        cipher: "AES",
        key: 192,
        iv: 16,
        mode: "CBC",
        type: "block"
      },
      "aes-256-cbc": {
        cipher: "AES",
        key: 256,
        iv: 16,
        mode: "CBC",
        type: "block"
      },
      aes128: {
        cipher: "AES",
        key: 128,
        iv: 16,
        mode: "CBC",
        type: "block"
      },
      aes192: {
        cipher: "AES",
        key: 192,
        iv: 16,
        mode: "CBC",
        type: "block"
      },
      aes256: {
        cipher: "AES",
        key: 256,
        iv: 16,
        mode: "CBC",
        type: "block"
      },
      "aes-128-cfb": {
        cipher: "AES",
        key: 128,
        iv: 16,
        mode: "CFB",
        type: "stream"
      },
      "aes-192-cfb": {
        cipher: "AES",
        key: 192,
        iv: 16,
        mode: "CFB",
        type: "stream"
      },
      "aes-256-cfb": {
        cipher: "AES",
        key: 256,
        iv: 16,
        mode: "CFB",
        type: "stream"
      },
      "aes-128-cfb8": {
        cipher: "AES",
        key: 128,
        iv: 16,
        mode: "CFB8",
        type: "stream"
      },
      "aes-192-cfb8": {
        cipher: "AES",
        key: 192,
        iv: 16,
        mode: "CFB8",
        type: "stream"
      },
      "aes-256-cfb8": {
        cipher: "AES",
        key: 256,
        iv: 16,
        mode: "CFB8",
        type: "stream"
      },
      "aes-128-cfb1": {
        cipher: "AES",
        key: 128,
        iv: 16,
        mode: "CFB1",
        type: "stream"
      },
      "aes-192-cfb1": {
        cipher: "AES",
        key: 192,
        iv: 16,
        mode: "CFB1",
        type: "stream"
      },
      "aes-256-cfb1": {
        cipher: "AES",
        key: 256,
        iv: 16,
        mode: "CFB1",
        type: "stream"
      },
      "aes-128-ofb": {
        cipher: "AES",
        key: 128,
        iv: 16,
        mode: "OFB",
        type: "stream"
      },
      "aes-192-ofb": {
        cipher: "AES",
        key: 192,
        iv: 16,
        mode: "OFB",
        type: "stream"
      },
      "aes-256-ofb": {
        cipher: "AES",
        key: 256,
        iv: 16,
        mode: "OFB",
        type: "stream"
      },
      "aes-128-ctr": {
        cipher: "AES",
        key: 128,
        iv: 16,
        mode: "CTR",
        type: "stream"
      },
      "aes-192-ctr": {
        cipher: "AES",
        key: 192,
        iv: 16,
        mode: "CTR",
        type: "stream"
      },
      "aes-256-ctr": {
        cipher: "AES",
        key: 256,
        iv: 16,
        mode: "CTR",
        type: "stream"
      },
      "aes-128-gcm": {
        cipher: "AES",
        key: 128,
        iv: 12,
        mode: "GCM",
        type: "auth"
      },
      "aes-192-gcm": {
        cipher: "AES",
        key: 192,
        iv: 12,
        mode: "GCM",
        type: "auth"
      },
      "aes-256-gcm": {
        cipher: "AES",
        key: 256,
        iv: 12,
        mode: "GCM",
        type: "auth"
      }
    };
  }, function (e, t) {
    e.exports = function (e) {
      for (var t, r = e.length; r--;) {
        if (255 !== (t = e.readUInt8(r))) {
          t++, e.writeUInt8(t, r);
          break;
        }

        e.writeUInt8(0, r);
      }
    };
  }, function (e, t, r) {
    var n = r(28),
        i = r(6).Buffer,
        s = r(93);

    function o(e) {
      var t = e._cipher.encryptBlockRaw(e._prev);

      return s(e._prev), t;
    }

    t.encrypt = function (e, t) {
      var r = Math.ceil(t.length / 16),
          s = e._cache.length;
      e._cache = i.concat([e._cache, i.allocUnsafe(16 * r)]);

      for (var a = 0; a < r; a++) {
        var f = o(e),
            c = s + 16 * a;
        e._cache.writeUInt32BE(f[0], c + 0), e._cache.writeUInt32BE(f[1], c + 4), e._cache.writeUInt32BE(f[2], c + 8), e._cache.writeUInt32BE(f[3], c + 12);
      }

      var u = e._cache.slice(0, t.length);

      return e._cache = e._cache.slice(t.length), n(t, u);
    };
  }, function (e, t, r) {
    var n = r(56),
        i = r(55),
        s = r(52),
        o = r(97),
        a = r(96),
        f = r(6).Buffer,
        c = f.alloc(128),
        u = {
      md5: 16,
      sha1: 20,
      sha224: 28,
      sha256: 32,
      sha384: 48,
      sha512: 64,
      rmd160: 20,
      ripemd160: 20
    };

    function h(e, t, r) {
      var o = function (e) {
        return "rmd160" === e || "ripemd160" === e ? i : "md5" === e ? n : function (t) {
          return s(e).update(t).digest();
        };
      }(e),
          a = "sha512" === e || "sha384" === e ? 128 : 64;

      t.length > a ? t = o(t) : t.length < a && (t = f.concat([t, c], a));

      for (var h = f.allocUnsafe(a + u[e]), d = f.allocUnsafe(a + u[e]), l = 0; l < a; l++) {
        h[l] = 54 ^ t[l], d[l] = 92 ^ t[l];
      }

      var p = f.allocUnsafe(a + r + 4);
      h.copy(p, 0, 0, a), this.ipad1 = p, this.ipad2 = h, this.opad = d, this.alg = e, this.blocksize = a, this.hash = o, this.size = u[e];
    }

    h.prototype.run = function (e, t) {
      return e.copy(t, this.blocksize), this.hash(t).copy(this.opad, this.blocksize), this.hash(this.opad);
    }, e.exports = function (e, t, r, n, i) {
      f.isBuffer(e) || (e = f.from(e, a)), f.isBuffer(t) || (t = f.from(t, a)), o(r, n);
      var s = new h(i = i || "sha1", e, t.length),
          c = f.allocUnsafe(n),
          d = f.allocUnsafe(t.length + 4);
      t.copy(d, 0, 0, t.length);

      for (var l = 0, p = u[i], b = Math.ceil(n / p), _ = 1; _ <= b; _++) {
        d.writeUInt32BE(_, t.length);

        for (var g = s.run(d, s.ipad1), v = g, m = 1; m < r; m++) {
          v = s.run(v, s.ipad2);

          for (var y = 0; y < p; y++) {
            g[y] ^= v[y];
          }
        }

        g.copy(c, l), l += p;
      }

      return c;
    };
  }, function (e, t) {
    var r;
    process.browser ? r = "utf-8" : r = parseInt(process.version.split(".")[0].slice(1), 10) >= 6 ? "utf-8" : "binary";
    e.exports = r;
  }, function (e, t) {
    var r = Math.pow(2, 30) - 1;

    e.exports = function (e, t) {
      if ("number" != typeof e) throw new TypeError("Iterations not a number");
      if (e < 0) throw new TypeError("Bad iterations");
      if ("number" != typeof t) throw new TypeError("Key length not a number");
      if (t < 0 || t > r || t != t) throw new TypeError("Bad key length");
    };
  }, function (e, t, r) {
    t.pbkdf2 = r(224), t.pbkdf2Sync = r(95);
  }, function (e) {
    e.exports = {
      sha224WithRSAEncryption: {
        sign: "rsa",
        hash: "sha224",
        id: "302d300d06096086480165030402040500041c"
      },
      "RSA-SHA224": {
        sign: "ecdsa/rsa",
        hash: "sha224",
        id: "302d300d06096086480165030402040500041c"
      },
      sha256WithRSAEncryption: {
        sign: "rsa",
        hash: "sha256",
        id: "3031300d060960864801650304020105000420"
      },
      "RSA-SHA256": {
        sign: "ecdsa/rsa",
        hash: "sha256",
        id: "3031300d060960864801650304020105000420"
      },
      sha384WithRSAEncryption: {
        sign: "rsa",
        hash: "sha384",
        id: "3041300d060960864801650304020205000430"
      },
      "RSA-SHA384": {
        sign: "ecdsa/rsa",
        hash: "sha384",
        id: "3041300d060960864801650304020205000430"
      },
      sha512WithRSAEncryption: {
        sign: "rsa",
        hash: "sha512",
        id: "3051300d060960864801650304020305000440"
      },
      "RSA-SHA512": {
        sign: "ecdsa/rsa",
        hash: "sha512",
        id: "3051300d060960864801650304020305000440"
      },
      "RSA-SHA1": {
        sign: "rsa",
        hash: "sha1",
        id: "3021300906052b0e03021a05000414"
      },
      "ecdsa-with-SHA1": {
        sign: "ecdsa",
        hash: "sha1",
        id: ""
      },
      sha256: {
        sign: "ecdsa",
        hash: "sha256",
        id: ""
      },
      sha224: {
        sign: "ecdsa",
        hash: "sha224",
        id: ""
      },
      sha384: {
        sign: "ecdsa",
        hash: "sha384",
        id: ""
      },
      sha512: {
        sign: "ecdsa",
        hash: "sha512",
        id: ""
      },
      "DSA-SHA": {
        sign: "dsa",
        hash: "sha1",
        id: ""
      },
      "DSA-SHA1": {
        sign: "dsa",
        hash: "sha1",
        id: ""
      },
      DSA: {
        sign: "dsa",
        hash: "sha1",
        id: ""
      },
      "DSA-WITH-SHA224": {
        sign: "dsa",
        hash: "sha224",
        id: ""
      },
      "DSA-SHA224": {
        sign: "dsa",
        hash: "sha224",
        id: ""
      },
      "DSA-WITH-SHA256": {
        sign: "dsa",
        hash: "sha256",
        id: ""
      },
      "DSA-SHA256": {
        sign: "dsa",
        hash: "sha256",
        id: ""
      },
      "DSA-WITH-SHA384": {
        sign: "dsa",
        hash: "sha384",
        id: ""
      },
      "DSA-SHA384": {
        sign: "dsa",
        hash: "sha384",
        id: ""
      },
      "DSA-WITH-SHA512": {
        sign: "dsa",
        hash: "sha512",
        id: ""
      },
      "DSA-SHA512": {
        sign: "dsa",
        hash: "sha512",
        id: ""
      },
      "DSA-RIPEMD160": {
        sign: "dsa",
        hash: "rmd160",
        id: ""
      },
      ripemd160WithRSA: {
        sign: "rsa",
        hash: "rmd160",
        id: "3021300906052b2403020105000414"
      },
      "RSA-RIPEMD160": {
        sign: "rsa",
        hash: "rmd160",
        id: "3021300906052b2403020105000414"
      },
      md5WithRSAEncryption: {
        sign: "rsa",
        hash: "md5",
        id: "3020300c06082a864886f70d020505000410"
      },
      "RSA-MD5": {
        sign: "rsa",
        hash: "md5",
        id: "3020300c06082a864886f70d020505000410"
      }
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(2),
        i = r(226),
        s = r(16),
        o = r(6).Buffer,
        a = r(56),
        f = r(55),
        c = r(52),
        u = o.alloc(128);

    function h(e, t) {
      s.call(this, "digest"), "string" == typeof t && (t = o.from(t));
      var r = "sha512" === e || "sha384" === e ? 128 : 64;
      (this._alg = e, this._key = t, t.length > r) ? t = ("rmd160" === e ? new f() : c(e)).update(t).digest() : t.length < r && (t = o.concat([t, u], r));

      for (var n = this._ipad = o.allocUnsafe(r), i = this._opad = o.allocUnsafe(r), a = 0; a < r; a++) {
        n[a] = 54 ^ t[a], i[a] = 92 ^ t[a];
      }

      this._hash = "rmd160" === e ? new f() : c(e), this._hash.update(n);
    }

    n(h, s), h.prototype._update = function (e) {
      this._hash.update(e);
    }, h.prototype._final = function () {
      var e = this._hash.digest();

      return ("rmd160" === this._alg ? new f() : c(this._alg)).update(this._opad).update(e).digest();
    }, e.exports = function (e, t) {
      return "rmd160" === (e = e.toLowerCase()) || "ripemd160" === e ? new h("rmd160", t) : "md5" === e ? new i(a, t) : new h(e, t);
    };
  }, function (e, t, r) {
    var n = r(2),
        i = r(20),
        s = r(6).Buffer,
        o = [1116352408, 3609767458, 1899447441, 602891725, 3049323471, 3964484399, 3921009573, 2173295548, 961987163, 4081628472, 1508970993, 3053834265, 2453635748, 2937671579, 2870763221, 3664609560, 3624381080, 2734883394, 310598401, 1164996542, 607225278, 1323610764, 1426881987, 3590304994, 1925078388, 4068182383, 2162078206, 991336113, 2614888103, 633803317, 3248222580, 3479774868, 3835390401, 2666613458, 4022224774, 944711139, 264347078, 2341262773, 604807628, 2007800933, 770255983, 1495990901, 1249150122, 1856431235, 1555081692, 3175218132, 1996064986, 2198950837, 2554220882, 3999719339, 2821834349, 766784016, 2952996808, 2566594879, 3210313671, 3203337956, 3336571891, 1034457026, 3584528711, 2466948901, 113926993, 3758326383, 338241895, 168717936, 666307205, 1188179964, 773529912, 1546045734, 1294757372, 1522805485, 1396182291, 2643833823, 1695183700, 2343527390, 1986661051, 1014477480, 2177026350, 1206759142, 2456956037, 344077627, 2730485921, 1290863460, 2820302411, 3158454273, 3259730800, 3505952657, 3345764771, 106217008, 3516065817, 3606008344, 3600352804, 1432725776, 4094571909, 1467031594, 275423344, 851169720, 430227734, 3100823752, 506948616, 1363258195, 659060556, 3750685593, 883997877, 3785050280, 958139571, 3318307427, 1322822218, 3812723403, 1537002063, 2003034995, 1747873779, 3602036899, 1955562222, 1575990012, 2024104815, 1125592928, 2227730452, 2716904306, 2361852424, 442776044, 2428436474, 593698344, 2756734187, 3733110249, 3204031479, 2999351573, 3329325298, 3815920427, 3391569614, 3928383900, 3515267271, 566280711, 3940187606, 3454069534, 4118630271, 4000239992, 116418474, 1914138554, 174292421, 2731055270, 289380356, 3203993006, 460393269, 320620315, 685471733, 587496836, 852142971, 1086792851, 1017036298, 365543100, 1126000580, 2618297676, 1288033470, 3409855158, 1501505948, 4234509866, 1607167915, 987167468, 1816402316, 1246189591],
        a = new Array(160);

    function f() {
      this.init(), this._w = a, i.call(this, 128, 112);
    }

    function c(e, t, r) {
      return r ^ e & (t ^ r);
    }

    function u(e, t, r) {
      return e & t | r & (e | t);
    }

    function h(e, t) {
      return (e >>> 28 | t << 4) ^ (t >>> 2 | e << 30) ^ (t >>> 7 | e << 25);
    }

    function d(e, t) {
      return (e >>> 14 | t << 18) ^ (e >>> 18 | t << 14) ^ (t >>> 9 | e << 23);
    }

    function l(e, t) {
      return (e >>> 1 | t << 31) ^ (e >>> 8 | t << 24) ^ e >>> 7;
    }

    function p(e, t) {
      return (e >>> 1 | t << 31) ^ (e >>> 8 | t << 24) ^ (e >>> 7 | t << 25);
    }

    function b(e, t) {
      return (e >>> 19 | t << 13) ^ (t >>> 29 | e << 3) ^ e >>> 6;
    }

    function _(e, t) {
      return (e >>> 19 | t << 13) ^ (t >>> 29 | e << 3) ^ (e >>> 6 | t << 26);
    }

    function g(e, t) {
      return e >>> 0 < t >>> 0 ? 1 : 0;
    }

    n(f, i), f.prototype.init = function () {
      return this._ah = 1779033703, this._bh = 3144134277, this._ch = 1013904242, this._dh = 2773480762, this._eh = 1359893119, this._fh = 2600822924, this._gh = 528734635, this._hh = 1541459225, this._al = 4089235720, this._bl = 2227873595, this._cl = 4271175723, this._dl = 1595750129, this._el = 2917565137, this._fl = 725511199, this._gl = 4215389547, this._hl = 327033209, this;
    }, f.prototype._update = function (e) {
      for (var t = this._w, r = 0 | this._ah, n = 0 | this._bh, i = 0 | this._ch, s = 0 | this._dh, a = 0 | this._eh, f = 0 | this._fh, v = 0 | this._gh, m = 0 | this._hh, y = 0 | this._al, w = 0 | this._bl, k = 0 | this._cl, S = 0 | this._dl, E = 0 | this._el, A = 0 | this._fl, x = 0 | this._gl, T = 0 | this._hl, R = 0; R < 32; R += 2) {
        t[R] = e.readInt32BE(4 * R), t[R + 1] = e.readInt32BE(4 * R + 4);
      }

      for (; R < 160; R += 2) {
        var M = t[R - 30],
            I = t[R - 30 + 1],
            O = l(M, I),
            C = p(I, M),
            B = b(M = t[R - 4], I = t[R - 4 + 1]),
            P = _(I, M),
            N = t[R - 14],
            L = t[R - 14 + 1],
            j = t[R - 32],
            U = t[R - 32 + 1],
            D = C + L | 0,
            q = O + N + g(D, C) | 0;

        q = (q = q + B + g(D = D + P | 0, P) | 0) + j + g(D = D + U | 0, U) | 0, t[R] = q, t[R + 1] = D;
      }

      for (var z = 0; z < 160; z += 2) {
        q = t[z], D = t[z + 1];
        var F = u(r, n, i),
            W = u(y, w, k),
            Z = h(r, y),
            V = h(y, r),
            H = d(a, E),
            $ = d(E, a),
            K = o[z],
            G = o[z + 1],
            Y = c(a, f, v),
            X = c(E, A, x),
            J = T + $ | 0,
            Q = m + H + g(J, T) | 0;
        Q = (Q = (Q = Q + Y + g(J = J + X | 0, X) | 0) + K + g(J = J + G | 0, G) | 0) + q + g(J = J + D | 0, D) | 0;
        var ee = V + W | 0,
            te = Z + F + g(ee, V) | 0;
        m = v, T = x, v = f, x = A, f = a, A = E, a = s + Q + g(E = S + J | 0, S) | 0, s = i, S = k, i = n, k = w, n = r, w = y, r = Q + te + g(y = J + ee | 0, J) | 0;
      }

      this._al = this._al + y | 0, this._bl = this._bl + w | 0, this._cl = this._cl + k | 0, this._dl = this._dl + S | 0, this._el = this._el + E | 0, this._fl = this._fl + A | 0, this._gl = this._gl + x | 0, this._hl = this._hl + T | 0, this._ah = this._ah + r + g(this._al, y) | 0, this._bh = this._bh + n + g(this._bl, w) | 0, this._ch = this._ch + i + g(this._cl, k) | 0, this._dh = this._dh + s + g(this._dl, S) | 0, this._eh = this._eh + a + g(this._el, E) | 0, this._fh = this._fh + f + g(this._fl, A) | 0, this._gh = this._gh + v + g(this._gl, x) | 0, this._hh = this._hh + m + g(this._hl, T) | 0;
    }, f.prototype._hash = function () {
      var e = s.allocUnsafe(64);

      function t(t, r, n) {
        e.writeInt32BE(t, n), e.writeInt32BE(r, n + 4);
      }

      return t(this._ah, this._al, 0), t(this._bh, this._bl, 8), t(this._ch, this._cl, 16), t(this._dh, this._dl, 24), t(this._eh, this._el, 32), t(this._fh, this._fl, 40), t(this._gh, this._gl, 48), t(this._hh, this._hl, 56), e;
    }, e.exports = f;
  }, function (e, t, r) {
    var n = r(2),
        i = r(20),
        s = r(6).Buffer,
        o = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298],
        a = new Array(64);

    function f() {
      this.init(), this._w = a, i.call(this, 64, 56);
    }

    function c(e, t, r) {
      return r ^ e & (t ^ r);
    }

    function u(e, t, r) {
      return e & t | r & (e | t);
    }

    function h(e) {
      return (e >>> 2 | e << 30) ^ (e >>> 13 | e << 19) ^ (e >>> 22 | e << 10);
    }

    function d(e) {
      return (e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7);
    }

    function l(e) {
      return (e >>> 7 | e << 25) ^ (e >>> 18 | e << 14) ^ e >>> 3;
    }

    n(f, i), f.prototype.init = function () {
      return this._a = 1779033703, this._b = 3144134277, this._c = 1013904242, this._d = 2773480762, this._e = 1359893119, this._f = 2600822924, this._g = 528734635, this._h = 1541459225, this;
    }, f.prototype._update = function (e) {
      for (var t, r = this._w, n = 0 | this._a, i = 0 | this._b, s = 0 | this._c, a = 0 | this._d, f = 0 | this._e, p = 0 | this._f, b = 0 | this._g, _ = 0 | this._h, g = 0; g < 16; ++g) {
        r[g] = e.readInt32BE(4 * g);
      }

      for (; g < 64; ++g) {
        r[g] = 0 | (((t = r[g - 2]) >>> 17 | t << 15) ^ (t >>> 19 | t << 13) ^ t >>> 10) + r[g - 7] + l(r[g - 15]) + r[g - 16];
      }

      for (var v = 0; v < 64; ++v) {
        var m = _ + d(f) + c(f, p, b) + o[v] + r[v] | 0,
            y = h(n) + u(n, i, s) | 0;
        _ = b, b = p, p = f, f = a + m | 0, a = s, s = i, i = n, n = m + y | 0;
      }

      this._a = n + this._a | 0, this._b = i + this._b | 0, this._c = s + this._c | 0, this._d = a + this._d | 0, this._e = f + this._e | 0, this._f = p + this._f | 0, this._g = b + this._g | 0, this._h = _ + this._h | 0;
    }, f.prototype._hash = function () {
      var e = s.allocUnsafe(32);
      return e.writeInt32BE(this._a, 0), e.writeInt32BE(this._b, 4), e.writeInt32BE(this._c, 8), e.writeInt32BE(this._d, 12), e.writeInt32BE(this._e, 16), e.writeInt32BE(this._f, 20), e.writeInt32BE(this._g, 24), e.writeInt32BE(this._h, 28), e;
    }, e.exports = f;
  }, function (e, t, r) {
    "use strict";

    e.exports = s;
    var n = r(17),
        i = r(29);

    function s(e) {
      if (!(this instanceof s)) return new s(e);
      n.call(this, e), this._transformState = {
        afterTransform: function (e, t) {
          var r = this._transformState;
          r.transforming = !1;
          var n = r.writecb;
          if (!n) return this.emit("error", new Error("write callback called multiple times"));
          r.writechunk = null, r.writecb = null, null != t && this.push(t), n(e);
          var i = this._readableState;
          i.reading = !1, (i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
        }.bind(this),
        needTransform: !1,
        transforming: !1,
        writecb: null,
        writechunk: null,
        writeencoding: null
      }, this._readableState.needReadable = !0, this._readableState.sync = !1, e && ("function" == typeof e.transform && (this._transform = e.transform), "function" == typeof e.flush && (this._flush = e.flush)), this.on("prefinish", o);
    }

    function o() {
      var e = this;
      "function" == typeof this._flush ? this._flush(function (t, r) {
        a(e, t, r);
      }) : a(this, null, null);
    }

    function a(e, t, r) {
      if (t) return e.emit("error", t);
      if (null != r && e.push(r), e._writableState.length) throw new Error("Calling transform done when ws.length != 0");
      if (e._transformState.transforming) throw new Error("Calling transform done when still transforming");
      return e.push(null);
    }

    i.inherits = r(2), i.inherits(s, n), s.prototype.push = function (e, t) {
      return this._transformState.needTransform = !1, n.prototype.push.call(this, e, t);
    }, s.prototype._transform = function (e, t, r) {
      throw new Error("_transform() is not implemented");
    }, s.prototype._write = function (e, t, r) {
      var n = this._transformState;

      if (n.writecb = r, n.writechunk = e, n.writeencoding = t, !n.transforming) {
        var i = this._readableState;
        (n.needTransform || i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
      }
    }, s.prototype._read = function (e) {
      var t = this._transformState;
      null !== t.writechunk && t.writecb && !t.transforming ? (t.transforming = !0, this._transform(t.writechunk, t.writeencoding, t.afterTransform)) : t.needTransform = !0;
    }, s.prototype._destroy = function (e, t) {
      var r = this;

      n.prototype._destroy.call(this, e, function (e) {
        t(e), r.emit("close");
      });
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(40);

    function i(e, t) {
      e.emit("error", t);
    }

    e.exports = {
      destroy: function destroy(e, t) {
        var r = this,
            s = this._readableState && this._readableState.destroyed,
            o = this._writableState && this._writableState.destroyed;
        return s || o ? (t ? t(e) : !e || this._writableState && this._writableState.errorEmitted || n.nextTick(i, this, e), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(e || null, function (e) {
          !t && e ? (n.nextTick(i, r, e), r._writableState && (r._writableState.errorEmitted = !0)) : t && t(e);
        }), this);
      },
      undestroy: function undestroy() {
        this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
      }
    };
  }, function (e, t, r) {
    e.exports = r(7).EventEmitter;
  }, function (e, t, r) {
    "use strict";

    (function (t) {
      var n = r(40);
      e.exports = v;
      var i,
          s = r(107);
      v.ReadableState = g;
      r(7).EventEmitter;

      var o = function o(e, t) {
        return e.listeners(t).length;
      },
          a = r(105),
          f = r(6).Buffer,
          c = t.Uint8Array || function () {};

      var u = r(29);
      u.inherits = r(2);
      var h = r(241),
          d = void 0;
      d = h && h.debuglog ? h.debuglog("stream") : function () {};
      var l,
          p = r(240),
          b = r(104);
      u.inherits(v, a);
      var _ = ["error", "close", "destroy", "pause", "resume"];

      function g(e, t) {
        i = i || r(17), e = e || {};
        var n = t instanceof i;
        this.objectMode = !!e.objectMode, n && (this.objectMode = this.objectMode || !!e.readableObjectMode);
        var s = e.highWaterMark,
            o = e.readableHighWaterMark,
            a = this.objectMode ? 16 : 16384;
        this.highWaterMark = s || 0 === s ? s : n && (o || 0 === o) ? o : a, this.highWaterMark = Math.floor(this.highWaterMark), this.buffer = new p(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.destroyed = !1, this.defaultEncoding = e.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, e.encoding && (l || (l = r(53).StringDecoder), this.decoder = new l(e.encoding), this.encoding = e.encoding);
      }

      function v(e) {
        if (i = i || r(17), !(this instanceof v)) return new v(e);
        this._readableState = new g(e, this), this.readable = !0, e && ("function" == typeof e.read && (this._read = e.read), "function" == typeof e.destroy && (this._destroy = e.destroy)), a.call(this);
      }

      function m(e, t, r, n, i) {
        var s,
            o = e._readableState;
        null === t ? (o.reading = !1, function (e, t) {
          if (t.ended) return;

          if (t.decoder) {
            var r = t.decoder.end();
            r && r.length && (t.buffer.push(r), t.length += t.objectMode ? 1 : r.length);
          }

          t.ended = !0, S(e);
        }(e, o)) : (i || (s = function (e, t) {
          var r;
          n = t, f.isBuffer(n) || n instanceof c || "string" == typeof t || void 0 === t || e.objectMode || (r = new TypeError("Invalid non-string/buffer chunk"));
          var n;
          return r;
        }(o, t)), s ? e.emit("error", s) : o.objectMode || t && t.length > 0 ? ("string" == typeof t || o.objectMode || Object.getPrototypeOf(t) === f.prototype || (t = function (e) {
          return f.from(e);
        }(t)), n ? o.endEmitted ? e.emit("error", new Error("stream.unshift() after end event")) : y(e, o, t, !0) : o.ended ? e.emit("error", new Error("stream.push() after EOF")) : (o.reading = !1, o.decoder && !r ? (t = o.decoder.write(t), o.objectMode || 0 !== t.length ? y(e, o, t, !1) : A(e, o)) : y(e, o, t, !1))) : n || (o.reading = !1));
        return function (e) {
          return !e.ended && (e.needReadable || e.length < e.highWaterMark || 0 === e.length);
        }(o);
      }

      function y(e, t, r, n) {
        t.flowing && 0 === t.length && !t.sync ? (e.emit("data", r), e.read(0)) : (t.length += t.objectMode ? 1 : r.length, n ? t.buffer.unshift(r) : t.buffer.push(r), t.needReadable && S(e)), A(e, t);
      }

      Object.defineProperty(v.prototype, "destroyed", {
        get: function get() {
          return void 0 !== this._readableState && this._readableState.destroyed;
        },
        set: function set(e) {
          this._readableState && (this._readableState.destroyed = e);
        }
      }), v.prototype.destroy = b.destroy, v.prototype._undestroy = b.undestroy, v.prototype._destroy = function (e, t) {
        this.push(null), t(e);
      }, v.prototype.push = function (e, t) {
        var r,
            n = this._readableState;
        return n.objectMode ? r = !0 : "string" == typeof e && ((t = t || n.defaultEncoding) !== n.encoding && (e = f.from(e, t), t = ""), r = !0), m(this, e, t, !1, r);
      }, v.prototype.unshift = function (e) {
        return m(this, e, null, !0, !1);
      }, v.prototype.isPaused = function () {
        return !1 === this._readableState.flowing;
      }, v.prototype.setEncoding = function (e) {
        return l || (l = r(53).StringDecoder), this._readableState.decoder = new l(e), this._readableState.encoding = e, this;
      };
      var w = 8388608;

      function k(e, t) {
        return e <= 0 || 0 === t.length && t.ended ? 0 : t.objectMode ? 1 : e != e ? t.flowing && t.length ? t.buffer.head.data.length : t.length : (e > t.highWaterMark && (t.highWaterMark = function (e) {
          return e >= w ? e = w : (e--, e |= e >>> 1, e |= e >>> 2, e |= e >>> 4, e |= e >>> 8, e |= e >>> 16, e++), e;
        }(e)), e <= t.length ? e : t.ended ? t.length : (t.needReadable = !0, 0));
      }

      function S(e) {
        var t = e._readableState;
        t.needReadable = !1, t.emittedReadable || (d("emitReadable", t.flowing), t.emittedReadable = !0, t.sync ? n.nextTick(E, e) : E(e));
      }

      function E(e) {
        d("emit readable"), e.emit("readable"), M(e);
      }

      function A(e, t) {
        t.readingMore || (t.readingMore = !0, n.nextTick(x, e, t));
      }

      function x(e, t) {
        for (var r = t.length; !t.reading && !t.flowing && !t.ended && t.length < t.highWaterMark && (d("maybeReadMore read 0"), e.read(0), r !== t.length);) {
          r = t.length;
        }

        t.readingMore = !1;
      }

      function T(e) {
        d("readable nexttick read 0"), e.read(0);
      }

      function R(e, t) {
        t.reading || (d("resume read 0"), e.read(0)), t.resumeScheduled = !1, t.awaitDrain = 0, e.emit("resume"), M(e), t.flowing && !t.reading && e.read(0);
      }

      function M(e) {
        var t = e._readableState;

        for (d("flow", t.flowing); t.flowing && null !== e.read();) {
          ;
        }
      }

      function I(e, t) {
        return 0 === t.length ? null : (t.objectMode ? r = t.buffer.shift() : !e || e >= t.length ? (r = t.decoder ? t.buffer.join("") : 1 === t.buffer.length ? t.buffer.head.data : t.buffer.concat(t.length), t.buffer.clear()) : r = function (e, t, r) {
          var n;
          e < t.head.data.length ? (n = t.head.data.slice(0, e), t.head.data = t.head.data.slice(e)) : n = e === t.head.data.length ? t.shift() : r ? function (e, t) {
            var r = t.head,
                n = 1,
                i = r.data;
            e -= i.length;

            for (; r = r.next;) {
              var s = r.data,
                  o = e > s.length ? s.length : e;

              if (o === s.length ? i += s : i += s.slice(0, e), 0 === (e -= o)) {
                o === s.length ? (++n, r.next ? t.head = r.next : t.head = t.tail = null) : (t.head = r, r.data = s.slice(o));
                break;
              }

              ++n;
            }

            return t.length -= n, i;
          }(e, t) : function (e, t) {
            var r = f.allocUnsafe(e),
                n = t.head,
                i = 1;
            n.data.copy(r), e -= n.data.length;

            for (; n = n.next;) {
              var s = n.data,
                  o = e > s.length ? s.length : e;

              if (s.copy(r, r.length - e, 0, o), 0 === (e -= o)) {
                o === s.length ? (++i, n.next ? t.head = n.next : t.head = t.tail = null) : (t.head = n, n.data = s.slice(o));
                break;
              }

              ++i;
            }

            return t.length -= i, r;
          }(e, t);
          return n;
        }(e, t.buffer, t.decoder), r);
        var r;
      }

      function O(e) {
        var t = e._readableState;
        if (t.length > 0) throw new Error('"endReadable()" called on non-empty stream');
        t.endEmitted || (t.ended = !0, n.nextTick(C, t, e));
      }

      function C(e, t) {
        e.endEmitted || 0 !== e.length || (e.endEmitted = !0, t.readable = !1, t.emit("end"));
      }

      function B(e, t) {
        for (var r = 0, n = e.length; r < n; r++) {
          if (e[r] === t) return r;
        }

        return -1;
      }

      v.prototype.read = function (e) {
        d("read", e), e = parseInt(e, 10);
        var t = this._readableState,
            r = e;
        if (0 !== e && (t.emittedReadable = !1), 0 === e && t.needReadable && (t.length >= t.highWaterMark || t.ended)) return d("read: emitReadable", t.length, t.ended), 0 === t.length && t.ended ? O(this) : S(this), null;
        if (0 === (e = k(e, t)) && t.ended) return 0 === t.length && O(this), null;
        var n,
            i = t.needReadable;
        return d("need readable", i), (0 === t.length || t.length - e < t.highWaterMark) && d("length less than watermark", i = !0), t.ended || t.reading ? d("reading or ended", i = !1) : i && (d("do read"), t.reading = !0, t.sync = !0, 0 === t.length && (t.needReadable = !0), this._read(t.highWaterMark), t.sync = !1, t.reading || (e = k(r, t))), null === (n = e > 0 ? I(e, t) : null) ? (t.needReadable = !0, e = 0) : t.length -= e, 0 === t.length && (t.ended || (t.needReadable = !0), r !== e && t.ended && O(this)), null !== n && this.emit("data", n), n;
      }, v.prototype._read = function (e) {
        this.emit("error", new Error("_read() is not implemented"));
      }, v.prototype.pipe = function (e, t) {
        var r = this,
            i = this._readableState;

        switch (i.pipesCount) {
          case 0:
            i.pipes = e;
            break;

          case 1:
            i.pipes = [i.pipes, e];
            break;

          default:
            i.pipes.push(e);
        }

        i.pipesCount += 1, d("pipe count=%d opts=%j", i.pipesCount, t);
        var a = (!t || !1 !== t.end) && e !== process.stdout && e !== process.stderr ? c : v;

        function f(t, n) {
          d("onunpipe"), t === r && n && !1 === n.hasUnpiped && (n.hasUnpiped = !0, d("cleanup"), e.removeListener("close", _), e.removeListener("finish", g), e.removeListener("drain", u), e.removeListener("error", b), e.removeListener("unpipe", f), r.removeListener("end", c), r.removeListener("end", v), r.removeListener("data", p), h = !0, !i.awaitDrain || e._writableState && !e._writableState.needDrain || u());
        }

        function c() {
          d("onend"), e.end();
        }

        i.endEmitted ? n.nextTick(a) : r.once("end", a), e.on("unpipe", f);

        var u = function (e) {
          return function () {
            var t = e._readableState;
            d("pipeOnDrain", t.awaitDrain), t.awaitDrain && t.awaitDrain--, 0 === t.awaitDrain && o(e, "data") && (t.flowing = !0, M(e));
          };
        }(r);

        e.on("drain", u);
        var h = !1;
        var l = !1;

        function p(t) {
          d("ondata"), l = !1, !1 !== e.write(t) || l || ((1 === i.pipesCount && i.pipes === e || i.pipesCount > 1 && -1 !== B(i.pipes, e)) && !h && (d("false write response, pause", r._readableState.awaitDrain), r._readableState.awaitDrain++, l = !0), r.pause());
        }

        function b(t) {
          d("onerror", t), v(), e.removeListener("error", b), 0 === o(e, "error") && e.emit("error", t);
        }

        function _() {
          e.removeListener("finish", g), v();
        }

        function g() {
          d("onfinish"), e.removeListener("close", _), v();
        }

        function v() {
          d("unpipe"), r.unpipe(e);
        }

        return r.on("data", p), function (e, t, r) {
          if ("function" == typeof e.prependListener) return e.prependListener(t, r);
          e._events && e._events[t] ? s(e._events[t]) ? e._events[t].unshift(r) : e._events[t] = [r, e._events[t]] : e.on(t, r);
        }(e, "error", b), e.once("close", _), e.once("finish", g), e.emit("pipe", r), i.flowing || (d("pipe resume"), r.resume()), e;
      }, v.prototype.unpipe = function (e) {
        var t = this._readableState,
            r = {
          hasUnpiped: !1
        };
        if (0 === t.pipesCount) return this;
        if (1 === t.pipesCount) return e && e !== t.pipes ? this : (e || (e = t.pipes), t.pipes = null, t.pipesCount = 0, t.flowing = !1, e && e.emit("unpipe", this, r), this);

        if (!e) {
          var n = t.pipes,
              i = t.pipesCount;
          t.pipes = null, t.pipesCount = 0, t.flowing = !1;

          for (var s = 0; s < i; s++) {
            n[s].emit("unpipe", this, r);
          }

          return this;
        }

        var o = B(t.pipes, e);
        return -1 === o ? this : (t.pipes.splice(o, 1), t.pipesCount -= 1, 1 === t.pipesCount && (t.pipes = t.pipes[0]), e.emit("unpipe", this, r), this);
      }, v.prototype.on = function (e, t) {
        var r = a.prototype.on.call(this, e, t);
        if ("data" === e) !1 !== this._readableState.flowing && this.resume();else if ("readable" === e) {
          var i = this._readableState;
          i.endEmitted || i.readableListening || (i.readableListening = i.needReadable = !0, i.emittedReadable = !1, i.reading ? i.length && S(this) : n.nextTick(T, this));
        }
        return r;
      }, v.prototype.addListener = v.prototype.on, v.prototype.resume = function () {
        var e = this._readableState;
        return e.flowing || (d("resume"), e.flowing = !0, function (e, t) {
          t.resumeScheduled || (t.resumeScheduled = !0, n.nextTick(R, e, t));
        }(this, e)), this;
      }, v.prototype.pause = function () {
        return d("call pause flowing=%j", this._readableState.flowing), !1 !== this._readableState.flowing && (d("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
      }, v.prototype.wrap = function (e) {
        var t = this,
            r = this._readableState,
            n = !1;

        for (var i in e.on("end", function () {
          if (d("wrapped end"), r.decoder && !r.ended) {
            var e = r.decoder.end();
            e && e.length && t.push(e);
          }

          t.push(null);
        }), e.on("data", function (i) {
          (d("wrapped data"), r.decoder && (i = r.decoder.write(i)), !r.objectMode || null !== i && void 0 !== i) && (r.objectMode || i && i.length) && (t.push(i) || (n = !0, e.pause()));
        }), e) {
          void 0 === this[i] && "function" == typeof e[i] && (this[i] = function (t) {
            return function () {
              return e[t].apply(e, arguments);
            };
          }(i));
        }

        for (var s = 0; s < _.length; s++) {
          e.on(_[s], this.emit.bind(this, _[s]));
        }

        return this._read = function (t) {
          d("wrapped _read", t), n && (n = !1, e.resume());
        }, this;
      }, Object.defineProperty(v.prototype, "readableHighWaterMark", {
        enumerable: !1,
        get: function get() {
          return this._readableState.highWaterMark;
        }
      }), v._fromList = I;
    }).call(this, r(9));
  }, function (e, t) {
    var r = {}.toString;

    e.exports = Array.isArray || function (e) {
      return "[object Array]" == r.call(e);
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(7),
        i = r(57),
        s = r(156),
        o = r(46),
        a = r(45),
        f = r(45),
        c = r(35),
        u = r(34),
        h = r(135),
        d = r(69),
        l = r(24),
        p = r(68),
        b = r(65),
        _ = ["CONNECTING", "OPEN", "CLOSING", "CLOSED"],
        g = l.kWebSocket,
        v = [8, 13],
        m = 3e4;

    var y =
    /*#__PURE__*/
    function (_n5) {
      _inherits(y, _n5);

      function y(e, t, r) {
        var _this53;

        _classCallCheck(this, y);

        _this53 = _possibleConstructorReturn(this, _getPrototypeOf(y).call(this)), _this53.readyState = y.CONNECTING, _this53.protocol = "", _this53._binaryType = l.BINARY_TYPES[0], _this53._closeFrameReceived = !1, _this53._closeFrameSent = !1, _this53._closeMessage = "", _this53._closeTimer = null, _this53._closeCode = 1006, _this53._extensions = {}, _this53._isServer = !0, _this53._receiver = null, _this53._sender = null, _this53._socket = null, null !== e && (Array.isArray(t) ? t = t.join(", ") : "object" == typeof t && null !== t && (r = t, t = void 0), function (e, t, r) {
          var _this54 = this;

          if (r = Object.assign({
            protocolVersion: v[1],
            perMessageDeflate: !0
          }, r, {
            createConnection: void 0,
            socketPath: void 0,
            hostname: void 0,
            protocol: void 0,
            timeout: void 0,
            method: void 0,
            auth: void 0,
            host: void 0,
            path: void 0,
            port: void 0
          }), -1 === v.indexOf(r.protocolVersion)) throw new RangeError("Unsupported protocol version: ".concat(r.protocolVersion, " ") + "(supported versions: ".concat(v.join(", "), ")"));
          var n;
          this._isServer = !1, "object" == typeof e && void 0 !== e.href ? (n = e, this.url = e.href) : (n = c.parse(e), this.url = e);
          var a = "ws+unix:" === n.protocol;
          if (!(n.host || a && n.pathname)) throw new Error("Invalid URL: ".concat(this.url));
          var f = "wss:" === n.protocol || "https:" === n.protocol,
              h = i.randomBytes(16).toString("base64"),
              p = f ? s : o,
              b = n.search ? "".concat(n.pathname || "/").concat(n.search) : n.pathname || "/";

          var _;

          r.createConnection = f ? k : w, r.port = n.port || (f ? 443 : 80), r.host = n.hostname.startsWith("[") ? n.hostname.slice(1, -1) : n.hostname, r.headers = Object.assign({
            "Sec-WebSocket-Version": r.protocolVersion,
            "Sec-WebSocket-Key": h,
            Connection: "Upgrade",
            Upgrade: "websocket"
          }, r.headers), r.path = b, r.perMessageDeflate && (_ = new u(!0 !== r.perMessageDeflate ? r.perMessageDeflate : {}, !1), r.headers["Sec-WebSocket-Extensions"] = d.format(_defineProperty({}, u.extensionName, _.offer())));
          t && (r.headers["Sec-WebSocket-Protocol"] = t);
          r.origin && (r.protocolVersion < 13 ? r.headers["Sec-WebSocket-Origin"] = r.origin : r.headers.Origin = r.origin);
          n.auth ? r.auth = n.auth : (n.username || n.password) && (r.auth = "".concat(n.username, ":").concat(n.password));

          if (a) {
            var _e16 = b.split(":");

            null == r.agent && process.versions.modules < 57 ? r._socketPath = _e16[0] : r.socketPath = _e16[0], r.path = _e16[1];
          }

          var g = this._req = p.get(r);
          r.handshakeTimeout && g.setTimeout(r.handshakeTimeout, S.bind(null, this, g, "Opening handshake has timed out"));
          g.on("error", function (e) {
            _this54._req.aborted || (g = _this54._req = null, _this54.readyState = y.CLOSING, _this54.emit("error", e), _this54.emitClose());
          }), g.on("response", function (e) {
            _this54.emit("unexpected-response", g, e) || S(_this54, g, "Unexpected server response: ".concat(e.statusCode));
          }), g.on("upgrade", function (e, r, n) {
            if (_this54.emit("upgrade", e), _this54.readyState !== y.CONNECTING) return;
            g = _this54._req = null;
            var s = i.createHash("sha1").update(h + l.GUID, "binary").digest("base64");
            if (e.headers["sec-websocket-accept"] !== s) return void S(_this54, r, "Invalid Sec-WebSocket-Accept header");
            var o = e.headers["sec-websocket-protocol"],
                a = (t || "").split(/, */);
            var f;
            if (!t && o ? f = "Server sent a subprotocol but none was requested" : t && !o ? f = "Server sent no subprotocol" : o && -1 === a.indexOf(o) && (f = "Server sent an invalid subprotocol"), f) S(_this54, r, f);else {
              if (o && (_this54.protocol = o), _) try {
                var _t26 = d.parse(e.headers["sec-websocket-extensions"]);

                _t26[u.extensionName] && (_.accept(_t26[u.extensionName]), _this54._extensions[u.extensionName] = _);
              } catch (e) {
                return void S(_this54, r, "Invalid Sec-WebSocket-Extensions header");
              }

              _this54.setSocket(r, n, 0);
            }
          });
        }.call(_assertThisInitialized(_this53), e, t, r));
        return _this53;
      }

      _createClass(y, [{
        key: "setSocket",
        value: function setSocket(e, t, r) {
          var n = new p(this._binaryType, this._extensions, r);
          this._sender = new b(e, this._extensions), this._receiver = n, this._socket = e, n[g] = this, e[g] = this, n.on("conclude", E), n.on("drain", A), n.on("error", x), n.on("message", R), n.on("ping", M), n.on("pong", I), e.setTimeout(0), e.setNoDelay(), t.length > 0 && e.unshift(t), e.on("close", O), e.on("data", C), e.on("end", B), e.on("error", P), this.readyState = y.OPEN, this.emit("open");
        }
      }, {
        key: "emitClose",
        value: function emitClose() {
          this.readyState = y.CLOSED, this._socket ? (this._extensions[u.extensionName] && this._extensions[u.extensionName].cleanup(), this._receiver.removeAllListeners(), this.emit("close", this._closeCode, this._closeMessage)) : this.emit("close", this._closeCode, this._closeMessage);
        }
      }, {
        key: "close",
        value: function close(e, t) {
          var _this55 = this;

          if (this.readyState !== y.CLOSED) {
            if (this.readyState === y.CONNECTING) {
              var _e17 = "WebSocket was closed before the connection was established";
              return S(this, this._req, _e17);
            }

            this.readyState !== y.CLOSING ? (this.readyState = y.CLOSING, this._sender.close(e, t, !this._isServer, function (e) {
              e || (_this55._closeFrameSent = !0, _this55._socket.writable && (_this55._closeFrameReceived && _this55._socket.end(), _this55._closeTimer = setTimeout(_this55._socket.destroy.bind(_this55._socket), m)));
            })) : this._closeFrameSent && this._closeFrameReceived && this._socket.end();
          }
        }
      }, {
        key: "ping",
        value: function ping(e, t, r) {
          if ("function" == typeof e ? (r = e, e = t = void 0) : "function" == typeof t && (r = t, t = void 0), this.readyState !== y.OPEN) {
            var _e18 = new Error("WebSocket is not open: readyState ".concat(this.readyState, " ") + "(".concat(_[this.readyState], ")"));

            if (r) return r(_e18);
            throw _e18;
          }

          "number" == typeof e && (e = e.toString()), void 0 === t && (t = !this._isServer), this._sender.ping(e || l.EMPTY_BUFFER, t, r);
        }
      }, {
        key: "pong",
        value: function pong(e, t, r) {
          if ("function" == typeof e ? (r = e, e = t = void 0) : "function" == typeof t && (r = t, t = void 0), this.readyState !== y.OPEN) {
            var _e19 = new Error("WebSocket is not open: readyState ".concat(this.readyState, " ") + "(".concat(_[this.readyState], ")"));

            if (r) return r(_e19);
            throw _e19;
          }

          "number" == typeof e && (e = e.toString()), void 0 === t && (t = !this._isServer), this._sender.pong(e || l.EMPTY_BUFFER, t, r);
        }
      }, {
        key: "send",
        value: function send(e, t, r) {
          if ("function" == typeof t && (r = t, t = {}), this.readyState !== y.OPEN) {
            var _e20 = new Error("WebSocket is not open: readyState ".concat(this.readyState, " ") + "(".concat(_[this.readyState], ")"));

            if (r) return r(_e20);
            throw _e20;
          }

          "number" == typeof e && (e = e.toString());
          var n = Object.assign({
            binary: "string" != typeof e,
            mask: !this._isServer,
            compress: !0,
            fin: !0
          }, t);
          this._extensions[u.extensionName] || (n.compress = !1), this._sender.send(e || l.EMPTY_BUFFER, n, r);
        }
      }, {
        key: "terminate",
        value: function terminate() {
          if (this.readyState !== y.CLOSED) {
            if (this.readyState === y.CONNECTING) {
              var _e21 = "WebSocket was closed before the connection was established";
              return S(this, this._req, _e21);
            }

            this._socket && (this.readyState = y.CLOSING, this._socket.destroy());
          }
        }
      }, {
        key: "CONNECTING",
        get: function get() {
          return y.CONNECTING;
        }
      }, {
        key: "CLOSING",
        get: function get() {
          return y.CLOSING;
        }
      }, {
        key: "CLOSED",
        get: function get() {
          return y.CLOSED;
        }
      }, {
        key: "OPEN",
        get: function get() {
          return y.OPEN;
        }
      }, {
        key: "binaryType",
        get: function get() {
          return this._binaryType;
        },
        set: function set(e) {
          l.BINARY_TYPES.indexOf(e) < 0 || (this._binaryType = e, this._receiver && (this._receiver._binaryType = e));
        }
      }, {
        key: "bufferedAmount",
        get: function get() {
          return this._socket ? (this._socket.bufferSize || 0) + this._sender._bufferedBytes : 0;
        }
      }, {
        key: "extensions",
        get: function get() {
          return Object.keys(this._extensions).join();
        }
      }]);

      return y;
    }(n);

    function w(e) {
      return e.path = e.socketPath || e._socketPath || void 0, a.connect(e);
    }

    function k(e) {
      return e.path = e.socketPath || e._socketPath || void 0, e.servername = e.servername || e.host, f.connect(e);
    }

    function S(e, t, r) {
      e.readyState = y.CLOSING;
      var n = new Error(r);
      Error.captureStackTrace(n, S), t.setHeader ? (t.abort(), t.once("abort", e.emitClose.bind(e)), e.emit("error", n)) : (t.destroy(n), t.once("error", e.emit.bind(e, "error")), t.once("close", e.emitClose.bind(e)));
    }

    function E(e, t) {
      var r = this[g];
      r._socket.removeListener("data", C), r._socket.resume(), r._closeFrameReceived = !0, r._closeMessage = t, r._closeCode = e, 1005 === e ? r.close() : r.close(e, t);
    }

    function A() {
      this[g]._socket.resume();
    }

    function x(e) {
      var t = this[g];
      t.readyState = y.CLOSING, t._closeCode = e[l.kStatusCode], t.emit("error", e), t._socket.destroy();
    }

    function T() {
      this[g].emitClose();
    }

    function R(e) {
      this[g].emit("message", e);
    }

    function M(e) {
      var t = this[g];
      t.pong(e, !t._isServer, l.NOOP), t.emit("ping", e);
    }

    function I(e) {
      this[g].emit("pong", e);
    }

    function O() {
      var e = this[g];
      this.removeListener("close", O), this.removeListener("data", C), this.removeListener("end", B), this[g] = void 0, e.readyState = y.CLOSING, e._socket.read(), e._receiver.end(), clearTimeout(e._closeTimer), e._receiver._writableState.finished || e._receiver._writableState.errorEmitted ? e.emitClose() : (e._receiver.on("error", T), e._receiver.on("finish", T));
    }

    function C(e) {
      this[g]._receiver.write(e) || this.pause();
    }

    function B() {
      var e = this[g];
      e.readyState = y.CLOSING, e._receiver.end(), this.end();
    }

    function P() {
      var e = this[g];
      this.removeListener("error", P), this.on("error", l.NOOP), e && (e.readyState = y.CLOSING, this.destroy());
    }

    _.forEach(function (e, t) {
      y[_[t]] = t;
    }), ["open", "error", "close", "message"].forEach(function (e) {
      Object.defineProperty(y.prototype, "on".concat(e), {
        get: function get() {
          var t = this.listeners(e);

          for (var r = 0; r < t.length; r++) {
            if (t[r]._listener) return t[r]._listener;
          }
        },
        set: function set(t) {
          var r = this.listeners(e);

          for (var n = 0; n < r.length; n++) {
            r[n]._listener && this.removeListener(e, r[n]);
          }

          this.addEventListener(e, t);
        }
      });
    }), y.prototype.addEventListener = h.addEventListener, y.prototype.removeEventListener = h.removeEventListener, e.exports = y;
  }, function (e, t, r) {
    e.exports = r(130);
  }, function (e, t) {
    function r(e) {
      if (!(this instanceof r)) return new r(e);
      e = e || {};

      var t = function t() {},
          n = {
        interval: 10,
        now: function now() {
          return new Date().getTime();
        },
        repeat: function repeat(e, t) {
          return setInterval(e, t);
        },
        stop: function stop(e, t) {
          return clearInterval(e, t);
        },
        onsleep: t,
        onwakeup: t
      };

      for (var _t27 in n) {
        _t27 in e || (e[_t27] = n[_t27]);
      }

      this.interval = e.interval, this.lastbeat = 0, this.pintvl = null, this.onsleep = e.onsleep, this.onwakeup = e.onwakeup, this.repeat = e.repeat, this.stop = e.stop, this.now = e.now;
    }

    r.toString = function () {
      return "[Twilio.Heartbeat class]";
    }, r.prototype.toString = function () {
      return "[Twilio.Heartbeat instance]";
    }, r.prototype.beat = function () {
      if (this.lastbeat = this.now(), this.sleeping()) {
        this.onwakeup && this.onwakeup();
        var e = this;
        this.pintvl = this.repeat.call(null, function () {
          e.check();
        }, 1e3 * this.interval);
      }
    }, r.prototype.check = function () {
      var e = this.now() - this.lastbeat;
      !this.sleeping() && e >= 1e3 * this.interval && (this.onsleep && this.onsleep(), this.stop.call(null, this.pintvl), this.pintvl = null);
    }, r.prototype.sleeping = function () {
      return null === this.pintvl;
    }, t.Heartbeat = r;
  }, function (e, t, r) {
    "use strict";

    (function (e) {
      r.d(t, "a", function () {
        return p;
      });
      var n = r(0),
          i = r.n(n),
          s = r(1),
          o = r(7),
          a = r(110),
          f = r(15),
          c = r(42);
      var u = e.window || e,
          h = u.WebSocket ? u.WebSocket : r(246),
          d = 5e3,
          l = c.a;

      var p =
      /*#__PURE__*/
      function (_o$EventEmitter) {
        _inherits(p, _o$EventEmitter);

        function p(e) {
          var _this56;

          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

          _classCallCheck(this, p);

          if (_this56 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this)), !(e && e instanceof f.b)) throw s.twilioErrors.INVALID_ARGUMENT.clone("<Worker>worker is a required parameter to construct EventBridgeSignaling.");
          var r = e.getLogger("EventBridgeSignaling-".concat(e.sid));
          if (!i.a.isNil(t.closeExistingSessions) && !i.a.isBoolean(t.closeExistingSessions)) throw new TypeError("Invalid type passed for <boolean>closeExistingSessions");
          _this56._heartbeat = null, _this56.webSocket = null, _this56._log = r, _this56._worker = e, _this56.closeExistingSessions = t.closeExistingSessions || !1, _this56._config = e._config, _this56.reconnect = !1, _this56.tokenTimer = null, _this56.setUpWebSocket();
          return _possibleConstructorReturn(_this56);
        }

        _createClass(p, [{
          key: "updateToken",
          value: function updateToken(e) {
            if (!e) throw s.twilioErrors.INVALID_ARGUMENT.clone("To update the Twilio token, a new Twilio token must be passed in. <string>newToken is a required parameter.");
            this.setTokenExpirationEvent(), this._log.info("Updated token for Worker " + this._worker.sid), this.reconnect = !0, this.webSocket.readyState !== this.webSocket.CLOSING && this.webSocket.readyState !== this.webSocket.CLOSED || this.createWebSocket();
          }
        }, {
          key: "setTokenExpirationEvent",
          value: function setTokenExpirationEvent() {
            var _this57 = this;

            clearTimeout(this.tokenTimer), this.tokenTimer = setTimeout(function () {
              _this57.reconnect = !1, _this57.emit("tokenExpired");
            }, this.tokenLifetime - d);
          }
        }, {
          key: "setUpWebSocket",
          value: function setUpWebSocket() {
            this._heartbeat && (this._heartbeat.onsleep = function () {}), this._heartbeat = new a.Heartbeat({
              interval: 60
            }), this.createWebSocket();
          }
        }, {
          key: "setLifetime",
          value: function setLifetime(e) {
            this.tokenLifetime = e, this.setTokenExpirationEvent();
          }
        }, {
          key: "createWebSocket",
          value: function createWebSocket() {
            var _this58 = this;

            this.numAttempts = 1, this.reconnect = !0;
            var e = "?".concat(s.EB_URL_PARAMS.TOKEN, "=").concat(this._config.token, "&").concat(s.EB_URL_PARAMS.CLOSE_EXISTING_SESSIONS, "=").concat(this.closeExistingSessions, "&").concat(s.EB_URL_PARAMS.CLIENT_VERSION, "=").concat(l);
            this.webSocket = new h(this._config.WS_SERVER + e), this.webSocket.onopen = function () {
              _this58.numAttempts = 1, _this58.emit("connected"), _this58._heartbeat.onsleep = function () {
                _this58._log.info("Heartbeat not received in the past 60 seconds. Proceeding to disconnect websocket."), _this58.webSocket.onclose();
              }, _this58._heartbeat.beat();
            }, this.webSocket.onmessage = function (e) {
              if (_this58._log.debug("Received event", e.data), _this58._heartbeat.beat(), 0 === e.data.trim().length) return;
              var t;

              try {
                t = JSON.parse(e.data);
              } catch (t) {
                return _this58._log.error("Received data is not valid JSON: " + e.data), void _this58.emit("error", s.twilioErrors.INVALID_GATEWAY_MESSAGE);
              }

              _this58._log.debug("Emitting event: %s with %s", t.event_type, JSON.stringify(t.payload)), _this58.emit(t.event_type, t.payload || null);
            }, this.webSocket.onerror = function (e) {
              _this58._log.error("WebSocket error occurred: ", e), _this58.emit("error", s.twilioErrors.GATEWAY_CONNECTION_FAILED);
            }, this.webSocket.onclose = function () {
              if (_this58.reconnect ? _this58._log.info("WebSocket connection has closed. Trying to reconnect.") : _this58._log.info("WebSocket connection has closed. Not reconnecting due to token expiration."), _this58.emit("disconnected"), _this58._heartbeat.onsleep = function () {}, _this58.reconnect) {
                var _e22 = _this58.generateBackOffInterval(_this58.numAttempts);

                setTimeout(function () {
                  _this58.numAttempts++, _this58.createWebSocket();
                }, _e22);
              }
            };
          }
        }, {
          key: "generateBackOffInterval",
          value: function generateBackOffInterval(e) {
            var t = Math.ceil(800),
                r = Math.floor(1e3 * Math.min(30, Math.pow(2, e) - 1));
            return Math.round(Math.floor(Math.random() * (r - t + 1)) + t);
          }
        }, {
          key: "disconnect",
          value: function disconnect() {
            var _this59 = this;

            this._log.info("Disconnecting websocket"), null !== this.webSocket && (["onmessage", "onclose", "onopen", "onerror"].forEach(function (e) {
              _this59.webSocket[e] = null;
            }), this.webSocket.close()), this.emit("disconnected");
          }
        }]);

        return p;
      }(o.EventEmitter);
    }).call(this, r(9));
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0),
        i = r.n(n),
        s = r(15),
        o = r(1),
        a = r(4);

    var f =
    /*#__PURE__*/
    function (_s$b) {
      _inherits(f, _s$b);

      function f() {
        _classCallCheck(this, f);

        return _possibleConstructorReturn(this, _getPrototypeOf(f).apply(this, arguments));
      }

      _createClass(f, [{
        key: "monitor",
        value: function monitor(e, t, r) {
          if (!i.a.isString(e)) throw new TypeError("Error monitoring reservation: <string>taskSid is a required parameter");
          if (!i.a.isString(t)) throw new TypeError("Error monitoring reservation: <string>reservationSid is a required parameter");
          if (r && !i.a.isObject(r)) throw new TypeError("Error monitoring reservation: <string>extraParams must be an object");
          return this._supervise("monitor", e, t, r);
        }
      }, {
        key: "_supervise",
        value: function _supervise(e, t, r, n) {
          var i = this.getRoutes().getRoute(a.j, t, r).path,
              s = Object.assign({}, n, {
            Instruction: "supervise",
            Supervisor: this.sid,
            SupervisorMode: e
          });
          return this._request.post(i, s, o.API_V1).then(function () {});
        }
      }]);

      return f;
    }(s.b),
        c = r(23),
        u = r(41);

    var h = r(5);

    var d = function d(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      _classCallCheck(this, d);

      if ((this instanceof d ? this.constructor : void 0) === d) throw new TypeError("You cannot instantiate TaskRouterBase directly");
      this._config = new c.a(e, t), this._request = new u.a(this._config), e = h.verifyJWT(e), this.jwt = e, this.accountSid = e.sub, this.workspaceSid = e.grants.task_router.workspace_sid, this.workerSid = e.grants.task_router.worker_sid, this.role = e.grants.task_router.role;
    };

    var l = r(19),
        p = r(5);
    var b = ["friendly_name", "reservation_activity_name", "assignment_activity_name", "target_workers", "max_reserved_workers", "task_order", "reservation_activity_sid", "assignment_activity_sid", "workspace_sid", "account_sid", "sid", "date_created", "date_updated", "lifo_queue"];

    var _ = function _(e) {
      _classCallCheck(this, _);

      if (!(e instanceof g)) throw new TypeError("Failed to create a TaskQueue. <TaskQueueDescriptor>descriptor is a required parameter.");
      Object.assign(this, e);
    };

    var g = function g(e) {
      _classCallCheck(this, g);

      if (!i.a.isObject(e)) throw new TypeError("Failed to instantiate TaskQueueDescriptor. <Descriptor>descriptor is required.");
      if (!b.every(function (t) {
        return t in e;
      })) throw new TypeError("Failed to instantiate TaskQueueDescriptor. <Descriptor>descriptor does not contain all properties of a TaskQueue.");
      this.sid = e.sid, this.accountSid = e.account_sid, this.workspaceSid = e.workspace_sid, this.name = e.friendly_name, this.assignmentActivityName = e.assignment_activity_name, this.reservationActivityName = e.reservation_activity_name, this.assignmentActivitySid = e.assignment_activity_sid, this.reservationActivitySid = e.reservation_activity_sid, this.targetWorkers = e.target_workers, this.maxReservedWorkers = e.max_reserved_workers, this.taskOrder = e.task_order, this.dateCreated = Object(p.parseTime)(1e3 * e.date_created), this.dateUpdated = Object(p.parseTime)(1e3 * e.date_updated);
    };

    var v = function v(e) {
      _classCallCheck(this, v);

      if (!(e instanceof l.a)) throw new TypeError("Failed to create a WorkerContainer. <WorkerDescriptor>descriptor is a required parameter.");
      Object.assign(this, e);
    };

    var m = r(18);

    var y =
    /*#__PURE__*/
    function () {
      function y(e, t) {
        var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        _classCallCheck(this, y);

        if (!(e instanceof s.b)) throw new TypeError("Failed to initialize WorkspacesEntity. <Worker>worker is a required parameter.");
        this._Workers = new Map(), this._TaskQueues = new Map(), this._worker = e, this._request = t, this._log = e.getLogger("WorkspaceEntity-".concat(this._worker.workspaceSid)), this._pageSize = r.pageSize || o.DEFAULT_PAGE_SIZE, i.a.inRange(this._pageSize, 1, o.DEFAULT_PAGE_SIZE + 1) || (this._log.warn("PageSize range for WorkspaceEntity must be between 1 and %d. Setting pageSize to default size=%d", o.DEFAULT_PAGE_SIZE, o.DEFAULT_PAGE_SIZE), this._pageSize = o.DEFAULT_PAGE_SIZE);
      }

      _createClass(y, [{
        key: "fetchWorkers",
        value: function fetchWorkers() {
          return this._getAllWorkers(this._getWorkerPage());
        }
      }, {
        key: "fetchTaskQueues",
        value: function fetchTaskQueues() {
          return this._getAllTaskQueues(this._getTaskQueuePage());
        }
      }, {
        key: "_getAllWorkers",
        value: function _getAllWorkers(e) {
          var _this60 = this;

          return e.then(function (e) {
            e.items.forEach(function (e) {
              return _this60._insertWorker(e);
            }), e.hasNextPage && _this60._getAllWorkers(e.nextPage());
          });
        }
      }, {
        key: "_getWorkerPage",
        value: function _getWorkerPage(e) {
          var _this61 = this;

          e = e || {};

          var t = this._worker.getRoutes().getRoute(a.o).path,
              r = {
            PageSize: this._pageSize
          };

          return e.AfterSid && (r.AfterSid = e.AfterSid), this._request.get(t, o.API_V1, r).then(function (e) {
            return new m(e.contents.map(function (e) {
              return new l.a(e);
            }), function (e) {
              return _this61._getPage({
                AfterSid: e
              });
            }, e.after_sid);
          });
        }
      }, {
        key: "_insertWorker",
        value: function _insertWorker(e) {
          var t = e.sid;

          this._log.trace("_insertWorker(sid=%s, data=%s)", t, JSON.stringify(e));

          try {
            this._Workers.set(t, new v(e));
          } catch (e) {
            this._log.error("Unable to create a Worker for sid=%s. Skipping insert into Worker map. Error: %s", t, e);
          }
        }
      }, {
        key: "_getAllTaskQueues",
        value: function _getAllTaskQueues(e) {
          var _this62 = this;

          return e.then(function (e) {
            e.items.forEach(function (e) {
              return _this62._insertTaskQueue(e);
            }), e.hasNextPage && _this62._getAllTaskQueues(e.nextPage());
          });
        }
      }, {
        key: "_getTaskQueuePage",
        value: function _getTaskQueuePage(e) {
          var _this63 = this;

          e = e || {};

          var t = this._worker.getRoute(a.g).path,
              r = {
            PageSize: this._pageSize
          };

          return e.AfterSid && (r.AfterSid = e.AfterSid), this._request.get(t, o.API_V1, r).then(function (e) {
            return new m(e.contents.map(function (e) {
              return new g(e);
            }), function (e) {
              return _this63._getPage({
                AfterSid: e
              });
            }, e.after_sid);
          });
        }
      }, {
        key: "_insertTaskQueue",
        value: function _insertTaskQueue(e) {
          var t = e.sid;

          this._log.trace("_insertTaskQueue(sid=%s, data=%s", t, JSON.stringify(e));

          try {
            this._TaskQueues.set(t, new _(e));
          } catch (e) {
            this._log.error("Unable to create a TaskQueue for sid=%s. Skipping insert into TaskQueue map. Error: %s", t, e);
          }
        }
      }, {
        key: "Workers",
        get: function get() {
          return this._Workers;
        }
      }, {
        key: "TaskQueues",
        get: function get() {
          return this._TaskQueues;
        }
      }]);

      return y;
    }();

    var w =
    /*#__PURE__*/
    function (_d) {
      _inherits(w, _d);

      function w(e) {
        var _this64;

        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, w);

        if (_this64 = _possibleConstructorReturn(this, _getPrototypeOf(w).call(this, e, t)), "admin" !== _this64.role.toLowerCase()) throw new TypeError('A token with the "admin" role is required to use this functionality.');
        _this64.workspaceEntity = new y(_this64._config, _this64._request, t);
        return _possibleConstructorReturn(_this64);
      }

      _createClass(w, [{
        key: "fetchWorkers",
        value: function fetchWorkers() {
          var _this65 = this;

          return this.workspaceEntity.fetchWorkers().then(function () {
            return _this65.workspaceEntity.Workers;
          });
        }
      }, {
        key: "fetchTaskQueues",
        value: function fetchTaskQueues() {
          var _this66 = this;

          return this.workspaceEntity.fetchTaskQueues().then(function () {
            return _this66.workspaceEntity.TaskQueues;
          });
        }
      }]);

      return w;
    }(d);

    r.d(t, "Supervisor", function () {
      return f;
    }), r.d(t, "Worker", function () {
      return s.b;
    }), r.d(t, "Workspace", function () {
      return w;
    });
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e) {
      return function (t) {
        return e.apply(null, t);
      };
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(60);

    function i(e) {
      if ("function" != typeof e) throw new TypeError("executor must be a function.");
      var t;
      this.promise = new Promise(function (e) {
        t = e;
      });
      var r = this;
      e(function (e) {
        r.reason || (r.reason = new n(e), t(r.reason));
      });
    }

    i.prototype.throwIfRequested = function () {
      if (this.reason) throw this.reason;
    }, i.source = function () {
      var e;
      return {
        token: new i(function (t) {
          e = t;
        }),
        cancel: e
      };
    }, e.exports = i;
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e, t) {
      return t ? e.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : e;
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e) {
      return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(e);
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(12);

    e.exports = function (e, t, r) {
      return n.forEach(r, function (r) {
        e = r(e, t);
      }), e;
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(12),
        i = r(117),
        s = r(61),
        o = r(43),
        a = r(116),
        f = r(115);

    function c(e) {
      e.cancelToken && e.cancelToken.throwIfRequested();
    }

    e.exports = function (e) {
      return c(e), e.baseURL && !a(e.url) && (e.url = f(e.baseURL, e.url)), e.headers = e.headers || {}, e.data = i(e.data, e.headers, e.transformRequest), e.headers = n.merge(e.headers.common || {}, e.headers[e.method] || {}, e.headers || {}), n.forEach(["delete", "get", "head", "post", "put", "patch", "common"], function (t) {
        delete e.headers[t];
      }), (e.adapter || o.adapter)(e).then(function (t) {
        return c(e), t.data = i(t.data, t.headers, e.transformResponse), t;
      }, function (t) {
        return s(t) || (c(e), t && t.response && (t.response.data = i(t.response.data, t.response.headers, e.transformResponse))), Promise.reject(t);
      });
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(12);

    function i() {
      this.handlers = [];
    }

    i.prototype.use = function (e, t) {
      return this.handlers.push({
        fulfilled: e,
        rejected: t
      }), this.handlers.length - 1;
    }, i.prototype.eject = function (e) {
      this.handlers[e] && (this.handlers[e] = null);
    }, i.prototype.forEach = function (e) {
      n.forEach(this.handlers, function (t) {
        null !== t && e(t);
      });
    }, e.exports = i;
  }, function (e, t, r) {
    "use strict";

    var n = r(12);
    e.exports = n.isStandardBrowserEnv() ? {
      write: function write(e, t, r, i, s, o) {
        var a = [];
        a.push(e + "=" + encodeURIComponent(t)), n.isNumber(r) && a.push("expires=" + new Date(r).toGMTString()), n.isString(i) && a.push("path=" + i), n.isString(s) && a.push("domain=" + s), !0 === o && a.push("secure"), document.cookie = a.join("; ");
      },
      read: function read(e) {
        var t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
        return t ? decodeURIComponent(t[3]) : null;
      },
      remove: function remove(e) {
        this.write(e, "", Date.now() - 864e5);
      }
    } : {
      write: function write() {},
      read: function read() {
        return null;
      },
      remove: function remove() {}
    };
  }, function (e, t, r) {
    "use strict";

    var n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

    function i() {
      this.message = "String contains an invalid character";
    }

    i.prototype = new Error(), i.prototype.code = 5, i.prototype.name = "InvalidCharacterError", e.exports = function (e) {
      for (var t, r, s = String(e), o = "", a = 0, f = n; s.charAt(0 | a) || (f = "=", a % 1); o += f.charAt(63 & t >> 8 - a % 1 * 8)) {
        if ((r = s.charCodeAt(a += .75)) > 255) throw new i();
        t = t << 8 | r;
      }

      return o;
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(12);
    e.exports = n.isStandardBrowserEnv() ? function () {
      var e,
          t = /(msie|trident)/i.test(navigator.userAgent),
          r = document.createElement("a");

      function i(e) {
        var n = e;
        return t && (r.setAttribute("href", n), n = r.href), r.setAttribute("href", n), {
          href: r.href,
          protocol: r.protocol ? r.protocol.replace(/:$/, "") : "",
          host: r.host,
          search: r.search ? r.search.replace(/^\?/, "") : "",
          hash: r.hash ? r.hash.replace(/^#/, "") : "",
          hostname: r.hostname,
          port: r.port,
          pathname: "/" === r.pathname.charAt(0) ? r.pathname : "/" + r.pathname
        };
      }

      return e = i(window.location.href), function (t) {
        var r = n.isString(t) ? i(t) : t;
        return r.protocol === e.protocol && r.host === e.host;
      };
    }() : function () {
      return !0;
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(12),
        i = ["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"];

    e.exports = function (e) {
      var t,
          r,
          s,
          o = {};
      return e ? (n.forEach(e.split("\n"), function (e) {
        if (s = e.indexOf(":"), t = n.trim(e.substr(0, s)).toLowerCase(), r = n.trim(e.substr(s + 1)), t) {
          if (o[t] && i.indexOf(t) >= 0) return;
          o[t] = "set-cookie" === t ? (o[t] ? o[t] : []).concat([r]) : o[t] ? o[t] + ", " + r : r;
        }
      }), o) : o;
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(12);

    function i(e) {
      return encodeURIComponent(e).replace(/%40/gi, "@").replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    }

    e.exports = function (e, t, r) {
      if (!t) return e;
      var s;
      if (r) s = r(t);else if (n.isURLSearchParams(t)) s = t.toString();else {
        var o = [];
        n.forEach(t, function (e, t) {
          null !== e && void 0 !== e && (n.isArray(e) ? t += "[]" : e = [e], n.forEach(e, function (e) {
            n.isDate(e) ? e = e.toISOString() : n.isObject(e) && (e = JSON.stringify(e)), o.push(i(t) + "=" + i(e));
          }));
        }), s = o.join("&");
      }
      return s && (e += (-1 === e.indexOf("?") ? "?" : "&") + s), e;
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e, t, r, n, i) {
      return e.config = t, r && (e.code = r), e.request = n, e.response = i, e;
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(62);

    e.exports = function (e, t, r) {
      var i = r.config.validateStatus;
      r.status && i && !i(r.status) ? t(n("Request failed with status code " + r.status, r.config, null, r.request, r)) : e(r);
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(12);

    e.exports = function (e, t) {
      n.forEach(e, function (r, n) {
        n !== t && n.toUpperCase() === t.toUpperCase() && (e[t] = r, delete e[n]);
      });
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(43),
        i = r(12),
        s = r(119),
        o = r(118);

    function a(e) {
      this.defaults = e, this.interceptors = {
        request: new s(),
        response: new s()
      };
    }

    a.prototype.request = function (e) {
      "string" == typeof e && (e = i.merge({
        url: arguments[0]
      }, arguments[1])), (e = i.merge(n, {
        method: "get"
      }, this.defaults, e)).method = e.method.toLowerCase();
      var t = [o, void 0],
          r = Promise.resolve(e);

      for (this.interceptors.request.forEach(function (e) {
        t.unshift(e.fulfilled, e.rejected);
      }), this.interceptors.response.forEach(function (e) {
        t.push(e.fulfilled, e.rejected);
      }); t.length;) {
        r = r.then(t.shift(), t.shift());
      }

      return r;
    }, i.forEach(["delete", "get", "head", "options"], function (e) {
      a.prototype[e] = function (t, r) {
        return this.request(i.merge(r || {}, {
          method: e,
          url: t
        }));
      };
    }), i.forEach(["post", "put", "patch"], function (e) {
      a.prototype[e] = function (t, r, n) {
        return this.request(i.merge(n || {}, {
          method: e,
          url: t,
          data: r
        }));
      };
    }), e.exports = a;
  }, function (e, t) {
    function r(e) {
      return !!e.constructor && "function" == typeof e.constructor.isBuffer && e.constructor.isBuffer(e);
    }
    /*!
     * Determine if an object is a Buffer
     *
     * @author   Feross Aboukhadijeh <https://feross.org>
     * @license  MIT
     */


    e.exports = function (e) {
      return null != e && (r(e) || function (e) {
        return "function" == typeof e.readFloatLE && "function" == typeof e.slice && r(e.slice(0, 0));
      }(e) || !!e._isBuffer);
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(12),
        i = r(64),
        s = r(128),
        o = r(43);

    function a(e) {
      var t = new s(e),
          r = i(s.prototype.request, t);
      return n.extend(r, s.prototype, t), n.extend(r, t), r;
    }

    var f = a(o);
    f.Axios = s, f.create = function (e) {
      return a(n.merge(o, e));
    }, f.Cancel = r(60), f.CancelToken = r(114), f.isCancel = r(61), f.all = function (e) {
      return Promise.all(e);
    }, f.spread = r(113), e.exports = f, e.exports.default = f;
  }, function (e, t, r) {
    "use strict";

    (function (t) {
      var n = r(7),
          i = r(57),
          s = r(46),
          o = r(35),
          a = r(34),
          f = r(69),
          c = r(24),
          u = r(108);

      function h() {
        this.destroy();
      }

      function d(e, r, n) {
        e.writable && (n = n || s.STATUS_CODES[r], e.write("HTTP/1.1 ".concat(r, " ").concat(s.STATUS_CODES[r], "\r\n") + "Connection: close\r\nContent-type: text/html\r\n" + "Content-Length: ".concat(t.byteLength(n), "\r\n") + "\r\n" + n)), e.removeListener("error", h), e.destroy();
      }

      e.exports =
      /*#__PURE__*/
      function (_n6) {
        _inherits(_class4, _n6);

        function _class4(e, t) {
          var _this67;

          _classCallCheck(this, _class4);

          if (_this67 = _possibleConstructorReturn(this, _getPrototypeOf(_class4).call(this)), null == (e = Object.assign({
            maxPayload: 104857600,
            perMessageDeflate: !1,
            handleProtocols: null,
            clientTracking: !0,
            verifyClient: null,
            noServer: !1,
            backlog: null,
            server: null,
            host: null,
            path: null,
            port: null
          }, e)).port && !e.server && !e.noServer) throw new TypeError('One of the "port", "server", or "noServer" options must be specified');
          null != e.port ? (_this67._server = s.createServer(function (e, t) {
            var r = s.STATUS_CODES[426];
            t.writeHead(426, {
              "Content-Length": r.length,
              "Content-Type": "text/plain"
            }), t.end(r);
          }), _this67._server.listen(e.port, e.host, e.backlog, t)) : e.server && (_this67._server = e.server), _this67._server && (_this67._removeListeners = function (e, t) {
            for (var _i2 = 0, _Object$keys = Object.keys(t); _i2 < _Object$keys.length; _i2++) {
              var _r19 = _Object$keys[_i2];
              e.on(_r19, t[_r19]);
            }

            return function () {
              for (var _i3 = 0, _Object$keys2 = Object.keys(t); _i3 < _Object$keys2.length; _i3++) {
                var _r18 = _Object$keys2[_i3];
                e.removeListener(_r18, t[_r18]);
              }
            };
          }(_this67._server, {
            listening: _this67.emit.bind(_assertThisInitialized(_this67), "listening"),
            error: _this67.emit.bind(_assertThisInitialized(_this67), "error"),
            upgrade: function upgrade(e, t, r) {
              _this67.handleUpgrade(e, t, r, function (t) {
                _this67.emit("connection", t, e);
              });
            }
          })), !0 === e.perMessageDeflate && (e.perMessageDeflate = {}), e.clientTracking && (_this67.clients = new Set()), _this67.options = e;
          return _possibleConstructorReturn(_this67);
        }

        _createClass(_class4, [{
          key: "address",
          value: function address() {
            if (this.options.noServer) throw new Error('The server is operating in "noServer" mode');
            return this._server ? this._server.address() : null;
          }
        }, {
          key: "close",
          value: function close(e) {
            if (this.clients) {
              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = this.clients[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var _e23 = _step2.value;

                  _e23.terminate();
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }
            }

            var t = this._server;
            if (t && (this._removeListeners(), this._removeListeners = this._server = null, null != this.options.port)) return t.close(e);
            e && e();
          }
        }, {
          key: "shouldHandle",
          value: function shouldHandle(e) {
            return !this.options.path || o.parse(e.url).pathname === this.options.path;
          }
        }, {
          key: "handleUpgrade",
          value: function handleUpgrade(e, t, r, n) {
            var _this68 = this;

            t.on("error", h);
            var i = +e.headers["sec-websocket-version"],
                s = {};
            if ("GET" !== e.method || "websocket" !== e.headers.upgrade.toLowerCase() || !e.headers["sec-websocket-key"] || 8 !== i && 13 !== i || !this.shouldHandle(e)) return d(t, 400);

            if (this.options.perMessageDeflate) {
              var _r20 = new a(this.options.perMessageDeflate, !0, this.options.maxPayload);

              try {
                var _n7 = f.parse(e.headers["sec-websocket-extensions"]);

                _n7[a.extensionName] && (_r20.accept(_n7[a.extensionName]), s[a.extensionName] = _r20);
              } catch (e) {
                return d(t, 400);
              }
            }

            if (this.options.verifyClient) {
              var _o2 = {
                origin: e.headers["".concat(8 === i ? "sec-websocket-origin" : "origin")],
                secure: !(!e.connection.authorized && !e.connection.encrypted),
                req: e
              };
              if (2 === this.options.verifyClient.length) return void this.options.verifyClient(_o2, function (i, o, a) {
                if (!i) return d(t, o || 401, a);

                _this68.completeUpgrade(s, e, t, r, n);
              });
              if (!this.options.verifyClient(_o2)) return d(t, 401);
            }

            this.completeUpgrade(s, e, t, r, n);
          }
        }, {
          key: "completeUpgrade",
          value: function completeUpgrade(e, t, r, n, s) {
            var _this69 = this;

            if (!r.readable || !r.writable) return r.destroy();
            var o = ["HTTP/1.1 101 Switching Protocols", "Upgrade: websocket", "Connection: Upgrade", "Sec-WebSocket-Accept: ".concat(i.createHash("sha1").update(t.headers["sec-websocket-key"] + c.GUID, "binary").digest("base64"))],
                d = new u(null);
            var l = t.headers["sec-websocket-protocol"];

            if (l && (l = l.trim().split(/ *, */), (l = this.options.handleProtocols ? this.options.handleProtocols(l, t) : l[0]) && (o.push("Sec-WebSocket-Protocol: ".concat(l)), d.protocol = l)), e[a.extensionName]) {
              var _t28 = e[a.extensionName].params,
                  _r21 = f.format(_defineProperty({}, a.extensionName, [_t28]));

              o.push("Sec-WebSocket-Extensions: ".concat(_r21)), d._extensions = e;
            }

            this.emit("headers", o, t), r.write(o.concat("\r\n").join("\r\n")), r.removeListener("error", h), d.setSocket(r, n, this.options.maxPayload), this.clients && (this.clients.add(d), d.on("close", function () {
              return _this69.clients.delete(d);
            })), s(d);
          }
        }]);

        return _class4;
      }(n);
    }).call(this, r(3).Buffer);
  }, function (e, t, r) {
    "use strict";
    /*!
     * UTF-8 validate: UTF-8 validation for WebSockets.
     * Copyright(c) 2015 Einar Otto Stangvik <einaros@gmail.com>
     * MIT Licensed
     */

    e.exports = function (e) {
      for (var t = e.length, r = 0; r < t;) {
        if (e[r] < 128) r++;else if (192 == (224 & e[r])) {
          if (r + 1 === t || 128 != (192 & e[r + 1]) || 192 == (254 & e[r])) return !1;
          r += 2;
        } else if (224 == (240 & e[r])) {
          if (r + 2 >= t || 128 != (192 & e[r + 1]) || 128 != (192 & e[r + 2]) || 224 === e[r] && 128 == (224 & e[r + 1]) || 237 === e[r] && 160 == (224 & e[r + 1])) return !1;
          r += 3;
        } else {
          if (240 != (248 & e[r])) return !1;
          if (r + 3 >= t || 128 != (192 & e[r + 1]) || 128 != (192 & e[r + 2]) || 128 != (192 & e[r + 3]) || 240 === e[r] && 128 == (240 & e[r + 1]) || 244 === e[r] && e[r + 1] > 143 || e[r] > 244) return !1;
          r += 4;
        }
      }

      return !0;
    };
  }, function (e, _t29, r) {
    (function (n) {
      var i = r(45),
          s = r(10),
          o = s.join,
          a = s.dirname,
          f = i.accessSync && function (e) {
        try {
          i.accessSync(e);
        } catch (e) {
          return !1;
        }

        return !0;
      } || i.existsSync || s.existsSync,
          c = {
        arrow: process.env.NODE_BINDINGS_ARROW || " → ",
        compiled: process.env.NODE_BINDINGS_COMPILED_DIR || "compiled",
        platform: process.platform,
        arch: process.arch,
        version: process.versions.node,
        bindings: "bindings.node",
        try: [["module_root", "build", "bindings"], ["module_root", "build", "Debug", "bindings"], ["module_root", "build", "Release", "bindings"], ["module_root", "out", "Debug", "bindings"], ["module_root", "Debug", "bindings"], ["module_root", "out", "Release", "bindings"], ["module_root", "Release", "bindings"], ["module_root", "build", "default", "bindings"], ["module_root", "compiled", "version", "platform", "arch", "bindings"]]
      };

      e.exports = _t29 = function t(e) {
        "string" == typeof e ? e = {
          bindings: e
        } : e || (e = {}), Object.keys(c).map(function (t) {
          t in e || (e[t] = c[t]);
        }), e.module_root || (e.module_root = _t29.getRoot(_t29.getFileName())), ".node" != s.extname(e.bindings) && (e.bindings += ".node");

        for (var n, i, a, f = [], u = 0, h = e.try.length; u < h; u++) {
          n = o.apply(null, e.try[u].map(function (t) {
            return e[t] || t;
          })), f.push(n);

          try {
            return i = e.path ? r(66).resolve(n) : r(66)(n), e.path || (i.path = n), i;
          } catch (e) {
            if (!/not find/i.test(e.message)) throw e;
          }
        }

        throw (a = new Error("Could not locate the bindings file. Tried:\n" + f.map(function (t) {
          return e.arrow + t;
        }).join("\n"))).tries = f, a;
      }, _t29.getFileName = function (e) {
        var t,
            r = Error.prepareStackTrace,
            i = Error.stackTraceLimit,
            s = {};
        return Error.stackTraceLimit = 10, Error.prepareStackTrace = function (r, i) {
          for (var s = 0, o = i.length; s < o; s++) {
            if ((t = i[s].getFileName()) !== n) {
              if (!e) return;
              if (t !== e) return;
            }
          }
        }, Error.captureStackTrace(s), Error.prepareStackTrace = r, Error.stackTraceLimit = i, t;
      }, _t29.getRoot = function (e) {
        for (var t, r = a(e);;) {
          if ("." === r && (r = process.cwd()), f(o(r, "package.json")) || f(o(r, "node_modules"))) return r;
          if (t === r) throw new Error('Could not find module root given file: "' + e + '". Do you have a `package.json` file? ');
          t = r, r = o(r, "..");
        }
      };
    }).call(this, "/index.js");
  }, function (e, t, r) {
    "use strict";

    try {
      e.exports = r(133)("validation");
    } catch (t) {
      e.exports = r(132);
    }
  }, function (e, t, r) {
    "use strict";

    var n = function n(e, t) {
      _classCallCheck(this, n);

      this.target = t, this.type = e;
    };

    var i =
    /*#__PURE__*/
    function (_n8) {
      _inherits(i, _n8);

      function i(e, t) {
        var _this70;

        _classCallCheck(this, i);

        _this70 = _possibleConstructorReturn(this, _getPrototypeOf(i).call(this, "message", t)), _this70.data = e;
        return _this70;
      }

      return i;
    }(n);

    var s =
    /*#__PURE__*/
    function (_n9) {
      _inherits(s, _n9);

      function s(e, t, r) {
        var _this71;

        _classCallCheck(this, s);

        _this71 = _possibleConstructorReturn(this, _getPrototypeOf(s).call(this, "close", r)), _this71.wasClean = r._closeFrameReceived && r._closeFrameSent, _this71.reason = t, _this71.code = e;
        return _this71;
      }

      return s;
    }(n);

    var o =
    /*#__PURE__*/
    function (_n10) {
      _inherits(o, _n10);

      function o(e) {
        _classCallCheck(this, o);

        return _possibleConstructorReturn(this, _getPrototypeOf(o).call(this, "open", e));
      }

      return o;
    }(n);

    var a =
    /*#__PURE__*/
    function (_n11) {
      _inherits(a, _n11);

      function a(e, t) {
        var _this72;

        _classCallCheck(this, a);

        _this72 = _possibleConstructorReturn(this, _getPrototypeOf(a).call(this, "error", t)), _this72.message = e.message, _this72.error = e;
        return _this72;
      }

      return a;
    }(n);

    var f = {
      addEventListener: function addEventListener(e, t) {
        function r(e) {
          t.call(this, new i(e, this));
        }

        function n(e, r) {
          t.call(this, new s(e, r, this));
        }

        function f(e) {
          t.call(this, new a(e, this));
        }

        function c() {
          t.call(this, new o(this));
        }

        "function" == typeof t && ("message" === e ? (r._listener = t, this.on(e, r)) : "close" === e ? (n._listener = t, this.on(e, n)) : "error" === e ? (f._listener = t, this.on(e, f)) : "open" === e ? (c._listener = t, this.on(e, c)) : this.on(e, t));
      },
      removeEventListener: function removeEventListener(e, t) {
        var r = this.listeners(e);

        for (var n = 0; n < r.length; n++) {
          r[n] !== t && r[n]._listener !== t || this.removeListener(e, r[n]);
        }
      }
    };
    e.exports = f;
  }, function (e, t, r) {
    "use strict";

    e.exports = {
      Z_NO_FLUSH: 0,
      Z_PARTIAL_FLUSH: 1,
      Z_SYNC_FLUSH: 2,
      Z_FULL_FLUSH: 3,
      Z_FINISH: 4,
      Z_BLOCK: 5,
      Z_TREES: 6,
      Z_OK: 0,
      Z_STREAM_END: 1,
      Z_NEED_DICT: 2,
      Z_ERRNO: -1,
      Z_STREAM_ERROR: -2,
      Z_DATA_ERROR: -3,
      Z_BUF_ERROR: -5,
      Z_NO_COMPRESSION: 0,
      Z_BEST_SPEED: 1,
      Z_BEST_COMPRESSION: 9,
      Z_DEFAULT_COMPRESSION: -1,
      Z_FILTERED: 1,
      Z_HUFFMAN_ONLY: 2,
      Z_RLE: 3,
      Z_FIXED: 4,
      Z_DEFAULT_STRATEGY: 0,
      Z_BINARY: 0,
      Z_TEXT: 1,
      Z_UNKNOWN: 2,
      Z_DEFLATED: 8
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(33),
        i = [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0],
        s = [16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78],
        o = [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0],
        a = [16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64];

    e.exports = function (e, t, r, f, c, u, h, d) {
      var l,
          p,
          b,
          _,
          g,
          v,
          m,
          y,
          w,
          k = d.bits,
          S = 0,
          E = 0,
          A = 0,
          x = 0,
          T = 0,
          R = 0,
          M = 0,
          I = 0,
          O = 0,
          C = 0,
          B = null,
          P = 0,
          N = new n.Buf16(16),
          L = new n.Buf16(16),
          j = null,
          U = 0;

      for (S = 0; S <= 15; S++) {
        N[S] = 0;
      }

      for (E = 0; E < f; E++) {
        N[t[r + E]]++;
      }

      for (T = k, x = 15; x >= 1 && 0 === N[x]; x--) {
        ;
      }

      if (T > x && (T = x), 0 === x) return c[u++] = 20971520, c[u++] = 20971520, d.bits = 1, 0;

      for (A = 1; A < x && 0 === N[A]; A++) {
        ;
      }

      for (T < A && (T = A), I = 1, S = 1; S <= 15; S++) {
        if (I <<= 1, (I -= N[S]) < 0) return -1;
      }

      if (I > 0 && (0 === e || 1 !== x)) return -1;

      for (L[1] = 0, S = 1; S < 15; S++) {
        L[S + 1] = L[S] + N[S];
      }

      for (E = 0; E < f; E++) {
        0 !== t[r + E] && (h[L[t[r + E]]++] = E);
      }

      if (0 === e ? (B = j = h, v = 19) : 1 === e ? (B = i, P -= 257, j = s, U -= 257, v = 256) : (B = o, j = a, v = -1), C = 0, E = 0, S = A, g = u, R = T, M = 0, b = -1, _ = (O = 1 << T) - 1, 1 === e && O > 852 || 2 === e && O > 592) return 1;

      for (;;) {
        m = S - M, h[E] < v ? (y = 0, w = h[E]) : h[E] > v ? (y = j[U + h[E]], w = B[P + h[E]]) : (y = 96, w = 0), l = 1 << S - M, A = p = 1 << R;

        do {
          c[g + (C >> M) + (p -= l)] = m << 24 | y << 16 | w | 0;
        } while (0 !== p);

        for (l = 1 << S - 1; C & l;) {
          l >>= 1;
        }

        if (0 !== l ? (C &= l - 1, C += l) : C = 0, E++, 0 == --N[S]) {
          if (S === x) break;
          S = t[r + h[E]];
        }

        if (S > T && (C & _) !== b) {
          for (0 === M && (M = T), g += A, I = 1 << (R = S - M); R + M < x && !((I -= N[R + M]) <= 0);) {
            R++, I <<= 1;
          }

          if (O += 1 << R, 1 === e && O > 852 || 2 === e && O > 592) return 1;
          c[b = C & _] = T << 24 | R << 16 | g - u | 0;
        }
      }

      return 0 !== C && (c[g + C] = S - M << 24 | 64 << 16 | 0), d.bits = T, 0;
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e, t) {
      var r, n, i, s, o, a, f, c, u, h, d, l, p, b, _, g, v, m, y, w, k, S, E, A, x;

      r = e.state, n = e.next_in, A = e.input, i = n + (e.avail_in - 5), s = e.next_out, x = e.output, o = s - (t - e.avail_out), a = s + (e.avail_out - 257), f = r.dmax, c = r.wsize, u = r.whave, h = r.wnext, d = r.window, l = r.hold, p = r.bits, b = r.lencode, _ = r.distcode, g = (1 << r.lenbits) - 1, v = (1 << r.distbits) - 1;

      e: do {
        p < 15 && (l += A[n++] << p, p += 8, l += A[n++] << p, p += 8), m = b[l & g];

        t: for (;;) {
          if (l >>>= y = m >>> 24, p -= y, 0 === (y = m >>> 16 & 255)) x[s++] = 65535 & m;else {
            if (!(16 & y)) {
              if (0 == (64 & y)) {
                m = b[(65535 & m) + (l & (1 << y) - 1)];
                continue t;
              }

              if (32 & y) {
                r.mode = 12;
                break e;
              }

              e.msg = "invalid literal/length code", r.mode = 30;
              break e;
            }

            w = 65535 & m, (y &= 15) && (p < y && (l += A[n++] << p, p += 8), w += l & (1 << y) - 1, l >>>= y, p -= y), p < 15 && (l += A[n++] << p, p += 8, l += A[n++] << p, p += 8), m = _[l & v];

            r: for (;;) {
              if (l >>>= y = m >>> 24, p -= y, !(16 & (y = m >>> 16 & 255))) {
                if (0 == (64 & y)) {
                  m = _[(65535 & m) + (l & (1 << y) - 1)];
                  continue r;
                }

                e.msg = "invalid distance code", r.mode = 30;
                break e;
              }

              if (k = 65535 & m, p < (y &= 15) && (l += A[n++] << p, (p += 8) < y && (l += A[n++] << p, p += 8)), (k += l & (1 << y) - 1) > f) {
                e.msg = "invalid distance too far back", r.mode = 30;
                break e;
              }

              if (l >>>= y, p -= y, k > (y = s - o)) {
                if ((y = k - y) > u && r.sane) {
                  e.msg = "invalid distance too far back", r.mode = 30;
                  break e;
                }

                if (S = 0, E = d, 0 === h) {
                  if (S += c - y, y < w) {
                    w -= y;

                    do {
                      x[s++] = d[S++];
                    } while (--y);

                    S = s - k, E = x;
                  }
                } else if (h < y) {
                  if (S += c + h - y, (y -= h) < w) {
                    w -= y;

                    do {
                      x[s++] = d[S++];
                    } while (--y);

                    if (S = 0, h < w) {
                      w -= y = h;

                      do {
                        x[s++] = d[S++];
                      } while (--y);

                      S = s - k, E = x;
                    }
                  }
                } else if (S += h - y, y < w) {
                  w -= y;

                  do {
                    x[s++] = d[S++];
                  } while (--y);

                  S = s - k, E = x;
                }

                for (; w > 2;) {
                  x[s++] = E[S++], x[s++] = E[S++], x[s++] = E[S++], w -= 3;
                }

                w && (x[s++] = E[S++], w > 1 && (x[s++] = E[S++]));
              } else {
                S = s - k;

                do {
                  x[s++] = x[S++], x[s++] = x[S++], x[s++] = x[S++], w -= 3;
                } while (w > 2);

                w && (x[s++] = x[S++], w > 1 && (x[s++] = x[S++]));
              }

              break;
            }
          }
          break;
        }
      } while (n < i && s < a);

      n -= w = p >> 3, l &= (1 << (p -= w << 3)) - 1, e.next_in = n, e.next_out = s, e.avail_in = n < i ? i - n + 5 : 5 - (n - i), e.avail_out = s < a ? a - s + 257 : 257 - (s - a), r.hold = l, r.bits = p;
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(33),
        i = r(71),
        s = r(70),
        o = r(138),
        a = r(137),
        f = 0,
        c = 1,
        u = 2,
        h = 4,
        d = 5,
        l = 6,
        p = 0,
        b = 1,
        _ = 2,
        g = -2,
        v = -3,
        m = -4,
        y = -5,
        w = 8,
        k = 1,
        S = 2,
        E = 3,
        A = 4,
        x = 5,
        T = 6,
        R = 7,
        M = 8,
        I = 9,
        O = 10,
        C = 11,
        B = 12,
        P = 13,
        N = 14,
        L = 15,
        j = 16,
        U = 17,
        D = 18,
        q = 19,
        z = 20,
        F = 21,
        W = 22,
        Z = 23,
        V = 24,
        H = 25,
        $ = 26,
        K = 27,
        G = 28,
        Y = 29,
        X = 30,
        J = 31,
        Q = 32,
        ee = 852,
        te = 592,
        re = 15;

    function ne(e) {
      return (e >>> 24 & 255) + (e >>> 8 & 65280) + ((65280 & e) << 8) + ((255 & e) << 24);
    }

    function ie(e) {
      var t;
      return e && e.state ? (t = e.state, e.total_in = e.total_out = t.total = 0, e.msg = "", t.wrap && (e.adler = 1 & t.wrap), t.mode = k, t.last = 0, t.havedict = 0, t.dmax = 32768, t.head = null, t.hold = 0, t.bits = 0, t.lencode = t.lendyn = new n.Buf32(ee), t.distcode = t.distdyn = new n.Buf32(te), t.sane = 1, t.back = -1, p) : g;
    }

    function se(e) {
      var t;
      return e && e.state ? ((t = e.state).wsize = 0, t.whave = 0, t.wnext = 0, ie(e)) : g;
    }

    function oe(e, t) {
      var r, n;
      return e && e.state ? (n = e.state, t < 0 ? (r = 0, t = -t) : (r = 1 + (t >> 4), t < 48 && (t &= 15)), t && (t < 8 || t > 15) ? g : (null !== n.window && n.wbits !== t && (n.window = null), n.wrap = r, n.wbits = t, se(e))) : g;
    }

    function ae(e, t) {
      var r, i;
      return e ? (i = new function () {
        this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new n.Buf16(320), this.work = new n.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
      }(), e.state = i, i.window = null, (r = oe(e, t)) !== p && (e.state = null), r) : g;
    }

    var fe,
        ce,
        ue = !0;

    function he(e) {
      if (ue) {
        var t;

        for (fe = new n.Buf32(512), ce = new n.Buf32(32), t = 0; t < 144;) {
          e.lens[t++] = 8;
        }

        for (; t < 256;) {
          e.lens[t++] = 9;
        }

        for (; t < 280;) {
          e.lens[t++] = 7;
        }

        for (; t < 288;) {
          e.lens[t++] = 8;
        }

        for (a(c, e.lens, 0, 288, fe, 0, e.work, {
          bits: 9
        }), t = 0; t < 32;) {
          e.lens[t++] = 5;
        }

        a(u, e.lens, 0, 32, ce, 0, e.work, {
          bits: 5
        }), ue = !1;
      }

      e.lencode = fe, e.lenbits = 9, e.distcode = ce, e.distbits = 5;
    }

    function de(e, t, r, i) {
      var s,
          o = e.state;
      return null === o.window && (o.wsize = 1 << o.wbits, o.wnext = 0, o.whave = 0, o.window = new n.Buf8(o.wsize)), i >= o.wsize ? (n.arraySet(o.window, t, r - o.wsize, o.wsize, 0), o.wnext = 0, o.whave = o.wsize) : ((s = o.wsize - o.wnext) > i && (s = i), n.arraySet(o.window, t, r - i, s, o.wnext), (i -= s) ? (n.arraySet(o.window, t, r - i, i, 0), o.wnext = i, o.whave = o.wsize) : (o.wnext += s, o.wnext === o.wsize && (o.wnext = 0), o.whave < o.wsize && (o.whave += s))), 0;
    }

    t.inflateReset = se, t.inflateReset2 = oe, t.inflateResetKeep = ie, t.inflateInit = function (e) {
      return ae(e, re);
    }, t.inflateInit2 = ae, t.inflate = function (e, t) {
      var r,
          ee,
          te,
          re,
          ie,
          se,
          oe,
          ae,
          fe,
          ce,
          ue,
          le,
          pe,
          be,
          _e,
          ge,
          ve,
          me,
          ye,
          we,
          ke,
          Se,
          Ee,
          Ae,
          xe = 0,
          Te = new n.Buf8(4),
          Re = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];

      if (!e || !e.state || !e.output || !e.input && 0 !== e.avail_in) return g;
      (r = e.state).mode === B && (r.mode = P), ie = e.next_out, te = e.output, oe = e.avail_out, re = e.next_in, ee = e.input, se = e.avail_in, ae = r.hold, fe = r.bits, ce = se, ue = oe, Se = p;

      e: for (;;) {
        switch (r.mode) {
          case k:
            if (0 === r.wrap) {
              r.mode = P;
              break;
            }

            for (; fe < 16;) {
              if (0 === se) break e;
              se--, ae += ee[re++] << fe, fe += 8;
            }

            if (2 & r.wrap && 35615 === ae) {
              r.check = 0, Te[0] = 255 & ae, Te[1] = ae >>> 8 & 255, r.check = s(r.check, Te, 2, 0), ae = 0, fe = 0, r.mode = S;
              break;
            }

            if (r.flags = 0, r.head && (r.head.done = !1), !(1 & r.wrap) || (((255 & ae) << 8) + (ae >> 8)) % 31) {
              e.msg = "incorrect header check", r.mode = X;
              break;
            }

            if ((15 & ae) !== w) {
              e.msg = "unknown compression method", r.mode = X;
              break;
            }

            if (fe -= 4, ke = 8 + (15 & (ae >>>= 4)), 0 === r.wbits) r.wbits = ke;else if (ke > r.wbits) {
              e.msg = "invalid window size", r.mode = X;
              break;
            }
            r.dmax = 1 << ke, e.adler = r.check = 1, r.mode = 512 & ae ? O : B, ae = 0, fe = 0;
            break;

          case S:
            for (; fe < 16;) {
              if (0 === se) break e;
              se--, ae += ee[re++] << fe, fe += 8;
            }

            if (r.flags = ae, (255 & r.flags) !== w) {
              e.msg = "unknown compression method", r.mode = X;
              break;
            }

            if (57344 & r.flags) {
              e.msg = "unknown header flags set", r.mode = X;
              break;
            }

            r.head && (r.head.text = ae >> 8 & 1), 512 & r.flags && (Te[0] = 255 & ae, Te[1] = ae >>> 8 & 255, r.check = s(r.check, Te, 2, 0)), ae = 0, fe = 0, r.mode = E;

          case E:
            for (; fe < 32;) {
              if (0 === se) break e;
              se--, ae += ee[re++] << fe, fe += 8;
            }

            r.head && (r.head.time = ae), 512 & r.flags && (Te[0] = 255 & ae, Te[1] = ae >>> 8 & 255, Te[2] = ae >>> 16 & 255, Te[3] = ae >>> 24 & 255, r.check = s(r.check, Te, 4, 0)), ae = 0, fe = 0, r.mode = A;

          case A:
            for (; fe < 16;) {
              if (0 === se) break e;
              se--, ae += ee[re++] << fe, fe += 8;
            }

            r.head && (r.head.xflags = 255 & ae, r.head.os = ae >> 8), 512 & r.flags && (Te[0] = 255 & ae, Te[1] = ae >>> 8 & 255, r.check = s(r.check, Te, 2, 0)), ae = 0, fe = 0, r.mode = x;

          case x:
            if (1024 & r.flags) {
              for (; fe < 16;) {
                if (0 === se) break e;
                se--, ae += ee[re++] << fe, fe += 8;
              }

              r.length = ae, r.head && (r.head.extra_len = ae), 512 & r.flags && (Te[0] = 255 & ae, Te[1] = ae >>> 8 & 255, r.check = s(r.check, Te, 2, 0)), ae = 0, fe = 0;
            } else r.head && (r.head.extra = null);

            r.mode = T;

          case T:
            if (1024 & r.flags && ((le = r.length) > se && (le = se), le && (r.head && (ke = r.head.extra_len - r.length, r.head.extra || (r.head.extra = new Array(r.head.extra_len)), n.arraySet(r.head.extra, ee, re, le, ke)), 512 & r.flags && (r.check = s(r.check, ee, le, re)), se -= le, re += le, r.length -= le), r.length)) break e;
            r.length = 0, r.mode = R;

          case R:
            if (2048 & r.flags) {
              if (0 === se) break e;
              le = 0;

              do {
                ke = ee[re + le++], r.head && ke && r.length < 65536 && (r.head.name += String.fromCharCode(ke));
              } while (ke && le < se);

              if (512 & r.flags && (r.check = s(r.check, ee, le, re)), se -= le, re += le, ke) break e;
            } else r.head && (r.head.name = null);

            r.length = 0, r.mode = M;

          case M:
            if (4096 & r.flags) {
              if (0 === se) break e;
              le = 0;

              do {
                ke = ee[re + le++], r.head && ke && r.length < 65536 && (r.head.comment += String.fromCharCode(ke));
              } while (ke && le < se);

              if (512 & r.flags && (r.check = s(r.check, ee, le, re)), se -= le, re += le, ke) break e;
            } else r.head && (r.head.comment = null);

            r.mode = I;

          case I:
            if (512 & r.flags) {
              for (; fe < 16;) {
                if (0 === se) break e;
                se--, ae += ee[re++] << fe, fe += 8;
              }

              if (ae !== (65535 & r.check)) {
                e.msg = "header crc mismatch", r.mode = X;
                break;
              }

              ae = 0, fe = 0;
            }

            r.head && (r.head.hcrc = r.flags >> 9 & 1, r.head.done = !0), e.adler = r.check = 0, r.mode = B;
            break;

          case O:
            for (; fe < 32;) {
              if (0 === se) break e;
              se--, ae += ee[re++] << fe, fe += 8;
            }

            e.adler = r.check = ne(ae), ae = 0, fe = 0, r.mode = C;

          case C:
            if (0 === r.havedict) return e.next_out = ie, e.avail_out = oe, e.next_in = re, e.avail_in = se, r.hold = ae, r.bits = fe, _;
            e.adler = r.check = 1, r.mode = B;

          case B:
            if (t === d || t === l) break e;

          case P:
            if (r.last) {
              ae >>>= 7 & fe, fe -= 7 & fe, r.mode = K;
              break;
            }

            for (; fe < 3;) {
              if (0 === se) break e;
              se--, ae += ee[re++] << fe, fe += 8;
            }

            switch (r.last = 1 & ae, fe -= 1, 3 & (ae >>>= 1)) {
              case 0:
                r.mode = N;
                break;

              case 1:
                if (he(r), r.mode = z, t === l) {
                  ae >>>= 2, fe -= 2;
                  break e;
                }

                break;

              case 2:
                r.mode = U;
                break;

              case 3:
                e.msg = "invalid block type", r.mode = X;
            }

            ae >>>= 2, fe -= 2;
            break;

          case N:
            for (ae >>>= 7 & fe, fe -= 7 & fe; fe < 32;) {
              if (0 === se) break e;
              se--, ae += ee[re++] << fe, fe += 8;
            }

            if ((65535 & ae) != (ae >>> 16 ^ 65535)) {
              e.msg = "invalid stored block lengths", r.mode = X;
              break;
            }

            if (r.length = 65535 & ae, ae = 0, fe = 0, r.mode = L, t === l) break e;

          case L:
            r.mode = j;

          case j:
            if (le = r.length) {
              if (le > se && (le = se), le > oe && (le = oe), 0 === le) break e;
              n.arraySet(te, ee, re, le, ie), se -= le, re += le, oe -= le, ie += le, r.length -= le;
              break;
            }

            r.mode = B;
            break;

          case U:
            for (; fe < 14;) {
              if (0 === se) break e;
              se--, ae += ee[re++] << fe, fe += 8;
            }

            if (r.nlen = 257 + (31 & ae), ae >>>= 5, fe -= 5, r.ndist = 1 + (31 & ae), ae >>>= 5, fe -= 5, r.ncode = 4 + (15 & ae), ae >>>= 4, fe -= 4, r.nlen > 286 || r.ndist > 30) {
              e.msg = "too many length or distance symbols", r.mode = X;
              break;
            }

            r.have = 0, r.mode = D;

          case D:
            for (; r.have < r.ncode;) {
              for (; fe < 3;) {
                if (0 === se) break e;
                se--, ae += ee[re++] << fe, fe += 8;
              }

              r.lens[Re[r.have++]] = 7 & ae, ae >>>= 3, fe -= 3;
            }

            for (; r.have < 19;) {
              r.lens[Re[r.have++]] = 0;
            }

            if (r.lencode = r.lendyn, r.lenbits = 7, Ee = {
              bits: r.lenbits
            }, Se = a(f, r.lens, 0, 19, r.lencode, 0, r.work, Ee), r.lenbits = Ee.bits, Se) {
              e.msg = "invalid code lengths set", r.mode = X;
              break;
            }

            r.have = 0, r.mode = q;

          case q:
            for (; r.have < r.nlen + r.ndist;) {
              for (; ge = (xe = r.lencode[ae & (1 << r.lenbits) - 1]) >>> 16 & 255, ve = 65535 & xe, !((_e = xe >>> 24) <= fe);) {
                if (0 === se) break e;
                se--, ae += ee[re++] << fe, fe += 8;
              }

              if (ve < 16) ae >>>= _e, fe -= _e, r.lens[r.have++] = ve;else {
                if (16 === ve) {
                  for (Ae = _e + 2; fe < Ae;) {
                    if (0 === se) break e;
                    se--, ae += ee[re++] << fe, fe += 8;
                  }

                  if (ae >>>= _e, fe -= _e, 0 === r.have) {
                    e.msg = "invalid bit length repeat", r.mode = X;
                    break;
                  }

                  ke = r.lens[r.have - 1], le = 3 + (3 & ae), ae >>>= 2, fe -= 2;
                } else if (17 === ve) {
                  for (Ae = _e + 3; fe < Ae;) {
                    if (0 === se) break e;
                    se--, ae += ee[re++] << fe, fe += 8;
                  }

                  fe -= _e, ke = 0, le = 3 + (7 & (ae >>>= _e)), ae >>>= 3, fe -= 3;
                } else {
                  for (Ae = _e + 7; fe < Ae;) {
                    if (0 === se) break e;
                    se--, ae += ee[re++] << fe, fe += 8;
                  }

                  fe -= _e, ke = 0, le = 11 + (127 & (ae >>>= _e)), ae >>>= 7, fe -= 7;
                }

                if (r.have + le > r.nlen + r.ndist) {
                  e.msg = "invalid bit length repeat", r.mode = X;
                  break;
                }

                for (; le--;) {
                  r.lens[r.have++] = ke;
                }
              }
            }

            if (r.mode === X) break;

            if (0 === r.lens[256]) {
              e.msg = "invalid code -- missing end-of-block", r.mode = X;
              break;
            }

            if (r.lenbits = 9, Ee = {
              bits: r.lenbits
            }, Se = a(c, r.lens, 0, r.nlen, r.lencode, 0, r.work, Ee), r.lenbits = Ee.bits, Se) {
              e.msg = "invalid literal/lengths set", r.mode = X;
              break;
            }

            if (r.distbits = 6, r.distcode = r.distdyn, Ee = {
              bits: r.distbits
            }, Se = a(u, r.lens, r.nlen, r.ndist, r.distcode, 0, r.work, Ee), r.distbits = Ee.bits, Se) {
              e.msg = "invalid distances set", r.mode = X;
              break;
            }

            if (r.mode = z, t === l) break e;

          case z:
            r.mode = F;

          case F:
            if (se >= 6 && oe >= 258) {
              e.next_out = ie, e.avail_out = oe, e.next_in = re, e.avail_in = se, r.hold = ae, r.bits = fe, o(e, ue), ie = e.next_out, te = e.output, oe = e.avail_out, re = e.next_in, ee = e.input, se = e.avail_in, ae = r.hold, fe = r.bits, r.mode === B && (r.back = -1);
              break;
            }

            for (r.back = 0; ge = (xe = r.lencode[ae & (1 << r.lenbits) - 1]) >>> 16 & 255, ve = 65535 & xe, !((_e = xe >>> 24) <= fe);) {
              if (0 === se) break e;
              se--, ae += ee[re++] << fe, fe += 8;
            }

            if (ge && 0 == (240 & ge)) {
              for (me = _e, ye = ge, we = ve; ge = (xe = r.lencode[we + ((ae & (1 << me + ye) - 1) >> me)]) >>> 16 & 255, ve = 65535 & xe, !(me + (_e = xe >>> 24) <= fe);) {
                if (0 === se) break e;
                se--, ae += ee[re++] << fe, fe += 8;
              }

              ae >>>= me, fe -= me, r.back += me;
            }

            if (ae >>>= _e, fe -= _e, r.back += _e, r.length = ve, 0 === ge) {
              r.mode = $;
              break;
            }

            if (32 & ge) {
              r.back = -1, r.mode = B;
              break;
            }

            if (64 & ge) {
              e.msg = "invalid literal/length code", r.mode = X;
              break;
            }

            r.extra = 15 & ge, r.mode = W;

          case W:
            if (r.extra) {
              for (Ae = r.extra; fe < Ae;) {
                if (0 === se) break e;
                se--, ae += ee[re++] << fe, fe += 8;
              }

              r.length += ae & (1 << r.extra) - 1, ae >>>= r.extra, fe -= r.extra, r.back += r.extra;
            }

            r.was = r.length, r.mode = Z;

          case Z:
            for (; ge = (xe = r.distcode[ae & (1 << r.distbits) - 1]) >>> 16 & 255, ve = 65535 & xe, !((_e = xe >>> 24) <= fe);) {
              if (0 === se) break e;
              se--, ae += ee[re++] << fe, fe += 8;
            }

            if (0 == (240 & ge)) {
              for (me = _e, ye = ge, we = ve; ge = (xe = r.distcode[we + ((ae & (1 << me + ye) - 1) >> me)]) >>> 16 & 255, ve = 65535 & xe, !(me + (_e = xe >>> 24) <= fe);) {
                if (0 === se) break e;
                se--, ae += ee[re++] << fe, fe += 8;
              }

              ae >>>= me, fe -= me, r.back += me;
            }

            if (ae >>>= _e, fe -= _e, r.back += _e, 64 & ge) {
              e.msg = "invalid distance code", r.mode = X;
              break;
            }

            r.offset = ve, r.extra = 15 & ge, r.mode = V;

          case V:
            if (r.extra) {
              for (Ae = r.extra; fe < Ae;) {
                if (0 === se) break e;
                se--, ae += ee[re++] << fe, fe += 8;
              }

              r.offset += ae & (1 << r.extra) - 1, ae >>>= r.extra, fe -= r.extra, r.back += r.extra;
            }

            if (r.offset > r.dmax) {
              e.msg = "invalid distance too far back", r.mode = X;
              break;
            }

            r.mode = H;

          case H:
            if (0 === oe) break e;

            if (le = ue - oe, r.offset > le) {
              if ((le = r.offset - le) > r.whave && r.sane) {
                e.msg = "invalid distance too far back", r.mode = X;
                break;
              }

              le > r.wnext ? (le -= r.wnext, pe = r.wsize - le) : pe = r.wnext - le, le > r.length && (le = r.length), be = r.window;
            } else be = te, pe = ie - r.offset, le = r.length;

            le > oe && (le = oe), oe -= le, r.length -= le;

            do {
              te[ie++] = be[pe++];
            } while (--le);

            0 === r.length && (r.mode = F);
            break;

          case $:
            if (0 === oe) break e;
            te[ie++] = r.length, oe--, r.mode = F;
            break;

          case K:
            if (r.wrap) {
              for (; fe < 32;) {
                if (0 === se) break e;
                se--, ae |= ee[re++] << fe, fe += 8;
              }

              if (ue -= oe, e.total_out += ue, r.total += ue, ue && (e.adler = r.check = r.flags ? s(r.check, te, ue, ie - ue) : i(r.check, te, ue, ie - ue)), ue = oe, (r.flags ? ae : ne(ae)) !== r.check) {
                e.msg = "incorrect data check", r.mode = X;
                break;
              }

              ae = 0, fe = 0;
            }

            r.mode = G;

          case G:
            if (r.wrap && r.flags) {
              for (; fe < 32;) {
                if (0 === se) break e;
                se--, ae += ee[re++] << fe, fe += 8;
              }

              if (ae !== (4294967295 & r.total)) {
                e.msg = "incorrect length check", r.mode = X;
                break;
              }

              ae = 0, fe = 0;
            }

            r.mode = Y;

          case Y:
            Se = b;
            break e;

          case X:
            Se = v;
            break e;

          case J:
            return m;

          case Q:
          default:
            return g;
        }
      }

      return e.next_out = ie, e.avail_out = oe, e.next_in = re, e.avail_in = se, r.hold = ae, r.bits = fe, (r.wsize || ue !== e.avail_out && r.mode < X && (r.mode < K || t !== h)) && de(e, e.output, e.next_out, ue - e.avail_out) ? (r.mode = J, m) : (ce -= e.avail_in, ue -= e.avail_out, e.total_in += ce, e.total_out += ue, r.total += ue, r.wrap && ue && (e.adler = r.check = r.flags ? s(r.check, te, ue, e.next_out - ue) : i(r.check, te, ue, e.next_out - ue)), e.data_type = r.bits + (r.last ? 64 : 0) + (r.mode === B ? 128 : 0) + (r.mode === z || r.mode === L ? 256 : 0), (0 === ce && 0 === ue || t === h) && Se === p && (Se = y), Se);
    }, t.inflateEnd = function (e) {
      if (!e || !e.state) return g;
      var t = e.state;
      return t.window && (t.window = null), e.state = null, p;
    }, t.inflateGetHeader = function (e, t) {
      var r;
      return e && e.state ? 0 == (2 & (r = e.state).wrap) ? g : (r.head = t, t.done = !1, p) : g;
    }, t.inflateSetDictionary = function (e, t) {
      var r,
          n = t.length;
      return e && e.state ? 0 !== (r = e.state).wrap && r.mode !== C ? g : r.mode === C && i(1, t, n, 0) !== r.check ? v : de(e, t, n, n) ? (r.mode = J, m) : (r.havedict = 1, p) : g;
    }, t.inflateInfo = "pako inflate (from Nodeca project)";
  }, function (e, t, r) {
    "use strict";

    e.exports = {
      2: "need dictionary",
      1: "stream end",
      0: "",
      "-1": "file error",
      "-2": "stream error",
      "-3": "data error",
      "-4": "insufficient memory",
      "-5": "buffer error",
      "-6": "incompatible version"
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(33),
        i = 4,
        s = 0,
        o = 1,
        a = 2;

    function f(e) {
      for (var t = e.length; --t >= 0;) {
        e[t] = 0;
      }
    }

    var c = 0,
        u = 1,
        h = 2,
        d = 29,
        l = 256,
        p = l + 1 + d,
        b = 30,
        _ = 19,
        g = 2 * p + 1,
        v = 15,
        m = 16,
        y = 7,
        w = 256,
        k = 16,
        S = 17,
        E = 18,
        A = [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0],
        x = [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13],
        T = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7],
        R = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15],
        M = new Array(2 * (p + 2));
    f(M);
    var I = new Array(2 * b);
    f(I);
    var O = new Array(512);
    f(O);
    var C = new Array(256);
    f(C);
    var B = new Array(d);
    f(B);
    var P,
        N,
        L,
        j = new Array(b);

    function U(e, t, r, n, i) {
      this.static_tree = e, this.extra_bits = t, this.extra_base = r, this.elems = n, this.max_length = i, this.has_stree = e && e.length;
    }

    function D(e, t) {
      this.dyn_tree = e, this.max_code = 0, this.stat_desc = t;
    }

    function q(e) {
      return e < 256 ? O[e] : O[256 + (e >>> 7)];
    }

    function z(e, t) {
      e.pending_buf[e.pending++] = 255 & t, e.pending_buf[e.pending++] = t >>> 8 & 255;
    }

    function F(e, t, r) {
      e.bi_valid > m - r ? (e.bi_buf |= t << e.bi_valid & 65535, z(e, e.bi_buf), e.bi_buf = t >> m - e.bi_valid, e.bi_valid += r - m) : (e.bi_buf |= t << e.bi_valid & 65535, e.bi_valid += r);
    }

    function W(e, t, r) {
      F(e, r[2 * t], r[2 * t + 1]);
    }

    function Z(e, t) {
      var r = 0;

      do {
        r |= 1 & e, e >>>= 1, r <<= 1;
      } while (--t > 0);

      return r >>> 1;
    }

    function V(e, t, r) {
      var n,
          i,
          s = new Array(v + 1),
          o = 0;

      for (n = 1; n <= v; n++) {
        s[n] = o = o + r[n - 1] << 1;
      }

      for (i = 0; i <= t; i++) {
        var a = e[2 * i + 1];
        0 !== a && (e[2 * i] = Z(s[a]++, a));
      }
    }

    function H(e) {
      var t;

      for (t = 0; t < p; t++) {
        e.dyn_ltree[2 * t] = 0;
      }

      for (t = 0; t < b; t++) {
        e.dyn_dtree[2 * t] = 0;
      }

      for (t = 0; t < _; t++) {
        e.bl_tree[2 * t] = 0;
      }

      e.dyn_ltree[2 * w] = 1, e.opt_len = e.static_len = 0, e.last_lit = e.matches = 0;
    }

    function $(e) {
      e.bi_valid > 8 ? z(e, e.bi_buf) : e.bi_valid > 0 && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
    }

    function K(e, t, r, n) {
      var i = 2 * t,
          s = 2 * r;
      return e[i] < e[s] || e[i] === e[s] && n[t] <= n[r];
    }

    function G(e, t, r) {
      for (var n = e.heap[r], i = r << 1; i <= e.heap_len && (i < e.heap_len && K(t, e.heap[i + 1], e.heap[i], e.depth) && i++, !K(t, n, e.heap[i], e.depth));) {
        e.heap[r] = e.heap[i], r = i, i <<= 1;
      }

      e.heap[r] = n;
    }

    function Y(e, t, r) {
      var n,
          i,
          s,
          o,
          a = 0;
      if (0 !== e.last_lit) do {
        n = e.pending_buf[e.d_buf + 2 * a] << 8 | e.pending_buf[e.d_buf + 2 * a + 1], i = e.pending_buf[e.l_buf + a], a++, 0 === n ? W(e, i, t) : (W(e, (s = C[i]) + l + 1, t), 0 !== (o = A[s]) && F(e, i -= B[s], o), W(e, s = q(--n), r), 0 !== (o = x[s]) && F(e, n -= j[s], o));
      } while (a < e.last_lit);
      W(e, w, t);
    }

    function X(e, t) {
      var r,
          n,
          i,
          s = t.dyn_tree,
          o = t.stat_desc.static_tree,
          a = t.stat_desc.has_stree,
          f = t.stat_desc.elems,
          c = -1;

      for (e.heap_len = 0, e.heap_max = g, r = 0; r < f; r++) {
        0 !== s[2 * r] ? (e.heap[++e.heap_len] = c = r, e.depth[r] = 0) : s[2 * r + 1] = 0;
      }

      for (; e.heap_len < 2;) {
        s[2 * (i = e.heap[++e.heap_len] = c < 2 ? ++c : 0)] = 1, e.depth[i] = 0, e.opt_len--, a && (e.static_len -= o[2 * i + 1]);
      }

      for (t.max_code = c, r = e.heap_len >> 1; r >= 1; r--) {
        G(e, s, r);
      }

      i = f;

      do {
        r = e.heap[1], e.heap[1] = e.heap[e.heap_len--], G(e, s, 1), n = e.heap[1], e.heap[--e.heap_max] = r, e.heap[--e.heap_max] = n, s[2 * i] = s[2 * r] + s[2 * n], e.depth[i] = (e.depth[r] >= e.depth[n] ? e.depth[r] : e.depth[n]) + 1, s[2 * r + 1] = s[2 * n + 1] = i, e.heap[1] = i++, G(e, s, 1);
      } while (e.heap_len >= 2);

      e.heap[--e.heap_max] = e.heap[1], function (e, t) {
        var r,
            n,
            i,
            s,
            o,
            a,
            f = t.dyn_tree,
            c = t.max_code,
            u = t.stat_desc.static_tree,
            h = t.stat_desc.has_stree,
            d = t.stat_desc.extra_bits,
            l = t.stat_desc.extra_base,
            p = t.stat_desc.max_length,
            b = 0;

        for (s = 0; s <= v; s++) {
          e.bl_count[s] = 0;
        }

        for (f[2 * e.heap[e.heap_max] + 1] = 0, r = e.heap_max + 1; r < g; r++) {
          (s = f[2 * f[2 * (n = e.heap[r]) + 1] + 1] + 1) > p && (s = p, b++), f[2 * n + 1] = s, n > c || (e.bl_count[s]++, o = 0, n >= l && (o = d[n - l]), a = f[2 * n], e.opt_len += a * (s + o), h && (e.static_len += a * (u[2 * n + 1] + o)));
        }

        if (0 !== b) {
          do {
            for (s = p - 1; 0 === e.bl_count[s];) {
              s--;
            }

            e.bl_count[s]--, e.bl_count[s + 1] += 2, e.bl_count[p]--, b -= 2;
          } while (b > 0);

          for (s = p; 0 !== s; s--) {
            for (n = e.bl_count[s]; 0 !== n;) {
              (i = e.heap[--r]) > c || (f[2 * i + 1] !== s && (e.opt_len += (s - f[2 * i + 1]) * f[2 * i], f[2 * i + 1] = s), n--);
            }
          }
        }
      }(e, t), V(s, c, e.bl_count);
    }

    function J(e, t, r) {
      var n,
          i,
          s = -1,
          o = t[1],
          a = 0,
          f = 7,
          c = 4;

      for (0 === o && (f = 138, c = 3), t[2 * (r + 1) + 1] = 65535, n = 0; n <= r; n++) {
        i = o, o = t[2 * (n + 1) + 1], ++a < f && i === o || (a < c ? e.bl_tree[2 * i] += a : 0 !== i ? (i !== s && e.bl_tree[2 * i]++, e.bl_tree[2 * k]++) : a <= 10 ? e.bl_tree[2 * S]++ : e.bl_tree[2 * E]++, a = 0, s = i, 0 === o ? (f = 138, c = 3) : i === o ? (f = 6, c = 3) : (f = 7, c = 4));
      }
    }

    function Q(e, t, r) {
      var n,
          i,
          s = -1,
          o = t[1],
          a = 0,
          f = 7,
          c = 4;

      for (0 === o && (f = 138, c = 3), n = 0; n <= r; n++) {
        if (i = o, o = t[2 * (n + 1) + 1], !(++a < f && i === o)) {
          if (a < c) do {
            W(e, i, e.bl_tree);
          } while (0 != --a);else 0 !== i ? (i !== s && (W(e, i, e.bl_tree), a--), W(e, k, e.bl_tree), F(e, a - 3, 2)) : a <= 10 ? (W(e, S, e.bl_tree), F(e, a - 3, 3)) : (W(e, E, e.bl_tree), F(e, a - 11, 7));
          a = 0, s = i, 0 === o ? (f = 138, c = 3) : i === o ? (f = 6, c = 3) : (f = 7, c = 4);
        }
      }
    }

    f(j);
    var ee = !1;

    function te(e, t, r, i) {
      F(e, (c << 1) + (i ? 1 : 0), 3), function (e, t, r, i) {
        $(e), i && (z(e, r), z(e, ~r)), n.arraySet(e.pending_buf, e.window, t, r, e.pending), e.pending += r;
      }(e, t, r, !0);
    }

    t._tr_init = function (e) {
      ee || (function () {
        var e,
            t,
            r,
            n,
            i,
            s = new Array(v + 1);

        for (r = 0, n = 0; n < d - 1; n++) {
          for (B[n] = r, e = 0; e < 1 << A[n]; e++) {
            C[r++] = n;
          }
        }

        for (C[r - 1] = n, i = 0, n = 0; n < 16; n++) {
          for (j[n] = i, e = 0; e < 1 << x[n]; e++) {
            O[i++] = n;
          }
        }

        for (i >>= 7; n < b; n++) {
          for (j[n] = i << 7, e = 0; e < 1 << x[n] - 7; e++) {
            O[256 + i++] = n;
          }
        }

        for (t = 0; t <= v; t++) {
          s[t] = 0;
        }

        for (e = 0; e <= 143;) {
          M[2 * e + 1] = 8, e++, s[8]++;
        }

        for (; e <= 255;) {
          M[2 * e + 1] = 9, e++, s[9]++;
        }

        for (; e <= 279;) {
          M[2 * e + 1] = 7, e++, s[7]++;
        }

        for (; e <= 287;) {
          M[2 * e + 1] = 8, e++, s[8]++;
        }

        for (V(M, p + 1, s), e = 0; e < b; e++) {
          I[2 * e + 1] = 5, I[2 * e] = Z(e, 5);
        }

        P = new U(M, A, l + 1, p, v), N = new U(I, x, 0, b, v), L = new U(new Array(0), T, 0, _, y);
      }(), ee = !0), e.l_desc = new D(e.dyn_ltree, P), e.d_desc = new D(e.dyn_dtree, N), e.bl_desc = new D(e.bl_tree, L), e.bi_buf = 0, e.bi_valid = 0, H(e);
    }, t._tr_stored_block = te, t._tr_flush_block = function (e, t, r, n) {
      var f,
          c,
          d = 0;
      e.level > 0 ? (e.strm.data_type === a && (e.strm.data_type = function (e) {
        var t,
            r = 4093624447;

        for (t = 0; t <= 31; t++, r >>>= 1) {
          if (1 & r && 0 !== e.dyn_ltree[2 * t]) return s;
        }

        if (0 !== e.dyn_ltree[18] || 0 !== e.dyn_ltree[20] || 0 !== e.dyn_ltree[26]) return o;

        for (t = 32; t < l; t++) {
          if (0 !== e.dyn_ltree[2 * t]) return o;
        }

        return s;
      }(e)), X(e, e.l_desc), X(e, e.d_desc), d = function (e) {
        var t;

        for (J(e, e.dyn_ltree, e.l_desc.max_code), J(e, e.dyn_dtree, e.d_desc.max_code), X(e, e.bl_desc), t = _ - 1; t >= 3 && 0 === e.bl_tree[2 * R[t] + 1]; t--) {
          ;
        }

        return e.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
      }(e), f = e.opt_len + 3 + 7 >>> 3, (c = e.static_len + 3 + 7 >>> 3) <= f && (f = c)) : f = c = r + 5, r + 4 <= f && -1 !== t ? te(e, t, r, n) : e.strategy === i || c === f ? (F(e, (u << 1) + (n ? 1 : 0), 3), Y(e, M, I)) : (F(e, (h << 1) + (n ? 1 : 0), 3), function (e, t, r, n) {
        var i;

        for (F(e, t - 257, 5), F(e, r - 1, 5), F(e, n - 4, 4), i = 0; i < n; i++) {
          F(e, e.bl_tree[2 * R[i] + 1], 3);
        }

        Q(e, e.dyn_ltree, t - 1), Q(e, e.dyn_dtree, r - 1);
      }(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, d + 1), Y(e, e.dyn_ltree, e.dyn_dtree)), H(e), n && $(e);
    }, t._tr_tally = function (e, t, r) {
      return e.pending_buf[e.d_buf + 2 * e.last_lit] = t >>> 8 & 255, e.pending_buf[e.d_buf + 2 * e.last_lit + 1] = 255 & t, e.pending_buf[e.l_buf + e.last_lit] = 255 & r, e.last_lit++, 0 === t ? e.dyn_ltree[2 * r]++ : (e.matches++, t--, e.dyn_ltree[2 * (C[r] + l + 1)]++, e.dyn_dtree[2 * q(t)]++), e.last_lit === e.lit_bufsize - 1;
    }, t._tr_align = function (e) {
      F(e, u << 1, 3), W(e, w, M), function (e) {
        16 === e.bi_valid ? (z(e, e.bi_buf), e.bi_buf = 0, e.bi_valid = 0) : e.bi_valid >= 8 && (e.pending_buf[e.pending++] = 255 & e.bi_buf, e.bi_buf >>= 8, e.bi_valid -= 8);
      }(e);
    };
  }, function (e, t, r) {
    "use strict";

    var n,
        i = r(33),
        s = r(141),
        o = r(71),
        a = r(70),
        f = r(140),
        c = 0,
        u = 1,
        h = 3,
        d = 4,
        l = 5,
        p = 0,
        b = 1,
        _ = -2,
        g = -3,
        v = -5,
        m = -1,
        y = 1,
        w = 2,
        k = 3,
        S = 4,
        E = 0,
        A = 2,
        x = 8,
        T = 9,
        R = 15,
        M = 8,
        I = 286,
        O = 30,
        C = 19,
        B = 2 * I + 1,
        P = 15,
        N = 3,
        L = 258,
        j = L + N + 1,
        U = 32,
        D = 42,
        q = 69,
        z = 73,
        F = 91,
        W = 103,
        Z = 113,
        V = 666,
        H = 1,
        $ = 2,
        K = 3,
        G = 4,
        Y = 3;

    function X(e, t) {
      return e.msg = f[t], t;
    }

    function J(e) {
      return (e << 1) - (e > 4 ? 9 : 0);
    }

    function Q(e) {
      for (var t = e.length; --t >= 0;) {
        e[t] = 0;
      }
    }

    function ee(e) {
      var t = e.state,
          r = t.pending;
      r > e.avail_out && (r = e.avail_out), 0 !== r && (i.arraySet(e.output, t.pending_buf, t.pending_out, r, e.next_out), e.next_out += r, t.pending_out += r, e.total_out += r, e.avail_out -= r, t.pending -= r, 0 === t.pending && (t.pending_out = 0));
    }

    function te(e, t) {
      s._tr_flush_block(e, e.block_start >= 0 ? e.block_start : -1, e.strstart - e.block_start, t), e.block_start = e.strstart, ee(e.strm);
    }

    function re(e, t) {
      e.pending_buf[e.pending++] = t;
    }

    function ne(e, t) {
      e.pending_buf[e.pending++] = t >>> 8 & 255, e.pending_buf[e.pending++] = 255 & t;
    }

    function ie(e, t) {
      var r,
          n,
          i = e.max_chain_length,
          s = e.strstart,
          o = e.prev_length,
          a = e.nice_match,
          f = e.strstart > e.w_size - j ? e.strstart - (e.w_size - j) : 0,
          c = e.window,
          u = e.w_mask,
          h = e.prev,
          d = e.strstart + L,
          l = c[s + o - 1],
          p = c[s + o];
      e.prev_length >= e.good_match && (i >>= 2), a > e.lookahead && (a = e.lookahead);

      do {
        if (c[(r = t) + o] === p && c[r + o - 1] === l && c[r] === c[s] && c[++r] === c[s + 1]) {
          s += 2, r++;

          do {} while (c[++s] === c[++r] && c[++s] === c[++r] && c[++s] === c[++r] && c[++s] === c[++r] && c[++s] === c[++r] && c[++s] === c[++r] && c[++s] === c[++r] && c[++s] === c[++r] && s < d);

          if (n = L - (d - s), s = d - L, n > o) {
            if (e.match_start = t, o = n, n >= a) break;
            l = c[s + o - 1], p = c[s + o];
          }
        }
      } while ((t = h[t & u]) > f && 0 != --i);

      return o <= e.lookahead ? o : e.lookahead;
    }

    function se(e) {
      var t,
          r,
          n,
          s,
          f,
          c,
          u,
          h,
          d,
          l,
          p = e.w_size;

      do {
        if (s = e.window_size - e.lookahead - e.strstart, e.strstart >= p + (p - j)) {
          i.arraySet(e.window, e.window, p, p, 0), e.match_start -= p, e.strstart -= p, e.block_start -= p, t = r = e.hash_size;

          do {
            n = e.head[--t], e.head[t] = n >= p ? n - p : 0;
          } while (--r);

          t = r = p;

          do {
            n = e.prev[--t], e.prev[t] = n >= p ? n - p : 0;
          } while (--r);

          s += p;
        }

        if (0 === e.strm.avail_in) break;
        if (c = e.strm, u = e.window, h = e.strstart + e.lookahead, d = s, l = void 0, (l = c.avail_in) > d && (l = d), r = 0 === l ? 0 : (c.avail_in -= l, i.arraySet(u, c.input, c.next_in, l, h), 1 === c.state.wrap ? c.adler = o(c.adler, u, l, h) : 2 === c.state.wrap && (c.adler = a(c.adler, u, l, h)), c.next_in += l, c.total_in += l, l), e.lookahead += r, e.lookahead + e.insert >= N) for (f = e.strstart - e.insert, e.ins_h = e.window[f], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[f + 1]) & e.hash_mask; e.insert && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[f + N - 1]) & e.hash_mask, e.prev[f & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = f, f++, e.insert--, !(e.lookahead + e.insert < N));) {
          ;
        }
      } while (e.lookahead < j && 0 !== e.strm.avail_in);
    }

    function oe(e, t) {
      for (var r, n;;) {
        if (e.lookahead < j) {
          if (se(e), e.lookahead < j && t === c) return H;
          if (0 === e.lookahead) break;
        }

        if (r = 0, e.lookahead >= N && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + N - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 !== r && e.strstart - r <= e.w_size - j && (e.match_length = ie(e, r)), e.match_length >= N) {
          if (n = s._tr_tally(e, e.strstart - e.match_start, e.match_length - N), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= N) {
            e.match_length--;

            do {
              e.strstart++, e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + N - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart;
            } while (0 != --e.match_length);

            e.strstart++;
          } else e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 1]) & e.hash_mask;
        } else n = s._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
        if (n && (te(e, !1), 0 === e.strm.avail_out)) return H;
      }

      return e.insert = e.strstart < N - 1 ? e.strstart : N - 1, t === d ? (te(e, !0), 0 === e.strm.avail_out ? K : G) : e.last_lit && (te(e, !1), 0 === e.strm.avail_out) ? H : $;
    }

    function ae(e, t) {
      for (var r, n, i;;) {
        if (e.lookahead < j) {
          if (se(e), e.lookahead < j && t === c) return H;
          if (0 === e.lookahead) break;
        }

        if (r = 0, e.lookahead >= N && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + N - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = N - 1, 0 !== r && e.prev_length < e.max_lazy_match && e.strstart - r <= e.w_size - j && (e.match_length = ie(e, r), e.match_length <= 5 && (e.strategy === y || e.match_length === N && e.strstart - e.match_start > 4096) && (e.match_length = N - 1)), e.prev_length >= N && e.match_length <= e.prev_length) {
          i = e.strstart + e.lookahead - N, n = s._tr_tally(e, e.strstart - 1 - e.prev_match, e.prev_length - N), e.lookahead -= e.prev_length - 1, e.prev_length -= 2;

          do {
            ++e.strstart <= i && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + N - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart);
          } while (0 != --e.prev_length);

          if (e.match_available = 0, e.match_length = N - 1, e.strstart++, n && (te(e, !1), 0 === e.strm.avail_out)) return H;
        } else if (e.match_available) {
          if ((n = s._tr_tally(e, 0, e.window[e.strstart - 1])) && te(e, !1), e.strstart++, e.lookahead--, 0 === e.strm.avail_out) return H;
        } else e.match_available = 1, e.strstart++, e.lookahead--;
      }

      return e.match_available && (n = s._tr_tally(e, 0, e.window[e.strstart - 1]), e.match_available = 0), e.insert = e.strstart < N - 1 ? e.strstart : N - 1, t === d ? (te(e, !0), 0 === e.strm.avail_out ? K : G) : e.last_lit && (te(e, !1), 0 === e.strm.avail_out) ? H : $;
    }

    function fe(e, t, r, n, i) {
      this.good_length = e, this.max_lazy = t, this.nice_length = r, this.max_chain = n, this.func = i;
    }

    function ce(e) {
      var t;
      return e && e.state ? (e.total_in = e.total_out = 0, e.data_type = A, (t = e.state).pending = 0, t.pending_out = 0, t.wrap < 0 && (t.wrap = -t.wrap), t.status = t.wrap ? D : Z, e.adler = 2 === t.wrap ? 0 : 1, t.last_flush = c, s._tr_init(t), p) : X(e, _);
    }

    function ue(e) {
      var t,
          r = ce(e);
      return r === p && ((t = e.state).window_size = 2 * t.w_size, Q(t.head), t.max_lazy_match = n[t.level].max_lazy, t.good_match = n[t.level].good_length, t.nice_match = n[t.level].nice_length, t.max_chain_length = n[t.level].max_chain, t.strstart = 0, t.block_start = 0, t.lookahead = 0, t.insert = 0, t.match_length = t.prev_length = N - 1, t.match_available = 0, t.ins_h = 0), r;
    }

    function he(e, t, r, n, s, o) {
      if (!e) return _;
      var a = 1;
      if (t === m && (t = 6), n < 0 ? (a = 0, n = -n) : n > 15 && (a = 2, n -= 16), s < 1 || s > T || r !== x || n < 8 || n > 15 || t < 0 || t > 9 || o < 0 || o > S) return X(e, _);
      8 === n && (n = 9);
      var f = new function () {
        this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = x, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new i.Buf16(2 * B), this.dyn_dtree = new i.Buf16(2 * (2 * O + 1)), this.bl_tree = new i.Buf16(2 * (2 * C + 1)), Q(this.dyn_ltree), Q(this.dyn_dtree), Q(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new i.Buf16(P + 1), this.heap = new i.Buf16(2 * I + 1), Q(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new i.Buf16(2 * I + 1), Q(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
      }();
      return e.state = f, f.strm = e, f.wrap = a, f.gzhead = null, f.w_bits = n, f.w_size = 1 << f.w_bits, f.w_mask = f.w_size - 1, f.hash_bits = s + 7, f.hash_size = 1 << f.hash_bits, f.hash_mask = f.hash_size - 1, f.hash_shift = ~~((f.hash_bits + N - 1) / N), f.window = new i.Buf8(2 * f.w_size), f.head = new i.Buf16(f.hash_size), f.prev = new i.Buf16(f.w_size), f.lit_bufsize = 1 << s + 6, f.pending_buf_size = 4 * f.lit_bufsize, f.pending_buf = new i.Buf8(f.pending_buf_size), f.d_buf = 1 * f.lit_bufsize, f.l_buf = 3 * f.lit_bufsize, f.level = t, f.strategy = o, f.method = r, ue(e);
    }

    n = [new fe(0, 0, 0, 0, function (e, t) {
      var r = 65535;

      for (r > e.pending_buf_size - 5 && (r = e.pending_buf_size - 5);;) {
        if (e.lookahead <= 1) {
          if (se(e), 0 === e.lookahead && t === c) return H;
          if (0 === e.lookahead) break;
        }

        e.strstart += e.lookahead, e.lookahead = 0;
        var n = e.block_start + r;
        if ((0 === e.strstart || e.strstart >= n) && (e.lookahead = e.strstart - n, e.strstart = n, te(e, !1), 0 === e.strm.avail_out)) return H;
        if (e.strstart - e.block_start >= e.w_size - j && (te(e, !1), 0 === e.strm.avail_out)) return H;
      }

      return e.insert = 0, t === d ? (te(e, !0), 0 === e.strm.avail_out ? K : G) : (e.strstart > e.block_start && (te(e, !1), e.strm.avail_out), H);
    }), new fe(4, 4, 8, 4, oe), new fe(4, 5, 16, 8, oe), new fe(4, 6, 32, 32, oe), new fe(4, 4, 16, 16, ae), new fe(8, 16, 32, 32, ae), new fe(8, 16, 128, 128, ae), new fe(8, 32, 128, 256, ae), new fe(32, 128, 258, 1024, ae), new fe(32, 258, 258, 4096, ae)], t.deflateInit = function (e, t) {
      return he(e, t, x, R, M, E);
    }, t.deflateInit2 = he, t.deflateReset = ue, t.deflateResetKeep = ce, t.deflateSetHeader = function (e, t) {
      return e && e.state ? 2 !== e.state.wrap ? _ : (e.state.gzhead = t, p) : _;
    }, t.deflate = function (e, t) {
      var r, i, o, f;
      if (!e || !e.state || t > l || t < 0) return e ? X(e, _) : _;
      if (i = e.state, !e.output || !e.input && 0 !== e.avail_in || i.status === V && t !== d) return X(e, 0 === e.avail_out ? v : _);
      if (i.strm = e, r = i.last_flush, i.last_flush = t, i.status === D) if (2 === i.wrap) e.adler = 0, re(i, 31), re(i, 139), re(i, 8), i.gzhead ? (re(i, (i.gzhead.text ? 1 : 0) + (i.gzhead.hcrc ? 2 : 0) + (i.gzhead.extra ? 4 : 0) + (i.gzhead.name ? 8 : 0) + (i.gzhead.comment ? 16 : 0)), re(i, 255 & i.gzhead.time), re(i, i.gzhead.time >> 8 & 255), re(i, i.gzhead.time >> 16 & 255), re(i, i.gzhead.time >> 24 & 255), re(i, 9 === i.level ? 2 : i.strategy >= w || i.level < 2 ? 4 : 0), re(i, 255 & i.gzhead.os), i.gzhead.extra && i.gzhead.extra.length && (re(i, 255 & i.gzhead.extra.length), re(i, i.gzhead.extra.length >> 8 & 255)), i.gzhead.hcrc && (e.adler = a(e.adler, i.pending_buf, i.pending, 0)), i.gzindex = 0, i.status = q) : (re(i, 0), re(i, 0), re(i, 0), re(i, 0), re(i, 0), re(i, 9 === i.level ? 2 : i.strategy >= w || i.level < 2 ? 4 : 0), re(i, Y), i.status = Z);else {
        var g = x + (i.w_bits - 8 << 4) << 8;
        g |= (i.strategy >= w || i.level < 2 ? 0 : i.level < 6 ? 1 : 6 === i.level ? 2 : 3) << 6, 0 !== i.strstart && (g |= U), g += 31 - g % 31, i.status = Z, ne(i, g), 0 !== i.strstart && (ne(i, e.adler >>> 16), ne(i, 65535 & e.adler)), e.adler = 1;
      }
      if (i.status === q) if (i.gzhead.extra) {
        for (o = i.pending; i.gzindex < (65535 & i.gzhead.extra.length) && (i.pending !== i.pending_buf_size || (i.gzhead.hcrc && i.pending > o && (e.adler = a(e.adler, i.pending_buf, i.pending - o, o)), ee(e), o = i.pending, i.pending !== i.pending_buf_size));) {
          re(i, 255 & i.gzhead.extra[i.gzindex]), i.gzindex++;
        }

        i.gzhead.hcrc && i.pending > o && (e.adler = a(e.adler, i.pending_buf, i.pending - o, o)), i.gzindex === i.gzhead.extra.length && (i.gzindex = 0, i.status = z);
      } else i.status = z;
      if (i.status === z) if (i.gzhead.name) {
        o = i.pending;

        do {
          if (i.pending === i.pending_buf_size && (i.gzhead.hcrc && i.pending > o && (e.adler = a(e.adler, i.pending_buf, i.pending - o, o)), ee(e), o = i.pending, i.pending === i.pending_buf_size)) {
            f = 1;
            break;
          }

          f = i.gzindex < i.gzhead.name.length ? 255 & i.gzhead.name.charCodeAt(i.gzindex++) : 0, re(i, f);
        } while (0 !== f);

        i.gzhead.hcrc && i.pending > o && (e.adler = a(e.adler, i.pending_buf, i.pending - o, o)), 0 === f && (i.gzindex = 0, i.status = F);
      } else i.status = F;
      if (i.status === F) if (i.gzhead.comment) {
        o = i.pending;

        do {
          if (i.pending === i.pending_buf_size && (i.gzhead.hcrc && i.pending > o && (e.adler = a(e.adler, i.pending_buf, i.pending - o, o)), ee(e), o = i.pending, i.pending === i.pending_buf_size)) {
            f = 1;
            break;
          }

          f = i.gzindex < i.gzhead.comment.length ? 255 & i.gzhead.comment.charCodeAt(i.gzindex++) : 0, re(i, f);
        } while (0 !== f);

        i.gzhead.hcrc && i.pending > o && (e.adler = a(e.adler, i.pending_buf, i.pending - o, o)), 0 === f && (i.status = W);
      } else i.status = W;

      if (i.status === W && (i.gzhead.hcrc ? (i.pending + 2 > i.pending_buf_size && ee(e), i.pending + 2 <= i.pending_buf_size && (re(i, 255 & e.adler), re(i, e.adler >> 8 & 255), e.adler = 0, i.status = Z)) : i.status = Z), 0 !== i.pending) {
        if (ee(e), 0 === e.avail_out) return i.last_flush = -1, p;
      } else if (0 === e.avail_in && J(t) <= J(r) && t !== d) return X(e, v);

      if (i.status === V && 0 !== e.avail_in) return X(e, v);

      if (0 !== e.avail_in || 0 !== i.lookahead || t !== c && i.status !== V) {
        var m = i.strategy === w ? function (e, t) {
          for (var r;;) {
            if (0 === e.lookahead && (se(e), 0 === e.lookahead)) {
              if (t === c) return H;
              break;
            }

            if (e.match_length = 0, r = s._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++, r && (te(e, !1), 0 === e.strm.avail_out)) return H;
          }

          return e.insert = 0, t === d ? (te(e, !0), 0 === e.strm.avail_out ? K : G) : e.last_lit && (te(e, !1), 0 === e.strm.avail_out) ? H : $;
        }(i, t) : i.strategy === k ? function (e, t) {
          for (var r, n, i, o, a = e.window;;) {
            if (e.lookahead <= L) {
              if (se(e), e.lookahead <= L && t === c) return H;
              if (0 === e.lookahead) break;
            }

            if (e.match_length = 0, e.lookahead >= N && e.strstart > 0 && (n = a[i = e.strstart - 1]) === a[++i] && n === a[++i] && n === a[++i]) {
              o = e.strstart + L;

              do {} while (n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && i < o);

              e.match_length = L - (o - i), e.match_length > e.lookahead && (e.match_length = e.lookahead);
            }

            if (e.match_length >= N ? (r = s._tr_tally(e, 1, e.match_length - N), e.lookahead -= e.match_length, e.strstart += e.match_length, e.match_length = 0) : (r = s._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++), r && (te(e, !1), 0 === e.strm.avail_out)) return H;
          }

          return e.insert = 0, t === d ? (te(e, !0), 0 === e.strm.avail_out ? K : G) : e.last_lit && (te(e, !1), 0 === e.strm.avail_out) ? H : $;
        }(i, t) : n[i.level].func(i, t);
        if (m !== K && m !== G || (i.status = V), m === H || m === K) return 0 === e.avail_out && (i.last_flush = -1), p;
        if (m === $ && (t === u ? s._tr_align(i) : t !== l && (s._tr_stored_block(i, 0, 0, !1), t === h && (Q(i.head), 0 === i.lookahead && (i.strstart = 0, i.block_start = 0, i.insert = 0))), ee(e), 0 === e.avail_out)) return i.last_flush = -1, p;
      }

      return t !== d ? p : i.wrap <= 0 ? b : (2 === i.wrap ? (re(i, 255 & e.adler), re(i, e.adler >> 8 & 255), re(i, e.adler >> 16 & 255), re(i, e.adler >> 24 & 255), re(i, 255 & e.total_in), re(i, e.total_in >> 8 & 255), re(i, e.total_in >> 16 & 255), re(i, e.total_in >> 24 & 255)) : (ne(i, e.adler >>> 16), ne(i, 65535 & e.adler)), ee(e), i.wrap > 0 && (i.wrap = -i.wrap), 0 !== i.pending ? p : b);
    }, t.deflateEnd = function (e) {
      var t;
      return e && e.state ? (t = e.state.status) !== D && t !== q && t !== z && t !== F && t !== W && t !== Z && t !== V ? X(e, _) : (e.state = null, t === Z ? X(e, g) : p) : _;
    }, t.deflateSetDictionary = function (e, t) {
      var r,
          n,
          s,
          a,
          f,
          c,
          u,
          h,
          d = t.length;
      if (!e || !e.state) return _;
      if (2 === (a = (r = e.state).wrap) || 1 === a && r.status !== D || r.lookahead) return _;

      for (1 === a && (e.adler = o(e.adler, t, d, 0)), r.wrap = 0, d >= r.w_size && (0 === a && (Q(r.head), r.strstart = 0, r.block_start = 0, r.insert = 0), h = new i.Buf8(r.w_size), i.arraySet(h, t, d - r.w_size, r.w_size, 0), t = h, d = r.w_size), f = e.avail_in, c = e.next_in, u = e.input, e.avail_in = d, e.next_in = 0, e.input = t, se(r); r.lookahead >= N;) {
        n = r.strstart, s = r.lookahead - (N - 1);

        do {
          r.ins_h = (r.ins_h << r.hash_shift ^ r.window[n + N - 1]) & r.hash_mask, r.prev[n & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = n, n++;
        } while (--s);

        r.strstart = n, r.lookahead = N - 1, se(r);
      }

      return r.strstart += r.lookahead, r.block_start = r.strstart, r.insert = r.lookahead, r.lookahead = 0, r.match_length = r.prev_length = N - 1, r.match_available = 0, e.next_in = c, e.input = u, e.avail_in = f, r.wrap = a, p;
    }, t.deflateInfo = "pako deflate (from Nodeca project)";
  }, function (e, t, r) {
    "use strict";

    e.exports = function () {
      this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
    };
  }, function (e, t, r) {
    "use strict";

    (function (e) {
      var n = r(72),
          i = r(143),
          s = r(142),
          o = r(139),
          a = r(136);

      for (var f in a) {
        t[f] = a[f];
      }

      t.NONE = 0, t.DEFLATE = 1, t.INFLATE = 2, t.GZIP = 3, t.GUNZIP = 4, t.DEFLATERAW = 5, t.INFLATERAW = 6, t.UNZIP = 7;

      function c(e) {
        if ("number" != typeof e || e < t.DEFLATE || e > t.UNZIP) throw new TypeError("Bad argument");
        this.dictionary = null, this.err = 0, this.flush = 0, this.init_done = !1, this.level = 0, this.memLevel = 0, this.mode = e, this.strategy = 0, this.windowBits = 0, this.write_in_progress = !1, this.pending_close = !1, this.gzip_id_bytes_read = 0;
      }

      c.prototype.close = function () {
        this.write_in_progress ? this.pending_close = !0 : (this.pending_close = !1, n(this.init_done, "close before init"), n(this.mode <= t.UNZIP), this.mode === t.DEFLATE || this.mode === t.GZIP || this.mode === t.DEFLATERAW ? s.deflateEnd(this.strm) : this.mode !== t.INFLATE && this.mode !== t.GUNZIP && this.mode !== t.INFLATERAW && this.mode !== t.UNZIP || o.inflateEnd(this.strm), this.mode = t.NONE, this.dictionary = null);
      }, c.prototype.write = function (e, t, r, n, i, s, o) {
        return this._write(!0, e, t, r, n, i, s, o);
      }, c.prototype.writeSync = function (e, t, r, n, i, s, o) {
        return this._write(!1, e, t, r, n, i, s, o);
      }, c.prototype._write = function (r, i, s, o, a, f, c, u) {
        if (n.equal(arguments.length, 8), n(this.init_done, "write before init"), n(this.mode !== t.NONE, "already finalized"), n.equal(!1, this.write_in_progress, "write already in progress"), n.equal(!1, this.pending_close, "close is pending"), this.write_in_progress = !0, n.equal(!1, void 0 === i, "must provide flush value"), this.write_in_progress = !0, i !== t.Z_NO_FLUSH && i !== t.Z_PARTIAL_FLUSH && i !== t.Z_SYNC_FLUSH && i !== t.Z_FULL_FLUSH && i !== t.Z_FINISH && i !== t.Z_BLOCK) throw new Error("Invalid flush value");
        if (null == s && (s = e.alloc(0), a = 0, o = 0), this.strm.avail_in = a, this.strm.input = s, this.strm.next_in = o, this.strm.avail_out = u, this.strm.output = f, this.strm.next_out = c, this.flush = i, !r) return this._process(), this._checkError() ? this._afterSync() : void 0;
        var h = this;
        return process.nextTick(function () {
          h._process(), h._after();
        }), this;
      }, c.prototype._afterSync = function () {
        var e = this.strm.avail_out,
            t = this.strm.avail_in;
        return this.write_in_progress = !1, [t, e];
      }, c.prototype._process = function () {
        var e = null;

        switch (this.mode) {
          case t.DEFLATE:
          case t.GZIP:
          case t.DEFLATERAW:
            this.err = s.deflate(this.strm, this.flush);
            break;

          case t.UNZIP:
            switch (this.strm.avail_in > 0 && (e = this.strm.next_in), this.gzip_id_bytes_read) {
              case 0:
                if (null === e) break;

                if (31 !== this.strm.input[e]) {
                  this.mode = t.INFLATE;
                  break;
                }

                if (this.gzip_id_bytes_read = 1, e++, 1 === this.strm.avail_in) break;

              case 1:
                if (null === e) break;
                139 === this.strm.input[e] ? (this.gzip_id_bytes_read = 2, this.mode = t.GUNZIP) : this.mode = t.INFLATE;
                break;

              default:
                throw new Error("invalid number of gzip magic number bytes read");
            }

          case t.INFLATE:
          case t.GUNZIP:
          case t.INFLATERAW:
            for (this.err = o.inflate(this.strm, this.flush), this.err === t.Z_NEED_DICT && this.dictionary && (this.err = o.inflateSetDictionary(this.strm, this.dictionary), this.err === t.Z_OK ? this.err = o.inflate(this.strm, this.flush) : this.err === t.Z_DATA_ERROR && (this.err = t.Z_NEED_DICT)); this.strm.avail_in > 0 && this.mode === t.GUNZIP && this.err === t.Z_STREAM_END && 0 !== this.strm.next_in[0];) {
              this.reset(), this.err = o.inflate(this.strm, this.flush);
            }

            break;

          default:
            throw new Error("Unknown mode " + this.mode);
        }
      }, c.prototype._checkError = function () {
        switch (this.err) {
          case t.Z_OK:
          case t.Z_BUF_ERROR:
            if (0 !== this.strm.avail_out && this.flush === t.Z_FINISH) return this._error("unexpected end of file"), !1;
            break;

          case t.Z_STREAM_END:
            break;

          case t.Z_NEED_DICT:
            return null == this.dictionary ? this._error("Missing dictionary") : this._error("Bad dictionary"), !1;

          default:
            return this._error("Zlib error"), !1;
        }

        return !0;
      }, c.prototype._after = function () {
        if (this._checkError()) {
          var e = this.strm.avail_out,
              t = this.strm.avail_in;
          this.write_in_progress = !1, this.callback(t, e), this.pending_close && this.close();
        }
      }, c.prototype._error = function (e) {
        this.strm.msg && (e = this.strm.msg), this.onerror(e, this.err), this.write_in_progress = !1, this.pending_close && this.close();
      }, c.prototype.init = function (e, r, i, s, o) {
        n(4 === arguments.length || 5 === arguments.length, "init(windowBits, level, memLevel, strategy, [dictionary])"), n(e >= 8 && e <= 15, "invalid windowBits"), n(r >= -1 && r <= 9, "invalid compression level"), n(i >= 1 && i <= 9, "invalid memlevel"), n(s === t.Z_FILTERED || s === t.Z_HUFFMAN_ONLY || s === t.Z_RLE || s === t.Z_FIXED || s === t.Z_DEFAULT_STRATEGY, "invalid strategy"), this._init(r, e, i, s, o), this._setDictionary();
      }, c.prototype.params = function () {
        throw new Error("deflateParams Not supported");
      }, c.prototype.reset = function () {
        this._reset(), this._setDictionary();
      }, c.prototype._init = function (e, r, n, a, f) {
        switch (this.level = e, this.windowBits = r, this.memLevel = n, this.strategy = a, this.flush = t.Z_NO_FLUSH, this.err = t.Z_OK, this.mode !== t.GZIP && this.mode !== t.GUNZIP || (this.windowBits += 16), this.mode === t.UNZIP && (this.windowBits += 32), this.mode !== t.DEFLATERAW && this.mode !== t.INFLATERAW || (this.windowBits = -1 * this.windowBits), this.strm = new i(), this.mode) {
          case t.DEFLATE:
          case t.GZIP:
          case t.DEFLATERAW:
            this.err = s.deflateInit2(this.strm, this.level, t.Z_DEFLATED, this.windowBits, this.memLevel, this.strategy);
            break;

          case t.INFLATE:
          case t.GUNZIP:
          case t.INFLATERAW:
          case t.UNZIP:
            this.err = o.inflateInit2(this.strm, this.windowBits);
            break;

          default:
            throw new Error("Unknown mode " + this.mode);
        }

        this.err !== t.Z_OK && this._error("Init error"), this.dictionary = f, this.write_in_progress = !1, this.init_done = !0;
      }, c.prototype._setDictionary = function () {
        if (null != this.dictionary) {
          switch (this.err = t.Z_OK, this.mode) {
            case t.DEFLATE:
            case t.DEFLATERAW:
              this.err = s.deflateSetDictionary(this.strm, this.dictionary);
          }

          this.err !== t.Z_OK && this._error("Failed to set dictionary");
        }
      }, c.prototype._reset = function () {
        switch (this.err = t.Z_OK, this.mode) {
          case t.DEFLATE:
          case t.DEFLATERAW:
          case t.GZIP:
            this.err = s.deflateReset(this.strm);
            break;

          case t.INFLATE:
          case t.INFLATERAW:
          case t.GUNZIP:
            this.err = o.inflateReset(this.strm);
        }

        this.err !== t.Z_OK && this._error("Failed to reset stream");
      }, t.Zlib = c;
    }).call(this, r(3).Buffer);
  }, function (e, t, r) {
    "use strict";

    var n = r(3).Buffer,
        i = r(21).Transform,
        s = r(144),
        o = r(58),
        a = r(72).ok,
        f = r(3).kMaxLength,
        c = "Cannot create final Buffer. It would be larger than 0x" + f.toString(16) + " bytes";
    s.Z_MIN_WINDOWBITS = 8, s.Z_MAX_WINDOWBITS = 15, s.Z_DEFAULT_WINDOWBITS = 15, s.Z_MIN_CHUNK = 64, s.Z_MAX_CHUNK = 1 / 0, s.Z_DEFAULT_CHUNK = 16384, s.Z_MIN_MEMLEVEL = 1, s.Z_MAX_MEMLEVEL = 9, s.Z_DEFAULT_MEMLEVEL = 8, s.Z_MIN_LEVEL = -1, s.Z_MAX_LEVEL = 9, s.Z_DEFAULT_LEVEL = s.Z_DEFAULT_COMPRESSION;

    for (var u = Object.keys(s), h = 0; h < u.length; h++) {
      var d = u[h];
      d.match(/^Z/) && Object.defineProperty(t, d, {
        enumerable: !0,
        value: s[d],
        writable: !1
      });
    }

    for (var l = {
      Z_OK: s.Z_OK,
      Z_STREAM_END: s.Z_STREAM_END,
      Z_NEED_DICT: s.Z_NEED_DICT,
      Z_ERRNO: s.Z_ERRNO,
      Z_STREAM_ERROR: s.Z_STREAM_ERROR,
      Z_DATA_ERROR: s.Z_DATA_ERROR,
      Z_MEM_ERROR: s.Z_MEM_ERROR,
      Z_BUF_ERROR: s.Z_BUF_ERROR,
      Z_VERSION_ERROR: s.Z_VERSION_ERROR
    }, p = Object.keys(l), b = 0; b < p.length; b++) {
      var _ = p[b];
      l[l[_]] = _;
    }

    function g(e, t, r) {
      var i = [],
          s = 0;

      function o() {
        for (var t; null !== (t = e.read());) {
          i.push(t), s += t.length;
        }

        e.once("readable", o);
      }

      function a() {
        var t,
            o = null;
        s >= f ? o = new RangeError(c) : t = n.concat(i, s), i = [], e.close(), r(o, t);
      }

      e.on("error", function (t) {
        e.removeListener("end", a), e.removeListener("readable", o), r(t);
      }), e.on("end", a), e.end(t), o();
    }

    function v(e, t) {
      if ("string" == typeof t && (t = n.from(t)), !n.isBuffer(t)) throw new TypeError("Not a string or buffer");
      var r = e._finishFlushFlag;
      return e._processChunk(t, r);
    }

    function m(e) {
      if (!(this instanceof m)) return new m(e);
      T.call(this, e, s.DEFLATE);
    }

    function y(e) {
      if (!(this instanceof y)) return new y(e);
      T.call(this, e, s.INFLATE);
    }

    function w(e) {
      if (!(this instanceof w)) return new w(e);
      T.call(this, e, s.GZIP);
    }

    function k(e) {
      if (!(this instanceof k)) return new k(e);
      T.call(this, e, s.GUNZIP);
    }

    function S(e) {
      if (!(this instanceof S)) return new S(e);
      T.call(this, e, s.DEFLATERAW);
    }

    function E(e) {
      if (!(this instanceof E)) return new E(e);
      T.call(this, e, s.INFLATERAW);
    }

    function A(e) {
      if (!(this instanceof A)) return new A(e);
      T.call(this, e, s.UNZIP);
    }

    function x(e) {
      return e === s.Z_NO_FLUSH || e === s.Z_PARTIAL_FLUSH || e === s.Z_SYNC_FLUSH || e === s.Z_FULL_FLUSH || e === s.Z_FINISH || e === s.Z_BLOCK;
    }

    function T(e, r) {
      var o = this;
      if (this._opts = e = e || {}, this._chunkSize = e.chunkSize || t.Z_DEFAULT_CHUNK, i.call(this, e), e.flush && !x(e.flush)) throw new Error("Invalid flush flag: " + e.flush);
      if (e.finishFlush && !x(e.finishFlush)) throw new Error("Invalid flush flag: " + e.finishFlush);
      if (this._flushFlag = e.flush || s.Z_NO_FLUSH, this._finishFlushFlag = void 0 !== e.finishFlush ? e.finishFlush : s.Z_FINISH, e.chunkSize && (e.chunkSize < t.Z_MIN_CHUNK || e.chunkSize > t.Z_MAX_CHUNK)) throw new Error("Invalid chunk size: " + e.chunkSize);
      if (e.windowBits && (e.windowBits < t.Z_MIN_WINDOWBITS || e.windowBits > t.Z_MAX_WINDOWBITS)) throw new Error("Invalid windowBits: " + e.windowBits);
      if (e.level && (e.level < t.Z_MIN_LEVEL || e.level > t.Z_MAX_LEVEL)) throw new Error("Invalid compression level: " + e.level);
      if (e.memLevel && (e.memLevel < t.Z_MIN_MEMLEVEL || e.memLevel > t.Z_MAX_MEMLEVEL)) throw new Error("Invalid memLevel: " + e.memLevel);
      if (e.strategy && e.strategy != t.Z_FILTERED && e.strategy != t.Z_HUFFMAN_ONLY && e.strategy != t.Z_RLE && e.strategy != t.Z_FIXED && e.strategy != t.Z_DEFAULT_STRATEGY) throw new Error("Invalid strategy: " + e.strategy);
      if (e.dictionary && !n.isBuffer(e.dictionary)) throw new Error("Invalid dictionary: it should be a Buffer instance");
      this._handle = new s.Zlib(r);
      var a = this;
      this._hadError = !1, this._handle.onerror = function (e, r) {
        R(a), a._hadError = !0;
        var n = new Error(e);
        n.errno = r, n.code = t.codes[r], a.emit("error", n);
      };
      var f = t.Z_DEFAULT_COMPRESSION;
      "number" == typeof e.level && (f = e.level);
      var c = t.Z_DEFAULT_STRATEGY;
      "number" == typeof e.strategy && (c = e.strategy), this._handle.init(e.windowBits || t.Z_DEFAULT_WINDOWBITS, f, e.memLevel || t.Z_DEFAULT_MEMLEVEL, c, e.dictionary), this._buffer = n.allocUnsafe(this._chunkSize), this._offset = 0, this._level = f, this._strategy = c, this.once("end", this.close), Object.defineProperty(this, "_closed", {
        get: function get() {
          return !o._handle;
        },
        configurable: !0,
        enumerable: !0
      });
    }

    function R(e, t) {
      t && process.nextTick(t), e._handle && (e._handle.close(), e._handle = null);
    }

    function M(e) {
      e.emit("close");
    }

    Object.defineProperty(t, "codes", {
      enumerable: !0,
      value: Object.freeze(l),
      writable: !1
    }), t.Deflate = m, t.Inflate = y, t.Gzip = w, t.Gunzip = k, t.DeflateRaw = S, t.InflateRaw = E, t.Unzip = A, t.createDeflate = function (e) {
      return new m(e);
    }, t.createInflate = function (e) {
      return new y(e);
    }, t.createDeflateRaw = function (e) {
      return new S(e);
    }, t.createInflateRaw = function (e) {
      return new E(e);
    }, t.createGzip = function (e) {
      return new w(e);
    }, t.createGunzip = function (e) {
      return new k(e);
    }, t.createUnzip = function (e) {
      return new A(e);
    }, t.deflate = function (e, t, r) {
      return "function" == typeof t && (r = t, t = {}), g(new m(t), e, r);
    }, t.deflateSync = function (e, t) {
      return v(new m(t), e);
    }, t.gzip = function (e, t, r) {
      return "function" == typeof t && (r = t, t = {}), g(new w(t), e, r);
    }, t.gzipSync = function (e, t) {
      return v(new w(t), e);
    }, t.deflateRaw = function (e, t, r) {
      return "function" == typeof t && (r = t, t = {}), g(new S(t), e, r);
    }, t.deflateRawSync = function (e, t) {
      return v(new S(t), e);
    }, t.unzip = function (e, t, r) {
      return "function" == typeof t && (r = t, t = {}), g(new A(t), e, r);
    }, t.unzipSync = function (e, t) {
      return v(new A(t), e);
    }, t.inflate = function (e, t, r) {
      return "function" == typeof t && (r = t, t = {}), g(new y(t), e, r);
    }, t.inflateSync = function (e, t) {
      return v(new y(t), e);
    }, t.gunzip = function (e, t, r) {
      return "function" == typeof t && (r = t, t = {}), g(new k(t), e, r);
    }, t.gunzipSync = function (e, t) {
      return v(new k(t), e);
    }, t.inflateRaw = function (e, t, r) {
      return "function" == typeof t && (r = t, t = {}), g(new E(t), e, r);
    }, t.inflateRawSync = function (e, t) {
      return v(new E(t), e);
    }, o.inherits(T, i), T.prototype.params = function (e, r, n) {
      if (e < t.Z_MIN_LEVEL || e > t.Z_MAX_LEVEL) throw new RangeError("Invalid compression level: " + e);
      if (r != t.Z_FILTERED && r != t.Z_HUFFMAN_ONLY && r != t.Z_RLE && r != t.Z_FIXED && r != t.Z_DEFAULT_STRATEGY) throw new TypeError("Invalid strategy: " + r);

      if (this._level !== e || this._strategy !== r) {
        var i = this;
        this.flush(s.Z_SYNC_FLUSH, function () {
          a(i._handle, "zlib binding closed"), i._handle.params(e, r), i._hadError || (i._level = e, i._strategy = r, n && n());
        });
      } else process.nextTick(n);
    }, T.prototype.reset = function () {
      return a(this._handle, "zlib binding closed"), this._handle.reset();
    }, T.prototype._flush = function (e) {
      this._transform(n.alloc(0), "", e);
    }, T.prototype.flush = function (e, t) {
      var r = this,
          i = this._writableState;
      ("function" == typeof e || void 0 === e && !t) && (t = e, e = s.Z_FULL_FLUSH), i.ended ? t && process.nextTick(t) : i.ending ? t && this.once("end", t) : i.needDrain ? t && this.once("drain", function () {
        return r.flush(e, t);
      }) : (this._flushFlag = e, this.write(n.alloc(0), "", t));
    }, T.prototype.close = function (e) {
      R(this, e), process.nextTick(M, this);
    }, T.prototype._transform = function (e, t, r) {
      var i,
          o = this._writableState,
          a = (o.ending || o.ended) && (!e || o.length === e.length);
      return null === e || n.isBuffer(e) ? this._handle ? (a ? i = this._finishFlushFlag : (i = this._flushFlag, e.length >= o.length && (this._flushFlag = this._opts.flush || s.Z_NO_FLUSH)), void this._processChunk(e, i, r)) : r(new Error("zlib binding closed")) : r(new Error("invalid input"));
    }, T.prototype._processChunk = function (e, t, r) {
      var i = e && e.length,
          s = this._chunkSize - this._offset,
          o = 0,
          u = this,
          h = "function" == typeof r;

      if (!h) {
        var d,
            l = [],
            p = 0;
        this.on("error", function (e) {
          d = e;
        }), a(this._handle, "zlib binding closed");

        do {
          var b = this._handle.writeSync(t, e, o, i, this._buffer, this._offset, s);
        } while (!this._hadError && v(b[0], b[1]));

        if (this._hadError) throw d;
        if (p >= f) throw R(this), new RangeError(c);

        var _ = n.concat(l, p);

        return R(this), _;
      }

      a(this._handle, "zlib binding closed");

      var g = this._handle.write(t, e, o, i, this._buffer, this._offset, s);

      function v(f, c) {
        if (this && (this.buffer = null, this.callback = null), !u._hadError) {
          var d = s - c;

          if (a(d >= 0, "have should not go down"), d > 0) {
            var b = u._buffer.slice(u._offset, u._offset + d);

            u._offset += d, h ? u.push(b) : (l.push(b), p += b.length);
          }

          if ((0 === c || u._offset >= u._chunkSize) && (s = u._chunkSize, u._offset = 0, u._buffer = n.allocUnsafe(u._chunkSize)), 0 === c) {
            if (o += i - f, i = f, !h) return !0;

            var _ = u._handle.write(t, e, o, i, u._buffer, u._offset, u._chunkSize);

            return _.callback = v, void (_.buffer = e);
          }

          if (!h) return !1;
          r();
        }
      }

      g.buffer = e, g.callback = v;
    }, o.inherits(m, T), o.inherits(y, T), o.inherits(w, T), o.inherits(k, T), o.inherits(S, T), o.inherits(E, T), o.inherits(A, T);
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      if (!(this instanceof n)) return new n(e);
      e = e || {}, this.concurrency = e.concurrency || 1 / 0, this.pending = 0, this.jobs = [], this.cbs = [], this._done = function () {
        this.pending--, this._run();
      }.bind(this);
    }

    ["push", "unshift", "splice"].forEach(function (e) {
      n.prototype[e] = function () {
        var t = Array.prototype[e].apply(this.jobs, arguments);
        return this._run(), t;
      };
    }), Object.defineProperty(n.prototype, "length", {
      get: function get() {
        return this.pending + this.jobs.length;
      }
    }), n.prototype._run = function () {
      if (this.pending !== this.concurrency) {
        if (this.jobs.length) {
          var e = this.jobs.shift();
          this.pending++, e(this._done), this._run();
        }

        if (0 === this.pending) for (; 0 !== this.cbs.length;) {
          var t = this.cbs.pop();
          process.nextTick(t);
        }
      }
    }, n.prototype.onDone = function (e) {
      "function" == typeof e && (this.cbs.push(e), this._run());
    }, e.exports = n;
  }, function (e, t, r) {
    "use strict";

    var n = function n(e) {
      switch (typeof e) {
        case "string":
          return e;

        case "boolean":
          return e ? "true" : "false";

        case "number":
          return isFinite(e) ? e : "";

        default:
          return "";
      }
    };

    e.exports = function (e, t, r, a) {
      return t = t || "&", r = r || "=", null === e && (e = void 0), "object" == typeof e ? s(o(e), function (o) {
        var a = encodeURIComponent(n(o)) + r;
        return i(e[o]) ? s(e[o], function (e) {
          return a + encodeURIComponent(n(e));
        }).join(t) : a + encodeURIComponent(n(e[o]));
      }).join(t) : a ? encodeURIComponent(n(a)) + r + encodeURIComponent(n(e)) : "";
    };

    var i = Array.isArray || function (e) {
      return "[object Array]" === Object.prototype.toString.call(e);
    };

    function s(e, t) {
      if (e.map) return e.map(t);

      for (var r = [], n = 0; n < e.length; n++) {
        r.push(t(e[n], n));
      }

      return r;
    }

    var o = Object.keys || function (e) {
      var t = [];

      for (var r in e) {
        Object.prototype.hasOwnProperty.call(e, r) && t.push(r);
      }

      return t;
    };
  }, function (e, t, r) {
    "use strict";

    function n(e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }

    e.exports = function (e, t, r, s) {
      t = t || "&", r = r || "=";
      var o = {};
      if ("string" != typeof e || 0 === e.length) return o;
      var a = /\+/g;
      e = e.split(t);
      var f = 1e3;
      s && "number" == typeof s.maxKeys && (f = s.maxKeys);
      var c = e.length;
      f > 0 && c > f && (c = f);

      for (var u = 0; u < c; ++u) {
        var h,
            d,
            l,
            p,
            b = e[u].replace(a, "%20"),
            _ = b.indexOf(r);

        _ >= 0 ? (h = b.substr(0, _), d = b.substr(_ + 1)) : (h = b, d = ""), l = decodeURIComponent(h), p = decodeURIComponent(d), n(o, l) ? i(o[l]) ? o[l].push(p) : o[l] = [o[l], p] : o[l] = p;
      }

      return o;
    };

    var i = Array.isArray || function (e) {
      return "[object Array]" === Object.prototype.toString.call(e);
    };
  }, function (e, t, r) {
    "use strict";

    t.decode = t.parse = r(148), t.encode = t.stringify = r(147);
  }, function (e, t, r) {
    "use strict";

    e.exports = {
      isString: function isString(e) {
        return "string" == typeof e;
      },
      isObject: function isObject(e) {
        return "object" == typeof e && null !== e;
      },
      isNull: function isNull(e) {
        return null === e;
      },
      isNullOrUndefined: function isNullOrUndefined(e) {
        return null == e;
      }
    };
  }, function (e, t, r) {
    (function (e, n) {
      var i;
      /*! https://mths.be/punycode v1.4.1 by @mathias */

      !function (s) {
        "object" == typeof t && t && t.nodeType, "object" == typeof e && e && e.nodeType;
        var o = "object" == typeof n && n;
        o.global !== o && o.window !== o && o.self;
        var a,
            f = 2147483647,
            c = 36,
            u = 1,
            h = 26,
            d = 38,
            l = 700,
            p = 72,
            b = 128,
            _ = "-",
            g = /^xn--/,
            v = /[^\x20-\x7E]/,
            m = /[\x2E\u3002\uFF0E\uFF61]/g,
            y = {
          overflow: "Overflow: input needs wider integers to process",
          "not-basic": "Illegal input >= 0x80 (not a basic code point)",
          "invalid-input": "Invalid input"
        },
            w = c - u,
            k = Math.floor,
            S = String.fromCharCode;

        function E(e) {
          throw new RangeError(y[e]);
        }

        function A(e, t) {
          for (var r = e.length, n = []; r--;) {
            n[r] = t(e[r]);
          }

          return n;
        }

        function x(e, t) {
          var r = e.split("@"),
              n = "";
          return r.length > 1 && (n = r[0] + "@", e = r[1]), n + A((e = e.replace(m, ".")).split("."), t).join(".");
        }

        function T(e) {
          for (var t, r, n = [], i = 0, s = e.length; i < s;) {
            (t = e.charCodeAt(i++)) >= 55296 && t <= 56319 && i < s ? 56320 == (64512 & (r = e.charCodeAt(i++))) ? n.push(((1023 & t) << 10) + (1023 & r) + 65536) : (n.push(t), i--) : n.push(t);
          }

          return n;
        }

        function R(e) {
          return A(e, function (e) {
            var t = "";
            return e > 65535 && (t += S((e -= 65536) >>> 10 & 1023 | 55296), e = 56320 | 1023 & e), t += S(e);
          }).join("");
        }

        function M(e, t) {
          return e + 22 + 75 * (e < 26) - ((0 != t) << 5);
        }

        function I(e, t, r) {
          var n = 0;

          for (e = r ? k(e / l) : e >> 1, e += k(e / t); e > w * h >> 1; n += c) {
            e = k(e / w);
          }

          return k(n + (w + 1) * e / (e + d));
        }

        function O(e) {
          var t,
              r,
              n,
              i,
              s,
              o,
              a,
              d,
              l,
              g,
              v,
              m = [],
              y = e.length,
              w = 0,
              S = b,
              A = p;

          for ((r = e.lastIndexOf(_)) < 0 && (r = 0), n = 0; n < r; ++n) {
            e.charCodeAt(n) >= 128 && E("not-basic"), m.push(e.charCodeAt(n));
          }

          for (i = r > 0 ? r + 1 : 0; i < y;) {
            for (s = w, o = 1, a = c; i >= y && E("invalid-input"), ((d = (v = e.charCodeAt(i++)) - 48 < 10 ? v - 22 : v - 65 < 26 ? v - 65 : v - 97 < 26 ? v - 97 : c) >= c || d > k((f - w) / o)) && E("overflow"), w += d * o, !(d < (l = a <= A ? u : a >= A + h ? h : a - A)); a += c) {
              o > k(f / (g = c - l)) && E("overflow"), o *= g;
            }

            A = I(w - s, t = m.length + 1, 0 == s), k(w / t) > f - S && E("overflow"), S += k(w / t), w %= t, m.splice(w++, 0, S);
          }

          return R(m);
        }

        function C(e) {
          var t,
              r,
              n,
              i,
              s,
              o,
              a,
              d,
              l,
              g,
              v,
              m,
              y,
              w,
              A,
              x = [];

          for (m = (e = T(e)).length, t = b, r = 0, s = p, o = 0; o < m; ++o) {
            (v = e[o]) < 128 && x.push(S(v));
          }

          for (n = i = x.length, i && x.push(_); n < m;) {
            for (a = f, o = 0; o < m; ++o) {
              (v = e[o]) >= t && v < a && (a = v);
            }

            for (a - t > k((f - r) / (y = n + 1)) && E("overflow"), r += (a - t) * y, t = a, o = 0; o < m; ++o) {
              if ((v = e[o]) < t && ++r > f && E("overflow"), v == t) {
                for (d = r, l = c; !(d < (g = l <= s ? u : l >= s + h ? h : l - s)); l += c) {
                  A = d - g, w = c - g, x.push(S(M(g + A % w, 0))), d = k(A / w);
                }

                x.push(S(M(d, 0))), s = I(r, y, n == i), r = 0, ++n;
              }
            }

            ++r, ++t;
          }

          return x.join("");
        }

        a = {
          version: "1.4.1",
          ucs2: {
            decode: T,
            encode: R
          },
          decode: O,
          encode: C,
          toASCII: function toASCII(e) {
            return x(e, function (e) {
              return v.test(e) ? "xn--" + C(e) : e;
            });
          },
          toUnicode: function toUnicode(e) {
            return x(e, function (e) {
              return g.test(e) ? O(e.slice(4).toLowerCase()) : e;
            });
          }
        }, void 0 === (i = function () {
          return a;
        }.call(t, r, t, e)) || (e.exports = i);
      }();
    }).call(this, r(59)(e), r(9));
  }, function (e, t) {
    e.exports = {
      100: "Continue",
      101: "Switching Protocols",
      102: "Processing",
      200: "OK",
      201: "Created",
      202: "Accepted",
      203: "Non-Authoritative Information",
      204: "No Content",
      205: "Reset Content",
      206: "Partial Content",
      207: "Multi-Status",
      208: "Already Reported",
      226: "IM Used",
      300: "Multiple Choices",
      301: "Moved Permanently",
      302: "Found",
      303: "See Other",
      304: "Not Modified",
      305: "Use Proxy",
      307: "Temporary Redirect",
      308: "Permanent Redirect",
      400: "Bad Request",
      401: "Unauthorized",
      402: "Payment Required",
      403: "Forbidden",
      404: "Not Found",
      405: "Method Not Allowed",
      406: "Not Acceptable",
      407: "Proxy Authentication Required",
      408: "Request Timeout",
      409: "Conflict",
      410: "Gone",
      411: "Length Required",
      412: "Precondition Failed",
      413: "Payload Too Large",
      414: "URI Too Long",
      415: "Unsupported Media Type",
      416: "Range Not Satisfiable",
      417: "Expectation Failed",
      418: "I'm a teapot",
      421: "Misdirected Request",
      422: "Unprocessable Entity",
      423: "Locked",
      424: "Failed Dependency",
      425: "Unordered Collection",
      426: "Upgrade Required",
      428: "Precondition Required",
      429: "Too Many Requests",
      431: "Request Header Fields Too Large",
      451: "Unavailable For Legal Reasons",
      500: "Internal Server Error",
      501: "Not Implemented",
      502: "Bad Gateway",
      503: "Service Unavailable",
      504: "Gateway Timeout",
      505: "HTTP Version Not Supported",
      506: "Variant Also Negotiates",
      507: "Insufficient Storage",
      508: "Loop Detected",
      509: "Bandwidth Limit Exceeded",
      510: "Not Extended",
      511: "Network Authentication Required"
    };
  }, function (e, t) {
    e.exports = function () {
      for (var e = {}, t = 0; t < arguments.length; t++) {
        var n = arguments[t];

        for (var i in n) {
          r.call(n, i) && (e[i] = n[i]);
        }
      }

      return e;
    };

    var r = Object.prototype.hasOwnProperty;
  }, function (e, t, r) {
    var n = r(3).Buffer;

    e.exports = function (e) {
      if (e instanceof Uint8Array) {
        if (0 === e.byteOffset && e.byteLength === e.buffer.byteLength) return e.buffer;
        if ("function" == typeof e.buffer.slice) return e.buffer.slice(e.byteOffset, e.byteOffset + e.byteLength);
      }

      if (n.isBuffer(e)) {
        for (var t = new Uint8Array(e.length), r = e.length, i = 0; i < r; i++) {
          t[i] = e[i];
        }

        return t.buffer;
      }

      throw new Error("Argument must be a Buffer");
    };
  }, function (e, t, r) {
    (function (t, n) {
      var i = r(74),
          s = r(2),
          o = r(73),
          a = r(30),
          f = r(154),
          c = o.IncomingMessage,
          u = o.readyStates;

      var h = e.exports = function (e) {
        var r,
            n = this;
        a.Writable.call(n), n._opts = e, n._body = [], n._headers = {}, e.auth && n.setHeader("Authorization", "Basic " + new t(e.auth).toString("base64")), Object.keys(e.headers).forEach(function (t) {
          n.setHeader(t, e.headers[t]);
        });
        var s = !0;
        if ("disable-fetch" === e.mode || "requestTimeout" in e && !i.abortController) s = !1, r = !0;else if ("prefer-streaming" === e.mode) r = !1;else if ("allow-wrong-content-type" === e.mode) r = !i.overrideMimeType;else {
          if (e.mode && "default" !== e.mode && "prefer-fast" !== e.mode) throw new Error("Invalid value for opts.mode");
          r = !0;
        }
        n._mode = function (e, t) {
          return i.fetch && t ? "fetch" : i.mozchunkedarraybuffer ? "moz-chunked-arraybuffer" : i.msstream ? "ms-stream" : i.arraybuffer && e ? "arraybuffer" : i.vbArray && e ? "text:vbarray" : "text";
        }(r, s), n.on("finish", function () {
          n._onFinish();
        });
      };

      s(h, a.Writable), h.prototype.setHeader = function (e, t) {
        var r = e.toLowerCase();
        -1 === d.indexOf(r) && (this._headers[r] = {
          name: e,
          value: t
        });
      }, h.prototype.getHeader = function (e) {
        var t = this._headers[e.toLowerCase()];

        return t ? t.value : null;
      }, h.prototype.removeHeader = function (e) {
        delete this._headers[e.toLowerCase()];
      }, h.prototype._onFinish = function () {
        var e = this;

        if (!e._destroyed) {
          var r = e._opts,
              s = e._headers,
              o = null;
          "GET" !== r.method && "HEAD" !== r.method && (o = i.arraybuffer ? f(t.concat(e._body)) : i.blobConstructor ? new n.Blob(e._body.map(function (e) {
            return f(e);
          }), {
            type: (s["content-type"] || {}).value || ""
          }) : t.concat(e._body).toString());
          var a = [];

          if (Object.keys(s).forEach(function (e) {
            var t = s[e].name,
                r = s[e].value;
            Array.isArray(r) ? r.forEach(function (e) {
              a.push([t, e]);
            }) : a.push([t, r]);
          }), "fetch" === e._mode) {
            var c = null;

            if (i.abortController) {
              var h = new AbortController();
              c = h.signal, e._fetchAbortController = h, "requestTimeout" in r && 0 !== r.requestTimeout && n.setTimeout(function () {
                e.emit("requestTimeout"), e._fetchAbortController && e._fetchAbortController.abort();
              }, r.requestTimeout);
            }

            n.fetch(e._opts.url, {
              method: e._opts.method,
              headers: a,
              body: o || void 0,
              mode: "cors",
              credentials: r.withCredentials ? "include" : "same-origin",
              signal: c
            }).then(function (t) {
              e._fetchResponse = t, e._connect();
            }, function (t) {
              e.emit("error", t);
            });
          } else {
            var d = e._xhr = new n.XMLHttpRequest();

            try {
              d.open(e._opts.method, e._opts.url, !0);
            } catch (t) {
              return void process.nextTick(function () {
                e.emit("error", t);
              });
            }

            "responseType" in d && (d.responseType = e._mode.split(":")[0]), "withCredentials" in d && (d.withCredentials = !!r.withCredentials), "text" === e._mode && "overrideMimeType" in d && d.overrideMimeType("text/plain; charset=x-user-defined"), "requestTimeout" in r && (d.timeout = r.requestTimeout, d.ontimeout = function () {
              e.emit("requestTimeout");
            }), a.forEach(function (e) {
              d.setRequestHeader(e[0], e[1]);
            }), e._response = null, d.onreadystatechange = function () {
              switch (d.readyState) {
                case u.LOADING:
                case u.DONE:
                  e._onXHRProgress();

              }
            }, "moz-chunked-arraybuffer" === e._mode && (d.onprogress = function () {
              e._onXHRProgress();
            }), d.onerror = function () {
              e._destroyed || e.emit("error", new Error("XHR error"));
            };

            try {
              d.send(o);
            } catch (t) {
              return void process.nextTick(function () {
                e.emit("error", t);
              });
            }
          }
        }
      }, h.prototype._onXHRProgress = function () {
        (function (e) {
          try {
            var t = e.status;
            return null !== t && 0 !== t;
          } catch (e) {
            return !1;
          }
        })(this._xhr) && !this._destroyed && (this._response || this._connect(), this._response._onXHRProgress());
      }, h.prototype._connect = function () {
        var e = this;
        e._destroyed || (e._response = new c(e._xhr, e._fetchResponse, e._mode), e._response.on("error", function (t) {
          e.emit("error", t);
        }), e.emit("response", e._response));
      }, h.prototype._write = function (e, t, r) {
        this._body.push(e), r();
      }, h.prototype.abort = h.prototype.destroy = function () {
        this._destroyed = !0, this._response && (this._response._destroyed = !0), this._xhr ? this._xhr.abort() : this._fetchAbortController && this._fetchAbortController.abort();
      }, h.prototype.end = function (e, t, r) {
        "function" == typeof e && (r = e, e = void 0), a.Writable.prototype.end.call(this, e, t, r);
      }, h.prototype.flushHeaders = function () {}, h.prototype.setTimeout = function () {}, h.prototype.setNoDelay = function () {}, h.prototype.setSocketKeepAlive = function () {};
      var d = ["accept-charset", "accept-encoding", "access-control-request-headers", "access-control-request-method", "connection", "content-length", "cookie", "cookie2", "date", "dnt", "expect", "host", "keep-alive", "origin", "referer", "te", "trailer", "transfer-encoding", "upgrade", "user-agent", "via"];
    }).call(this, r(3).Buffer, r(9));
  }, function (e, t, r) {
    var n = r(46),
        i = r(35),
        s = e.exports;

    for (var o in n) {
      n.hasOwnProperty(o) && (s[o] = n[o]);
    }

    function a(e) {
      if ("string" == typeof e && (e = i.parse(e)), e.protocol || (e.protocol = "https:"), "https:" !== e.protocol) throw new Error('Protocol "' + e.protocol + '" not supported. Expected "https:"');
      return e;
    }

    s.request = function (e, t) {
      return e = a(e), n.request.call(this, e, t);
    }, s.get = function (e, t) {
      return e = a(e), n.get.call(this, e, t);
    };
  }, function (e, t, r) {
    "use strict";

    (function (e) {
      function n() {
        throw new Error("secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11");
      }

      var i = r(6),
          s = r(22),
          o = i.Buffer,
          a = i.kMaxLength,
          f = e.crypto || e.msCrypto,
          c = Math.pow(2, 32) - 1;

      function u(e, t) {
        if ("number" != typeof e || e != e) throw new TypeError("offset must be a number");
        if (e > c || e < 0) throw new TypeError("offset must be a uint32");
        if (e > a || e > t) throw new RangeError("offset out of range");
      }

      function h(e, t, r) {
        if ("number" != typeof e || e != e) throw new TypeError("size must be a number");
        if (e > c || e < 0) throw new TypeError("size must be a uint32");
        if (e + t > r || e > a) throw new RangeError("buffer too small");
      }

      function d(e, t, r, n) {
        if (process.browser) {
          var i = e.buffer,
              o = new Uint8Array(i, t, r);
          return f.getRandomValues(o), n ? void process.nextTick(function () {
            n(null, e);
          }) : e;
        }

        if (!n) return s(r).copy(e, t), e;
        s(r, function (r, i) {
          if (r) return n(r);
          i.copy(e, t), n(null, e);
        });
      }

      f && f.getRandomValues || !process.browser ? (t.randomFill = function (t, r, n, i) {
        if (!(o.isBuffer(t) || t instanceof e.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
        if ("function" == typeof r) i = r, r = 0, n = t.length;else if ("function" == typeof n) i = n, n = t.length - r;else if ("function" != typeof i) throw new TypeError('"cb" argument must be a function');
        return u(r, t.length), h(n, r, t.length), d(t, r, n, i);
      }, t.randomFillSync = function (t, r, n) {
        void 0 === r && (r = 0);
        if (!(o.isBuffer(t) || t instanceof e.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
        u(r, t.length), void 0 === n && (n = t.length - r);
        return h(n, r, t.length), d(t, r, n);
      }) : (t.randomFill = n, t.randomFillSync = n);
    }).call(this, r(9));
  }, function (e, t, r) {
    (function (t) {
      var n = r(36),
          i = r(77),
          s = r(76),
          o = r(8),
          a = r(48),
          f = r(31),
          c = r(75);

      e.exports = function (e, r, u) {
        var h;
        h = e.padding ? e.padding : u ? 1 : 4;
        var d,
            l = n(e),
            p = l.modulus.byteLength();
        if (r.length > p || new o(r).cmp(l.modulus) >= 0) throw new Error("decryption error");
        d = u ? c(new o(r), l) : a(r, l);
        var b = new t(p - d.length);
        if (b.fill(0), d = t.concat([b, d], p), 4 === h) return function (e, r) {
          e.modulus;
          var n = e.modulus.byteLength(),
              o = (r.length, f("sha1").update(new t("")).digest()),
              a = o.length;
          if (0 !== r[0]) throw new Error("decryption error");
          var c = r.slice(1, a + 1),
              u = r.slice(a + 1),
              h = s(c, i(u, a)),
              d = s(u, i(h, n - a - 1));
          if (function (e, r) {
            e = new t(e), r = new t(r);
            var n = 0,
                i = e.length;
            e.length !== r.length && (n++, i = Math.min(e.length, r.length));
            var s = -1;

            for (; ++s < i;) {
              n += e[s] ^ r[s];
            }

            return n;
          }(o, d.slice(0, a))) throw new Error("decryption error");
          var l = a;

          for (; 0 === d[l];) {
            l++;
          }

          if (1 !== d[l++]) throw new Error("decryption error");
          return d.slice(l);
        }(l, d);
        if (1 === h) return function (e, t, r) {
          var n = t.slice(0, 2),
              i = 2,
              s = 0;

          for (; 0 !== t[i++];) {
            if (i >= t.length) {
              s++;
              break;
            }
          }

          var o = t.slice(2, i - 1);
          t.slice(i - 1, i);
          ("0002" !== n.toString("hex") && !r || "0001" !== n.toString("hex") && r) && s++;
          o.length < 8 && s++;
          if (s) throw new Error("decryption error");
          return t.slice(i);
        }(0, d, u);
        if (3 === h) return d;
        throw new Error("unknown padding");
      };
    }).call(this, r(3).Buffer);
  }, function (e, t, r) {
    (function (t) {
      var n = r(36),
          i = r(22),
          s = r(31),
          o = r(77),
          a = r(76),
          f = r(8),
          c = r(75),
          u = r(48);

      e.exports = function (e, r, h) {
        var d;
        d = e.padding ? e.padding : h ? 1 : 4;
        var l,
            p = n(e);
        if (4 === d) l = function (e, r) {
          var n = e.modulus.byteLength(),
              c = r.length,
              u = s("sha1").update(new t("")).digest(),
              h = u.length,
              d = 2 * h;
          if (c > n - d - 2) throw new Error("message too long");
          var l = new t(n - c - d - 2);
          l.fill(0);

          var p = n - h - 1,
              b = i(h),
              _ = a(t.concat([u, l, new t([1]), r], p), o(b, p)),
              g = a(b, o(_, h));

          return new f(t.concat([new t([0]), g, _], n));
        }(p, r);else if (1 === d) l = function (e, r, n) {
          var s,
              o = r.length,
              a = e.modulus.byteLength();
          if (o > a - 11) throw new Error("message too long");
          n ? (s = new t(a - o - 3)).fill(255) : s = function (e, r) {
            var n,
                s = new t(e),
                o = 0,
                a = i(2 * e),
                f = 0;

            for (; o < e;) {
              f === a.length && (a = i(2 * e), f = 0), (n = a[f++]) && (s[o++] = n);
            }

            return s;
          }(a - o - 3);
          return new f(t.concat([new t([0, n ? 1 : 2]), s, new t([0]), r], a));
        }(p, r, h);else {
          if (3 !== d) throw new Error("unknown padding");
          if ((l = new f(r)).cmp(p.modulus) >= 0) throw new Error("data too long for modulus");
        }
        return h ? u(l, p) : c(l, p);
      };
    }).call(this, r(3).Buffer);
  }, function (e, t, r) {
    t.publicEncrypt = r(159), t.privateDecrypt = r(158), t.privateEncrypt = function (e, r) {
      return t.publicEncrypt(e, r, !0);
    }, t.publicDecrypt = function (e, r) {
      return t.privateDecrypt(e, r, !0);
    };
  }, function (e, t, r) {
    (function (t) {
      var n = r(11),
          i = r(8);

      e.exports = function (e) {
        return new o(e);
      };

      var s = {
        secp256k1: {
          name: "secp256k1",
          byteLength: 32
        },
        secp224r1: {
          name: "p224",
          byteLength: 28
        },
        prime256v1: {
          name: "p256",
          byteLength: 32
        },
        prime192v1: {
          name: "p192",
          byteLength: 24
        },
        ed25519: {
          name: "ed25519",
          byteLength: 32
        },
        secp384r1: {
          name: "p384",
          byteLength: 48
        },
        secp521r1: {
          name: "p521",
          byteLength: 66
        }
      };

      function o(e) {
        this.curveType = s[e], this.curveType || (this.curveType = {
          name: e
        }), this.curve = new n.ec(this.curveType.name), this.keys = void 0;
      }

      function a(e, r, n) {
        Array.isArray(e) || (e = e.toArray());
        var i = new t(e);

        if (n && i.length < n) {
          var s = new t(n - i.length);
          s.fill(0), i = t.concat([s, i]);
        }

        return r ? i.toString(r) : i;
      }

      s.p224 = s.secp224r1, s.p256 = s.secp256r1 = s.prime256v1, s.p192 = s.secp192r1 = s.prime192v1, s.p384 = s.secp384r1, s.p521 = s.secp521r1, o.prototype.generateKeys = function (e, t) {
        return this.keys = this.curve.genKeyPair(), this.getPublicKey(e, t);
      }, o.prototype.computeSecret = function (e, r, n) {
        return r = r || "utf8", t.isBuffer(e) || (e = new t(e, r)), a(this.curve.keyFromPublic(e).getPublic().mul(this.keys.getPrivate()).getX(), n, this.curveType.byteLength);
      }, o.prototype.getPublicKey = function (e, t) {
        var r = this.keys.getPublic("compressed" === t, !0);
        return "hybrid" === t && (r[r.length - 1] % 2 ? r[0] = 7 : r[0] = 6), a(r, e);
      }, o.prototype.getPrivateKey = function (e) {
        return a(this.keys.getPrivate(), e);
      }, o.prototype.setPublicKey = function (e, r) {
        return r = r || "utf8", t.isBuffer(e) || (e = new t(e, r)), this.keys._importPublic(e), this;
      }, o.prototype.setPrivateKey = function (e, r) {
        r = r || "utf8", t.isBuffer(e) || (e = new t(e, r));
        var n = new i(e);
        return n = n.toString(16), this.keys._importPrivate(n), this;
      };
    }).call(this, r(3).Buffer);
  }, function (e, t, r) {
    (function (t) {
      var n = r(8),
          i = r(11).ec,
          s = r(36),
          o = r(78);

      function a(e, t) {
        if (e.cmpn(0) <= 0) throw new Error("invalid sig");
        if (e.cmp(t) >= t) throw new Error("invalid sig");
      }

      e.exports = function (e, r, f, c, u) {
        var h = s(f);

        if ("ec" === h.type) {
          if ("ecdsa" !== c && "ecdsa/rsa" !== c) throw new Error("wrong public key type");
          return function (e, t, r) {
            var n = o[r.data.algorithm.curve.join(".")];
            if (!n) throw new Error("unknown curve " + r.data.algorithm.curve.join("."));
            var s = new i(n),
                a = r.data.subjectPrivateKey.data;
            return s.verify(t, e, a);
          }(e, r, h);
        }

        if ("dsa" === h.type) {
          if ("dsa" !== c) throw new Error("wrong public key type");
          return function (e, t, r) {
            var i = r.data.p,
                o = r.data.q,
                f = r.data.g,
                c = r.data.pub_key,
                u = s.signature.decode(e, "der"),
                h = u.s,
                d = u.r;
            a(h, o), a(d, o);
            var l = n.mont(i),
                p = h.invm(o);
            return 0 === f.toRed(l).redPow(new n(t).mul(p).mod(o)).fromRed().mul(c.toRed(l).redPow(d.mul(p).mod(o)).fromRed()).mod(i).mod(o).cmp(d);
          }(e, r, h);
        }

        if ("rsa" !== c && "ecdsa/rsa" !== c) throw new Error("wrong public key type");
        r = t.concat([u, r]);

        for (var d = h.modulus.byteLength(), l = [1], p = 0; r.length + l.length + 2 < d;) {
          l.push(255), p++;
        }

        l.push(0);

        for (var b = -1; ++b < r.length;) {
          l.push(r[b]);
        }

        l = new t(l);

        var _ = n.mont(h.modulus);

        e = (e = new n(e).toRed(_)).redPow(new n(h.publicExponent)), e = new t(e.fromRed().toArray());
        var g = p < 8 ? 1 : 0;

        for (d = Math.min(e.length, l.length), e.length !== l.length && (g = 1), b = -1; ++b < d;) {
          g |= e[b] ^ l[b];
        }

        return 0 === g;
      };
    }).call(this, r(3).Buffer);
  }, function (e, t, r) {
    (function (t) {
      var n = /Proc-Type: 4,ENCRYPTED\n\r?DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)\n\r?\n\r?([0-9A-z\n\r\+\/\=]+)\n\r?/m,
          i = /^-----BEGIN ((?:.* KEY)|CERTIFICATE)-----\n/m,
          s = /^-----BEGIN ((?:.* KEY)|CERTIFICATE)-----\n\r?([0-9A-z\n\r\+\/\=]+)\n\r?-----END \1-----$/m,
          o = r(39),
          a = r(51);

      e.exports = function (e, r) {
        var f,
            c = e.toString(),
            u = c.match(n);

        if (u) {
          var h = "aes" + u[1],
              d = new t(u[2], "hex"),
              l = new t(u[3].replace(/\r?\n/g, ""), "base64"),
              p = o(r, d.slice(0, 8), parseInt(u[1], 10)).key,
              b = [],
              _ = a.createDecipheriv(h, p, d);

          b.push(_.update(l)), b.push(_.final()), f = t.concat(b);
        } else {
          var g = c.match(s);
          f = new t(g[2].replace(/\r?\n/g, ""), "base64");
        }

        return {
          tag: c.match(i)[1],
          data: f
        };
      };
    }).call(this, r(3).Buffer);
  }, function (e) {
    e.exports = {
      "2.16.840.1.101.3.4.1.1": "aes-128-ecb",
      "2.16.840.1.101.3.4.1.2": "aes-128-cbc",
      "2.16.840.1.101.3.4.1.3": "aes-128-ofb",
      "2.16.840.1.101.3.4.1.4": "aes-128-cfb",
      "2.16.840.1.101.3.4.1.21": "aes-192-ecb",
      "2.16.840.1.101.3.4.1.22": "aes-192-cbc",
      "2.16.840.1.101.3.4.1.23": "aes-192-ofb",
      "2.16.840.1.101.3.4.1.24": "aes-192-cfb",
      "2.16.840.1.101.3.4.1.41": "aes-256-ecb",
      "2.16.840.1.101.3.4.1.42": "aes-256-cbc",
      "2.16.840.1.101.3.4.1.43": "aes-256-ofb",
      "2.16.840.1.101.3.4.1.44": "aes-256-cfb"
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(26),
        i = n.define("Time", function () {
      this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
      });
    }),
        s = n.define("AttributeTypeValue", function () {
      this.seq().obj(this.key("type").objid(), this.key("value").any());
    }),
        o = n.define("AlgorithmIdentifier", function () {
      this.seq().obj(this.key("algorithm").objid(), this.key("parameters").optional());
    }),
        a = n.define("SubjectPublicKeyInfo", function () {
      this.seq().obj(this.key("algorithm").use(o), this.key("subjectPublicKey").bitstr());
    }),
        f = n.define("RelativeDistinguishedName", function () {
      this.setof(s);
    }),
        c = n.define("RDNSequence", function () {
      this.seqof(f);
    }),
        u = n.define("Name", function () {
      this.choice({
        rdnSequence: this.use(c)
      });
    }),
        h = n.define("Validity", function () {
      this.seq().obj(this.key("notBefore").use(i), this.key("notAfter").use(i));
    }),
        d = n.define("Extension", function () {
      this.seq().obj(this.key("extnID").objid(), this.key("critical").bool().def(!1), this.key("extnValue").octstr());
    }),
        l = n.define("TBSCertificate", function () {
      this.seq().obj(this.key("version").explicit(0).int(), this.key("serialNumber").int(), this.key("signature").use(o), this.key("issuer").use(u), this.key("validity").use(h), this.key("subject").use(u), this.key("subjectPublicKeyInfo").use(a), this.key("issuerUniqueID").implicit(1).bitstr().optional(), this.key("subjectUniqueID").implicit(2).bitstr().optional(), this.key("extensions").explicit(3).seqof(d).optional());
    }),
        p = n.define("X509Certificate", function () {
      this.seq().obj(this.key("tbsCertificate").use(l), this.key("signatureAlgorithm").use(o), this.key("signatureValue").bitstr());
    });
    e.exports = p;
  }, function (e, t, r) {
    var n = r(2),
        i = r(79);

    function s(e) {
      i.call(this, e), this.enc = "pem";
    }

    n(s, i), e.exports = s, s.prototype.encode = function (e, t) {
      for (var r = i.prototype.encode.call(this, e).toString("base64"), n = ["-----BEGIN " + t.label + "-----"], s = 0; s < r.length; s += 64) {
        n.push(r.slice(s, s + 64));
      }

      return n.push("-----END " + t.label + "-----"), n.join("\n");
    };
  }, function (e, t, r) {
    var n = t;
    n.der = r(79), n.pem = r(166);
  }, function (e, t, r) {
    var n = r(2),
        i = r(3).Buffer,
        s = r(80);

    function o(e) {
      s.call(this, e), this.enc = "pem";
    }

    n(o, s), e.exports = o, o.prototype.decode = function (e, t) {
      for (var r = e.toString().split(/[\r\n]+/g), n = t.label.toUpperCase(), o = /^-----(BEGIN|END) ([^-]+)-----$/, a = -1, f = -1, c = 0; c < r.length; c++) {
        var u = r[c].match(o);

        if (null !== u && u[2] === n) {
          if (-1 !== a) {
            if ("END" !== u[1]) break;
            f = c;
            break;
          }

          if ("BEGIN" !== u[1]) break;
          a = c;
        }
      }

      if (-1 === a || -1 === f) throw new Error("PEM section not found for: " + n);
      var h = r.slice(a + 1, f).join("");
      h.replace(/[^a-z0-9\+\/=]+/gi, "");
      var d = new i(h, "base64");
      return s.prototype.decode.call(this, d, t);
    };
  }, function (e, t, r) {
    var n = t;
    n.der = r(80), n.pem = r(168);
  }, function (e, t, r) {
    var n = r(81);
    t.tagClass = {
      0: "universal",
      1: "application",
      2: "context",
      3: "private"
    }, t.tagClassByName = n._reverse(t.tagClass), t.tag = {
      0: "end",
      1: "bool",
      2: "int",
      3: "bitstr",
      4: "octstr",
      5: "null_",
      6: "objid",
      7: "objDesc",
      8: "external",
      9: "real",
      10: "enum",
      11: "embed",
      12: "utf8str",
      13: "relativeOid",
      16: "seq",
      17: "set",
      18: "numstr",
      19: "printstr",
      20: "t61str",
      21: "videostr",
      22: "ia5str",
      23: "utctime",
      24: "gentime",
      25: "graphstr",
      26: "iso646str",
      27: "genstr",
      28: "unistr",
      29: "charstr",
      30: "bmpstr"
    }, t.tagByName = n._reverse(t.tag);
  }, function (e, t, r) {
    var n = r(25).Reporter,
        i = r(25).EncoderBuffer,
        s = r(25).DecoderBuffer,
        o = r(13),
        a = ["seq", "seqof", "set", "setof", "objid", "bool", "gentime", "utctime", "null_", "enum", "int", "objDesc", "bitstr", "bmpstr", "charstr", "genstr", "graphstr", "ia5str", "iso646str", "numstr", "octstr", "printstr", "t61str", "unistr", "utf8str", "videostr"],
        f = ["key", "obj", "use", "optional", "explicit", "implicit", "def", "choice", "any", "contains"].concat(a);

    function c(e, t) {
      var r = {};
      this._baseState = r, r.enc = e, r.parent = t || null, r.children = null, r.tag = null, r.args = null, r.reverseArgs = null, r.choice = null, r.optional = !1, r.any = !1, r.obj = !1, r.use = null, r.useDecoder = null, r.key = null, r.default = null, r.explicit = null, r.implicit = null, r.contains = null, r.parent || (r.children = [], this._wrap());
    }

    e.exports = c;
    var u = ["enc", "parent", "children", "tag", "args", "reverseArgs", "choice", "optional", "any", "obj", "use", "alteredUse", "key", "default", "explicit", "implicit", "contains"];
    c.prototype.clone = function () {
      var e = this._baseState,
          t = {};
      u.forEach(function (r) {
        t[r] = e[r];
      });
      var r = new this.constructor(t.parent);
      return r._baseState = t, r;
    }, c.prototype._wrap = function () {
      var e = this._baseState;
      f.forEach(function (t) {
        this[t] = function () {
          var r = new this.constructor(this);
          return e.children.push(r), r[t].apply(r, arguments);
        };
      }, this);
    }, c.prototype._init = function (e) {
      var t = this._baseState;
      o(null === t.parent), e.call(this), t.children = t.children.filter(function (e) {
        return e._baseState.parent === this;
      }, this), o.equal(t.children.length, 1, "Root node can have only one child");
    }, c.prototype._useArgs = function (e) {
      var t = this._baseState,
          r = e.filter(function (e) {
        return e instanceof this.constructor;
      }, this);
      e = e.filter(function (e) {
        return !(e instanceof this.constructor);
      }, this), 0 !== r.length && (o(null === t.children), t.children = r, r.forEach(function (e) {
        e._baseState.parent = this;
      }, this)), 0 !== e.length && (o(null === t.args), t.args = e, t.reverseArgs = e.map(function (e) {
        if ("object" != typeof e || e.constructor !== Object) return e;
        var t = {};
        return Object.keys(e).forEach(function (r) {
          r == (0 | r) && (r |= 0);
          var n = e[r];
          t[n] = r;
        }), t;
      }));
    }, ["_peekTag", "_decodeTag", "_use", "_decodeStr", "_decodeObjid", "_decodeTime", "_decodeNull", "_decodeInt", "_decodeBool", "_decodeList", "_encodeComposite", "_encodeStr", "_encodeObjid", "_encodeTime", "_encodeNull", "_encodeInt", "_encodeBool"].forEach(function (e) {
      c.prototype[e] = function () {
        var t = this._baseState;
        throw new Error(e + " not implemented for encoding: " + t.enc);
      };
    }), a.forEach(function (e) {
      c.prototype[e] = function () {
        var t = this._baseState,
            r = Array.prototype.slice.call(arguments);
        return o(null === t.tag), t.tag = e, this._useArgs(r), this;
      };
    }), c.prototype.use = function (e) {
      o(e);
      var t = this._baseState;
      return o(null === t.use), t.use = e, this;
    }, c.prototype.optional = function () {
      return this._baseState.optional = !0, this;
    }, c.prototype.def = function (e) {
      var t = this._baseState;
      return o(null === t.default), t.default = e, t.optional = !0, this;
    }, c.prototype.explicit = function (e) {
      var t = this._baseState;
      return o(null === t.explicit && null === t.implicit), t.explicit = e, this;
    }, c.prototype.implicit = function (e) {
      var t = this._baseState;
      return o(null === t.explicit && null === t.implicit), t.implicit = e, this;
    }, c.prototype.obj = function () {
      var e = this._baseState,
          t = Array.prototype.slice.call(arguments);
      return e.obj = !0, 0 !== t.length && this._useArgs(t), this;
    }, c.prototype.key = function (e) {
      var t = this._baseState;
      return o(null === t.key), t.key = e, this;
    }, c.prototype.any = function () {
      return this._baseState.any = !0, this;
    }, c.prototype.choice = function (e) {
      var t = this._baseState;
      return o(null === t.choice), t.choice = e, this._useArgs(Object.keys(e).map(function (t) {
        return e[t];
      })), this;
    }, c.prototype.contains = function (e) {
      var t = this._baseState;
      return o(null === t.use), t.contains = e, this;
    }, c.prototype._decode = function (e, t) {
      var r = this._baseState;
      if (null === r.parent) return e.wrapResult(r.children[0]._decode(e, t));
      var n,
          i = r.default,
          o = !0,
          a = null;

      if (null !== r.key && (a = e.enterKey(r.key)), r.optional) {
        var f = null;

        if (null !== r.explicit ? f = r.explicit : null !== r.implicit ? f = r.implicit : null !== r.tag && (f = r.tag), null !== f || r.any) {
          if (o = this._peekTag(e, f, r.any), e.isError(o)) return o;
        } else {
          var c = e.save();

          try {
            null === r.choice ? this._decodeGeneric(r.tag, e, t) : this._decodeChoice(e, t), o = !0;
          } catch (e) {
            o = !1;
          }

          e.restore(c);
        }
      }

      if (r.obj && o && (n = e.enterObject()), o) {
        if (null !== r.explicit) {
          var u = this._decodeTag(e, r.explicit);

          if (e.isError(u)) return u;
          e = u;
        }

        var h = e.offset;

        if (null === r.use && null === r.choice) {
          if (r.any) c = e.save();

          var d = this._decodeTag(e, null !== r.implicit ? r.implicit : r.tag, r.any);

          if (e.isError(d)) return d;
          r.any ? i = e.raw(c) : e = d;
        }

        if (t && t.track && null !== r.tag && t.track(e.path(), h, e.length, "tagged"), t && t.track && null !== r.tag && t.track(e.path(), e.offset, e.length, "content"), i = r.any ? i : null === r.choice ? this._decodeGeneric(r.tag, e, t) : this._decodeChoice(e, t), e.isError(i)) return i;

        if (r.any || null !== r.choice || null === r.children || r.children.forEach(function (r) {
          r._decode(e, t);
        }), r.contains && ("octstr" === r.tag || "bitstr" === r.tag)) {
          var l = new s(i);
          i = this._getUse(r.contains, e._reporterState.obj)._decode(l, t);
        }
      }

      return r.obj && o && (i = e.leaveObject(n)), null === r.key || null === i && !0 !== o ? null !== a && e.exitKey(a) : e.leaveKey(a, r.key, i), i;
    }, c.prototype._decodeGeneric = function (e, t, r) {
      var n = this._baseState;
      return "seq" === e || "set" === e ? null : "seqof" === e || "setof" === e ? this._decodeList(t, e, n.args[0], r) : /str$/.test(e) ? this._decodeStr(t, e, r) : "objid" === e && n.args ? this._decodeObjid(t, n.args[0], n.args[1], r) : "objid" === e ? this._decodeObjid(t, null, null, r) : "gentime" === e || "utctime" === e ? this._decodeTime(t, e, r) : "null_" === e ? this._decodeNull(t, r) : "bool" === e ? this._decodeBool(t, r) : "objDesc" === e ? this._decodeStr(t, e, r) : "int" === e || "enum" === e ? this._decodeInt(t, n.args && n.args[0], r) : null !== n.use ? this._getUse(n.use, t._reporterState.obj)._decode(t, r) : t.error("unknown tag: " + e);
    }, c.prototype._getUse = function (e, t) {
      var r = this._baseState;
      return r.useDecoder = this._use(e, t), o(null === r.useDecoder._baseState.parent), r.useDecoder = r.useDecoder._baseState.children[0], r.implicit !== r.useDecoder._baseState.implicit && (r.useDecoder = r.useDecoder.clone(), r.useDecoder._baseState.implicit = r.implicit), r.useDecoder;
    }, c.prototype._decodeChoice = function (e, t) {
      var r = this._baseState,
          n = null,
          i = !1;
      return Object.keys(r.choice).some(function (s) {
        var o = e.save(),
            a = r.choice[s];

        try {
          var f = a._decode(e, t);

          if (e.isError(f)) return !1;
          n = {
            type: s,
            value: f
          }, i = !0;
        } catch (t) {
          return e.restore(o), !1;
        }

        return !0;
      }, this), i ? n : e.error("Choice not matched");
    }, c.prototype._createEncoderBuffer = function (e) {
      return new i(e, this.reporter);
    }, c.prototype._encode = function (e, t, r) {
      var n = this._baseState;

      if (null === n.default || n.default !== e) {
        var i = this._encodeValue(e, t, r);

        if (void 0 !== i && !this._skipDefault(i, t, r)) return i;
      }
    }, c.prototype._encodeValue = function (e, t, r) {
      var i = this._baseState;
      if (null === i.parent) return i.children[0]._encode(e, t || new n());
      var s = null;

      if (this.reporter = t, i.optional && void 0 === e) {
        if (null === i.default) return;
        e = i.default;
      }

      var o = null,
          a = !1;
      if (i.any) s = this._createEncoderBuffer(e);else if (i.choice) s = this._encodeChoice(e, t);else if (i.contains) o = this._getUse(i.contains, r)._encode(e, t), a = !0;else if (i.children) o = i.children.map(function (r) {
        if ("null_" === r._baseState.tag) return r._encode(null, t, e);
        if (null === r._baseState.key) return t.error("Child should have a key");
        var n = t.enterKey(r._baseState.key);
        if ("object" != typeof e) return t.error("Child expected, but input is not object");

        var i = r._encode(e[r._baseState.key], t, e);

        return t.leaveKey(n), i;
      }, this).filter(function (e) {
        return e;
      }), o = this._createEncoderBuffer(o);else if ("seqof" === i.tag || "setof" === i.tag) {
        if (!i.args || 1 !== i.args.length) return t.error("Too many args for : " + i.tag);
        if (!Array.isArray(e)) return t.error("seqof/setof, but data is not Array");
        var f = this.clone();
        f._baseState.implicit = null, o = this._createEncoderBuffer(e.map(function (r) {
          var n = this._baseState;
          return this._getUse(n.args[0], e)._encode(r, t);
        }, f));
      } else null !== i.use ? s = this._getUse(i.use, r)._encode(e, t) : (o = this._encodePrimitive(i.tag, e), a = !0);

      if (!i.any && null === i.choice) {
        var c = null !== i.implicit ? i.implicit : i.tag,
            u = null === i.implicit ? "universal" : "context";
        null === c ? null === i.use && t.error("Tag could be omitted only for .use()") : null === i.use && (s = this._encodeComposite(c, a, u, o));
      }

      return null !== i.explicit && (s = this._encodeComposite(i.explicit, !1, "context", s)), s;
    }, c.prototype._encodeChoice = function (e, t) {
      var r = this._baseState,
          n = r.choice[e.type];
      return n || o(!1, e.type + " not found in " + JSON.stringify(Object.keys(r.choice))), n._encode(e.value, t);
    }, c.prototype._encodePrimitive = function (e, t) {
      var r = this._baseState;
      if (/str$/.test(e)) return this._encodeStr(t, e);
      if ("objid" === e && r.args) return this._encodeObjid(t, r.reverseArgs[0], r.args[1]);
      if ("objid" === e) return this._encodeObjid(t, null, null);
      if ("gentime" === e || "utctime" === e) return this._encodeTime(t, e);
      if ("null_" === e) return this._encodeNull();
      if ("int" === e || "enum" === e) return this._encodeInt(t, r.args && r.reverseArgs[0]);
      if ("bool" === e) return this._encodeBool(t);
      if ("objDesc" === e) return this._encodeStr(t, e);
      throw new Error("Unsupported tag: " + e);
    }, c.prototype._isNumstr = function (e) {
      return /^[0-9 ]*$/.test(e);
    }, c.prototype._isPrintstr = function (e) {
      return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(e);
    };
  }, function (e, t, r) {
    var n = r(2);

    function i(e) {
      this._reporterState = {
        obj: null,
        path: [],
        options: e || {},
        errors: []
      };
    }

    function s(e, t) {
      this.path = e, this.rethrow(t);
    }

    t.Reporter = i, i.prototype.isError = function (e) {
      return e instanceof s;
    }, i.prototype.save = function () {
      var e = this._reporterState;
      return {
        obj: e.obj,
        pathLen: e.path.length
      };
    }, i.prototype.restore = function (e) {
      var t = this._reporterState;
      t.obj = e.obj, t.path = t.path.slice(0, e.pathLen);
    }, i.prototype.enterKey = function (e) {
      return this._reporterState.path.push(e);
    }, i.prototype.exitKey = function (e) {
      var t = this._reporterState;
      t.path = t.path.slice(0, e - 1);
    }, i.prototype.leaveKey = function (e, t, r) {
      var n = this._reporterState;
      this.exitKey(e), null !== n.obj && (n.obj[t] = r);
    }, i.prototype.path = function () {
      return this._reporterState.path.join("/");
    }, i.prototype.enterObject = function () {
      var e = this._reporterState,
          t = e.obj;
      return e.obj = {}, t;
    }, i.prototype.leaveObject = function (e) {
      var t = this._reporterState,
          r = t.obj;
      return t.obj = e, r;
    }, i.prototype.error = function (e) {
      var t,
          r = this._reporterState,
          n = e instanceof s;
      if (t = n ? e : new s(r.path.map(function (e) {
        return "[" + JSON.stringify(e) + "]";
      }).join(""), e.message || e, e.stack), !r.options.partial) throw t;
      return n || r.errors.push(t), t;
    }, i.prototype.wrapResult = function (e) {
      var t = this._reporterState;
      return t.options.partial ? {
        result: this.isError(e) ? null : e,
        errors: t.errors
      } : e;
    }, n(s, Error), s.prototype.rethrow = function (e) {
      if (this.message = e + " at: " + (this.path || "(shallow)"), Error.captureStackTrace && Error.captureStackTrace(this, s), !this.stack) try {
        throw new Error(this.message);
      } catch (e) {
        this.stack = e.stack;
      }
      return this;
    };
  }, function (e, t) {
    var r = [].indexOf;

    e.exports = function (e, t) {
      if (r) return e.indexOf(t);

      for (var n = 0; n < e.length; ++n) {
        if (e[n] === t) return n;
      }

      return -1;
    };
  }, function (module, exports, __webpack_require__) {
    var indexOf = __webpack_require__(173),
        Object_keys = function Object_keys(e) {
      if (Object.keys) return Object.keys(e);
      var t = [];

      for (var r in e) {
        t.push(r);
      }

      return t;
    },
        forEach = function forEach(e, t) {
      if (e.forEach) return e.forEach(t);

      for (var r = 0; r < e.length; r++) {
        t(e[r], r, e);
      }
    },
        defineProp = function () {
      try {
        return Object.defineProperty({}, "_", {}), function (e, t, r) {
          Object.defineProperty(e, t, {
            writable: !0,
            enumerable: !1,
            configurable: !0,
            value: r
          });
        };
      } catch (e) {
        return function (e, t, r) {
          e[t] = r;
        };
      }
    }(),
        globals = ["Array", "Boolean", "Date", "Error", "EvalError", "Function", "Infinity", "JSON", "Math", "NaN", "Number", "Object", "RangeError", "ReferenceError", "RegExp", "String", "SyntaxError", "TypeError", "URIError", "decodeURI", "decodeURIComponent", "encodeURI", "encodeURIComponent", "escape", "eval", "isFinite", "isNaN", "parseFloat", "parseInt", "undefined", "unescape"];

    function Context() {}

    Context.prototype = {};

    var Script = exports.Script = function (e) {
      if (!(this instanceof Script)) return new Script(e);
      this.code = e;
    };

    Script.prototype.runInContext = function (e) {
      if (!(e instanceof Context)) throw new TypeError("needs a 'context' argument.");
      var t = document.createElement("iframe");
      t.style || (t.style = {}), t.style.display = "none", document.body.appendChild(t);
      var r = t.contentWindow,
          n = r.eval,
          i = r.execScript;
      !n && i && (i.call(r, "null"), n = r.eval), forEach(Object_keys(e), function (t) {
        r[t] = e[t];
      }), forEach(globals, function (t) {
        e[t] && (r[t] = e[t]);
      });
      var s = Object_keys(r),
          o = n.call(r, this.code);
      return forEach(Object_keys(r), function (t) {
        (t in e || -1 === indexOf(s, t)) && (e[t] = r[t]);
      }), forEach(globals, function (t) {
        t in e || defineProp(e, t, r[t]);
      }), document.body.removeChild(t), o;
    }, Script.prototype.runInThisContext = function () {
      return eval(this.code);
    }, Script.prototype.runInNewContext = function (e) {
      var t = Script.createContext(e),
          r = this.runInContext(t);
      return forEach(Object_keys(t), function (r) {
        e[r] = t[r];
      }), r;
    }, forEach(Object_keys(Script.prototype), function (e) {
      exports[e] = Script[e] = function (t) {
        var r = Script(t);
        return r[e].apply(r, [].slice.call(arguments, 1));
      };
    }), exports.createScript = function (e) {
      return exports.Script(e);
    }, exports.createContext = Script.createContext = function (e) {
      var t = new Context();
      return "object" == typeof e && forEach(Object_keys(e), function (r) {
        t[r] = e[r];
      }), t;
    };
  }, function (e, t, r) {
    var n = r(26),
        i = r(2);

    function s(e, t) {
      this.name = e, this.body = t, this.decoders = {}, this.encoders = {};
    }

    t.define = function (e, t) {
      return new s(e, t);
    }, s.prototype._createNamed = function (e) {
      var t;

      try {
        t = r(174).runInThisContext("(function " + this.name + "(entity) {\n  this._initNamed(entity);\n})");
      } catch (e) {
        t = function t(e) {
          this._initNamed(e);
        };
      }

      return i(t, e), t.prototype._initNamed = function (t) {
        e.call(this, t);
      }, new t(this);
    }, s.prototype._getDecoder = function (e) {
      return e = e || "der", this.decoders.hasOwnProperty(e) || (this.decoders[e] = this._createNamed(n.decoders[e])), this.decoders[e];
    }, s.prototype.decode = function (e, t, r) {
      return this._getDecoder(t).decode(e, r);
    }, s.prototype._getEncoder = function (e) {
      return e = e || "der", this.encoders.hasOwnProperty(e) || (this.encoders[e] = this._createNamed(n.encoders[e])), this.encoders[e];
    }, s.prototype.encode = function (e, t, r) {
      return this._getEncoder(t).encode(e, r);
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(26);
    t.certificate = r(165);
    var i = n.define("RSAPrivateKey", function () {
      this.seq().obj(this.key("version").int(), this.key("modulus").int(), this.key("publicExponent").int(), this.key("privateExponent").int(), this.key("prime1").int(), this.key("prime2").int(), this.key("exponent1").int(), this.key("exponent2").int(), this.key("coefficient").int());
    });
    t.RSAPrivateKey = i;
    var s = n.define("RSAPublicKey", function () {
      this.seq().obj(this.key("modulus").int(), this.key("publicExponent").int());
    });
    t.RSAPublicKey = s;
    var o = n.define("SubjectPublicKeyInfo", function () {
      this.seq().obj(this.key("algorithm").use(a), this.key("subjectPublicKey").bitstr());
    });
    t.PublicKey = o;
    var a = n.define("AlgorithmIdentifier", function () {
      this.seq().obj(this.key("algorithm").objid(), this.key("none").null_().optional(), this.key("curve").objid().optional(), this.key("params").seq().obj(this.key("p").int(), this.key("q").int(), this.key("g").int()).optional());
    }),
        f = n.define("PrivateKeyInfo", function () {
      this.seq().obj(this.key("version").int(), this.key("algorithm").use(a), this.key("subjectPrivateKey").octstr());
    });
    t.PrivateKey = f;
    var c = n.define("EncryptedPrivateKeyInfo", function () {
      this.seq().obj(this.key("algorithm").seq().obj(this.key("id").objid(), this.key("decrypt").seq().obj(this.key("kde").seq().obj(this.key("id").objid(), this.key("kdeparams").seq().obj(this.key("salt").octstr(), this.key("iters").int())), this.key("cipher").seq().obj(this.key("algo").objid(), this.key("iv").octstr()))), this.key("subjectPrivateKey").octstr());
    });
    t.EncryptedPrivateKey = c;
    var u = n.define("DSAPrivateKey", function () {
      this.seq().obj(this.key("version").int(), this.key("p").int(), this.key("q").int(), this.key("g").int(), this.key("pub_key").int(), this.key("priv_key").int());
    });
    t.DSAPrivateKey = u, t.DSAparam = n.define("DSAparam", function () {
      this.int();
    });
    var h = n.define("ECPrivateKey", function () {
      this.seq().obj(this.key("version").int(), this.key("privateKey").octstr(), this.key("parameters").optional().explicit(0).use(d), this.key("publicKey").optional().explicit(1).bitstr());
    });
    t.ECPrivateKey = h;
    var d = n.define("ECParameters", function () {
      this.choice({
        namedCurve: this.objid()
      });
    });
    t.signature = n.define("signature", function () {
      this.seq().obj(this.key("r").int(), this.key("s").int());
    });
  }, function (e, t, r) {
    "use strict";

    var n = r(8),
        i = r(11).utils,
        s = i.assert,
        o = i.cachedProperty,
        a = i.parseBytes;

    function f(e, t) {
      this.eddsa = e, "object" != typeof t && (t = a(t)), Array.isArray(t) && (t = {
        R: t.slice(0, e.encodingLength),
        S: t.slice(e.encodingLength)
      }), s(t.R && t.S, "Signature without R or S"), e.isPoint(t.R) && (this._R = t.R), t.S instanceof n && (this._S = t.S), this._Rencoded = Array.isArray(t.R) ? t.R : t.Rencoded, this._Sencoded = Array.isArray(t.S) ? t.S : t.Sencoded;
    }

    o(f, "S", function () {
      return this.eddsa.decodeInt(this.Sencoded());
    }), o(f, "R", function () {
      return this.eddsa.decodePoint(this.Rencoded());
    }), o(f, "Rencoded", function () {
      return this.eddsa.encodePoint(this.R());
    }), o(f, "Sencoded", function () {
      return this.eddsa.encodeInt(this.S());
    }), f.prototype.toBytes = function () {
      return this.Rencoded().concat(this.Sencoded());
    }, f.prototype.toHex = function () {
      return i.encode(this.toBytes(), "hex").toUpperCase();
    }, e.exports = f;
  }, function (e, t, r) {
    "use strict";

    var n = r(11).utils,
        i = n.assert,
        s = n.parseBytes,
        o = n.cachedProperty;

    function a(e, t) {
      this.eddsa = e, this._secret = s(t.secret), e.isPoint(t.pub) ? this._pub = t.pub : this._pubBytes = s(t.pub);
    }

    a.fromPublic = function (e, t) {
      return t instanceof a ? t : new a(e, {
        pub: t
      });
    }, a.fromSecret = function (e, t) {
      return t instanceof a ? t : new a(e, {
        secret: t
      });
    }, a.prototype.secret = function () {
      return this._secret;
    }, o(a, "pubBytes", function () {
      return this.eddsa.encodePoint(this.pub());
    }), o(a, "pub", function () {
      return this._pubBytes ? this.eddsa.decodePoint(this._pubBytes) : this.eddsa.g.mul(this.priv());
    }), o(a, "privBytes", function () {
      var e = this.eddsa,
          t = this.hash(),
          r = e.encodingLength - 1,
          n = t.slice(0, e.encodingLength);
      return n[0] &= 248, n[r] &= 127, n[r] |= 64, n;
    }), o(a, "priv", function () {
      return this.eddsa.decodeInt(this.privBytes());
    }), o(a, "hash", function () {
      return this.eddsa.hash().update(this.secret()).digest();
    }), o(a, "messagePrefix", function () {
      return this.hash().slice(this.eddsa.encodingLength);
    }), a.prototype.sign = function (e) {
      return i(this._secret, "KeyPair can only verify"), this.eddsa.sign(e, this);
    }, a.prototype.verify = function (e, t) {
      return this.eddsa.verify(e, t, this);
    }, a.prototype.getSecret = function (e) {
      return i(this._secret, "KeyPair is public only"), n.encode(this.secret(), e);
    }, a.prototype.getPublic = function (e) {
      return n.encode(this.pubBytes(), e);
    }, e.exports = a;
  }, function (e, t, r) {
    "use strict";

    var n = r(47),
        i = r(11),
        s = i.utils,
        o = s.assert,
        a = s.parseBytes,
        f = r(178),
        c = r(177);

    function u(e) {
      if (o("ed25519" === e, "only tested with ed25519 so far"), !(this instanceof u)) return new u(e);
      e = i.curves[e].curve;
      this.curve = e, this.g = e.g, this.g.precompute(e.n.bitLength() + 1), this.pointClass = e.point().constructor, this.encodingLength = Math.ceil(e.n.bitLength() / 8), this.hash = n.sha512;
    }

    e.exports = u, u.prototype.sign = function (e, t) {
      e = a(e);
      var r = this.keyFromSecret(t),
          n = this.hashInt(r.messagePrefix(), e),
          i = this.g.mul(n),
          s = this.encodePoint(i),
          o = this.hashInt(s, r.pubBytes(), e).mul(r.priv()),
          f = n.add(o).umod(this.curve.n);
      return this.makeSignature({
        R: i,
        S: f,
        Rencoded: s
      });
    }, u.prototype.verify = function (e, t, r) {
      e = a(e), t = this.makeSignature(t);
      var n = this.keyFromPublic(r),
          i = this.hashInt(t.Rencoded(), n.pubBytes(), e),
          s = this.g.mul(t.S());
      return t.R().add(n.pub().mul(i)).eq(s);
    }, u.prototype.hashInt = function () {
      for (var e = this.hash(), t = 0; t < arguments.length; t++) {
        e.update(arguments[t]);
      }

      return s.intFromLE(e.digest()).umod(this.curve.n);
    }, u.prototype.keyFromPublic = function (e) {
      return f.fromPublic(this, e);
    }, u.prototype.keyFromSecret = function (e) {
      return f.fromSecret(this, e);
    }, u.prototype.makeSignature = function (e) {
      return e instanceof c ? e : new c(this, e);
    }, u.prototype.encodePoint = function (e) {
      var t = e.getY().toArray("le", this.encodingLength);
      return t[this.encodingLength - 1] |= e.getX().isOdd() ? 128 : 0, t;
    }, u.prototype.decodePoint = function (e) {
      var t = (e = s.parseBytes(e)).length - 1,
          r = e.slice(0, t).concat(-129 & e[t]),
          n = 0 != (128 & e[t]),
          i = s.intFromLE(r);
      return this.curve.pointFromY(i, n);
    }, u.prototype.encodeInt = function (e) {
      return e.toArray("le", this.encodingLength);
    }, u.prototype.decodeInt = function (e) {
      return s.intFromLE(e);
    }, u.prototype.isPoint = function (e) {
      return e instanceof this.pointClass;
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(8),
        i = r(11).utils,
        s = i.assert;

    function o(e, t) {
      if (e instanceof o) return e;
      this._importDER(e, t) || (s(e.r && e.s, "Signature without r or s"), this.r = new n(e.r, 16), this.s = new n(e.s, 16), void 0 === e.recoveryParam ? this.recoveryParam = null : this.recoveryParam = e.recoveryParam);
    }

    function a(e, t) {
      var r = e[t.place++];
      if (!(128 & r)) return r;

      for (var n = 15 & r, i = 0, s = 0, o = t.place; s < n; s++, o++) {
        i <<= 8, i |= e[o];
      }

      return t.place = o, i;
    }

    function f(e) {
      for (var t = 0, r = e.length - 1; !e[t] && !(128 & e[t + 1]) && t < r;) {
        t++;
      }

      return 0 === t ? e : e.slice(t);
    }

    function c(e, t) {
      if (t < 128) e.push(t);else {
        var r = 1 + (Math.log(t) / Math.LN2 >>> 3);

        for (e.push(128 | r); --r;) {
          e.push(t >>> (r << 3) & 255);
        }

        e.push(t);
      }
    }

    e.exports = o, o.prototype._importDER = function (e, t) {
      e = i.toArray(e, t);
      var r = new function () {
        this.place = 0;
      }();
      if (48 !== e[r.place++]) return !1;
      if (a(e, r) + r.place !== e.length) return !1;
      if (2 !== e[r.place++]) return !1;
      var s = a(e, r),
          o = e.slice(r.place, s + r.place);
      if (r.place += s, 2 !== e[r.place++]) return !1;
      var f = a(e, r);
      if (e.length !== f + r.place) return !1;
      var c = e.slice(r.place, f + r.place);
      return 0 === o[0] && 128 & o[1] && (o = o.slice(1)), 0 === c[0] && 128 & c[1] && (c = c.slice(1)), this.r = new n(o), this.s = new n(c), this.recoveryParam = null, !0;
    }, o.prototype.toDER = function (e) {
      var t = this.r.toArray(),
          r = this.s.toArray();

      for (128 & t[0] && (t = [0].concat(t)), 128 & r[0] && (r = [0].concat(r)), t = f(t), r = f(r); !(r[0] || 128 & r[1]);) {
        r = r.slice(1);
      }

      var n = [2];
      c(n, t.length), (n = n.concat(t)).push(2), c(n, r.length);
      var s = n.concat(r),
          o = [48];
      return c(o, s.length), o = o.concat(s), i.encode(o, e);
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(8),
        i = r(11).utils.assert;

    function s(e, t) {
      this.ec = e, this.priv = null, this.pub = null, t.priv && this._importPrivate(t.priv, t.privEnc), t.pub && this._importPublic(t.pub, t.pubEnc);
    }

    e.exports = s, s.fromPublic = function (e, t, r) {
      return t instanceof s ? t : new s(e, {
        pub: t,
        pubEnc: r
      });
    }, s.fromPrivate = function (e, t, r) {
      return t instanceof s ? t : new s(e, {
        priv: t,
        privEnc: r
      });
    }, s.prototype.validate = function () {
      var e = this.getPublic();
      return e.isInfinity() ? {
        result: !1,
        reason: "Invalid public key"
      } : e.validate() ? e.mul(this.ec.curve.n).isInfinity() ? {
        result: !0,
        reason: null
      } : {
        result: !1,
        reason: "Public key * N != O"
      } : {
        result: !1,
        reason: "Public key is not a point"
      };
    }, s.prototype.getPublic = function (e, t) {
      return "string" == typeof e && (t = e, e = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), t ? this.pub.encode(t, e) : this.pub;
    }, s.prototype.getPrivate = function (e) {
      return "hex" === e ? this.priv.toString(16, 2) : this.priv;
    }, s.prototype._importPrivate = function (e, t) {
      this.priv = new n(e, t || 16), this.priv = this.priv.umod(this.ec.curve.n);
    }, s.prototype._importPublic = function (e, t) {
      if (e.x || e.y) return "mont" === this.ec.curve.type ? i(e.x, "Need x coordinate") : "short" !== this.ec.curve.type && "edwards" !== this.ec.curve.type || i(e.x && e.y, "Need both x and y coordinate"), void (this.pub = this.ec.curve.point(e.x, e.y));
      this.pub = this.ec.curve.decodePoint(e, t);
    }, s.prototype.derive = function (e) {
      return e.mul(this.priv).getX();
    }, s.prototype.sign = function (e, t, r) {
      return this.ec.sign(e, this, t, r);
    }, s.prototype.verify = function (e, t) {
      return this.ec.verify(e, t, this);
    }, s.prototype.inspect = function () {
      return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(47),
        i = r(86),
        s = r(13);

    function o(e) {
      if (!(this instanceof o)) return new o(e);
      this.hash = e.hash, this.predResist = !!e.predResist, this.outLen = this.hash.outSize, this.minEntropy = e.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
      var t = i.toArray(e.entropy, e.entropyEnc || "hex"),
          r = i.toArray(e.nonce, e.nonceEnc || "hex"),
          n = i.toArray(e.pers, e.persEnc || "hex");
      s(t.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._init(t, r, n);
    }

    e.exports = o, o.prototype._init = function (e, t, r) {
      var n = e.concat(t).concat(r);
      this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);

      for (var i = 0; i < this.V.length; i++) {
        this.K[i] = 0, this.V[i] = 1;
      }

      this._update(n), this._reseed = 1, this.reseedInterval = 281474976710656;
    }, o.prototype._hmac = function () {
      return new n.hmac(this.hash, this.K);
    }, o.prototype._update = function (e) {
      var t = this._hmac().update(this.V).update([0]);

      e && (t = t.update(e)), this.K = t.digest(), this.V = this._hmac().update(this.V).digest(), e && (this.K = this._hmac().update(this.V).update([1]).update(e).digest(), this.V = this._hmac().update(this.V).digest());
    }, o.prototype.reseed = function (e, t, r, n) {
      "string" != typeof t && (n = r, r = t, t = null), e = i.toArray(e, t), r = i.toArray(r, n), s(e.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._update(e.concat(r || [])), this._reseed = 1;
    }, o.prototype.generate = function (e, t, r, n) {
      if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
      "string" != typeof t && (n = r, r = t, t = null), r && (r = i.toArray(r, n || "hex"), this._update(r));

      for (var s = []; s.length < e;) {
        this.V = this._hmac().update(this.V).digest(), s = s.concat(this.V);
      }

      var o = s.slice(0, e);
      return this._update(r), this._reseed++, i.encode(o, t);
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(8),
        i = r(182),
        s = r(11),
        o = s.utils.assert,
        a = r(181),
        f = r(180);

    function c(e) {
      if (!(this instanceof c)) return new c(e);
      "string" == typeof e && (o(s.curves.hasOwnProperty(e), "Unknown curve " + e), e = s.curves[e]), e instanceof s.curves.PresetCurve && (e = {
        curve: e
      }), this.curve = e.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = e.curve.g, this.g.precompute(e.curve.n.bitLength() + 1), this.hash = e.hash || e.curve.hash;
    }

    e.exports = c, c.prototype.keyPair = function (e) {
      return new a(this, e);
    }, c.prototype.keyFromPrivate = function (e, t) {
      return a.fromPrivate(this, e, t);
    }, c.prototype.keyFromPublic = function (e, t) {
      return a.fromPublic(this, e, t);
    }, c.prototype.genKeyPair = function (e) {
      e || (e = {});

      for (var t = new i({
        hash: this.hash,
        pers: e.pers,
        persEnc: e.persEnc || "utf8",
        entropy: e.entropy || s.rand(this.hash.hmacStrength),
        entropyEnc: e.entropy && e.entropyEnc || "utf8",
        nonce: this.n.toArray()
      }), r = this.n.byteLength(), o = this.n.sub(new n(2));;) {
        var a = new n(t.generate(r));
        if (!(a.cmp(o) > 0)) return a.iaddn(1), this.keyFromPrivate(a);
      }
    }, c.prototype._truncateToN = function (e, t) {
      var r = 8 * e.byteLength() - this.n.bitLength();
      return r > 0 && (e = e.ushrn(r)), !t && e.cmp(this.n) >= 0 ? e.sub(this.n) : e;
    }, c.prototype.sign = function (e, t, r, s) {
      "object" == typeof r && (s = r, r = null), s || (s = {}), t = this.keyFromPrivate(t, r), e = this._truncateToN(new n(e, 16));

      for (var o = this.n.byteLength(), a = t.getPrivate().toArray("be", o), c = e.toArray("be", o), u = new i({
        hash: this.hash,
        entropy: a,
        nonce: c,
        pers: s.pers,
        persEnc: s.persEnc || "utf8"
      }), h = this.n.sub(new n(1)), d = 0;; d++) {
        var l = s.k ? s.k(d) : new n(u.generate(this.n.byteLength()));

        if (!((l = this._truncateToN(l, !0)).cmpn(1) <= 0 || l.cmp(h) >= 0)) {
          var p = this.g.mul(l);

          if (!p.isInfinity()) {
            var b = p.getX(),
                _ = b.umod(this.n);

            if (0 !== _.cmpn(0)) {
              var g = l.invm(this.n).mul(_.mul(t.getPrivate()).iadd(e));

              if (0 !== (g = g.umod(this.n)).cmpn(0)) {
                var v = (p.getY().isOdd() ? 1 : 0) | (0 !== b.cmp(_) ? 2 : 0);
                return s.canonical && g.cmp(this.nh) > 0 && (g = this.n.sub(g), v ^= 1), new f({
                  r: _,
                  s: g,
                  recoveryParam: v
                });
              }
            }
          }
        }
      }
    }, c.prototype.verify = function (e, t, r, i) {
      e = this._truncateToN(new n(e, 16)), r = this.keyFromPublic(r, i);
      var s = (t = new f(t, "hex")).r,
          o = t.s;
      if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return !1;
      if (o.cmpn(1) < 0 || o.cmp(this.n) >= 0) return !1;
      var a,
          c = o.invm(this.n),
          u = c.mul(e).umod(this.n),
          h = c.mul(s).umod(this.n);
      return this.curve._maxwellTrick ? !(a = this.g.jmulAdd(u, r.getPublic(), h)).isInfinity() && a.eqXToP(s) : !(a = this.g.mulAdd(u, r.getPublic(), h)).isInfinity() && 0 === a.getX().umod(this.n).cmp(s);
    }, c.prototype.recoverPubKey = function (e, t, r, i) {
      o((3 & r) === r, "The recovery param is more than two bits"), t = new f(t, i);
      var s = this.n,
          a = new n(e),
          c = t.r,
          u = t.s,
          h = 1 & r,
          d = r >> 1;
      if (c.cmp(this.curve.p.umod(this.curve.n)) >= 0 && d) throw new Error("Unable to find sencond key candinate");
      c = d ? this.curve.pointFromX(c.add(this.curve.n), h) : this.curve.pointFromX(c, h);
      var l = t.r.invm(s),
          p = s.sub(a).mul(l).umod(s),
          b = u.mul(l).umod(s);
      return this.g.mulAdd(p, c, b);
    }, c.prototype.getKeyRecoveryParam = function (e, t, r, n) {
      if (null !== (t = new f(t, n)).recoveryParam) return t.recoveryParam;

      for (var i = 0; i < 4; i++) {
        var s;

        try {
          s = this.recoverPubKey(e, t, i);
        } catch (e) {
          continue;
        }

        if (s.eq(r)) return i;
      }

      throw new Error("Unable to find valid recovery factor");
    };
  }, function (e, t) {
    e.exports = {
      doubles: {
        step: 4,
        points: [["e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a", "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"], ["8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508", "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"], ["175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739", "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"], ["363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640", "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"], ["8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c", "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"], ["723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda", "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"], ["eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa", "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"], ["100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0", "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"], ["e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d", "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"], ["feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d", "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"], ["da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1", "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"], ["53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0", "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"], ["8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047", "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"], ["385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862", "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"], ["6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7", "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"], ["3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd", "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"], ["85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83", "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"], ["948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a", "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"], ["6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8", "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"], ["e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d", "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"], ["e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725", "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"], ["213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754", "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"], ["4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c", "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"], ["fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6", "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"], ["76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39", "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"], ["c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891", "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"], ["d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b", "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"], ["b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03", "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"], ["e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d", "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"], ["a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070", "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"], ["90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4", "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"], ["8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da", "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"], ["e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11", "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"], ["8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e", "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"], ["e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41", "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"], ["b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef", "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"], ["d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8", "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"], ["324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d", "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"], ["4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96", "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"], ["9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd", "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"], ["6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5", "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"], ["a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266", "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"], ["7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71", "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"], ["928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac", "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"], ["85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751", "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"], ["ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e", "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"], ["827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241", "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"], ["eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3", "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"], ["e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f", "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"], ["1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19", "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"], ["146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be", "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"], ["fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9", "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"], ["da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2", "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"], ["a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13", "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"], ["174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c", "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"], ["959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba", "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"], ["d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151", "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"], ["64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073", "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"], ["8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458", "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"], ["13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b", "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"], ["bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366", "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"], ["8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa", "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"], ["8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0", "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"], ["dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787", "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"], ["f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e", "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"]]
      },
      naf: {
        wnd: 7,
        points: [["f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9", "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"], ["2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4", "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"], ["5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc", "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"], ["acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe", "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"], ["774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb", "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"], ["f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8", "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"], ["d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e", "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"], ["defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34", "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"], ["2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c", "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"], ["352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5", "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"], ["2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f", "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"], ["9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714", "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"], ["daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729", "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"], ["c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db", "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"], ["6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4", "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"], ["1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5", "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"], ["605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479", "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"], ["62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d", "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"], ["80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f", "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"], ["7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb", "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"], ["d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9", "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"], ["49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963", "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"], ["77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74", "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"], ["f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530", "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"], ["463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b", "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"], ["f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247", "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"], ["caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1", "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"], ["2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120", "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"], ["7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435", "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"], ["754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18", "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"], ["e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8", "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"], ["186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb", "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"], ["df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f", "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"], ["5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143", "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"], ["290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba", "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"], ["af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45", "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"], ["766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a", "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"], ["59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e", "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"], ["f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8", "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"], ["7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c", "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"], ["948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519", "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"], ["7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab", "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"], ["3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca", "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"], ["d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf", "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"], ["1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610", "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"], ["733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4", "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"], ["15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c", "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"], ["a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940", "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"], ["e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980", "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"], ["311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3", "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"], ["34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf", "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"], ["f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63", "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"], ["d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448", "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"], ["32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf", "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"], ["7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5", "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"], ["ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6", "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"], ["16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5", "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"], ["eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99", "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"], ["78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51", "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"], ["494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5", "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"], ["a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5", "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"], ["c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997", "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"], ["841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881", "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"], ["5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5", "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"], ["36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66", "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"], ["336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726", "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"], ["8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede", "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"], ["1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94", "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"], ["85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31", "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"], ["29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51", "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"], ["a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252", "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"], ["4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5", "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"], ["d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b", "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"], ["ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4", "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"], ["af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f", "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"], ["e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889", "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"], ["591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246", "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"], ["11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984", "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"], ["3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a", "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"], ["cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030", "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"], ["c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197", "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"], ["c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593", "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"], ["a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef", "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"], ["347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38", "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"], ["da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a", "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"], ["c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111", "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"], ["4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502", "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"], ["3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea", "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"], ["cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26", "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"], ["b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986", "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"], ["d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e", "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"], ["48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4", "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"], ["dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda", "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"], ["6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859", "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"], ["e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f", "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"], ["eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c", "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"], ["13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942", "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"], ["ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a", "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"], ["b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80", "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"], ["ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d", "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"], ["8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1", "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"], ["52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63", "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"], ["e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352", "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"], ["7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193", "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"], ["5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00", "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"], ["32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58", "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"], ["e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7", "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"], ["8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8", "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"], ["4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e", "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"], ["3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d", "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"], ["674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b", "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"], ["d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f", "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"], ["30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6", "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"], ["be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297", "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"], ["93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a", "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"], ["b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c", "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"], ["d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52", "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"], ["d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb", "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"], ["463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065", "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"], ["7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917", "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"], ["74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9", "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"], ["30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3", "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"], ["9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57", "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"], ["176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66", "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"], ["75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8", "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"], ["809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721", "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"], ["1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180", "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"]]
      }
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(14),
        i = r(13);

    function s(e, t, r) {
      if (!(this instanceof s)) return new s(e, t, r);
      this.Hash = e, this.blockSize = e.blockSize / 8, this.outSize = e.outSize / 8, this.inner = null, this.outer = null, this._init(n.toArray(t, r));
    }

    e.exports = s, s.prototype._init = function (e) {
      e.length > this.blockSize && (e = new this.Hash().update(e).digest()), i(e.length <= this.blockSize);

      for (var t = e.length; t < this.blockSize; t++) {
        e.push(0);
      }

      for (t = 0; t < e.length; t++) {
        e[t] ^= 54;
      }

      for (this.inner = new this.Hash().update(e), t = 0; t < e.length; t++) {
        e[t] ^= 106;
      }

      this.outer = new this.Hash().update(e);
    }, s.prototype.update = function (e, t) {
      return this.inner.update(e, t), this;
    }, s.prototype.digest = function (e) {
      return this.outer.update(this.inner.digest()), this.outer.digest(e);
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(14),
        i = r(27),
        s = n.rotl32,
        o = n.sum32,
        a = n.sum32_3,
        f = n.sum32_4,
        c = i.BlockHash;

    function u() {
      if (!(this instanceof u)) return new u();
      c.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.endian = "little";
    }

    function h(e, t, r, n) {
      return e <= 15 ? t ^ r ^ n : e <= 31 ? t & r | ~t & n : e <= 47 ? (t | ~r) ^ n : e <= 63 ? t & n | r & ~n : t ^ (r | ~n);
    }

    function d(e) {
      return e <= 15 ? 0 : e <= 31 ? 1518500249 : e <= 47 ? 1859775393 : e <= 63 ? 2400959708 : 2840853838;
    }

    function l(e) {
      return e <= 15 ? 1352829926 : e <= 31 ? 1548603684 : e <= 47 ? 1836072691 : e <= 63 ? 2053994217 : 0;
    }

    n.inherits(u, c), t.ripemd160 = u, u.blockSize = 512, u.outSize = 160, u.hmacStrength = 192, u.padLength = 64, u.prototype._update = function (e, t) {
      for (var r = this.h[0], n = this.h[1], i = this.h[2], c = this.h[3], u = this.h[4], v = r, m = n, y = i, w = c, k = u, S = 0; S < 80; S++) {
        var E = o(s(f(r, h(S, n, i, c), e[p[S] + t], d(S)), _[S]), u);
        r = u, u = c, c = s(i, 10), i = n, n = E, E = o(s(f(v, h(79 - S, m, y, w), e[b[S] + t], l(S)), g[S]), k), v = k, k = w, w = s(y, 10), y = m, m = E;
      }

      E = a(this.h[1], i, w), this.h[1] = a(this.h[2], c, k), this.h[2] = a(this.h[3], u, v), this.h[3] = a(this.h[4], r, m), this.h[4] = a(this.h[0], n, y), this.h[0] = E;
    }, u.prototype._digest = function (e) {
      return "hex" === e ? n.toHex32(this.h, "little") : n.split32(this.h, "little");
    };
    var p = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13],
        b = [5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11],
        _ = [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6],
        g = [8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11];
  }, function (e, t, r) {
    "use strict";

    var n = r(14),
        i = r(83);

    function s() {
      if (!(this instanceof s)) return new s();
      i.call(this), this.h = [3418070365, 3238371032, 1654270250, 914150663, 2438529370, 812702999, 355462360, 4144912697, 1731405415, 4290775857, 2394180231, 1750603025, 3675008525, 1694076839, 1203062813, 3204075428];
    }

    n.inherits(s, i), e.exports = s, s.blockSize = 1024, s.outSize = 384, s.hmacStrength = 192, s.padLength = 128, s.prototype._digest = function (e) {
      return "hex" === e ? n.toHex32(this.h.slice(0, 12), "big") : n.split32(this.h.slice(0, 12), "big");
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(14),
        i = r(84);

    function s() {
      if (!(this instanceof s)) return new s();
      i.call(this), this.h = [3238371032, 914150663, 812702999, 4144912697, 4290775857, 1750603025, 1694076839, 3204075428];
    }

    n.inherits(s, i), e.exports = s, s.blockSize = 512, s.outSize = 224, s.hmacStrength = 192, s.padLength = 64, s.prototype._digest = function (e) {
      return "hex" === e ? n.toHex32(this.h.slice(0, 7), "big") : n.split32(this.h.slice(0, 7), "big");
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(14),
        i = r(27),
        s = r(85),
        o = n.rotl32,
        a = n.sum32,
        f = n.sum32_5,
        c = s.ft_1,
        u = i.BlockHash,
        h = [1518500249, 1859775393, 2400959708, 3395469782];

    function d() {
      if (!(this instanceof d)) return new d();
      u.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.W = new Array(80);
    }

    n.inherits(d, u), e.exports = d, d.blockSize = 512, d.outSize = 160, d.hmacStrength = 80, d.padLength = 64, d.prototype._update = function (e, t) {
      for (var r = this.W, n = 0; n < 16; n++) {
        r[n] = e[t + n];
      }

      for (; n < r.length; n++) {
        r[n] = o(r[n - 3] ^ r[n - 8] ^ r[n - 14] ^ r[n - 16], 1);
      }

      var i = this.h[0],
          s = this.h[1],
          u = this.h[2],
          d = this.h[3],
          l = this.h[4];

      for (n = 0; n < r.length; n++) {
        var p = ~~(n / 20),
            b = f(o(i, 5), c(p, s, u, d), l, r[n], h[p]);
        l = d, d = u, u = o(s, 30), s = i, i = b;
      }

      this.h[0] = a(this.h[0], i), this.h[1] = a(this.h[1], s), this.h[2] = a(this.h[2], u), this.h[3] = a(this.h[3], d), this.h[4] = a(this.h[4], l);
    }, d.prototype._digest = function (e) {
      return "hex" === e ? n.toHex32(this.h, "big") : n.split32(this.h, "big");
    };
  }, function (e, t, r) {
    "use strict";

    t.sha1 = r(189), t.sha224 = r(188), t.sha256 = r(84), t.sha384 = r(187), t.sha512 = r(83);
  }, function (e, t, r) {
    "use strict";

    var n,
        i = t,
        s = r(47),
        o = r(11),
        a = o.utils.assert;

    function f(e) {
      "short" === e.type ? this.curve = new o.curve.short(e) : "edwards" === e.type ? this.curve = new o.curve.edwards(e) : this.curve = new o.curve.mont(e), this.g = this.curve.g, this.n = this.curve.n, this.hash = e.hash, a(this.g.validate(), "Invalid curve"), a(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
    }

    function c(e, t) {
      Object.defineProperty(i, e, {
        configurable: !0,
        enumerable: !0,
        get: function get() {
          var r = new f(t);
          return Object.defineProperty(i, e, {
            configurable: !0,
            enumerable: !0,
            value: r
          }), r;
        }
      });
    }

    i.PresetCurve = f, c("p192", {
      type: "short",
      prime: "p192",
      p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
      a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
      b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
      n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
      hash: s.sha256,
      gRed: !1,
      g: ["188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012", "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"]
    }), c("p224", {
      type: "short",
      prime: "p224",
      p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
      a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
      b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
      n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
      hash: s.sha256,
      gRed: !1,
      g: ["b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21", "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"]
    }), c("p256", {
      type: "short",
      prime: null,
      p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
      a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
      b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
      n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
      hash: s.sha256,
      gRed: !1,
      g: ["6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296", "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"]
    }), c("p384", {
      type: "short",
      prime: null,
      p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
      a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
      b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
      n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
      hash: s.sha384,
      gRed: !1,
      g: ["aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7", "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"]
    }), c("p521", {
      type: "short",
      prime: null,
      p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
      a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
      b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
      n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
      hash: s.sha512,
      gRed: !1,
      g: ["000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66", "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"]
    }), c("curve25519", {
      type: "mont",
      prime: "p25519",
      p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
      a: "76d06",
      b: "1",
      n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
      hash: s.sha256,
      gRed: !1,
      g: ["9"]
    }), c("ed25519", {
      type: "edwards",
      prime: "p25519",
      p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
      a: "-1",
      c: "1",
      d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
      n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
      hash: s.sha256,
      gRed: !1,
      g: ["216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a", "6666666666666666666666666666666666666666666666666666666666666658"]
    });

    try {
      n = r(184);
    } catch (e) {
      n = void 0;
    }

    c("secp256k1", {
      type: "short",
      prime: "k256",
      p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
      a: "0",
      b: "7",
      n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
      h: "1",
      hash: s.sha256,
      beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
      lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
      basis: [{
        a: "3086d221a7d46bcde86c90e49284eb15",
        b: "-e4437ed6010e88286f547fa90abfe4c3"
      }, {
        a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
        b: "3086d221a7d46bcde86c90e49284eb15"
      }],
      gRed: !1,
      g: ["79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798", "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8", n]
    });
  }, function (e, t, r) {
    "use strict";

    var n = r(37),
        i = r(11),
        s = r(8),
        o = r(2),
        a = n.base,
        f = i.utils.assert;

    function c(e) {
      this.twisted = 1 != (0 | e.a), this.mOneA = this.twisted && -1 == (0 | e.a), this.extended = this.mOneA, a.call(this, "edwards", e), this.a = new s(e.a, 16).umod(this.red.m), this.a = this.a.toRed(this.red), this.c = new s(e.c, 16).toRed(this.red), this.c2 = this.c.redSqr(), this.d = new s(e.d, 16).toRed(this.red), this.dd = this.d.redAdd(this.d), f(!this.twisted || 0 === this.c.fromRed().cmpn(1)), this.oneC = 1 == (0 | e.c);
    }

    function u(e, t, r, n, i) {
      a.BasePoint.call(this, e, "projective"), null === t && null === r && null === n ? (this.x = this.curve.zero, this.y = this.curve.one, this.z = this.curve.one, this.t = this.curve.zero, this.zOne = !0) : (this.x = new s(t, 16), this.y = new s(r, 16), this.z = n ? new s(n, 16) : this.curve.one, this.t = i && new s(i, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.t && !this.t.red && (this.t = this.t.toRed(this.curve.red)), this.zOne = this.z === this.curve.one, this.curve.extended && !this.t && (this.t = this.x.redMul(this.y), this.zOne || (this.t = this.t.redMul(this.z.redInvm()))));
    }

    o(c, a), e.exports = c, c.prototype._mulA = function (e) {
      return this.mOneA ? e.redNeg() : this.a.redMul(e);
    }, c.prototype._mulC = function (e) {
      return this.oneC ? e : this.c.redMul(e);
    }, c.prototype.jpoint = function (e, t, r, n) {
      return this.point(e, t, r, n);
    }, c.prototype.pointFromX = function (e, t) {
      (e = new s(e, 16)).red || (e = e.toRed(this.red));
      var r = e.redSqr(),
          n = this.c2.redSub(this.a.redMul(r)),
          i = this.one.redSub(this.c2.redMul(this.d).redMul(r)),
          o = n.redMul(i.redInvm()),
          a = o.redSqrt();
      if (0 !== a.redSqr().redSub(o).cmp(this.zero)) throw new Error("invalid point");
      var f = a.fromRed().isOdd();
      return (t && !f || !t && f) && (a = a.redNeg()), this.point(e, a);
    }, c.prototype.pointFromY = function (e, t) {
      (e = new s(e, 16)).red || (e = e.toRed(this.red));
      var r = e.redSqr(),
          n = r.redSub(this.one),
          i = r.redMul(this.d).redAdd(this.one),
          o = n.redMul(i.redInvm());

      if (0 === o.cmp(this.zero)) {
        if (t) throw new Error("invalid point");
        return this.point(this.zero, e);
      }

      var a = o.redSqrt();
      if (0 !== a.redSqr().redSub(o).cmp(this.zero)) throw new Error("invalid point");
      return a.isOdd() !== t && (a = a.redNeg()), this.point(a, e);
    }, c.prototype.validate = function (e) {
      if (e.isInfinity()) return !0;
      e.normalize();
      var t = e.x.redSqr(),
          r = e.y.redSqr(),
          n = t.redMul(this.a).redAdd(r),
          i = this.c2.redMul(this.one.redAdd(this.d.redMul(t).redMul(r)));
      return 0 === n.cmp(i);
    }, o(u, a.BasePoint), c.prototype.pointFromJSON = function (e) {
      return u.fromJSON(this, e);
    }, c.prototype.point = function (e, t, r, n) {
      return new u(this, e, t, r, n);
    }, u.fromJSON = function (e, t) {
      return new u(e, t[0], t[1], t[2]);
    }, u.prototype.inspect = function () {
      return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
    }, u.prototype.isInfinity = function () {
      return 0 === this.x.cmpn(0) && 0 === this.y.cmp(this.z);
    }, u.prototype._extDbl = function () {
      var e = this.x.redSqr(),
          t = this.y.redSqr(),
          r = this.z.redSqr();
      r = r.redIAdd(r);

      var n = this.curve._mulA(e),
          i = this.x.redAdd(this.y).redSqr().redISub(e).redISub(t),
          s = n.redAdd(t),
          o = s.redSub(r),
          a = n.redSub(t),
          f = i.redMul(o),
          c = s.redMul(a),
          u = i.redMul(a),
          h = o.redMul(s);

      return this.curve.point(f, c, h, u);
    }, u.prototype._projDbl = function () {
      var e,
          t,
          r,
          n = this.x.redAdd(this.y).redSqr(),
          i = this.x.redSqr(),
          s = this.y.redSqr();

      if (this.curve.twisted) {
        var o = (c = this.curve._mulA(i)).redAdd(s);

        if (this.zOne) e = n.redSub(i).redSub(s).redMul(o.redSub(this.curve.two)), t = o.redMul(c.redSub(s)), r = o.redSqr().redSub(o).redSub(o);else {
          var a = this.z.redSqr(),
              f = o.redSub(a).redISub(a);
          e = n.redSub(i).redISub(s).redMul(f), t = o.redMul(c.redSub(s)), r = o.redMul(f);
        }
      } else {
        var c = i.redAdd(s);
        a = this.curve._mulC(this.c.redMul(this.z)).redSqr(), f = c.redSub(a).redSub(a);
        e = this.curve._mulC(n.redISub(c)).redMul(f), t = this.curve._mulC(c).redMul(i.redISub(s)), r = c.redMul(f);
      }

      return this.curve.point(e, t, r);
    }, u.prototype.dbl = function () {
      return this.isInfinity() ? this : this.curve.extended ? this._extDbl() : this._projDbl();
    }, u.prototype._extAdd = function (e) {
      var t = this.y.redSub(this.x).redMul(e.y.redSub(e.x)),
          r = this.y.redAdd(this.x).redMul(e.y.redAdd(e.x)),
          n = this.t.redMul(this.curve.dd).redMul(e.t),
          i = this.z.redMul(e.z.redAdd(e.z)),
          s = r.redSub(t),
          o = i.redSub(n),
          a = i.redAdd(n),
          f = r.redAdd(t),
          c = s.redMul(o),
          u = a.redMul(f),
          h = s.redMul(f),
          d = o.redMul(a);
      return this.curve.point(c, u, d, h);
    }, u.prototype._projAdd = function (e) {
      var t,
          r,
          n = this.z.redMul(e.z),
          i = n.redSqr(),
          s = this.x.redMul(e.x),
          o = this.y.redMul(e.y),
          a = this.curve.d.redMul(s).redMul(o),
          f = i.redSub(a),
          c = i.redAdd(a),
          u = this.x.redAdd(this.y).redMul(e.x.redAdd(e.y)).redISub(s).redISub(o),
          h = n.redMul(f).redMul(u);
      return this.curve.twisted ? (t = n.redMul(c).redMul(o.redSub(this.curve._mulA(s))), r = f.redMul(c)) : (t = n.redMul(c).redMul(o.redSub(s)), r = this.curve._mulC(f).redMul(c)), this.curve.point(h, t, r);
    }, u.prototype.add = function (e) {
      return this.isInfinity() ? e : e.isInfinity() ? this : this.curve.extended ? this._extAdd(e) : this._projAdd(e);
    }, u.prototype.mul = function (e) {
      return this._hasDoubles(e) ? this.curve._fixedNafMul(this, e) : this.curve._wnafMul(this, e);
    }, u.prototype.mulAdd = function (e, t, r) {
      return this.curve._wnafMulAdd(1, [this, t], [e, r], 2, !1);
    }, u.prototype.jmulAdd = function (e, t, r) {
      return this.curve._wnafMulAdd(1, [this, t], [e, r], 2, !0);
    }, u.prototype.normalize = function () {
      if (this.zOne) return this;
      var e = this.z.redInvm();
      return this.x = this.x.redMul(e), this.y = this.y.redMul(e), this.t && (this.t = this.t.redMul(e)), this.z = this.curve.one, this.zOne = !0, this;
    }, u.prototype.neg = function () {
      return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
    }, u.prototype.getX = function () {
      return this.normalize(), this.x.fromRed();
    }, u.prototype.getY = function () {
      return this.normalize(), this.y.fromRed();
    }, u.prototype.eq = function (e) {
      return this === e || 0 === this.getX().cmp(e.getX()) && 0 === this.getY().cmp(e.getY());
    }, u.prototype.eqXToP = function (e) {
      var t = e.toRed(this.curve.red).redMul(this.z);
      if (0 === this.x.cmp(t)) return !0;

      for (var r = e.clone(), n = this.curve.redN.redMul(this.z);;) {
        if (r.iadd(this.curve.n), r.cmp(this.curve.p) >= 0) return !1;
        if (t.redIAdd(n), 0 === this.x.cmp(t)) return !0;
      }

      return !1;
    }, u.prototype.toP = u.prototype.normalize, u.prototype.mixedAdd = u.prototype.add;
  }, function (e, t, r) {
    "use strict";

    var n = r(37),
        i = r(8),
        s = r(2),
        o = n.base,
        a = r(11).utils;

    function f(e) {
      o.call(this, "mont", e), this.a = new i(e.a, 16).toRed(this.red), this.b = new i(e.b, 16).toRed(this.red), this.i4 = new i(4).toRed(this.red).redInvm(), this.two = new i(2).toRed(this.red), this.a24 = this.i4.redMul(this.a.redAdd(this.two));
    }

    function c(e, t, r) {
      o.BasePoint.call(this, e, "projective"), null === t && null === r ? (this.x = this.curve.one, this.z = this.curve.zero) : (this.x = new i(t, 16), this.z = new i(r, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)));
    }

    s(f, o), e.exports = f, f.prototype.validate = function (e) {
      var t = e.normalize().x,
          r = t.redSqr(),
          n = r.redMul(t).redAdd(r.redMul(this.a)).redAdd(t);
      return 0 === n.redSqrt().redSqr().cmp(n);
    }, s(c, o.BasePoint), f.prototype.decodePoint = function (e, t) {
      return this.point(a.toArray(e, t), 1);
    }, f.prototype.point = function (e, t) {
      return new c(this, e, t);
    }, f.prototype.pointFromJSON = function (e) {
      return c.fromJSON(this, e);
    }, c.prototype.precompute = function () {}, c.prototype._encode = function () {
      return this.getX().toArray("be", this.curve.p.byteLength());
    }, c.fromJSON = function (e, t) {
      return new c(e, t[0], t[1] || e.one);
    }, c.prototype.inspect = function () {
      return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
    }, c.prototype.isInfinity = function () {
      return 0 === this.z.cmpn(0);
    }, c.prototype.dbl = function () {
      var e = this.x.redAdd(this.z).redSqr(),
          t = this.x.redSub(this.z).redSqr(),
          r = e.redSub(t),
          n = e.redMul(t),
          i = r.redMul(t.redAdd(this.curve.a24.redMul(r)));
      return this.curve.point(n, i);
    }, c.prototype.add = function () {
      throw new Error("Not supported on Montgomery curve");
    }, c.prototype.diffAdd = function (e, t) {
      var r = this.x.redAdd(this.z),
          n = this.x.redSub(this.z),
          i = e.x.redAdd(e.z),
          s = e.x.redSub(e.z).redMul(r),
          o = i.redMul(n),
          a = t.z.redMul(s.redAdd(o).redSqr()),
          f = t.x.redMul(s.redISub(o).redSqr());
      return this.curve.point(a, f);
    }, c.prototype.mul = function (e) {
      for (var t = e.clone(), r = this, n = this.curve.point(null, null), i = []; 0 !== t.cmpn(0); t.iushrn(1)) {
        i.push(t.andln(1));
      }

      for (var s = i.length - 1; s >= 0; s--) {
        0 === i[s] ? (r = r.diffAdd(n, this), n = n.dbl()) : (n = r.diffAdd(n, this), r = r.dbl());
      }

      return n;
    }, c.prototype.mulAdd = function () {
      throw new Error("Not supported on Montgomery curve");
    }, c.prototype.jumlAdd = function () {
      throw new Error("Not supported on Montgomery curve");
    }, c.prototype.eq = function (e) {
      return 0 === this.getX().cmp(e.getX());
    }, c.prototype.normalize = function () {
      return this.x = this.x.redMul(this.z.redInvm()), this.z = this.curve.one, this;
    }, c.prototype.getX = function () {
      return this.normalize(), this.x.fromRed();
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(37),
        i = r(11),
        s = r(8),
        o = r(2),
        a = n.base,
        f = i.utils.assert;

    function c(e) {
      a.call(this, "short", e), this.a = new s(e.a, 16).toRed(this.red), this.b = new s(e.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = 0 === this.a.fromRed().cmpn(0), this.threeA = 0 === this.a.fromRed().sub(this.p).cmpn(-3), this.endo = this._getEndomorphism(e), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
    }

    function u(e, t, r, n) {
      a.BasePoint.call(this, e, "affine"), null === t && null === r ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new s(t, 16), this.y = new s(r, 16), n && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
    }

    function h(e, t, r, n) {
      a.BasePoint.call(this, e, "jacobian"), null === t && null === r && null === n ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new s(0)) : (this.x = new s(t, 16), this.y = new s(r, 16), this.z = new s(n, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
    }

    o(c, a), e.exports = c, c.prototype._getEndomorphism = function (e) {
      if (this.zeroA && this.g && this.n && 1 === this.p.modn(3)) {
        var t, r;
        if (e.beta) t = new s(e.beta, 16).toRed(this.red);else {
          var n = this._getEndoRoots(this.p);

          t = (t = n[0].cmp(n[1]) < 0 ? n[0] : n[1]).toRed(this.red);
        }
        if (e.lambda) r = new s(e.lambda, 16);else {
          var i = this._getEndoRoots(this.n);

          0 === this.g.mul(i[0]).x.cmp(this.g.x.redMul(t)) ? r = i[0] : (r = i[1], f(0 === this.g.mul(r).x.cmp(this.g.x.redMul(t))));
        }
        return {
          beta: t,
          lambda: r,
          basis: e.basis ? e.basis.map(function (e) {
            return {
              a: new s(e.a, 16),
              b: new s(e.b, 16)
            };
          }) : this._getEndoBasis(r)
        };
      }
    }, c.prototype._getEndoRoots = function (e) {
      var t = e === this.p ? this.red : s.mont(e),
          r = new s(2).toRed(t).redInvm(),
          n = r.redNeg(),
          i = new s(3).toRed(t).redNeg().redSqrt().redMul(r);
      return [n.redAdd(i).fromRed(), n.redSub(i).fromRed()];
    }, c.prototype._getEndoBasis = function (e) {
      for (var t, r, n, i, o, a, f, c, u, h = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), d = e, l = this.n.clone(), p = new s(1), b = new s(0), _ = new s(0), g = new s(1), v = 0; 0 !== d.cmpn(0);) {
        var m = l.div(d);
        c = l.sub(m.mul(d)), u = _.sub(m.mul(p));
        var y = g.sub(m.mul(b));
        if (!n && c.cmp(h) < 0) t = f.neg(), r = p, n = c.neg(), i = u;else if (n && 2 == ++v) break;
        f = c, l = d, d = c, _ = p, p = u, g = b, b = y;
      }

      o = c.neg(), a = u;
      var w = n.sqr().add(i.sqr());
      return o.sqr().add(a.sqr()).cmp(w) >= 0 && (o = t, a = r), n.negative && (n = n.neg(), i = i.neg()), o.negative && (o = o.neg(), a = a.neg()), [{
        a: n,
        b: i
      }, {
        a: o,
        b: a
      }];
    }, c.prototype._endoSplit = function (e) {
      var t = this.endo.basis,
          r = t[0],
          n = t[1],
          i = n.b.mul(e).divRound(this.n),
          s = r.b.neg().mul(e).divRound(this.n),
          o = i.mul(r.a),
          a = s.mul(n.a),
          f = i.mul(r.b),
          c = s.mul(n.b);
      return {
        k1: e.sub(o).sub(a),
        k2: f.add(c).neg()
      };
    }, c.prototype.pointFromX = function (e, t) {
      (e = new s(e, 16)).red || (e = e.toRed(this.red));
      var r = e.redSqr().redMul(e).redIAdd(e.redMul(this.a)).redIAdd(this.b),
          n = r.redSqrt();
      if (0 !== n.redSqr().redSub(r).cmp(this.zero)) throw new Error("invalid point");
      var i = n.fromRed().isOdd();
      return (t && !i || !t && i) && (n = n.redNeg()), this.point(e, n);
    }, c.prototype.validate = function (e) {
      if (e.inf) return !0;
      var t = e.x,
          r = e.y,
          n = this.a.redMul(t),
          i = t.redSqr().redMul(t).redIAdd(n).redIAdd(this.b);
      return 0 === r.redSqr().redISub(i).cmpn(0);
    }, c.prototype._endoWnafMulAdd = function (e, t, r) {
      for (var n = this._endoWnafT1, i = this._endoWnafT2, s = 0; s < e.length; s++) {
        var o = this._endoSplit(t[s]),
            a = e[s],
            f = a._getBeta();

        o.k1.negative && (o.k1.ineg(), a = a.neg(!0)), o.k2.negative && (o.k2.ineg(), f = f.neg(!0)), n[2 * s] = a, n[2 * s + 1] = f, i[2 * s] = o.k1, i[2 * s + 1] = o.k2;
      }

      for (var c = this._wnafMulAdd(1, n, i, 2 * s, r), u = 0; u < 2 * s; u++) {
        n[u] = null, i[u] = null;
      }

      return c;
    }, o(u, a.BasePoint), c.prototype.point = function (e, t, r) {
      return new u(this, e, t, r);
    }, c.prototype.pointFromJSON = function (e, t) {
      return u.fromJSON(this, e, t);
    }, u.prototype._getBeta = function () {
      if (this.curve.endo) {
        var e = this.precomputed;
        if (e && e.beta) return e.beta;
        var t = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);

        if (e) {
          var r = this.curve,
              n = function n(e) {
            return r.point(e.x.redMul(r.endo.beta), e.y);
          };

          e.beta = t, t.precomputed = {
            beta: null,
            naf: e.naf && {
              wnd: e.naf.wnd,
              points: e.naf.points.map(n)
            },
            doubles: e.doubles && {
              step: e.doubles.step,
              points: e.doubles.points.map(n)
            }
          };
        }

        return t;
      }
    }, u.prototype.toJSON = function () {
      return this.precomputed ? [this.x, this.y, this.precomputed && {
        doubles: this.precomputed.doubles && {
          step: this.precomputed.doubles.step,
          points: this.precomputed.doubles.points.slice(1)
        },
        naf: this.precomputed.naf && {
          wnd: this.precomputed.naf.wnd,
          points: this.precomputed.naf.points.slice(1)
        }
      }] : [this.x, this.y];
    }, u.fromJSON = function (e, t, r) {
      "string" == typeof t && (t = JSON.parse(t));
      var n = e.point(t[0], t[1], r);
      if (!t[2]) return n;

      function i(t) {
        return e.point(t[0], t[1], r);
      }

      var s = t[2];
      return n.precomputed = {
        beta: null,
        doubles: s.doubles && {
          step: s.doubles.step,
          points: [n].concat(s.doubles.points.map(i))
        },
        naf: s.naf && {
          wnd: s.naf.wnd,
          points: [n].concat(s.naf.points.map(i))
        }
      }, n;
    }, u.prototype.inspect = function () {
      return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
    }, u.prototype.isInfinity = function () {
      return this.inf;
    }, u.prototype.add = function (e) {
      if (this.inf) return e;
      if (e.inf) return this;
      if (this.eq(e)) return this.dbl();
      if (this.neg().eq(e)) return this.curve.point(null, null);
      if (0 === this.x.cmp(e.x)) return this.curve.point(null, null);
      var t = this.y.redSub(e.y);
      0 !== t.cmpn(0) && (t = t.redMul(this.x.redSub(e.x).redInvm()));
      var r = t.redSqr().redISub(this.x).redISub(e.x),
          n = t.redMul(this.x.redSub(r)).redISub(this.y);
      return this.curve.point(r, n);
    }, u.prototype.dbl = function () {
      if (this.inf) return this;
      var e = this.y.redAdd(this.y);
      if (0 === e.cmpn(0)) return this.curve.point(null, null);
      var t = this.curve.a,
          r = this.x.redSqr(),
          n = e.redInvm(),
          i = r.redAdd(r).redIAdd(r).redIAdd(t).redMul(n),
          s = i.redSqr().redISub(this.x.redAdd(this.x)),
          o = i.redMul(this.x.redSub(s)).redISub(this.y);
      return this.curve.point(s, o);
    }, u.prototype.getX = function () {
      return this.x.fromRed();
    }, u.prototype.getY = function () {
      return this.y.fromRed();
    }, u.prototype.mul = function (e) {
      return e = new s(e, 16), this._hasDoubles(e) ? this.curve._fixedNafMul(this, e) : this.curve.endo ? this.curve._endoWnafMulAdd([this], [e]) : this.curve._wnafMul(this, e);
    }, u.prototype.mulAdd = function (e, t, r) {
      var n = [this, t],
          i = [e, r];
      return this.curve.endo ? this.curve._endoWnafMulAdd(n, i) : this.curve._wnafMulAdd(1, n, i, 2);
    }, u.prototype.jmulAdd = function (e, t, r) {
      var n = [this, t],
          i = [e, r];
      return this.curve.endo ? this.curve._endoWnafMulAdd(n, i, !0) : this.curve._wnafMulAdd(1, n, i, 2, !0);
    }, u.prototype.eq = function (e) {
      return this === e || this.inf === e.inf && (this.inf || 0 === this.x.cmp(e.x) && 0 === this.y.cmp(e.y));
    }, u.prototype.neg = function (e) {
      if (this.inf) return this;
      var t = this.curve.point(this.x, this.y.redNeg());

      if (e && this.precomputed) {
        var r = this.precomputed,
            n = function n(e) {
          return e.neg();
        };

        t.precomputed = {
          naf: r.naf && {
            wnd: r.naf.wnd,
            points: r.naf.points.map(n)
          },
          doubles: r.doubles && {
            step: r.doubles.step,
            points: r.doubles.points.map(n)
          }
        };
      }

      return t;
    }, u.prototype.toJ = function () {
      return this.inf ? this.curve.jpoint(null, null, null) : this.curve.jpoint(this.x, this.y, this.curve.one);
    }, o(h, a.BasePoint), c.prototype.jpoint = function (e, t, r) {
      return new h(this, e, t, r);
    }, h.prototype.toP = function () {
      if (this.isInfinity()) return this.curve.point(null, null);
      var e = this.z.redInvm(),
          t = e.redSqr(),
          r = this.x.redMul(t),
          n = this.y.redMul(t).redMul(e);
      return this.curve.point(r, n);
    }, h.prototype.neg = function () {
      return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
    }, h.prototype.add = function (e) {
      if (this.isInfinity()) return e;
      if (e.isInfinity()) return this;
      var t = e.z.redSqr(),
          r = this.z.redSqr(),
          n = this.x.redMul(t),
          i = e.x.redMul(r),
          s = this.y.redMul(t.redMul(e.z)),
          o = e.y.redMul(r.redMul(this.z)),
          a = n.redSub(i),
          f = s.redSub(o);
      if (0 === a.cmpn(0)) return 0 !== f.cmpn(0) ? this.curve.jpoint(null, null, null) : this.dbl();
      var c = a.redSqr(),
          u = c.redMul(a),
          h = n.redMul(c),
          d = f.redSqr().redIAdd(u).redISub(h).redISub(h),
          l = f.redMul(h.redISub(d)).redISub(s.redMul(u)),
          p = this.z.redMul(e.z).redMul(a);
      return this.curve.jpoint(d, l, p);
    }, h.prototype.mixedAdd = function (e) {
      if (this.isInfinity()) return e.toJ();
      if (e.isInfinity()) return this;
      var t = this.z.redSqr(),
          r = this.x,
          n = e.x.redMul(t),
          i = this.y,
          s = e.y.redMul(t).redMul(this.z),
          o = r.redSub(n),
          a = i.redSub(s);
      if (0 === o.cmpn(0)) return 0 !== a.cmpn(0) ? this.curve.jpoint(null, null, null) : this.dbl();
      var f = o.redSqr(),
          c = f.redMul(o),
          u = r.redMul(f),
          h = a.redSqr().redIAdd(c).redISub(u).redISub(u),
          d = a.redMul(u.redISub(h)).redISub(i.redMul(c)),
          l = this.z.redMul(o);
      return this.curve.jpoint(h, d, l);
    }, h.prototype.dblp = function (e) {
      if (0 === e) return this;
      if (this.isInfinity()) return this;
      if (!e) return this.dbl();

      if (this.curve.zeroA || this.curve.threeA) {
        for (var t = this, r = 0; r < e; r++) {
          t = t.dbl();
        }

        return t;
      }

      var n = this.curve.a,
          i = this.curve.tinv,
          s = this.x,
          o = this.y,
          a = this.z,
          f = a.redSqr().redSqr(),
          c = o.redAdd(o);

      for (r = 0; r < e; r++) {
        var u = s.redSqr(),
            h = c.redSqr(),
            d = h.redSqr(),
            l = u.redAdd(u).redIAdd(u).redIAdd(n.redMul(f)),
            p = s.redMul(h),
            b = l.redSqr().redISub(p.redAdd(p)),
            _ = p.redISub(b),
            g = l.redMul(_);

        g = g.redIAdd(g).redISub(d);
        var v = c.redMul(a);
        r + 1 < e && (f = f.redMul(d)), s = b, a = v, c = g;
      }

      return this.curve.jpoint(s, c.redMul(i), a);
    }, h.prototype.dbl = function () {
      return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
    }, h.prototype._zeroDbl = function () {
      var e, t, r;

      if (this.zOne) {
        var n = this.x.redSqr(),
            i = this.y.redSqr(),
            s = i.redSqr(),
            o = this.x.redAdd(i).redSqr().redISub(n).redISub(s);
        o = o.redIAdd(o);
        var a = n.redAdd(n).redIAdd(n),
            f = a.redSqr().redISub(o).redISub(o),
            c = s.redIAdd(s);
        c = (c = c.redIAdd(c)).redIAdd(c), e = f, t = a.redMul(o.redISub(f)).redISub(c), r = this.y.redAdd(this.y);
      } else {
        var u = this.x.redSqr(),
            h = this.y.redSqr(),
            d = h.redSqr(),
            l = this.x.redAdd(h).redSqr().redISub(u).redISub(d);
        l = l.redIAdd(l);

        var p = u.redAdd(u).redIAdd(u),
            b = p.redSqr(),
            _ = d.redIAdd(d);

        _ = (_ = _.redIAdd(_)).redIAdd(_), e = b.redISub(l).redISub(l), t = p.redMul(l.redISub(e)).redISub(_), r = (r = this.y.redMul(this.z)).redIAdd(r);
      }

      return this.curve.jpoint(e, t, r);
    }, h.prototype._threeDbl = function () {
      var e, t, r;

      if (this.zOne) {
        var n = this.x.redSqr(),
            i = this.y.redSqr(),
            s = i.redSqr(),
            o = this.x.redAdd(i).redSqr().redISub(n).redISub(s);
        o = o.redIAdd(o);
        var a = n.redAdd(n).redIAdd(n).redIAdd(this.curve.a),
            f = a.redSqr().redISub(o).redISub(o);
        e = f;
        var c = s.redIAdd(s);
        c = (c = c.redIAdd(c)).redIAdd(c), t = a.redMul(o.redISub(f)).redISub(c), r = this.y.redAdd(this.y);
      } else {
        var u = this.z.redSqr(),
            h = this.y.redSqr(),
            d = this.x.redMul(h),
            l = this.x.redSub(u).redMul(this.x.redAdd(u));
        l = l.redAdd(l).redIAdd(l);
        var p = d.redIAdd(d),
            b = (p = p.redIAdd(p)).redAdd(p);
        e = l.redSqr().redISub(b), r = this.y.redAdd(this.z).redSqr().redISub(h).redISub(u);

        var _ = h.redSqr();

        _ = (_ = (_ = _.redIAdd(_)).redIAdd(_)).redIAdd(_), t = l.redMul(p.redISub(e)).redISub(_);
      }

      return this.curve.jpoint(e, t, r);
    }, h.prototype._dbl = function () {
      var e = this.curve.a,
          t = this.x,
          r = this.y,
          n = this.z,
          i = n.redSqr().redSqr(),
          s = t.redSqr(),
          o = r.redSqr(),
          a = s.redAdd(s).redIAdd(s).redIAdd(e.redMul(i)),
          f = t.redAdd(t),
          c = (f = f.redIAdd(f)).redMul(o),
          u = a.redSqr().redISub(c.redAdd(c)),
          h = c.redISub(u),
          d = o.redSqr();
      d = (d = (d = d.redIAdd(d)).redIAdd(d)).redIAdd(d);
      var l = a.redMul(h).redISub(d),
          p = r.redAdd(r).redMul(n);
      return this.curve.jpoint(u, l, p);
    }, h.prototype.trpl = function () {
      if (!this.curve.zeroA) return this.dbl().add(this);
      var e = this.x.redSqr(),
          t = this.y.redSqr(),
          r = this.z.redSqr(),
          n = t.redSqr(),
          i = e.redAdd(e).redIAdd(e),
          s = i.redSqr(),
          o = this.x.redAdd(t).redSqr().redISub(e).redISub(n),
          a = (o = (o = (o = o.redIAdd(o)).redAdd(o).redIAdd(o)).redISub(s)).redSqr(),
          f = n.redIAdd(n);
      f = (f = (f = f.redIAdd(f)).redIAdd(f)).redIAdd(f);
      var c = i.redIAdd(o).redSqr().redISub(s).redISub(a).redISub(f),
          u = t.redMul(c);
      u = (u = u.redIAdd(u)).redIAdd(u);
      var h = this.x.redMul(a).redISub(u);
      h = (h = h.redIAdd(h)).redIAdd(h);
      var d = this.y.redMul(c.redMul(f.redISub(c)).redISub(o.redMul(a)));
      d = (d = (d = d.redIAdd(d)).redIAdd(d)).redIAdd(d);
      var l = this.z.redAdd(o).redSqr().redISub(r).redISub(a);
      return this.curve.jpoint(h, d, l);
    }, h.prototype.mul = function (e, t) {
      return e = new s(e, t), this.curve._wnafMul(this, e);
    }, h.prototype.eq = function (e) {
      if ("affine" === e.type) return this.eq(e.toJ());
      if (this === e) return !0;
      var t = this.z.redSqr(),
          r = e.z.redSqr();
      if (0 !== this.x.redMul(r).redISub(e.x.redMul(t)).cmpn(0)) return !1;
      var n = t.redMul(this.z),
          i = r.redMul(e.z);
      return 0 === this.y.redMul(i).redISub(e.y.redMul(n)).cmpn(0);
    }, h.prototype.eqXToP = function (e) {
      var t = this.z.redSqr(),
          r = e.toRed(this.curve.red).redMul(t);
      if (0 === this.x.cmp(r)) return !0;

      for (var n = e.clone(), i = this.curve.redN.redMul(t);;) {
        if (n.iadd(this.curve.n), n.cmp(this.curve.p) >= 0) return !1;
        if (r.redIAdd(i), 0 === this.x.cmp(r)) return !0;
      }

      return !1;
    }, h.prototype.inspect = function () {
      return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
    }, h.prototype.isInfinity = function () {
      return 0 === this.z.cmpn(0);
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(8),
        i = r(11).utils,
        s = i.getNAF,
        o = i.getJSF,
        a = i.assert;

    function f(e, t) {
      this.type = e, this.p = new n(t.p, 16), this.red = t.prime ? n.red(t.prime) : n.mont(this.p), this.zero = new n(0).toRed(this.red), this.one = new n(1).toRed(this.red), this.two = new n(2).toRed(this.red), this.n = t.n && new n(t.n, 16), this.g = t.g && this.pointFromJSON(t.g, t.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4);
      var r = this.n && this.p.div(this.n);
      !r || r.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
    }

    function c(e, t) {
      this.curve = e, this.type = t, this.precomputed = null;
    }

    e.exports = f, f.prototype.point = function () {
      throw new Error("Not implemented");
    }, f.prototype.validate = function () {
      throw new Error("Not implemented");
    }, f.prototype._fixedNafMul = function (e, t) {
      a(e.precomputed);

      var r = e._getDoubles(),
          n = s(t, 1),
          i = (1 << r.step + 1) - (r.step % 2 == 0 ? 2 : 1);

      i /= 3;

      for (var o = [], f = 0; f < n.length; f += r.step) {
        var c = 0;

        for (t = f + r.step - 1; t >= f; t--) {
          c = (c << 1) + n[t];
        }

        o.push(c);
      }

      for (var u = this.jpoint(null, null, null), h = this.jpoint(null, null, null), d = i; d > 0; d--) {
        for (f = 0; f < o.length; f++) {
          (c = o[f]) === d ? h = h.mixedAdd(r.points[f]) : c === -d && (h = h.mixedAdd(r.points[f].neg()));
        }

        u = u.add(h);
      }

      return u.toP();
    }, f.prototype._wnafMul = function (e, t) {
      var r = 4,
          n = e._getNAFPoints(r);

      r = n.wnd;

      for (var i = n.points, o = s(t, r), f = this.jpoint(null, null, null), c = o.length - 1; c >= 0; c--) {
        for (t = 0; c >= 0 && 0 === o[c]; c--) {
          t++;
        }

        if (c >= 0 && t++, f = f.dblp(t), c < 0) break;
        var u = o[c];
        a(0 !== u), f = "affine" === e.type ? u > 0 ? f.mixedAdd(i[u - 1 >> 1]) : f.mixedAdd(i[-u - 1 >> 1].neg()) : u > 0 ? f.add(i[u - 1 >> 1]) : f.add(i[-u - 1 >> 1].neg());
      }

      return "affine" === e.type ? f.toP() : f;
    }, f.prototype._wnafMulAdd = function (e, t, r, n, i) {
      for (var a = this._wnafT1, f = this._wnafT2, c = this._wnafT3, u = 0, h = 0; h < n; h++) {
        var d = (A = t[h])._getNAFPoints(e);

        a[h] = d.wnd, f[h] = d.points;
      }

      for (h = n - 1; h >= 1; h -= 2) {
        var l = h - 1,
            p = h;

        if (1 === a[l] && 1 === a[p]) {
          var b = [t[l], null, null, t[p]];
          0 === t[l].y.cmp(t[p].y) ? (b[1] = t[l].add(t[p]), b[2] = t[l].toJ().mixedAdd(t[p].neg())) : 0 === t[l].y.cmp(t[p].y.redNeg()) ? (b[1] = t[l].toJ().mixedAdd(t[p]), b[2] = t[l].add(t[p].neg())) : (b[1] = t[l].toJ().mixedAdd(t[p]), b[2] = t[l].toJ().mixedAdd(t[p].neg()));
          var _ = [-3, -1, -5, -7, 0, 7, 5, 1, 3],
              g = o(r[l], r[p]);
          u = Math.max(g[0].length, u), c[l] = new Array(u), c[p] = new Array(u);

          for (var v = 0; v < u; v++) {
            var m = 0 | g[0][v],
                y = 0 | g[1][v];
            c[l][v] = _[3 * (m + 1) + (y + 1)], c[p][v] = 0, f[l] = b;
          }
        } else c[l] = s(r[l], a[l]), c[p] = s(r[p], a[p]), u = Math.max(c[l].length, u), u = Math.max(c[p].length, u);
      }

      var w = this.jpoint(null, null, null),
          k = this._wnafT4;

      for (h = u; h >= 0; h--) {
        for (var S = 0; h >= 0;) {
          var E = !0;

          for (v = 0; v < n; v++) {
            k[v] = 0 | c[v][h], 0 !== k[v] && (E = !1);
          }

          if (!E) break;
          S++, h--;
        }

        if (h >= 0 && S++, w = w.dblp(S), h < 0) break;

        for (v = 0; v < n; v++) {
          var A,
              x = k[v];
          0 !== x && (x > 0 ? A = f[v][x - 1 >> 1] : x < 0 && (A = f[v][-x - 1 >> 1].neg()), w = "affine" === A.type ? w.mixedAdd(A) : w.add(A));
        }
      }

      for (h = 0; h < n; h++) {
        f[h] = null;
      }

      return i ? w : w.toP();
    }, f.BasePoint = c, c.prototype.eq = function () {
      throw new Error("Not implemented");
    }, c.prototype.validate = function () {
      return this.curve.validate(this);
    }, f.prototype.decodePoint = function (e, t) {
      e = i.toArray(e, t);
      var r = this.p.byteLength();
      if ((4 === e[0] || 6 === e[0] || 7 === e[0]) && e.length - 1 == 2 * r) return 6 === e[0] ? a(e[e.length - 1] % 2 == 0) : 7 === e[0] && a(e[e.length - 1] % 2 == 1), this.point(e.slice(1, 1 + r), e.slice(1 + r, 1 + 2 * r));
      if ((2 === e[0] || 3 === e[0]) && e.length - 1 === r) return this.pointFromX(e.slice(1, 1 + r), 3 === e[0]);
      throw new Error("Unknown point format");
    }, c.prototype.encodeCompressed = function (e) {
      return this.encode(e, !0);
    }, c.prototype._encode = function (e) {
      var t = this.curve.p.byteLength(),
          r = this.getX().toArray("be", t);
      return e ? [this.getY().isEven() ? 2 : 3].concat(r) : [4].concat(r, this.getY().toArray("be", t));
    }, c.prototype.encode = function (e, t) {
      return i.encode(this._encode(t), e);
    }, c.prototype.precompute = function (e) {
      if (this.precomputed) return this;
      var t = {
        doubles: null,
        naf: null,
        beta: null
      };
      return t.naf = this._getNAFPoints(8), t.doubles = this._getDoubles(4, e), t.beta = this._getBeta(), this.precomputed = t, this;
    }, c.prototype._hasDoubles = function (e) {
      if (!this.precomputed) return !1;
      var t = this.precomputed.doubles;
      return !!t && t.points.length >= Math.ceil((e.bitLength() + 1) / t.step);
    }, c.prototype._getDoubles = function (e, t) {
      if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;

      for (var r = [this], n = this, i = 0; i < t; i += e) {
        for (var s = 0; s < e; s++) {
          n = n.dbl();
        }

        r.push(n);
      }

      return {
        step: e,
        points: r
      };
    }, c.prototype._getNAFPoints = function (e) {
      if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;

      for (var t = [this], r = (1 << e) - 1, n = 1 === r ? null : this.dbl(), i = 1; i < r; i++) {
        t[i] = t[i - 1].add(n);
      }

      return {
        wnd: e,
        points: t
      };
    }, c.prototype._getBeta = function () {
      return null;
    }, c.prototype.dblp = function (e) {
      for (var t = this, r = 0; r < e; r++) {
        t = t.dbl();
      }

      return t;
    };
  }, function (e, t, r) {
    "use strict";

    var n = t,
        i = r(8),
        s = r(13),
        o = r(86);
    n.assert = s, n.toArray = o.toArray, n.zero2 = o.zero2, n.toHex = o.toHex, n.encode = o.encode, n.getNAF = function (e, t) {
      for (var r = [], n = 1 << t + 1, i = e.clone(); i.cmpn(1) >= 0;) {
        var s;

        if (i.isOdd()) {
          var o = i.andln(n - 1);
          s = o > (n >> 1) - 1 ? (n >> 1) - o : o, i.isubn(s);
        } else s = 0;

        r.push(s);

        for (var a = 0 !== i.cmpn(0) && 0 === i.andln(n - 1) ? t + 1 : 1, f = 1; f < a; f++) {
          r.push(0);
        }

        i.iushrn(a);
      }

      return r;
    }, n.getJSF = function (e, t) {
      var r = [[], []];
      e = e.clone(), t = t.clone();

      for (var n = 0, i = 0; e.cmpn(-n) > 0 || t.cmpn(-i) > 0;) {
        var s,
            o,
            a,
            f = e.andln(3) + n & 3,
            c = t.andln(3) + i & 3;
        3 === f && (f = -1), 3 === c && (c = -1), s = 0 == (1 & f) ? 0 : 3 != (a = e.andln(7) + n & 7) && 5 !== a || 2 !== c ? f : -f, r[0].push(s), o = 0 == (1 & c) ? 0 : 3 != (a = t.andln(7) + i & 7) && 5 !== a || 2 !== f ? c : -c, r[1].push(o), 2 * n === s + 1 && (n = 1 - n), 2 * i === o + 1 && (i = 1 - i), e.iushrn(1), t.iushrn(1);
      }

      return r;
    }, n.cachedProperty = function (e, t, r) {
      var n = "_" + t;

      e.prototype[t] = function () {
        return void 0 !== this[n] ? this[n] : this[n] = r.call(this);
      };
    }, n.parseBytes = function (e) {
      return "string" == typeof e ? n.toArray(e, "hex") : e;
    }, n.intFromLE = function (e) {
      return new i(e, "hex", "le");
    };
  }, function (e) {
    e.exports = {
      name: "elliptic",
      version: "6.4.0",
      description: "EC cryptography",
      main: "lib/elliptic.js",
      files: ["lib"],
      scripts: {
        jscs: "jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js",
        jshint: "jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js",
        lint: "npm run jscs && npm run jshint",
        unit: "istanbul test _mocha --reporter=spec test/index.js",
        test: "npm run lint && npm run unit",
        version: "grunt dist && git add dist/"
      },
      repository: {
        type: "git",
        url: "git@github.com:indutny/elliptic"
      },
      keywords: ["EC", "Elliptic", "curve", "Cryptography"],
      author: "Fedor Indutny <fedor@indutny.com>",
      license: "MIT",
      bugs: {
        url: "https://github.com/indutny/elliptic/issues"
      },
      homepage: "https://github.com/indutny/elliptic",
      devDependencies: {
        brfs: "^1.4.3",
        coveralls: "^2.11.3",
        grunt: "^0.4.5",
        "grunt-browserify": "^5.0.0",
        "grunt-cli": "^1.2.0",
        "grunt-contrib-connect": "^1.0.0",
        "grunt-contrib-copy": "^1.0.0",
        "grunt-contrib-uglify": "^1.0.1",
        "grunt-mocha-istanbul": "^3.0.1",
        "grunt-saucelabs": "^8.6.2",
        istanbul: "^0.4.2",
        jscs: "^2.9.0",
        jshint: "^2.6.0",
        mocha: "^2.1.0"
      },
      dependencies: {
        "bn.js": "^4.4.0",
        brorand: "^1.0.1",
        "hash.js": "^1.0.0",
        "hmac-drbg": "^1.0.0",
        inherits: "^2.0.1",
        "minimalistic-assert": "^1.0.0",
        "minimalistic-crypto-utils": "^1.0.0"
      }
    };
  }, function (e, t, r) {
    (function (t) {
      var n = r(100),
          i = r(48),
          s = r(11).ec,
          o = r(8),
          a = r(36),
          f = r(78);

      function c(e, r, i, s) {
        if ((e = new t(e.toArray())).length < r.byteLength()) {
          var o = new t(r.byteLength() - e.length);
          o.fill(0), e = t.concat([o, e]);
        }

        var a = i.length,
            f = function (e, r) {
          e = (e = u(e, r)).mod(r);
          var n = new t(e.toArray());

          if (n.length < r.byteLength()) {
            var i = new t(r.byteLength() - n.length);
            i.fill(0), n = t.concat([i, n]);
          }

          return n;
        }(i, r),
            c = new t(a);

        c.fill(1);
        var h = new t(a);
        return h.fill(0), h = n(s, h).update(c).update(new t([0])).update(e).update(f).digest(), c = n(s, h).update(c).digest(), {
          k: h = n(s, h).update(c).update(new t([1])).update(e).update(f).digest(),
          v: c = n(s, h).update(c).digest()
        };
      }

      function u(e, t) {
        var r = new o(e),
            n = (e.length << 3) - t.bitLength();
        return n > 0 && r.ishrn(n), r;
      }

      function h(e, r, i) {
        var s, o;

        do {
          for (s = new t(0); 8 * s.length < e.bitLength();) {
            r.v = n(i, r.k).update(r.v).digest(), s = t.concat([s, r.v]);
          }

          o = u(s, e), r.k = n(i, r.k).update(r.v).update(new t([0])).digest(), r.v = n(i, r.k).update(r.v).digest();
        } while (-1 !== o.cmp(e));

        return o;
      }

      function d(e, t, r, n) {
        return e.toRed(o.mont(r)).redPow(t).fromRed().mod(n);
      }

      e.exports = function (e, r, n, l, p) {
        var b = a(r);

        if (b.curve) {
          if ("ecdsa" !== l && "ecdsa/rsa" !== l) throw new Error("wrong private key type");
          return function (e, r) {
            var n = f[r.curve.join(".")];
            if (!n) throw new Error("unknown curve " + r.curve.join("."));
            var i = new s(n).keyFromPrivate(r.privateKey).sign(e);
            return new t(i.toDER());
          }(e, b);
        }

        if ("dsa" === b.type) {
          if ("dsa" !== l) throw new Error("wrong private key type");
          return function (e, r, n) {
            for (var i, s = r.params.priv_key, a = r.params.p, f = r.params.q, l = r.params.g, p = new o(0), b = u(e, f).mod(f), _ = !1, g = c(s, f, e, n); !1 === _;) {
              i = h(f, g, n), p = d(l, i, a, f), 0 === (_ = i.invm(f).imul(b.add(s.mul(p))).mod(f)).cmpn(0) && (_ = !1, p = new o(0));
            }

            return function (e, r) {
              e = e.toArray(), r = r.toArray(), 128 & e[0] && (e = [0].concat(e)), 128 & r[0] && (r = [0].concat(r));
              var n = [48, e.length + r.length + 4, 2, e.length];
              return n = n.concat(e, [2, r.length], r), new t(n);
            }(p, _);
          }(e, b, n);
        }

        if ("rsa" !== l && "ecdsa/rsa" !== l) throw new Error("wrong private key type");
        e = t.concat([p, e]);

        for (var _ = b.modulus.byteLength(), g = [0, 1]; e.length + g.length + 1 < _;) {
          g.push(255);
        }

        g.push(0);

        for (var v = -1; ++v < e.length;) {
          g.push(e[v]);
        }

        return i(g, b);
      }, e.exports.getKey = c, e.exports.makeKey = h;
    }).call(this, r(3).Buffer);
  }, function (e, t, r) {
    (function (t) {
      var n = r(31),
          i = r(21),
          s = r(2),
          o = r(198),
          a = r(162),
          f = r(99);

      function c(e) {
        i.Writable.call(this);
        var t = f[e];
        if (!t) throw new Error("Unknown message digest");
        this._hashType = t.hash, this._hash = n(t.hash), this._tag = t.id, this._signType = t.sign;
      }

      function u(e) {
        i.Writable.call(this);
        var t = f[e];
        if (!t) throw new Error("Unknown message digest");
        this._hash = n(t.hash), this._tag = t.id, this._signType = t.sign;
      }

      function h(e) {
        return new c(e);
      }

      function d(e) {
        return new u(e);
      }

      Object.keys(f).forEach(function (e) {
        f[e].id = new t(f[e].id, "hex"), f[e.toLowerCase()] = f[e];
      }), s(c, i.Writable), c.prototype._write = function (e, t, r) {
        this._hash.update(e), r();
      }, c.prototype.update = function (e, r) {
        return "string" == typeof e && (e = new t(e, r)), this._hash.update(e), this;
      }, c.prototype.sign = function (e, t) {
        this.end();

        var r = this._hash.digest(),
            n = o(r, e, this._hashType, this._signType, this._tag);

        return t ? n.toString(t) : n;
      }, s(u, i.Writable), u.prototype._write = function (e, t, r) {
        this._hash.update(e), r();
      }, u.prototype.update = function (e, r) {
        return "string" == typeof e && (e = new t(e, r)), this._hash.update(e), this;
      }, u.prototype.verify = function (e, r, n) {
        "string" == typeof r && (r = new t(r, n)), this.end();

        var i = this._hash.digest();

        return a(r, i, e, this._signType, this._tag);
      }, e.exports = {
        Sign: h,
        Verify: d,
        createSign: h,
        createVerify: d
      };
    }).call(this, r(3).Buffer);
  }, function (e, t, r) {
    (function (t) {
      var n = r(8),
          i = new (r(88))(),
          s = new n(24),
          o = new n(11),
          a = new n(10),
          f = new n(3),
          c = new n(7),
          u = r(89),
          h = r(22);

      function d(e, r) {
        return r = r || "utf8", t.isBuffer(e) || (e = new t(e, r)), this._pub = new n(e), this;
      }

      function l(e, r) {
        return r = r || "utf8", t.isBuffer(e) || (e = new t(e, r)), this._priv = new n(e), this;
      }

      e.exports = b;
      var p = {};

      function b(e, t, r) {
        this.setGenerator(t), this.__prime = new n(e), this._prime = n.mont(this.__prime), this._primeLen = e.length, this._pub = void 0, this._priv = void 0, this._primeCode = void 0, r ? (this.setPublicKey = d, this.setPrivateKey = l) : this._primeCode = 8;
      }

      function _(e, r) {
        var n = new t(e.toArray());
        return r ? n.toString(r) : n;
      }

      Object.defineProperty(b.prototype, "verifyError", {
        enumerable: !0,
        get: function get() {
          return "number" != typeof this._primeCode && (this._primeCode = function (e, t) {
            var r = t.toString("hex"),
                n = [r, e.toString(16)].join("_");
            if (n in p) return p[n];
            var h,
                d = 0;
            if (e.isEven() || !u.simpleSieve || !u.fermatTest(e) || !i.test(e)) return d += 1, d += "02" === r || "05" === r ? 8 : 4, p[n] = d, d;

            switch (i.test(e.shrn(1)) || (d += 2), r) {
              case "02":
                e.mod(s).cmp(o) && (d += 8);
                break;

              case "05":
                (h = e.mod(a)).cmp(f) && h.cmp(c) && (d += 8);
                break;

              default:
                d += 4;
            }

            return p[n] = d, d;
          }(this.__prime, this.__gen)), this._primeCode;
        }
      }), b.prototype.generateKeys = function () {
        return this._priv || (this._priv = new n(h(this._primeLen))), this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed(), this.getPublicKey();
      }, b.prototype.computeSecret = function (e) {
        var r = (e = (e = new n(e)).toRed(this._prime)).redPow(this._priv).fromRed(),
            i = new t(r.toArray()),
            s = this.getPrime();

        if (i.length < s.length) {
          var o = new t(s.length - i.length);
          o.fill(0), i = t.concat([o, i]);
        }

        return i;
      }, b.prototype.getPublicKey = function (e) {
        return _(this._pub, e);
      }, b.prototype.getPrivateKey = function (e) {
        return _(this._priv, e);
      }, b.prototype.getPrime = function (e) {
        return _(this.__prime, e);
      }, b.prototype.getGenerator = function (e) {
        return _(this._gen, e);
      }, b.prototype.setGenerator = function (e, r) {
        return r = r || "utf8", t.isBuffer(e) || (e = new t(e, r)), this.__gen = e, this._gen = new n(e), this;
      };
    }).call(this, r(3).Buffer);
  }, function (e) {
    e.exports = {
      modp1: {
        gen: "02",
        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"
      },
      modp2: {
        gen: "02",
        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"
      },
      modp5: {
        gen: "02",
        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"
      },
      modp14: {
        gen: "02",
        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"
      },
      modp15: {
        gen: "02",
        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"
      },
      modp16: {
        gen: "02",
        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"
      },
      modp17: {
        gen: "02",
        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"
      },
      modp18: {
        gen: "02",
        prime: "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"
      }
    };
  }, function (e, t) {}, function (e, t) {}, function (e, t, r) {
    (function (e) {
      var n = r(89),
          i = r(201),
          s = r(200);
      var o = {
        binary: !0,
        hex: !0,
        base64: !0
      };
      t.DiffieHellmanGroup = t.createDiffieHellmanGroup = t.getDiffieHellman = function (t) {
        var r = new e(i[t].prime, "hex"),
            n = new e(i[t].gen, "hex");
        return new s(r, n);
      }, t.createDiffieHellman = t.DiffieHellman = function t(r, i, a, f) {
        return e.isBuffer(i) || void 0 === o[i] ? t(r, "binary", i, a) : (i = i || "binary", f = f || "binary", a = a || new e([2]), e.isBuffer(a) || (a = new e(a, f)), "number" == typeof r ? new s(n(r, a), a, !0) : (e.isBuffer(r) || (r = new e(r, i)), new s(r, a, !0)));
      };
    }).call(this, r(3).Buffer);
  }, function (e, t) {
    t["des-ecb"] = {
      key: 8,
      iv: 0
    }, t["des-cbc"] = t.des = {
      key: 8,
      iv: 8
    }, t["des-ede3-cbc"] = t.des3 = {
      key: 24,
      iv: 8
    }, t["des-ede3"] = {
      key: 24,
      iv: 0
    }, t["des-ede-cbc"] = {
      key: 16,
      iv: 8
    }, t["des-ede"] = {
      key: 16,
      iv: 0
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(13),
        i = r(2),
        s = r(49),
        o = s.Cipher,
        a = s.DES;

    function f(e) {
      o.call(this, e);
      var t = new function (e, t) {
        n.equal(t.length, 24, "Invalid key length");
        var r = t.slice(0, 8),
            i = t.slice(8, 16),
            s = t.slice(16, 24);
        this.ciphers = "encrypt" === e ? [a.create({
          type: "encrypt",
          key: r
        }), a.create({
          type: "decrypt",
          key: i
        }), a.create({
          type: "encrypt",
          key: s
        })] : [a.create({
          type: "decrypt",
          key: s
        }), a.create({
          type: "encrypt",
          key: i
        }), a.create({
          type: "decrypt",
          key: r
        })];
      }(this.type, this.options.key);
      this._edeState = t;
    }

    i(f, o), e.exports = f, f.create = function (e) {
      return new f(e);
    }, f.prototype._update = function (e, t, r, n) {
      var i = this._edeState;
      i.ciphers[0]._update(e, t, r, n), i.ciphers[1]._update(r, n, r, n), i.ciphers[2]._update(r, n, r, n);
    }, f.prototype._pad = a.prototype._pad, f.prototype._unpad = a.prototype._unpad;
  }, function (e, t, r) {
    "use strict";

    var n = r(13),
        i = r(2),
        s = {};
    t.instantiate = function (e) {
      function t(t) {
        e.call(this, t), this._cbcInit();
      }

      i(t, e);

      for (var r = Object.keys(s), n = 0; n < r.length; n++) {
        var o = r[n];
        t.prototype[o] = s[o];
      }

      return t.create = function (e) {
        return new t(e);
      }, t;
    }, s._cbcInit = function () {
      var e = new function (e) {
        n.equal(e.length, 8, "Invalid IV length"), this.iv = new Array(8);

        for (var t = 0; t < this.iv.length; t++) {
          this.iv[t] = e[t];
        }
      }(this.options.iv);
      this._cbcState = e;
    }, s._update = function (e, t, r, n) {
      var i = this._cbcState,
          s = this.constructor.super_.prototype,
          o = i.iv;

      if ("encrypt" === this.type) {
        for (var a = 0; a < this.blockSize; a++) {
          o[a] ^= e[t + a];
        }

        s._update.call(this, o, 0, r, n);

        for (a = 0; a < this.blockSize; a++) {
          o[a] = r[n + a];
        }
      } else {
        s._update.call(this, e, t, r, n);

        for (a = 0; a < this.blockSize; a++) {
          r[n + a] ^= o[a];
        }

        for (a = 0; a < this.blockSize; a++) {
          o[a] = e[t + a];
        }
      }
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(13),
        i = r(2),
        s = r(49),
        o = s.utils,
        a = s.Cipher;

    function f(e) {
      a.call(this, e);
      var t = new function () {
        this.tmp = new Array(2), this.keys = null;
      }();
      this._desState = t, this.deriveKeys(t, e.key);
    }

    i(f, a), e.exports = f, f.create = function (e) {
      return new f(e);
    };
    var c = [1, 1, 2, 2, 2, 2, 2, 2, 1, 2, 2, 2, 2, 2, 2, 1];
    f.prototype.deriveKeys = function (e, t) {
      e.keys = new Array(32), n.equal(t.length, this.blockSize, "Invalid key length");
      var r = o.readUInt32BE(t, 0),
          i = o.readUInt32BE(t, 4);
      o.pc1(r, i, e.tmp, 0), r = e.tmp[0], i = e.tmp[1];

      for (var s = 0; s < e.keys.length; s += 2) {
        var a = c[s >>> 1];
        r = o.r28shl(r, a), i = o.r28shl(i, a), o.pc2(r, i, e.keys, s);
      }
    }, f.prototype._update = function (e, t, r, n) {
      var i = this._desState,
          s = o.readUInt32BE(e, t),
          a = o.readUInt32BE(e, t + 4);
      o.ip(s, a, i.tmp, 0), s = i.tmp[0], a = i.tmp[1], "encrypt" === this.type ? this._encrypt(i, s, a, i.tmp, 0) : this._decrypt(i, s, a, i.tmp, 0), s = i.tmp[0], a = i.tmp[1], o.writeUInt32BE(r, s, n), o.writeUInt32BE(r, a, n + 4);
    }, f.prototype._pad = function (e, t) {
      for (var r = e.length - t, n = t; n < e.length; n++) {
        e[n] = r;
      }

      return !0;
    }, f.prototype._unpad = function (e) {
      for (var t = e[e.length - 1], r = e.length - t; r < e.length; r++) {
        n.equal(e[r], t);
      }

      return e.slice(0, e.length - t);
    }, f.prototype._encrypt = function (e, t, r, n, i) {
      for (var s = t, a = r, f = 0; f < e.keys.length; f += 2) {
        var c = e.keys[f],
            u = e.keys[f + 1];
        o.expand(a, e.tmp, 0), c ^= e.tmp[0], u ^= e.tmp[1];
        var h = o.substitute(c, u),
            d = a;
        a = (s ^ o.permute(h)) >>> 0, s = d;
      }

      o.rip(a, s, n, i);
    }, f.prototype._decrypt = function (e, t, r, n, i) {
      for (var s = r, a = t, f = e.keys.length - 2; f >= 0; f -= 2) {
        var c = e.keys[f],
            u = e.keys[f + 1];
        o.expand(s, e.tmp, 0), c ^= e.tmp[0], u ^= e.tmp[1];
        var h = o.substitute(c, u),
            d = s;
        s = (a ^ o.permute(h)) >>> 0, a = d;
      }

      o.rip(s, a, n, i);
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(13);

    function i(e) {
      this.options = e, this.type = this.options.type, this.blockSize = 8, this._init(), this.buffer = new Array(this.blockSize), this.bufferOff = 0;
    }

    e.exports = i, i.prototype._init = function () {}, i.prototype.update = function (e) {
      return 0 === e.length ? [] : "decrypt" === this.type ? this._updateDecrypt(e) : this._updateEncrypt(e);
    }, i.prototype._buffer = function (e, t) {
      for (var r = Math.min(this.buffer.length - this.bufferOff, e.length - t), n = 0; n < r; n++) {
        this.buffer[this.bufferOff + n] = e[t + n];
      }

      return this.bufferOff += r, r;
    }, i.prototype._flushBuffer = function (e, t) {
      return this._update(this.buffer, 0, e, t), this.bufferOff = 0, this.blockSize;
    }, i.prototype._updateEncrypt = function (e) {
      var t = 0,
          r = 0,
          n = (this.bufferOff + e.length) / this.blockSize | 0,
          i = new Array(n * this.blockSize);
      0 !== this.bufferOff && (t += this._buffer(e, t), this.bufferOff === this.buffer.length && (r += this._flushBuffer(i, r)));

      for (var s = e.length - (e.length - t) % this.blockSize; t < s; t += this.blockSize) {
        this._update(e, t, i, r), r += this.blockSize;
      }

      for (; t < e.length; t++, this.bufferOff++) {
        this.buffer[this.bufferOff] = e[t];
      }

      return i;
    }, i.prototype._updateDecrypt = function (e) {
      for (var t = 0, r = 0, n = Math.ceil((this.bufferOff + e.length) / this.blockSize) - 1, i = new Array(n * this.blockSize); n > 0; n--) {
        t += this._buffer(e, t), r += this._flushBuffer(i, r);
      }

      return t += this._buffer(e, t), i;
    }, i.prototype.final = function (e) {
      var t, r;
      return e && (t = this.update(e)), r = "encrypt" === this.type ? this._finalEncrypt() : this._finalDecrypt(), t ? t.concat(r) : r;
    }, i.prototype._pad = function (e, t) {
      if (0 === t) return !1;

      for (; t < e.length;) {
        e[t++] = 0;
      }

      return !0;
    }, i.prototype._finalEncrypt = function () {
      if (!this._pad(this.buffer, this.bufferOff)) return [];
      var e = new Array(this.blockSize);
      return this._update(this.buffer, 0, e, 0), e;
    }, i.prototype._unpad = function (e) {
      return e;
    }, i.prototype._finalDecrypt = function () {
      n.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
      var e = new Array(this.blockSize);
      return this._flushBuffer(e, 0), this._unpad(e);
    };
  }, function (e, t, r) {
    "use strict";

    t.readUInt32BE = function (e, t) {
      return (e[0 + t] << 24 | e[1 + t] << 16 | e[2 + t] << 8 | e[3 + t]) >>> 0;
    }, t.writeUInt32BE = function (e, t, r) {
      e[0 + r] = t >>> 24, e[1 + r] = t >>> 16 & 255, e[2 + r] = t >>> 8 & 255, e[3 + r] = 255 & t;
    }, t.ip = function (e, t, r, n) {
      for (var i = 0, s = 0, o = 6; o >= 0; o -= 2) {
        for (var a = 0; a <= 24; a += 8) {
          i <<= 1, i |= t >>> a + o & 1;
        }

        for (a = 0; a <= 24; a += 8) {
          i <<= 1, i |= e >>> a + o & 1;
        }
      }

      for (o = 6; o >= 0; o -= 2) {
        for (a = 1; a <= 25; a += 8) {
          s <<= 1, s |= t >>> a + o & 1;
        }

        for (a = 1; a <= 25; a += 8) {
          s <<= 1, s |= e >>> a + o & 1;
        }
      }

      r[n + 0] = i >>> 0, r[n + 1] = s >>> 0;
    }, t.rip = function (e, t, r, n) {
      for (var i = 0, s = 0, o = 0; o < 4; o++) {
        for (var a = 24; a >= 0; a -= 8) {
          i <<= 1, i |= t >>> a + o & 1, i <<= 1, i |= e >>> a + o & 1;
        }
      }

      for (o = 4; o < 8; o++) {
        for (a = 24; a >= 0; a -= 8) {
          s <<= 1, s |= t >>> a + o & 1, s <<= 1, s |= e >>> a + o & 1;
        }
      }

      r[n + 0] = i >>> 0, r[n + 1] = s >>> 0;
    }, t.pc1 = function (e, t, r, n) {
      for (var i = 0, s = 0, o = 7; o >= 5; o--) {
        for (var a = 0; a <= 24; a += 8) {
          i <<= 1, i |= t >> a + o & 1;
        }

        for (a = 0; a <= 24; a += 8) {
          i <<= 1, i |= e >> a + o & 1;
        }
      }

      for (a = 0; a <= 24; a += 8) {
        i <<= 1, i |= t >> a + o & 1;
      }

      for (o = 1; o <= 3; o++) {
        for (a = 0; a <= 24; a += 8) {
          s <<= 1, s |= t >> a + o & 1;
        }

        for (a = 0; a <= 24; a += 8) {
          s <<= 1, s |= e >> a + o & 1;
        }
      }

      for (a = 0; a <= 24; a += 8) {
        s <<= 1, s |= e >> a + o & 1;
      }

      r[n + 0] = i >>> 0, r[n + 1] = s >>> 0;
    }, t.r28shl = function (e, t) {
      return e << t & 268435455 | e >>> 28 - t;
    };
    var n = [14, 11, 17, 4, 27, 23, 25, 0, 13, 22, 7, 18, 5, 9, 16, 24, 2, 20, 12, 21, 1, 8, 15, 26, 15, 4, 25, 19, 9, 1, 26, 16, 5, 11, 23, 8, 12, 7, 17, 0, 22, 3, 10, 14, 6, 20, 27, 24];
    t.pc2 = function (e, t, r, i) {
      for (var s = 0, o = 0, a = n.length >>> 1, f = 0; f < a; f++) {
        s <<= 1, s |= e >>> n[f] & 1;
      }

      for (f = a; f < n.length; f++) {
        o <<= 1, o |= t >>> n[f] & 1;
      }

      r[i + 0] = s >>> 0, r[i + 1] = o >>> 0;
    }, t.expand = function (e, t, r) {
      var n = 0,
          i = 0;
      n = (1 & e) << 5 | e >>> 27;

      for (var s = 23; s >= 15; s -= 4) {
        n <<= 6, n |= e >>> s & 63;
      }

      for (s = 11; s >= 3; s -= 4) {
        i |= e >>> s & 63, i <<= 6;
      }

      i |= (31 & e) << 1 | e >>> 31, t[r + 0] = n >>> 0, t[r + 1] = i >>> 0;
    };
    var i = [14, 0, 4, 15, 13, 7, 1, 4, 2, 14, 15, 2, 11, 13, 8, 1, 3, 10, 10, 6, 6, 12, 12, 11, 5, 9, 9, 5, 0, 3, 7, 8, 4, 15, 1, 12, 14, 8, 8, 2, 13, 4, 6, 9, 2, 1, 11, 7, 15, 5, 12, 11, 9, 3, 7, 14, 3, 10, 10, 0, 5, 6, 0, 13, 15, 3, 1, 13, 8, 4, 14, 7, 6, 15, 11, 2, 3, 8, 4, 14, 9, 12, 7, 0, 2, 1, 13, 10, 12, 6, 0, 9, 5, 11, 10, 5, 0, 13, 14, 8, 7, 10, 11, 1, 10, 3, 4, 15, 13, 4, 1, 2, 5, 11, 8, 6, 12, 7, 6, 12, 9, 0, 3, 5, 2, 14, 15, 9, 10, 13, 0, 7, 9, 0, 14, 9, 6, 3, 3, 4, 15, 6, 5, 10, 1, 2, 13, 8, 12, 5, 7, 14, 11, 12, 4, 11, 2, 15, 8, 1, 13, 1, 6, 10, 4, 13, 9, 0, 8, 6, 15, 9, 3, 8, 0, 7, 11, 4, 1, 15, 2, 14, 12, 3, 5, 11, 10, 5, 14, 2, 7, 12, 7, 13, 13, 8, 14, 11, 3, 5, 0, 6, 6, 15, 9, 0, 10, 3, 1, 4, 2, 7, 8, 2, 5, 12, 11, 1, 12, 10, 4, 14, 15, 9, 10, 3, 6, 15, 9, 0, 0, 6, 12, 10, 11, 1, 7, 13, 13, 8, 15, 9, 1, 4, 3, 5, 14, 11, 5, 12, 2, 7, 8, 2, 4, 14, 2, 14, 12, 11, 4, 2, 1, 12, 7, 4, 10, 7, 11, 13, 6, 1, 8, 5, 5, 0, 3, 15, 15, 10, 13, 3, 0, 9, 14, 8, 9, 6, 4, 11, 2, 8, 1, 12, 11, 7, 10, 1, 13, 14, 7, 2, 8, 13, 15, 6, 9, 15, 12, 0, 5, 9, 6, 10, 3, 4, 0, 5, 14, 3, 12, 10, 1, 15, 10, 4, 15, 2, 9, 7, 2, 12, 6, 9, 8, 5, 0, 6, 13, 1, 3, 13, 4, 14, 14, 0, 7, 11, 5, 3, 11, 8, 9, 4, 14, 3, 15, 2, 5, 12, 2, 9, 8, 5, 12, 15, 3, 10, 7, 11, 0, 14, 4, 1, 10, 7, 1, 6, 13, 0, 11, 8, 6, 13, 4, 13, 11, 0, 2, 11, 14, 7, 15, 4, 0, 9, 8, 1, 13, 10, 3, 14, 12, 3, 9, 5, 7, 12, 5, 2, 10, 15, 6, 8, 1, 6, 1, 6, 4, 11, 11, 13, 13, 8, 12, 1, 3, 4, 7, 10, 14, 7, 10, 9, 15, 5, 6, 0, 8, 15, 0, 14, 5, 2, 9, 3, 2, 12, 13, 1, 2, 15, 8, 13, 4, 8, 6, 10, 15, 3, 11, 7, 1, 4, 10, 12, 9, 5, 3, 6, 14, 11, 5, 0, 0, 14, 12, 9, 7, 2, 7, 2, 11, 1, 4, 14, 1, 7, 9, 4, 12, 10, 14, 8, 2, 13, 0, 15, 6, 12, 10, 9, 13, 0, 15, 3, 3, 5, 5, 6, 8, 11];

    t.substitute = function (e, t) {
      for (var r = 0, n = 0; n < 4; n++) {
        r <<= 4, r |= i[64 * n + (e >>> 18 - 6 * n & 63)];
      }

      for (n = 0; n < 4; n++) {
        r <<= 4, r |= i[256 + 64 * n + (t >>> 18 - 6 * n & 63)];
      }

      return r >>> 0;
    };

    var s = [16, 25, 12, 11, 3, 20, 4, 15, 31, 17, 9, 6, 27, 14, 1, 22, 30, 24, 8, 18, 0, 5, 29, 23, 13, 19, 2, 26, 10, 21, 28, 7];
    t.permute = function (e) {
      for (var t = 0, r = 0; r < s.length; r++) {
        t <<= 1, t |= e >>> s[r] & 1;
      }

      return t >>> 0;
    }, t.padSplit = function (e, t, r) {
      for (var n = e.toString(2); n.length < t;) {
        n = "0" + n;
      }

      for (var i = [], s = 0; s < t; s += r) {
        i.push(n.slice(s, s + r));
      }

      return i.join(" ");
    };
  }, function (e, t, r) {
    (function (t) {
      var n = r(16),
          i = r(49),
          s = r(2),
          o = {
        "des-ede3-cbc": i.CBC.instantiate(i.EDE),
        "des-ede3": i.EDE,
        "des-ede-cbc": i.CBC.instantiate(i.EDE),
        "des-ede": i.EDE,
        "des-cbc": i.CBC.instantiate(i.DES),
        "des-ecb": i.DES
      };

      function a(e) {
        n.call(this);
        var r,
            i = e.mode.toLowerCase(),
            s = o[i];
        r = e.decrypt ? "decrypt" : "encrypt";
        var a = e.key;
        "des-ede" !== i && "des-ede-cbc" !== i || (a = t.concat([a, a.slice(0, 8)]));
        var f = e.iv;
        this._des = s.create({
          key: a,
          iv: f,
          type: r
        });
      }

      o.des = o["des-cbc"], o.des3 = o["des-ede3-cbc"], e.exports = a, s(a, n), a.prototype._update = function (e) {
        return new t(this._des.update(e));
      }, a.prototype._final = function () {
        return new t(this._des.final());
      };
    }).call(this, r(3).Buffer);
  }, function (e, t, r) {
    var n = r(91),
        i = r(6).Buffer,
        s = r(50),
        o = r(90),
        a = r(16),
        f = r(38),
        c = r(39);

    function u(e, t, r) {
      a.call(this), this._cache = new h(), this._last = void 0, this._cipher = new f.AES(t), this._prev = i.from(r), this._mode = e, this._autopadding = !0;
    }

    function h() {
      this.cache = i.allocUnsafe(0);
    }

    function d(e, t, r) {
      var a = s[e.toLowerCase()];
      if (!a) throw new TypeError("invalid suite type");
      if ("string" == typeof r && (r = i.from(r)), "GCM" !== a.mode && r.length !== a.iv) throw new TypeError("invalid iv length " + r.length);
      if ("string" == typeof t && (t = i.from(t)), t.length !== a.key / 8) throw new TypeError("invalid key length " + t.length);
      return "stream" === a.type ? new o(a.module, t, r, !0) : "auth" === a.type ? new n(a.module, t, r, !0) : new u(a.module, t, r);
    }

    r(2)(u, a), u.prototype._update = function (e) {
      var t, r;

      this._cache.add(e);

      for (var n = []; t = this._cache.get(this._autopadding);) {
        r = this._mode.decrypt(this, t), n.push(r);
      }

      return i.concat(n);
    }, u.prototype._final = function () {
      var e = this._cache.flush();

      if (this._autopadding) return function (e) {
        var t = e[15];
        if (t < 1 || t > 16) throw new Error("unable to decrypt data");
        var r = -1;

        for (; ++r < t;) {
          if (e[r + (16 - t)] !== t) throw new Error("unable to decrypt data");
        }

        if (16 === t) return;
        return e.slice(0, 16 - t);
      }(this._mode.decrypt(this, e));
      if (e) throw new Error("data not multiple of block length");
    }, u.prototype.setAutoPadding = function (e) {
      return this._autopadding = !!e, this;
    }, h.prototype.add = function (e) {
      this.cache = i.concat([this.cache, e]);
    }, h.prototype.get = function (e) {
      var t;

      if (e) {
        if (this.cache.length > 16) return t = this.cache.slice(0, 16), this.cache = this.cache.slice(16), t;
      } else if (this.cache.length >= 16) return t = this.cache.slice(0, 16), this.cache = this.cache.slice(16), t;

      return null;
    }, h.prototype.flush = function () {
      if (this.cache.length) return this.cache;
    }, t.createDecipher = function (e, t) {
      var r = s[e.toLowerCase()];
      if (!r) throw new TypeError("invalid suite type");
      var n = c(t, !1, r.key, r.iv);
      return d(e, n.key, n.iv);
    }, t.createDecipheriv = d;
  }, function (e, t, r) {
    var n = r(6).Buffer,
        i = n.alloc(16, 0);

    function s(e) {
      var t = n.allocUnsafe(16);
      return t.writeUInt32BE(e[0] >>> 0, 0), t.writeUInt32BE(e[1] >>> 0, 4), t.writeUInt32BE(e[2] >>> 0, 8), t.writeUInt32BE(e[3] >>> 0, 12), t;
    }

    function o(e) {
      this.h = e, this.state = n.alloc(16, 0), this.cache = n.allocUnsafe(0);
    }

    o.prototype.ghash = function (e) {
      for (var t = -1; ++t < e.length;) {
        this.state[t] ^= e[t];
      }

      this._multiply();
    }, o.prototype._multiply = function () {
      for (var e, t, r, n = [(e = this.h).readUInt32BE(0), e.readUInt32BE(4), e.readUInt32BE(8), e.readUInt32BE(12)], i = [0, 0, 0, 0], o = -1; ++o < 128;) {
        for (0 != (this.state[~~(o / 8)] & 1 << 7 - o % 8) && (i[0] ^= n[0], i[1] ^= n[1], i[2] ^= n[2], i[3] ^= n[3]), r = 0 != (1 & n[3]), t = 3; t > 0; t--) {
          n[t] = n[t] >>> 1 | (1 & n[t - 1]) << 31;
        }

        n[0] = n[0] >>> 1, r && (n[0] = n[0] ^ 225 << 24);
      }

      this.state = s(i);
    }, o.prototype.update = function (e) {
      var t;

      for (this.cache = n.concat([this.cache, e]); this.cache.length >= 16;) {
        t = this.cache.slice(0, 16), this.cache = this.cache.slice(16), this.ghash(t);
      }
    }, o.prototype.final = function (e, t) {
      return this.cache.length && this.ghash(n.concat([this.cache, i], 16)), this.ghash(s([0, e, 0, t])), this.state;
    }, e.exports = o;
  }, function (e, t, r) {
    (function (e) {
      var n = r(28);

      function i(e) {
        return e._prev = e._cipher.encryptBlock(e._prev), e._prev;
      }

      t.encrypt = function (t, r) {
        for (; t._cache.length < r.length;) {
          t._cache = e.concat([t._cache, i(t)]);
        }

        var s = t._cache.slice(0, r.length);

        return t._cache = t._cache.slice(r.length), n(r, s);
      };
    }).call(this, r(3).Buffer);
  }, function (e, t, r) {
    var n = r(6).Buffer;

    function i(e, t, r) {
      for (var n, i, o, a = -1, f = 0; ++a < 8;) {
        n = e._cipher.encryptBlock(e._prev), i = t & 1 << 7 - a ? 128 : 0, f += (128 & (o = n[0] ^ i)) >> a % 8, e._prev = s(e._prev, r ? i : o);
      }

      return f;
    }

    function s(e, t) {
      var r = e.length,
          i = -1,
          s = n.allocUnsafe(e.length);

      for (e = n.concat([e, n.from([t])]); ++i < r;) {
        s[i] = e[i] << 1 | e[i + 1] >> 7;
      }

      return s;
    }

    t.encrypt = function (e, t, r) {
      for (var s = t.length, o = n.allocUnsafe(s), a = -1; ++a < s;) {
        o[a] = i(e, t[a], r);
      }

      return o;
    };
  }, function (e, t, r) {
    var n = r(6).Buffer;

    function i(e, t, r) {
      var i = e._cipher.encryptBlock(e._prev)[0] ^ t;
      return e._prev = n.concat([e._prev.slice(1), n.from([r ? t : i])]), i;
    }

    t.encrypt = function (e, t, r) {
      for (var s = t.length, o = n.allocUnsafe(s), a = -1; ++a < s;) {
        o[a] = i(e, t[a], r);
      }

      return o;
    };
  }, function (e, t, r) {
    var n = r(6).Buffer,
        i = r(28);

    function s(e, t, r) {
      var s = t.length,
          o = i(t, e._cache);
      return e._cache = e._cache.slice(s), e._prev = n.concat([e._prev, r ? t : o]), o;
    }

    t.encrypt = function (e, t, r) {
      for (var i, o = n.allocUnsafe(0); t.length;) {
        if (0 === e._cache.length && (e._cache = e._cipher.encryptBlock(e._prev), e._prev = n.allocUnsafe(0)), !(e._cache.length <= t.length)) {
          o = n.concat([o, s(e, t, r)]);
          break;
        }

        i = e._cache.length, o = n.concat([o, s(e, t.slice(0, i), r)]), t = t.slice(i);
      }

      return o;
    };
  }, function (e, t, r) {
    var n = r(28);
    t.encrypt = function (e, t) {
      var r = n(t, e._prev);
      return e._prev = e._cipher.encryptBlock(r), e._prev;
    }, t.decrypt = function (e, t) {
      var r = e._prev;
      e._prev = t;

      var i = e._cipher.decryptBlock(t);

      return n(i, r);
    };
  }, function (e, t) {
    t.encrypt = function (e, t) {
      return e._cipher.encryptBlock(t);
    }, t.decrypt = function (e, t) {
      return e._cipher.decryptBlock(t);
    };
  }, function (e, t, r) {
    var n = r(50),
        i = r(91),
        s = r(6).Buffer,
        o = r(90),
        a = r(16),
        f = r(38),
        c = r(39);

    function u(e, t, r) {
      a.call(this), this._cache = new d(), this._cipher = new f.AES(t), this._prev = s.from(r), this._mode = e, this._autopadding = !0;
    }

    r(2)(u, a), u.prototype._update = function (e) {
      var t, r;

      this._cache.add(e);

      for (var n = []; t = this._cache.get();) {
        r = this._mode.encrypt(this, t), n.push(r);
      }

      return s.concat(n);
    };
    var h = s.alloc(16, 16);

    function d() {
      this.cache = s.allocUnsafe(0);
    }

    function l(e, t, r) {
      var a = n[e.toLowerCase()];
      if (!a) throw new TypeError("invalid suite type");
      if ("string" == typeof t && (t = s.from(t)), t.length !== a.key / 8) throw new TypeError("invalid key length " + t.length);
      if ("string" == typeof r && (r = s.from(r)), "GCM" !== a.mode && r.length !== a.iv) throw new TypeError("invalid iv length " + r.length);
      return "stream" === a.type ? new o(a.module, t, r) : "auth" === a.type ? new i(a.module, t, r) : new u(a.module, t, r);
    }

    u.prototype._final = function () {
      var e = this._cache.flush();

      if (this._autopadding) return e = this._mode.encrypt(this, e), this._cipher.scrub(), e;
      if (!e.equals(h)) throw this._cipher.scrub(), new Error("data not multiple of block length");
    }, u.prototype.setAutoPadding = function (e) {
      return this._autopadding = !!e, this;
    }, d.prototype.add = function (e) {
      this.cache = s.concat([this.cache, e]);
    }, d.prototype.get = function () {
      if (this.cache.length > 15) {
        var e = this.cache.slice(0, 16);
        return this.cache = this.cache.slice(16), e;
      }

      return null;
    }, d.prototype.flush = function () {
      for (var e = 16 - this.cache.length, t = s.allocUnsafe(e), r = -1; ++r < e;) {
        t.writeUInt8(e, r);
      }

      return s.concat([this.cache, t]);
    }, t.createCipheriv = l, t.createCipher = function (e, t) {
      var r = n[e.toLowerCase()];
      if (!r) throw new TypeError("invalid suite type");
      var i = c(t, !1, r.key, r.iv);
      return l(e, i.key, i.iv);
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(6).Buffer,
        i = r(21).Transform;

    function s(e) {
      i.call(this), this._block = n.allocUnsafe(e), this._blockSize = e, this._blockOffset = 0, this._length = [0, 0, 0, 0], this._finalized = !1;
    }

    r(2)(s, i), s.prototype._transform = function (e, t, r) {
      var n = null;

      try {
        this.update(e, t);
      } catch (e) {
        n = e;
      }

      r(n);
    }, s.prototype._flush = function (e) {
      var t = null;

      try {
        this.push(this.digest());
      } catch (e) {
        t = e;
      }

      e(t);
    }, s.prototype.update = function (e, t) {
      if (function (e, t) {
        if (!n.isBuffer(e) && "string" != typeof e) throw new TypeError(t + " must be a string or a buffer");
      }(e, "Data"), this._finalized) throw new Error("Digest already called");
      n.isBuffer(e) || (e = n.from(e, t));

      for (var r = this._block, i = 0; this._blockOffset + e.length - i >= this._blockSize;) {
        for (var s = this._blockOffset; s < this._blockSize;) {
          r[s++] = e[i++];
        }

        this._update(), this._blockOffset = 0;
      }

      for (; i < e.length;) {
        r[this._blockOffset++] = e[i++];
      }

      for (var o = 0, a = 8 * e.length; a > 0; ++o) {
        this._length[o] += a, (a = this._length[o] / 4294967296 | 0) > 0 && (this._length[o] -= 4294967296 * a);
      }

      return this;
    }, s.prototype._update = function () {
      throw new Error("_update is not implemented");
    }, s.prototype.digest = function (e) {
      if (this._finalized) throw new Error("Digest already called");
      this._finalized = !0;

      var t = this._digest();

      void 0 !== e && (t = t.toString(e)), this._block.fill(0), this._blockOffset = 0;

      for (var r = 0; r < 4; ++r) {
        this._length[r] = 0;
      }

      return t;
    }, s.prototype._digest = function () {
      throw new Error("_digest is not implemented");
    }, e.exports = s;
  }, function (e, t, r) {
    "use strict";

    (function (t) {
      var n = r(2),
          i = r(221),
          s = new Array(16);

      function o() {
        i.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878;
      }

      function a(e, t) {
        return e << t | e >>> 32 - t;
      }

      function f(e, t, r, n, i, s, o) {
        return a(e + (t & r | ~t & n) + i + s | 0, o) + t | 0;
      }

      function c(e, t, r, n, i, s, o) {
        return a(e + (t & n | r & ~n) + i + s | 0, o) + t | 0;
      }

      function u(e, t, r, n, i, s, o) {
        return a(e + (t ^ r ^ n) + i + s | 0, o) + t | 0;
      }

      function h(e, t, r, n, i, s, o) {
        return a(e + (r ^ (t | ~n)) + i + s | 0, o) + t | 0;
      }

      n(o, i), o.prototype._update = function () {
        for (var e = s, t = 0; t < 16; ++t) {
          e[t] = this._block.readInt32LE(4 * t);
        }

        var r = this._a,
            n = this._b,
            i = this._c,
            o = this._d;
        n = h(n = h(n = h(n = h(n = u(n = u(n = u(n = u(n = c(n = c(n = c(n = c(n = f(n = f(n = f(n = f(n, i = f(i, o = f(o, r = f(r, n, i, o, e[0], 3614090360, 7), n, i, e[1], 3905402710, 12), r, n, e[2], 606105819, 17), o, r, e[3], 3250441966, 22), i = f(i, o = f(o, r = f(r, n, i, o, e[4], 4118548399, 7), n, i, e[5], 1200080426, 12), r, n, e[6], 2821735955, 17), o, r, e[7], 4249261313, 22), i = f(i, o = f(o, r = f(r, n, i, o, e[8], 1770035416, 7), n, i, e[9], 2336552879, 12), r, n, e[10], 4294925233, 17), o, r, e[11], 2304563134, 22), i = f(i, o = f(o, r = f(r, n, i, o, e[12], 1804603682, 7), n, i, e[13], 4254626195, 12), r, n, e[14], 2792965006, 17), o, r, e[15], 1236535329, 22), i = c(i, o = c(o, r = c(r, n, i, o, e[1], 4129170786, 5), n, i, e[6], 3225465664, 9), r, n, e[11], 643717713, 14), o, r, e[0], 3921069994, 20), i = c(i, o = c(o, r = c(r, n, i, o, e[5], 3593408605, 5), n, i, e[10], 38016083, 9), r, n, e[15], 3634488961, 14), o, r, e[4], 3889429448, 20), i = c(i, o = c(o, r = c(r, n, i, o, e[9], 568446438, 5), n, i, e[14], 3275163606, 9), r, n, e[3], 4107603335, 14), o, r, e[8], 1163531501, 20), i = c(i, o = c(o, r = c(r, n, i, o, e[13], 2850285829, 5), n, i, e[2], 4243563512, 9), r, n, e[7], 1735328473, 14), o, r, e[12], 2368359562, 20), i = u(i, o = u(o, r = u(r, n, i, o, e[5], 4294588738, 4), n, i, e[8], 2272392833, 11), r, n, e[11], 1839030562, 16), o, r, e[14], 4259657740, 23), i = u(i, o = u(o, r = u(r, n, i, o, e[1], 2763975236, 4), n, i, e[4], 1272893353, 11), r, n, e[7], 4139469664, 16), o, r, e[10], 3200236656, 23), i = u(i, o = u(o, r = u(r, n, i, o, e[13], 681279174, 4), n, i, e[0], 3936430074, 11), r, n, e[3], 3572445317, 16), o, r, e[6], 76029189, 23), i = u(i, o = u(o, r = u(r, n, i, o, e[9], 3654602809, 4), n, i, e[12], 3873151461, 11), r, n, e[15], 530742520, 16), o, r, e[2], 3299628645, 23), i = h(i, o = h(o, r = h(r, n, i, o, e[0], 4096336452, 6), n, i, e[7], 1126891415, 10), r, n, e[14], 2878612391, 15), o, r, e[5], 4237533241, 21), i = h(i, o = h(o, r = h(r, n, i, o, e[12], 1700485571, 6), n, i, e[3], 2399980690, 10), r, n, e[10], 4293915773, 15), o, r, e[1], 2240044497, 21), i = h(i, o = h(o, r = h(r, n, i, o, e[8], 1873313359, 6), n, i, e[15], 4264355552, 10), r, n, e[6], 2734768916, 15), o, r, e[13], 1309151649, 21), i = h(i, o = h(o, r = h(r, n, i, o, e[4], 4149444226, 6), n, i, e[11], 3174756917, 10), r, n, e[2], 718787259, 15), o, r, e[9], 3951481745, 21), this._a = this._a + r | 0, this._b = this._b + n | 0, this._c = this._c + i | 0, this._d = this._d + o | 0;
      }, o.prototype._digest = function () {
        this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
        var e = new t(16);
        return e.writeInt32LE(this._a, 0), e.writeInt32LE(this._b, 4), e.writeInt32LE(this._c, 8), e.writeInt32LE(this._d, 12), e;
      }, e.exports = o;
    }).call(this, r(3).Buffer);
  }, function (e, t, r) {
    var n = r(39),
        i = r(51),
        s = r(211),
        o = r(205),
        a = r(50);

    function f(e, t, r) {
      if (e = e.toLowerCase(), a[e]) return i.createCipheriv(e, t, r);
      if (o[e]) return new s({
        key: t,
        iv: r,
        mode: e
      });
      throw new TypeError("invalid suite type");
    }

    function c(e, t, r) {
      if (e = e.toLowerCase(), a[e]) return i.createDecipheriv(e, t, r);
      if (o[e]) return new s({
        key: t,
        iv: r,
        mode: e,
        decrypt: !0
      });
      throw new TypeError("invalid suite type");
    }

    t.createCipher = t.Cipher = function (e, t) {
      var r, i;
      if (e = e.toLowerCase(), a[e]) r = a[e].key, i = a[e].iv;else {
        if (!o[e]) throw new TypeError("invalid suite type");
        r = 8 * o[e].key, i = o[e].iv;
      }
      var s = n(t, !1, r, i);
      return f(e, s.key, s.iv);
    }, t.createCipheriv = t.Cipheriv = f, t.createDecipher = t.Decipher = function (e, t) {
      var r, i;
      if (e = e.toLowerCase(), a[e]) r = a[e].key, i = a[e].iv;else {
        if (!o[e]) throw new TypeError("invalid suite type");
        r = 8 * o[e].key, i = o[e].iv;
      }
      var s = n(t, !1, r, i);
      return c(e, s.key, s.iv);
    }, t.createDecipheriv = t.Decipheriv = c, t.listCiphers = t.getCiphers = function () {
      return Object.keys(o).concat(i.getCiphers());
    };
  }, function (e, t, r) {
    (function (t) {
      var n,
          i = r(97),
          s = r(96),
          o = r(95),
          a = r(6).Buffer,
          f = t.crypto && t.crypto.subtle,
          c = {
        sha: "SHA-1",
        "sha-1": "SHA-1",
        sha1: "SHA-1",
        sha256: "SHA-256",
        "sha-256": "SHA-256",
        sha384: "SHA-384",
        "sha-384": "SHA-384",
        "sha-512": "SHA-512",
        sha512: "SHA-512"
      },
          u = [];

      function h(e, t, r, n, i) {
        return f.importKey("raw", e, {
          name: "PBKDF2"
        }, !1, ["deriveBits"]).then(function (e) {
          return f.deriveBits({
            name: "PBKDF2",
            salt: t,
            iterations: r,
            hash: {
              name: i
            }
          }, e, n << 3);
        }).then(function (e) {
          return a.from(e);
        });
      }

      e.exports = function (e, r, d, l, p, b) {
        if (a.isBuffer(e) || (e = a.from(e, s)), a.isBuffer(r) || (r = a.from(r, s)), i(d, l), "function" == typeof p && (b = p, p = void 0), "function" != typeof b) throw new Error("No callback provided to pbkdf2");
        var _ = c[(p = p || "sha1").toLowerCase()];
        if (!_ || "function" != typeof t.Promise) return process.nextTick(function () {
          var t;

          try {
            t = o(e, r, d, l, p);
          } catch (e) {
            return b(e);
          }

          b(null, t);
        });
        !function (e, t) {
          e.then(function (e) {
            process.nextTick(function () {
              t(null, e);
            });
          }, function (e) {
            process.nextTick(function () {
              t(e);
            });
          });
        }(function (e) {
          if (t.process && !t.process.browser) return Promise.resolve(!1);
          if (!f || !f.importKey || !f.deriveBits) return Promise.resolve(!1);
          if (void 0 !== u[e]) return u[e];
          var r = h(n = n || a.alloc(8), n, 10, 128, e).then(function () {
            return !0;
          }).catch(function () {
            return !1;
          });
          return u[e] = r, r;
        }(_).then(function (t) {
          return t ? h(e, r, d, l, _) : o(e, r, d, l, p);
        }), b);
      };
    }).call(this, r(9));
  }, function (e, t, r) {
    e.exports = r(99);
  }, function (e, t, r) {
    "use strict";

    var n = r(2),
        i = r(6).Buffer,
        s = r(16),
        o = i.alloc(128),
        a = 64;

    function f(e, t) {
      s.call(this, "digest"), "string" == typeof t && (t = i.from(t)), this._alg = e, this._key = t, t.length > a ? t = e(t) : t.length < a && (t = i.concat([t, o], a));

      for (var r = this._ipad = i.allocUnsafe(a), n = this._opad = i.allocUnsafe(a), f = 0; f < a; f++) {
        r[f] = 54 ^ t[f], n[f] = 92 ^ t[f];
      }

      this._hash = [r];
    }

    n(f, s), f.prototype._update = function (e) {
      this._hash.push(e);
    }, f.prototype._final = function () {
      var e = this._alg(i.concat(this._hash));

      return this._alg(i.concat([this._opad, e]));
    }, e.exports = f;
  }, function (e, t, r) {
    var n = r(2),
        i = r(101),
        s = r(20),
        o = r(6).Buffer,
        a = new Array(160);

    function f() {
      this.init(), this._w = a, s.call(this, 128, 112);
    }

    n(f, i), f.prototype.init = function () {
      return this._ah = 3418070365, this._bh = 1654270250, this._ch = 2438529370, this._dh = 355462360, this._eh = 1731405415, this._fh = 2394180231, this._gh = 3675008525, this._hh = 1203062813, this._al = 3238371032, this._bl = 914150663, this._cl = 812702999, this._dl = 4144912697, this._el = 4290775857, this._fl = 1750603025, this._gl = 1694076839, this._hl = 3204075428, this;
    }, f.prototype._hash = function () {
      var e = o.allocUnsafe(48);

      function t(t, r, n) {
        e.writeInt32BE(t, n), e.writeInt32BE(r, n + 4);
      }

      return t(this._ah, this._al, 0), t(this._bh, this._bl, 8), t(this._ch, this._cl, 16), t(this._dh, this._dl, 24), t(this._eh, this._el, 32), t(this._fh, this._fl, 40), e;
    }, e.exports = f;
  }, function (e, t, r) {
    var n = r(2),
        i = r(102),
        s = r(20),
        o = r(6).Buffer,
        a = new Array(64);

    function f() {
      this.init(), this._w = a, s.call(this, 64, 56);
    }

    n(f, i), f.prototype.init = function () {
      return this._a = 3238371032, this._b = 914150663, this._c = 812702999, this._d = 4144912697, this._e = 4290775857, this._f = 1750603025, this._g = 1694076839, this._h = 3204075428, this;
    }, f.prototype._hash = function () {
      var e = o.allocUnsafe(28);
      return e.writeInt32BE(this._a, 0), e.writeInt32BE(this._b, 4), e.writeInt32BE(this._c, 8), e.writeInt32BE(this._d, 12), e.writeInt32BE(this._e, 16), e.writeInt32BE(this._f, 20), e.writeInt32BE(this._g, 24), e;
    }, e.exports = f;
  }, function (e, t, r) {
    var n = r(2),
        i = r(20),
        s = r(6).Buffer,
        o = [1518500249, 1859775393, -1894007588, -899497514],
        a = new Array(80);

    function f() {
      this.init(), this._w = a, i.call(this, 64, 56);
    }

    function c(e) {
      return e << 5 | e >>> 27;
    }

    function u(e) {
      return e << 30 | e >>> 2;
    }

    function h(e, t, r, n) {
      return 0 === e ? t & r | ~t & n : 2 === e ? t & r | t & n | r & n : t ^ r ^ n;
    }

    n(f, i), f.prototype.init = function () {
      return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
    }, f.prototype._update = function (e) {
      for (var t, r = this._w, n = 0 | this._a, i = 0 | this._b, s = 0 | this._c, a = 0 | this._d, f = 0 | this._e, d = 0; d < 16; ++d) {
        r[d] = e.readInt32BE(4 * d);
      }

      for (; d < 80; ++d) {
        r[d] = (t = r[d - 3] ^ r[d - 8] ^ r[d - 14] ^ r[d - 16]) << 1 | t >>> 31;
      }

      for (var l = 0; l < 80; ++l) {
        var p = ~~(l / 20),
            b = c(n) + h(p, i, s, a) + f + r[l] + o[p] | 0;
        f = a, a = s, s = u(i), i = n, n = b;
      }

      this._a = n + this._a | 0, this._b = i + this._b | 0, this._c = s + this._c | 0, this._d = a + this._d | 0, this._e = f + this._e | 0;
    }, f.prototype._hash = function () {
      var e = s.allocUnsafe(20);
      return e.writeInt32BE(0 | this._a, 0), e.writeInt32BE(0 | this._b, 4), e.writeInt32BE(0 | this._c, 8), e.writeInt32BE(0 | this._d, 12), e.writeInt32BE(0 | this._e, 16), e;
    }, e.exports = f;
  }, function (e, t, r) {
    var n = r(2),
        i = r(20),
        s = r(6).Buffer,
        o = [1518500249, 1859775393, -1894007588, -899497514],
        a = new Array(80);

    function f() {
      this.init(), this._w = a, i.call(this, 64, 56);
    }

    function c(e) {
      return e << 30 | e >>> 2;
    }

    function u(e, t, r, n) {
      return 0 === e ? t & r | ~t & n : 2 === e ? t & r | t & n | r & n : t ^ r ^ n;
    }

    n(f, i), f.prototype.init = function () {
      return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
    }, f.prototype._update = function (e) {
      for (var t, r = this._w, n = 0 | this._a, i = 0 | this._b, s = 0 | this._c, a = 0 | this._d, f = 0 | this._e, h = 0; h < 16; ++h) {
        r[h] = e.readInt32BE(4 * h);
      }

      for (; h < 80; ++h) {
        r[h] = r[h - 3] ^ r[h - 8] ^ r[h - 14] ^ r[h - 16];
      }

      for (var d = 0; d < 80; ++d) {
        var l = ~~(d / 20),
            p = 0 | ((t = n) << 5 | t >>> 27) + u(l, i, s, a) + f + r[d] + o[l];
        f = a, a = s, s = c(i), i = n, n = p;
      }

      this._a = n + this._a | 0, this._b = i + this._b | 0, this._c = s + this._c | 0, this._d = a + this._d | 0, this._e = f + this._e | 0;
    }, f.prototype._hash = function () {
      var e = s.allocUnsafe(20);
      return e.writeInt32BE(0 | this._a, 0), e.writeInt32BE(0 | this._b, 4), e.writeInt32BE(0 | this._c, 8), e.writeInt32BE(0 | this._d, 12), e.writeInt32BE(0 | this._e, 16), e;
    }, e.exports = f;
  }, function (e, t, r) {
    e.exports = r(30).PassThrough;
  }, function (e, t, r) {
    e.exports = r(30).Transform;
  }, function (e, t, r) {
    e.exports = r(17);
  }, function (e, t, r) {
    e.exports = r(54);
  }, function (e, t, r) {
    "use strict";

    e.exports = s;
    var n = r(103),
        i = r(29);

    function s(e) {
      if (!(this instanceof s)) return new s(e);
      n.call(this, e);
    }

    i.inherits = r(2), i.inherits(s, n), s.prototype._transform = function (e, t, r) {
      r(null, e);
    };
  }, function (e, t, r) {
    (function (t) {
      function r(e) {
        try {
          if (!t.localStorage) return !1;
        } catch (e) {
          return !1;
        }

        var r = t.localStorage[e];
        return null != r && "true" === String(r).toLowerCase();
      }

      e.exports = function (e, t) {
        if (r("noDeprecation")) return e;
        var n = !1;
        return function () {
          if (!n) {
            if (r("throwDeprecation")) throw new Error(t);
            r("traceDeprecation") ? console.trace(t) : console.warn(t), n = !0;
          }

          return e.apply(this, arguments);
        };
      };
    }).call(this, r(9));
  }, function (e, t, r) {
    (function (e) {
      !function (e, t) {
        "use strict";

        if (!e.setImmediate) {
          var r,
              n,
              i,
              s,
              o,
              a = 1,
              f = {},
              c = !1,
              u = e.document,
              h = Object.getPrototypeOf && Object.getPrototypeOf(e);
          h = h && h.setTimeout ? h : e, "[object process]" === {}.toString.call(e.process) ? r = function r(e) {
            process.nextTick(function () {
              l(e);
            });
          } : !function () {
            if (e.postMessage && !e.importScripts) {
              var t = !0,
                  r = e.onmessage;
              return e.onmessage = function () {
                t = !1;
              }, e.postMessage("", "*"), e.onmessage = r, t;
            }
          }() ? e.MessageChannel ? ((i = new MessageChannel()).port1.onmessage = function (e) {
            l(e.data);
          }, r = function r(e) {
            i.port2.postMessage(e);
          }) : u && "onreadystatechange" in u.createElement("script") ? (n = u.documentElement, r = function r(e) {
            var t = u.createElement("script");
            t.onreadystatechange = function () {
              l(e), t.onreadystatechange = null, n.removeChild(t), t = null;
            }, n.appendChild(t);
          }) : r = function r(e) {
            setTimeout(l, 0, e);
          } : (s = "setImmediate$" + Math.random() + "$", o = function o(t) {
            t.source === e && "string" == typeof t.data && 0 === t.data.indexOf(s) && l(+t.data.slice(s.length));
          }, e.addEventListener ? e.addEventListener("message", o, !1) : e.attachEvent("onmessage", o), r = function r(t) {
            e.postMessage(s + t, "*");
          }), h.setImmediate = function (e) {
            "function" != typeof e && (e = new Function("" + e));

            for (var t = new Array(arguments.length - 1), n = 0; n < t.length; n++) {
              t[n] = arguments[n + 1];
            }

            var i = {
              callback: e,
              args: t
            };
            return f[a] = i, r(a), a++;
          }, h.clearImmediate = d;
        }

        function d(e) {
          delete f[e];
        }

        function l(e) {
          if (c) setTimeout(l, 0, e);else {
            var r = f[e];

            if (r) {
              c = !0;

              try {
                !function (e) {
                  var r = e.callback,
                      n = e.args;

                  switch (n.length) {
                    case 0:
                      r();
                      break;

                    case 1:
                      r(n[0]);
                      break;

                    case 2:
                      r(n[0], n[1]);
                      break;

                    case 3:
                      r(n[0], n[1], n[2]);
                      break;

                    default:
                      r.apply(t, n);
                  }
                }(r);
              } finally {
                d(e), c = !1;
              }
            }
          }
        }
      }("undefined" == typeof self ? void 0 === e ? this : e : self);
    }).call(this, r(9));
  }, function (e, t, r) {
    (function (e) {
      var n = Function.prototype.apply;

      function i(e, t) {
        this._id = e, this._clearFn = t;
      }

      t.setTimeout = function () {
        return new i(n.call(setTimeout, window, arguments), clearTimeout);
      }, t.setInterval = function () {
        return new i(n.call(setInterval, window, arguments), clearInterval);
      }, t.clearTimeout = t.clearInterval = function (e) {
        e && e.close();
      }, i.prototype.unref = i.prototype.ref = function () {}, i.prototype.close = function () {
        this._clearFn.call(window, this._id);
      }, t.enroll = function (e, t) {
        clearTimeout(e._idleTimeoutId), e._idleTimeout = t;
      }, t.unenroll = function (e) {
        clearTimeout(e._idleTimeoutId), e._idleTimeout = -1;
      }, t._unrefActive = t.active = function (e) {
        clearTimeout(e._idleTimeoutId);
        var t = e._idleTimeout;
        t >= 0 && (e._idleTimeoutId = setTimeout(function () {
          e._onTimeout && e._onTimeout();
        }, t));
      }, r(237), t.setImmediate = "undefined" != typeof self && self.setImmediate || void 0 !== e && e.setImmediate || this && this.setImmediate, t.clearImmediate = "undefined" != typeof self && self.clearImmediate || void 0 !== e && e.clearImmediate || this && this.clearImmediate;
    }).call(this, r(9));
  }, function (e, t) {}, function (e, t, r) {
    "use strict";

    var n = r(6).Buffer,
        i = r(239);
    e.exports = function () {
      function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.head = null, this.tail = null, this.length = 0;
      }

      return e.prototype.push = function (e) {
        var t = {
          data: e,
          next: null
        };
        this.length > 0 ? this.tail.next = t : this.head = t, this.tail = t, ++this.length;
      }, e.prototype.unshift = function (e) {
        var t = {
          data: e,
          next: this.head
        };
        0 === this.length && (this.tail = t), this.head = t, ++this.length;
      }, e.prototype.shift = function () {
        if (0 !== this.length) {
          var e = this.head.data;
          return 1 === this.length ? this.head = this.tail = null : this.head = this.head.next, --this.length, e;
        }
      }, e.prototype.clear = function () {
        this.head = this.tail = null, this.length = 0;
      }, e.prototype.join = function (e) {
        if (0 === this.length) return "";

        for (var t = this.head, r = "" + t.data; t = t.next;) {
          r += e + t.data;
        }

        return r;
      }, e.prototype.concat = function (e) {
        if (0 === this.length) return n.alloc(0);
        if (1 === this.length) return this.head.data;

        for (var t, r, i, s = n.allocUnsafe(e >>> 0), o = this.head, a = 0; o;) {
          t = o.data, r = s, i = a, t.copy(r, i), a += o.data.length, o = o.next;
        }

        return s;
      }, e;
    }(), i && i.inspect && i.inspect.custom && (e.exports.prototype[i.inspect.custom] = function () {
      var e = i.inspect({
        length: this.length
      });
      return this.constructor.name + " " + e;
    });
  }, function (e, t) {}, function (e, t, r) {
    "use strict";

    (function (t) {
      var n = r(21).Transform;

      function i(e) {
        n.call(this), this._block = new t(e), this._blockSize = e, this._blockOffset = 0, this._length = [0, 0, 0, 0], this._finalized = !1;
      }

      r(2)(i, n), i.prototype._transform = function (e, r, n) {
        var i = null;

        try {
          "buffer" !== r && (e = new t(e, r)), this.update(e);
        } catch (e) {
          i = e;
        }

        n(i);
      }, i.prototype._flush = function (e) {
        var t = null;

        try {
          this.push(this._digest());
        } catch (e) {
          t = e;
        }

        e(t);
      }, i.prototype.update = function (e, r) {
        if (!t.isBuffer(e) && "string" != typeof e) throw new TypeError("Data must be a string or a buffer");
        if (this._finalized) throw new Error("Digest already called");
        t.isBuffer(e) || (e = new t(e, r || "binary"));

        for (var n = this._block, i = 0; this._blockOffset + e.length - i >= this._blockSize;) {
          for (var s = this._blockOffset; s < this._blockSize;) {
            n[s++] = e[i++];
          }

          this._update(), this._blockOffset = 0;
        }

        for (; i < e.length;) {
          n[this._blockOffset++] = e[i++];
        }

        for (var o = 0, a = 8 * e.length; a > 0; ++o) {
          this._length[o] += a, (a = this._length[o] / 4294967296 | 0) > 0 && (this._length[o] -= 4294967296 * a);
        }

        return this;
      }, i.prototype._update = function (e) {
        throw new Error("_update is not implemented");
      }, i.prototype.digest = function (e) {
        if (this._finalized) throw new Error("Digest already called");
        this._finalized = !0;

        var t = this._digest();

        return void 0 !== e && (t = t.toString(e)), t;
      }, i.prototype._digest = function () {
        throw new Error("_digest is not implemented");
      }, e.exports = i;
    }).call(this, r(3).Buffer);
  }, function (e, t, r) {
    "use strict";

    (function (t) {
      var r = 4,
          n = new t(r);
      n.fill(0);

      e.exports = function (e, i) {
        var s = i(function (e) {
          if (e.length % r != 0) {
            var i = e.length + (r - e.length % r);
            e = t.concat([e, n], i);
          }

          for (var s = new Array(e.length >>> 2), o = 0, a = 0; o < e.length; o += r, a++) {
            s[a] = e.readInt32LE(o);
          }

          return s;
        }(e), 8 * e.length);
        e = new t(16);

        for (var o = 0; o < s.length; o++) {
          e.writeInt32LE(s[o], o << 2, !0);
        }

        return e;
      };
    }).call(this, r(3).Buffer);
  }, function (e, t) {
    t.read = function (e, t, r, n, i) {
      var s,
          o,
          a = 8 * i - n - 1,
          f = (1 << a) - 1,
          c = f >> 1,
          u = -7,
          h = r ? i - 1 : 0,
          d = r ? -1 : 1,
          l = e[t + h];

      for (h += d, s = l & (1 << -u) - 1, l >>= -u, u += a; u > 0; s = 256 * s + e[t + h], h += d, u -= 8) {
        ;
      }

      for (o = s & (1 << -u) - 1, s >>= -u, u += n; u > 0; o = 256 * o + e[t + h], h += d, u -= 8) {
        ;
      }

      if (0 === s) s = 1 - c;else {
        if (s === f) return o ? NaN : 1 / 0 * (l ? -1 : 1);
        o += Math.pow(2, n), s -= c;
      }
      return (l ? -1 : 1) * o * Math.pow(2, s - n);
    }, t.write = function (e, t, r, n, i, s) {
      var o,
          a,
          f,
          c = 8 * s - i - 1,
          u = (1 << c) - 1,
          h = u >> 1,
          d = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
          l = n ? 0 : s - 1,
          p = n ? 1 : -1,
          b = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;

      for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (a = isNaN(t) ? 1 : 0, o = u) : (o = Math.floor(Math.log(t) / Math.LN2), t * (f = Math.pow(2, -o)) < 1 && (o--, f *= 2), (t += o + h >= 1 ? d / f : d * Math.pow(2, 1 - h)) * f >= 2 && (o++, f /= 2), o + h >= u ? (a = 0, o = u) : o + h >= 1 ? (a = (t * f - 1) * Math.pow(2, i), o += h) : (a = t * Math.pow(2, h - 1) * Math.pow(2, i), o = 0)); i >= 8; e[r + l] = 255 & a, l += p, a /= 256, i -= 8) {
        ;
      }

      for (o = o << i | a, c += i; c > 0; e[r + l] = 255 & o, l += p, o /= 256, c -= 8) {
        ;
      }

      e[r + l - p] |= 128 * b;
    };
  }, function (e, t, r) {
    "use strict";

    t.byteLength = function (e) {
      return 3 * e.length / 4 - c(e);
    }, t.toByteArray = function (e) {
      var t,
          r,
          n,
          o,
          a,
          f = e.length;
      o = c(e), a = new s(3 * f / 4 - o), r = o > 0 ? f - 4 : f;
      var u = 0;

      for (t = 0; t < r; t += 4) {
        n = i[e.charCodeAt(t)] << 18 | i[e.charCodeAt(t + 1)] << 12 | i[e.charCodeAt(t + 2)] << 6 | i[e.charCodeAt(t + 3)], a[u++] = n >> 16 & 255, a[u++] = n >> 8 & 255, a[u++] = 255 & n;
      }

      2 === o ? (n = i[e.charCodeAt(t)] << 2 | i[e.charCodeAt(t + 1)] >> 4, a[u++] = 255 & n) : 1 === o && (n = i[e.charCodeAt(t)] << 10 | i[e.charCodeAt(t + 1)] << 4 | i[e.charCodeAt(t + 2)] >> 2, a[u++] = n >> 8 & 255, a[u++] = 255 & n);
      return a;
    }, t.fromByteArray = function (e) {
      for (var t, r = e.length, i = r % 3, s = "", o = [], a = 0, f = r - i; a < f; a += 16383) {
        o.push(u(e, a, a + 16383 > f ? f : a + 16383));
      }

      1 === i ? (t = e[r - 1], s += n[t >> 2], s += n[t << 4 & 63], s += "==") : 2 === i && (t = (e[r - 2] << 8) + e[r - 1], s += n[t >> 10], s += n[t >> 4 & 63], s += n[t << 2 & 63], s += "=");
      return o.push(s), o.join("");
    };

    for (var n = [], i = [], s = "undefined" != typeof Uint8Array ? Uint8Array : Array, o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", a = 0, f = o.length; a < f; ++a) {
      n[a] = o[a], i[o.charCodeAt(a)] = a;
    }

    function c(e) {
      var t = e.length;
      if (t % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
      return "=" === e[t - 2] ? 2 : "=" === e[t - 1] ? 1 : 0;
    }

    function u(e, t, r) {
      for (var i, s, o = [], a = t; a < r; a += 3) {
        i = (e[a] << 16 & 16711680) + (e[a + 1] << 8 & 65280) + (255 & e[a + 2]), o.push(n[(s = i) >> 18 & 63] + n[s >> 12 & 63] + n[s >> 6 & 63] + n[63 & s]);
      }

      return o.join("");
    }

    i["-".charCodeAt(0)] = 62, i["_".charCodeAt(0)] = 63;
  }, function (e, t, r) {
    "use strict";

    var n = r(108);
    n.Server = r(131), n.Receiver = r(68), n.Sender = r(65), e.exports = n;
  }, function (e, t, r) {
    var n, i;
    !function (s, o) {
      "use strict";

      void 0 === (i = "function" == typeof (n = function n() {
        var e = function e() {},
            t = "undefined",
            r = ["trace", "debug", "info", "warn", "error"];

        function n(e, t) {
          var r = e[t];
          if ("function" == typeof r.bind) return r.bind(e);

          try {
            return Function.prototype.bind.call(r, e);
          } catch (t) {
            return function () {
              return Function.prototype.apply.apply(r, [e, arguments]);
            };
          }
        }

        function i(t, n) {
          for (var i = 0; i < r.length; i++) {
            var s = r[i];
            this[s] = i < t ? e : this.methodFactory(s, t, n);
          }

          this.log = this.debug;
        }

        function s(r, s, o) {
          return function (r) {
            "debug" === r && (r = "log");
            return typeof console !== t && (void 0 !== console[r] ? n(console, r) : void 0 !== console.log ? n(console, "log") : e);
          }(r) || function (e, r, n) {
            return function () {
              typeof console !== t && (i.call(this, r, n), this[e].apply(this, arguments));
            };
          }.apply(this, arguments);
        }

        function o(e, n, o) {
          var a,
              f = this,
              c = "loglevel";

          function u() {
            var e;

            if (typeof window !== t) {
              try {
                e = window.localStorage[c];
              } catch (e) {}

              if (typeof e === t) try {
                var r = window.document.cookie,
                    n = r.indexOf(encodeURIComponent(c) + "=");
                -1 !== n && (e = /^([^;]+)/.exec(r.slice(n))[1]);
              } catch (e) {}
              return void 0 === f.levels[e] && (e = void 0), e;
            }
          }

          e && (c += ":" + e), f.name = e, f.levels = {
            TRACE: 0,
            DEBUG: 1,
            INFO: 2,
            WARN: 3,
            ERROR: 4,
            SILENT: 5
          }, f.methodFactory = o || s, f.getLevel = function () {
            return a;
          }, f.setLevel = function (n, s) {
            if ("string" == typeof n && void 0 !== f.levels[n.toUpperCase()] && (n = f.levels[n.toUpperCase()]), !("number" == typeof n && n >= 0 && n <= f.levels.SILENT)) throw "log.setLevel() called with invalid level: " + n;
            if (a = n, !1 !== s && function (e) {
              var n = (r[e] || "silent").toUpperCase();
              if (typeof window === t) return;

              try {
                return void (window.localStorage[c] = n);
              } catch (e) {}

              try {
                window.document.cookie = encodeURIComponent(c) + "=" + n + ";";
              } catch (e) {}
            }(n), i.call(f, n, e), typeof console === t && n < f.levels.SILENT) return "No console available for logging";
          }, f.setDefaultLevel = function (e) {
            u() || f.setLevel(e, !1);
          }, f.enableAll = function (e) {
            f.setLevel(f.levels.TRACE, e);
          }, f.disableAll = function (e) {
            f.setLevel(f.levels.SILENT, e);
          };
          var h = u();
          null == h && (h = null == n ? "WARN" : n), f.setLevel(h, !1);
        }

        var a = new o(),
            f = {};

        a.getLogger = function (e) {
          if ("string" != typeof e || "" === e) throw new TypeError("You must supply a name when creating a logger.");
          var t = f[e];
          return t || (t = f[e] = new o(e, a.getLevel(), a.methodFactory)), t;
        };

        var c = typeof window !== t ? window.log : void 0;
        return a.noConflict = function () {
          return typeof window !== t && window.log === a && (window.log = c), a;
        }, a.getLoggers = function () {
          return f;
        }, a;
      }) ? n.call(t, r, t, e) : n) || (e.exports = i);
    }();
  }, function (e, t) {
    "function" == typeof Object.create ? e.exports = function (e, t) {
      e.super_ = t, e.prototype = Object.create(t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      });
    } : e.exports = function (e, t) {
      e.super_ = t;

      var r = function r() {};

      r.prototype = t.prototype, e.prototype = new r(), e.prototype.constructor = e;
    };
  }, function (e, t) {
    e.exports = function (e) {
      return e && "object" == typeof e && "function" == typeof e.copy && "function" == typeof e.fill && "function" == typeof e.readUInt8;
    };
  }, function (e, t, r) {
    function n(e, t) {
      Object.defineProperties(this, {
        _errorData: {
          value: e
        },
        name: {
          value: e.name
        },
        message: {
          value: t || e.message
        }
      });
    }

    (0, r(58).inherits)(n, Error), n.prototype.clone = function (e) {
      return new n(this._errorData, e);
    }, e.exports = n;
  }]);
});